"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function (e, t) {
  "use strict";

  "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = e.document ? t(e, !0) : function (e) {
    if (!e.document) throw new Error("jQuery requires a window with a document");
    return t(e);
  } : t(e);
}("undefined" != typeof window ? window : void 0, function (e, t) {
  "use strict";

  var n = [],
      r = e.document,
      i = Object.getPrototypeOf,
      o = n.slice,
      a = n.concat,
      s = n.push,
      u = n.indexOf,
      l = {},
      c = l.toString,
      f = l.hasOwnProperty,
      p = f.toString,
      d = p.call(Object),
      h = {},
      g = function e(t) {
    return "function" == typeof t && "number" != typeof t.nodeType;
  },
      y = function e(t) {
    return null != t && t === t.window;
  },
      v = {
    type: !0,
    src: !0,
    noModule: !0
  };

  function m(e, t, n) {
    var i,
        o = (t = t || r).createElement("script");
    if (o.text = e, n) for (i in v) {
      n[i] && (o[i] = n[i]);
    }
    t.head.appendChild(o).parentNode.removeChild(o);
  }

  function x(e) {
    return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? l[c.call(e)] || "object" : _typeof(e);
  }

  var b = "3.3.1",
      w = function w(e, t) {
    return new w.fn.init(e, t);
  },
      T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

  w.fn = w.prototype = {
    jquery: "3.3.1",
    constructor: w,
    length: 0,
    toArray: function toArray() {
      return o.call(this);
    },
    get: function get(e) {
      return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
    },
    pushStack: function pushStack(e) {
      var t = w.merge(this.constructor(), e);
      return t.prevObject = this, t;
    },
    each: function each(e) {
      return w.each(this, e);
    },
    map: function map(e) {
      return this.pushStack(w.map(this, function (t, n) {
        return e.call(t, n, t);
      }));
    },
    slice: function slice() {
      return this.pushStack(o.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    eq: function eq(e) {
      var t = this.length,
          n = +e + (e < 0 ? t : 0);
      return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor();
    },
    push: s,
    sort: n.sort,
    splice: n.splice
  }, w.extend = w.fn.extend = function () {
    var e,
        t,
        n,
        r,
        i,
        o,
        a = arguments[0] || {},
        s = 1,
        u = arguments.length,
        l = !1;

    for ("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == _typeof(a) || g(a) || (a = {}), s === u && (a = this, s--); s < u; s++) {
      if (null != (e = arguments[s])) for (t in e) {
        n = a[t], a !== (r = e[t]) && (l && r && (w.isPlainObject(r) || (i = Array.isArray(r))) ? (i ? (i = !1, o = n && Array.isArray(n) ? n : []) : o = n && w.isPlainObject(n) ? n : {}, a[t] = w.extend(l, o, r)) : void 0 !== r && (a[t] = r));
      }
    }

    return a;
  }, w.extend({
    expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
    isReady: !0,
    error: function error(e) {
      throw new Error(e);
    },
    noop: function noop() {},
    isPlainObject: function isPlainObject(e) {
      var t, n;
      return !(!e || "[object Object]" !== c.call(e)) && (!(t = i(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && p.call(n) === d);
    },
    isEmptyObject: function isEmptyObject(e) {
      var t;

      for (t in e) {
        return !1;
      }

      return !0;
    },
    globalEval: function globalEval(e) {
      m(e);
    },
    each: function each(e, t) {
      var n,
          r = 0;

      if (C(e)) {
        for (n = e.length; r < n; r++) {
          if (!1 === t.call(e[r], r, e[r])) break;
        }
      } else for (r in e) {
        if (!1 === t.call(e[r], r, e[r])) break;
      }

      return e;
    },
    trim: function trim(e) {
      return null == e ? "" : (e + "").replace(T, "");
    },
    makeArray: function makeArray(e, t) {
      var n = t || [];
      return null != e && (C(Object(e)) ? w.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)), n;
    },
    inArray: function inArray(e, t, n) {
      return null == t ? -1 : u.call(t, e, n);
    },
    merge: function merge(e, t) {
      for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
        e[i++] = t[r];
      }

      return e.length = i, e;
    },
    grep: function grep(e, t, n) {
      for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++) {
        (r = !t(e[o], o)) !== s && i.push(e[o]);
      }

      return i;
    },
    map: function map(e, t, n) {
      var r,
          i,
          o = 0,
          s = [];
      if (C(e)) for (r = e.length; o < r; o++) {
        null != (i = t(e[o], o, n)) && s.push(i);
      } else for (o in e) {
        null != (i = t(e[o], o, n)) && s.push(i);
      }
      return a.apply([], s);
    },
    guid: 1,
    support: h
  }), "function" == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]), w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
    l["[object " + t + "]"] = t.toLowerCase();
  });

  function C(e) {
    var t = !!e && "length" in e && e.length,
        n = x(e);
    return !g(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
  }

  var E = function (e) {
    var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y,
        v,
        m,
        x,
        b = "sizzle" + 1 * new Date(),
        w = e.document,
        T = 0,
        C = 0,
        E = ae(),
        k = ae(),
        S = ae(),
        D = function D(e, t) {
      return e === t && (f = !0), 0;
    },
        N = {}.hasOwnProperty,
        A = [],
        j = A.pop,
        q = A.push,
        L = A.push,
        H = A.slice,
        O = function O(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return n;
      }

      return -1;
    },
        P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        M = "[\\x20\\t\\r\\n\\f]",
        R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
        I = "\\[" + M + "*(" + R + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + M + "*\\]",
        W = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + I + ")*)|.*)\\)|)",
        $ = new RegExp(M + "+", "g"),
        B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
        F = new RegExp("^" + M + "*," + M + "*"),
        _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
        z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]", "g"),
        X = new RegExp(W),
        U = new RegExp("^" + R + "$"),
        V = {
      ID: new RegExp("^#(" + R + ")"),
      CLASS: new RegExp("^\\.(" + R + ")"),
      TAG: new RegExp("^(" + R + "|[*])"),
      ATTR: new RegExp("^" + I),
      PSEUDO: new RegExp("^" + W),
      CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"),
      bool: new RegExp("^(?:" + P + ")$", "i"),
      needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i")
    },
        G = /^(?:input|select|textarea|button)$/i,
        Y = /^h\d$/i,
        Q = /^[^{]+\{\s*\[native \w/,
        J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        K = /[+~]/,
        Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)", "ig"),
        ee = function ee(e, t, n) {
      var r = "0x" + t - 65536;
      return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
    },
        te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        ne = function ne(e, t) {
      return t ? "\0" === e ? "\uFFFD" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
    },
        re = function re() {
      p();
    },
        ie = me(function (e) {
      return !0 === e.disabled && ("form" in e || "label" in e);
    }, {
      dir: "parentNode",
      next: "legend"
    });

    try {
      L.apply(A = H.call(w.childNodes), w.childNodes), A[w.childNodes.length].nodeType;
    } catch (e) {
      L = {
        apply: A.length ? function (e, t) {
          q.apply(e, H.call(t));
        } : function (e, t) {
          var n = e.length,
              r = 0;

          while (e[n++] = t[r++]) {
            ;
          }

          e.length = n - 1;
        }
      };
    }

    function oe(e, t, r, i) {
      var o,
          s,
          l,
          c,
          f,
          h,
          v,
          m = t && t.ownerDocument,
          T = t ? t.nodeType : 9;
      if (r = r || [], "string" != typeof e || !e || 1 !== T && 9 !== T && 11 !== T) return r;

      if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t), t = t || d, g)) {
        if (11 !== T && (f = J.exec(e))) if (o = f[1]) {
          if (9 === T) {
            if (!(l = t.getElementById(o))) return r;
            if (l.id === o) return r.push(l), r;
          } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r;
        } else {
          if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;
          if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName) return L.apply(r, t.getElementsByClassName(o)), r;
        }

        if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
          if (1 !== T) m = t, v = e;else if ("object" !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute("id")) ? c = c.replace(te, ne) : t.setAttribute("id", c = b), s = (h = a(e)).length;

            while (s--) {
              h[s] = "#" + c + " " + ve(h[s]);
            }

            v = h.join(","), m = K.test(e) && ge(t.parentNode) || t;
          }
          if (v) try {
            return L.apply(r, m.querySelectorAll(v)), r;
          } catch (e) {} finally {
            c === b && t.removeAttribute("id");
          }
        }
      }

      return u(e.replace(B, "$1"), t, r, i);
    }

    function ae() {
      var e = [];

      function t(n, i) {
        return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i;
      }

      return t;
    }

    function se(e) {
      return e[b] = !0, e;
    }

    function ue(e) {
      var t = d.createElement("fieldset");

      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), t = null;
      }
    }

    function le(e, t) {
      var n = e.split("|"),
          i = n.length;

      while (i--) {
        r.attrHandle[n[i]] = t;
      }
    }

    function ce(e, t) {
      var n = t && e,
          r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while (n = n.nextSibling) {
        if (n === t) return -1;
      }
      return e ? 1 : -1;
    }

    function fe(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }

    function pe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();
        return ("input" === n || "button" === n) && t.type === e;
      };
    }

    function de(e) {
      return function (t) {
        return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ie(t) === e : t.disabled === e : "label" in t && t.disabled === e;
      };
    }

    function he(e) {
      return se(function (t) {
        return t = +t, se(function (n, r) {
          var i,
              o = e([], n.length, t),
              a = o.length;

          while (a--) {
            n[i = o[a]] && (n[i] = !(r[i] = n[i]));
          }
        });
      });
    }

    function ge(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }

    n = oe.support = {}, o = oe.isXML = function (e) {
      var t = e && (e.ownerDocument || e).documentElement;
      return !!t && "HTML" !== t.nodeName;
    }, p = oe.setDocument = function (e) {
      var t,
          i,
          a = e ? e.ownerDocument || e : w;
      return a !== d && 9 === a.nodeType && a.documentElement ? (d = a, h = d.documentElement, g = !o(d), w !== d && (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)), n.attributes = ue(function (e) {
        return e.className = "i", !e.getAttribute("className");
      }), n.getElementsByTagName = ue(function (e) {
        return e.appendChild(d.createComment("")), !e.getElementsByTagName("*").length;
      }), n.getElementsByClassName = Q.test(d.getElementsByClassName), n.getById = ue(function (e) {
        return h.appendChild(e).id = b, !d.getElementsByName || !d.getElementsByName(b).length;
      }), n.getById ? (r.filter.ID = function (e) {
        var t = e.replace(Z, ee);
        return function (e) {
          return e.getAttribute("id") === t;
        };
      }, r.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && g) {
          var n = t.getElementById(e);
          return n ? [n] : [];
        }
      }) : (r.filter.ID = function (e) {
        var t = e.replace(Z, ee);
        return function (e) {
          var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
          return n && n.value === t;
        };
      }, r.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && g) {
          var n,
              r,
              i,
              o = t.getElementById(e);

          if (o) {
            if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
            i = t.getElementsByName(e), r = 0;

            while (o = i[r++]) {
              if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
            }
          }

          return [];
        }
      }), r.find.TAG = n.getElementsByTagName ? function (e, t) {
        return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
      } : function (e, t) {
        var n,
            r = [],
            i = 0,
            o = t.getElementsByTagName(e);

        if ("*" === e) {
          while (n = o[i++]) {
            1 === n.nodeType && r.push(n);
          }

          return r;
        }

        return o;
      }, r.find.CLASS = n.getElementsByClassName && function (e, t) {
        if ("undefined" != typeof t.getElementsByClassName && g) return t.getElementsByClassName(e);
      }, v = [], y = [], (n.qsa = Q.test(d.querySelectorAll)) && (ue(function (e) {
        h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + M + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || y.push("\\[" + M + "*(?:value|" + P + ")"), e.querySelectorAll("[id~=" + b + "-]").length || y.push("~="), e.querySelectorAll(":checked").length || y.push(":checked"), e.querySelectorAll("a#" + b + "+*").length || y.push(".#.+[+~]");
      }), ue(function (e) {
        e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
        var t = d.createElement("input");
        t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && y.push("name" + M + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), y.push(",.*:");
      })), (n.matchesSelector = Q.test(m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ue(function (e) {
        n.disconnectedMatch = m.call(e, "*"), m.call(e, "[s!='']:x"), v.push("!=", W);
      }), y = y.length && new RegExp(y.join("|")), v = v.length && new RegExp(v.join("|")), t = Q.test(h.compareDocumentPosition), x = t || Q.test(h.contains) ? function (e, t) {
        var n = 9 === e.nodeType ? e.documentElement : e,
            r = t && t.parentNode;
        return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
      } : function (e, t) {
        if (t) while (t = t.parentNode) {
          if (t === e) return !0;
        }
        return !1;
      }, D = t ? function (e, t) {
        if (e === t) return f = !0, 0;
        var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
        return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === d || e.ownerDocument === w && x(w, e) ? -1 : t === d || t.ownerDocument === w && x(w, t) ? 1 : c ? O(c, e) - O(c, t) : 0 : 4 & r ? -1 : 1);
      } : function (e, t) {
        if (e === t) return f = !0, 0;
        var n,
            r = 0,
            i = e.parentNode,
            o = t.parentNode,
            a = [e],
            s = [t];
        if (!i || !o) return e === d ? -1 : t === d ? 1 : i ? -1 : o ? 1 : c ? O(c, e) - O(c, t) : 0;
        if (i === o) return ce(e, t);
        n = e;

        while (n = n.parentNode) {
          a.unshift(n);
        }

        n = t;

        while (n = n.parentNode) {
          s.unshift(n);
        }

        while (a[r] === s[r]) {
          r++;
        }

        return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0;
      }, d) : d;
    }, oe.matches = function (e, t) {
      return oe(e, null, null, t);
    }, oe.matchesSelector = function (e, t) {
      if ((e.ownerDocument || e) !== d && p(e), t = t.replace(z, "='$1']"), n.matchesSelector && g && !S[t + " "] && (!v || !v.test(t)) && (!y || !y.test(t))) try {
        var r = m.call(e, t);
        if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
      } catch (e) {}
      return oe(t, d, null, [e]).length > 0;
    }, oe.contains = function (e, t) {
      return (e.ownerDocument || e) !== d && p(e), x(e, t);
    }, oe.attr = function (e, t) {
      (e.ownerDocument || e) !== d && p(e);
      var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
      return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
    }, oe.escape = function (e) {
      return (e + "").replace(te, ne);
    }, oe.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }, oe.uniqueSort = function (e) {
      var t,
          r = [],
          i = 0,
          o = 0;

      if (f = !n.detectDuplicates, c = !n.sortStable && e.slice(0), e.sort(D), f) {
        while (t = e[o++]) {
          t === e[o] && (i = r.push(o));
        }

        while (i--) {
          e.splice(r[i], 1);
        }
      }

      return c = null, e;
    }, i = oe.getText = function (e) {
      var t,
          n = "",
          r = 0,
          o = e.nodeType;

      if (o) {
        if (1 === o || 9 === o || 11 === o) {
          if ("string" == typeof e.textContent) return e.textContent;

          for (e = e.firstChild; e; e = e.nextSibling) {
            n += i(e);
          }
        } else if (3 === o || 4 === o) return e.nodeValue;
      } else while (t = e[r++]) {
        n += i(t);
      }

      return n;
    }, (r = oe.selectors = {
      cacheLength: 50,
      createPseudo: se,
      match: V,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: !0
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: !0
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        ATTR: function ATTR(e) {
          return e[1] = e[1].replace(Z, ee), e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        },
        CHILD: function CHILD(e) {
          return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]), e;
        },
        PSEUDO: function PSEUDO(e) {
          var t,
              n = !e[6] && e[2];
          return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
        }
      },
      filter: {
        TAG: function TAG(e) {
          var t = e.replace(Z, ee).toLowerCase();
          return "*" === e ? function () {
            return !0;
          } : function (e) {
            return e.nodeName && e.nodeName.toLowerCase() === t;
          };
        },
        CLASS: function CLASS(e) {
          var t = E[e + " "];
          return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) && E(e, function (e) {
            return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "");
          });
        },
        ATTR: function ATTR(e, t, n) {
          return function (r) {
            var i = oe.attr(r, e);
            return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace($, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
          };
        },
        CHILD: function CHILD(e, t, n, r, i) {
          var o = "nth" !== e.slice(0, 3),
              a = "last" !== e.slice(-4),
              s = "of-type" === t;
          return 1 === r && 0 === i ? function (e) {
            return !!e.parentNode;
          } : function (t, n, u) {
            var l,
                c,
                f,
                p,
                d,
                h,
                g = o !== a ? "nextSibling" : "previousSibling",
                y = t.parentNode,
                v = s && t.nodeName.toLowerCase(),
                m = !u && !s,
                x = !1;

            if (y) {
              if (o) {
                while (g) {
                  p = t;

                  while (p = p[g]) {
                    if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                  }

                  h = g = "only" === e && !h && "nextSibling";
                }

                return !0;
              }

              if (h = [a ? y.firstChild : y.lastChild], a && m) {
                x = (d = (l = (c = (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2], p = d && y.childNodes[d];

                while (p = ++d && p && p[g] || (x = d = 0) || h.pop()) {
                  if (1 === p.nodeType && ++x && p === t) {
                    c[e] = [T, d, x];
                    break;
                  }
                }
              } else if (m && (x = d = (l = (c = (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]), !1 === x) while (p = ++d && p && p[g] || (x = d = 0) || h.pop()) {
                if ((s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) && ++x && (m && ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [T, x]), p === t)) break;
              }

              return (x -= i) === r || x % r == 0 && x / r >= 0;
            }
          };
        },
        PSEUDO: function PSEUDO(e, t) {
          var n,
              i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
          return i[b] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? se(function (e, n) {
            var r,
                o = i(e, t),
                a = o.length;

            while (a--) {
              e[r = O(e, o[a])] = !(n[r] = o[a]);
            }
          }) : function (e) {
            return i(e, 0, n);
          }) : i;
        }
      },
      pseudos: {
        not: se(function (e) {
          var t = [],
              n = [],
              r = s(e.replace(B, "$1"));
          return r[b] ? se(function (e, t, n, i) {
            var o,
                a = r(e, null, i, []),
                s = e.length;

            while (s--) {
              (o = a[s]) && (e[s] = !(t[s] = o));
            }
          }) : function (e, i, o) {
            return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
          };
        }),
        has: se(function (e) {
          return function (t) {
            return oe(e, t).length > 0;
          };
        }),
        contains: se(function (e) {
          return e = e.replace(Z, ee), function (t) {
            return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
          };
        }),
        lang: se(function (e) {
          return U.test(e || "") || oe.error("unsupported lang: " + e), e = e.replace(Z, ee).toLowerCase(), function (t) {
            var n;

            do {
              if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
            } while ((t = t.parentNode) && 1 === t.nodeType);

            return !1;
          };
        }),
        target: function target(t) {
          var n = e.location && e.location.hash;
          return n && n.slice(1) === t.id;
        },
        root: function root(e) {
          return e === h;
        },
        focus: function focus(e) {
          return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        },
        enabled: de(!1),
        disabled: de(!0),
        checked: function checked(e) {
          var t = e.nodeName.toLowerCase();
          return "input" === t && !!e.checked || "option" === t && !!e.selected;
        },
        selected: function selected(e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        },
        empty: function empty(e) {
          for (e = e.firstChild; e; e = e.nextSibling) {
            if (e.nodeType < 6) return !1;
          }

          return !0;
        },
        parent: function parent(e) {
          return !r.pseudos.empty(e);
        },
        header: function header(e) {
          return Y.test(e.nodeName);
        },
        input: function input(e) {
          return G.test(e.nodeName);
        },
        button: function button(e) {
          var t = e.nodeName.toLowerCase();
          return "input" === t && "button" === e.type || "button" === t;
        },
        text: function text(e) {
          var t;
          return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
        },
        first: he(function () {
          return [0];
        }),
        last: he(function (e, t) {
          return [t - 1];
        }),
        eq: he(function (e, t, n) {
          return [n < 0 ? n + t : n];
        }),
        even: he(function (e, t) {
          for (var n = 0; n < t; n += 2) {
            e.push(n);
          }

          return e;
        }),
        odd: he(function (e, t) {
          for (var n = 1; n < t; n += 2) {
            e.push(n);
          }

          return e;
        }),
        lt: he(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; --r >= 0;) {
            e.push(r);
          }

          return e;
        }),
        gt: he(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; ++r < t;) {
            e.push(r);
          }

          return e;
        })
      }
    }).pseudos.nth = r.pseudos.eq;

    for (t in {
      radio: !0,
      checkbox: !0,
      file: !0,
      password: !0,
      image: !0
    }) {
      r.pseudos[t] = fe(t);
    }

    for (t in {
      submit: !0,
      reset: !0
    }) {
      r.pseudos[t] = pe(t);
    }

    function ye() {}

    ye.prototype = r.filters = r.pseudos, r.setFilters = new ye(), a = oe.tokenize = function (e, t) {
      var n,
          i,
          o,
          a,
          s,
          u,
          l,
          c = k[e + " "];
      if (c) return t ? 0 : c.slice(0);
      s = e, u = [], l = r.preFilter;

      while (s) {
        n && !(i = F.exec(s)) || (i && (s = s.slice(i[0].length) || s), u.push(o = [])), n = !1, (i = _.exec(s)) && (n = i.shift(), o.push({
          value: n,
          type: i[0].replace(B, " ")
        }), s = s.slice(n.length));

        for (a in r.filter) {
          !(i = V[a].exec(s)) || l[a] && !(i = l[a](i)) || (n = i.shift(), o.push({
            value: n,
            type: a,
            matches: i
          }), s = s.slice(n.length));
        }

        if (!n) break;
      }

      return t ? s.length : s ? oe.error(e) : k(e, u).slice(0);
    };

    function ve(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) {
        r += e[t].value;
      }

      return r;
    }

    function me(e, t, n) {
      var r = t.dir,
          i = t.next,
          o = i || r,
          a = n && "parentNode" === o,
          s = C++;
      return t.first ? function (t, n, i) {
        while (t = t[r]) {
          if (1 === t.nodeType || a) return e(t, n, i);
        }

        return !1;
      } : function (t, n, u) {
        var l,
            c,
            f,
            p = [T, s];

        if (u) {
          while (t = t[r]) {
            if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
          }
        } else while (t = t[r]) {
          if (1 === t.nodeType || a) if (f = t[b] || (t[b] = {}), c = f[t.uniqueID] || (f[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[r] || t;else {
            if ((l = c[o]) && l[0] === T && l[1] === s) return p[2] = l[2];
            if (c[o] = p, p[2] = e(t, n, u)) return !0;
          }
        }

        return !1;
      };
    }

    function xe(e) {
      return e.length > 1 ? function (t, n, r) {
        var i = e.length;

        while (i--) {
          if (!e[i](t, n, r)) return !1;
        }

        return !0;
      } : e[0];
    }

    function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) {
        oe(e, t[r], n);
      }

      return n;
    }

    function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) {
        (o = e[s]) && (n && !n(o, r, i) || (a.push(o), l && t.push(s)));
      }

      return a;
    }

    function Te(e, t, n, r, i, o) {
      return r && !r[b] && (r = Te(r)), i && !i[b] && (i = Te(i, o)), se(function (o, a, s, u) {
        var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || "*", s.nodeType ? [s] : s, []),
            y = !e || !o && t ? g : we(g, p, e, s, u),
            v = n ? i || (o ? e : h || r) ? [] : a : y;

        if (n && n(y, v, s, u), r) {
          l = we(v, d), r(l, [], s, u), c = l.length;

          while (c--) {
            (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
          }
        }

        if (o) {
          if (i || e) {
            if (i) {
              l = [], c = v.length;

              while (c--) {
                (f = v[c]) && l.push(y[c] = f);
              }

              i(null, v = [], l, u);
            }

            c = v.length;

            while (c--) {
              (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f));
            }
          }
        } else v = we(v === a ? v.splice(h, v.length) : v), i ? i(null, a, v, u) : L.apply(a, v);
      });
    }

    function Ce(e) {
      for (var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, c = me(function (e) {
        return e === t;
      }, s, !0), f = me(function (e) {
        return O(t, e) > -1;
      }, s, !0), p = [function (e, n, r) {
        var i = !a && (r || n !== l) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
        return t = null, i;
      }]; u < o; u++) {
        if (n = r.relative[e[u].type]) p = [me(xe(p), n)];else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) {
              if (r.relative[e[i].type]) break;
            }

            return Te(u > 1 && xe(p), u > 1 && ve(e.slice(0, u - 1).concat({
              value: " " === e[u - 2].type ? "*" : ""
            })).replace(B, "$1"), n, u < i && Ce(e.slice(u, i)), i < o && Ce(e = e.slice(i)), i < o && ve(e));
          }

          p.push(n);
        }
      }

      return xe(p);
    }

    function Ee(e, t) {
      var n = t.length > 0,
          i = e.length > 0,
          o = function o(_o, a, s, u, c) {
        var f,
            h,
            y,
            v = 0,
            m = "0",
            x = _o && [],
            b = [],
            w = l,
            C = _o || i && r.find.TAG("*", c),
            E = T += null == w ? 1 : Math.random() || .1,
            k = C.length;

        for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
          if (i && f) {
            h = 0, a || f.ownerDocument === d || (p(f), s = !g);

            while (y = e[h++]) {
              if (y(f, a || d, s)) {
                u.push(f);
                break;
              }
            }

            c && (T = E);
          }

          n && ((f = !y && f) && v--, _o && x.push(f));
        }

        if (v += m, n && m !== v) {
          h = 0;

          while (y = t[h++]) {
            y(x, b, a, s);
          }

          if (_o) {
            if (v > 0) while (m--) {
              x[m] || b[m] || (b[m] = j.call(u));
            }
            b = we(b);
          }

          L.apply(u, b), c && !_o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u);
        }

        return c && (T = E, l = w), x;
      };

      return n ? se(o) : o;
    }

    return s = oe.compile = function (e, t) {
      var n,
          r = [],
          i = [],
          o = S[e + " "];

      if (!o) {
        t || (t = a(e)), n = t.length;

        while (n--) {
          (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
        }

        (o = S(e, Ee(i, r))).selector = e;
      }

      return o;
    }, u = oe.select = function (e, t, n, i) {
      var o,
          u,
          l,
          c,
          f,
          p = "function" == typeof e && e,
          d = !i && a(e = p.selector || e);

      if (n = n || [], 1 === d.length) {
        if ((u = d[0] = d[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && 9 === t.nodeType && g && r.relative[u[1].type]) {
          if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return n;
          p && (t = t.parentNode), e = e.slice(u.shift().value.length);
        }

        o = V.needsContext.test(e) ? 0 : u.length;

        while (o--) {
          if (l = u[o], r.relative[c = l.type]) break;

          if ((f = r.find[c]) && (i = f(l.matches[0].replace(Z, ee), K.test(u[0].type) && ge(t.parentNode) || t))) {
            if (u.splice(o, 1), !(e = i.length && ve(u))) return L.apply(n, i), n;
            break;
          }
        }
      }

      return (p || s(e, d))(i, t, !g, n, !t || K.test(e) && ge(t.parentNode) || t), n;
    }, n.sortStable = b.split("").sort(D).join("") === b, n.detectDuplicates = !!f, p(), n.sortDetached = ue(function (e) {
      return 1 & e.compareDocumentPosition(d.createElement("fieldset"));
    }), ue(function (e) {
      return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
    }) || le("type|href|height|width", function (e, t, n) {
      if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
    }), n.attributes && ue(function (e) {
      return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
    }) || le("value", function (e, t, n) {
      if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
    }), ue(function (e) {
      return null == e.getAttribute("disabled");
    }) || le(P, function (e, t, n) {
      var r;
      if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
    }), oe;
  }(e);

  w.find = E, w.expr = E.selectors, w.expr[":"] = w.expr.pseudos, w.uniqueSort = w.unique = E.uniqueSort, w.text = E.getText, w.isXMLDoc = E.isXML, w.contains = E.contains, w.escapeSelector = E.escape;

  var k = function k(e, t, n) {
    var r = [],
        i = void 0 !== n;

    while ((e = e[t]) && 9 !== e.nodeType) {
      if (1 === e.nodeType) {
        if (i && w(e).is(n)) break;
        r.push(e);
      }
    }

    return r;
  },
      S = function S(e, t) {
    for (var n = []; e; e = e.nextSibling) {
      1 === e.nodeType && e !== t && n.push(e);
    }

    return n;
  },
      D = w.expr.match.needsContext;

  function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }

  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

  function j(e, t, n) {
    return g(t) ? w.grep(e, function (e, r) {
      return !!t.call(e, r, e) !== n;
    }) : t.nodeType ? w.grep(e, function (e) {
      return e === t !== n;
    }) : "string" != typeof t ? w.grep(e, function (e) {
      return u.call(t, e) > -1 !== n;
    }) : w.filter(t, e, n);
  }

  w.filter = function (e, t, n) {
    var r = t[0];
    return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? w.find.matchesSelector(r, e) ? [r] : [] : w.find.matches(e, w.grep(t, function (e) {
      return 1 === e.nodeType;
    }));
  }, w.fn.extend({
    find: function find(e) {
      var t,
          n,
          r = this.length,
          i = this;
      if ("string" != typeof e) return this.pushStack(w(e).filter(function () {
        for (t = 0; t < r; t++) {
          if (w.contains(i[t], this)) return !0;
        }
      }));

      for (n = this.pushStack([]), t = 0; t < r; t++) {
        w.find(e, i[t], n);
      }

      return r > 1 ? w.uniqueSort(n) : n;
    },
    filter: function filter(e) {
      return this.pushStack(j(this, e || [], !1));
    },
    not: function not(e) {
      return this.pushStack(j(this, e || [], !0));
    },
    is: function is(e) {
      return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1).length;
    }
  });
  var q,
      L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  (w.fn.init = function (e, t, n) {
    var i, o;
    if (!e) return this;

    if (n = n || q, "string" == typeof e) {
      if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);

      if (i[1]) {
        if (t = t instanceof w ? t[0] : t, w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)), A.test(i[1]) && w.isPlainObject(t)) for (i in t) {
          g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        }
        return this;
      }

      return (o = r.getElementById(i[2])) && (this[0] = o, this.length = 1), this;
    }

    return e.nodeType ? (this[0] = e, this.length = 1, this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(w) : w.makeArray(e, this);
  }).prototype = w.fn, q = w(r);
  var H = /^(?:parents|prev(?:Until|All))/,
      O = {
    children: !0,
    contents: !0,
    next: !0,
    prev: !0
  };
  w.fn.extend({
    has: function has(e) {
      var t = w(e, this),
          n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) {
          if (w.contains(this, t[e])) return !0;
        }
      });
    },
    closest: function closest(e, t) {
      var n,
          r = 0,
          i = this.length,
          o = [],
          a = "string" != typeof e && w(e);
      if (!D.test(e)) for (; r < i; r++) {
        for (n = this[r]; n && n !== t; n = n.parentNode) {
          if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
            o.push(n);
            break;
          }
        }
      }
      return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    },
    index: function index(e) {
      return e ? "string" == typeof e ? u.call(w(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    },
    add: function add(e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    },
    addBack: function addBack(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }
  });

  function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType) {
      ;
    }

    return e;
  }

  w.each({
    parent: function parent(e) {
      var t = e.parentNode;
      return t && 11 !== t.nodeType ? t : null;
    },
    parents: function parents(e) {
      return k(e, "parentNode");
    },
    parentsUntil: function parentsUntil(e, t, n) {
      return k(e, "parentNode", n);
    },
    next: function next(e) {
      return P(e, "nextSibling");
    },
    prev: function prev(e) {
      return P(e, "previousSibling");
    },
    nextAll: function nextAll(e) {
      return k(e, "nextSibling");
    },
    prevAll: function prevAll(e) {
      return k(e, "previousSibling");
    },
    nextUntil: function nextUntil(e, t, n) {
      return k(e, "nextSibling", n);
    },
    prevUntil: function prevUntil(e, t, n) {
      return k(e, "previousSibling", n);
    },
    siblings: function siblings(e) {
      return S((e.parentNode || {}).firstChild, e);
    },
    children: function children(e) {
      return S(e.firstChild);
    },
    contents: function contents(e) {
      return N(e, "iframe") ? e.contentDocument : (N(e, "template") && (e = e.content || e), w.merge([], e.childNodes));
    }
  }, function (e, t) {
    w.fn[e] = function (n, r) {
      var i = w.map(this, t, n);
      return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = w.filter(r, i)), this.length > 1 && (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()), this.pushStack(i);
    };
  });
  var M = /[^\x20\t\r\n\f]+/g;

  function R(e) {
    var t = {};
    return w.each(e.match(M) || [], function (e, n) {
      t[n] = !0;
    }), t;
  }

  w.Callbacks = function (e) {
    e = "string" == typeof e ? R(e) : w.extend({}, e);

    var t,
        n,
        r,
        i,
        o = [],
        a = [],
        s = -1,
        u = function u() {
      for (i = i || e.once, r = t = !0; a.length; s = -1) {
        n = a.shift();

        while (++s < o.length) {
          !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
        }
      }

      e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
    },
        l = {
      add: function add() {
        return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
          w.each(n, function (n, r) {
            g(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== x(r) && t(r);
          });
        }(arguments), n && !t && u()), this;
      },
      remove: function remove() {
        return w.each(arguments, function (e, t) {
          var n;

          while ((n = w.inArray(t, o, n)) > -1) {
            o.splice(n, 1), n <= s && s--;
          }
        }), this;
      },
      has: function has(e) {
        return e ? w.inArray(e, o) > -1 : o.length > 0;
      },
      empty: function empty() {
        return o && (o = []), this;
      },
      disable: function disable() {
        return i = a = [], o = n = "", this;
      },
      disabled: function disabled() {
        return !o;
      },
      lock: function lock() {
        return i = a = [], n || t || (o = n = ""), this;
      },
      locked: function locked() {
        return !!i;
      },
      fireWith: function fireWith(e, n) {
        return i || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || u()), this;
      },
      fire: function fire() {
        return l.fireWith(this, arguments), this;
      },
      fired: function fired() {
        return !!r;
      }
    };

    return l;
  };

  function I(e) {
    return e;
  }

  function W(e) {
    throw e;
  }

  function $(e, t, n, r) {
    var i;

    try {
      e && g(i = e.promise) ? i.call(e).done(t).fail(n) : e && g(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }

  w.extend({
    Deferred: function Deferred(t) {
      var n = [["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2], ["resolve", "done", w.Callbacks("once memory"), w.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]],
          r = "pending",
          i = {
        state: function state() {
          return r;
        },
        always: function always() {
          return o.done(arguments).fail(arguments), this;
        },
        "catch": function _catch(e) {
          return i.then(null, e);
        },
        pipe: function pipe() {
          var e = arguments;
          return w.Deferred(function (t) {
            w.each(n, function (n, r) {
              var i = g(e[r[4]]) && e[r[4]];
              o[r[1]](function () {
                var e = i && i.apply(this, arguments);
                e && g(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, i ? [e] : arguments);
              });
            }), e = null;
          }).promise();
        },
        then: function then(t, r, i) {
          var o = 0;

          function a(t, n, r, i) {
            return function () {
              var s = this,
                  u = arguments,
                  l = function l() {
                var e, l;

                if (!(t < o)) {
                  if ((e = r.apply(s, u)) === n.promise()) throw new TypeError("Thenable self-resolution");
                  l = e && ("object" == _typeof(e) || "function" == typeof e) && e.then, g(l) ? i ? l.call(e, a(o, n, I, i), a(o, n, W, i)) : (o++, l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith))) : (r !== I && (s = void 0, u = [e]), (i || n.resolveWith)(s, u));
                }
              },
                  c = i ? l : function () {
                try {
                  l();
                } catch (e) {
                  w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace), t + 1 >= o && (r !== W && (s = void 0, u = [e]), n.rejectWith(s, u));
                }
              };

              t ? c() : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()), e.setTimeout(c));
            };
          }

          return w.Deferred(function (e) {
            n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)), n[1][3].add(a(0, e, g(t) ? t : I)), n[2][3].add(a(0, e, g(r) ? r : W));
          }).promise();
        },
        promise: function promise(e) {
          return null != e ? w.extend(e, i) : i;
        }
      },
          o = {};
      return w.each(n, function (e, t) {
        var a = t[2],
            s = t[5];
        i[t[1]] = a.add, s && a.add(function () {
          r = s;
        }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock), a.add(t[3].fire), o[t[0]] = function () {
          return o[t[0] + "With"](this === o ? void 0 : this, arguments), this;
        }, o[t[0] + "With"] = a.fireWith;
      }), i.promise(o), t && t.call(o, o), o;
    },
    when: function when(e) {
      var t = arguments.length,
          n = t,
          r = Array(n),
          i = o.call(arguments),
          a = w.Deferred(),
          s = function s(e) {
        return function (n) {
          r[e] = this, i[e] = arguments.length > 1 ? o.call(arguments) : n, --t || a.resolveWith(r, i);
        };
      };

      if (t <= 1 && ($(e, a.done(s(n)).resolve, a.reject, !t), "pending" === a.state() || g(i[n] && i[n].then))) return a.then();

      while (n--) {
        $(i[n], s(n), a.reject);
      }

      return a.promise();
    }
  });
  var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  w.Deferred.exceptionHook = function (t, n) {
    e.console && e.console.warn && t && B.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
  }, w.readyException = function (t) {
    e.setTimeout(function () {
      throw t;
    });
  };
  var F = w.Deferred();
  w.fn.ready = function (e) {
    return F.then(e)["catch"](function (e) {
      w.readyException(e);
    }), this;
  }, w.extend({
    isReady: !1,
    readyWait: 1,
    ready: function ready(e) {
      (!0 === e ? --w.readyWait : w.isReady) || (w.isReady = !0, !0 !== e && --w.readyWait > 0 || F.resolveWith(r, [w]));
    }
  }), w.ready.then = F.then;

  function _() {
    r.removeEventListener("DOMContentLoaded", _), e.removeEventListener("load", _), w.ready();
  }

  "complete" === r.readyState || "loading" !== r.readyState && !r.documentElement.doScroll ? e.setTimeout(w.ready) : (r.addEventListener("DOMContentLoaded", _), e.addEventListener("load", _));

  var z = function z(e, t, n, r, i, o, a) {
    var s = 0,
        u = e.length,
        l = null == n;

    if ("object" === x(n)) {
      i = !0;

      for (s in n) {
        z(e, t, s, n[s], !0, o, a);
      }
    } else if (void 0 !== r && (i = !0, g(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function t(e, _t2, n) {
      return l.call(w(e), n);
    })), t)) for (; s < u; s++) {
      t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
    }

    return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
  },
      X = /^-ms-/,
      U = /-([a-z])/g;

  function V(e, t) {
    return t.toUpperCase();
  }

  function G(e) {
    return e.replace(X, "ms-").replace(U, V);
  }

  var Y = function Y(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };

  function Q() {
    this.expando = w.expando + Q.uid++;
  }

  Q.uid = 1, Q.prototype = {
    cache: function cache(e) {
      var t = e[this.expando];
      return t || (t = {}, Y(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
        value: t,
        configurable: !0
      }))), t;
    },
    set: function set(e, t, n) {
      var r,
          i = this.cache(e);
      if ("string" == typeof t) i[G(t)] = n;else for (r in t) {
        i[G(r)] = t[r];
      }
      return i;
    },
    get: function get(e, t) {
      return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
    },
    access: function access(e, t, n) {
      return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
    },
    remove: function remove(e, t) {
      var n,
          r = e[this.expando];

      if (void 0 !== r) {
        if (void 0 !== t) {
          n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(M) || []).length;

          while (n--) {
            delete r[t[n]];
          }
        }

        (void 0 === t || w.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
      }
    },
    hasData: function hasData(e) {
      var t = e[this.expando];
      return void 0 !== t && !w.isEmptyObject(t);
    }
  };
  var J = new Q(),
      K = new Q(),
      Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      ee = /[A-Z]/g;

  function te(e) {
    return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e);
  }

  function ne(e, t, n) {
    var r;
    if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(ee, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
      try {
        n = te(n);
      } catch (e) {}

      K.set(e, t, n);
    } else n = void 0;
    return n;
  }

  w.extend({
    hasData: function hasData(e) {
      return K.hasData(e) || J.hasData(e);
    },
    data: function data(e, t, n) {
      return K.access(e, t, n);
    },
    removeData: function removeData(e, t) {
      K.remove(e, t);
    },
    _data: function _data(e, t, n) {
      return J.access(e, t, n);
    },
    _removeData: function _removeData(e, t) {
      J.remove(e, t);
    }
  }), w.fn.extend({
    data: function data(e, t) {
      var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;

      if (void 0 === e) {
        if (this.length && (i = K.get(o), 1 === o.nodeType && !J.get(o, "hasDataAttrs"))) {
          n = a.length;

          while (n--) {
            a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = G(r.slice(5)), ne(o, r, i[r]));
          }

          J.set(o, "hasDataAttrs", !0);
        }

        return i;
      }

      return "object" == _typeof(e) ? this.each(function () {
        K.set(this, e);
      }) : z(this, function (t) {
        var n;

        if (o && void 0 === t) {
          if (void 0 !== (n = K.get(o, e))) return n;
          if (void 0 !== (n = ne(o, e))) return n;
        } else this.each(function () {
          K.set(this, e, t);
        });
      }, null, t, arguments.length > 1, null, !0);
    },
    removeData: function removeData(e) {
      return this.each(function () {
        K.remove(this, e);
      });
    }
  }), w.extend({
    queue: function queue(e, t, n) {
      var r;
      if (e) return t = (t || "fx") + "queue", r = J.get(e, t), n && (!r || Array.isArray(n) ? r = J.access(e, t, w.makeArray(n)) : r.push(n)), r || [];
    },
    dequeue: function dequeue(e, t) {
      t = t || "fx";

      var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function a() {
        w.dequeue(e, t);
      };

      "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, a, o)), !r && o && o.empty.fire();
    },
    _queueHooks: function _queueHooks(e, t) {
      var n = t + "queueHooks";
      return J.get(e, n) || J.access(e, n, {
        empty: w.Callbacks("once memory").add(function () {
          J.remove(e, [t + "queue", n]);
        })
      });
    }
  }), w.fn.extend({
    queue: function queue(e, t) {
      var n = 2;
      return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? w.queue(this[0], e) : void 0 === t ? this : this.each(function () {
        var n = w.queue(this, e, t);
        w._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e);
      });
    },
    dequeue: function dequeue(e) {
      return this.each(function () {
        w.dequeue(this, e);
      });
    },
    clearQueue: function clearQueue(e) {
      return this.queue(e || "fx", []);
    },
    promise: function promise(e, t) {
      var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function s() {
        --r || i.resolveWith(o, [o]);
      };

      "string" != typeof e && (t = e, e = void 0), e = e || "fx";

      while (a--) {
        (n = J.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
      }

      return s(), i.promise(t);
    }
  });

  var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
      oe = ["Top", "Right", "Bottom", "Left"],
      ae = function ae(e, t) {
    return "none" === (e = t || e).style.display || "" === e.style.display && w.contains(e.ownerDocument, e) && "none" === w.css(e, "display");
  },
      se = function se(e, t, n, r) {
    var i,
        o,
        a = {};

    for (o in t) {
      a[o] = e.style[o], e.style[o] = t[o];
    }

    i = n.apply(e, r || []);

    for (o in t) {
      e.style[o] = a[o];
    }

    return i;
  };

  function ue(e, t, n, r) {
    var i,
        o,
        a = 20,
        s = r ? function () {
      return r.cur();
    } : function () {
      return w.css(e, t, "");
    },
        u = s(),
        l = n && n[3] || (w.cssNumber[t] ? "" : "px"),
        c = (w.cssNumber[t] || "px" !== l && +u) && ie.exec(w.css(e, t));

    if (c && c[3] !== l) {
      u /= 2, l = l || c[3], c = +u || 1;

      while (a--) {
        w.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), c /= o;
      }

      c *= 2, w.style(e, t, c + l), n = n || [];
    }

    return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i;
  }

  var le = {};

  function ce(e) {
    var t,
        n = e.ownerDocument,
        r = e.nodeName,
        i = le[r];
    return i || (t = n.body.appendChild(n.createElement(r)), i = w.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), le[r] = i, i);
  }

  function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++) {
      (r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = J.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ae(r) && (i[o] = ce(r))) : "none" !== n && (i[o] = "none", J.set(r, "display", n)));
    }

    for (o = 0; o < a; o++) {
      null != i[o] && (e[o].style.display = i[o]);
    }

    return e;
  }

  w.fn.extend({
    show: function show() {
      return fe(this, !0);
    },
    hide: function hide() {
      return fe(this);
    },
    toggle: function toggle(e) {
      return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
        ae(this) ? w(this).show() : w(this).hide();
      });
    }
  });
  var pe = /^(?:checkbox|radio)$/i,
      de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
      he = /^$|^module$|\/(?:java|ecma)script/i,
      ge = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  ge.optgroup = ge.option, ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td;

  function ye(e, t) {
    var n;
    return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && N(e, t) ? w.merge([e], n) : n;
  }

  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++) {
      J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"));
    }
  }

  var me = /<|&#?\w+;/;

  function xe(e, t, n, r, i) {
    for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++) {
      if ((o = e[d]) || 0 === o) if ("object" === x(o)) w.merge(p, o.nodeType ? [o] : o);else if (me.test(o)) {
        a = a || f.appendChild(t.createElement("div")), s = (de.exec(o) || ["", ""])[1].toLowerCase(), u = ge[s] || ge._default, a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2], c = u[0];

        while (c--) {
          a = a.lastChild;
        }

        w.merge(p, a.childNodes), (a = f.firstChild).textContent = "";
      } else p.push(t.createTextNode(o));
    }

    f.textContent = "", d = 0;

    while (o = p[d++]) {
      if (r && w.inArray(o, r) > -1) i && i.push(o);else if (l = w.contains(o.ownerDocument, o), a = ye(f.appendChild(o), "script"), l && ve(a), n) {
        c = 0;

        while (o = a[c++]) {
          he.test(o.type || "") && n.push(o);
        }
      }
    }

    return f;
  }

  !function () {
    var e = r.createDocumentFragment().appendChild(r.createElement("div")),
        t = r.createElement("input");
    t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue;
  }();
  var be = r.documentElement,
      we = /^key/,
      Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Ce = /^([^.]*)(?:\.(.+)|)/;

  function Ee() {
    return !0;
  }

  function ke() {
    return !1;
  }

  function Se() {
    try {
      return r.activeElement;
    } catch (e) {}
  }

  function De(e, t, n, r, i, o) {
    var a, s;

    if ("object" == _typeof(t)) {
      "string" != typeof n && (r = r || n, n = void 0);

      for (s in t) {
        De(e, s, n, r, t[s], o);
      }

      return e;
    }

    if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = ke;else if (!i) return e;
    return 1 === o && (a = i, (i = function i(e) {
      return w().off(e), a.apply(this, arguments);
    }).guid = a.guid || (a.guid = w.guid++)), e.each(function () {
      w.event.add(this, t, i, r, n);
    });
  }

  w.event = {
    global: {},
    add: function add(e, t, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          y = J.get(e);

      if (y) {
        n.handler && (n = (o = n).handler, i = o.selector), i && w.find.matchesSelector(be, i), n.guid || (n.guid = w.guid++), (u = y.events) || (u = y.events = {}), (a = y.handle) || (a = y.handle = function (t) {
          return "undefined" != typeof w && w.event.triggered !== t.type ? w.event.dispatch.apply(e, arguments) : void 0;
        }), l = (t = (t || "").match(M) || [""]).length;

        while (l--) {
          d = g = (s = Ce.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d && (f = w.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = w.event.special[d] || {}, c = w.extend({
            type: d,
            origType: g,
            data: r,
            handler: n,
            guid: n.guid,
            selector: i,
            needsContext: i && w.expr.match.needsContext.test(i),
            namespace: h.join(".")
          }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(d, a)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), w.event.global[d] = !0);
        }
      }
    },
    remove: function remove(e, t, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          y = J.hasData(e) && J.get(e);

      if (y && (u = y.events)) {
        l = (t = (t || "").match(M) || [""]).length;

        while (l--) {
          if (s = Ce.exec(t[l]) || [], d = g = s[1], h = (s[2] || "").split(".").sort(), d) {
            f = w.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length;

            while (o--) {
              c = p[o], !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
            }

            a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, y.handle) || w.removeEvent(e, d, y.handle), delete u[d]);
          } else for (d in u) {
            w.event.remove(e, d + t[l], n, r, !0);
          }
        }

        w.isEmptyObject(u) && J.remove(e, "handle events");
      }
    },
    dispatch: function dispatch(e) {
      var t = w.event.fix(e),
          n,
          r,
          i,
          o,
          a,
          s,
          u = new Array(arguments.length),
          l = (J.get(this, "events") || {})[t.type] || [],
          c = w.event.special[t.type] || {};

      for (u[0] = t, n = 1; n < arguments.length; n++) {
        u[n] = arguments[n];
      }

      if (t.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
        s = w.event.handlers.call(this, t, l), n = 0;

        while ((o = s[n++]) && !t.isPropagationStopped()) {
          t.currentTarget = o.elem, r = 0;

          while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped()) {
            t.rnamespace && !t.rnamespace.test(a.namespace) || (t.handleObj = a, t.data = a.data, void 0 !== (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) && !1 === (t.result = i) && (t.preventDefault(), t.stopPropagation()));
          }
        }

        return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    },
    handlers: function handlers(e, t) {
      var n,
          r,
          i,
          o,
          a,
          s = [],
          u = t.delegateCount,
          l = e.target;
      if (u && l.nodeType && !("click" === e.type && e.button >= 1)) for (; l !== this; l = l.parentNode || this) {
        if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
          for (o = [], a = {}, n = 0; n < u; n++) {
            void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? w(i, this).index(l) > -1 : w.find(i, this, null, [l]).length), a[i] && o.push(r);
          }

          o.length && s.push({
            elem: l,
            handlers: o
          });
        }
      }
      return l = this, u < t.length && s.push({
        elem: l,
        handlers: t.slice(u)
      }), s;
    },
    addProp: function addProp(e, t) {
      Object.defineProperty(w.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: g(t) ? function () {
          if (this.originalEvent) return t(this.originalEvent);
        } : function () {
          if (this.originalEvent) return this.originalEvent[e];
        },
        set: function set(t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
          });
        }
      });
    },
    fix: function fix(e) {
      return e[w.expando] ? e : new w.Event(e);
    },
    special: {
      load: {
        noBubble: !0
      },
      focus: {
        trigger: function trigger() {
          if (this !== Se() && this.focus) return this.focus(), !1;
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function trigger() {
          if (this === Se() && this.blur) return this.blur(), !1;
        },
        delegateType: "focusout"
      },
      click: {
        trigger: function trigger() {
          if ("checkbox" === this.type && this.click && N(this, "input")) return this.click(), !1;
        },
        _default: function _default(e) {
          return N(e.target, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        }
      }
    }
  }, w.removeEvent = function (e, t, n) {
    e.removeEventListener && e.removeEventListener(t, n);
  }, w.Event = function (e, t) {
    if (!(this instanceof w.Event)) return new w.Event(e, t);
    e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ee : ke, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && w.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[w.expando] = !0;
  }, w.Event.prototype = {
    constructor: w.Event,
    isDefaultPrevented: ke,
    isPropagationStopped: ke,
    isImmediatePropagationStopped: ke,
    isSimulated: !1,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = Ee, e && !this.isSimulated && e.preventDefault();
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = Ee, e && !this.isSimulated && e.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = Ee, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
    }
  }, w.each({
    altKey: !0,
    bubbles: !0,
    cancelable: !0,
    changedTouches: !0,
    ctrlKey: !0,
    detail: !0,
    eventPhase: !0,
    metaKey: !0,
    pageX: !0,
    pageY: !0,
    shiftKey: !0,
    view: !0,
    "char": !0,
    charCode: !0,
    key: !0,
    keyCode: !0,
    button: !0,
    buttons: !0,
    clientX: !0,
    clientY: !0,
    offsetX: !0,
    offsetY: !0,
    pointerId: !0,
    pointerType: !0,
    screenX: !0,
    screenY: !0,
    targetTouches: !0,
    toElement: !0,
    touches: !0,
    which: function which(e) {
      var t = e.button;
      return null == e.which && we.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Te.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which;
    }
  }, w.event.addProp), w.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (e, t) {
    w.event.special[e] = {
      delegateType: t,
      bindType: t,
      handle: function handle(e) {
        var n,
            r = this,
            i = e.relatedTarget,
            o = e.handleObj;
        return i && (i === r || w.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
      }
    };
  }), w.fn.extend({
    on: function on(e, t, n, r) {
      return De(this, e, t, n, r);
    },
    one: function one(e, t, n, r) {
      return De(this, e, t, n, r, 1);
    },
    off: function off(e, t, n) {
      var r, i;
      if (e && e.preventDefault && e.handleObj) return r = e.handleObj, w(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;

      if ("object" == _typeof(e)) {
        for (i in e) {
          this.off(i, t, e[i]);
        }

        return this;
      }

      return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = ke), this.each(function () {
        w.event.remove(this, e, n, t);
      });
    }
  });
  var Ne = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
      Ae = /<script|<style|<link/i,
      je = /checked\s*(?:[^=]|=\s*.checked.)/i,
      qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

  function Le(e, t) {
    return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr") ? w(e).children("tbody")[0] || e : e;
  }

  function He(e) {
    return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
  }

  function Oe(e) {
    return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
  }

  function Pe(e, t) {
    var n, r, i, o, a, s, u, l;

    if (1 === t.nodeType) {
      if (J.hasData(e) && (o = J.access(e), a = J.set(t, o), l = o.events)) {
        delete a.handle, a.events = {};

        for (i in l) {
          for (n = 0, r = l[i].length; n < r; n++) {
            w.event.add(t, i, l[i][n]);
          }
        }
      }

      K.hasData(e) && (s = K.access(e), u = w.extend({}, s), K.set(t, u));
    }
  }

  function Me(e, t) {
    var n = t.nodeName.toLowerCase();
    "input" === n && pe.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
  }

  function Re(e, t, n, r) {
    t = a.apply([], t);
    var i,
        o,
        s,
        u,
        l,
        c,
        f = 0,
        p = e.length,
        d = p - 1,
        y = t[0],
        v = g(y);
    if (v || p > 1 && "string" == typeof y && !h.checkClone && je.test(y)) return e.each(function (i) {
      var o = e.eq(i);
      v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r);
    });

    if (p && (i = xe(t, e[0].ownerDocument, !1, e, r), o = i.firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
      for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++) {
        l = i, f !== d && (l = w.clone(l, !0, !0), u && w.merge(s, ye(l, "script"))), n.call(e[f], l, f);
      }

      if (u) for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++) {
        l = s[f], he.test(l.type || "") && !J.access(l, "globalEval") && w.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? w._evalUrl && w._evalUrl(l.src) : m(l.textContent.replace(qe, ""), c, l));
      }
    }

    return e;
  }

  function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
      n || 1 !== r.nodeType || w.cleanData(ye(r)), r.parentNode && (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")), r.parentNode.removeChild(r));
    }

    return e;
  }

  w.extend({
    htmlPrefilter: function htmlPrefilter(e) {
      return e.replace(Ne, "<$1></$2>");
    },
    clone: function clone(e, t, n) {
      var r,
          i,
          o,
          a,
          s = e.cloneNode(!0),
          u = w.contains(e.ownerDocument, e);
      if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e))) for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++) {
        Me(o[r], a[r]);
      }
      if (t) if (n) for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++) {
        Pe(o[r], a[r]);
      } else Pe(e, s);
      return (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")), s;
    },
    cleanData: function cleanData(e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++) {
        if (Y(n)) {
          if (t = n[J.expando]) {
            if (t.events) for (r in t.events) {
              i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            }
            n[J.expando] = void 0;
          }

          n[K.expando] && (n[K.expando] = void 0);
        }
      }
    }
  }), w.fn.extend({
    detach: function detach(e) {
      return Ie(this, e, !0);
    },
    remove: function remove(e) {
      return Ie(this, e);
    },
    text: function text(e) {
      return z(this, function (e) {
        return void 0 === e ? w.text(this) : this.empty().each(function () {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
        });
      }, null, e, arguments.length);
    },
    append: function append() {
      return Re(this, arguments, function (e) {
        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Le(this, e).appendChild(e);
      });
    },
    prepend: function prepend() {
      return Re(this, arguments, function (e) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var t = Le(this, e);
          t.insertBefore(e, t.firstChild);
        }
      });
    },
    before: function before() {
      return Re(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this);
      });
    },
    after: function after() {
      return Re(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
      });
    },
    empty: function empty() {
      for (var e, t = 0; null != (e = this[t]); t++) {
        1 === e.nodeType && (w.cleanData(ye(e, !1)), e.textContent = "");
      }

      return this;
    },
    clone: function clone(e, t) {
      return e = null != e && e, t = null == t ? e : t, this.map(function () {
        return w.clone(this, e, t);
      });
    },
    html: function html(e) {
      return z(this, function (e) {
        var t = this[0] || {},
            n = 0,
            r = this.length;
        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;

        if ("string" == typeof e && !Ae.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
          e = w.htmlPrefilter(e);

          try {
            for (; n < r; n++) {
              1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)), t.innerHTML = e);
            }

            t = 0;
          } catch (e) {}
        }

        t && this.empty().append(e);
      }, null, e, arguments.length);
    },
    replaceWith: function replaceWith() {
      var e = [];
      return Re(this, arguments, function (t) {
        var n = this.parentNode;
        w.inArray(this, e) < 0 && (w.cleanData(ye(this)), n && n.replaceChild(t, this));
      }, e);
    }
  }), w.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (e, t) {
    w.fn[e] = function (e) {
      for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++) {
        n = a === o ? this : this.clone(!0), w(i[a])[t](n), s.apply(r, n.get());
      }

      return this.pushStack(r);
    };
  });

  var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
      $e = function $e(t) {
    var n = t.ownerDocument.defaultView;
    return n && n.opener || (n = e), n.getComputedStyle(t);
  },
      Be = new RegExp(oe.join("|"), "i");

  !function () {
    function t() {
      if (c) {
        l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", be.appendChild(l).appendChild(c);
        var t = e.getComputedStyle(c);
        i = "1%" !== t.top, u = 12 === n(t.marginLeft), c.style.right = "60%", s = 36 === n(t.right), o = 36 === n(t.width), c.style.position = "absolute", a = 36 === c.offsetWidth || "absolute", be.removeChild(l), c = null;
      }
    }

    function n(e) {
      return Math.round(parseFloat(e));
    }

    var i,
        o,
        a,
        s,
        u,
        l = r.createElement("div"),
        c = r.createElement("div");
    c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === c.style.backgroundClip, w.extend(h, {
      boxSizingReliable: function boxSizingReliable() {
        return t(), o;
      },
      pixelBoxStyles: function pixelBoxStyles() {
        return t(), s;
      },
      pixelPosition: function pixelPosition() {
        return t(), i;
      },
      reliableMarginLeft: function reliableMarginLeft() {
        return t(), u;
      },
      scrollboxSize: function scrollboxSize() {
        return t(), a;
      }
    }));
  }();

  function Fe(e, t, n) {
    var r,
        i,
        o,
        a,
        s = e.style;
    return (n = n || $e(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || w.contains(e.ownerDocument, e) || (a = w.style(e, t)), !h.pixelBoxStyles() && We.test(a) && Be.test(t) && (r = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = i, s.maxWidth = o)), void 0 !== a ? a + "" : a;
  }

  function _e(e, t) {
    return {
      get: function get() {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      }
    };
  }

  var ze = /^(none|table(?!-c[ea]).+)/,
      Xe = /^--/,
      Ue = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
  },
      Ve = {
    letterSpacing: "0",
    fontWeight: "400"
  },
      Ge = ["Webkit", "Moz", "ms"],
      Ye = r.createElement("div").style;

  function Qe(e) {
    if (e in Ye) return e;
    var t = e[0].toUpperCase() + e.slice(1),
        n = Ge.length;

    while (n--) {
      if ((e = Ge[n] + t) in Ye) return e;
    }
  }

  function Je(e) {
    var t = w.cssProps[e];
    return t || (t = w.cssProps[e] = Qe(e) || e), t;
  }

  function Ke(e, t, n) {
    var r = ie.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }

  function Ze(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
        s = 0,
        u = 0;
    if (n === (r ? "border" : "content")) return 0;

    for (; a < 4; a += 2) {
      "margin" === n && (u += w.css(e, n + oe[a], !0, i)), r ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)), "margin" !== n && (u -= w.css(e, "border" + oe[a] + "Width", !0, i))) : (u += w.css(e, "padding" + oe[a], !0, i), "padding" !== n ? u += w.css(e, "border" + oe[a] + "Width", !0, i) : s += w.css(e, "border" + oe[a] + "Width", !0, i));
    }

    return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5))), u;
  }

  function et(e, t, n) {
    var r = $e(e),
        i = Fe(e, t, r),
        o = "border-box" === w.css(e, "boxSizing", !1, r),
        a = o;

    if (We.test(i)) {
      if (!n) return i;
      i = "auto";
    }

    return a = a && (h.boxSizingReliable() || i === e.style[t]), ("auto" === i || !parseFloat(i) && "inline" === w.css(e, "display", !1, r)) && (i = e["offset" + t[0].toUpperCase() + t.slice(1)], a = !0), (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? "border" : "content"), a, r, i) + "px";
  }

  w.extend({
    cssHooks: {
      opacity: {
        get: function get(e, t) {
          if (t) {
            var n = Fe(e, "opacity");
            return "" === n ? "1" : n;
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function style(e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
            o,
            a,
            s = G(t),
            u = Xe.test(t),
            l = e.style;
        if (u || (t = Je(s)), a = w.cssHooks[t] || w.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        "string" == (o = _typeof(n)) && (i = ie.exec(n)) && i[1] && (n = ue(e, t, i), o = "number"), null != n && n === n && ("number" === o && (n += i && i[3] || (w.cssNumber[s] ? "" : "px")), h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n));
      }
    },
    css: function css(e, t, n, r) {
      var i,
          o,
          a,
          s = G(t);
      return Xe.test(t) || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Fe(e, t, r)), "normal" === i && t in Ve && (i = Ve[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
    }
  }), w.each(["height", "width"], function (e, t) {
    w.cssHooks[t] = {
      get: function get(e, n, r) {
        if (n) return !ze.test(w.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? et(e, t, r) : se(e, Ue, function () {
          return et(e, t, r);
        });
      },
      set: function set(e, n, r) {
        var i,
            o = $e(e),
            a = "border-box" === w.css(e, "boxSizing", !1, o),
            s = r && Ze(e, t, r, a, o);
        return a && h.scrollboxSize() === o.position && (s -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Ze(e, t, "border", !1, o) - .5)), s && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = w.css(e, t)), Ke(e, n, s);
      }
    };
  }), w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function (e, t) {
    if (t) return (parseFloat(Fe(e, "marginLeft")) || e.getBoundingClientRect().left - se(e, {
      marginLeft: 0
    }, function () {
      return e.getBoundingClientRect().left;
    })) + "px";
  }), w.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (e, t) {
    w.cssHooks[e + t] = {
      expand: function expand(n) {
        for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) {
          i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
        }

        return i;
      }
    }, "margin" !== e && (w.cssHooks[e + t].set = Ke);
  }), w.fn.extend({
    css: function css(e, t) {
      return z(this, function (e, t, n) {
        var r,
            i,
            o = {},
            a = 0;

        if (Array.isArray(t)) {
          for (r = $e(e), i = t.length; a < i; a++) {
            o[t[a]] = w.css(e, t[a], !1, r);
          }

          return o;
        }

        return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
      }, e, t, arguments.length > 1);
    }
  });

  function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i);
  }

  w.Tween = tt, tt.prototype = {
    constructor: tt,
    init: function init(e, t, n, r, i, o) {
      this.elem = e, this.prop = n, this.easing = i || w.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (w.cssNumber[n] ? "" : "px");
    },
    cur: function cur() {
      var e = tt.propHooks[this.prop];
      return e && e.get ? e.get(this) : tt.propHooks._default.get(this);
    },
    run: function run(e) {
      var t,
          n = tt.propHooks[this.prop];
      return this.options.duration ? this.pos = t = w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : tt.propHooks._default.set(this), this;
    }
  }, tt.prototype.init.prototype = tt.prototype, tt.propHooks = {
    _default: {
      get: function get(e) {
        var t;
        return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = w.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
      },
      set: function set(e) {
        w.fx.step[e.prop] ? w.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop] ? e.elem[e.prop] = e.now : w.style(e.elem, e.prop, e.now + e.unit);
      }
    }
  }, tt.propHooks.scrollTop = tt.propHooks.scrollLeft = {
    set: function set(e) {
      e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
    }
  }, w.easing = {
    linear: function linear(e) {
      return e;
    },
    swing: function swing(e) {
      return .5 - Math.cos(e * Math.PI) / 2;
    },
    _default: "swing"
  }, w.fx = tt.prototype.init, w.fx.step = {};
  var nt,
      rt,
      it = /^(?:toggle|show|hide)$/,
      ot = /queueHooks$/;

  function at() {
    rt && (!1 === r.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(at) : e.setTimeout(at, w.fx.interval), w.fx.tick());
  }

  function st() {
    return e.setTimeout(function () {
      nt = void 0;
    }), nt = Date.now();
  }

  function ut(e, t) {
    var n,
        r = 0,
        i = {
      height: e
    };

    for (t = t ? 1 : 0; r < 4; r += 2 - t) {
      i["margin" + (n = oe[r])] = i["padding" + n] = e;
    }

    return t && (i.opacity = i.width = e), i;
  }

  function lt(e, t, n) {
    for (var r, i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]), o = 0, a = i.length; o < a; o++) {
      if (r = i[o].call(n, t, e)) return r;
    }
  }

  function ct(e, t, n) {
    var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = "width" in t || "height" in t,
        p = this,
        d = {},
        h = e.style,
        g = e.nodeType && ae(e),
        y = J.get(e, "fxshow");
    n.queue || (null == (a = w._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
      a.unqueued || s();
    }), a.unqueued++, p.always(function () {
      p.always(function () {
        a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
      });
    }));

    for (r in t) {
      if (i = t[r], it.test(i)) {
        if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) {
          if ("show" !== i || !y || void 0 === y[r]) continue;
          g = !0;
        }

        d[r] = y && y[r] || w.style(e, r);
      }
    }

    if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (l = y && y.display) && (l = J.get(e, "display")), "none" === (c = w.css(e, "display")) && (l ? c = l : (fe([e], !0), l = e.style.display || l, c = w.css(e, "display"), fe([e]))), ("inline" === c || "inline-block" === c && null != l) && "none" === w.css(e, "float") && (u || (p.done(function () {
        h.display = l;
      }), null == l && (c = h.display, l = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function () {
        h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
      })), u = !1;

      for (r in d) {
        u || (y ? "hidden" in y && (g = y.hidden) : y = J.access(e, "fxshow", {
          display: l
        }), o && (y.hidden = !g), g && fe([e], !0), p.done(function () {
          g || fe([e]), J.remove(e, "fxshow");

          for (r in d) {
            w.style(e, r, d[r]);
          }
        })), u = lt(g ? y[r] : 0, r, p), r in y || (y[r] = u.start, g && (u.end = u.start, u.start = 0));
      }
    }
  }

  function ft(e, t) {
    var n, r, i, o, a;

    for (n in e) {
      if (r = G(n), i = t[r], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = w.cssHooks[r]) && "expand" in a) {
        o = a.expand(o), delete e[r];

        for (n in o) {
          n in e || (e[n] = o[n], t[n] = i);
        }
      } else t[r] = i;
    }
  }

  function pt(e, t, n) {
    var r,
        i,
        o = 0,
        a = pt.prefilters.length,
        s = w.Deferred().always(function () {
      delete u.elem;
    }),
        u = function u() {
      if (i) return !1;

      for (var t = nt || st(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, a = l.tweens.length; o < a; o++) {
        l.tweens[o].run(r);
      }

      return s.notifyWith(e, [l, r, n]), r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1);
    },
        l = s.promise({
      elem: e,
      props: w.extend({}, t),
      opts: w.extend(!0, {
        specialEasing: {},
        easing: w.easing._default
      }, n),
      originalProperties: t,
      originalOptions: n,
      startTime: nt || st(),
      duration: n.duration,
      tweens: [],
      createTween: function createTween(t, n) {
        var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
        return l.tweens.push(r), r;
      },
      stop: function stop(t) {
        var n = 0,
            r = t ? l.tweens.length : 0;
        if (i) return this;

        for (i = !0; n < r; n++) {
          l.tweens[n].run(1);
        }

        return t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]), this;
      }
    }),
        c = l.props;

    for (ft(c, l.opts.specialEasing); o < a; o++) {
      if (r = pt.prefilters[o].call(l, e, c, l.opts)) return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
    }

    return w.map(c, lt, l), g(l.opts.start) && l.opts.start.call(e, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), w.fx.timer(w.extend(u, {
      elem: e,
      anim: l,
      queue: l.opts.queue
    })), l;
  }

  w.Animation = w.extend(pt, {
    tweeners: {
      "*": [function (e, t) {
        var n = this.createTween(e, t);
        return ue(n.elem, e, ie.exec(t), n), n;
      }]
    },
    tweener: function tweener(e, t) {
      g(e) ? (t = e, e = ["*"]) : e = e.match(M);

      for (var n, r = 0, i = e.length; r < i; r++) {
        n = e[r], pt.tweeners[n] = pt.tweeners[n] || [], pt.tweeners[n].unshift(t);
      }
    },
    prefilters: [ct],
    prefilter: function prefilter(e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
    }
  }), w.speed = function (e, t, n) {
    var r = e && "object" == _typeof(e) ? w.extend({}, e) : {
      complete: n || !n && t || g(e) && e,
      duration: e,
      easing: n && t || t && !g(t) && t
    };
    return w.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in w.fx.speeds ? r.duration = w.fx.speeds[r.duration] : r.duration = w.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
      g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
    }, r;
  }, w.fn.extend({
    fadeTo: function fadeTo(e, t, n, r) {
      return this.filter(ae).css("opacity", 0).show().end().animate({
        opacity: t
      }, e, n, r);
    },
    animate: function animate(e, t, n, r) {
      var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function a() {
        var t = pt(this, w.extend({}, e), o);
        (i || J.get(this, "finish")) && t.stop(!0);
      };

      return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
    },
    stop: function stop(e, t, n) {
      var r = function r(e) {
        var t = e.stop;
        delete e.stop, t(n);
      };

      return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
        var t = !0,
            i = null != e && e + "queueHooks",
            o = w.timers,
            a = J.get(this);
        if (i) a[i] && a[i].stop && r(a[i]);else for (i in a) {
          a[i] && a[i].stop && ot.test(i) && r(a[i]);
        }

        for (i = o.length; i--;) {
          o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
        }

        !t && n || w.dequeue(this, e);
      });
    },
    finish: function finish(e) {
      return !1 !== e && (e = e || "fx"), this.each(function () {
        var t,
            n = J.get(this),
            r = n[e + "queue"],
            i = n[e + "queueHooks"],
            o = w.timers,
            a = r ? r.length : 0;

        for (n.finish = !0, w.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) {
          o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
        }

        for (t = 0; t < a; t++) {
          r[t] && r[t].finish && r[t].finish.call(this);
        }

        delete n.finish;
      });
    }
  }), w.each(["toggle", "show", "hide"], function (e, t) {
    var n = w.fn[t];

    w.fn[t] = function (e, r, i) {
      return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ut(t, !0), e, r, i);
    };
  }), w.each({
    slideDown: ut("show"),
    slideUp: ut("hide"),
    slideToggle: ut("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (e, t) {
    w.fn[e] = function (e, n, r) {
      return this.animate(t, e, n, r);
    };
  }), w.timers = [], w.fx.tick = function () {
    var e,
        t = 0,
        n = w.timers;

    for (nt = Date.now(); t < n.length; t++) {
      (e = n[t])() || n[t] !== e || n.splice(t--, 1);
    }

    n.length || w.fx.stop(), nt = void 0;
  }, w.fx.timer = function (e) {
    w.timers.push(e), w.fx.start();
  }, w.fx.interval = 13, w.fx.start = function () {
    rt || (rt = !0, at());
  }, w.fx.stop = function () {
    rt = null;
  }, w.fx.speeds = {
    slow: 600,
    fast: 200,
    _default: 400
  }, w.fn.delay = function (t, n) {
    return t = w.fx ? w.fx.speeds[t] || t : t, n = n || "fx", this.queue(n, function (n, r) {
      var i = e.setTimeout(n, t);

      r.stop = function () {
        e.clearTimeout(i);
      };
    });
  }, function () {
    var e = r.createElement("input"),
        t = r.createElement("select").appendChild(r.createElement("option"));
    e.type = "checkbox", h.checkOn = "" !== e.value, h.optSelected = t.selected, (e = r.createElement("input")).value = "t", e.type = "radio", h.radioValue = "t" === e.value;
  }();
  var dt,
      ht = w.expr.attrHandle;
  w.fn.extend({
    attr: function attr(e, t) {
      return z(this, w.attr, e, t, arguments.length > 1);
    },
    removeAttr: function removeAttr(e) {
      return this.each(function () {
        w.removeAttr(this, e);
      });
    }
  }), w.extend({
    attr: function attr(e, t, n) {
      var r,
          i,
          o = e.nodeType;
      if (3 !== o && 8 !== o && 2 !== o) return "undefined" == typeof e.getAttribute ? w.prop(e, t, n) : (1 === o && w.isXMLDoc(e) || (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)), void 0 !== n ? null === n ? void w.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = w.find.attr(e, t)) ? void 0 : r);
    },
    attrHooks: {
      type: {
        set: function set(e, t) {
          if (!h.radioValue && "radio" === t && N(e, "input")) {
            var n = e.value;
            return e.setAttribute("type", t), n && (e.value = n), t;
          }
        }
      }
    },
    removeAttr: function removeAttr(e, t) {
      var n,
          r = 0,
          i = t && t.match(M);
      if (i && 1 === e.nodeType) while (n = i[r++]) {
        e.removeAttribute(n);
      }
    }
  }), dt = {
    set: function set(e, t, n) {
      return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
    }
  }, w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
    var n = ht[t] || w.find.attr;

    ht[t] = function (e, t, r) {
      var i,
          o,
          a = t.toLowerCase();
      return r || (o = ht[a], ht[a] = i, i = null != n(e, t, r) ? a : null, ht[a] = o), i;
    };
  });
  var gt = /^(?:input|select|textarea|button)$/i,
      yt = /^(?:a|area)$/i;
  w.fn.extend({
    prop: function prop(e, t) {
      return z(this, w.prop, e, t, arguments.length > 1);
    },
    removeProp: function removeProp(e) {
      return this.each(function () {
        delete this[w.propFix[e] || e];
      });
    }
  }), w.extend({
    prop: function prop(e, t, n) {
      var r,
          i,
          o = e.nodeType;
      if (3 !== o && 8 !== o && 2 !== o) return 1 === o && w.isXMLDoc(e) || (t = w.propFix[t] || t, i = w.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
    },
    propHooks: {
      tabIndex: {
        get: function get(e) {
          var t = w.find.attr(e, "tabindex");
          return t ? parseInt(t, 10) : gt.test(e.nodeName) || yt.test(e.nodeName) && e.href ? 0 : -1;
        }
      }
    },
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  }), h.optSelected || (w.propHooks.selected = {
    get: function get(e) {
      var t = e.parentNode;
      return t && t.parentNode && t.parentNode.selectedIndex, null;
    },
    set: function set(e) {
      var t = e.parentNode;
      t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
    }
  }), w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    w.propFix[this.toLowerCase()] = this;
  });

  function vt(e) {
    return (e.match(M) || []).join(" ");
  }

  function mt(e) {
    return e.getAttribute && e.getAttribute("class") || "";
  }

  function xt(e) {
    return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : [];
  }

  w.fn.extend({
    addClass: function addClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
      if (g(e)) return this.each(function (t) {
        w(this).addClass(e.call(this, t, mt(this)));
      });
      if ((t = xt(e)).length) while (n = this[u++]) {
        if (i = mt(n), r = 1 === n.nodeType && " " + vt(i) + " ") {
          a = 0;

          while (o = t[a++]) {
            r.indexOf(" " + o + " ") < 0 && (r += o + " ");
          }

          i !== (s = vt(r)) && n.setAttribute("class", s);
        }
      }
      return this;
    },
    removeClass: function removeClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
      if (g(e)) return this.each(function (t) {
        w(this).removeClass(e.call(this, t, mt(this)));
      });
      if (!arguments.length) return this.attr("class", "");
      if ((t = xt(e)).length) while (n = this[u++]) {
        if (i = mt(n), r = 1 === n.nodeType && " " + vt(i) + " ") {
          a = 0;

          while (o = t[a++]) {
            while (r.indexOf(" " + o + " ") > -1) {
              r = r.replace(" " + o + " ", " ");
            }
          }

          i !== (s = vt(r)) && n.setAttribute("class", s);
        }
      }
      return this;
    },
    toggleClass: function toggleClass(e, t) {
      var n = _typeof(e),
          r = "string" === n || Array.isArray(e);

      return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function (n) {
        w(this).toggleClass(e.call(this, n, mt(this), t), t);
      }) : this.each(function () {
        var t, i, o, a;

        if (r) {
          i = 0, o = w(this), a = xt(e);

          while (t = a[i++]) {
            o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
          }
        } else void 0 !== e && "boolean" !== n || ((t = mt(this)) && J.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""));
      });
    },
    hasClass: function hasClass(e) {
      var t,
          n,
          r = 0;
      t = " " + e + " ";

      while (n = this[r++]) {
        if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1) return !0;
      }

      return !1;
    }
  });
  var bt = /\r/g;
  w.fn.extend({
    val: function val(e) {
      var t,
          n,
          r,
          i = this[0];
      {
        if (arguments.length) return r = g(e), this.each(function (n) {
          var i;
          1 === this.nodeType && (null == (i = r ? e.call(this, n, w(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = w.map(i, function (e) {
            return null == e ? "" : e + "";
          })), (t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
        });
        if (i) return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(bt, "") : null == n ? "" : n;
      }
    }
  }), w.extend({
    valHooks: {
      option: {
        get: function get(e) {
          var t = w.find.attr(e, "value");
          return null != t ? t : vt(w.text(e));
        }
      },
      select: {
        get: function get(e) {
          var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;

          for (r = o < 0 ? u : a ? o : 0; r < u; r++) {
            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))) {
              if (t = w(n).val(), a) return t;
              s.push(t);
            }
          }

          return s;
        },
        set: function set(e, t) {
          var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;

          while (a--) {
            ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
          }

          return n || (e.selectedIndex = -1), o;
        }
      }
    }
  }), w.each(["radio", "checkbox"], function () {
    w.valHooks[this] = {
      set: function set(e, t) {
        if (Array.isArray(t)) return e.checked = w.inArray(w(e).val(), t) > -1;
      }
    }, h.checkOn || (w.valHooks[this].get = function (e) {
      return null === e.getAttribute("value") ? "on" : e.value;
    });
  }), h.focusin = "onfocusin" in e;

  var wt = /^(?:focusinfocus|focusoutblur)$/,
      Tt = function Tt(e) {
    e.stopPropagation();
  };

  w.extend(w.event, {
    trigger: function trigger(t, n, i, o) {
      var a,
          s,
          u,
          l,
          c,
          p,
          d,
          h,
          v = [i || r],
          m = f.call(t, "type") ? t.type : t,
          x = f.call(t, "namespace") ? t.namespace.split(".") : [];

      if (s = h = u = i = i || r, 3 !== i.nodeType && 8 !== i.nodeType && !wt.test(m + w.event.triggered) && (m.indexOf(".") > -1 && (m = (x = m.split(".")).shift(), x.sort()), c = m.indexOf(":") < 0 && "on" + m, t = t[w.expando] ? t : new w.Event(m, "object" == _typeof(t) && t), t.isTrigger = o ? 2 : 3, t.namespace = x.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : w.makeArray(n, [t]), d = w.event.special[m] || {}, o || !d.trigger || !1 !== d.trigger.apply(i, n))) {
        if (!o && !d.noBubble && !y(i)) {
          for (l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode) {
            v.push(s), u = s;
          }

          u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e);
        }

        a = 0;

        while ((s = v[a++]) && !t.isPropagationStopped()) {
          h = s, t.type = a > 1 ? l : d.bindType || m, (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) && p.apply(s, n), (p = c && s[c]) && p.apply && Y(s) && (t.result = p.apply(s, n), !1 === t.result && t.preventDefault());
        }

        return t.type = m, o || t.isDefaultPrevented() || d._default && !1 !== d._default.apply(v.pop(), n) || !Y(i) || c && g(i[m]) && !y(i) && ((u = i[c]) && (i[c] = null), w.event.triggered = m, t.isPropagationStopped() && h.addEventListener(m, Tt), i[m](), t.isPropagationStopped() && h.removeEventListener(m, Tt), w.event.triggered = void 0, u && (i[c] = u)), t.result;
      }
    },
    simulate: function simulate(e, t, n) {
      var r = w.extend(new w.Event(), n, {
        type: e,
        isSimulated: !0
      });
      w.event.trigger(r, null, t);
    }
  }), w.fn.extend({
    trigger: function trigger(e, t) {
      return this.each(function () {
        w.event.trigger(e, t, this);
      });
    },
    triggerHandler: function triggerHandler(e, t) {
      var n = this[0];
      if (n) return w.event.trigger(e, t, n, !0);
    }
  }), h.focusin || w.each({
    focus: "focusin",
    blur: "focusout"
  }, function (e, t) {
    var n = function n(e) {
      w.event.simulate(t, e.target, w.event.fix(e));
    };

    w.event.special[t] = {
      setup: function setup() {
        var r = this.ownerDocument || this,
            i = J.access(r, t);
        i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1);
      },
      teardown: function teardown() {
        var r = this.ownerDocument || this,
            i = J.access(r, t) - 1;
        i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0), J.remove(r, t));
      }
    };
  });
  var Ct = e.location,
      Et = Date.now(),
      kt = /\?/;

  w.parseXML = function (t) {
    var n;
    if (!t || "string" != typeof t) return null;

    try {
      n = new e.DOMParser().parseFromString(t, "text/xml");
    } catch (e) {
      n = void 0;
    }

    return n && !n.getElementsByTagName("parsererror").length || w.error("Invalid XML: " + t), n;
  };

  var St = /\[\]$/,
      Dt = /\r?\n/g,
      Nt = /^(?:submit|button|image|reset|file)$/i,
      At = /^(?:input|select|textarea|keygen)/i;

  function jt(e, t, n, r) {
    var i;
    if (Array.isArray(t)) w.each(t, function (t, i) {
      n || St.test(e) ? r(e, i) : jt(e + "[" + ("object" == _typeof(i) && null != i ? t : "") + "]", i, n, r);
    });else if (n || "object" !== x(t)) r(e, t);else for (i in t) {
      jt(e + "[" + i + "]", t[i], n, r);
    }
  }

  w.param = function (e, t) {
    var n,
        r = [],
        i = function i(e, t) {
      var n = g(t) ? t() : t;
      r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
    };

    if (Array.isArray(e) || e.jquery && !w.isPlainObject(e)) w.each(e, function () {
      i(this.name, this.value);
    });else for (n in e) {
      jt(n, e[n], t, i);
    }
    return r.join("&");
  }, w.fn.extend({
    serialize: function serialize() {
      return w.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        var e = w.prop(this, "elements");
        return e ? w.makeArray(e) : this;
      }).filter(function () {
        var e = this.type;
        return this.name && !w(this).is(":disabled") && At.test(this.nodeName) && !Nt.test(e) && (this.checked || !pe.test(e));
      }).map(function (e, t) {
        var n = w(this).val();
        return null == n ? null : Array.isArray(n) ? w.map(n, function (e) {
          return {
            name: t.name,
            value: e.replace(Dt, "\r\n")
          };
        }) : {
          name: t.name,
          value: n.replace(Dt, "\r\n")
        };
      }).get();
    }
  });
  var qt = /%20/g,
      Lt = /#.*$/,
      Ht = /([?&])_=[^&]*/,
      Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Mt = /^(?:GET|HEAD)$/,
      Rt = /^\/\//,
      It = {},
      Wt = {},
      $t = "*/".concat("*"),
      Bt = r.createElement("a");
  Bt.href = Ct.href;

  function Ft(e) {
    return function (t, n) {
      "string" != typeof t && (n = t, t = "*");
      var r,
          i = 0,
          o = t.toLowerCase().match(M) || [];
      if (g(n)) while (r = o[i++]) {
        "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
      }
    };
  }

  function _t(e, t, n, r) {
    var i = {},
        o = e === Wt;

    function a(s) {
      var u;
      return i[s] = !0, w.each(e[s] || [], function (e, s) {
        var l = s(t, n, r);
        return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (t.dataTypes.unshift(l), a(l), !1);
      }), u;
    }

    return a(t.dataTypes[0]) || !i["*"] && a("*");
  }

  function zt(e, t) {
    var n,
        r,
        i = w.ajaxSettings.flatOptions || {};

    for (n in t) {
      void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    }

    return r && w.extend(!0, e, r), e;
  }

  function Xt(e, t, n) {
    var r,
        i,
        o,
        a,
        s = e.contents,
        u = e.dataTypes;

    while ("*" === u[0]) {
      u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
    }

    if (r) for (i in s) {
      if (s[i] && s[i].test(r)) {
        u.unshift(i);
        break;
      }
    }
    if (u[0] in n) o = u[0];else {
      for (i in n) {
        if (!u[0] || e.converters[i + " " + u[0]]) {
          o = i;
          break;
        }

        a || (a = i);
      }

      o = o || a;
    }
    if (o) return o !== u[0] && u.unshift(o), n[o];
  }

  function Ut(e, t, n, r) {
    var i,
        o,
        a,
        s,
        u,
        l = {},
        c = e.dataTypes.slice();
    if (c[1]) for (a in e.converters) {
      l[a.toLowerCase()] = e.converters[a];
    }
    o = c.shift();

    while (o) {
      if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) if ("*" === o) o = u;else if ("*" !== u && u !== o) {
        if (!(a = l[u + " " + o] || l["* " + o])) for (i in l) {
          if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
            !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0], c.unshift(s[1]));
            break;
          }
        }
        if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
          t = a(t);
        } catch (e) {
          return {
            state: "parsererror",
            error: a ? e : "No conversion from " + u + " to " + o
          };
        }
      }
    }

    return {
      state: "success",
      data: t
    };
  }

  w.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Ct.href,
      type: "GET",
      isLocal: Pt.test(Ct.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": $t,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": JSON.parse,
        "text xml": w.parseXML
      },
      flatOptions: {
        url: !0,
        context: !0
      }
    },
    ajaxSetup: function ajaxSetup(e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e);
    },
    ajaxPrefilter: Ft(It),
    ajaxTransport: Ft(Wt),
    ajax: function ajax(t, n) {
      "object" == _typeof(t) && (n = t, t = void 0), n = n || {};
      var i,
          o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h = w.ajaxSetup({}, n),
          g = h.context || h,
          y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
          v = w.Deferred(),
          m = w.Callbacks("once memory"),
          x = h.statusCode || {},
          b = {},
          T = {},
          C = "canceled",
          E = {
        readyState: 0,
        getResponseHeader: function getResponseHeader(e) {
          var t;

          if (c) {
            if (!s) {
              s = {};

              while (t = Ot.exec(a)) {
                s[t[1].toLowerCase()] = t[2];
              }
            }

            t = s[e.toLowerCase()];
          }

          return null == t ? null : t;
        },
        getAllResponseHeaders: function getAllResponseHeaders() {
          return c ? a : null;
        },
        setRequestHeader: function setRequestHeader(e, t) {
          return null == c && (e = T[e.toLowerCase()] = T[e.toLowerCase()] || e, b[e] = t), this;
        },
        overrideMimeType: function overrideMimeType(e) {
          return null == c && (h.mimeType = e), this;
        },
        statusCode: function statusCode(e) {
          var t;
          if (e) if (c) E.always(e[E.status]);else for (t in e) {
            x[t] = [x[t], e[t]];
          }
          return this;
        },
        abort: function abort(e) {
          var t = e || C;
          return i && i.abort(t), k(0, t), this;
        }
      };

      if (v.promise(E), h.url = ((t || h.url || Ct.href) + "").replace(Rt, Ct.protocol + "//"), h.type = n.method || n.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""], null == h.crossDomain) {
        l = r.createElement("a");

        try {
          l.href = h.url, l.href = l.href, h.crossDomain = Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host;
        } catch (e) {
          h.crossDomain = !0;
        }
      }

      if (h.data && h.processData && "string" != typeof h.data && (h.data = w.param(h.data, h.traditional)), _t(It, h, n, E), c) return E;
      (f = w.event && h.global) && 0 == w.active++ && w.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !Mt.test(h.type), o = h.url.replace(Lt, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(qt, "+")) : (d = h.url.slice(o.length), h.data && (h.processData || "string" == typeof h.data) && (o += (kt.test(o) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (o = o.replace(Ht, "$1"), d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d), h.url = o + d), h.ifModified && (w.lastModified[o] && E.setRequestHeader("If-Modified-Since", w.lastModified[o]), w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])), (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && E.setRequestHeader("Content-Type", h.contentType), E.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "") : h.accepts["*"]);

      for (p in h.headers) {
        E.setRequestHeader(p, h.headers[p]);
      }

      if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c)) return E.abort();

      if (C = "abort", m.add(h.complete), E.done(h.success), E.fail(h.error), i = _t(Wt, h, n, E)) {
        if (E.readyState = 1, f && y.trigger("ajaxSend", [E, h]), c) return E;
        h.async && h.timeout > 0 && (u = e.setTimeout(function () {
          E.abort("timeout");
        }, h.timeout));

        try {
          c = !1, i.send(b, k);
        } catch (e) {
          if (c) throw e;
          k(-1, e);
        }
      } else k(-1, "No Transport");

      function k(t, n, r, s) {
        var l,
            p,
            d,
            b,
            T,
            C = n;
        c || (c = !0, u && e.clearTimeout(u), i = void 0, a = s || "", E.readyState = t > 0 ? 4 : 0, l = t >= 200 && t < 300 || 304 === t, r && (b = Xt(h, E, r)), b = Ut(h, b, E, l), l ? (h.ifModified && ((T = E.getResponseHeader("Last-Modified")) && (w.lastModified[o] = T), (T = E.getResponseHeader("etag")) && (w.etag[o] = T)), 204 === t || "HEAD" === h.type ? C = "nocontent" : 304 === t ? C = "notmodified" : (C = b.state, p = b.data, l = !(d = b.error))) : (d = C, !t && C || (C = "error", t < 0 && (t = 0))), E.status = t, E.statusText = (n || C) + "", l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]), E.statusCode(x), x = void 0, f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]), m.fireWith(g, [E, C]), f && (y.trigger("ajaxComplete", [E, h]), --w.active || w.event.trigger("ajaxStop")));
      }

      return E;
    },
    getJSON: function getJSON(e, t, n) {
      return w.get(e, t, n, "json");
    },
    getScript: function getScript(e, t) {
      return w.get(e, void 0, t, "script");
    }
  }), w.each(["get", "post"], function (e, t) {
    w[t] = function (e, n, r, i) {
      return g(n) && (i = i || r, r = n, n = void 0), w.ajax(w.extend({
        url: e,
        type: t,
        dataType: i,
        data: n,
        success: r
      }, w.isPlainObject(e) && e));
    };
  }), w._evalUrl = function (e) {
    return w.ajax({
      url: e,
      type: "GET",
      dataType: "script",
      cache: !0,
      async: !1,
      global: !1,
      "throws": !0
    });
  }, w.fn.extend({
    wrapAll: function wrapAll(e) {
      var t;
      return this[0] && (g(e) && (e = e.call(this[0])), t = w(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
        var e = this;

        while (e.firstElementChild) {
          e = e.firstElementChild;
        }

        return e;
      }).append(this)), this;
    },
    wrapInner: function wrapInner(e) {
      return g(e) ? this.each(function (t) {
        w(this).wrapInner(e.call(this, t));
      }) : this.each(function () {
        var t = w(this),
            n = t.contents();
        n.length ? n.wrapAll(e) : t.append(e);
      });
    },
    wrap: function wrap(e) {
      var t = g(e);
      return this.each(function (n) {
        w(this).wrapAll(t ? e.call(this, n) : e);
      });
    },
    unwrap: function unwrap(e) {
      return this.parent(e).not("body").each(function () {
        w(this).replaceWith(this.childNodes);
      }), this;
    }
  }), w.expr.pseudos.hidden = function (e) {
    return !w.expr.pseudos.visible(e);
  }, w.expr.pseudos.visible = function (e) {
    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
  }, w.ajaxSettings.xhr = function () {
    try {
      return new e.XMLHttpRequest();
    } catch (e) {}
  };
  var Vt = {
    0: 200,
    1223: 204
  },
      Gt = w.ajaxSettings.xhr();
  h.cors = !!Gt && "withCredentials" in Gt, h.ajax = Gt = !!Gt, w.ajaxTransport(function (t) {
    var _n, r;

    if (h.cors || Gt && !t.crossDomain) return {
      send: function send(i, o) {
        var a,
            s = t.xhr();
        if (s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields) for (a in t.xhrFields) {
          s[a] = t.xhrFields[a];
        }
        t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType), t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");

        for (a in i) {
          s.setRequestHeader(a, i[a]);
        }

        _n = function n(e) {
          return function () {
            _n && (_n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Vt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
              binary: s.response
            } : {
              text: s.responseText
            }, s.getAllResponseHeaders()));
          };
        }, s.onload = _n(), r = s.onerror = s.ontimeout = _n("error"), void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function () {
          4 === s.readyState && e.setTimeout(function () {
            _n && r();
          });
        }, _n = _n("abort");

        try {
          s.send(t.hasContent && t.data || null);
        } catch (e) {
          if (_n) throw e;
        }
      },
      abort: function abort() {
        _n && _n();
      }
    };
  }), w.ajaxPrefilter(function (e) {
    e.crossDomain && (e.contents.script = !1);
  }), w.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function textScript(e) {
        return w.globalEval(e), e;
      }
    }
  }), w.ajaxPrefilter("script", function (e) {
    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
  }), w.ajaxTransport("script", function (e) {
    if (e.crossDomain) {
      var t, _n2;

      return {
        send: function send(i, o) {
          t = w("<script>").prop({
            charset: e.scriptCharset,
            src: e.url
          }).on("load error", _n2 = function n(e) {
            t.remove(), _n2 = null, e && o("error" === e.type ? 404 : 200, e.type);
          }), r.head.appendChild(t[0]);
        },
        abort: function abort() {
          _n2 && _n2();
        }
      };
    }
  });
  var Yt = [],
      Qt = /(=)\?(?=&|$)|\?\?/;
  w.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var e = Yt.pop() || w.expando + "_" + Et++;
      return this[e] = !0, e;
    }
  }), w.ajaxPrefilter("json jsonp", function (t, n, r) {
    var i,
        o,
        a,
        s = !1 !== t.jsonp && (Qt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qt.test(t.data) && "data");
    if (s || "jsonp" === t.dataTypes[0]) return i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(Qt, "$1" + i) : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function () {
      return a || w.error(i + " was not called"), a[0];
    }, t.dataTypes[0] = "json", o = e[i], e[i] = function () {
      a = arguments;
    }, r.always(function () {
      void 0 === o ? w(e).removeProp(i) : e[i] = o, t[i] && (t.jsonpCallback = n.jsonpCallback, Yt.push(i)), a && g(o) && o(a[0]), a = o = void 0;
    }), "script";
  }), h.createHTMLDocument = function () {
    var e = r.implementation.createHTMLDocument("").body;
    return e.innerHTML = "<form></form><form></form>", 2 === e.childNodes.length;
  }(), w.parseHTML = function (e, t, n) {
    if ("string" != typeof e) return [];
    "boolean" == typeof t && (n = t, t = !1);
    var i, o, a;
    return t || (h.createHTMLDocument ? ((i = (t = r.implementation.createHTMLDocument("")).createElement("base")).href = r.location.href, t.head.appendChild(i)) : t = r), o = A.exec(e), a = !n && [], o ? [t.createElement(o[1])] : (o = xe([e], t, a), a && a.length && w(a).remove(), w.merge([], o.childNodes));
  }, w.fn.load = function (e, t, n) {
    var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");
    return s > -1 && (r = vt(e.slice(s)), e = e.slice(0, s)), g(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (i = "POST"), a.length > 0 && w.ajax({
      url: e,
      type: i || "GET",
      dataType: "html",
      data: t
    }).done(function (e) {
      o = arguments, a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e);
    }).always(n && function (e, t) {
      a.each(function () {
        n.apply(this, o || [e.responseText, t, e]);
      });
    }), this;
  }, w.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
    w.fn[t] = function (e) {
      return this.on(t, e);
    };
  }), w.expr.pseudos.animated = function (e) {
    return w.grep(w.timers, function (t) {
      return e === t.elem;
    }).length;
  }, w.offset = {
    setOffset: function setOffset(e, t, n) {
      var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, "position"),
          f = w(e),
          p = {};
      "static" === c && (e.style.position = "relative"), s = f.offset(), o = w.css(e, "top"), u = w.css(e, "left"), (l = ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1) ? (a = (r = f.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), g(t) && (t = t.call(e, n, w.extend({}, s))), null != t.top && (p.top = t.top - s.top + a), null != t.left && (p.left = t.left - s.left + i), "using" in t ? t.using.call(e, p) : f.css(p);
    }
  }, w.fn.extend({
    offset: function offset(e) {
      if (arguments.length) return void 0 === e ? this : this.each(function (t) {
        w.offset.setOffset(this, e, t);
      });
      var t,
          n,
          r = this[0];
      if (r) return r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
        top: t.top + n.pageYOffset,
        left: t.left + n.pageXOffset
      }) : {
        top: 0,
        left: 0
      };
    },
    position: function position() {
      if (this[0]) {
        var e,
            t,
            n,
            r = this[0],
            i = {
          top: 0,
          left: 0
        };
        if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect();else {
          t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;

          while (e && (e === n.body || e === n.documentElement) && "static" === w.css(e, "position")) {
            e = e.parentNode;
          }

          e && e !== r && 1 === e.nodeType && ((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0), i.left += w.css(e, "borderLeftWidth", !0));
        }
        return {
          top: t.top - i.top - w.css(r, "marginTop", !0),
          left: t.left - i.left - w.css(r, "marginLeft", !0)
        };
      }
    },
    offsetParent: function offsetParent() {
      return this.map(function () {
        var e = this.offsetParent;

        while (e && "static" === w.css(e, "position")) {
          e = e.offsetParent;
        }

        return e || be;
      });
    }
  }), w.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (e, t) {
    var n = "pageYOffset" === t;

    w.fn[e] = function (r) {
      return z(this, function (e, r, i) {
        var o;
        if (y(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];
        o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
      }, e, r, arguments.length);
    };
  }), w.each(["top", "left"], function (e, t) {
    w.cssHooks[t] = _e(h.pixelPosition, function (e, n) {
      if (n) return n = Fe(e, t), We.test(n) ? w(e).position()[t] + "px" : n;
    });
  }), w.each({
    Height: "height",
    Width: "width"
  }, function (e, t) {
    w.each({
      padding: "inner" + e,
      content: t,
      "": "outer" + e
    }, function (n, r) {
      w.fn[r] = function (i, o) {
        var a = arguments.length && (n || "boolean" != typeof i),
            s = n || (!0 === i || !0 === o ? "margin" : "border");
        return z(this, function (t, n, i) {
          var o;
          return y(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? w.css(t, n, s) : w.style(t, n, i, s);
        }, t, a ? i : void 0, a);
      };
    });
  }), w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
    w.fn[t] = function (e, n) {
      return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
    };
  }), w.fn.extend({
    hover: function hover(e, t) {
      return this.mouseenter(e).mouseleave(t || e);
    }
  }), w.fn.extend({
    bind: function bind(e, t, n) {
      return this.on(e, null, t, n);
    },
    unbind: function unbind(e, t) {
      return this.off(e, null, t);
    },
    delegate: function delegate(e, t, n, r) {
      return this.on(t, e, n, r);
    },
    undelegate: function undelegate(e, t, n) {
      return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
    }
  }), w.proxy = function (e, t) {
    var n, r, i;
    if ("string" == typeof t && (n = e[t], t = e, e = n), g(e)) return r = o.call(arguments, 2), i = function i() {
      return e.apply(t || this, r.concat(o.call(arguments)));
    }, i.guid = e.guid = e.guid || w.guid++, i;
  }, w.holdReady = function (e) {
    e ? w.readyWait++ : w.ready(!0);
  }, w.isArray = Array.isArray, w.parseJSON = JSON.parse, w.nodeName = N, w.isFunction = g, w.isWindow = y, w.camelCase = G, w.type = x, w.now = Date.now, w.isNumeric = function (e) {
    var t = w.type(e);
    return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
  }, "function" == typeof define && define.amd && define("jquery", [], function () {
    return w;
  });
  var Jt = e.jQuery,
      Kt = e.$;
  return w.noConflict = function (t) {
    return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w;
  }, t || (e.jQuery = e.$ = w), w;
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Datepicker for Bootstrap v1.6.4 (https://github.com/eternicode/bootstrap-datepicker)
 *
 * Copyright 2012 Stefan Petre
 * Improvements by Andrew Rowls
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */
!function (a) {
  "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("jquery") : jQuery);
}(function (a, b) {
  function c() {
    return new Date(Date.UTC.apply(Date, arguments));
  }

  function d() {
    var a = new Date();
    return c(a.getFullYear(), a.getMonth(), a.getDate());
  }

  function e(a, b) {
    return a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate();
  }

  function f(a) {
    return function () {
      return this[a].apply(this, arguments);
    };
  }

  function g(a) {
    return a && !isNaN(a.getTime());
  }

  function h(b, c) {
    function d(a, b) {
      return b.toLowerCase();
    }

    var e,
        f = a(b).data(),
        g = {},
        h = new RegExp("^" + c.toLowerCase() + "([A-Z])");
    c = new RegExp("^" + c.toLowerCase());

    for (var i in f) {
      c.test(i) && (e = i.replace(h, d), g[e] = f[i]);
    }

    return g;
  }

  function i(b) {
    var c = {};

    if (q[b] || (b = b.split("-")[0], q[b])) {
      var d = q[b];
      return a.each(p, function (a, b) {
        b in d && (c[b] = d[b]);
      }), c;
    }
  }

  var j = function () {
    var b = {
      get: function get(a) {
        return this.slice(a)[0];
      },
      contains: function contains(a) {
        for (var b = a && a.valueOf(), c = 0, d = this.length; d > c; c++) {
          if (this[c].valueOf() === b) return c;
        }

        return -1;
      },
      remove: function remove(a) {
        this.splice(a, 1);
      },
      replace: function replace(b) {
        b && (a.isArray(b) || (b = [b]), this.clear(), this.push.apply(this, b));
      },
      clear: function clear() {
        this.length = 0;
      },
      copy: function copy() {
        var a = new j();
        return a.replace(this), a;
      }
    };
    return function () {
      var c = [];
      return c.push.apply(c, arguments), a.extend(c, b), c;
    };
  }(),
      k = function k(b, c) {
    a(b).data("datepicker", this), this._process_options(c), this.dates = new j(), this.viewDate = this.o.defaultViewDate, this.focusDate = null, this.element = a(b), this.isInput = this.element.is("input"), this.inputField = this.isInput ? this.element : this.element.find("input"), this.component = this.element.hasClass("date") ? this.element.find(".add-on, .input-group-addon, .btn") : !1, this.hasInput = this.component && this.inputField.length, this.component && 0 === this.component.length && (this.component = !1), this.isInline = !this.component && this.element.is("div"), this.picker = a(r.template), this._check_template(this.o.templates.leftArrow) && this.picker.find(".prev").html(this.o.templates.leftArrow), this._check_template(this.o.templates.rightArrow) && this.picker.find(".next").html(this.o.templates.rightArrow), this._buildEvents(), this._attachEvents(), this.isInline ? this.picker.addClass("datepicker-inline").appendTo(this.element) : this.picker.addClass("datepicker-dropdown dropdown-menu"), this.o.rtl && this.picker.addClass("datepicker-rtl"), this.viewMode = this.o.startView, this.o.calendarWeeks && this.picker.find("thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan", function (a, b) {
      return parseInt(b) + 1;
    }), this._allow_update = !1, this.setStartDate(this._o.startDate), this.setEndDate(this._o.endDate), this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled), this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted), this.setDatesDisabled(this.o.datesDisabled), this.fillDow(), this.fillMonths(), this._allow_update = !0, this.update(), this.showMode(), this.isInline && this.show();
  };

  k.prototype = {
    constructor: k,
    _resolveViewName: function _resolveViewName(a, c) {
      return 0 === a || "days" === a || "month" === a ? 0 : 1 === a || "months" === a || "year" === a ? 1 : 2 === a || "years" === a || "decade" === a ? 2 : 3 === a || "decades" === a || "century" === a ? 3 : 4 === a || "centuries" === a || "millennium" === a ? 4 : c === b ? !1 : c;
    },
    _check_template: function _check_template(c) {
      try {
        if (c === b || "" === c) return !1;
        if ((c.match(/[<>]/g) || []).length <= 0) return !0;
        var d = a(c);
        return d.length > 0;
      } catch (e) {
        return !1;
      }
    },
    _process_options: function _process_options(b) {
      this._o = a.extend({}, this._o, b);
      var e = this.o = a.extend({}, this._o),
          f = e.language;
      q[f] || (f = f.split("-")[0], q[f] || (f = o.language)), e.language = f, e.startView = this._resolveViewName(e.startView, 0), e.minViewMode = this._resolveViewName(e.minViewMode, 0), e.maxViewMode = this._resolveViewName(e.maxViewMode, 4), e.startView = Math.min(e.startView, e.maxViewMode), e.startView = Math.max(e.startView, e.minViewMode), e.multidate !== !0 && (e.multidate = Number(e.multidate) || !1, e.multidate !== !1 && (e.multidate = Math.max(0, e.multidate))), e.multidateSeparator = String(e.multidateSeparator), e.weekStart %= 7, e.weekEnd = (e.weekStart + 6) % 7;
      var g = r.parseFormat(e.format);
      e.startDate !== -(1 / 0) && (e.startDate ? e.startDate instanceof Date ? e.startDate = this._local_to_utc(this._zero_time(e.startDate)) : e.startDate = r.parseDate(e.startDate, g, e.language, e.assumeNearbyYear) : e.startDate = -(1 / 0)), e.endDate !== 1 / 0 && (e.endDate ? e.endDate instanceof Date ? e.endDate = this._local_to_utc(this._zero_time(e.endDate)) : e.endDate = r.parseDate(e.endDate, g, e.language, e.assumeNearbyYear) : e.endDate = 1 / 0), e.daysOfWeekDisabled = e.daysOfWeekDisabled || [], a.isArray(e.daysOfWeekDisabled) || (e.daysOfWeekDisabled = e.daysOfWeekDisabled.split(/[,\s]*/)), e.daysOfWeekDisabled = a.map(e.daysOfWeekDisabled, function (a) {
        return parseInt(a, 10);
      }), e.daysOfWeekHighlighted = e.daysOfWeekHighlighted || [], a.isArray(e.daysOfWeekHighlighted) || (e.daysOfWeekHighlighted = e.daysOfWeekHighlighted.split(/[,\s]*/)), e.daysOfWeekHighlighted = a.map(e.daysOfWeekHighlighted, function (a) {
        return parseInt(a, 10);
      }), e.datesDisabled = e.datesDisabled || [], a.isArray(e.datesDisabled) || (e.datesDisabled = [e.datesDisabled]), e.datesDisabled = a.map(e.datesDisabled, function (a) {
        return r.parseDate(a, g, e.language, e.assumeNearbyYear);
      });
      var h = String(e.orientation).toLowerCase().split(/\s+/g),
          i = e.orientation.toLowerCase();
      if (h = a.grep(h, function (a) {
        return /^auto|left|right|top|bottom$/.test(a);
      }), e.orientation = {
        x: "auto",
        y: "auto"
      }, i && "auto" !== i) {
        if (1 === h.length) switch (h[0]) {
          case "top":
          case "bottom":
            e.orientation.y = h[0];
            break;

          case "left":
          case "right":
            e.orientation.x = h[0];
        } else i = a.grep(h, function (a) {
          return /^left|right$/.test(a);
        }), e.orientation.x = i[0] || "auto", i = a.grep(h, function (a) {
          return /^top|bottom$/.test(a);
        }), e.orientation.y = i[0] || "auto";
      } else ;

      if (e.defaultViewDate) {
        var j = e.defaultViewDate.year || new Date().getFullYear(),
            k = e.defaultViewDate.month || 0,
            l = e.defaultViewDate.day || 1;
        e.defaultViewDate = c(j, k, l);
      } else e.defaultViewDate = d();
    },
    _events: [],
    _secondaryEvents: [],
    _applyEvents: function _applyEvents(a) {
      for (var c, d, e, f = 0; f < a.length; f++) {
        c = a[f][0], 2 === a[f].length ? (d = b, e = a[f][1]) : 3 === a[f].length && (d = a[f][1], e = a[f][2]), c.on(e, d);
      }
    },
    _unapplyEvents: function _unapplyEvents(a) {
      for (var c, d, e, f = 0; f < a.length; f++) {
        c = a[f][0], 2 === a[f].length ? (e = b, d = a[f][1]) : 3 === a[f].length && (e = a[f][1], d = a[f][2]), c.off(d, e);
      }
    },
    _buildEvents: function _buildEvents() {
      var b = {
        keyup: a.proxy(function (b) {
          -1 === a.inArray(b.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) && this.update();
        }, this),
        keydown: a.proxy(this.keydown, this),
        paste: a.proxy(this.paste, this)
      };
      this.o.showOnFocus === !0 && (b.focus = a.proxy(this.show, this)), this.isInput ? this._events = [[this.element, b]] : this.component && this.hasInput ? this._events = [[this.inputField, b], [this.component, {
        click: a.proxy(this.show, this)
      }]] : this._events = [[this.element, {
        click: a.proxy(this.show, this),
        keydown: a.proxy(this.keydown, this)
      }]], this._events.push([this.element, "*", {
        blur: a.proxy(function (a) {
          this._focused_from = a.target;
        }, this)
      }], [this.element, {
        blur: a.proxy(function (a) {
          this._focused_from = a.target;
        }, this)
      }]), this.o.immediateUpdates && this._events.push([this.element, {
        "changeYear changeMonth": a.proxy(function (a) {
          this.update(a.date);
        }, this)
      }]), this._secondaryEvents = [[this.picker, {
        click: a.proxy(this.click, this)
      }], [a(window), {
        resize: a.proxy(this.place, this)
      }], [a(document), {
        mousedown: a.proxy(function (a) {
          this.element.is(a.target) || this.element.find(a.target).length || this.picker.is(a.target) || this.picker.find(a.target).length || this.isInline || this.hide();
        }, this)
      }]];
    },
    _attachEvents: function _attachEvents() {
      this._detachEvents(), this._applyEvents(this._events);
    },
    _detachEvents: function _detachEvents() {
      this._unapplyEvents(this._events);
    },
    _attachSecondaryEvents: function _attachSecondaryEvents() {
      this._detachSecondaryEvents(), this._applyEvents(this._secondaryEvents);
    },
    _detachSecondaryEvents: function _detachSecondaryEvents() {
      this._unapplyEvents(this._secondaryEvents);
    },
    _trigger: function _trigger(b, c) {
      var d = c || this.dates.get(-1),
          e = this._utc_to_local(d);

      this.element.trigger({
        type: b,
        date: e,
        dates: a.map(this.dates, this._utc_to_local),
        format: a.proxy(function (a, b) {
          0 === arguments.length ? (a = this.dates.length - 1, b = this.o.format) : "string" == typeof a && (b = a, a = this.dates.length - 1), b = b || this.o.format;
          var c = this.dates.get(a);
          return r.formatDate(c, b, this.o.language);
        }, this)
      });
    },
    show: function show() {
      return this.inputField.prop("disabled") || this.inputField.prop("readonly") && this.o.enableOnReadonly === !1 ? void 0 : (this.isInline || this.picker.appendTo(this.o.container), this.place(), this.picker.show(), this._attachSecondaryEvents(), this._trigger("show"), (window.navigator.msMaxTouchPoints || "ontouchstart" in document) && this.o.disableTouchKeyboard && a(this.element).blur(), this);
    },
    hide: function hide() {
      return this.isInline || !this.picker.is(":visible") ? this : (this.focusDate = null, this.picker.hide().detach(), this._detachSecondaryEvents(), this.viewMode = this.o.startView, this.showMode(), this.o.forceParse && this.inputField.val() && this.setValue(), this._trigger("hide"), this);
    },
    destroy: function destroy() {
      return this.hide(), this._detachEvents(), this._detachSecondaryEvents(), this.picker.remove(), delete this.element.data().datepicker, this.isInput || delete this.element.data().date, this;
    },
    paste: function paste(b) {
      var c;
      if (b.originalEvent.clipboardData && b.originalEvent.clipboardData.types && -1 !== a.inArray("text/plain", b.originalEvent.clipboardData.types)) c = b.originalEvent.clipboardData.getData("text/plain");else {
        if (!window.clipboardData) return;
        c = window.clipboardData.getData("Text");
      }
      this.setDate(c), this.update(), b.preventDefault();
    },
    _utc_to_local: function _utc_to_local(a) {
      return a && new Date(a.getTime() + 6e4 * a.getTimezoneOffset());
    },
    _local_to_utc: function _local_to_utc(a) {
      return a && new Date(a.getTime() - 6e4 * a.getTimezoneOffset());
    },
    _zero_time: function _zero_time(a) {
      return a && new Date(a.getFullYear(), a.getMonth(), a.getDate());
    },
    _zero_utc_time: function _zero_utc_time(a) {
      return a && new Date(Date.UTC(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()));
    },
    getDates: function getDates() {
      return a.map(this.dates, this._utc_to_local);
    },
    getUTCDates: function getUTCDates() {
      return a.map(this.dates, function (a) {
        return new Date(a);
      });
    },
    getDate: function getDate() {
      return this._utc_to_local(this.getUTCDate());
    },
    getUTCDate: function getUTCDate() {
      var a = this.dates.get(-1);
      return "undefined" != typeof a ? new Date(a) : null;
    },
    clearDates: function clearDates() {
      this.inputField && this.inputField.val(""), this.update(), this._trigger("changeDate"), this.o.autoclose && this.hide();
    },
    setDates: function setDates() {
      var b = a.isArray(arguments[0]) ? arguments[0] : arguments;
      return this.update.apply(this, b), this._trigger("changeDate"), this.setValue(), this;
    },
    setUTCDates: function setUTCDates() {
      var b = a.isArray(arguments[0]) ? arguments[0] : arguments;
      return this.update.apply(this, a.map(b, this._utc_to_local)), this._trigger("changeDate"), this.setValue(), this;
    },
    setDate: f("setDates"),
    setUTCDate: f("setUTCDates"),
    remove: f("destroy"),
    setValue: function setValue() {
      var a = this.getFormattedDate();
      return this.inputField.val(a), this;
    },
    getFormattedDate: function getFormattedDate(c) {
      c === b && (c = this.o.format);
      var d = this.o.language;
      return a.map(this.dates, function (a) {
        return r.formatDate(a, c, d);
      }).join(this.o.multidateSeparator);
    },
    getStartDate: function getStartDate() {
      return this.o.startDate;
    },
    setStartDate: function setStartDate(a) {
      return this._process_options({
        startDate: a
      }), this.update(), this.updateNavArrows(), this;
    },
    getEndDate: function getEndDate() {
      return this.o.endDate;
    },
    setEndDate: function setEndDate(a) {
      return this._process_options({
        endDate: a
      }), this.update(), this.updateNavArrows(), this;
    },
    setDaysOfWeekDisabled: function setDaysOfWeekDisabled(a) {
      return this._process_options({
        daysOfWeekDisabled: a
      }), this.update(), this.updateNavArrows(), this;
    },
    setDaysOfWeekHighlighted: function setDaysOfWeekHighlighted(a) {
      return this._process_options({
        daysOfWeekHighlighted: a
      }), this.update(), this;
    },
    setDatesDisabled: function setDatesDisabled(a) {
      this._process_options({
        datesDisabled: a
      }), this.update(), this.updateNavArrows();
    },
    place: function place() {
      if (this.isInline) return this;
      var b = this.picker.outerWidth(),
          c = this.picker.outerHeight(),
          d = 10,
          e = a(this.o.container),
          f = e.width(),
          g = "body" === this.o.container ? a(document).scrollTop() : e.scrollTop(),
          h = e.offset(),
          i = [];
      this.element.parents().each(function () {
        var b = a(this).css("z-index");
        "auto" !== b && 0 !== b && i.push(parseInt(b));
      });
      var j = Math.max.apply(Math, i) + this.o.zIndexOffset,
          k = this.component ? this.component.parent().offset() : this.element.offset(),
          l = this.component ? this.component.outerHeight(!0) : this.element.outerHeight(!1),
          m = this.component ? this.component.outerWidth(!0) : this.element.outerWidth(!1),
          n = k.left - h.left,
          o = k.top - h.top;
      "body" !== this.o.container && (o += g), this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"), "auto" !== this.o.orientation.x ? (this.picker.addClass("datepicker-orient-" + this.o.orientation.x), "right" === this.o.orientation.x && (n -= b - m)) : k.left < 0 ? (this.picker.addClass("datepicker-orient-left"), n -= k.left - d) : n + b > f ? (this.picker.addClass("datepicker-orient-right"), n += m - b) : this.picker.addClass("datepicker-orient-left");
      var p,
          q = this.o.orientation.y;

      if ("auto" === q && (p = -g + o - c, q = 0 > p ? "bottom" : "top"), this.picker.addClass("datepicker-orient-" + q), "top" === q ? o -= c + parseInt(this.picker.css("padding-top")) : o += l, this.o.rtl) {
        var r = f - (n + m);
        this.picker.css({
          top: o,
          right: r,
          zIndex: j
        });
      } else this.picker.css({
        top: o,
        left: n,
        zIndex: j
      });

      return this;
    },
    _allow_update: !0,
    update: function update() {
      if (!this._allow_update) return this;
      var b = this.dates.copy(),
          c = [],
          d = !1;
      return arguments.length ? (a.each(arguments, a.proxy(function (a, b) {
        b instanceof Date && (b = this._local_to_utc(b)), c.push(b);
      }, this)), d = !0) : (c = this.isInput ? this.element.val() : this.element.data("date") || this.inputField.val(), c = c && this.o.multidate ? c.split(this.o.multidateSeparator) : [c], delete this.element.data().date), c = a.map(c, a.proxy(function (a) {
        return r.parseDate(a, this.o.format, this.o.language, this.o.assumeNearbyYear);
      }, this)), c = a.grep(c, a.proxy(function (a) {
        return !this.dateWithinRange(a) || !a;
      }, this), !0), this.dates.replace(c), this.dates.length ? this.viewDate = new Date(this.dates.get(-1)) : this.viewDate < this.o.startDate ? this.viewDate = new Date(this.o.startDate) : this.viewDate > this.o.endDate ? this.viewDate = new Date(this.o.endDate) : this.viewDate = this.o.defaultViewDate, d ? this.setValue() : c.length && String(b) !== String(this.dates) && this._trigger("changeDate"), !this.dates.length && b.length && this._trigger("clearDate"), this.fill(), this.element.change(), this;
    },
    fillDow: function fillDow() {
      var b = this.o.weekStart,
          c = "<tr>";

      for (this.o.calendarWeeks && (this.picker.find(".datepicker-days .datepicker-switch").attr("colspan", function (a, b) {
        return parseInt(b) + 1;
      }), c += '<th class="cw">&#160;</th>'); b < this.o.weekStart + 7;) {
        c += '<th class="dow', a.inArray(b, this.o.daysOfWeekDisabled) > -1 && (c += " disabled"), c += '">' + q[this.o.language].daysMin[b++ % 7] + "</th>";
      }

      c += "</tr>", this.picker.find(".datepicker-days thead").append(c);
    },
    fillMonths: function fillMonths() {
      for (var a = this._utc_to_local(this.viewDate), b = "", c = 0; 12 > c;) {
        var d = a && a.getMonth() === c ? " focused" : "";
        b += '<span class="month' + d + '">' + q[this.o.language].monthsShort[c++] + "</span>";
      }

      this.picker.find(".datepicker-months td").html(b);
    },
    setRange: function setRange(b) {
      b && b.length ? this.range = a.map(b, function (a) {
        return a.valueOf();
      }) : delete this.range, this.fill();
    },
    getClassNames: function getClassNames(b) {
      var c = [],
          d = this.viewDate.getUTCFullYear(),
          e = this.viewDate.getUTCMonth(),
          f = new Date();
      return b.getUTCFullYear() < d || b.getUTCFullYear() === d && b.getUTCMonth() < e ? c.push("old") : (b.getUTCFullYear() > d || b.getUTCFullYear() === d && b.getUTCMonth() > e) && c.push("new"), this.focusDate && b.valueOf() === this.focusDate.valueOf() && c.push("focused"), this.o.todayHighlight && b.getUTCFullYear() === f.getFullYear() && b.getUTCMonth() === f.getMonth() && b.getUTCDate() === f.getDate() && c.push("today"), -1 !== this.dates.contains(b) && c.push("active"), this.dateWithinRange(b) || c.push("disabled"), this.dateIsDisabled(b) && c.push("disabled", "disabled-date"), -1 !== a.inArray(b.getUTCDay(), this.o.daysOfWeekHighlighted) && c.push("highlighted"), this.range && (b > this.range[0] && b < this.range[this.range.length - 1] && c.push("range"), -1 !== a.inArray(b.valueOf(), this.range) && c.push("selected"), b.valueOf() === this.range[0] && c.push("range-start"), b.valueOf() === this.range[this.range.length - 1] && c.push("range-end")), c;
    },
    _fill_yearsView: function _fill_yearsView(c, d, e, f, g, h, i, j) {
      var k, l, m, n, o, p, q, r, s, t, u;

      for (k = "", l = this.picker.find(c), m = parseInt(g / e, 10) * e, o = parseInt(h / f, 10) * f, p = parseInt(i / f, 10) * f, n = a.map(this.dates, function (a) {
        return parseInt(a.getUTCFullYear() / f, 10) * f;
      }), l.find(".datepicker-switch").text(m + "-" + (m + 9 * f)), q = m - f, r = -1; 11 > r; r += 1) {
        s = [d], t = null, -1 === r ? s.push("old") : 10 === r && s.push("new"), -1 !== a.inArray(q, n) && s.push("active"), (o > q || q > p) && s.push("disabled"), q === this.viewDate.getFullYear() && s.push("focused"), j !== a.noop && (u = j(new Date(q, 0, 1)), u === b ? u = {} : "boolean" == typeof u ? u = {
          enabled: u
        } : "string" == typeof u && (u = {
          classes: u
        }), u.enabled === !1 && s.push("disabled"), u.classes && (s = s.concat(u.classes.split(/\s+/))), u.tooltip && (t = u.tooltip)), k += '<span class="' + s.join(" ") + '"' + (t ? ' title="' + t + '"' : "") + ">" + q + "</span>", q += f;
      }

      l.find("td").html(k);
    },
    fill: function fill() {
      var d,
          e,
          f = new Date(this.viewDate),
          g = f.getUTCFullYear(),
          h = f.getUTCMonth(),
          i = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCFullYear() : -(1 / 0),
          j = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCMonth() : -(1 / 0),
          k = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCFullYear() : 1 / 0,
          l = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCMonth() : 1 / 0,
          m = q[this.o.language].today || q.en.today || "",
          n = q[this.o.language].clear || q.en.clear || "",
          o = q[this.o.language].titleFormat || q.en.titleFormat;

      if (!isNaN(g) && !isNaN(h)) {
        this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(f, o, this.o.language)), this.picker.find("tfoot .today").text(m).toggle(this.o.todayBtn !== !1), this.picker.find("tfoot .clear").text(n).toggle(this.o.clearBtn !== !1), this.picker.find("thead .datepicker-title").text(this.o.title).toggle("" !== this.o.title), this.updateNavArrows(), this.fillMonths();
        var p = c(g, h - 1, 28),
            s = r.getDaysInMonth(p.getUTCFullYear(), p.getUTCMonth());
        p.setUTCDate(s), p.setUTCDate(s - (p.getUTCDay() - this.o.weekStart + 7) % 7);
        var t = new Date(p);
        p.getUTCFullYear() < 100 && t.setUTCFullYear(p.getUTCFullYear()), t.setUTCDate(t.getUTCDate() + 42), t = t.valueOf();

        for (var u, v = []; p.valueOf() < t;) {
          if (p.getUTCDay() === this.o.weekStart && (v.push("<tr>"), this.o.calendarWeeks)) {
            var w = new Date(+p + (this.o.weekStart - p.getUTCDay() - 7) % 7 * 864e5),
                x = new Date(Number(w) + (11 - w.getUTCDay()) % 7 * 864e5),
                y = new Date(Number(y = c(x.getUTCFullYear(), 0, 1)) + (11 - y.getUTCDay()) % 7 * 864e5),
                z = (x - y) / 864e5 / 7 + 1;
            v.push('<td class="cw">' + z + "</td>");
          }

          u = this.getClassNames(p), u.push("day"), this.o.beforeShowDay !== a.noop && (e = this.o.beforeShowDay(this._utc_to_local(p)), e === b ? e = {} : "boolean" == typeof e ? e = {
            enabled: e
          } : "string" == typeof e && (e = {
            classes: e
          }), e.enabled === !1 && u.push("disabled"), e.classes && (u = u.concat(e.classes.split(/\s+/))), e.tooltip && (d = e.tooltip)), u = a.isFunction(a.uniqueSort) ? a.uniqueSort(u) : a.unique(u), v.push('<td class="' + u.join(" ") + '"' + (d ? ' title="' + d + '"' : "") + ">" + p.getUTCDate() + "</td>"), d = null, p.getUTCDay() === this.o.weekEnd && v.push("</tr>"), p.setUTCDate(p.getUTCDate() + 1);
        }

        this.picker.find(".datepicker-days tbody").empty().append(v.join(""));
        var A = q[this.o.language].monthsTitle || q.en.monthsTitle || "Months",
            B = this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode < 2 ? A : g).end().find("span").removeClass("active");

        if (a.each(this.dates, function (a, b) {
          b.getUTCFullYear() === g && B.eq(b.getUTCMonth()).addClass("active");
        }), (i > g || g > k) && B.addClass("disabled"), g === i && B.slice(0, j).addClass("disabled"), g === k && B.slice(l + 1).addClass("disabled"), this.o.beforeShowMonth !== a.noop) {
          var C = this;
          a.each(B, function (c, d) {
            var e = new Date(g, c, 1),
                f = C.o.beforeShowMonth(e);
            f === b ? f = {} : "boolean" == typeof f ? f = {
              enabled: f
            } : "string" == typeof f && (f = {
              classes: f
            }), f.enabled !== !1 || a(d).hasClass("disabled") || a(d).addClass("disabled"), f.classes && a(d).addClass(f.classes), f.tooltip && a(d).prop("title", f.tooltip);
          });
        }

        this._fill_yearsView(".datepicker-years", "year", 10, 1, g, i, k, this.o.beforeShowYear), this._fill_yearsView(".datepicker-decades", "decade", 100, 10, g, i, k, this.o.beforeShowDecade), this._fill_yearsView(".datepicker-centuries", "century", 1e3, 100, g, i, k, this.o.beforeShowCentury);
      }
    },
    updateNavArrows: function updateNavArrows() {
      if (this._allow_update) {
        var a = new Date(this.viewDate),
            b = a.getUTCFullYear(),
            c = a.getUTCMonth();

        switch (this.viewMode) {
          case 0:
            this.o.startDate !== -(1 / 0) && b <= this.o.startDate.getUTCFullYear() && c <= this.o.startDate.getUTCMonth() ? this.picker.find(".prev").css({
              visibility: "hidden"
            }) : this.picker.find(".prev").css({
              visibility: "visible"
            }), this.o.endDate !== 1 / 0 && b >= this.o.endDate.getUTCFullYear() && c >= this.o.endDate.getUTCMonth() ? this.picker.find(".next").css({
              visibility: "hidden"
            }) : this.picker.find(".next").css({
              visibility: "visible"
            });
            break;

          case 1:
          case 2:
          case 3:
          case 4:
            this.o.startDate !== -(1 / 0) && b <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2 ? this.picker.find(".prev").css({
              visibility: "hidden"
            }) : this.picker.find(".prev").css({
              visibility: "visible"
            }), this.o.endDate !== 1 / 0 && b >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2 ? this.picker.find(".next").css({
              visibility: "hidden"
            }) : this.picker.find(".next").css({
              visibility: "visible"
            });
        }
      }
    },
    click: function click(b) {
      b.preventDefault(), b.stopPropagation();
      var e, f, g, h, i, j, k;
      e = a(b.target), e.hasClass("datepicker-switch") && this.showMode(1);
      var l = e.closest(".prev, .next");
      l.length > 0 && (f = r.modes[this.viewMode].navStep * (l.hasClass("prev") ? -1 : 1), 0 === this.viewMode ? (this.viewDate = this.moveMonth(this.viewDate, f), this._trigger("changeMonth", this.viewDate)) : (this.viewDate = this.moveYear(this.viewDate, f), 1 === this.viewMode && this._trigger("changeYear", this.viewDate)), this.fill()), e.hasClass("today") && !e.hasClass("day") && (this.showMode(-2), this._setDate(d(), "linked" === this.o.todayBtn ? null : "view")), e.hasClass("clear") && this.clearDates(), e.hasClass("disabled") || (e.hasClass("day") && (g = parseInt(e.text(), 10) || 1, h = this.viewDate.getUTCFullYear(), i = this.viewDate.getUTCMonth(), e.hasClass("old") && (0 === i ? (i = 11, h -= 1, j = !0, k = !0) : (i -= 1, j = !0)), e.hasClass("new") && (11 === i ? (i = 0, h += 1, j = !0, k = !0) : (i += 1, j = !0)), this._setDate(c(h, i, g)), k && this._trigger("changeYear", this.viewDate), j && this._trigger("changeMonth", this.viewDate)), e.hasClass("month") && (this.viewDate.setUTCDate(1), g = 1, i = e.parent().find("span").index(e), h = this.viewDate.getUTCFullYear(), this.viewDate.setUTCMonth(i), this._trigger("changeMonth", this.viewDate), 1 === this.o.minViewMode ? (this._setDate(c(h, i, g)), this.showMode()) : this.showMode(-1), this.fill()), (e.hasClass("year") || e.hasClass("decade") || e.hasClass("century")) && (this.viewDate.setUTCDate(1), g = 1, i = 0, h = parseInt(e.text(), 10) || 0, this.viewDate.setUTCFullYear(h), e.hasClass("year") && (this._trigger("changeYear", this.viewDate), 2 === this.o.minViewMode && this._setDate(c(h, i, g))), e.hasClass("decade") && (this._trigger("changeDecade", this.viewDate), 3 === this.o.minViewMode && this._setDate(c(h, i, g))), e.hasClass("century") && (this._trigger("changeCentury", this.viewDate), 4 === this.o.minViewMode && this._setDate(c(h, i, g))), this.showMode(-1), this.fill())), this.picker.is(":visible") && this._focused_from && a(this._focused_from).focus(), delete this._focused_from;
    },
    _toggle_multidate: function _toggle_multidate(a) {
      var b = this.dates.contains(a);
      if (a || this.dates.clear(), -1 !== b ? (this.o.multidate === !0 || this.o.multidate > 1 || this.o.toggleActive) && this.dates.remove(b) : this.o.multidate === !1 ? (this.dates.clear(), this.dates.push(a)) : this.dates.push(a), "number" == typeof this.o.multidate) for (; this.dates.length > this.o.multidate;) {
        this.dates.remove(0);
      }
    },
    _setDate: function _setDate(a, b) {
      b && "date" !== b || this._toggle_multidate(a && new Date(a)), b && "view" !== b || (this.viewDate = a && new Date(a)), this.fill(), this.setValue(), b && "view" === b || this._trigger("changeDate"), this.inputField && this.inputField.change(), !this.o.autoclose || b && "date" !== b || this.hide();
    },
    moveDay: function moveDay(a, b) {
      var c = new Date(a);
      return c.setUTCDate(a.getUTCDate() + b), c;
    },
    moveWeek: function moveWeek(a, b) {
      return this.moveDay(a, 7 * b);
    },
    moveMonth: function moveMonth(a, b) {
      if (!g(a)) return this.o.defaultViewDate;
      if (!b) return a;
      var c,
          d,
          e = new Date(a.valueOf()),
          f = e.getUTCDate(),
          h = e.getUTCMonth(),
          i = Math.abs(b);
      if (b = b > 0 ? 1 : -1, 1 === i) d = -1 === b ? function () {
        return e.getUTCMonth() === h;
      } : function () {
        return e.getUTCMonth() !== c;
      }, c = h + b, e.setUTCMonth(c), (0 > c || c > 11) && (c = (c + 12) % 12);else {
        for (var j = 0; i > j; j++) {
          e = this.moveMonth(e, b);
        }

        c = e.getUTCMonth(), e.setUTCDate(f), d = function d() {
          return c !== e.getUTCMonth();
        };
      }

      for (; d();) {
        e.setUTCDate(--f), e.setUTCMonth(c);
      }

      return e;
    },
    moveYear: function moveYear(a, b) {
      return this.moveMonth(a, 12 * b);
    },
    moveAvailableDate: function moveAvailableDate(a, b, c) {
      do {
        if (a = this[c](a, b), !this.dateWithinRange(a)) return !1;
        c = "moveDay";
      } while (this.dateIsDisabled(a));

      return a;
    },
    weekOfDateIsDisabled: function weekOfDateIsDisabled(b) {
      return -1 !== a.inArray(b.getUTCDay(), this.o.daysOfWeekDisabled);
    },
    dateIsDisabled: function dateIsDisabled(b) {
      return this.weekOfDateIsDisabled(b) || a.grep(this.o.datesDisabled, function (a) {
        return e(b, a);
      }).length > 0;
    },
    dateWithinRange: function dateWithinRange(a) {
      return a >= this.o.startDate && a <= this.o.endDate;
    },
    keydown: function keydown(a) {
      if (!this.picker.is(":visible")) return void ((40 === a.keyCode || 27 === a.keyCode) && (this.show(), a.stopPropagation()));
      var b,
          c,
          d = !1,
          e = this.focusDate || this.viewDate;

      switch (a.keyCode) {
        case 27:
          this.focusDate ? (this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill()) : this.hide(), a.preventDefault(), a.stopPropagation();
          break;

        case 37:
        case 38:
        case 39:
        case 40:
          if (!this.o.keyboardNavigation || 7 === this.o.daysOfWeekDisabled.length) break;
          b = 37 === a.keyCode || 38 === a.keyCode ? -1 : 1, 0 === this.viewMode ? a.ctrlKey ? (c = this.moveAvailableDate(e, b, "moveYear"), c && this._trigger("changeYear", this.viewDate)) : a.shiftKey ? (c = this.moveAvailableDate(e, b, "moveMonth"), c && this._trigger("changeMonth", this.viewDate)) : 37 === a.keyCode || 39 === a.keyCode ? c = this.moveAvailableDate(e, b, "moveDay") : this.weekOfDateIsDisabled(e) || (c = this.moveAvailableDate(e, b, "moveWeek")) : 1 === this.viewMode ? ((38 === a.keyCode || 40 === a.keyCode) && (b = 4 * b), c = this.moveAvailableDate(e, b, "moveMonth")) : 2 === this.viewMode && ((38 === a.keyCode || 40 === a.keyCode) && (b = 4 * b), c = this.moveAvailableDate(e, b, "moveYear")), c && (this.focusDate = this.viewDate = c, this.setValue(), this.fill(), a.preventDefault());
          break;

        case 13:
          if (!this.o.forceParse) break;
          e = this.focusDate || this.dates.get(-1) || this.viewDate, this.o.keyboardNavigation && (this._toggle_multidate(e), d = !0), this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.setValue(), this.fill(), this.picker.is(":visible") && (a.preventDefault(), a.stopPropagation(), this.o.autoclose && this.hide());
          break;

        case 9:
          this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill(), this.hide();
      }

      d && (this.dates.length ? this._trigger("changeDate") : this._trigger("clearDate"), this.inputField && this.inputField.change());
    },
    showMode: function showMode(a) {
      a && (this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + a))), this.picker.children("div").hide().filter(".datepicker-" + r.modes[this.viewMode].clsName).show(), this.updateNavArrows();
    }
  };

  var l = function l(b, c) {
    a(b).data("datepicker", this), this.element = a(b), this.inputs = a.map(c.inputs, function (a) {
      return a.jquery ? a[0] : a;
    }), delete c.inputs, n.call(a(this.inputs), c).on("changeDate", a.proxy(this.dateUpdated, this)), this.pickers = a.map(this.inputs, function (b) {
      return a(b).data("datepicker");
    }), this.updateDates();
  };

  l.prototype = {
    updateDates: function updateDates() {
      this.dates = a.map(this.pickers, function (a) {
        return a.getUTCDate();
      }), this.updateRanges();
    },
    updateRanges: function updateRanges() {
      var b = a.map(this.dates, function (a) {
        return a.valueOf();
      });
      a.each(this.pickers, function (a, c) {
        c.setRange(b);
      });
    },
    dateUpdated: function dateUpdated(b) {
      if (!this.updating) {
        this.updating = !0;
        var c = a(b.target).data("datepicker");

        if ("undefined" != typeof c) {
          var d = c.getUTCDate(),
              e = a.inArray(b.target, this.inputs),
              f = e - 1,
              g = e + 1,
              h = this.inputs.length;

          if (-1 !== e) {
            if (a.each(this.pickers, function (a, b) {
              b.getUTCDate() || b.setUTCDate(d);
            }), d < this.dates[f]) for (; f >= 0 && d < this.dates[f];) {
              this.pickers[f--].setUTCDate(d);
            } else if (d > this.dates[g]) for (; h > g && d > this.dates[g];) {
              this.pickers[g++].setUTCDate(d);
            }
            this.updateDates(), delete this.updating;
          }
        }
      }
    },
    remove: function remove() {
      a.map(this.pickers, function (a) {
        a.remove();
      }), delete this.element.data().datepicker;
    }
  };

  var m = a.fn.datepicker,
      n = function n(c) {
    var d = Array.apply(null, arguments);
    d.shift();
    var e;
    if (this.each(function () {
      var b = a(this),
          f = b.data("datepicker"),
          g = "object" == _typeof(c) && c;

      if (!f) {
        var j = h(this, "date"),
            m = a.extend({}, o, j, g),
            n = i(m.language),
            p = a.extend({}, o, n, j, g);
        b.hasClass("input-daterange") || p.inputs ? (a.extend(p, {
          inputs: p.inputs || b.find("input").toArray()
        }), f = new l(this, p)) : f = new k(this, p), b.data("datepicker", f);
      }

      "string" == typeof c && "function" == typeof f[c] && (e = f[c].apply(f, d));
    }), e === b || e instanceof k || e instanceof l) return this;
    if (this.length > 1) throw new Error("Using only allowed for the collection of a single element (" + c + " function)");
    return e;
  };

  a.fn.datepicker = n;
  var o = a.fn.datepicker.defaults = {
    assumeNearbyYear: !1,
    autoclose: !1,
    beforeShowDay: a.noop,
    beforeShowMonth: a.noop,
    beforeShowYear: a.noop,
    beforeShowDecade: a.noop,
    beforeShowCentury: a.noop,
    calendarWeeks: !1,
    clearBtn: !1,
    toggleActive: !1,
    daysOfWeekDisabled: [],
    daysOfWeekHighlighted: [],
    datesDisabled: [],
    endDate: 1 / 0,
    forceParse: !0,
    format: "mm/dd/yyyy",
    keyboardNavigation: !0,
    language: "en",
    minViewMode: 0,
    maxViewMode: 4,
    multidate: !1,
    multidateSeparator: ",",
    orientation: "auto",
    rtl: !1,
    startDate: -(1 / 0),
    startView: 0,
    todayBtn: !1,
    todayHighlight: !1,
    weekStart: 0,
    disableTouchKeyboard: !1,
    enableOnReadonly: !0,
    showOnFocus: !0,
    zIndexOffset: 10,
    container: "body",
    immediateUpdates: !1,
    title: "",
    templates: {
      leftArrow: "&laquo;",
      rightArrow: "&raquo;"
    }
  },
      p = a.fn.datepicker.locale_opts = ["format", "rtl", "weekStart"];
  a.fn.datepicker.Constructor = k;
  var q = a.fn.datepicker.dates = {
    en: {
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      today: "Today",
      clear: "Clear",
      titleFormat: "MM yyyy"
    }
  },
      r = {
    modes: [{
      clsName: "days",
      navFnc: "Month",
      navStep: 1
    }, {
      clsName: "months",
      navFnc: "FullYear",
      navStep: 1
    }, {
      clsName: "years",
      navFnc: "FullYear",
      navStep: 10
    }, {
      clsName: "decades",
      navFnc: "FullDecade",
      navStep: 100
    }, {
      clsName: "centuries",
      navFnc: "FullCentury",
      navStep: 1e3
    }],
    isLeapYear: function isLeapYear(a) {
      return a % 4 === 0 && a % 100 !== 0 || a % 400 === 0;
    },
    getDaysInMonth: function getDaysInMonth(a, b) {
      return [31, r.isLeapYear(a) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][b];
    },
    validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
    nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
    parseFormat: function parseFormat(a) {
      if ("function" == typeof a.toValue && "function" == typeof a.toDisplay) return a;
      var b = a.replace(this.validParts, "\x00").split("\x00"),
          c = a.match(this.validParts);
      if (!b || !b.length || !c || 0 === c.length) throw new Error("Invalid date format.");
      return {
        separators: b,
        parts: c
      };
    },
    parseDate: function parseDate(e, f, g, h) {
      function i(a, b) {
        return b === !0 && (b = 10), 100 > a && (a += 2e3, a > new Date().getFullYear() + b && (a -= 100)), a;
      }

      function j() {
        var a = this.slice(0, s[n].length),
            b = s[n].slice(0, a.length);
        return a.toLowerCase() === b.toLowerCase();
      }

      if (!e) return b;
      if (e instanceof Date) return e;
      if ("string" == typeof f && (f = r.parseFormat(f)), f.toValue) return f.toValue(e, f, g);
      var l,
          m,
          n,
          o,
          p = /([\-+]\d+)([dmwy])/,
          s = e.match(/([\-+]\d+)([dmwy])/g),
          t = {
        d: "moveDay",
        m: "moveMonth",
        w: "moveWeek",
        y: "moveYear"
      },
          u = {
        yesterday: "-1d",
        today: "+0d",
        tomorrow: "+1d"
      };

      if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e)) {
        for (e = new Date(), n = 0; n < s.length; n++) {
          l = p.exec(s[n]), m = parseInt(l[1]), o = t[l[2]], e = k.prototype[o](e, m);
        }

        return c(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate());
      }

      if ("undefined" != typeof u[e] && (e = u[e], s = e.match(/([\-+]\d+)([dmwy])/g), /^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e))) {
        for (e = new Date(), n = 0; n < s.length; n++) {
          l = p.exec(s[n]), m = parseInt(l[1]), o = t[l[2]], e = k.prototype[o](e, m);
        }

        return c(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate());
      }

      s = e && e.match(this.nonpunctuation) || [], e = new Date();
      var v,
          w,
          x = {},
          y = ["yyyy", "yy", "M", "MM", "m", "mm", "d", "dd"],
          z = {
        yyyy: function yyyy(a, b) {
          return a.setUTCFullYear(h ? i(b, h) : b);
        },
        yy: function yy(a, b) {
          return a.setUTCFullYear(h ? i(b, h) : b);
        },
        m: function m(a, b) {
          if (isNaN(a)) return a;

          for (b -= 1; 0 > b;) {
            b += 12;
          }

          for (b %= 12, a.setUTCMonth(b); a.getUTCMonth() !== b;) {
            a.setUTCDate(a.getUTCDate() - 1);
          }

          return a;
        },
        d: function d(a, b) {
          return a.setUTCDate(b);
        }
      };
      z.M = z.MM = z.mm = z.m, z.dd = z.d, e = d();
      var A = f.parts.slice();

      if (s.length !== A.length && (A = a(A).filter(function (b, c) {
        return -1 !== a.inArray(c, y);
      }).toArray()), s.length === A.length) {
        var B;

        for (n = 0, B = A.length; B > n; n++) {
          if (v = parseInt(s[n], 10), l = A[n], isNaN(v)) switch (l) {
            case "MM":
              w = a(q[g].months).filter(j), v = a.inArray(w[0], q[g].months) + 1;
              break;

            case "M":
              w = a(q[g].monthsShort).filter(j), v = a.inArray(w[0], q[g].monthsShort) + 1;
          }
          x[l] = v;
        }

        var C, D;

        for (n = 0; n < y.length; n++) {
          D = y[n], D in x && !isNaN(x[D]) && (C = new Date(e), z[D](C, x[D]), isNaN(C) || (e = C));
        }
      }

      return e;
    },
    formatDate: function formatDate(b, c, d) {
      if (!b) return "";
      if ("string" == typeof c && (c = r.parseFormat(c)), c.toDisplay) return c.toDisplay(b, c, d);
      var e = {
        d: b.getUTCDate(),
        D: q[d].daysShort[b.getUTCDay()],
        DD: q[d].days[b.getUTCDay()],
        m: b.getUTCMonth() + 1,
        M: q[d].monthsShort[b.getUTCMonth()],
        MM: q[d].months[b.getUTCMonth()],
        yy: b.getUTCFullYear().toString().substring(2),
        yyyy: b.getUTCFullYear()
      };
      e.dd = (e.d < 10 ? "0" : "") + e.d, e.mm = (e.m < 10 ? "0" : "") + e.m, b = [];

      for (var f = a.extend([], c.separators), g = 0, h = c.parts.length; h >= g; g++) {
        f.length && b.push(f.shift()), b.push(e[c.parts[g]]);
      }

      return b.join("");
    },
    headTemplate: '<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">&laquo;</th><th colspan="5" class="datepicker-switch"></th><th class="next">&raquo;</th></tr></thead>',
    contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
    footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'
  };
  r.template = '<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">' + r.headTemplate + "<tbody></tbody>" + r.footTemplate + '</table></div><div class="datepicker-months"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-years"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-decades"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-centuries"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + "</table></div></div>", a.fn.datepicker.DPGlobal = r, a.fn.datepicker.noConflict = function () {
    return a.fn.datepicker = m, this;
  }, a.fn.datepicker.version = "1.6.4", a(document).on("focus.datepicker.data-api click.datepicker.data-api", '[data-provide="datepicker"]', function (b) {
    var c = a(this);
    c.data("datepicker") || (b.preventDefault(), n.call(c, "show"));
  }), a(function () {
    n.call(a('[data-provide="datepicker-inline"]'));
  });
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//! moment.js
//! version : 2.29.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
;

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.moment = factory();
})(window, function () {
  'use strict';

  var hookCallback;

  function hooks() {
    return hookCallback.apply(null, arguments);
  } // This is done to register the method called with moment()
  // without creating circular dependencies.


  function setHookCallback(callback) {
    hookCallback = callback;
  }

  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
  }

  function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
  }

  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
      return Object.getOwnPropertyNames(obj).length === 0;
    } else {
      var k;

      for (k in obj) {
        if (hasOwnProp(obj, k)) {
          return false;
        }
      }

      return true;
    }
  }

  function isUndefined(input) {
    return input === void 0;
  }

  function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
  }

  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
  }

  function map(arr, fn) {
    var res = [],
        i;

    for (i = 0; i < arr.length; ++i) {
      res.push(fn(arr[i], i));
    }

    return res;
  }

  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }

    if (hasOwnProp(b, 'toString')) {
      a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
      a.valueOf = b.valueOf;
    }

    return a;
  }

  function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }

  function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidEra: null,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: false,
      weekdayMismatch: false
    };
  }

  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }

    return m._pf;
  }

  var some;

  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function some(fun) {
      var t = Object(this),
          len = t.length >>> 0,
          i;

      for (i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }

      return false;
    };
  }

  function isValid(m) {
    if (m._isValid == null) {
      var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
        return i != null;
      }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

      if (m._strict) {
        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
      }

      if (Object.isFrozen == null || !Object.isFrozen(m)) {
        m._isValid = isNowValid;
      } else {
        return isNowValid;
      }
    }

    return m._isValid;
  }

  function createInvalid(flags) {
    var m = createUTC(NaN);

    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }

    return m;
  } // Plugins that add properties should also add the key here (null value),
  // so we can properly clone ourselves.


  var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;

  function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }

    if (!isUndefined(from._i)) {
      to._i = from._i;
    }

    if (!isUndefined(from._f)) {
      to._f = from._f;
    }

    if (!isUndefined(from._l)) {
      to._l = from._l;
    }

    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }

    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }

    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }

    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }

    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }

    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
      for (i = 0; i < momentProperties.length; i++) {
        prop = momentProperties[i];
        val = from[prop];

        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }

    return to;
  } // Moment prototype object


  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);

    if (!this.isValid()) {
      this._d = new Date(NaN);
    } // Prevent infinite loop in case updateOffset creates new moment
    // objects.


    if (updateInProgress === false) {
      updateInProgress = true;
      hooks.updateOffset(this);
      updateInProgress = false;
    }
  }

  function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
  }

  function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
      console.warn('Deprecation warning: ' + msg);
    }
  }

  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function () {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(null, msg);
      }

      if (firstTime) {
        var args = [],
            arg,
            i,
            key;

        for (i = 0; i < arguments.length; i++) {
          arg = '';

          if (_typeof(arguments[i]) === 'object') {
            arg += '\n[' + i + '] ';

            for (key in arguments[0]) {
              if (hasOwnProp(arguments[0], key)) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }
            }

            arg = arg.slice(0, -2); // Remove trailing comma and space
          } else {
            arg = arguments[i];
          }

          args.push(arg);
        }

        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
        firstTime = false;
      }

      return fn.apply(this, arguments);
    }, fn);
  }

  var deprecations = {};

  function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(name, msg);
    }

    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }

  hooks.suppressDeprecationWarnings = false;
  hooks.deprecationHandler = null;

  function isFunction(input) {
    return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
  }

  function set(config) {
    var prop, i;

    for (i in config) {
      if (hasOwnProp(config, i)) {
        prop = config[i];

        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }
    }

    this._config = config; // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.

    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
  }

  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
        prop;

    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }

    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
        // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
      }
    }

    return res;
  }

  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }

  var keys;

  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function keys(obj) {
      var i,
          res = [];

      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }

      return res;
    };
  }

  var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  };

  function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
  }

  function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }

  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {}; // token:    'M'
  // padded:   ['MM', 2]
  // ordinal:  'Mo'
  // callback: function () { this.month() + 1 }

  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;

    if (typeof callback === 'string') {
      func = function func() {
        return this[callback]();
      };
    }

    if (token) {
      formatTokenFunctions[token] = func;
    }

    if (padded) {
      formatTokenFunctions[padded[0]] = function () {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }

    if (ordinal) {
      formatTokenFunctions[ordinal] = function () {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }

  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, '');
    }

    return input.replace(/\\/g, '');
  }

  function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;

    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }

    return function (mom) {
      var output = '',
          i;

      for (i = 0; i < length; i++) {
        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
      }

      return output;
    };
  } // format date using native date object


  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
  }

  function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;

    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }

    return format;
  }

  var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };

  function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
      return format;
    }

    this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
      if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
        return tok.slice(1);
      }

      return tok;
    }).join('');
    return this._longDateFormat[key];
  }

  var defaultInvalidDate = 'Invalid date';

  function invalidDate() {
    return this._invalidDate;
  }

  var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;

  function ordinal(number) {
    return this._ordinal.replace('%d', number);
  }

  var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  };

  function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }

  function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }

  var aliases = {};

  function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
  }

  function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }

  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);

        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }

    return normalizedInput;
  }

  var priorities = {};

  function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
  }

  function getPrioritizedUnits(unitsObj) {
    var units = [],
        u;

    for (u in unitsObj) {
      if (hasOwnProp(unitsObj, u)) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }
    }

    units.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return units;
  }

  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }

  function absFloor(number) {
    if (number < 0) {
      // -0 -> 0
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }

  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }

    return value;
  }

  function makeGetSet(unit, keepTime) {
    return function (value) {
      if (value != null) {
        set$1(this, unit, value);
        hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get(this, unit);
      }
    };
  }

  function get(mom, unit) {
    return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
  }

  function set$1(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
      if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
        value = toInt(value);

        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
      } else {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
      }
    }
  } // MOMENTS


  function stringGet(units) {
    units = normalizeUnits(units);

    if (isFunction(this[units])) {
      return this[units]();
    }

    return this;
  }

  function stringSet(units, value) {
    if (_typeof(units) === 'object') {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units),
          i;

      for (i = 0; i < prioritized.length; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units](value);
      }
    }

    return this;
  }

  var match1 = /\d/,
      //       0 - 9
  match2 = /\d\d/,
      //      00 - 99
  match3 = /\d{3}/,
      //     000 - 999
  match4 = /\d{4}/,
      //    0000 - 9999
  match6 = /[+-]?\d{6}/,
      // -999999 - 999999
  match1to2 = /\d\d?/,
      //       0 - 99
  match3to4 = /\d\d\d\d?/,
      //     999 - 9999
  match5to6 = /\d\d\d\d\d\d?/,
      //   99999 - 999999
  match1to3 = /\d{1,3}/,
      //       0 - 999
  match1to4 = /\d{1,4}/,
      //       0 - 9999
  match1to6 = /[+-]?\d{1,6}/,
      // -999999 - 999999
  matchUnsigned = /\d+/,
      //       0 - inf
  matchSigned = /[+-]?\d+/,
      //    -inf - inf
  matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      // +00:00 -00:00 +0000 -0000 or Z
  matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      // +00 -00 +00:00 -00:00 +0000 -0000 or Z
  matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      // 123456789 123456789.123
  // any word (or two) characters or numbers including two/three word month in arabic.
  // includes scottish gaelic two word and hyphenated months
  matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
  regexes = {};

  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
      return isStrict && strictRegex ? strictRegex : regex;
    };
  }

  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
  } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


  function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }

  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  var tokens = {};

  function addParseToken(token, callback) {
    var i,
        func = callback;

    if (typeof token === 'string') {
      token = [token];
    }

    if (isNumber(callback)) {
      func = function func(input, array) {
        array[callback] = toInt(input);
      };
    }

    for (i = 0; i < token.length; i++) {
      tokens[token[i]] = func;
    }
  }

  function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }

  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }

  var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;

  function mod(n, x) {
    return (n % x + x) % x;
  }

  var indexOf;

  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function indexOf(o) {
      // I know
      var i;

      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }

      return -1;
    };
  }

  function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
      return NaN;
    }

    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
  } // FORMATTING


  addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
  });
  addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
  });
  addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
  }); // ALIASES

  addUnitAlias('month', 'M'); // PRIORITY

  addUnitPriority('month', 8); // PARSING

  addRegexToken('M', match1to2);
  addRegexToken('MM', match1to2, match2);
  addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });
  addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  }); // LOCALES

  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;

  function localeMonths(m, format) {
    if (!m) {
      return isArray(this._months) ? this._months : this._months['standalone'];
    }

    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
  }

  function localeMonthsShort(m, format) {
    if (!m) {
      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
    }

    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }

  function handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();

    if (!this._monthsParse) {
      // this is not used
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];

      for (i = 0; i < 12; ++i) {
        mom = createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
      return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    } // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse


    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);

      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
      }

      if (!strict && !this._monthsParse[i]) {
        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
      } // test the regex


      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  } // MOMENTS


  function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
      // No op
      return mom;
    }

    if (typeof value === 'string') {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

        if (!isNumber(value)) {
          return mom;
        }
      }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

    return mom;
  }

  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      hooks.updateOffset(this, true);
      return this;
    } else {
      return get(this, 'Month');
    }
  }

  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }

  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }

      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsShortRegex')) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }

      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }

  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }

      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsRegex')) {
        this._monthsRegex = defaultMonthsRegex;
      }

      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }

  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;

    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      shortPieces.push(this.monthsShort(mom, ''));
      longPieces.push(this.months(mom, ''));
      mixedPieces.push(this.months(mom, ''));
      mixedPieces.push(this.monthsShort(mom, ''));
    } // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.


    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    for (i = 0; i < 12; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
    }

    for (i = 0; i < 24; i++) {
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
  } // FORMATTING


  addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
  });
  addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
  });
  addFormatToken(0, ['YYYY', 4], 0, 'year');
  addFormatToken(0, ['YYYYY', 5], 0, 'year');
  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

  addUnitAlias('year', 'y'); // PRIORITIES

  addUnitPriority('year', 1); // PARSING

  addRegexToken('Y', matchSigned);
  addRegexToken('YY', match1to2, match2);
  addRegexToken('YYYY', match1to4, match4);
  addRegexToken('YYYYY', match1to6, match6);
  addRegexToken('YYYYYY', match1to6, match6);
  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
  addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
  });
  addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
  }); // HELPERS

  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  } // HOOKS


  hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  }; // MOMENTS


  var getSetYear = makeGetSet('FullYear', true);

  function getIsLeapYear() {
    return isLeapYear(this.year());
  }

  function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date; // the date constructor remaps years 0-99 to 1900-1999

    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      date = new Date(y + 400, m, d, h, M, s, ms);

      if (isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
    } else {
      date = new Date(y, m, d, h, M, s, ms);
    }

    return date;
  }

  function createUTCDate(y) {
    var date, args; // the Date.UTC function remaps years 0-99 to 1900-1999

    if (y < 100 && y >= 0) {
      args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

      args[0] = y + 400;
      date = new Date(Date.UTC.apply(null, args));

      if (isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
    } else {
      date = new Date(Date.UTC.apply(null, arguments));
    }

    return date;
  } // start-of-first-week - start-of-year


  function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
    fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }

    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }

  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }

    return {
      week: resWeek,
      year: resYear
    };
  }

  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  } // FORMATTING


  addFormatToken('w', ['ww', 2], 'wo', 'week');
  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

  addUnitAlias('week', 'w');
  addUnitAlias('isoWeek', 'W'); // PRIORITIES

  addUnitPriority('week', 5);
  addUnitPriority('isoWeek', 5); // PARSING

  addRegexToken('w', match1to2);
  addRegexToken('ww', match1to2, match2);
  addRegexToken('W', match1to2);
  addRegexToken('WW', match1to2, match2);
  addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  }); // HELPERS
  // LOCALES

  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }

  var defaultLocaleWeek = {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6 // The week that contains Jan 6th is the first week of the year.

  };

  function localeFirstDayOfWeek() {
    return this._week.dow;
  }

  function localeFirstDayOfYear() {
    return this._week.doy;
  } // MOMENTS


  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
  }

  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
  } // FORMATTING


  addFormatToken('d', 0, 'do', 'day');
  addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
  });
  addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
  });
  addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
  });
  addFormatToken('e', 0, 0, 'weekday');
  addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

  addUnitAlias('day', 'd');
  addUnitAlias('weekday', 'e');
  addUnitAlias('isoWeekday', 'E'); // PRIORITY

  addUnitPriority('day', 11);
  addUnitPriority('weekday', 11);
  addUnitPriority('isoWeekday', 11); // PARSING

  addRegexToken('d', match1to2);
  addRegexToken('e', match1to2);
  addRegexToken('E', match1to2);
  addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });
  addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
  }); // HELPERS

  function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
      return input;
    }

    if (!isNaN(input)) {
      return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);

    if (typeof input === 'number') {
      return input;
    }

    return null;
  }

  function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
      return locale.weekdaysParse(input) % 7 || 7;
    }

    return isNaN(input) ? null : input;
  } // LOCALES


  function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
  }

  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;

  function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
  }

  function localeWeekdaysShort(m) {
    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
  }

  function localeWeekdaysMin(m) {
    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
  }

  function handleStrictParse$1(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];

      for (i = 0; i < 7; ++i) {
        mom = createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
      return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);

      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
      }

      if (!this._weekdaysParse[i]) {
        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
      } // test the regex


      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  } // MOMENTS


  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, 'd');
    } else {
      return day;
    }
  }

  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
  }

  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    } // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.


    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }

  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }

      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }

  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysShortRegex')) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }

      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }

  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysMinRegex')) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }

      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }

  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);
      minp = regexEscape(this.weekdaysMin(mom, ''));
      shortp = regexEscape(this.weekdaysShort(mom, ''));
      longp = regexEscape(this.weekdays(mom, ''));
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.


    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
  } // FORMATTING


  function hFormat() {
    return this.hours() % 12 || 12;
  }

  function kFormat() {
    return this.hours() || 24;
  }

  addFormatToken('H', ['HH', 2], 0, 'hour');
  addFormatToken('h', ['hh', 2], 0, hFormat);
  addFormatToken('k', ['kk', 2], 0, kFormat);
  addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });

  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }

  meridiem('a', true);
  meridiem('A', false); // ALIASES

  addUnitAlias('hour', 'h'); // PRIORITY

  addUnitPriority('hour', 13); // PARSING

  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }

  addRegexToken('a', matchMeridiem);
  addRegexToken('A', matchMeridiem);
  addRegexToken('H', match1to2);
  addRegexToken('h', match1to2);
  addRegexToken('k', match1to2);
  addRegexToken('HH', match1to2, match2);
  addRegexToken('hh', match1to2, match2);
  addRegexToken('kk', match1to2, match2);
  addRegexToken('hmm', match3to4);
  addRegexToken('hmmss', match5to6);
  addRegexToken('Hmm', match3to4);
  addRegexToken('Hmmss', match5to6);
  addParseToken(['H', 'HH'], HOUR);
  addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
  });
  addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  }); // LOCALES

  function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
  }

  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      // Setting the hour should keep the time, because the user explicitly
  // specified which hour they want. So trying to maintain the same hour (in
  // a new timezone) makes sense. Adding/subtracting hours does not follow
  // this rule.
  getSetHour = makeGetSet('Hours', true);

  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'pm' : 'PM';
    } else {
      return isLower ? 'am' : 'AM';
    }
  }

  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
  }; // internal storage for locale config files

  var locales = {},
      localeFamilies = {},
      globalLocale;

  function commonPrefix(arr1, arr2) {
    var i,
        minl = Math.min(arr1.length, arr2.length);

    for (i = 0; i < minl; i += 1) {
      if (arr1[i] !== arr2[i]) {
        return i;
      }
    }

    return minl;
  }

  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
  } // pick the locale from the array
  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


  function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;

    while (i < names.length) {
      split = normalizeLocale(names[i]).split('-');
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split('-') : null;

      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join('-'));

        if (locale) {
          return locale;
        }

        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
          //the next array item is better than a shallower substring of this one
          break;
        }

        j--;
      }

      i++;
    }

    return globalLocale;
  }

  function loadLocale(name) {
    var oldLocale = null,
        aliasedRequire; // TODO: Find a better way to register and load all the locales in Node

    if (locales[name] === undefined && typeof module !== 'undefined' && module && module.exports) {
      try {
        oldLocale = globalLocale._abbr;
        aliasedRequire = require;
        aliasedRequire('./locale/' + name);
        getSetGlobalLocale(oldLocale);
      } catch (e) {
        // mark as not found to avoid repeating expensive file require call causing high CPU
        // when trying to find en-US, en_US, en-us for every format call
        locales[name] = null; // null means not found
      }
    }

    return locales[name];
  } // This function will load locale and then set the global locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.


  function getSetGlobalLocale(key, values) {
    var data;

    if (key) {
      if (isUndefined(values)) {
        data = getLocale(key);
      } else {
        data = defineLocale(key, values);
      }

      if (data) {
        // moment.duration._locale = moment._locale = data;
        globalLocale = data;
      } else {
        if (typeof console !== 'undefined' && console.warn) {
          //warn user if arguments are passed but the locale could not be set
          console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
      }
    }

    return globalLocale._abbr;
  }

  function defineLocale(name, config) {
    if (config !== null) {
      var locale,
          parentConfig = baseConfig;
      config.abbr = name;

      if (locales[name] != null) {
        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          locale = loadLocale(config.parentLocale);

          if (locale != null) {
            parentConfig = locale._config;
          } else {
            if (!localeFamilies[config.parentLocale]) {
              localeFamilies[config.parentLocale] = [];
            }

            localeFamilies[config.parentLocale].push({
              name: name,
              config: config
            });
            return null;
          }
        }
      }

      locales[name] = new Locale(mergeConfigs(parentConfig, config));

      if (localeFamilies[name]) {
        localeFamilies[name].forEach(function (x) {
          defineLocale(x.name, x.config);
        });
      } // backwards compat for now: also set the locale
      // make sure we set the locale AFTER all child locales have been
      // created, so we won't end up with the child locale set.


      getSetGlobalLocale(name);
      return locales[name];
    } else {
      // useful for testing
      delete locales[name];
      return null;
    }
  }

  function updateLocale(name, config) {
    if (config != null) {
      var locale,
          tmpLocale,
          parentConfig = baseConfig;

      if (locales[name] != null && locales[name].parentLocale != null) {
        // Update existing child locale in-place to avoid memory-leaks
        locales[name].set(mergeConfigs(locales[name]._config, config));
      } else {
        // MERGE
        tmpLocale = loadLocale(name);

        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }

        config = mergeConfigs(parentConfig, config);

        if (tmpLocale == null) {
          // updateLocale is called for creating a new locale
          // Set abbr so it will have a name (getters return
          // undefined otherwise).
          config.abbr = name;
        }

        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;
      } // backwards compat for now: also set the locale


      getSetGlobalLocale(name);
    } else {
      // pass null for config to unupdate, useful for tests
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;

          if (name === getSetGlobalLocale()) {
            getSetGlobalLocale(name);
          }
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }

    return locales[name];
  } // returns locale data


  function getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }

    if (!key) {
      return globalLocale;
    }

    if (!isArray(key)) {
      //short-circuit everything else
      locale = loadLocale(key);

      if (locale) {
        return locale;
      }

      key = [key];
    }

    return chooseLocale(key);
  }

  function listLocales() {
    return keys(locales);
  }

  function checkOverflow(m) {
    var overflow,
        a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }

      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }

      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }

      getParsingFlags(m).overflow = overflow;
    }

    return m;
  } // iso 8601 regex
  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      // iso time formats and regexes
  isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
  rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
  }; // date from iso format

  function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;

    if (match) {
      getParsingFlags(config).iso = true;

      for (i = 0, l = isoDates.length; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }

      if (dateFormat == null) {
        config._isValid = false;
        return;
      }

      if (match[3]) {
        for (i = 0, l = isoTimes.length; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            // match[2] should be 'T' or space
            timeFormat = (match[2] || ' ') + isoTimes[i][0];
            break;
          }
        }

        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }

      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }

      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = 'Z';
        } else {
          config._isValid = false;
          return;
        }
      }

      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }

  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

    if (secondStr) {
      result.push(parseInt(secondStr, 10));
    }

    return result;
  }

  function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);

    if (year <= 49) {
      return 2000 + year;
    } else if (year <= 999) {
      return 1900 + year;
    }

    return year;
  }

  function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
      // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

      if (weekdayProvided !== weekdayActual) {
        getParsingFlags(config).weekdayMismatch = true;
        config._isValid = false;
        return false;
      }
    }

    return true;
  }

  function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
      return obsOffsets[obsOffset];
    } else if (militaryOffset) {
      // the only allowed military tz is Z
      return 0;
    } else {
      var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
      return h * 60 + m;
    }
  } // date and time from ref 2822 format


  function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;

    if (match) {
      parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

      if (!checkWeekday(match[1], parsedArray, config)) {
        return;
      }

      config._a = parsedArray;
      config._tzm = calculateOffset(match[8], match[9], match[10]);
      config._d = createUTCDate.apply(null, config._a);

      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

      getParsingFlags(config).rfc2822 = true;
    } else {
      config._isValid = false;
    }
  } // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict


  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }

    configFromISO(config);

    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }

    configFromRFC2822(config);

    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }

    if (config._strict) {
      config._isValid = false;
    } else {
      // Final attempt, use Input Fallback
      hooks.createFromInputFallback(config);
    }
  }

  hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
  }); // Pick the first defined of two or three arguments.

  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }

    if (b != null) {
      return b;
    }

    return c;
  }

  function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());

    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }

    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  } // convert an array to a date.
  // the array should mirror the parameters below
  // note: all values past the year are optional and will default to the lowest possible value.
  // [year, month, day , hour, minute, second, millisecond]


  function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

    if (config._d) {
      return;
    }

    currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    } //if the day of the year is set, figure out what it is


    if (config._dayOfYear != null) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }

      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    } // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything


    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    } // Zero out whatever was not defaulted, including time


    for (; i < 7; i++) {
      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    } // Check for 24:00:00.000


    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.

    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
      config._a[HOUR] = 24;
    } // check for mismatching day of week


    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
      getParsingFlags(config).weekdayMismatch = true;
    }
  }

  function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
    w = config._w;

    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
      // how we interpret now (local, utc, fixed offset). So create
      // a now version of current config (take local/utc/offset flags, and
      // create now).

      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);

      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      curWeek = weekOfYear(createLocal(), dow, doy);
      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

      week = defaults(w.w, curWeek.week);

      if (w.d != null) {
        // weekday -- low day numbers are considered next week
        weekday = w.d;

        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        // local weekday -- counting starts from beginning of week
        weekday = w.e + dow;

        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        // default to beginning of week
        weekday = dow;
      }
    }

    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  } // constant that refers to the ISO standard


  hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


  hooks.RFC_2822 = function () {}; // date from string and format string


  function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
      configFromISO(config);
      return;
    }

    if (config._f === hooks.RFC_2822) {
      configFromRFC2822(config);
      return;
    }

    config._a = [];
    getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];

      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));

        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }

        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      } // don't parse if it's not a known token


      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token);
        }

        addTimeToArrayFromToken(token, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    } // add remaining unparsed input length to the string


    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    } // clear _12h flag if hour is <= 12


    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem); // handle era

    era = getParsingFlags(config).era;

    if (era !== null) {
      config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }

    configFromArray(config);
    checkOverflow(config);
  }

  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
      // nothing to do
      return hour;
    }

    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      // Fallback
      isPm = locale.isPM(meridiem);

      if (isPm && hour < 12) {
        hour += 12;
      }

      if (!isPm && hour === 12) {
        hour = 0;
      }

      return hour;
    } else {
      // this is not supposed to happen
      return hour;
    }
  } // date from string and array of format strings


  function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false;

    if (config._f.length === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }

    for (i = 0; i < config._f.length; i++) {
      currentScore = 0;
      validFormatFound = false;
      tempConfig = copyConfig({}, config);

      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }

      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);

      if (isValid(tempConfig)) {
        validFormatFound = true;
      } // if there is any input that was not parsed add a penalty for that format


      currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;

      if (!bestFormatIsValid) {
        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;

          if (validFormatFound) {
            bestFormatIsValid = true;
          }
        }
      } else {
        if (currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }
    }

    extend(config, bestMoment || tempConfig);
  }

  function configFromObject(config) {
    if (config._d) {
      return;
    }

    var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
      return obj && parseInt(obj, 10);
    });
    configFromArray(config);
  }

  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));

    if (res._nextDay) {
      // Adding is smart enough around DST
      res.add(1, 'd');
      res._nextDay = undefined;
    }

    return res;
  }

  function prepareConfig(config) {
    var input = config._i,
        format = config._f;
    config._locale = config._locale || getLocale(config._l);

    if (input === null || format === undefined && input === '') {
      return createInvalid({
        nullInput: true
      });
    }

    if (typeof input === 'string') {
      config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
      config._d = input;
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (format) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }

    if (!isValid(config)) {
      config._d = null;
    }

    return config;
  }

  function configFromInput(config) {
    var input = config._i;

    if (isUndefined(input)) {
      config._d = new Date(hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function (obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (isObject(input)) {
      configFromObject(config);
    } else if (isNumber(input)) {
      // from milliseconds
      config._d = new Date(input);
    } else {
      hooks.createFromInputFallback(config);
    }
  }

  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (format === true || format === false) {
      strict = format;
      format = undefined;
    }

    if (locale === true || locale === false) {
      strict = locale;
      locale = undefined;
    }

    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
      input = undefined;
    } // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423


    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
  }

  function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }

  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);

    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);

    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }); // Pick a moment m from moments so that m[fn](other) is true for all
  // other. This relies on the function fn to be transitive.
  //
  // moments should either be an array of moment objects or an array, whose
  // first element is an array of moment objects.

  function pickBy(fn, moments) {
    var res, i;

    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }

    if (!moments.length) {
      return createLocal();
    }

    res = moments[0];

    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }

    return res;
  } // TODO: Use [].sort instead?


  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
  }

  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
  }

  var now = function now() {
    return Date.now ? Date.now() : +new Date();
  };

  var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

  function isDurationValid(m) {
    var key,
        unitHasDecimal = false,
        i;

    for (key in m) {
      if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
        return false;
      }
    }

    for (i = 0; i < ordering.length; ++i) {
      if (m[ordering[i]]) {
        if (unitHasDecimal) {
          return false; // only allow non-integers for smallest unit
        }

        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
          unitHasDecimal = true;
        }
      }
    }

    return true;
  }

  function isValid$1() {
    return this._isValid;
  }

  function createInvalid$1() {
    return createDuration(NaN);
  }

  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

    this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
    minutes * 6e4 + // 1000 * 60
    hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately

    this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.

    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = getLocale();

    this._bubble();
  }

  function isDuration(obj) {
    return obj instanceof Duration;
  }

  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  } // compare two arrays, return the number of differences


  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;

    for (i = 0; i < len; i++) {
      if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
        diffs++;
      }
    }

    return diffs + lengthDiff;
  } // FORMATTING


  function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
      var offset = this.utcOffset(),
          sign = '+';

      if (offset < 0) {
        offset = -offset;
        sign = '-';
      }

      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
    });
  }

  offset('Z', ':');
  offset('ZZ', ''); // PARSING

  addRegexToken('Z', matchShortOffset);
  addRegexToken('ZZ', matchShortOffset);
  addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  }); // HELPERS
  // timezone chunker
  // '+10:00' > ['10',  '00']
  // '-1530'  > ['-15', '30']

  var chunkOffset = /([\+\-]|\d\d)/gi;

  function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;

    if (matches === null) {
      return null;
    }

    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + toInt(parts[2]);
    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
  } // Return a moment from input, that is local/utc/zone equivalent to model.


  function cloneWithOffset(input, model) {
    var res, diff;

    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

      res._d.setTime(res._d.valueOf() + diff);

      hooks.updateOffset(res, false);
      return res;
    } else {
      return createLocal(input).local();
    }
  }

  function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
  } // HOOKS
  // This function will be called whenever a moment is mutated.
  // It is intended to keep the offset in sync with the timezone.


  hooks.updateOffset = function () {}; // MOMENTS
  // keepLocalTime = true means only change the timezone, without
  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
  // +0200, so we adjust the time as needed, to be valid.
  //
  // Keeping the time actually adds/subtracts (one hour)
  // from the actual represented time. That is why we call updateOffset
  // a second time. In case it wants us to change the offset again
  // _changeInProgress == true case, then we have to adjust, because
  // there is no such time in the given timezone.


  function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;

    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    if (input != null) {
      if (typeof input === 'string') {
        input = offsetFromString(matchShortOffset, input);

        if (input === null) {
          return this;
        }
      } else if (Math.abs(input) < 16 && !keepMinutes) {
        input = input * 60;
      }

      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }

      this._offset = input;
      this._isUTC = true;

      if (localAdjust != null) {
        this.add(localAdjust, 'm');
      }

      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          addSubtract(this, createDuration(input - offset, 'm'), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }

      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }

  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== 'string') {
        input = -input;
      }

      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }

  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }

  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;

      if (keepLocalTime) {
        this.subtract(getDateOffset(this), 'm');
      }
    }

    return this;
  }

  function setOffsetToParsedOffset() {
    if (this._tzm != null) {
      this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
      var tZone = offsetFromString(matchOffset, this._i);

      if (tZone != null) {
        this.utcOffset(tZone);
      } else {
        this.utcOffset(0, true);
      }
    }

    return this;
  }

  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }

    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }

  function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }

  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }

    var c = {},
        other;
    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
      other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }

    return this._isDSTShifted;
  }

  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }

  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }

  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  } // ASP.NET json date format regex


  var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
  // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
  // and further modified to allow for strings containing both week and day
  isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

  function createDuration(input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
    match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (isNumber(input) || !isNaN(+input)) {
      duration = {};

      if (key) {
        duration[key] = +input;
      } else {
        duration.milliseconds = +input;
      }
    } else if (match = aspNetRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

      };
    } else if (match = isoRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {
      // checks for null or undefined
      duration = {};
    } else if (_typeof(duration) === 'object' && ('from' in duration || 'to' in duration)) {
      diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
      ret._locale = input._locale;
    }

    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
      ret._isValid = input._isValid;
    }

    return ret;
  }

  createDuration.fn = Duration.prototype;
  createDuration.invalid = createInvalid$1;

  function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

    return (isNaN(res) ? 0 : res) * sign;
  }

  function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

    if (base.clone().add(res.months, 'M').isAfter(other)) {
      --res.months;
    }

    res.milliseconds = +other - +base.clone().add(res.months, 'M');
    return res;
  }

  function momentsDifference(base, other) {
    var res;

    if (!(base.isValid() && other.isValid())) {
      return {
        milliseconds: 0,
        months: 0
      };
    }

    other = cloneWithOffset(other, base);

    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }

    return res;
  } // TODO: remove 'name' arg after deprecation is removed


  function createAdder(direction, name) {
    return function (val, period) {
      var dur, tmp; //invert the arguments, but complain about it

      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
        tmp = val;
        val = period;
        period = tmp;
      }

      dur = createDuration(val, period);
      addSubtract(this, dur, direction);
      return this;
    };
  }

  function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
      // No op
      return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
      setMonth(mom, get(mom, 'Month') + months * isAdding);
    }

    if (days) {
      set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }

    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }

    if (updateOffset) {
      hooks.updateOffset(mom, days || months);
    }
  }

  var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');

  function isString(input) {
    return typeof input === 'string' || input instanceof String;
  } // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined


  function isMomentInput(input) {
    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
  }

  function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
  }

  function isNumberOrStringArray(input) {
    var arrayTest = isArray(input),
        dataTypeTest = false;

    if (arrayTest) {
      dataTypeTest = input.filter(function (item) {
        return !isNumber(item) && isString(input);
      }).length === 0;
    }

    return arrayTest && dataTypeTest;
  }

  function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
  }

  function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
  }

  function calendar$1(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
      if (!arguments[0]) {
        time = undefined;
        formats = undefined;
      } else if (isMomentInput(arguments[0])) {
        time = arguments[0];
        formats = undefined;
      } else if (isCalendarSpec(arguments[0])) {
        formats = arguments[0];
        time = undefined;
      }
    } // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.


    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
  }

  function clone() {
    return new Moment(this);
  }

  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }

  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }

  function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);

    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
      return false;
    }

    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
  }

  function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }

  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }

  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }

  function diff(input, units, asFloat) {
    var that, zoneDelta, output;

    if (!this.isValid()) {
      return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
      return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);

    switch (units) {
      case 'year':
        output = monthDiff(this, that) / 12;
        break;

      case 'month':
        output = monthDiff(this, that);
        break;

      case 'quarter':
        output = monthDiff(this, that) / 3;
        break;

      case 'second':
        output = (this - that) / 1e3;
        break;
      // 1000

      case 'minute':
        output = (this - that) / 6e4;
        break;
      // 1000 * 60

      case 'hour':
        output = (this - that) / 36e5;
        break;
      // 1000 * 60 * 60

      case 'day':
        output = (this - that - zoneDelta) / 864e5;
        break;
      // 1000 * 60 * 60 * 24, negate dst

      case 'week':
        output = (this - that - zoneDelta) / 6048e5;
        break;
      // 1000 * 60 * 60 * 24 * 7, negate dst

      default:
        output = this - that;
    }

    return asFloat ? output : absFloor(output);
  }

  function monthDiff(a, b) {
    if (a.date() < b.date()) {
      // end-of-month calculations work correct when the start month has more
      // days than the end month.
      return -monthDiff(b, a);
    } // difference in months


    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
    anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;

    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

      adjust = (b - anchor) / (anchor2 - anchor);
    } //check for negative zero, return zero if negative zero


    return -(wholeMonthDiff + adjust) || 0;
  }

  hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
  hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

  function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }

  function toISOString(keepOffset) {
    if (!this.isValid()) {
      return null;
    }

    var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;

    if (m.year() < 0 || m.year() > 9999) {
      return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    if (isFunction(Date.prototype.toISOString)) {
      // native implementation is ~50x faster, use it when we can
      if (utc) {
        return this.toDate().toISOString();
      } else {
        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
      }
    }

    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
  }
  /**
   * Return a human readable representation of a moment that can
   * also be evaluated to get a new moment which is the same
   *
   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
   */


  function inspect() {
    if (!this.isValid()) {
      return 'moment.invalid(/* ' + this._i + ' */)';
    }

    var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;

    if (!this.isLocal()) {
      func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
      zone = 'Z';
    }

    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
  }

  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }

    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }

  function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        to: this,
        from: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
  }

  function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        from: this,
        to: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
  } // If passed a locale key, it will set the locale for this
  // instance.  Otherwise, it will return the locale configuration
  // variables for this instance.


  function locale(key) {
    var newLocaleData;

    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = getLocale(key);

      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }

      return this;
    }
  }

  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  });

  function localeData() {
    return this._locale;
  }

  var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

  function mod$1(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
  }

  function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return new Date(y, m, d).valueOf();
    }
  }

  function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return Date.UTC(y, m, d);
    }
  }

  function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);

    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
      case 'year':
        time = startOfDate(this.year(), 0, 1);
        break;

      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
        break;

      case 'month':
        time = startOfDate(this.year(), this.month(), 1);
        break;

      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
        break;

      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;

      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date());
        break;

      case 'hour':
        time = this._d.valueOf();
        time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
        break;

      case 'minute':
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_MINUTE);
        break;

      case 'second':
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_SECOND);
        break;
    }

    this._d.setTime(time);

    hooks.updateOffset(this, true);
    return this;
  }

  function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);

    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
      case 'year':
        time = startOfDate(this.year() + 1, 0, 1) - 1;
        break;

      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
        break;

      case 'month':
        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
        break;

      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;

      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
        break;

      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
        break;

      case 'hour':
        time = this._d.valueOf();
        time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
        break;

      case 'minute':
        time = this._d.valueOf();
        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
        break;

      case 'second':
        time = this._d.valueOf();
        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
        break;
    }

    this._d.setTime(time);

    hooks.updateOffset(this, true);
    return this;
  }

  function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
  }

  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }

  function toDate() {
    return new Date(this.valueOf());
  }

  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }

  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }

  function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
  }

  function isValid$2() {
    return isValid(this);
  }

  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }

  function invalidAt() {
    return getParsingFlags(this).overflow;
  }

  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }

  addFormatToken('N', 0, 0, 'eraAbbr');
  addFormatToken('NN', 0, 0, 'eraAbbr');
  addFormatToken('NNN', 0, 0, 'eraAbbr');
  addFormatToken('NNNN', 0, 0, 'eraName');
  addFormatToken('NNNNN', 0, 0, 'eraNarrow');
  addFormatToken('y', ['y', 1], 'yo', 'eraYear');
  addFormatToken('y', ['yy', 2], 0, 'eraYear');
  addFormatToken('y', ['yyy', 3], 0, 'eraYear');
  addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
  addRegexToken('N', matchEraAbbr);
  addRegexToken('NN', matchEraAbbr);
  addRegexToken('NNN', matchEraAbbr);
  addRegexToken('NNNN', matchEraName);
  addRegexToken('NNNNN', matchEraNarrow);
  addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
    var era = config._locale.erasParse(input, token, config._strict);

    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  });
  addRegexToken('y', matchUnsigned);
  addRegexToken('yy', matchUnsigned);
  addRegexToken('yyy', matchUnsigned);
  addRegexToken('yyyy', matchUnsigned);
  addRegexToken('yo', matchEraYearOrdinal);
  addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
  addParseToken(['yo'], function (input, array, config, token) {
    var match;

    if (config._locale._eraYearOrdinalRegex) {
      match = input.match(config._locale._eraYearOrdinalRegex);
    }

    if (config._locale.eraYearOrdinalParse) {
      array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
      array[YEAR] = parseInt(input, 10);
    }
  });

  function localeEras(m, format) {
    var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;

    for (i = 0, l = eras.length; i < l; ++i) {
      switch (_typeof(eras[i].since)) {
        case 'string':
          // truncate time
          date = hooks(eras[i].since).startOf('day');
          eras[i].since = date.valueOf();
          break;
      }

      switch (_typeof(eras[i].until)) {
        case 'undefined':
          eras[i].until = +Infinity;
          break;

        case 'string':
          // truncate time
          date = hooks(eras[i].until).startOf('day').valueOf();
          eras[i].until = date.valueOf();
          break;
      }
    }

    return eras;
  }

  function localeErasParse(eraName, format, strict) {
    var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
    eraName = eraName.toUpperCase();

    for (i = 0, l = eras.length; i < l; ++i) {
      name = eras[i].name.toUpperCase();
      abbr = eras[i].abbr.toUpperCase();
      narrow = eras[i].narrow.toUpperCase();

      if (strict) {
        switch (format) {
          case 'N':
          case 'NN':
          case 'NNN':
            if (abbr === eraName) {
              return eras[i];
            }

            break;

          case 'NNNN':
            if (name === eraName) {
              return eras[i];
            }

            break;

          case 'NNNNN':
            if (narrow === eraName) {
              return eras[i];
            }

            break;
        }
      } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
        return eras[i];
      }
    }
  }

  function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? +1 : -1;

    if (year === undefined) {
      return hooks(era.since).year();
    } else {
      return hooks(era.since).year() + (year - era.offset) * dir;
    }
  }

  function getEraName() {
    var i,
        l,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].name;
      }

      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].name;
      }
    }

    return '';
  }

  function getEraNarrow() {
    var i,
        l,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].narrow;
      }

      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].narrow;
      }
    }

    return '';
  }

  function getEraAbbr() {
    var i,
        l,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].abbr;
      }

      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].abbr;
      }
    }

    return '';
  }

  function getEraYear() {
    var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      dir = eras[i].since <= eras[i].until ? +1 : -1; // truncate time

      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
        return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
      }
    }

    return this.year();
  }

  function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNameRegex')) {
      computeErasParse.call(this);
    }

    return isStrict ? this._erasNameRegex : this._erasRegex;
  }

  function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, '_erasAbbrRegex')) {
      computeErasParse.call(this);
    }

    return isStrict ? this._erasAbbrRegex : this._erasRegex;
  }

  function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNarrowRegex')) {
      computeErasParse.call(this);
    }

    return isStrict ? this._erasNarrowRegex : this._erasRegex;
  }

  function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
  }

  function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
  }

  function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
  }

  function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
  }

  function computeErasParse() {
    var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      namePieces.push(regexEscape(eras[i].name));
      abbrPieces.push(regexEscape(eras[i].abbr));
      narrowPieces.push(regexEscape(eras[i].narrow));
      mixedPieces.push(regexEscape(eras[i].name));
      mixedPieces.push(regexEscape(eras[i].abbr));
      mixedPieces.push(regexEscape(eras[i].narrow));
    }

    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
  } // FORMATTING


  addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
  });

  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }

  addWeekYearFormatToken('gggg', 'weekYear');
  addWeekYearFormatToken('ggggg', 'weekYear');
  addWeekYearFormatToken('GGGG', 'isoWeekYear');
  addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

  addUnitAlias('weekYear', 'gg');
  addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

  addUnitPriority('weekYear', 1);
  addUnitPriority('isoWeekYear', 1); // PARSING

  addRegexToken('G', matchSigned);
  addRegexToken('g', matchSigned);
  addRegexToken('GG', match1to2, match2);
  addRegexToken('gg', match1to2, match2);
  addRegexToken('GGGG', match1to4, match4);
  addRegexToken('gggg', match1to4, match4);
  addRegexToken('GGGGG', match1to6, match6);
  addRegexToken('ggggg', match1to6, match6);
  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });
  addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
  }); // MOMENTS

  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }

  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }

  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }

  function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
  }

  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;

    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }

  function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;

    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
  }

  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;

    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);

      if (week > weeksTarget) {
        week = weeksTarget;
      }

      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }

  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  } // FORMATTING


  addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

  addUnitAlias('quarter', 'Q'); // PRIORITY

  addUnitPriority('quarter', 7); // PARSING

  addRegexToken('Q', match1);
  addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  }); // MOMENTS

  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  } // FORMATTING


  addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

  addUnitAlias('date', 'D'); // PRIORITY

  addUnitPriority('date', 9); // PARSING

  addRegexToken('D', match1to2);
  addRegexToken('DD', match1to2, match2);
  addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
  });
  addParseToken(['D', 'DD'], DATE);
  addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
  }); // MOMENTS

  var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

  addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

  addUnitPriority('dayOfYear', 4); // PARSING

  addRegexToken('DDD', match1to3);
  addRegexToken('DDDD', match3);
  addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
  }); // HELPERS
  // MOMENTS

  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
  } // FORMATTING


  addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

  addUnitAlias('minute', 'm'); // PRIORITY

  addUnitPriority('minute', 14); // PARSING

  addRegexToken('m', match1to2);
  addRegexToken('mm', match1to2, match2);
  addParseToken(['m', 'mm'], MINUTE); // MOMENTS

  var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

  addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

  addUnitAlias('second', 's'); // PRIORITY

  addUnitPriority('second', 15); // PARSING

  addRegexToken('s', match1to2);
  addRegexToken('ss', match1to2, match2);
  addParseToken(['s', 'ss'], SECOND); // MOMENTS

  var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

  addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
  addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
  }); // ALIASES

  addUnitAlias('millisecond', 'ms'); // PRIORITY

  addUnitPriority('millisecond', 16); // PARSING

  addRegexToken('S', match1to3, match1);
  addRegexToken('SS', match1to3, match2);
  addRegexToken('SSS', match1to3, match3);
  var token, getSetMillisecond;

  for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
  }

  function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
  }

  for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
  }

  getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

  addFormatToken('z', 0, 0, 'zoneAbbr');
  addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

  function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
  }

  function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
  }

  var proto = Moment.prototype;
  proto.add = add;
  proto.calendar = calendar$1;
  proto.clone = clone;
  proto.diff = diff;
  proto.endOf = endOf;
  proto.format = format;
  proto.from = from;
  proto.fromNow = fromNow;
  proto.to = to;
  proto.toNow = toNow;
  proto.get = stringGet;
  proto.invalidAt = invalidAt;
  proto.isAfter = isAfter;
  proto.isBefore = isBefore;
  proto.isBetween = isBetween;
  proto.isSame = isSame;
  proto.isSameOrAfter = isSameOrAfter;
  proto.isSameOrBefore = isSameOrBefore;
  proto.isValid = isValid$2;
  proto.lang = lang;
  proto.locale = locale;
  proto.localeData = localeData;
  proto.max = prototypeMax;
  proto.min = prototypeMin;
  proto.parsingFlags = parsingFlags;
  proto.set = stringSet;
  proto.startOf = startOf;
  proto.subtract = subtract;
  proto.toArray = toArray;
  proto.toObject = toObject;
  proto.toDate = toDate;
  proto.toISOString = toISOString;
  proto.inspect = inspect;

  if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
    proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
      return 'Moment<' + this.format() + '>';
    };
  }

  proto.toJSON = toJSON;
  proto.toString = toString;
  proto.unix = unix;
  proto.valueOf = valueOf;
  proto.creationData = creationData;
  proto.eraName = getEraName;
  proto.eraNarrow = getEraNarrow;
  proto.eraAbbr = getEraAbbr;
  proto.eraYear = getEraYear;
  proto.year = getSetYear;
  proto.isLeapYear = getIsLeapYear;
  proto.weekYear = getSetWeekYear;
  proto.isoWeekYear = getSetISOWeekYear;
  proto.quarter = proto.quarters = getSetQuarter;
  proto.month = getSetMonth;
  proto.daysInMonth = getDaysInMonth;
  proto.week = proto.weeks = getSetWeek;
  proto.isoWeek = proto.isoWeeks = getSetISOWeek;
  proto.weeksInYear = getWeeksInYear;
  proto.weeksInWeekYear = getWeeksInWeekYear;
  proto.isoWeeksInYear = getISOWeeksInYear;
  proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
  proto.date = getSetDayOfMonth;
  proto.day = proto.days = getSetDayOfWeek;
  proto.weekday = getSetLocaleDayOfWeek;
  proto.isoWeekday = getSetISODayOfWeek;
  proto.dayOfYear = getSetDayOfYear;
  proto.hour = proto.hours = getSetHour;
  proto.minute = proto.minutes = getSetMinute;
  proto.second = proto.seconds = getSetSecond;
  proto.millisecond = proto.milliseconds = getSetMillisecond;
  proto.utcOffset = getSetOffset;
  proto.utc = setOffsetToUTC;
  proto.local = setOffsetToLocal;
  proto.parseZone = setOffsetToParsedOffset;
  proto.hasAlignedHourOffset = hasAlignedHourOffset;
  proto.isDST = isDaylightSavingTime;
  proto.isLocal = isLocal;
  proto.isUtcOffset = isUtcOffset;
  proto.isUtc = isUtc;
  proto.isUTC = isUtc;
  proto.zoneAbbr = getZoneAbbr;
  proto.zoneName = getZoneName;
  proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
  proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
  proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
  proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
  proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

  function createUnix(input) {
    return createLocal(input * 1000);
  }

  function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
  }

  function preParsePostFormat(string) {
    return string;
  }

  var proto$1 = Locale.prototype;
  proto$1.calendar = calendar;
  proto$1.longDateFormat = longDateFormat;
  proto$1.invalidDate = invalidDate;
  proto$1.ordinal = ordinal;
  proto$1.preparse = preParsePostFormat;
  proto$1.postformat = preParsePostFormat;
  proto$1.relativeTime = relativeTime;
  proto$1.pastFuture = pastFuture;
  proto$1.set = set;
  proto$1.eras = localeEras;
  proto$1.erasParse = localeErasParse;
  proto$1.erasConvertYear = localeErasConvertYear;
  proto$1.erasAbbrRegex = erasAbbrRegex;
  proto$1.erasNameRegex = erasNameRegex;
  proto$1.erasNarrowRegex = erasNarrowRegex;
  proto$1.months = localeMonths;
  proto$1.monthsShort = localeMonthsShort;
  proto$1.monthsParse = localeMonthsParse;
  proto$1.monthsRegex = monthsRegex;
  proto$1.monthsShortRegex = monthsShortRegex;
  proto$1.week = localeWeek;
  proto$1.firstDayOfYear = localeFirstDayOfYear;
  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
  proto$1.weekdays = localeWeekdays;
  proto$1.weekdaysMin = localeWeekdaysMin;
  proto$1.weekdaysShort = localeWeekdaysShort;
  proto$1.weekdaysParse = localeWeekdaysParse;
  proto$1.weekdaysRegex = weekdaysRegex;
  proto$1.weekdaysShortRegex = weekdaysShortRegex;
  proto$1.weekdaysMinRegex = weekdaysMinRegex;
  proto$1.isPM = localeIsPM;
  proto$1.meridiem = localeMeridiem;

  function get$1(format, index, field, setter) {
    var locale = getLocale(),
        utc = createUTC().set(setter, index);
    return locale[field](utc, format);
  }

  function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
      index = format;
      format = undefined;
    }

    format = format || '';

    if (index != null) {
      return get$1(format, index, field, 'month');
    }

    var i,
        out = [];

    for (i = 0; i < 12; i++) {
      out[i] = get$1(format, i, field, 'month');
    }

    return out;
  } // ()
  // (5)
  // (fmt, 5)
  // (fmt)
  // (true)
  // (true, 5)
  // (true, fmt, 5)
  // (true, fmt)


  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;

      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];

    if (index != null) {
      return get$1(format, (index + shift) % 7, field, 'day');
    }

    for (i = 0; i < 7; i++) {
      out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }

    return out;
  }

  function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
  }

  function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
  }

  function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
  }

  function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
  }

  function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
  }

  getSetGlobalLocale('en', {
    eras: [{
      since: '0001-01-01',
      until: +Infinity,
      offset: 1,
      name: 'Anno Domini',
      narrow: 'AD',
      abbr: 'AD'
    }, {
      since: '0000-12-31',
      until: -Infinity,
      offset: 1,
      name: 'Before Christ',
      narrow: 'BC',
      abbr: 'BC'
    }],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function ordinal(number) {
      var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      return number + output;
    }
  }); // Side effect imports

  hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
  hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
  var mathAbs = Math.abs;

  function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }

  function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  } // supports only 2.0-style add(1, 's') or add(duration)


  function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
  } // supports only 2.0-style subtract(1, 's') or subtract(duration)


  function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
  }

  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }

  function bubble() {
    var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays; // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166

    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    } // The following code bubbles up values, see the tests for
    // examples of what that means.


    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24); // convert days to months

    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
  }

  function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
  }

  function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
  }

  function as(units) {
    if (!this.isValid()) {
      return NaN;
    }

    var days,
        months,
        milliseconds = this._milliseconds;
    units = normalizeUnits(units);

    if (units === 'month' || units === 'quarter' || units === 'year') {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);

      switch (units) {
        case 'month':
          return months;

        case 'quarter':
          return months / 3;

        case 'year':
          return months / 12;
      }
    } else {
      // handle milliseconds separately because of floating point math errors (issue #1867)
      days = this._days + Math.round(monthsToDays(this._months));

      switch (units) {
        case 'week':
          return days / 7 + milliseconds / 6048e5;

        case 'day':
          return days + milliseconds / 864e5;

        case 'hour':
          return days * 24 + milliseconds / 36e5;

        case 'minute':
          return days * 1440 + milliseconds / 6e4;

        case 'second':
          return days * 86400 + milliseconds / 1000;
        // Math.floor prevents floating point math errors here

        case 'millisecond':
          return Math.floor(days * 864e5) + milliseconds;

        default:
          throw new Error('Unknown unit ' + units);
      }
    }
  } // TODO: Use this.as('ms')?


  function valueOf$1() {
    if (!this.isValid()) {
      return NaN;
    }

    return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
  }

  function makeAs(alias) {
    return function () {
      return this.as(alias);
    };
  }

  var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');

  function clone$1() {
    return createDuration(this);
  }

  function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
  }

  function makeGetter(name) {
    return function () {
      return this.isValid() ? this._data[name] : NaN;
    };
  }

  var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');

  function weeks() {
    return absFloor(this.days() / 7);
  }

  var round = Math.round,
      thresholds = {
    ss: 44,
    // a few seconds to seconds
    s: 45,
    // seconds to minute
    m: 45,
    // minutes to hour
    h: 22,
    // hours to day
    d: 26,
    // days to month/week
    w: null,
    // weeks to month
    M: 11 // months to year

  }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }

  function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

    if (thresholds.w != null) {
      a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
    }

    a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  } // This function allows you to set the rounding function for relative time strings


  function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
      return round;
    }

    if (typeof roundingFunction === 'function') {
      round = roundingFunction;
      return true;
    }

    return false;
  } // This function allows you to set a threshold for relative time strings


  function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }

    if (limit === undefined) {
      return thresholds[threshold];
    }

    thresholds[threshold] = limit;

    if (threshold === 's') {
      thresholds.ss = limit - 1;
    }

    return true;
  }

  function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }

    var withSuffix = false,
        th = thresholds,
        locale,
        output;

    if (_typeof(argWithSuffix) === 'object') {
      argThresholds = argWithSuffix;
      argWithSuffix = false;
    }

    if (typeof argWithSuffix === 'boolean') {
      withSuffix = argWithSuffix;
    }

    if (_typeof(argThresholds) === 'object') {
      th = Object.assign({}, thresholds, argThresholds);

      if (argThresholds.s != null && argThresholds.ss == null) {
        th.ss = argThresholds.s - 1;
      }
    }

    locale = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale);

    if (withSuffix) {
      output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
  }

  var abs$1 = Math.abs;

  function sign(x) {
    return (x > 0) - (x < 0) || +x;
  }

  function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;

    if (!total) {
      // this is the same as C#'s (Noda) and python (isodate)...
      // but not other JS (goog.date)
      return 'P0D';
    } // 3600 seconds -> 60 minutes -> 1 hour


    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60; // 12 months -> 1 year

    years = absFloor(months / 12);
    months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
    return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
  }

  var proto$2 = Duration.prototype;
  proto$2.isValid = isValid$1;
  proto$2.abs = abs;
  proto$2.add = add$1;
  proto$2.subtract = subtract$1;
  proto$2.as = as;
  proto$2.asMilliseconds = asMilliseconds;
  proto$2.asSeconds = asSeconds;
  proto$2.asMinutes = asMinutes;
  proto$2.asHours = asHours;
  proto$2.asDays = asDays;
  proto$2.asWeeks = asWeeks;
  proto$2.asMonths = asMonths;
  proto$2.asQuarters = asQuarters;
  proto$2.asYears = asYears;
  proto$2.valueOf = valueOf$1;
  proto$2._bubble = bubble;
  proto$2.clone = clone$1;
  proto$2.get = get$2;
  proto$2.milliseconds = milliseconds;
  proto$2.seconds = seconds;
  proto$2.minutes = minutes;
  proto$2.hours = hours;
  proto$2.days = days;
  proto$2.weeks = weeks;
  proto$2.months = months;
  proto$2.years = years;
  proto$2.humanize = humanize;
  proto$2.toISOString = toISOString$1;
  proto$2.toString = toISOString$1;
  proto$2.toJSON = toISOString$1;
  proto$2.locale = locale;
  proto$2.localeData = localeData;
  proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
  proto$2.lang = lang; // FORMATTING

  addFormatToken('X', 0, 0, 'unix');
  addFormatToken('x', 0, 0, 'valueOf'); // PARSING

  addRegexToken('x', matchSigned);
  addRegexToken('X', matchTimestamp);
  addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
  });
  addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
  }); //! moment.js

  hooks.version = '2.29.0';
  setHookCallback(createLocal);
  hooks.fn = proto;
  hooks.min = min;
  hooks.max = max;
  hooks.now = now;
  hooks.utc = createUTC;
  hooks.unix = createUnix;
  hooks.months = listMonths;
  hooks.isDate = isDate;
  hooks.locale = getSetGlobalLocale;
  hooks.invalid = createInvalid;
  hooks.duration = createDuration;
  hooks.isMoment = isMoment;
  hooks.weekdays = listWeekdays;
  hooks.parseZone = createInZone;
  hooks.localeData = getLocale;
  hooks.isDuration = isDuration;
  hooks.monthsShort = listMonthsShort;
  hooks.weekdaysMin = listWeekdaysMin;
  hooks.defineLocale = defineLocale;
  hooks.updateLocale = updateLocale;
  hooks.locales = listLocales;
  hooks.weekdaysShort = listWeekdaysShort;
  hooks.normalizeUnits = normalizeUnits;
  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
  hooks.calendarFormat = getCalendarFormat;
  hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

  hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
    // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
    // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
    // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',
    // <input type="date" />
    TIME: 'HH:mm',
    // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',
    // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',
    // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW',
    // <input type="week" />
    MONTH: 'YYYY-MM' // <input type="month" />

  };
  return hooks;
});
/**
* @version: 2.1.24
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2016 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See https://www.opensource.org/licenses/mit-license.php
* @website: https://www.improvely.com/
*/
// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js


(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Make globaly available as well
    define(['moment', 'jquery'], function (moment, jquery) {
      return root.daterangepicker = factory(moment, jquery);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // Node / Browserify
    //isomorphic issue
    var jQuery = typeof window != 'undefined' ? window.jQuery : undefined;

    if (!jQuery) {
      jQuery = require('jquery');
      if (!jQuery.fn) jQuery.fn = {};
    }

    module.exports = factory(require('moment'), jQuery);
  } else {
    // Browser globals
    root.daterangepicker = factory(root.moment, root.jQuery);
  }
})(window, function (moment, $) {
  var DateRangePicker = function DateRangePicker(element, options, cb) {
    //default settings for options
    // If there is parentEl options we set it
    // Otherwise we check if inline options is set and we set the element.parent() by default or the body for a tootlip picker
    this.parentEl = options && options.parentEl && $(options.parentEl).length ? $(options.parentEl) : options && options.inline ? element.parent() : $('body');
    this.element = $(element);
    this.startDate = moment().startOf('day');
    this.endDate = moment().endOf('day');
    this.minDate = false;
    this.maxDate = false;
    this.dateLimit = false;
    this.autoApply = false;
    this.singleDatePicker = false;
    this.showDropdowns = false;
    this.showWeekNumbers = false;
    this.showISOWeekNumbers = false;
    this.showCustomRangeLabel = true;
    this.timePicker = false;
    this.timePicker24Hour = false;
    this.timePickerIncrement = 1;
    this.timePickerSeconds = false;
    this.linkedCalendars = true;
    this.autoUpdateInput = true;
    this.alwaysShowCalendars = false;
    this.inline = false;
    this.ranges = {};
    this.opens = 'right';
    if (this.element.hasClass('pull-right')) this.opens = 'left';
    this.drops = 'down';
    if (this.element.hasClass('dropup')) this.drops = 'up';
    this.buttonClasses = 'btn btn-sm';
    this.applyClass = 'btn-success';
    this.cancelClass = 'btn-default';
    this.locale = {
      direction: 'ltr',
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: moment.localeData().firstDayOfWeek()
    };

    this.callback = function () {}; //some state information


    this.isShowing = false;
    this.leftCalendar = {};
    this.rightCalendar = {}; //custom options from user

    if (_typeof(options) !== 'object' || options === null) options = {}; //allow setting options with data attributes
    //data-api options will be overwritten with custom javascript options

    options = $.extend(this.element.data(), options); //
    // handle all the possible options overriding defaults
    //

    if (_typeof(options.locale) === 'object') {
      if (typeof options.locale.direction === 'string') this.locale.direction = options.locale.direction;
      if (typeof options.locale.format === 'string') this.locale.format = options.locale.format;
      if (typeof options.locale.separator === 'string') this.locale.separator = options.locale.separator;
      if (_typeof(options.locale.daysOfWeek) === 'object') this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
      if (_typeof(options.locale.monthNames) === 'object') this.locale.monthNames = options.locale.monthNames.slice();
      if (typeof options.locale.firstDay === 'number') this.locale.firstDay = options.locale.firstDay;
      if (typeof options.locale.applyLabel === 'string') this.locale.applyLabel = options.locale.applyLabel;
      if (typeof options.locale.cancelLabel === 'string') this.locale.cancelLabel = options.locale.cancelLabel;
      if (typeof options.locale.weekLabel === 'string') this.locale.weekLabel = options.locale.weekLabel;
      if (typeof options.locale.customRangeLabel === 'string') this.locale.customRangeLabel = options.locale.customRangeLabel;
    }

    if (typeof options.startDate === 'string') this.startDate = moment(options.startDate, this.locale.format);
    if (typeof options.endDate === 'string') this.endDate = moment(options.endDate, this.locale.format);
    if (typeof options.minDate === 'string') this.minDate = moment(options.minDate, this.locale.format);
    if (typeof options.maxDate === 'string') this.maxDate = moment(options.maxDate, this.locale.format);
    if (_typeof(options.startDate) === 'object') this.startDate = moment(options.startDate);
    if (_typeof(options.endDate) === 'object') this.endDate = moment(options.endDate);
    if (_typeof(options.minDate) === 'object') this.minDate = moment(options.minDate);
    if (_typeof(options.maxDate) === 'object') this.maxDate = moment(options.maxDate); // sanity check for bad options

    if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate.clone(); // sanity check for bad options

    if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
    if (typeof options.applyClass === 'string') this.applyClass = options.applyClass;
    if (typeof options.cancelClass === 'string') this.cancelClass = options.cancelClass;
    if (_typeof(options.dateLimit) === 'object') this.dateLimit = options.dateLimit;
    if (typeof options.opens === 'string') this.opens = options.opens;
    if (typeof options.drops === 'string') this.drops = options.drops;
    if (typeof options.showWeekNumbers === 'boolean') this.showWeekNumbers = options.showWeekNumbers;
    if (typeof options.showISOWeekNumbers === 'boolean') this.showISOWeekNumbers = options.showISOWeekNumbers;
    if (typeof options.buttonClasses === 'string') this.buttonClasses = options.buttonClasses;
    if (_typeof(options.buttonClasses) === 'object') this.buttonClasses = options.buttonClasses.join(' ');
    if (typeof options.showDropdowns === 'boolean') this.showDropdowns = options.showDropdowns;
    if (typeof options.showCustomRangeLabel === 'boolean') this.showCustomRangeLabel = options.showCustomRangeLabel;

    if (typeof options.singleDatePicker === 'boolean') {
      this.singleDatePicker = options.singleDatePicker;
      if (this.singleDatePicker) this.endDate = this.startDate.clone();
    }

    if (typeof options.timePicker === 'boolean') this.timePicker = options.timePicker;
    if (typeof options.timePickerSeconds === 'boolean') this.timePickerSeconds = options.timePickerSeconds;
    if (typeof options.timePickerIncrement === 'number') this.timePickerIncrement = options.timePickerIncrement;
    if (typeof options.timePicker24Hour === 'boolean') this.timePicker24Hour = options.timePicker24Hour;
    if (typeof options.autoApply === 'boolean') this.autoApply = options.autoApply;
    if (typeof options.autoUpdateInput === 'boolean') this.autoUpdateInput = options.autoUpdateInput;
    if (typeof options.linkedCalendars === 'boolean') this.linkedCalendars = options.linkedCalendars;
    if (typeof options.isInvalidDate === 'function') this.isInvalidDate = options.isInvalidDate;
    if (typeof options.isCustomDate === 'function') this.isCustomDate = options.isCustomDate;
    if (typeof options.alwaysShowCalendars === 'boolean') this.alwaysShowCalendars = options.alwaysShowCalendars;
    if (typeof options.inline === 'boolean') this.inline = options.inline; // update day names order to firstDay

    if (this.locale.firstDay != 0) {
      var iterator = this.locale.firstDay;

      while (iterator > 0) {
        this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
        iterator--;
      }
    } //html template for the picker UI


    if (typeof options.template !== 'string' && !(options.template instanceof $)) options.template = '<div class="daterangepicker ' + (this.inline ? 'daterangepicker-inline' : 'daterangepicker-tooltip dropdown-menu') + '">' + '<div class="input-group input-daterange-chalet">' + '<input type="text" name="daterangepicker_start" value="" class="form-control-from input-mini" placeholder="02/08/2018" onfocus="blur();">' + '<div class="daterange--sep">' + '<img src="' + site_url + '/assets/images/icons/cal_arrow.svg" alt=""></div>' + '<input type="text" name="daterangepicker_end" value="" class="form-control-to input-mini" placeholder="02/08/2018" onfocus="blur();"></div>' + '<div class="calendar left">' + '<div class="daterangepicker_input">' + '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' + '<div class="calendar-time">' + '<div></div>' + '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' + '</div>' + '</div>' + '<div class="calendar-table"></div>' + '</div>' + '<div class="ranges">' + '<div class="range_inputs">' + '<button class="applyBtn" disabled="disabled" type="button"></button>' + '<button class="cancelBtn" type="button"></button>' + '</div>' + '</div>' + '</div>';
    this.container = $(options.template).appendTo(this.parentEl);
    this.container.addClass(this.locale.direction);
    var start, end, range; //if no start/end dates set, check if an input element contains initial values

    if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
      if ($(this.element).is('input[type=text]')) {
        var val = $(this.element).val(),
            split = val.split(this.locale.separator);
        start = end = null;

        if (split.length == 2) {
          start = moment(split[0], this.locale.format);
          end = moment(split[1], this.locale.format);
        } else if (this.singleDatePicker && val !== "") {
          start = moment(val, this.locale.format);
          end = moment(val, this.locale.format);
        }

        if (start !== null && end !== null) {
          this.setStartDate(start);
          this.setEndDate(end);
        }
      }
    }

    if (_typeof(options.ranges) === 'object') {
      for (range in options.ranges) {
        if (typeof options.ranges[range][0] === 'string') start = moment(options.ranges[range][0], this.locale.format);else start = moment(options.ranges[range][0]);
        if (typeof options.ranges[range][1] === 'string') end = moment(options.ranges[range][1], this.locale.format);else end = moment(options.ranges[range][1]); // If the start or end date exceed those allowed by the minDate or dateLimit
        // options, shorten the range to the allowable period.

        if (this.minDate && start.isBefore(this.minDate)) start = this.minDate.clone();
        var maxDate = this.maxDate;
        if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate)) maxDate = start.clone().add(this.dateLimit);
        if (maxDate && end.isAfter(maxDate)) end = maxDate.clone(); // If the end of the range is before the minimum or the start of the range is
        // after the maximum, don't display this range option at all.

        if (this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day') || maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')) continue; //Support unicode chars in the range names.

        var elem = document.createElement('textarea');
        elem.innerHTML = range;
        var rangeHtml = elem.value;
        this.ranges[rangeHtml] = [start, end];
      }

      var list = '<ul>';

      for (range in this.ranges) {
        list += '<li data-range-key="' + range + '">' + range + '</li>';
      }

      if (this.showCustomRangeLabel) {
        list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
      }

      list += '</ul>';
      this.container.find('.ranges').prepend(list);
    }

    if (typeof cb === 'function') {
      this.callback = cb;
    }

    if (!this.timePicker) {
      this.startDate = this.startDate.startOf('day');
      this.endDate = this.endDate.endOf('day');
      this.container.find('.calendar-time').hide();
    } // can't be used together for now
    // You can only use it with inline option


    if (this.timePicker && this.autoApply && !this.inline) this.autoApply = false;

    if (this.autoApply && _typeof(options.ranges) !== 'object') {
      this.container.find('.ranges').hide();
    } else if (this.autoApply) {
      this.container.find('.applyBtn, .cancelBtn').addClass('hide');
    }

    if (this.singleDatePicker) {
      this.container.addClass('single');
      this.container.find('.calendar.left').addClass('single');
      this.container.find('.calendar.left').show();
      this.container.find('.calendar.right').hide();
      this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();

      if (this.timePicker) {
        this.container.find('.ranges ul').hide();
      } else {
        this.container.find('.ranges').hide();
      }
    }

    if (typeof options.ranges === 'undefined' && !this.singleDatePicker || this.alwaysShowCalendars) {
      this.container.addClass('show-calendar');
    }

    this.container.addClass('opens' + this.opens); //swap the position of the predefined ranges if opens right

    if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
      this.container.find('.ranges').prependTo(this.container.find('.calendar.left').parent());
    } //apply CSS classes and labels to buttons


    this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
    if (this.applyClass.length) this.container.find('.applyBtn').addClass(this.applyClass);
    if (this.cancelClass.length) this.container.find('.cancelBtn').addClass(this.cancelClass);
    this.container.find('.applyBtn').html(this.locale.applyLabel);
    this.container.find('.cancelBtn').html(this.locale.cancelLabel); //
    // event listeners
    //

    this.container.find('.calendar').on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this)).on('click.daterangepicker', '.next', $.proxy(this.clickNext, this)) //.on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
    .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this)).on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this)).on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this)).on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this)).on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this)).on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this)).on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this)).on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));
    this.container.find('.ranges').on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this)).on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this)).on('click.daterangepicker', 'li', $.proxy(this.clickRange, this)).on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this)).on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));

    if (this.element.is('input') || this.element.is('button')) {
      this.element.on({
        'click.daterangepicker': $.proxy(this.show, this),
        'focus.daterangepicker': $.proxy(this.show, this),
        'keyup.daterangepicker': $.proxy(this.elementChanged, this),
        'keydown.daterangepicker': $.proxy(this.keydown, this)
      });
    } else {
      this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
    } //
    // if attached to a text input, set the initial value
    //


    if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
      this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
      this.element.trigger('change');
    } else if (this.element.is('input') && this.autoUpdateInput) {
      this.element.val(this.startDate.format(this.locale.format));
      this.element.trigger('change');
    } // Show the daterangepicker since it's started for inline mode


    if (this.inline) this.show();
  };

  DateRangePicker.prototype = {
    constructor: DateRangePicker,
    setStartDate: function setStartDate(startDate) {
      if (typeof startDate === 'string') this.startDate = moment(startDate, this.locale.format);
      if (_typeof(startDate) === 'object') this.startDate = moment(startDate);
      if (!this.timePicker) this.startDate = this.startDate.startOf('day');
      if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

      if (this.minDate && this.startDate.isBefore(this.minDate)) {
        this.startDate = this.minDate;
        if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
      }

      if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
        this.startDate = this.maxDate;
        if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
      }

      if (!this.isShowing) this.updateElement();
      this.updateMonthsInView();
    },
    setEndDate: function setEndDate(endDate) {
      if (typeof endDate === 'string') this.endDate = moment(endDate, this.locale.format);
      if (_typeof(endDate) === 'object') this.endDate = moment(endDate);
      if (!this.timePicker) this.endDate = this.endDate.endOf('day');
      if (this.timePicker && this.timePickerIncrement) this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
      if (this.endDate.isBefore(this.startDate)) this.endDate = this.startDate.clone();
      if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate;
      if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate)) this.endDate = this.startDate.clone().add(this.dateLimit);
      this.previousRightTime = this.endDate.clone();
      if (!this.isShowing) this.updateElement();
      this.updateMonthsInView();
    },
    isInvalidDate: function isInvalidDate() {
      return false;
    },
    isCustomDate: function isCustomDate() {
      return false;
    },
    updateView: function updateView() {
      if (this.timePicker) {
        this.renderTimePicker('left');
        this.renderTimePicker('right');

        if (!this.endDate) {
          this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
        } else {
          this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
        }
      }

      if (this.endDate) {
        this.container.find('input[name="daterangepicker_end"]').removeClass('active');
        this.container.find('input[name="daterangepicker_start"]').addClass('active');
      } else {
        this.container.find('input[name="daterangepicker_end"]').addClass('active');
        this.container.find('input[name="daterangepicker_start"]').removeClass('active');
      }

      this.updateMonthsInView();
      this.updateCalendars();
      this.updateFormInputs();
    },
    updateMonthsInView: function updateMonthsInView() {
      if (this.endDate) {
        //if both dates are visible already, do nothing
        if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM')) && (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))) {
          return;
        }

        this.leftCalendar.month = this.startDate.clone().date(2);

        if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
          this.rightCalendar.month = this.endDate.clone().date(2);
        } else {
          this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
        }
      } else {
        if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
          this.leftCalendar.month = this.startDate.clone().date(2);
          this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
        }
      }

      if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
        this.rightCalendar.month = this.maxDate.clone().date(2);
        this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
      }
    },
    updateCalendars: function updateCalendars() {
      if (this.timePicker) {
        var hour, minute, second;

        if (this.endDate) {
          hour = parseInt(this.container.find('.left .hourselect').val(), 10);
          minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
          second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;

          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.left .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }
        } else {
          hour = parseInt(this.container.find('.right .hourselect').val(), 10);
          minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
          second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;

          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.right .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }
        }

        this.leftCalendar.month.hour(hour).minute(minute).second(second);
        this.rightCalendar.month.hour(hour).minute(minute).second(second);
      }

      this.renderCalendar('left');
      this.renderCalendar('right'); //highlight any predefined range matching the current start and end dates

      this.container.find('.ranges li').removeClass('active');
      if (this.endDate == null) return;
      this.calculateChosenLabel();
    },
    renderCalendar: function renderCalendar(side) {
      //
      // Build the matrix of dates that will populate the calendar
      //
      var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
      var month = calendar.month.month();
      var year = calendar.month.year();
      var hour = calendar.month.hour();
      var minute = calendar.month.minute();
      var second = calendar.month.second();
      var daysInMonth = moment([year, month]).daysInMonth();
      var firstDay = moment([year, month, 1]);
      var lastDay = moment([year, month, daysInMonth]);
      var lastMonth = moment(firstDay).subtract(1, 'month').month();
      var lastYear = moment(firstDay).subtract(1, 'month').year();
      var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
      var dayOfWeek = firstDay.day(); //initialize a 6 rows x 7 columns array for the calendar

      var calendar = [];
      calendar.firstDay = firstDay;
      calendar.lastDay = lastDay;

      for (var i = 0; i < 6; i++) {
        calendar[i] = [];
      } //populate the calendar with date objects


      var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
      if (startDay > daysInLastMonth) startDay -= 7;
      if (dayOfWeek == this.locale.firstDay) startDay = daysInLastMonth - 6;
      var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
      var col, row;

      for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
        if (i > 0 && col % 7 === 0) {
          col = 0;
          row++;
        }

        calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
        curDate.hour(12);

        if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
          calendar[row][col] = this.minDate.clone();
        }

        if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
          calendar[row][col] = this.maxDate.clone();
        }
      } //make the calendar object available to hoverDate/clickDate


      if (side == 'left') {
        findActiveValues();
        this.leftCalendar.calendar = calendar;
      } else {
        this.rightCalendar.calendar = calendar;
      } //
      // Display the calendar
      //


      var minDate = side == 'left' ? this.minDate : this.startDate;
      var maxDate = this.maxDate;
      var selected = side == 'left' ? this.startDate : this.endDate;
      var arrow = this.locale.direction == 'ltr' ? {
        left: 'chevron-left',
        right: 'chevron-right'
      } : {
        left: 'chevron-right',
        right: 'chevron-left'
      };
      var html = '<table class="table-condensed">';
      html += '<thead>';
      html += '<tr>'; // add empty cell for week number

      if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="next available"><i class="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i></th>';

      if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
        html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
      } else {
        html += '<th class="next available"><i class="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i></th>';
      }

      var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

      if (this.showDropdowns) {
        var currentMonth = calendar[1][1].month();
        var currentYear = calendar[1][1].year();
        var maxYear = maxDate && maxDate.year() || currentYear + 5;
        var minYear = minDate && minDate.year() || currentYear - 50;
        var inMinYear = currentYear == minYear;
        var inMaxYear = currentYear == maxYear;
        var monthHtml = '<select class="monthselect">';

        for (var m = 0; m < 12; m++) {
          if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
            monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + ">" + this.locale.monthNames[m] + "</option>";
          } else {
            monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
          }
        }

        monthHtml += "</select>";
        var yearHtml = '<select class="yearselect">';

        for (var y = minYear; y <= maxYear; y++) {
          yearHtml += '<option value="' + y + '"' + (y === currentYear ? ' selected="selected"' : '') + '>' + y + '</option>';
        }

        yearHtml += '</select>';
        dateHtml = monthHtml + yearHtml;
      }

      html += '<th colspan="5" class="month">' + dateHtml + '</th>';

      if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
        html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
      } else {
        html += '<th class="next available"><i class="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i></th>';
      }

      html += '</tr>';
      html += '<tr>'; // add week number label

      if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="week">' + this.locale.weekLabel + '</th>';
      $.each(this.locale.daysOfWeek, function (index, dayOfWeek) {
        html += '<th>' + dayOfWeek + '</th>';
      });
      html += '</tr>';
      html += '</thead>';
      html += '<tbody>'; //adjust maxDate to reflect the dateLimit setting in order to
      //grey out end dates beyond the dateLimit

      if (this.endDate == null && this.dateLimit) {
        var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');

        if (!maxDate || maxLimit.isBefore(maxDate)) {
          maxDate = maxLimit;
        }
      }

      for (var row = 0; row < 6; row++) {
        html += '<tr>'; // add week number

        if (this.showWeekNumbers) html += '<td class="week">' + calendar[row][0].week() + '</td>';else if (this.showISOWeekNumbers) html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

        for (var col = 0; col < 7; col++) {
          var classes = []; //highlight today's date

          if (calendar[row][col].isSame(new Date(), "day")) classes.push('today'); //highlight weekends

          if (calendar[row][col].isoWeekday() > 5) classes.push('weekend'); //grey out the dates in other months displayed at beginning and end of this calendar

          if (calendar[row][col].month() != calendar[1][1].month()) classes.push('off'); //don't allow selection of dates before the minimum date

          if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) classes.push('off', 'disabled'); //don't allow selection of dates after the maximum date

          if (maxDate && calendar[row][col].isAfter(maxDate, 'day')) classes.push('off', 'disabled'); //don't allow selection of date if a custom function decides it's invalid

          if (this.isInvalidDate(calendar[row][col])) classes.push('off', 'disabled'); //highlight the currently selected start date

          if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD')) classes.push('active', 'start-date'); //highlight the currently selected end date

          if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD')) classes.push('active', 'end-date'); //highlight dates in-between the selected dates

          if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) classes.push('in-range'); //apply custom classes for this date

          var isCustom = this.isCustomDate(calendar[row][col]);

          if (isCustom !== false) {
            if (typeof isCustom === 'string') classes.push(isCustom);else Array.prototype.push.apply(classes, isCustom);
          }

          var cname = '',
              disabled = false;

          for (var i = 0; i < classes.length; i++) {
            cname += classes[i] + ' ';
            if (classes[i] == 'disabled') disabled = true;
          }

          if (!disabled) cname += 'available';
          html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-name="" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
        }

        html += '</tr>';
      }

      html += '</tbody>';
      html += '</table>';
      this.container.find('.calendar.' + side + ' .calendar-table').html(html);
    },
    renderTimePicker: function renderTimePicker(side) {
      // Don't bother updating the time picker if it's currently disabled
      // because an end date hasn't been clicked yet
      if (side == 'right' && !this.endDate) return;
      var html,
          selected,
          minDate,
          maxDate = this.maxDate;
      if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate))) maxDate = this.startDate.clone().add(this.dateLimit);

      if (side == 'left') {
        selected = this.startDate.clone();
        minDate = this.minDate;
      } else if (side == 'right') {
        selected = this.endDate.clone();
        minDate = this.startDate; //Preserve the time already selected

        var timeSelector = this.container.find('.calendar.right .calendar-time div');

        if (!this.endDate && timeSelector.html() != '') {
          selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
          selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
          selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());

          if (!this.timePicker24Hour) {
            var ampm = timeSelector.find('.ampmselect option:selected').val();
            if (ampm === 'PM' && selected.hour() < 12) selected.hour(selected.hour() + 12);
            if (ampm === 'AM' && selected.hour() === 12) selected.hour(0);
          }
        }

        if (selected.isBefore(this.startDate)) selected = this.startDate.clone();
        if (maxDate && selected.isAfter(maxDate)) selected = maxDate.clone();
      } //
      // hours
      //


      html = '<select class="hourselect">';
      var start = this.timePicker24Hour ? 0 : 1;
      var end = this.timePicker24Hour ? 23 : 12;

      for (var i = start; i <= end; i++) {
        var i_in_24 = i;
        if (!this.timePicker24Hour) i_in_24 = selected.hour() >= 12 ? i == 12 ? 12 : i + 12 : i == 12 ? 0 : i;
        var time = selected.clone().hour(i_in_24);
        var disabled = false;
        if (minDate && time.minute(59).isBefore(minDate)) disabled = true;
        if (maxDate && time.minute(0).isAfter(maxDate)) disabled = true;

        if (i_in_24 == selected.hour() && !disabled) {
          html += '<option value="' + i + '" selected="selected">' + i + '</option>';
        } else if (disabled) {
          html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
        } else {
          html += '<option value="' + i + '">' + i + '</option>';
        }
      }

      html += '</select> '; //
      // minutes
      //

      html += ': <select class="minuteselect">';

      for (var i = 0; i < 60; i += this.timePickerIncrement) {
        var padded = i < 10 ? '0' + i : i;
        var time = selected.clone().minute(i);
        var disabled = false;
        if (minDate && time.second(59).isBefore(minDate)) disabled = true;
        if (maxDate && time.second(0).isAfter(maxDate)) disabled = true;

        if (selected.minute() == i && !disabled) {
          html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
        } else if (disabled) {
          html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
        } else {
          html += '<option value="' + i + '">' + padded + '</option>';
        }
      }

      html += '</select> '; //
      // seconds
      //

      if (this.timePickerSeconds) {
        html += ': <select class="secondselect">';

        for (var i = 0; i < 60; i++) {
          var padded = i < 10 ? '0' + i : i;
          var time = selected.clone().second(i);
          var disabled = false;
          if (minDate && time.isBefore(minDate)) disabled = true;
          if (maxDate && time.isAfter(maxDate)) disabled = true;

          if (selected.second() == i && !disabled) {
            html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
          } else if (disabled) {
            html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
          } else {
            html += '<option value="' + i + '">' + padded + '</option>';
          }
        }

        html += '</select> ';
      } //
      // AM/PM
      //


      if (!this.timePicker24Hour) {
        html += '<select class="ampmselect">';
        var am_html = '';
        var pm_html = '';
        if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) am_html = ' disabled="disabled" class="disabled"';
        if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) pm_html = ' disabled="disabled" class="disabled"';

        if (selected.hour() >= 12) {
          html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
        } else {
          html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
        }

        html += '</select>';
      }

      this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
    },
    updateFormInputs: function updateFormInputs() {
      //ignore mouse movements while an above-calendar text input has focus
      if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus")) return;
      this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
      if (this.endDate) this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));

      if (this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate))) {
        this.container.find('button.applyBtn').removeAttr('disabled');
      } else {
        this.container.find('button.applyBtn').attr('disabled', 'disabled');
      }
    },
    move: function move() {
      // Should not move if it's inline mode
      if (this.inline) return;
      var parentOffset = {
        top: 0,
        left: 0
      },
          containerTop;
      var parentRightEdge = $(window).width();

      if (!this.parentEl.is('body')) {
        parentOffset = {
          top: this.parentEl.offset().top - this.parentEl.scrollTop(),
          left: this.parentEl.offset().left - this.parentEl.scrollLeft()
        };
        parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
      }

      if (this.drops == 'up') containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;else containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
      this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');

      if (this.opens == 'left') {
        this.container.css({
          top: containerTop,
          right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
          left: 'auto'
        });

        if (this.container.offset().left < 0) {
          this.container.css({
            right: 'auto',
            left: 9
          });
        }
      } else if (this.opens == 'center') {
        this.container.css({
          top: containerTop,
          left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 - this.container.outerWidth() / 2,
          right: 'auto'
        });

        if (this.container.offset().left < 0) {
          this.container.css({
            right: 'auto',
            left: 9
          });
        }
      } else {
        this.container.css({
          top: containerTop,
          left: this.element.offset().left - parentOffset.left,
          right: 'auto'
        });

        if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
          this.container.css({
            left: 'auto',
            right: 0
          });
        }
      }
    },
    show: function show(e) {
      if (this.isShowing) return; // Create a click proxy that is private to this instance of datepicker, for unbinding

      this._outsideClickProxy = $.proxy(function (e) {
        this.outsideClick(e);
      }, this); // Bind global datepicker mousedown for hiding and

      $(document).on('mousedown.daterangepicker', this._outsideClickProxy) // also support mobile devices
      .on('touchend.daterangepicker', this._outsideClickProxy) // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
      .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy) // and also close when focus changes to outside the picker (eg. tabbing between controls)
      .on('focusin.daterangepicker', this._outsideClickProxy); // Reposition the picker if the window is resized while it's open

      $(window).on('resize.daterangepicker', $.proxy(function (e) {
        this.move(e);
      }, this));
      this.oldStartDate = this.startDate.clone();
      this.oldEndDate = this.endDate.clone();
      this.previousRightTime = this.endDate.clone();
      this.updateView();
      this.container.show();
      this.move();
      this.element.trigger('show.daterangepicker', this);
      this.isShowing = true;
    },
    hide: function hide(e) {
      if (!this.isShowing) return; //if picker is attached to a text input, update it

      this.updateElement();
      $(document).off('.daterangepicker');
      $(window).off('.daterangepicker');
      this.container.hide();
      this.element.trigger('hide.daterangepicker', this);
      this.isShowing = false;
    },
    toggle: function toggle(e) {
      if (this.isShowing && !this.inline) {
        this.hide();
      } else {
        this.show();
      }
    },
    outsideClick: function outsideClick(e) {
      var target = $(e.target); // if the page is clicked anywhere except within the daterangerpicker/button
      // itself then call this.hide()

      if ( // ie modal dialog fix
      e.type == "focusin" || target.closest(this.element).length || target.closest(this.container).length || target.closest('.calendar-table').length || this.inline) return;
      this.hide();
      this.element.trigger('outsideClick.daterangepicker', this);
    },
    showCalendars: function showCalendars() {
      this.container.addClass('show-calendar');
      this.move();
      this.element.trigger('showCalendar.daterangepicker', this);
    },
    hideCalendars: function hideCalendars() {
      this.container.removeClass('show-calendar');
      this.element.trigger('hideCalendar.daterangepicker', this);
    },
    hoverRange: function hoverRange(e) {
      //ignore mouse movements while an above-calendar text input has focus
      if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus")) return;
      var label = e.target.getAttribute('data-range-key');

      if (label == this.locale.customRangeLabel) {
        this.updateView();
      } else {
        var dates = this.ranges[label];
        this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
        this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
      }
    },
    clickRange: function clickRange(e) {
      var label = e.target.getAttribute('data-range-key');
      this.chosenLabel = label;

      if (label == this.locale.customRangeLabel) {
        this.showCalendars();
      } else {
        var dates = this.ranges[label];
        this.startDate = dates[0];
        this.endDate = dates[1];

        if (!this.timePicker) {
          this.startDate.startOf('day');
          this.endDate.endOf('day');
        }

        if (!this.alwaysShowCalendars) this.hideCalendars();
        this.clickApply();
      }
    },
    clickPrev: function clickPrev(e) {
      var cal = $(e.target).parents('.calendar');

      if (cal.hasClass('left')) {
        this.leftCalendar.month.subtract(1, 'month');
        if (this.linkedCalendars) this.rightCalendar.month.subtract(1, 'month');
      } else {
        this.rightCalendar.month.subtract(1, 'month');
      }

      this.element.trigger('clickPrev.daterangepicker', this);
      this.updateCalendars();
    },
    clickNext: function clickNext(e) {
      var cal = $(e.target).parents('.calendar');

      if (cal.hasClass('left')) {
        this.leftCalendar.month.add(1, 'month');
      } else {
        this.rightCalendar.month.add(1, 'month');
        if (this.linkedCalendars) this.leftCalendar.month.add(1, 'month');
      }

      this.element.trigger('clickNext.daterangepicker', this);
      this.updateCalendars();
    },
    hoverDate: function hoverDate(e) {//ignore mouse movements while an above-calendar text input has focus
      //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
      //    return;
      //ignore dates that can't be selected

      /* if (!$(e.target).hasClass('available')) return;
         //have the text inputs above calendars reflect the date being hovered over
       var title = $(e.target).attr('data-title');
       var row = title.substr(1, 1);
       var col = title.substr(3, 1);
       var cal = $(e.target).parents('.calendar');
       var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
         if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
           this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
       } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
           this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
       }
         //highlight the dates between the start date and the date being hovered as a potential end date
       var leftCalendar = this.leftCalendar;
       var rightCalendar = this.rightCalendar;
       var startDate = this.startDate;
       if (!this.endDate) {
           this.container.find('.calendar td').each(function (index, el) {
                 //skip week numbers, only look at dates
               if ($(el).hasClass('week')) return;
                 var title = $(el).attr('data-title');
               var row = title.substr(1, 1);
               var col = title.substr(3, 1);
               var cal = $(el).parents('.calendar');
               var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
                 if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                   $(el).addClass('in-range');
               } else {
                   $(el).removeClass('in-range');
               }
             });
       }*/
    },
    clickDate: function clickDate(e) {
      findActiveValues();
      if (!$(e.target).hasClass('available')) return;
      var title = $(e.target).attr('data-title');
      var row = title.substr(1, 1);
      var col = title.substr(3, 1);
      var cal = $(e.target).parents('.calendar');
      var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col]; //
      // this function needs to do a few things:
      // * alternate between selecting a start and end date for the range,
      // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
      // * if autoapply is enabled, and an end date was chosen, apply the selection
      // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
      // * if one of the inputs above the calendars was focused, cancel that manual input
      //

      if (this.endDate || date.isBefore(this.startDate, 'day')) {
        //picking start
        if (this.timePicker) {
          var hour = parseInt(this.container.find('.left .hourselect').val(), 10);

          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.left .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }

          var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
          var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
          date = date.clone().hour(hour).minute(minute).second(second);
        }

        this.endDate = null;
        this.setStartDate(date.clone());
      } else if (!this.endDate && date.isBefore(this.startDate)) {
        //special case: clicking the same date for start/end,
        //but the time of the end date is before the start date
        this.setEndDate(this.startDate.clone());
      } else {
        // picking end
        if (this.timePicker) {
          var hour = parseInt(this.container.find('.right .hourselect').val(), 10);

          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.right .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }

          var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
          var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
          date = date.clone().hour(hour).minute(minute).second(second);
        }

        this.setEndDate(date.clone());

        if (this.autoApply) {
          this.calculateChosenLabel();
          this.clickApply();
        }
      }

      if (this.singleDatePicker) {
        this.setEndDate(this.startDate);
        if (!this.timePicker) this.clickApply();
      }

      this.updateView(); //This is to cancel the blur event handler if the mouse was in one of the inputs

      e.stopPropagation();
    },
    calculateChosenLabel: function calculateChosenLabel() {
      var customRange = true;
      var i = 0;

      for (var range in this.ranges) {
        if (this.timePicker) {
          if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
            customRange = false;
            this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
            break;
          }
        } else {
          //ignore times when comparing dates if time picker is not enabled
          if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
            customRange = false;
            this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
            break;
          }
        }

        i++;
      }

      if (customRange && this.showCustomRangeLabel) {
        this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
        this.showCalendars();
      }
    },
    clickApply: function clickApply(e) {
      // Should not hide the picker if it's inline mode, but should update the parentElement
      !this.inline ? this.hide() : this.updateElement();
      this.element.trigger('apply.daterangepicker', this);
    },
    clickCancel: function clickCancel(e) {
      this.startDate = this.oldStartDate;
      this.endDate = this.oldEndDate; // Should not hide the picker if it's inline mode, but should update the parentElement

      !this.inline ? this.hide() : this.updateElement();
      this.element.trigger('cancel.daterangepicker', this);
    },
    monthOrYearChanged: function monthOrYearChanged(e) {
      var isLeft = $(e.target).closest('.calendar').hasClass('left'),
          leftOrRight = isLeft ? 'left' : 'right',
          cal = this.container.find('.calendar.' + leftOrRight); // Month must be Number for new moment versions

      var month = parseInt(cal.find('.monthselect').val(), 10);
      var year = cal.find('.yearselect').val();

      if (!isLeft) {
        if (year < this.startDate.year() || year == this.startDate.year() && month < this.startDate.month()) {
          month = this.startDate.month();
          year = this.startDate.year();
        }
      }

      if (this.minDate) {
        if (year < this.minDate.year() || year == this.minDate.year() && month < this.minDate.month()) {
          month = this.minDate.month();
          year = this.minDate.year();
        }
      }

      if (this.maxDate) {
        if (year > this.maxDate.year() || year == this.maxDate.year() && month > this.maxDate.month()) {
          month = this.maxDate.month();
          year = this.maxDate.year();
        }
      }

      if (isLeft) {
        this.leftCalendar.month.month(month).year(year);
        if (this.linkedCalendars) this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
      } else {
        this.rightCalendar.month.month(month).year(year);
        if (this.linkedCalendars) this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
      }

      this.updateCalendars();
    },
    timeChanged: function timeChanged(e) {
      var cal = $(e.target).closest('.calendar'),
          isLeft = cal.hasClass('left');
      var hour = parseInt(cal.find('.hourselect').val(), 10);
      var minute = parseInt(cal.find('.minuteselect').val(), 10);
      var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

      if (!this.timePicker24Hour) {
        var ampm = cal.find('.ampmselect').val();
        if (ampm === 'PM' && hour < 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;
      }

      if (isLeft) {
        var start = this.startDate.clone();
        start.hour(hour);
        start.minute(minute);
        start.second(second);
        this.setStartDate(start);

        if (this.singleDatePicker) {
          this.endDate = this.startDate.clone();
        } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
          this.setEndDate(start.clone());
        }
      } else if (this.endDate) {
        var end = this.endDate.clone();
        end.hour(hour);
        end.minute(minute);
        end.second(second);
        this.setEndDate(end);
      } // Update the parent element with the autoplay option in inline mode


      if (this.inline && this.autoApply) this.updateElement(); //update the calendars so all clickable dates reflect the new time component

      this.updateCalendars(); //update the form inputs above the calendars with the new time

      this.updateFormInputs(); //re-render the time pickers because changing one selection can affect what's enabled in another

      this.renderTimePicker('left');
      this.renderTimePicker('right');
    },
    formInputsChanged: function formInputsChanged(e) {
      var isRight = $(e.target).closest('.calendar').hasClass('right');
      var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
      var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);

      if (start.isValid() && end.isValid()) {
        if (isRight && end.isBefore(start)) start = end.clone();
        this.setStartDate(start);
        this.setEndDate(end);

        if (isRight) {
          this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
        } else {
          this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
        }
      }

      this.updateView(); // Update the parent element with the autoplay option in inline mode

      if (this.inline && this.autoApply) this.updateElement();
    },
    formInputsFocused: function formInputsFocused(e) {
      // Highlight the focused input
      this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
      $(e.target).addClass('active'); // Set the state such that if the user goes back to using a mouse,
      // the calendars are aware we're selecting the end of the range, not
      // the start. This allows someone to edit the end of a date range without
      // re-selecting the beginning, by clicking on the end date input then
      // using the calendar.

      var isRight = $(e.target).closest('.calendar').hasClass('right');

      if (isRight) {
        this.endDate = null;
        this.setStartDate(this.startDate.clone());
        this.updateView();
      }
    },
    formInputsBlurred: function formInputsBlurred(e) {
      // this function has one purpose right now: if you tab from the first
      // text input to the second in the UI, the endDate is nulled so that
      // you can click another, but if you tab out without clicking anything
      // or changing the input value, the old endDate should be retained
      if (!this.endDate) {
        var val = this.container.find('input[name="daterangepicker_end"]').val();
        var end = moment(val, this.locale.format);

        if (end.isValid()) {
          this.setEndDate(end);
          this.updateView();
        }
      }
    },
    elementChanged: function elementChanged() {
      if (!this.element.is('input')) return;
      if (!this.element.val().length) return;
      if (this.element.val().length < this.locale.format.length) return;
      var dateString = this.element.val().split(this.locale.separator),
          start = null,
          end = null;

      if (dateString.length === 2) {
        start = moment(dateString[0], this.locale.format);
        end = moment(dateString[1], this.locale.format);
      }

      if (this.singleDatePicker || start === null || end === null) {
        start = moment(this.element.val(), this.locale.format);
        end = start;
      }

      if (!start.isValid() || !end.isValid()) return;
      this.setStartDate(start);
      this.setEndDate(end);
      this.updateView();
    },
    keydown: function keydown(e) {
      //hide on tab or enter
      if (e.keyCode === 9 || e.keyCode === 13) {
        this.hide();
      }
    },
    updateElement: function updateElement() {
      //incomplete date selection, revert to last values
      if (!this.endDate) {
        this.startDate = this.oldStartDate.clone();
        this.endDate = this.oldEndDate.clone();
      } //if a new date range was selected, invoke the user callback function


      if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate)) this.callback(this.startDate, this.endDate, this.chosenLabel);

      if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
        this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
        this.element.trigger('change');
      } else if (this.element.is('input') && this.autoUpdateInput) {
        this.element.val(this.startDate.format(this.locale.format));
        this.element.trigger('change');
      }
    },
    remove: function remove() {
      this.container.remove();
      this.element.off('.daterangepicker');
      this.element.removeData();
    }
  };

  $.fn.daterangepicker = function (options, callback) {
    this.each(function () {
      var el = $(this);
      if (el.data('daterangepicker')) el.data('daterangepicker').remove();
      el.data('daterangepicker', new DateRangePicker(el, options, callback));
    });
    return this;
  };

  return DateRangePicker;
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * jQuery goMap
 *
 * @url		http://www.pittss.lv/jquery/gomap/
 * @author	Jevgenijs Shtrauss <pittss@gmail.com>
 * @version	1.3.3 2014.11.27
 * This software is released under the MIT License <http://www.opensource.org/licenses/mit-license.php>
 */
var mapauchalet;

(function ($) {
  var geocoder = new google.maps.Geocoder();

  function MyOverlay(map) {
    this.setMap(map);
  }

  ;
  MyOverlay.prototype = new google.maps.OverlayView();

  MyOverlay.prototype.onAdd = function () {};

  MyOverlay.prototype.onRemove = function () {};

  MyOverlay.prototype.draw = function () {};

  $.goMap = {};

  $.fn.goMap = function (options) {
    return this.each(function () {
      var goMap = $(this).data('goMap');

      if (!goMap) {
        var goMapBase = $.extend(true, {}, $.goMapBase);
        $(this).data('goMap', goMapBase.init(this, options));
        $.goMap = goMapBase;
      } else {
        $.goMap = goMap;
      }
    });
  };

  $.goMapBase = {
    defaults: {
      address: '',
      // Street, City, Country
      latitude: '',
      longitude: '',
      zoom: 4,
      delay: 200,
      hideByClick: true,
      oneInfoWindow: true,
      prefixId: 'gomarker',
      polyId: 'gopoly',
      groupId: 'gogroup',
      navigationControl: true,
      // Show or hide navigation control
      navigationControlOptions: {
        position: 'TOP_RIGHT',
        // TOP, TOP_LEFT, TOP_RIGHT, BOTTOM, BOTTOM_LEFT, BOTTOM_RIGHT, LEFT, RIGHT
        style: 'DEFAULT' // DEFAULT, SMALL, LARGE

      },
      mapTypeControl: false,
      // Show or hide map control
      mapTypeControlOptions: {
        position: 'TOP_RIGHT',
        // TOP, TOP_LEFT, TOP_RIGHT, BOTTOM, BOTTOM_LEFT, BOTTOM_RIGHT, LEFT, RIGHT
        style: 'DEFAULT' // DEFAULT, DROPDOWN_MENU, HORIZONTAL_BAR

      },
      scaleControl: true,
      // Show or hide scale
      scrollwheel: true,
      // Mouse scroll whell
      directions: false,
      directionsResult: null,
      disableDoubleClickZoom: false,
      streetViewControl: false,
      markers: [],
      overlays: [],
      polyline: {
        color: '#FF0000',
        opacity: 1.0,
        weight: 2
      },
      polygon: {
        color: '#FF0000',
        opacity: 1.0,
        weight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.2
      },
      circle: {
        color: '#FF0000',
        opacity: 1.0,
        weight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.2
      },
      rectangle: {
        color: '#FF0000',
        opacity: 1.0,
        weight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.2
      },
      maptype: 'HYBRID',
      // Map type - HYBRID, ROADMAP, SATELLITE, TERRAIN
      html_prepend: '<div class="gomapMarker">',
      html_append: '</div>',
      addMarker: false
    },
    map: null,
    count: 0,
    markers: [],
    polylines: [],
    polygons: [],
    circles: [],
    rectangles: [],
    tmpMarkers: [],
    geoMarkers: [],
    lockGeocode: false,
    bounds: null,
    overlays: null,
    overlay: null,
    mapId: null,
    plId: null,
    pgId: null,
    cId: null,
    rId: null,
    opts: null,
    centerLatLng: null,
    init: function init(el, options) {
      var opts = $.extend(true, {}, $.goMapBase.defaults, options);
      this.mapId = $(el);
      this.opts = opts;
      if (opts.address) this.geocode({
        address: opts.address,
        center: true
      }); //			else if (opts.latitude != $.goMapBase.defaults.latitude && opts.longitude != $.goMapBase.defaults.longitude)
      //				this.centerLatLng = new google.maps.LatLng(opts.latitude, opts.longitude);
      else if ($.isArray(opts.markers) && opts.markers.length > 0) {
          if (opts.markers[0].address) this.geocode({
            address: opts.markers[0].address,
            center: true
          });else this.centerLatLng = new google.maps.LatLng(opts.markers[0].latitude, opts.markers[0].longitude);
        } else this.centerLatLng = new google.maps.LatLng(opts.latitude, opts.longitude);
      var myOptions = {
        center: this.centerLatLng,
        disableDoubleClickZoom: opts.disableDoubleClickZoom,
        mapTypeControl: opts.mapTypeControl,
        streetViewControl: opts.streetViewControl,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition[opts.mapTypeControlOptions.position.toUpperCase()],
          style: google.maps.MapTypeControlStyle[opts.mapTypeControlOptions.style.toUpperCase()]
        },
        mapTypeId: google.maps.MapTypeId[opts.maptype.toUpperCase()],
        panControl: opts.navigationControl,
        zoomControl: opts.navigationControl,
        panControlOptions: {
          position: google.maps.ControlPosition[opts.navigationControlOptions.position.toUpperCase()]
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition[opts.navigationControlOptions.position.toUpperCase()],
          style: google.maps.ZoomControlStyle[opts.navigationControlOptions.style.toUpperCase()]
        },
        scaleControl: opts.scaleControl,
        scrollwheel: opts.scrollwheel,
        zoom: opts.zoom,
        heading: 180,
        styles: [{
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#ebf1f4"
          }]
        }, {
          "featureType": "landscape.man_made",
          "elementType": "geometry",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [{
            "visibility": "on"
          }, {
            "hue": "#009cff"
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{
            "lightness": "100"
          }]
        }, {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [{
            "visibility": "simplified"
          }]
        }]
      };
      this.map = new google.maps.Map(el, myOptions);
      map = this.map;
      this.overlay = new MyOverlay(this.map);
      this.overlays = {
        polyline: {
          id: 'plId',
          array: 'polylines',
          create: 'createPolyline'
        },
        polygon: {
          id: 'pgId',
          array: 'polygons',
          create: 'createPolygon'
        },
        circle: {
          id: 'cId',
          array: 'circles',
          create: 'createCircle'
        },
        rectangle: {
          id: 'rId',
          array: 'rectangles',
          create: 'createRectangle'
        }
      };
      this.plId = $('<div style="display:none;"/>').appendTo(this.mapId);
      this.pgId = $('<div style="display:none;"/>').appendTo(this.mapId);
      this.cId = $('<div style="display:none;"/>').appendTo(this.mapId);
      this.rId = $('<div style="display:none;"/>').appendTo(this.mapId);

      for (var j = 0, l = opts.markers.length; j < l; j++) {
        this.createMarker(opts.markers[j]);
      }

      for (var j = 0, l = opts.overlays.length; j < l; j++) {
        this[this.overlays[opts.overlays[j].type].create](opts.overlays[j]);
      }

      var goMap = this;

      if (opts.addMarker == true || opts.addMarker == 'multi') {
        google.maps.event.addListener(goMap.map, 'click', function (event) {
          var options = {
            position: event.latLng,
            draggable: true
          };
          var marker = goMap.createMarker(options);
          google.maps.event.addListener(marker, 'click', function (event) {
            marker.setMap(null);
            goMap.removeMarker(marker.id);
          });
        });
      } else if (opts.addMarker == 'single') {
        google.maps.event.addListener(goMap.map, 'click', function (event) {
          if (!goMap.singleMarker) {
            var options = {
              position: event.latLng,
              draggable: true
            };
            var marker = goMap.createMarker(options);
            goMap.singleMarker = true;
            google.maps.event.addListener(marker, 'click', function (event) {
              marker.setMap(null);
              goMap.removeMarker(marker.id);
              goMap.singleMarker = false;
            });
          }
        });
      }

      delete opts.markers;
      delete opts.overlays;
      return this;
    },
    ready: function ready(f) {
      google.maps.event.addListenerOnce(this.map, 'bounds_changed', function () {
        return f();
      });
    },
    geocode: function geocode(address, options) {
      var goMap = this;
      setTimeout(function () {
        geocoder.geocode({
          'address': address.address
        }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK && address.center) goMap.map.setCenter(results[0].geometry.location);
          if (status == google.maps.GeocoderStatus.OK && options && options.markerId) options.markerId.setPosition(results[0].geometry.location);else if (status == google.maps.GeocoderStatus.OK && options) {
            if (goMap.lockGeocode) {
              goMap.lockGeocode = false;
              options.position = results[0].geometry.location;
              options.geocode = true;
              goMap.createMarker(options);
            }
          } else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
            goMap.geocode(address, options);
          }
        });
      }, this.opts.delay);
    },
    geoMarker: function geoMarker() {
      if (this.geoMarkers.length > 0 && !this.lockGeocode) {
        this.lockGeocode = true;
        var current = this.geoMarkers.splice(0, 1);
        this.geocode({
          address: current[0].address
        }, current[0]);
      } else if (this.lockGeocode) {
        var goMap = this;
        setTimeout(function () {
          goMap.geoMarker();
        }, this.opts.delay);
      }
    },
    setMap: function setMap(options) {
      delete options.mapTypeId;

      if (options.address) {
        this.geocode({
          address: options.address,
          center: true
        });
        delete options.address;
      } else if (options.latitude && options.longitude) {
        options.center = new google.maps.LatLng(options.latitude, options.longitude);
        delete options.longitude;
        delete options.latitude;
      }

      if (options.mapTypeControlOptions && options.mapTypeControlOptions.position) options.mapTypeControlOptions.position = google.maps.ControlPosition[options.mapTypeControlOptions.position.toUpperCase()];
      if (options.mapTypeControlOptions && options.mapTypeControlOptions.style) options.mapTypeControlOptions.style = google.maps.MapTypeControlStyle[options.mapTypeControlOptions.style.toUpperCase()];

      if (typeof options.navigationControl !== 'undefined') {
        options.panControl = options.navigationControl;
        options.zoomControl = options.navigationControl;
      }

      if (options.navigationControlOptions && options.navigationControlOptions.position) {
        options.panControlOptions = {
          position: google.maps.ControlPosition[options.navigationControlOptions.position.toUpperCase()]
        };
        options.zoomControlOptions = {
          position: google.maps.ControlPosition[options.navigationControlOptions.position.toUpperCase()]
        };
      }

      if (options.navigationControlOptions && options.navigationControlOptions.style) {
        if (typeof options.zoomControlOptions === 'undefined') options.zoomControlOptions = {
          style: google.maps.ZoomControlStyle[options.navigationControlOptions.style.toUpperCase()]
        };else options.zoomControlOptions.style = google.maps.ZoomControlStyle[options.navigationControlOptions.style.toUpperCase()];
      }

      this.map.setOptions(options);
    },
    getMap: function getMap() {
      return this.map;
    },
    createListener: function createListener(type, event, data) {
      var target;
      if (_typeof(type) != 'object') type = {
        type: type
      };
      if (type.type == 'map') target = this.map;else if (type.type == 'marker' && type.marker) target = $(this.mapId).data(type.marker);else if (type.type == 'info' && type.marker) target = $(this.mapId).data(type.marker + 'info');
      if (target) return google.maps.event.addListener(target, event, data);else if ((type.type == 'marker' || type.type == 'info') && this.getMarkerCount() != this.getTmpMarkerCount()) var goMap = this;
      setTimeout(function () {
        goMap.createListener(type, event, data);
      }, this.opts.delay);
    },
    removeListener: function removeListener(listener) {
      google.maps.event.removeListener(listener);
    },
    setInfoWindow: function setInfoWindow(marker, html) {
      var goMap = this;
      html.content = goMap.opts.html_prepend + html.content + goMap.opts.html_append;
      var infowindow = new google.maps.InfoWindow(html);
      infowindow.show = false;
      $(goMap.mapId).data(marker.id + 'info', infowindow);
      google.maps.event.addListener(marker, 'click', function () {
        goMap.openWindow(infowindow, marker, html);
      });
    },
    openWindow: function openWindow(infowindow, marker, html) {
      var modal = $('.' + marker.id);
      var obj = markers.find(function (x) {
        if (x.id === marker.id) {
          return x;
        }
      });
      $('.std_card--fullwidth.std_card, .std_card--fullwidth').hide();

      if ($.goMap.map != "undefined") {
        $.goMap.map.setZoom(15);
        $.goMap.map.panTo({
          lat: obj.latitude + 0.006,
          lng: obj.longitude + 0.0010
        });
      }

      modal.addClass('animatedfast fadeInDownLittle').fadeIn();
      setTimeout(function () {
        openmodal = false;
      }, 1000);
    },
    setInfo: function setInfo(id, text) {
      var info = $(this.mapId).data(id + 'info');
      if (_typeof(text) == 'object') info.setOptions(goMap.opts.html_prepend + text + goMap.opts.html_append);else info.setContent(goMap.opts.html_prepend + text + goMap.opts.html_append);
    },
    getInfo: function getInfo(id, hideDiv) {
      var info = $(this.mapId).data(id + 'info').getContent();
      if (hideDiv) return $(info).html();else return info;
    },
    clearInfo: function clearInfo() {
      for (var i = 0, l = this.markers.length; i < l; i++) {
        var info = $(this.mapId).data(this.markers[i] + 'info');

        if (info) {
          info.close();
          info.show = false;
        }
      }
    },
    fitBounds: function fitBounds(type, markers) {
      var goMap = this;
      if (this.getMarkerCount() != this.getTmpMarkerCount()) setTimeout(function () {
        goMap.fitBounds(type, markers);
      }, this.opts.delay);else {
        this.bounds = new google.maps.LatLngBounds();

        if (!type || type && type == 'all') {
          for (var i = 0, l = this.markers.length; i < l; i++) {
            this.bounds.extend($(this.mapId).data(this.markers[i]).position);
          }
        } else if (type && type == 'visible') {
          for (var i = 0, l = this.markers.length; i < l; i++) {
            if (this.getVisibleMarker(this.markers[i])) this.bounds.extend($(this.mapId).data(this.markers[i]).position);
          }
        } else if (type && type == 'markers' && $.isArray(markers)) {
          for (var i = 0, l = markers.length; i < l; i++) {
            this.bounds.extend($(this.mapId).data(markers[i]).position);
          }
        }

        this.map.fitBounds(this.bounds);
      }
    },
    getBounds: function getBounds() {
      return this.map.getBounds();
    },
    createPolyline: function createPolyline(poly) {
      poly.type = 'polyline';
      return this.createOverlay(poly);
    },
    createPolygon: function createPolygon(poly) {
      poly.type = 'polygon';
      return this.createOverlay(poly);
    },
    createCircle: function createCircle(poly) {
      poly.type = 'circle';
      return this.createOverlay(poly);
    },
    createRectangle: function createRectangle(poly) {
      poly.type = 'rectangle';
      return this.createOverlay(poly);
    },
    createOverlay: function createOverlay(poly) {
      var overlay = [];

      if (!poly.id) {
        this.count++;
        poly.id = this.opts.polyId + this.count;
      }

      switch (poly.type) {
        case 'polyline':
          if (poly.coords.length > 0) {
            for (var j = 0, l = poly.coords.length; j < l; j++) {
              overlay.push(new google.maps.LatLng(poly.coords[j].latitude, poly.coords[j].longitude));
            }

            overlay = new google.maps.Polyline({
              map: this.map,
              path: overlay,
              strokeColor: poly.color ? poly.color : this.opts.polyline.color,
              strokeOpacity: poly.opacity ? poly.opacity : this.opts.polyline.opacity,
              strokeWeight: poly.weight ? poly.weight : this.opts.polyline.weight
            });
          } else return false;

          break;

        case 'polygon':
          if (poly.coords.length > 0) {
            for (var j = 0, l = poly.coords.length; j < l; j++) {
              overlay.push(new google.maps.LatLng(poly.coords[j].latitude, poly.coords[j].longitude));
            }

            overlay = new google.maps.Polygon({
              map: this.map,
              path: overlay,
              strokeColor: poly.color ? poly.color : this.opts.polygon.color,
              strokeOpacity: poly.opacity ? poly.opacity : this.opts.polygon.opacity,
              strokeWeight: poly.weight ? poly.weight : this.opts.polygon.weight,
              fillColor: poly.fillColor ? poly.fillColor : this.opts.polygon.fillColor,
              fillOpacity: poly.fillOpacity ? poly.fillOpacity : this.opts.polygon.fillOpacity
            });
          } else return false;

          break;

        case 'circle':
          overlay = new google.maps.Circle({
            map: this.map,
            center: new google.maps.LatLng(poly.latitude, poly.longitude),
            radius: poly.radius,
            strokeColor: poly.color ? poly.color : this.opts.circle.color,
            strokeOpacity: poly.opacity ? poly.opacity : this.opts.circle.opacity,
            strokeWeight: poly.weight ? poly.weight : this.opts.circle.weight,
            fillColor: poly.fillColor ? poly.fillColor : this.opts.circle.fillColor,
            fillOpacity: poly.fillOpacity ? poly.fillOpacity : this.opts.circle.fillOpacity
          });
          break;

        case 'rectangle':
          overlay = new google.maps.Rectangle({
            map: this.map,
            bounds: new google.maps.LatLngBounds(new google.maps.LatLng(poly.sw.latitude, poly.sw.longitude), new google.maps.LatLng(poly.ne.latitude, poly.ne.longitude)),
            strokeColor: poly.color ? poly.color : this.opts.circle.color,
            strokeOpacity: poly.opacity ? poly.opacity : this.opts.circle.opacity,
            strokeWeight: poly.weight ? poly.weight : this.opts.circle.weight,
            fillColor: poly.fillColor ? poly.fillColor : this.opts.circle.fillColor,
            fillOpacity: poly.fillOpacity ? poly.fillOpacity : this.opts.circle.fillOpacity
          });
          break;

        default:
          return false;
          break;
      }

      this.addOverlay(poly, overlay);
      return overlay;
    },
    addOverlay: function addOverlay(poly, overlay) {
      $(this[this.overlays[poly.type].id]).data(poly.id, overlay);
      this[this.overlays[poly.type].array].push(poly.id);
    },
    setOverlay: function setOverlay(type, overlay, options) {
      overlay = $(this[this.overlays[type].id]).data(overlay);

      if (options.coords && options.coords.length > 0) {
        var array = [];

        for (var j = 0, l = options.coords.length; j < l; j++) {
          array.push(new google.maps.LatLng(options.coords[j].latitude, options.coords[j].longitude));
        }

        options.path = array;
        delete options.coords;
      } else if (options.ne && options.sw) {
        options.bounds = new google.maps.LatLngBounds(new google.maps.LatLng(options.sw.latitude, options.sw.longitude), new google.maps.LatLng(options.ne.latitude, options.ne.longitude));
        delete options.ne;
        delete options.sw;
      } else if (options.latitude && options.longitude) {
        options.center = new google.maps.LatLng(options.latitude, options.longitude);
        delete options.latitude;
        delete options.longitude;
      }

      overlay.setOptions(options);
    },
    showHideOverlay: function showHideOverlay(type, overlay, display) {
      if (typeof display === 'undefined') {
        if (this.getVisibleOverlay(type, overlay)) display = false;else display = true;
      }

      if (display) $(this[this.overlays[type].id]).data(overlay).setMap(this.map);else $(this[this.overlays[type].id]).data(overlay).setMap(null);
    },
    getVisibleOverlay: function getVisibleOverlay(type, overlay) {
      if ($(this[this.overlays[type].id]).data(overlay).getMap()) return true;else return false;
    },
    getOverlaysCount: function getOverlaysCount(type) {
      return this[this.overlays[type].array].length;
    },
    removeOverlay: function removeOverlay(type, overlay) {
      var index = $.inArray(overlay, this[this.overlays[type].array]),
          current;

      if (index > -1) {
        current = this[this.overlays[type].array].splice(index, 1);
        var markerId = current[0];
        $(this[this.overlays[type].id]).data(markerId).setMap(null);
        $(this[this.overlays[type].id]).removeData(markerId);
        return true;
      }

      return false;
    },
    clearOverlays: function clearOverlays(type) {
      for (var i = 0, l = this[this.overlays[type].array].length; i < l; i++) {
        var markerId = this[this.overlays[type].array][i];
        $(this[this.overlays[type].id]).data(markerId).setMap(null);
        $(this[this.overlays[type].id]).removeData(markerId);
      }

      this[this.overlays[type].array] = [];
    },
    showHideMarker: function showHideMarker(marker, display) {
      if (typeof display === 'undefined') {
        if (this.getVisibleMarker(marker)) {
          $(this.mapId).data(marker).setVisible(false);
          var info = $(this.mapId).data(marker + 'info');

          if (info && info.show) {
            info.close();
            info.show = false;
          }
        } else $(this.mapId).data(marker).setVisible(true);
      } else $(this.mapId).data(marker).setVisible(display);
    },
    showHideMarkerByGroup: function showHideMarkerByGroup(group, display) {
      for (var i = 0, l = this.markers.length; i < l; i++) {
        var markerId = this.markers[i];
        var marker = $(this.mapId).data(markerId);

        if (marker.group == group) {
          if (typeof display === 'undefined') {
            if (this.getVisibleMarker(markerId)) {
              marker.setVisible(false);
              var info = $(this.mapId).data(markerId + 'info');

              if (info && info.show) {
                info.close();
                info.show = false;
              }
            } else marker.setVisible(true);
          } else marker.setVisible(display);
        }
      }
    },
    getVisibleMarker: function getVisibleMarker(marker) {
      return $(this.mapId).data(marker).getVisible();
    },
    getMarkerCount: function getMarkerCount() {
      return this.markers.length;
    },
    getTmpMarkerCount: function getTmpMarkerCount() {
      return this.tmpMarkers.length;
    },
    getVisibleMarkerCount: function getVisibleMarkerCount() {
      return this.getMarkers('visiblesInMap').length;
    },
    getMarkerByGroupCount: function getMarkerByGroupCount(group) {
      return this.getMarkers('group', group).length;
    },
    getMarkers: function getMarkers(type, name) {
      var array = [];

      switch (type) {
        case "json":
          for (var i = 0, l = this.markers.length; i < l; i++) {
            var temp = "'" + i + "': '" + $(this.mapId).data(this.markers[i]).getPosition().toUrlValue() + "'";
            array.push(temp);
          }

          array = "{'markers':{" + array.join(",") + "}}";
          break;

        case "data":
          for (var i = 0, l = this.markers.length; i < l; i++) {
            var temp = "marker[" + i + "]=" + $(this.mapId).data(this.markers[i]).getPosition().toUrlValue();
            array.push(temp);
          }

          array = array.join("&");
          break;

        case "visiblesInBounds":
          for (var i = 0, l = this.markers.length; i < l; i++) {
            if (this.isVisible($(this.mapId).data(this.markers[i]).getPosition())) array.push(this.markers[i]);
          }

          break;

        case "visiblesInMap":
          for (var i = 0, l = this.markers.length; i < l; i++) {
            if (this.getVisibleMarker(this.markers[i])) array.push(this.markers[i]);
          }

          break;

        case "group":
          if (name) for (var i = 0, l = this.markers.length; i < l; i++) {
            if ($(this.mapId).data(this.markers[i]).group == name) array.push(this.markers[i]);
          }
          break;

        case "markers":
          for (var i = 0, l = this.markers.length; i < l; i++) {
            var temp = $(this.mapId).data(this.markers[i]);
            array.push(temp);
          }

          break;

        default:
          for (var i = 0, l = this.markers.length; i < l; i++) {
            var temp = $(this.mapId).data(this.markers[i]).getPosition().toUrlValue();
            array.push(temp);
          }

          break;
      }

      return array;
    },
    getVisibleMarkers: function getVisibleMarkers() {
      return this.getMarkers('visiblesInBounds');
    },
    createMarker: function createMarker(marker) {
      if (!marker.geocode) {
        this.count++;
        if (!marker.id) marker.id = this.opts.prefixId + this.count;
        this.tmpMarkers.push(marker.id);
      }

      if (marker.address && !marker.geocode) {
        this.geoMarkers.push(marker);
        this.geoMarker();
      } else if (marker.latitude && marker.longitude || marker.position) {
        var options = {
          map: this.map
        };
        options.id = marker.id;
        options.group = marker.group ? marker.group : this.opts.groupId;
        options.zIndex = marker.zIndex ? marker.zIndex : 0;
        options.zIndexOrg = marker.zIndexOrg ? marker.zIndexOrg : 0;
        if (marker.visible == false) options.visible = marker.visible;
        if (marker.title) options.title = marker.title;
        if (marker.draggable) options.draggable = marker.draggable;

        if (marker.icon && marker.icon.image) {
          options.icon = marker.icon.image;
          if (marker.icon.shadow) options.shadow = marker.icon.shadow;
        } else if (marker.icon) options.icon = marker.icon;else if (this.opts.icon && this.opts.icon.image) {
          options.icon = this.opts.icon.image;
          if (this.opts.icon.shadow) options.shadow = this.opts.icon.shadow;
        } else if (this.opts.icon) options.icon = this.opts.icon;

        options.position = marker.position ? marker.position : new google.maps.LatLng(marker.latitude, marker.longitude);
        var cmarker = new google.maps.Marker(options);

        if (marker.html) {
          if (!marker.html.content && !marker.html.ajax && !marker.html.id) marker.html = {
            content: marker.html
          };else if (!marker.html.content) marker.html.content = null;
          this.setInfoWindow(cmarker, marker.html);
        }

        this.addMarker(cmarker);
        return cmarker;
      }
    },
    addMarker: function addMarker(marker) {
      $(this.mapId).data(marker.id, marker);
      this.markers.push(marker.id);
    },
    setMarker: function setMarker(marker, options) {
      var tmarker = $(this.mapId).data(marker);
      delete options.id;
      delete options.visible;

      if (options.icon) {
        var toption = options.icon;
        delete options.icon;

        if (toption && toption == 'default') {
          if (this.opts.icon && this.opts.icon.image) {
            options.icon = this.opts.icon.image;
            if (this.opts.icon.shadow) options.shadow = this.opts.icon.shadow;
          } else if (this.opts.icon) options.icon = this.opts.icon;
        } else if (toption && toption.image) {
          options.icon = toption.image;
          if (toption.shadow) options.shadow = toption.shadow;
        } else if (toption) options.icon = toption;
      }

      if (options.address) {
        this.geocode({
          address: options.address
        }, {
          markerId: tmarker
        });
        delete options.address;
        delete options.latitude;
        delete options.longitude;
        delete options.position;
      } else if (options.latitude && options.longitude || options.position) {
        if (!options.position) options.position = new google.maps.LatLng(options.latitude, options.longitude);
      }

      tmarker.setOptions(options);
    },
    removeMarker: function removeMarker(marker) {
      var index = $.inArray(marker, this.markers),
          current;

      if (index > -1) {
        this.tmpMarkers.splice(index, 1);
        current = this.markers.splice(index, 1);
        var markerId = current[0];
        var marker = $(this.mapId).data(markerId);
        var info = $(this.mapId).data(markerId + 'info');
        marker.setVisible(false);
        marker.setMap(null);
        $(this.mapId).removeData(markerId);

        if (info) {
          info.close();
          info.show = false;
          $(this.mapId).removeData(markerId + 'info');
        }

        return true;
      }

      return false;
    },
    clearMarkers: function clearMarkers() {
      for (var i = 0, l = this.markers.length; i < l; i++) {
        var markerId = this.markers[i];
        var marker = $(this.mapId).data(markerId);
        var info = $(this.mapId).data(markerId + 'info');
        marker.setVisible(false);
        marker.setMap(null);
        $(this.mapId).removeData(markerId);

        if (info) {
          info.close();
          info.show = false;
          $(this.mapId).removeData(markerId + 'info');
        }
      }

      this.singleMarker = false;
      this.lockGeocode = false;
      this.markers = [];
      this.tmpMarkers = [];
      this.geoMarkers = [];
    },
    isVisible: function isVisible(latlng) {
      return this.map.getBounds().contains(latlng);
    }
  };
})(jQuery);
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;

(function ($, window, document, undefined) {
  "use strict"; // Create the defaults once

  var pluginName = "simpleCalendar",
      defaults = {
    months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
    //string of months starting from january
    days: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
    //string of days starting from sunday
    displayYear: true,
    // display year in header
    fixedStartDay: true,
    // Week begin always by monday or by day set by number 0 = sunday, 7 = saturday, false = month always begin by first day of the month
    displayEvent: true,
    // display existing event
    disableEventDetails: false,
    // disable showing event details
    disableEmptyDetails: false,
    // disable showing empty date details
    events: [],
    // List of event
    onInit: function onInit(calendar) {},
    // Callback after first initialization
    onMonthChange: function onMonthChange(month, year) {},
    // Callback on month change
    onDateSelect: function onDateSelect(date, events) {},
    // Callback on date selection
    onEventSelect: function onEventSelect() {},
    // Callback fired when an event is selected     - see $(this).data('event')
    onEventCreate: function onEventCreate($el) {},
    // Callback fired when an HTML event is created - see $(this).data('event')
    onDayCreate: function onDayCreate($el, d, m, y) {} // Callback fired when an HTML day is created   - see $(this).data('today'), .data('todayEvents')

  }; // The actual plugin constructor

  function Plugin(element, options) {
    this.element = element;
    this.settings = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.currentDate = new Date();
    this.init();
  } // Avoid Plugin.prototype conflicts


  $.extend(Plugin.prototype, {
    init: function init() {
      var container = $(this.element);
      var todayDate = this.currentDate;
      var calendar = $('<div class="event-calendar"></div>');
      var header = $('<header>' + '<h2 class="month"></h2>' + '<a class="simple-calendar-btn btn-prev" href="#"></a>' + '<a class="simple-calendar-btn btn-next" href="#"></a>' + '</header>');
      this.updateHeader(todayDate, header);
      calendar.append(header);
      this.buildCalendar(todayDate, calendar);
      container.append(calendar);
      this.bindEvents();
      this.settings.onInit(this);
    },
    //Update the current month header
    updateHeader: function updateHeader(date, header) {
      var monthText = this.settings.months[date.getMonth()];
      monthText += this.settings.displayYear ? ' <div class="year">' + date.getFullYear() : '</div>';
      header.find('.month').html(monthText);
    },
    //Build calendar of a month from date
    buildCalendar: function buildCalendar(fromDate, calendar) {
      var plugin = this;
      calendar.find('table').remove();
      var body = $('<table></table>');
      var thead = $('<thead></thead>');
      var tbody = $('<tbody></tbody>'); //setting current year and month

      var y = fromDate.getFullYear(),
          m = fromDate.getMonth(); //first day of the month

      var firstDay = new Date(y, m, 1); //last day of the month

      var lastDay = new Date(y, m + 1, 0); // Start day of weeks

      var startDayOfWeek = firstDay.getDay();

      if (this.settings.fixedStartDay !== false) {
        // Backward compatibility
        startDayOfWeek = this.settings.fixedStartDay ? 1 : this.settings.fixedStartDay; // If first day of month is different of startDayOfWeek

        while (firstDay.getDay() !== startDayOfWeek) {
          firstDay.setDate(firstDay.getDate() - 1);
        } // If last day of month is different of startDayOfWeek + 7


        while (lastDay.getDay() !== (startDayOfWeek + 6) % 7) {
          lastDay.setDate(lastDay.getDate() + 1);
        }
      } //Header day in a week ( (x to x + 7) % 7 to start the week by monday if x = 1)


      for (var i = startDayOfWeek; i < startDayOfWeek + 7; i++) {
        thead.append($('<td>' + this.settings.days[i % 7].substring(0, 3) + '</td>'));
      } //For firstDay to lastDay


      for (var day = firstDay; day <= lastDay; day.setDate(day.getDate())) {
        var tr = $('<tr></tr>'); //For each row

        for (var i = 0; i < 7; i++) {
          var td = $('<td><div class="day" data-date="' + day.toISOString() + '">' + (day.getDate() + '').padStart(2, '0') + '</div></td>');
          var $day = td.find('.day'); //if today is this day 

          if (day.toDateString() === new Date().toDateString()) {
            $day.addClass("today");
          } //if day is not in this month


          if (day.getMonth() != fromDate.getMonth()) {
            $day.addClass("wrong-month");
          } // filter today's events


          var todayEvents = plugin.getDateEvents(day);

          if (todayEvents.length && plugin.settings.displayEvent) {
            $day.addClass(plugin.settings.disableEventDetails ? "has-event disabled" : "has-event");
          } else {
            $day.addClass(plugin.settings.disableEmptyDetails ? "disabled" : "");
          } // associate some data available from the onDayCreate callback


          $day.data('todayEvents', todayEvents); // simplify further customization

          this.settings.onDayCreate($day, day.getDate(), m, y);
          tr.append(td);
          day.setDate(day.getDate() + 1);
        }

        tbody.append(tr);
      }

      body.append(thead);
      body.append(tbody);
      var eventContainer = $('<div class="event-container"><div class="close"></div><div class="event-wrapper"></div></div>');
      calendar.append(body);
      calendar.append(eventContainer);
    },
    changeMonth: function changeMonth(value) {
      this.setMonth(this.currentDate.getMonth() + value, true);
    },
    setMonth: function setMonth(value, trigger) {
      this.currentDate.setMonth(value, 1);
      this.buildCalendar(this.currentDate, $(this.element).find('.event-calendar'));
      this.updateHeader(this.currentDate, $(this.element).find('.event-calendar header'));
      if (trigger) this.settings.onMonthChange(this.currentDate.getMonth(), this.currentDate.getFullYear());
    },
    //Init global events listeners
    bindEvents: function bindEvents() {
      var plugin = this; //Click previous month

      $(plugin.element).on('click', '.btn-prev', function (e) {
        plugin.changeMonth(-1);
        e.preventDefault();
      }); //Click next month

      $(plugin.element).on('click', '.btn-next', function (e) {
        plugin.changeMonth(1);
        e.preventDefault();
      }); //Binding day event

      $(plugin.element).on('click', '.day', function (e) {
        var date = new Date($(this).data('date'));
        var events = plugin.getDateEvents(date);

        if (!$(this).hasClass('disabled')) {
          plugin.fillUp(e.pageX, e.pageY);
          plugin.displayEvents(events);
        }

        plugin.settings.onDateSelect(date, events);
      }); //Binding event container close

      $(plugin.element).on('click', '.event-container .close', function (e) {
        plugin.empty(e.pageX, e.pageY);
      });
    },
    displayEvents: function displayEvents(events) {
      var plugin = this;
      var container = $(this.element).find('.event-wrapper');
      events.forEach(function (event) {
        var startDate = new Date(event.startDate);
        var endDate = new Date(event.endDate);
        var $event = $('' + '<div class="event">' + ' <div class="event-hour">' + startDate.getHours() + ':' + (startDate.getMinutes() < 10 ? '0' : '') + startDate.getMinutes() + '</div>' + ' <div class="event-date">' + plugin.formatDateEvent(startDate, endDate) + '</div>' + ' <div class="event-summary">' + event.summary + '</div>' + '</div>');
        $event.data('event', event);
        $event.click(plugin.settings.onEventSelect); // simplify further customization

        plugin.settings.onEventCreate($event);
        container.append($event);
      });
    },
    addEvent: function addEvent(newEvent) {
      var plugin = this; // add the new event to events list

      plugin.settings.events = [].concat(_toConsumableArray(plugin.settings.events), [newEvent]);
      this.buildCalendar(this.currentDate, $(this.element).find('.event-calendar'));
    },
    setEvents: function setEvents(events) {
      var plugin = this;
      plugin.settings.events = events;
      this.buildCalendar(this.currentDate, $(this.element).find('.event-calendar'));
    },
    //Small effect to fillup a container
    fillUp: function fillUp(x, y) {
      var plugin = this;
      var elem = $(plugin.element);
      var elemOffset = elem.offset();
      var filler = $('<div class="filler" style=""></div>');
      filler.css("left", x - elemOffset.left);
      filler.css("top", y - elemOffset.top);
      elem.find('.event-calendar').append(filler);
      filler.animate({
        width: "300%",
        height: "300%"
      }, 500, function () {
        elem.find('.event-container').show();
        filler.hide();
      });
    },
    //Small effect to empty a container
    empty: function empty(x, y) {
      var plugin = this;
      var elem = $(plugin.element);
      var elemOffset = elem.offset();
      var filler = elem.find('.filler');
      filler.css("width", "300%");
      filler.css("height", "300%");
      filler.show();
      elem.find('.event-container').hide().find('.event').remove();
      filler.animate({
        width: "0%",
        height: "0%"
      }, 500, function () {
        filler.remove();
      });
    },
    getDateEvents: function getDateEvents(d) {
      var plugin = this;
      return plugin.settings.events.filter(function (event) {
        return plugin.isDayBetween(new Date(d), new Date(event.startDate), new Date(event.endDate));
      });
    },
    isDayBetween: function isDayBetween(d, dStart, dEnd) {
      dStart.setHours(0, 0, 0);
      dEnd.setHours(23, 59, 59, 999);
      d.setHours(12, 0, 0);
      return dStart <= d && d <= dEnd;
    },
    formatDateEvent: function formatDateEvent(dateStart, dateEnd) {
      var formatted = '';
      formatted += this.settings.days[dateStart.getDay()] + ' - ' + dateStart.getDate() + ' ' + this.settings.months[dateStart.getMonth()].substring(0, 3);

      if (dateEnd.getDate() !== dateStart.getDate()) {
        formatted += ' to ' + dateEnd.getDate() + ' ' + this.settings.months[dateEnd.getMonth()].substring(0, 3);
      }

      return formatted;
    }
  }); // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  };
})(jQuery, window, document);
"use strict";

!function (a) {
  "use strict";

  var b = "starRating",
      c = function c() {},
      d = {
    totalStars: 5,
    useFullStars: !1,
    starShape: "straight",
    emptyColor: "lightgray",
    hoverColor: "orange",
    activeColor: "gold",
    ratedColor: "crimson",
    useGradient: !0,
    readOnly: !1,
    disableAfterRate: !0,
    baseUrl: !1,
    starGradient: {
      start: "#FEF7CD",
      end: "#FF9511"
    },
    strokeWidth: 4,
    strokeColor: "black",
    initialRating: 0,
    starSize: 40,
    callback: c,
    onHover: c,
    onLeave: c
  },
      e = function e(c, _e) {
    var f, g, h;
    this.element = c, this.$el = a(c), this.settings = a.extend({}, d, _e), f = this.$el.data("rating") || this.settings.initialRating, h = this.settings.forceRoundUp ? Math.ceil : Math.round, g = (h(2 * f) / 2).toFixed(1), this._state = {
      rating: g
    }, this._uid = Math.floor(999 * Math.random()), _e.starGradient || this.settings.useGradient || (this.settings.starGradient.start = this.settings.starGradient.end = this.settings.activeColor), this._defaults = d, this._name = b, this.init();
  },
      f = {
    init: function init() {
      this.renderMarkup(), this.addListeners(), this.initRating();
    },
    addListeners: function addListeners() {
      this.settings.readOnly || (this.$stars.on("mouseover", this.hoverRating.bind(this)), this.$stars.on("mouseout", this.restoreState.bind(this)), this.$stars.on("click", this.handleRating.bind(this)));
    },
    hoverRating: function hoverRating(a) {
      var b = this.getIndex(a);
      this.paintStars(b, "hovered"), this.settings.onHover(b + 1, this._state.rating, this.$el);
    },
    handleRating: function handleRating(a) {
      var b = this.getIndex(a),
          c = b + 1;
      this.applyRating(c, this.$el), this.executeCallback(c, this.$el), this.settings.disableAfterRate && this.$stars.off();
    },
    applyRating: function applyRating(a) {
      var b = a - 1;
      this.paintStars(b, "rated"), this._state.rating = b + 1, this._state.rated = !0;
    },
    restoreState: function restoreState(a) {
      var b = this.getIndex(a),
          c = this._state.rating || -1,
          d = this._state.rated ? "rated" : "active";
      this.paintStars(c - 1, d), this.settings.onLeave(b + 1, this._state.rating, this.$el);
    },
    getIndex: function getIndex(b) {
      var c = a(b.currentTarget),
          d = c.width(),
          e = a(b.target).attr("data-side");
      e = e ? e : this.getOffsetByPixel(b, c, d), e = this.settings.useFullStars ? "right" : e;
      var f = c.index() - ("left" === e ? .5 : 0);
      return f = .5 > f && b.offsetX < d / 4 ? -1 : f;
    },
    getOffsetByPixel: function getOffsetByPixel(a, b, c) {
      var d = a.pageX - b.offset().left;
      return c / 2 >= d && !this.settings.useFullStars ? "left" : "right";
    },
    initRating: function initRating() {
      this.paintStars(this._state.rating - 1, "active");
    },
    paintStars: function paintStars(b, c) {
      var d, e, f, g;
      a.each(this.$stars, function (h, i) {
        d = a(i).find('[data-side="left"]'), e = a(i).find('[data-side="right"]'), f = g = b >= h ? c : "empty", f = h - b === .5 ? c : f, d.attr("class", "svg-" + f + "-" + this._uid), e.attr("class", "svg-" + g + "-" + this._uid);
      }.bind(this));
    },
    renderMarkup: function renderMarkup() {
      for (var a = this.settings, b = a.baseUrl ? location.href.split("#")[0] : "", c = '<div class="jq-star" style="width:' + a.starSize + "px;  height:" + a.starSize + 'px;"><svg version="1.0" class="jq-star-svg" shape-rendering="geometricPrecision" xmlns="http://www.w3.org/2000/svg" ' + this.getSvgDimensions(a.starShape) + " stroke-width:" + a.strokeWidth + 'px;" xml:space="preserve"><style type="text/css">.svg-empty-' + this._uid + "{fill:url(" + b + "#" + this._uid + "_SVGID_1_);}.svg-hovered-" + this._uid + "{fill:url(" + b + "#" + this._uid + "_SVGID_2_);}.svg-active-" + this._uid + "{fill:url(" + b + "#" + this._uid + "_SVGID_3_);}.svg-rated-" + this._uid + "{fill:" + a.ratedColor + ";}</style>" + this.getLinearGradient(this._uid + "_SVGID_1_", a.emptyColor, a.emptyColor, a.starShape) + this.getLinearGradient(this._uid + "_SVGID_2_", a.hoverColor, a.hoverColor, a.starShape) + this.getLinearGradient(this._uid + "_SVGID_3_", a.starGradient.start, a.starGradient.end, a.starShape) + this.getVectorPath(this._uid, {
        starShape: a.starShape,
        strokeWidth: a.strokeWidth,
        strokeColor: a.strokeColor
      }) + "</svg></div>", d = "", e = 0; e < a.totalStars; e++) {
        d += c;
      }

      this.$el.append(d), this.$stars = this.$el.find(".jq-star");
    },
    getVectorPath: function getVectorPath(a, b) {
      return "rounded" === b.starShape ? this.getRoundedVectorPath(a, b) : this.getSpikeVectorPath(a, b);
    },
    getSpikeVectorPath: function getSpikeVectorPath(a, b) {
      return '<polygon data-side="center" class="svg-empty-' + a + '" points="281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 212.9,181.1 213.9,181 306.5,241 " style="fill: transparent; stroke: ' + b.strokeColor + ';" /><polygon data-side="left" class="svg-empty-' + a + '" points="281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 213.9,181.1 213.9,181 306.5,241 " style="stroke-opacity: 0;" /><polygon data-side="right" class="svg-empty-' + a + '" points="364,55.7 255.5,46.8 214,-59 213.9,181 306.5,241 281.1,129.8 " style="stroke-opacity: 0;" />';
    },
    getRoundedVectorPath: function getRoundedVectorPath(a, b) {
      var c = "M520.9,336.5c-3.8-11.8-14.2-20.5-26.5-22.2l-140.9-20.5l-63-127.7 c-5.5-11.2-16.8-18.2-29.3-18.2c-12.5,0-23.8,7-29.3,18.2l-63,127.7L28,314.2C15.7,316,5.4,324.7,1.6,336.5S1,361.3,9.9,370 l102,99.4l-24,140.3c-2.1,12.3,2.9,24.6,13,32c5.7,4.2,12.4,6.2,19.2,6.2c5.2,0,10.5-1.2,15.2-3.8l126-66.3l126,66.2 c4.8,2.6,10,3.8,15.2,3.8c6.8,0,13.5-2.1,19.2-6.2c10.1-7.3,15.1-19.7,13-32l-24-140.3l102-99.4 C521.6,361.3,524.8,348.3,520.9,336.5z";
      return '<path data-side="center" class="svg-empty-' + a + '" d="' + c + '" style="stroke: ' + b.strokeColor + '; fill: transparent; " /><path data-side="right" class="svg-empty-' + a + '" d="' + c + '" style="stroke-opacity: 0;" /><path data-side="left" class="svg-empty-' + a + '" d="M121,648c-7.3,0-14.1-2.2-19.8-6.4c-10.4-7.6-15.6-20.3-13.4-33l24-139.9l-101.6-99 c-9.1-8.9-12.4-22.4-8.6-34.5c3.9-12.1,14.6-21.1,27.2-23l140.4-20.4L232,164.6c5.7-11.6,17.3-18.8,30.2-16.8c0.6,0,1,0.4,1,1 v430.1c0,0.4-0.2,0.7-0.5,0.9l-126,66.3C132,646.6,126.6,648,121,648z" style="stroke: ' + b.strokeColor + '; stroke-opacity: 0;" />';
    },
    getSvgDimensions: function getSvgDimensions(a) {
      return "rounded" === a ? 'width="550px" height="500.2px" viewBox="0 146.8 550 500.2" style="enable-background:new 0 0 550 500.2;' : 'x="0px" y="0px" width="305px" height="305px" viewBox="60 -62 309 309" style="enable-background:new 64 -59 305 305;';
    },
    getLinearGradient: function getLinearGradient(a, b, c, d) {
      var e = "rounded" === d ? 500 : 250;
      return '<linearGradient id="' + a + '" gradientUnits="userSpaceOnUse" x1="0" y1="-50" x2="0" y2="' + e + '"><stop  offset="0" style="stop-color:' + b + '"/><stop  offset="1" style="stop-color:' + c + '"/> </linearGradient>';
    },
    executeCallback: function executeCallback(a, b) {
      var c = this.settings.callback;
      c(a, b);
    }
  },
      g = {
    unload: function unload() {
      var c = "plugin_" + b,
          d = a(this),
          e = d.data(c).$stars;
      e.off(), d.removeData(c).remove();
    },
    setRating: function setRating(c, d) {
      var e = "plugin_" + b,
          f = a(this),
          g = f.data(e);
      c > g.settings.totalStars || 0 > c || (d && (c = Math.round(c)), g.applyRating(c));
    },
    getRating: function getRating() {
      var c = "plugin_" + b,
          d = a(this),
          e = d.data(c);
      return e._state.rating;
    },
    resize: function resize(c) {
      var d = "plugin_" + b,
          e = a(this),
          f = e.data(d),
          g = f.$stars;
      return 1 >= c || c > 200 ? void console.log("star size out of bounds") : (g = Array.prototype.slice.call(g), void g.forEach(function (b) {
        a(b).css({
          width: c + "px",
          height: c + "px"
        });
      }));
    },
    setReadOnly: function setReadOnly(c) {
      var d = "plugin_" + b,
          e = a(this),
          f = e.data(d);
      c === !0 ? f.$stars.off("mouseover mouseout click") : (f.settings.readOnly = !1, f.addListeners());
    }
  };

  a.extend(e.prototype, f), a.fn[b] = function (c) {
    if (!a.isPlainObject(c)) {
      if (g.hasOwnProperty(c)) return g[c].apply(this, Array.prototype.slice.call(arguments, 1));
      a.error("Method " + c + " does not exist on " + b + ".js");
    }

    return this.each(function () {
      a.data(this, "plugin_" + b) || a.data(this, "plugin_" + b, new e(this, c));
    });
  };
}(jQuery, window, document);
"use strict";

/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function (o) {
  var t = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: "mouseover",
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1
  };
  o.zoom = function (t, n, e, i) {
    var u,
        c,
        a,
        r,
        m,
        l,
        s,
        f = o(t),
        h = f.css("position"),
        d = o(n);
    return t.style.position = /(absolute|fixed)/.test(h) ? h : "relative", t.style.overflow = "hidden", e.style.width = e.style.height = "", o(e).addClass("zoomImg").css({
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0,
      width: e.width * i,
      height: e.height * i,
      border: "none",
      maxWidth: "none",
      maxHeight: "none"
    }).appendTo(t), {
      init: function init() {
        c = f.outerWidth(), u = f.outerHeight(), n === t ? (r = c, a = u) : (r = d.outerWidth(), a = d.outerHeight()), m = (e.width - c) / r, l = (e.height - u) / a, s = d.offset();
      },
      move: function move(o) {
        var t = o.pageX - s.left,
            n = o.pageY - s.top;
        n = Math.max(Math.min(n, a), 0), t = Math.max(Math.min(t, r), 0), e.style.left = t * -m + "px", e.style.top = n * -l + "px";
      }
    };
  }, o.fn.zoom = function (n) {
    return this.each(function () {
      var e = o.extend({}, t, n || {}),
          i = e.target && o(e.target)[0] || this,
          u = this,
          c = o(u),
          a = document.createElement("img"),
          r = o(a),
          m = "mousemove.zoom",
          l = !1,
          s = !1;

      if (!e.url) {
        var f = u.querySelector("img");
        if (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src), !e.url) return;
      }

      c.one("zoom.destroy", function (o, t) {
        c.off(".zoom"), i.style.position = o, i.style.overflow = t, a.onload = null, r.remove();
      }.bind(this, i.style.position, i.style.overflow)), a.onload = function () {
        function t(t) {
          f.init(), f.move(t), r.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1);
        }

        function n() {
          r.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1);
        }

        var f = o.zoom(i, u, a, e.magnify);
        "grab" === e.on ? c.on("mousedown.zoom", function (e) {
          1 === e.which && (o(document).one("mouseup.zoom", function () {
            n(), o(document).off(m, f.move);
          }), t(e), o(document).on(m, f.move), e.preventDefault());
        }) : "click" === e.on ? c.on("click.zoom", function (e) {
          return l ? void 0 : (l = !0, t(e), o(document).on(m, f.move), o(document).one("click.zoom", function () {
            n(), l = !1, o(document).off(m, f.move);
          }), !1);
        }) : "toggle" === e.on ? c.on("click.zoom", function (o) {
          l ? n() : t(o), l = !l;
        }) : "mouseover" === e.on && (f.init(), c.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(m, f.move)), e.touch && c.on("touchstart.zoom", function (o) {
          o.preventDefault(), s ? (s = !1, n()) : (s = !0, t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]));
        }).on("touchmove.zoom", function (o) {
          o.preventDefault(), f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]);
        }).on("touchend.zoom", function (o) {
          o.preventDefault(), s && (s = !1, n());
        }), o.isFunction(e.callback) && e.callback.call(a);
      }, a.setAttribute("role", "presentation"), a.alt = "", a.src = e.url;
    });
  }, o.fn.zoom.defaults = t;
})(window.jQuery);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! lightgallery - v1.6.7 - 2018-02-11
 * http://sachinchoolur.github.io/lightGallery/
 * Copyright (c) 2018 Sachin N; Licensed GPLv3 */
!function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(a.jQuery);
}(window, function (a) {
  !function () {
    "use strict";

    function b(b, d) {
      if (this.el = b, this.$el = a(b), this.s = a.extend({}, c, d), this.s.dynamic && "undefined" !== this.s.dynamicEl && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length) throw "When using dynamic mode, you must also define dynamicEl as an Array.";
      return this.modules = {}, this.lGalleryOn = !1, this.lgBusy = !1, this.hideBartimeout = !1, this.isTouch = "ontouchstart" in document.documentElement, this.s.slideEndAnimatoin && (this.s.hideControlOnEnd = !1), this.s.dynamic ? this.$items = this.s.dynamicEl : "this" === this.s.selector ? this.$items = this.$el : "" !== this.s.selector ? this.s.selectWithin ? this.$items = a(this.s.selectWithin).find(this.s.selector) : this.$items = this.$el.find(a(this.s.selector)) : this.$items = this.$el.children(), this.$slide = "", this.$outer = "", this.init(), this;
    }

    var c = {
      mode: "lg-slide",
      cssEasing: "ease",
      easing: "linear",
      speed: 600,
      height: "100%",
      width: "100%",
      addClass: "",
      startClass: "lg-start-zoom",
      backdropDuration: 150,
      hideBarsDelay: 6e3,
      useLeft: !1,
      closable: !0,
      loop: !0,
      escKey: !0,
      keyPress: !0,
      controls: !0,
      slideEndAnimatoin: !0,
      hideControlOnEnd: !1,
      mousewheel: !0,
      getCaptionFromTitleOrAlt: !0,
      appendSubHtmlTo: ".lg-sub-html",
      subHtmlSelectorRelative: !1,
      preload: 1,
      showAfterLoad: !0,
      selector: "",
      selectWithin: "",
      nextHtml: "",
      prevHtml: "",
      index: !1,
      iframeMaxWidth: "100%",
      download: !0,
      counter: !0,
      appendCounterTo: ".lg-toolbar",
      swipeThreshold: 50,
      enableSwipe: !0,
      enableDrag: !0,
      dynamic: !1,
      dynamicEl: [],
      galleryId: 1
    };
    b.prototype.init = function () {
      var b = this;
      b.s.preload > b.$items.length && (b.s.preload = b.$items.length);
      var c = window.location.hash;
      c.indexOf("lg=" + this.s.galleryId) > 0 && (b.index = parseInt(c.split("&slide=")[1], 10), a("body").addClass("lg-from-hash"), a("body").hasClass("lg-on") || (setTimeout(function () {
        b.build(b.index);
      }), a("body").addClass("lg-on"))), b.s.dynamic ? (b.$el.trigger("onBeforeOpen.lg"), b.index = b.s.index || 0, a("body").hasClass("lg-on") || setTimeout(function () {
        b.build(b.index), a("body").addClass("lg-on");
      })) : b.$items.on("click.lgcustom", function (c) {
        try {
          c.preventDefault(), c.preventDefault();
        } catch (a) {
          c.returnValue = !1;
        }

        b.$el.trigger("onBeforeOpen.lg"), b.index = b.s.index || b.$items.index(this), a("body").hasClass("lg-on") || (b.build(b.index), a("body").addClass("lg-on"));
      });
    }, b.prototype.build = function (b) {
      var c = this;
      c.structure(), a.each(a.fn.lightGallery.modules, function (b) {
        c.modules[b] = new a.fn.lightGallery.modules[b](c.el);
      }), c.slide(b, !1, !1, !1), c.s.keyPress && c.keyPress(), c.$items.length > 1 ? (c.arrow(), setTimeout(function () {
        c.enableDrag(), c.enableSwipe();
      }, 50), c.s.mousewheel && c.mousewheel()) : c.$slide.on("click.lg", function () {
        c.$el.trigger("onSlideClick.lg");
      }), c.counter(), c.closeGallery(), c.$el.trigger("onAfterOpen.lg"), c.$outer.on("mousemove.lg click.lg touchstart.lg", function () {
        c.$outer.removeClass("lg-hide-items"), clearTimeout(c.hideBartimeout), c.hideBartimeout = setTimeout(function () {
          c.$outer.addClass("lg-hide-items");
        }, c.s.hideBarsDelay);
      }), c.$outer.trigger("mousemove.lg");
    }, b.prototype.structure = function () {
      var b,
          c = "",
          d = "",
          e = 0,
          f = "",
          g = this;

      for (a("body").append('<div class="lg-backdrop"></div>'), a(".lg-backdrop").css("transition-duration", this.s.backdropDuration + "ms"), e = 0; e < this.$items.length; e++) {
        c += '<div class="lg-item"></div>';
      }

      if (this.s.controls && this.$items.length > 1 && (d = '<div class="lg-actions"><button class="lg-prev lg-icon">' + this.s.prevHtml + '</button><button class="lg-next lg-icon">' + this.s.nextHtml + "</button></div>"), ".lg-sub-html" === this.s.appendSubHtmlTo && (f = '<div class="lg-sub-html"></div>'), b = '<div class="lg-outer ' + this.s.addClass + " " + this.s.startClass + '"><div class="lg" style="width:' + this.s.width + "; height:" + this.s.height + '"><div class="lg-inner">' + c + '</div><div class="lg-toolbar lg-group"><span class="lg-close lg-icon"></span></div>' + d + f + "</div></div>", a("body").append(b), this.$outer = a(".lg-outer"), this.$slide = this.$outer.find(".lg-item"), this.s.useLeft ? (this.$outer.addClass("lg-use-left"), this.s.mode = "lg-slide") : this.$outer.addClass("lg-use-css3"), g.setTop(), a(window).on("resize.lg orientationchange.lg", function () {
        setTimeout(function () {
          g.setTop();
        }, 100);
      }), this.$slide.eq(this.index).addClass("lg-current"), this.doCss() ? this.$outer.addClass("lg-css3") : (this.$outer.addClass("lg-css"), this.s.speed = 0), this.$outer.addClass(this.s.mode), this.s.enableDrag && this.$items.length > 1 && this.$outer.addClass("lg-grab"), this.s.showAfterLoad && this.$outer.addClass("lg-show-after-load"), this.doCss()) {
        var h = this.$outer.find(".lg-inner");
        h.css("transition-timing-function", this.s.cssEasing), h.css("transition-duration", this.s.speed + "ms");
      }

      setTimeout(function () {
        a(".lg-backdrop").addClass("in");
      }), setTimeout(function () {
        g.$outer.addClass("lg-visible");
      }, this.s.backdropDuration), this.s.download && this.$outer.find(".lg-toolbar").append('<a id="lg-download" target="_blank" download class="lg-download lg-icon"></a>'), this.prevScrollTop = a(window).scrollTop();
    }, b.prototype.setTop = function () {
      if ("100%" !== this.s.height) {
        var b = a(window).height(),
            c = (b - parseInt(this.s.height, 10)) / 2,
            d = this.$outer.find(".lg");
        b >= parseInt(this.s.height, 10) ? d.css("top", c + "px") : d.css("top", "0px");
      }
    }, b.prototype.doCss = function () {
      var a = function a() {
        var a = ["transition", "MozTransition", "WebkitTransition", "OTransition", "msTransition", "KhtmlTransition"],
            b = document.documentElement,
            c = 0;

        for (c = 0; c < a.length; c++) {
          if (a[c] in b.style) return !0;
        }
      };

      return !!a();
    }, b.prototype.isVideo = function (a, b) {
      var c;
      if (c = this.s.dynamic ? this.s.dynamicEl[b].html : this.$items.eq(b).attr("data-html"), !a) return c ? {
        html5: !0
      } : (console.error("lightGallery :- data-src is not pvovided on slide item " + (b + 1) + ". Please make sure the selector property is properly configured. More info - http://sachinchoolur.github.io/lightGallery/demos/html-markup.html"), !1);
      var d = a.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i),
          e = a.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i),
          f = a.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i),
          g = a.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);
      return d ? {
        youtube: d
      } : e ? {
        vimeo: e
      } : f ? {
        dailymotion: f
      } : g ? {
        vk: g
      } : void 0;
    }, b.prototype.counter = function () {
      this.s.counter && a(this.s.appendCounterTo).append('<div id="lg-counter"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.$items.length + "</span></div>");
    }, b.prototype.addHtml = function (b) {
      var c,
          d,
          e = null;
      if (this.s.dynamic ? this.s.dynamicEl[b].subHtmlUrl ? c = this.s.dynamicEl[b].subHtmlUrl : e = this.s.dynamicEl[b].subHtml : (d = this.$items.eq(b), d.attr("data-sub-html-url") ? c = d.attr("data-sub-html-url") : (e = d.attr("data-sub-html"), this.s.getCaptionFromTitleOrAlt && !e && (e = d.attr("title") || d.find("img").first().attr("alt")))), !c) if ("undefined" != typeof e && null !== e) {
        var f = e.substring(0, 1);
        "." !== f && "#" !== f || (e = this.s.subHtmlSelectorRelative && !this.s.dynamic ? d.find(e).html() : a(e).html());
      } else e = "";
      ".lg-sub-html" === this.s.appendSubHtmlTo ? c ? this.$outer.find(this.s.appendSubHtmlTo).load(c) : this.$outer.find(this.s.appendSubHtmlTo).html(e) : c ? this.$slide.eq(b).load(c) : this.$slide.eq(b).append(e), "undefined" != typeof e && null !== e && ("" === e ? this.$outer.find(this.s.appendSubHtmlTo).addClass("lg-empty-html") : this.$outer.find(this.s.appendSubHtmlTo).removeClass("lg-empty-html")), this.$el.trigger("onAfterAppendSubHtml.lg", [b]);
    }, b.prototype.preload = function (a) {
      var b = 1,
          c = 1;

      for (b = 1; b <= this.s.preload && !(b >= this.$items.length - a); b++) {
        this.loadContent(a + b, !1, 0);
      }

      for (c = 1; c <= this.s.preload && !(a - c < 0); c++) {
        this.loadContent(a - c, !1, 0);
      }
    }, b.prototype.loadContent = function (b, c, d) {
      var e,
          f,
          g,
          h,
          i,
          j,
          k = this,
          l = !1,
          m = function m(b) {
        for (var c = [], d = [], e = 0; e < b.length; e++) {
          var g = b[e].split(" ");
          "" === g[0] && g.splice(0, 1), d.push(g[0]), c.push(g[1]);
        }

        for (var h = a(window).width(), i = 0; i < c.length; i++) {
          if (parseInt(c[i], 10) > h) {
            f = d[i];
            break;
          }
        }
      };

      if (k.s.dynamic) {
        if (k.s.dynamicEl[b].poster && (l = !0, g = k.s.dynamicEl[b].poster), j = k.s.dynamicEl[b].html, f = k.s.dynamicEl[b].src, k.s.dynamicEl[b].responsive) {
          var n = k.s.dynamicEl[b].responsive.split(",");
          m(n);
        }

        h = k.s.dynamicEl[b].srcset, i = k.s.dynamicEl[b].sizes;
      } else {
        if (k.$items.eq(b).attr("data-poster") && (l = !0, g = k.$items.eq(b).attr("data-poster")), j = k.$items.eq(b).attr("data-html"), f = k.$items.eq(b).attr("href") || k.$items.eq(b).attr("data-src"), k.$items.eq(b).attr("data-responsive")) {
          var o = k.$items.eq(b).attr("data-responsive").split(",");
          m(o);
        }

        h = k.$items.eq(b).attr("data-srcset"), i = k.$items.eq(b).attr("data-sizes");
      }

      var p = !1;
      k.s.dynamic ? k.s.dynamicEl[b].iframe && (p = !0) : "true" === k.$items.eq(b).attr("data-iframe") && (p = !0);
      var q = k.isVideo(f, b);

      if (!k.$slide.eq(b).hasClass("lg-loaded")) {
        if (p) k.$slide.eq(b).prepend('<div class="lg-video-cont lg-has-iframe" style="max-width:' + k.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + f + '"  allowfullscreen="true"></iframe></div></div>');else if (l) {
          var r = "";
          r = q && q.youtube ? "lg-has-youtube" : q && q.vimeo ? "lg-has-vimeo" : "lg-has-html5", k.$slide.eq(b).prepend('<div class="lg-video-cont ' + r + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + g + '" /></div></div>');
        } else q ? (k.$slide.eq(b).prepend('<div class="lg-video-cont "><div class="lg-video"></div></div>'), k.$el.trigger("hasVideo.lg", [b, f, j])) : k.$slide.eq(b).prepend('<div class="lg-img-wrap"><img class="lg-object lg-image" src="' + f + '" /></div>');

        if (k.$el.trigger("onAferAppendSlide.lg", [b]), e = k.$slide.eq(b).find(".lg-object"), i && e.attr("sizes", i), h) {
          e.attr("srcset", h);

          try {
            picturefill({
              elements: [e[0]]
            });
          } catch (a) {
            console.warn("lightGallery :- If you want srcset to be supported for older browser please include picturefil version 2 javascript library in your document.");
          }
        }

        ".lg-sub-html" !== this.s.appendSubHtmlTo && k.addHtml(b), k.$slide.eq(b).addClass("lg-loaded");
      }

      k.$slide.eq(b).find(".lg-object").on("load.lg error.lg", function () {
        var c = 0;
        d && !a("body").hasClass("lg-from-hash") && (c = d), setTimeout(function () {
          k.$slide.eq(b).addClass("lg-complete"), k.$el.trigger("onSlideItemLoad.lg", [b, d || 0]);
        }, c);
      }), q && q.html5 && !l && k.$slide.eq(b).addClass("lg-complete"), c === !0 && (k.$slide.eq(b).hasClass("lg-complete") ? k.preload(b) : k.$slide.eq(b).find(".lg-object").on("load.lg error.lg", function () {
        k.preload(b);
      }));
    }, b.prototype.slide = function (b, c, d, e) {
      var f = this.$outer.find(".lg-current").index(),
          g = this;

      if (!g.lGalleryOn || f !== b) {
        var h = this.$slide.length,
            i = g.lGalleryOn ? this.s.speed : 0;

        if (!g.lgBusy) {
          if (this.s.download) {
            var j;
            j = g.s.dynamic ? g.s.dynamicEl[b].downloadUrl !== !1 && (g.s.dynamicEl[b].downloadUrl || g.s.dynamicEl[b].src) : "false" !== g.$items.eq(b).attr("data-download-url") && (g.$items.eq(b).attr("data-download-url") || g.$items.eq(b).attr("href") || g.$items.eq(b).attr("data-src")), j ? (a("#lg-download").attr("href", j), g.$outer.removeClass("lg-hide-download")) : g.$outer.addClass("lg-hide-download");
          }

          if (this.$el.trigger("onBeforeSlide.lg", [f, b, c, d]), g.lgBusy = !0, clearTimeout(g.hideBartimeout), ".lg-sub-html" === this.s.appendSubHtmlTo && setTimeout(function () {
            g.addHtml(b);
          }, i), this.arrowDisable(b), e || (b < f ? e = "prev" : b > f && (e = "next")), c) {
            this.$slide.removeClass("lg-prev-slide lg-current lg-next-slide");
            var k, l;
            h > 2 ? (k = b - 1, l = b + 1, 0 === b && f === h - 1 ? (l = 0, k = h - 1) : b === h - 1 && 0 === f && (l = 0, k = h - 1)) : (k = 0, l = 1), "prev" === e ? g.$slide.eq(l).addClass("lg-next-slide") : g.$slide.eq(k).addClass("lg-prev-slide"), g.$slide.eq(b).addClass("lg-current");
          } else g.$outer.addClass("lg-no-trans"), this.$slide.removeClass("lg-prev-slide lg-next-slide"), "prev" === e ? (this.$slide.eq(b).addClass("lg-prev-slide"), this.$slide.eq(f).addClass("lg-next-slide")) : (this.$slide.eq(b).addClass("lg-next-slide"), this.$slide.eq(f).addClass("lg-prev-slide")), setTimeout(function () {
            g.$slide.removeClass("lg-current"), g.$slide.eq(b).addClass("lg-current"), g.$outer.removeClass("lg-no-trans");
          }, 50);

          g.lGalleryOn ? (setTimeout(function () {
            g.loadContent(b, !0, 0);
          }, this.s.speed + 50), setTimeout(function () {
            g.lgBusy = !1, g.$el.trigger("onAfterSlide.lg", [f, b, c, d]);
          }, this.s.speed)) : (g.loadContent(b, !0, g.s.backdropDuration), g.lgBusy = !1, g.$el.trigger("onAfterSlide.lg", [f, b, c, d])), g.lGalleryOn = !0, this.s.counter && a("#lg-counter-current").text(b + 1);
        }

        g.index = b;
      }
    }, b.prototype.goToNextSlide = function (a) {
      var b = this,
          c = b.s.loop;
      a && b.$slide.length < 3 && (c = !1), b.lgBusy || (b.index + 1 < b.$slide.length ? (b.index++, b.$el.trigger("onBeforeNextSlide.lg", [b.index]), b.slide(b.index, a, !1, "next")) : c ? (b.index = 0, b.$el.trigger("onBeforeNextSlide.lg", [b.index]), b.slide(b.index, a, !1, "next")) : b.s.slideEndAnimatoin && !a && (b.$outer.addClass("lg-right-end"), setTimeout(function () {
        b.$outer.removeClass("lg-right-end");
      }, 400)));
    }, b.prototype.goToPrevSlide = function (a) {
      var b = this,
          c = b.s.loop;
      a && b.$slide.length < 3 && (c = !1), b.lgBusy || (b.index > 0 ? (b.index--, b.$el.trigger("onBeforePrevSlide.lg", [b.index, a]), b.slide(b.index, a, !1, "prev")) : c ? (b.index = b.$items.length - 1, b.$el.trigger("onBeforePrevSlide.lg", [b.index, a]), b.slide(b.index, a, !1, "prev")) : b.s.slideEndAnimatoin && !a && (b.$outer.addClass("lg-left-end"), setTimeout(function () {
        b.$outer.removeClass("lg-left-end");
      }, 400)));
    }, b.prototype.keyPress = function () {
      var b = this;
      this.$items.length > 1 && a(window).on("keyup.lg", function (a) {
        b.$items.length > 1 && (37 === a.keyCode && (a.preventDefault(), b.goToPrevSlide()), 39 === a.keyCode && (a.preventDefault(), b.goToNextSlide()));
      }), a(window).on("keydown.lg", function (a) {
        b.s.escKey === !0 && 27 === a.keyCode && (a.preventDefault(), b.$outer.hasClass("lg-thumb-open") ? b.$outer.removeClass("lg-thumb-open") : b.destroy());
      });
    }, b.prototype.arrow = function () {
      var a = this;
      this.$outer.find(".lg-prev").on("click.lg", function () {
        a.goToPrevSlide();
      }), this.$outer.find(".lg-next").on("click.lg", function () {
        a.goToNextSlide();
      });
    }, b.prototype.arrowDisable = function (a) {
      !this.s.loop && this.s.hideControlOnEnd && (a + 1 < this.$slide.length ? this.$outer.find(".lg-next").removeAttr("disabled").removeClass("disabled") : this.$outer.find(".lg-next").attr("disabled", "disabled").addClass("disabled"), a > 0 ? this.$outer.find(".lg-prev").removeAttr("disabled").removeClass("disabled") : this.$outer.find(".lg-prev").attr("disabled", "disabled").addClass("disabled"));
    }, b.prototype.setTranslate = function (a, b, c) {
      this.s.useLeft ? a.css("left", b) : a.css({
        transform: "translate3d(" + b + "px, " + c + "px, 0px)"
      });
    }, b.prototype.touchMove = function (b, c) {
      var d = c - b;
      Math.abs(d) > 15 && (this.$outer.addClass("lg-dragging"), this.setTranslate(this.$slide.eq(this.index), d, 0), this.setTranslate(a(".lg-prev-slide"), -this.$slide.eq(this.index).width() + d, 0), this.setTranslate(a(".lg-next-slide"), this.$slide.eq(this.index).width() + d, 0));
    }, b.prototype.touchEnd = function (a) {
      var b = this;
      "lg-slide" !== b.s.mode && b.$outer.addClass("lg-slide"), this.$slide.not(".lg-current, .lg-prev-slide, .lg-next-slide").css("opacity", "0"), setTimeout(function () {
        b.$outer.removeClass("lg-dragging"), a < 0 && Math.abs(a) > b.s.swipeThreshold ? b.goToNextSlide(!0) : a > 0 && Math.abs(a) > b.s.swipeThreshold ? b.goToPrevSlide(!0) : Math.abs(a) < 5 && b.$el.trigger("onSlideClick.lg"), b.$slide.removeAttr("style");
      }), setTimeout(function () {
        b.$outer.hasClass("lg-dragging") || "lg-slide" === b.s.mode || b.$outer.removeClass("lg-slide");
      }, b.s.speed + 100);
    }, b.prototype.enableSwipe = function () {
      var a = this,
          b = 0,
          c = 0,
          d = !1;
      a.s.enableSwipe && a.doCss() && (a.$slide.on("touchstart.lg", function (c) {
        a.$outer.hasClass("lg-zoomed") || a.lgBusy || (c.preventDefault(), a.manageSwipeClass(), b = c.originalEvent.targetTouches[0].pageX);
      }), a.$slide.on("touchmove.lg", function (e) {
        a.$outer.hasClass("lg-zoomed") || (e.preventDefault(), c = e.originalEvent.targetTouches[0].pageX, a.touchMove(b, c), d = !0);
      }), a.$slide.on("touchend.lg", function () {
        a.$outer.hasClass("lg-zoomed") || (d ? (d = !1, a.touchEnd(c - b)) : a.$el.trigger("onSlideClick.lg"));
      }));
    }, b.prototype.enableDrag = function () {
      var b = this,
          c = 0,
          d = 0,
          e = !1,
          f = !1;
      b.s.enableDrag && b.doCss() && (b.$outer.on("mousedown.lg", function (d) {
        b.$outer.hasClass("lg-zoomed") || b.lgBusy || a(d.target).text() || (d.preventDefault(), b.manageSwipeClass(), c = d.pageX, e = !0, b.$outer.scrollLeft += 1, b.$outer.scrollLeft -= 1, b.$outer.removeClass("lg-grab").addClass("lg-grabbing"), b.$el.trigger("onDragstart.lg"));
      }), a(window).on("mousemove.lg", function (a) {
        e && (f = !0, d = a.pageX, b.touchMove(c, d), b.$el.trigger("onDragmove.lg"));
      }), a(window).on("mouseup.lg", function (g) {
        f ? (f = !1, b.touchEnd(d - c), b.$el.trigger("onDragend.lg")) : (a(g.target).hasClass("lg-object") || a(g.target).hasClass("lg-video-play")) && b.$el.trigger("onSlideClick.lg"), e && (e = !1, b.$outer.removeClass("lg-grabbing").addClass("lg-grab"));
      }));
    }, b.prototype.manageSwipeClass = function () {
      var a = this.index + 1,
          b = this.index - 1;
      this.s.loop && this.$slide.length > 2 && (0 === this.index ? b = this.$slide.length - 1 : this.index === this.$slide.length - 1 && (a = 0)), this.$slide.removeClass("lg-next-slide lg-prev-slide"), b > -1 && this.$slide.eq(b).addClass("lg-prev-slide"), this.$slide.eq(a).addClass("lg-next-slide");
    }, b.prototype.mousewheel = function () {
      var a = this;
      a.$outer.on("mousewheel.lg", function (b) {
        b.deltaY && (b.deltaY > 0 ? a.goToPrevSlide() : a.goToNextSlide(), b.preventDefault());
      });
    }, b.prototype.closeGallery = function () {
      var b = this,
          c = !1;
      this.$outer.find(".lg-close").on("click.lg", function () {
        b.destroy();
      }), b.s.closable && (b.$outer.on("mousedown.lg", function (b) {
        c = !!(a(b.target).is(".lg-outer") || a(b.target).is(".lg-item ") || a(b.target).is(".lg-img-wrap"));
      }), b.$outer.on("mousemove.lg", function () {
        c = !1;
      }), b.$outer.on("mouseup.lg", function (d) {
        (a(d.target).is(".lg-outer") || a(d.target).is(".lg-item ") || a(d.target).is(".lg-img-wrap") && c) && (b.$outer.hasClass("lg-dragging") || b.destroy());
      }));
    }, b.prototype.destroy = function (b) {
      var c = this;
      b || (c.$el.trigger("onBeforeClose.lg"), a(window).scrollTop(c.prevScrollTop)), b && (c.s.dynamic || this.$items.off("click.lg click.lgcustom"), a.removeData(c.el, "lightGallery")), this.$el.off(".lg.tm"), a.each(a.fn.lightGallery.modules, function (a) {
        c.modules[a] && c.modules[a].destroy();
      }), this.lGalleryOn = !1, clearTimeout(c.hideBartimeout), this.hideBartimeout = !1, a(window).off(".lg"), a("body").removeClass("lg-on lg-from-hash"), c.$outer && c.$outer.removeClass("lg-visible"), a(".lg-backdrop").removeClass("in"), setTimeout(function () {
        c.$outer && c.$outer.remove(), a(".lg-backdrop").remove(), b || c.$el.trigger("onCloseAfter.lg");
      }, c.s.backdropDuration + 50);
    }, a.fn.lightGallery = function (c) {
      return this.each(function () {
        if (a.data(this, "lightGallery")) try {
          a(this).data("lightGallery").init();
        } catch (a) {
          console.error("lightGallery has not initiated properly");
        } else a.data(this, "lightGallery", new b(this, c));
      });
    }, a.fn.lightGallery.modules = {};
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = {
      autoplay: !1,
      pause: 5e3,
      progressBar: !0,
      fourceAutoplay: !1,
      autoplayControls: !0,
      appendAutoplayControlsTo: ".lg-toolbar"
    },
        c = function c(_c) {
      return this.core = a(_c).data("lightGallery"), this.$el = a(_c), !(this.core.$items.length < 2) && (this.core.s = a.extend({}, b, this.core.s), this.interval = !1, this.fromAuto = !0, this.canceledOnTouch = !1, this.fourceAutoplayTemp = this.core.s.fourceAutoplay, this.core.doCss() || (this.core.s.progressBar = !1), this.init(), this);
    };

    c.prototype.init = function () {
      var a = this;
      a.core.s.autoplayControls && a.controls(), a.core.s.progressBar && a.core.$outer.find(".lg").append('<div class="lg-progress-bar"><div class="lg-progress"></div></div>'), a.progress(), a.core.s.autoplay && a.$el.one("onSlideItemLoad.lg.tm", function () {
        a.startlAuto();
      }), a.$el.on("onDragstart.lg.tm touchstart.lg.tm", function () {
        a.interval && (a.cancelAuto(), a.canceledOnTouch = !0);
      }), a.$el.on("onDragend.lg.tm touchend.lg.tm onSlideClick.lg.tm", function () {
        !a.interval && a.canceledOnTouch && (a.startlAuto(), a.canceledOnTouch = !1);
      });
    }, c.prototype.progress = function () {
      var a,
          b,
          c = this;
      c.$el.on("onBeforeSlide.lg.tm", function () {
        c.core.s.progressBar && c.fromAuto && (a = c.core.$outer.find(".lg-progress-bar"), b = c.core.$outer.find(".lg-progress"), c.interval && (b.removeAttr("style"), a.removeClass("lg-start"), setTimeout(function () {
          b.css("transition", "width " + (c.core.s.speed + c.core.s.pause) + "ms ease 0s"), a.addClass("lg-start");
        }, 20))), c.fromAuto || c.core.s.fourceAutoplay || c.cancelAuto(), c.fromAuto = !1;
      });
    }, c.prototype.controls = function () {
      var b = this,
          c = '<span class="lg-autoplay-button lg-icon"></span>';
      a(this.core.s.appendAutoplayControlsTo).append(c), b.core.$outer.find(".lg-autoplay-button").on("click.lg", function () {
        a(b.core.$outer).hasClass("lg-show-autoplay") ? (b.cancelAuto(), b.core.s.fourceAutoplay = !1) : b.interval || (b.startlAuto(), b.core.s.fourceAutoplay = b.fourceAutoplayTemp);
      });
    }, c.prototype.startlAuto = function () {
      var a = this;
      a.core.$outer.find(".lg-progress").css("transition", "width " + (a.core.s.speed + a.core.s.pause) + "ms ease 0s"), a.core.$outer.addClass("lg-show-autoplay"), a.core.$outer.find(".lg-progress-bar").addClass("lg-start"), a.interval = setInterval(function () {
        a.core.index + 1 < a.core.$items.length ? a.core.index++ : a.core.index = 0, a.fromAuto = !0, a.core.slide(a.core.index, !1, !1, "next");
      }, a.core.s.speed + a.core.s.pause);
    }, c.prototype.cancelAuto = function () {
      clearInterval(this.interval), this.interval = !1, this.core.$outer.find(".lg-progress").removeAttr("style"), this.core.$outer.removeClass("lg-show-autoplay"), this.core.$outer.find(".lg-progress-bar").removeClass("lg-start");
    }, c.prototype.destroy = function () {
      this.cancelAuto(), this.core.$outer.find(".lg-progress-bar").remove();
    }, a.fn.lightGallery.modules.autoplay = c;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = {
      fullScreen: !0
    },
        c = function c(_c2) {
      return this.core = a(_c2).data("lightGallery"), this.$el = a(_c2), this.core.s = a.extend({}, b, this.core.s), this.init(), this;
    };

    c.prototype.init = function () {
      var a = "";

      if (this.core.s.fullScreen) {
        if (!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled)) return;
        a = '<span class="lg-fullscreen lg-icon"></span>', this.core.$outer.find(".lg-toolbar").append(a), this.fullScreen();
      }
    }, c.prototype.requestFullscreen = function () {
      var a = document.documentElement;
      a.requestFullscreen ? a.requestFullscreen() : a.msRequestFullscreen ? a.msRequestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.webkitRequestFullscreen && a.webkitRequestFullscreen();
    }, c.prototype.exitFullscreen = function () {
      document.exitFullscreen ? document.exitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
    }, c.prototype.fullScreen = function () {
      var b = this;
      a(document).on("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg", function () {
        b.core.$outer.toggleClass("lg-fullscreen-on");
      }), this.core.$outer.find(".lg-fullscreen").on("click.lg", function () {
        document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement ? b.exitFullscreen() : b.requestFullscreen();
      });
    }, c.prototype.destroy = function () {
      this.exitFullscreen(), a(document).off("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg");
    }, a.fn.lightGallery.modules.fullscreen = c;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = {
      pager: !1
    },
        c = function c(_c3) {
      return this.core = a(_c3).data("lightGallery"), this.$el = a(_c3), this.core.s = a.extend({}, b, this.core.s), this.core.s.pager && this.core.$items.length > 1 && this.init(), this;
    };

    c.prototype.init = function () {
      var b,
          c,
          d,
          e = this,
          f = "";
      if (e.core.$outer.find(".lg").append('<div class="lg-pager-outer"></div>'), e.core.s.dynamic) for (var g = 0; g < e.core.s.dynamicEl.length; g++) {
        f += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + e.core.s.dynamicEl[g].thumb + '" /></div></span>';
      } else e.core.$items.each(function () {
        f += e.core.s.exThumbImage ? '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + a(this).attr(e.core.s.exThumbImage) + '" /></div></span>' : '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + a(this).find("img").attr("src") + '" /></div></span>';
      });
      c = e.core.$outer.find(".lg-pager-outer"), c.html(f), b = e.core.$outer.find(".lg-pager-cont"), b.on("click.lg touchend.lg", function () {
        var b = a(this);
        e.core.index = b.index(), e.core.slide(e.core.index, !1, !0, !1);
      }), c.on("mouseover.lg", function () {
        clearTimeout(d), c.addClass("lg-pager-hover");
      }), c.on("mouseout.lg", function () {
        d = setTimeout(function () {
          c.removeClass("lg-pager-hover");
        });
      }), e.core.$el.on("onBeforeSlide.lg.tm", function (a, c, d) {
        b.removeClass("lg-pager-active"), b.eq(d).addClass("lg-pager-active");
      });
    }, c.prototype.destroy = function () {}, a.fn.lightGallery.modules.pager = c;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = {
      thumbnail: !0,
      animateThumb: !0,
      currentPagerPosition: "middle",
      thumbWidth: 100,
      thumbHeight: "80px",
      thumbContHeight: 100,
      thumbMargin: 5,
      exThumbImage: !1,
      showThumbByDefault: !0,
      toogleThumb: !0,
      pullCaptionUp: !0,
      enableThumbDrag: !0,
      enableThumbSwipe: !0,
      swipeThreshold: 50,
      loadYoutubeThumbnail: !0,
      youtubeThumbSize: 1,
      loadVimeoThumbnail: !0,
      vimeoThumbSize: "thumbnail_small",
      loadDailymotionThumbnail: !0
    },
        c = function c(_c4) {
      return this.core = a(_c4).data("lightGallery"), this.core.s = a.extend({}, b, this.core.s), this.$el = a(_c4), this.$thumbOuter = null, this.thumbOuterWidth = 0, this.thumbTotalWidth = this.core.$items.length * (this.core.s.thumbWidth + this.core.s.thumbMargin), this.thumbIndex = this.core.index, this.core.s.animateThumb && (this.core.s.thumbHeight = "100%"), this.left = 0, this.init(), this;
    };

    c.prototype.init = function () {
      var a = this;
      this.core.s.thumbnail && this.core.$items.length > 1 && (this.core.s.showThumbByDefault && setTimeout(function () {
        a.core.$outer.addClass("lg-thumb-open");
      }, 700), this.core.s.pullCaptionUp && this.core.$outer.addClass("lg-pull-caption-up"), this.build(), this.core.s.animateThumb && this.core.doCss() ? (this.core.s.enableThumbDrag && this.enableThumbDrag(), this.core.s.enableThumbSwipe && this.enableThumbSwipe(), this.thumbClickable = !1) : this.thumbClickable = !0, this.toogle(), this.thumbkeyPress());
    }, c.prototype.build = function () {
      function b(a, b, c) {
        var g,
            h = d.core.isVideo(a, c) || {},
            i = "";
        h.youtube || h.vimeo || h.dailymotion ? h.youtube ? g = d.core.s.loadYoutubeThumbnail ? "//img.youtube.com/vi/" + h.youtube[1] + "/" + d.core.s.youtubeThumbSize + ".jpg" : b : h.vimeo ? d.core.s.loadVimeoThumbnail ? (g = "//i.vimeocdn.com/video/error_" + f + ".jpg", i = h.vimeo[1]) : g = b : h.dailymotion && (g = d.core.s.loadDailymotionThumbnail ? "//www.dailymotion.com/thumbnail/video/" + h.dailymotion[1] : b) : g = b, e += '<div data-vimeo-id="' + i + '" class="lg-thumb-item" style="width:' + d.core.s.thumbWidth + "px; height: " + d.core.s.thumbHeight + "; margin-right: " + d.core.s.thumbMargin + 'px"><img src="' + g + '" /></div>', i = "";
      }

      var c,
          d = this,
          e = "",
          f = "",
          g = '<div class="lg-thumb-outer"><div class="lg-thumb lg-group"></div></div>';

      switch (this.core.s.vimeoThumbSize) {
        case "thumbnail_large":
          f = "640";
          break;

        case "thumbnail_medium":
          f = "200x150";
          break;

        case "thumbnail_small":
          f = "100x75";
      }

      if (d.core.$outer.addClass("lg-has-thumb"), d.core.$outer.find(".lg").append(g), d.$thumbOuter = d.core.$outer.find(".lg-thumb-outer"), d.thumbOuterWidth = d.$thumbOuter.width(), d.core.s.animateThumb && d.core.$outer.find(".lg-thumb").css({
        width: d.thumbTotalWidth + "px",
        position: "relative"
      }), this.core.s.animateThumb && d.$thumbOuter.css("height", d.core.s.thumbContHeight + "px"), d.core.s.dynamic) for (var h = 0; h < d.core.s.dynamicEl.length; h++) {
        b(d.core.s.dynamicEl[h].src, d.core.s.dynamicEl[h].thumb, h);
      } else d.core.$items.each(function (c) {
        d.core.s.exThumbImage ? b(a(this).attr("href") || a(this).attr("data-src"), a(this).attr(d.core.s.exThumbImage), c) : b(a(this).attr("href") || a(this).attr("data-src"), a(this).find("img").attr("src"), c);
      });
      d.core.$outer.find(".lg-thumb").html(e), c = d.core.$outer.find(".lg-thumb-item"), c.each(function () {
        var b = a(this),
            c = b.attr("data-vimeo-id");
        c && a.getJSON("//www.vimeo.com/api/v2/video/" + c + ".json?callback=?", {
          format: "json"
        }, function (a) {
          b.find("img").attr("src", a[0][d.core.s.vimeoThumbSize]);
        });
      }), c.eq(d.core.index).addClass("active"), d.core.$el.on("onBeforeSlide.lg.tm", function () {
        c.removeClass("active"), c.eq(d.core.index).addClass("active");
      }), c.on("click.lg touchend.lg", function () {
        var b = a(this);
        setTimeout(function () {
          (d.thumbClickable && !d.core.lgBusy || !d.core.doCss()) && (d.core.index = b.index(), d.core.slide(d.core.index, !1, !0, !1));
        }, 50);
      }), d.core.$el.on("onBeforeSlide.lg.tm", function () {
        d.animateThumb(d.core.index);
      }), a(window).on("resize.lg.thumb orientationchange.lg.thumb", function () {
        setTimeout(function () {
          d.animateThumb(d.core.index), d.thumbOuterWidth = d.$thumbOuter.width();
        }, 200);
      });
    }, c.prototype.setTranslate = function (a) {
      this.core.$outer.find(".lg-thumb").css({
        transform: "translate3d(-" + a + "px, 0px, 0px)"
      });
    }, c.prototype.animateThumb = function (a) {
      var b = this.core.$outer.find(".lg-thumb");

      if (this.core.s.animateThumb) {
        var c;

        switch (this.core.s.currentPagerPosition) {
          case "left":
            c = 0;
            break;

          case "middle":
            c = this.thumbOuterWidth / 2 - this.core.s.thumbWidth / 2;
            break;

          case "right":
            c = this.thumbOuterWidth - this.core.s.thumbWidth;
        }

        this.left = (this.core.s.thumbWidth + this.core.s.thumbMargin) * a - 1 - c, this.left > this.thumbTotalWidth - this.thumbOuterWidth && (this.left = this.thumbTotalWidth - this.thumbOuterWidth), this.left < 0 && (this.left = 0), this.core.lGalleryOn ? (b.hasClass("on") || this.core.$outer.find(".lg-thumb").css("transition-duration", this.core.s.speed + "ms"), this.core.doCss() || b.animate({
          left: -this.left + "px"
        }, this.core.s.speed)) : this.core.doCss() || b.css("left", -this.left + "px"), this.setTranslate(this.left);
      }
    }, c.prototype.enableThumbDrag = function () {
      var b = this,
          c = 0,
          d = 0,
          e = !1,
          f = !1,
          g = 0;
      b.$thumbOuter.addClass("lg-grab"), b.core.$outer.find(".lg-thumb").on("mousedown.lg.thumb", function (a) {
        b.thumbTotalWidth > b.thumbOuterWidth && (a.preventDefault(), c = a.pageX, e = !0, b.core.$outer.scrollLeft += 1, b.core.$outer.scrollLeft -= 1, b.thumbClickable = !1, b.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"));
      }), a(window).on("mousemove.lg.thumb", function (a) {
        e && (g = b.left, f = !0, d = a.pageX, b.$thumbOuter.addClass("lg-dragging"), g -= d - c, g > b.thumbTotalWidth - b.thumbOuterWidth && (g = b.thumbTotalWidth - b.thumbOuterWidth), g < 0 && (g = 0), b.setTranslate(g));
      }), a(window).on("mouseup.lg.thumb", function () {
        f ? (f = !1, b.$thumbOuter.removeClass("lg-dragging"), b.left = g, Math.abs(d - c) < b.core.s.swipeThreshold && (b.thumbClickable = !0)) : b.thumbClickable = !0, e && (e = !1, b.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab"));
      });
    }, c.prototype.enableThumbSwipe = function () {
      var a = this,
          b = 0,
          c = 0,
          d = !1,
          e = 0;
      a.core.$outer.find(".lg-thumb").on("touchstart.lg", function (c) {
        a.thumbTotalWidth > a.thumbOuterWidth && (c.preventDefault(), b = c.originalEvent.targetTouches[0].pageX, a.thumbClickable = !1);
      }), a.core.$outer.find(".lg-thumb").on("touchmove.lg", function (f) {
        a.thumbTotalWidth > a.thumbOuterWidth && (f.preventDefault(), c = f.originalEvent.targetTouches[0].pageX, d = !0, a.$thumbOuter.addClass("lg-dragging"), e = a.left, e -= c - b, e > a.thumbTotalWidth - a.thumbOuterWidth && (e = a.thumbTotalWidth - a.thumbOuterWidth), e < 0 && (e = 0), a.setTranslate(e));
      }), a.core.$outer.find(".lg-thumb").on("touchend.lg", function () {
        a.thumbTotalWidth > a.thumbOuterWidth && d ? (d = !1, a.$thumbOuter.removeClass("lg-dragging"), Math.abs(c - b) < a.core.s.swipeThreshold && (a.thumbClickable = !0), a.left = e) : a.thumbClickable = !0;
      });
    }, c.prototype.toogle = function () {
      var a = this;
      a.core.s.toogleThumb && (a.core.$outer.addClass("lg-can-toggle"), a.$thumbOuter.append('<span class="lg-toogle-thumb lg-icon"></span>'), a.core.$outer.find(".lg-toogle-thumb").on("click.lg", function () {
        a.core.$outer.toggleClass("lg-thumb-open");
      }));
    }, c.prototype.thumbkeyPress = function () {
      var b = this;
      a(window).on("keydown.lg.thumb", function (a) {
        38 === a.keyCode ? (a.preventDefault(), b.core.$outer.addClass("lg-thumb-open")) : 40 === a.keyCode && (a.preventDefault(), b.core.$outer.removeClass("lg-thumb-open"));
      });
    }, c.prototype.destroy = function () {
      this.core.s.thumbnail && this.core.$items.length > 1 && (a(window).off("resize.lg.thumb orientationchange.lg.thumb keydown.lg.thumb"), this.$thumbOuter.remove(), this.core.$outer.removeClass("lg-has-thumb"));
    }, a.fn.lightGallery.modules.Thumbnail = c;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    function b(a, b, c, d) {
      var e = this;
      if (e.core.$slide.eq(b).find(".lg-video").append(e.loadVideo(c, "lg-object", !0, b, d)), d) if (e.core.s.videojs) try {
        videojs(e.core.$slide.eq(b).find(".lg-html5").get(0), e.core.s.videojsOptions, function () {
          !e.videoLoaded && e.core.s.autoplayFirstVideo && this.play();
        });
      } catch (a) {
        console.error("Make sure you have included videojs");
      } else !e.videoLoaded && e.core.s.autoplayFirstVideo && e.core.$slide.eq(b).find(".lg-html5").get(0).play();
    }

    function c(a, b) {
      var c = this.core.$slide.eq(b).find(".lg-video-cont");
      c.hasClass("lg-has-iframe") || (c.css("max-width", this.core.s.videoMaxWidth), this.videoLoaded = !0);
    }

    function d(b, c, d) {
      var e = this,
          f = e.core.$slide.eq(c),
          g = f.find(".lg-youtube").get(0),
          h = f.find(".lg-vimeo").get(0),
          i = f.find(".lg-dailymotion").get(0),
          j = f.find(".lg-vk").get(0),
          k = f.find(".lg-html5").get(0);
      if (g) g.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");else if (h) try {
        $f(h).api("pause");
      } catch (a) {
        console.error("Make sure you have included froogaloop2 js");
      } else if (i) i.contentWindow.postMessage("pause", "*");else if (k) if (e.core.s.videojs) try {
        videojs(k).pause();
      } catch (a) {
        console.error("Make sure you have included videojs");
      } else k.pause();
      j && a(j).attr("src", a(j).attr("src").replace("&autoplay", "&noplay"));
      var l;
      l = e.core.s.dynamic ? e.core.s.dynamicEl[d].src : e.core.$items.eq(d).attr("href") || e.core.$items.eq(d).attr("data-src");
      var m = e.core.isVideo(l, d) || {};
      (m.youtube || m.vimeo || m.dailymotion || m.vk) && e.core.$outer.addClass("lg-hide-download");
    }

    var e = {
      videoMaxWidth: "855px",
      autoplayFirstVideo: !0,
      youtubePlayerParams: !1,
      vimeoPlayerParams: !1,
      dailymotionPlayerParams: !1,
      vkPlayerParams: !1,
      videojs: !1,
      videojsOptions: {}
    },
        f = function f(b) {
      return this.core = a(b).data("lightGallery"), this.$el = a(b), this.core.s = a.extend({}, e, this.core.s), this.videoLoaded = !1, this.init(), this;
    };

    f.prototype.init = function () {
      var e = this;
      e.core.$el.on("hasVideo.lg.tm", b.bind(this)), e.core.$el.on("onAferAppendSlide.lg.tm", c.bind(this)), e.core.doCss() && e.core.$items.length > 1 && (e.core.s.enableSwipe || e.core.s.enableDrag) ? e.core.$el.on("onSlideClick.lg.tm", function () {
        var a = e.core.$slide.eq(e.core.index);
        e.loadVideoOnclick(a);
      }) : e.core.$slide.on("click.lg", function () {
        e.loadVideoOnclick(a(this));
      }), e.core.$el.on("onBeforeSlide.lg.tm", d.bind(this)), e.core.$el.on("onAfterSlide.lg.tm", function (a, b) {
        e.core.$slide.eq(b).removeClass("lg-video-playing");
      });
    }, f.prototype.loadVideo = function (b, c, d, e, f) {
      var g = "",
          h = 1,
          i = "",
          j = this.core.isVideo(b, e) || {};
      if (d && (h = this.videoLoaded ? 0 : this.core.s.autoplayFirstVideo ? 1 : 0), j.youtube) i = "?wmode=opaque&autoplay=" + h + "&enablejsapi=1", this.core.s.youtubePlayerParams && (i = i + "&" + a.param(this.core.s.youtubePlayerParams)), g = '<iframe class="lg-video-object lg-youtube ' + c + '" width="560" height="315" src="//www.youtube.com/embed/' + j.youtube[1] + i + '" frameborder="0" allowfullscreen></iframe>';else if (j.vimeo) i = "?autoplay=" + h + "&api=1", this.core.s.vimeoPlayerParams && (i = i + "&" + a.param(this.core.s.vimeoPlayerParams)), g = '<iframe class="lg-video-object lg-vimeo ' + c + '" width="560" height="315"  src="//player.vimeo.com/video/' + j.vimeo[1] + i + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';else if (j.dailymotion) i = "?wmode=opaque&autoplay=" + h + "&api=postMessage", this.core.s.dailymotionPlayerParams && (i = i + "&" + a.param(this.core.s.dailymotionPlayerParams)), g = '<iframe class="lg-video-object lg-dailymotion ' + c + '" width="560" height="315" src="//www.dailymotion.com/embed/video/' + j.dailymotion[1] + i + '" frameborder="0" allowfullscreen></iframe>';else if (j.html5) {
        var k = f.substring(0, 1);
        "." !== k && "#" !== k || (f = a(f).html()), g = f;
      } else j.vk && (i = "&autoplay=" + h, this.core.s.vkPlayerParams && (i = i + "&" + a.param(this.core.s.vkPlayerParams)), g = '<iframe class="lg-video-object lg-vk ' + c + '" width="560" height="315" src="http://vk.com/video_ext.php?' + j.vk[1] + i + '" frameborder="0" allowfullscreen></iframe>');
      return g;
    }, f.prototype.loadVideoOnclick = function (a) {
      var b = this;
      if (a.find(".lg-object").hasClass("lg-has-poster") && a.find(".lg-object").is(":visible")) if (a.hasClass("lg-has-video")) {
        var c = a.find(".lg-youtube").get(0),
            d = a.find(".lg-vimeo").get(0),
            e = a.find(".lg-dailymotion").get(0),
            f = a.find(".lg-html5").get(0);
        if (c) c.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");else if (d) try {
          $f(d).api("play");
        } catch (a) {
          console.error("Make sure you have included froogaloop2 js");
        } else if (e) e.contentWindow.postMessage("play", "*");else if (f) if (b.core.s.videojs) try {
          videojs(f).play();
        } catch (a) {
          console.error("Make sure you have included videojs");
        } else f.play();
        a.addClass("lg-video-playing");
      } else {
        a.addClass("lg-video-playing lg-has-video");

        var g,
            h,
            i = function i(c, d) {
          if (a.find(".lg-video").append(b.loadVideo(c, "", !1, b.core.index, d)), d) if (b.core.s.videojs) try {
            videojs(b.core.$slide.eq(b.core.index).find(".lg-html5").get(0), b.core.s.videojsOptions, function () {
              this.play();
            });
          } catch (a) {
            console.error("Make sure you have included videojs");
          } else b.core.$slide.eq(b.core.index).find(".lg-html5").get(0).play();
        };

        b.core.s.dynamic ? (g = b.core.s.dynamicEl[b.core.index].src, h = b.core.s.dynamicEl[b.core.index].html, i(g, h)) : (g = b.core.$items.eq(b.core.index).attr("href") || b.core.$items.eq(b.core.index).attr("data-src"), h = b.core.$items.eq(b.core.index).attr("data-html"), i(g, h));
        var j = a.find(".lg-object");
        a.find(".lg-video").append(j), a.find(".lg-video-object").hasClass("lg-html5") || (a.removeClass("lg-complete"), a.find(".lg-video-object").on("load.lg error.lg", function () {
          a.addClass("lg-complete");
        }));
      }
    }, f.prototype.destroy = function () {
      this.videoLoaded = !1;
    }, a.fn.lightGallery.modules.video = f;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = function b() {
      var a = !1,
          b = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
      return b && parseInt(b[2], 10) < 54 && (a = !0), a;
    },
        c = {
      scale: 1,
      zoom: !0,
      actualSize: !0,
      enableZoomAfter: 300,
      useLeftForZoom: b()
    },
        d = function d(b) {
      return this.core = a(b).data("lightGallery"), this.core.s = a.extend({}, c, this.core.s), this.core.s.zoom && this.core.doCss() && (this.init(), this.zoomabletimeout = !1, this.pageX = a(window).width() / 2, this.pageY = a(window).height() / 2 + a(window).scrollTop()), this;
    };

    d.prototype.init = function () {
      var b = this,
          c = '<span id="lg-zoom-in" class="lg-icon"></span><span id="lg-zoom-out" class="lg-icon"></span>';
      b.core.s.actualSize && (c += '<span id="lg-actual-size" class="lg-icon"></span>'), b.core.s.useLeftForZoom ? b.core.$outer.addClass("lg-use-left-for-zoom") : b.core.$outer.addClass("lg-use-transition-for-zoom"), this.core.$outer.find(".lg-toolbar").append(c), b.core.$el.on("onSlideItemLoad.lg.tm.zoom", function (c, d, e) {
        var f = b.core.s.enableZoomAfter + e;
        a("body").hasClass("lg-from-hash") && e ? f = 0 : a("body").removeClass("lg-from-hash"), b.zoomabletimeout = setTimeout(function () {
          b.core.$slide.eq(d).addClass("lg-zoomable");
        }, f + 30);
      });

      var d = 1,
          e = function e(c) {
        var d,
            e,
            f = b.core.$outer.find(".lg-current .lg-image"),
            g = (a(window).width() - f.prop("offsetWidth")) / 2,
            h = (a(window).height() - f.prop("offsetHeight")) / 2 + a(window).scrollTop();
        d = b.pageX - g, e = b.pageY - h;
        var i = (c - 1) * d,
            j = (c - 1) * e;
        f.css("transform", "scale3d(" + c + ", " + c + ", 1)").attr("data-scale", c), b.core.s.useLeftForZoom ? f.parent().css({
          left: -i + "px",
          top: -j + "px"
        }).attr("data-x", i).attr("data-y", j) : f.parent().css("transform", "translate3d(-" + i + "px, -" + j + "px, 0)").attr("data-x", i).attr("data-y", j);
      },
          f = function f() {
        d > 1 ? b.core.$outer.addClass("lg-zoomed") : b.resetZoom(), d < 1 && (d = 1), e(d);
      },
          g = function g(c, e, _g, h) {
        var i,
            j = e.prop("offsetWidth");
        i = b.core.s.dynamic ? b.core.s.dynamicEl[_g].width || e[0].naturalWidth || j : b.core.$items.eq(_g).attr("data-width") || e[0].naturalWidth || j;
        var k;
        b.core.$outer.hasClass("lg-zoomed") ? d = 1 : i > j && (k = i / j, d = k || 2), h ? (b.pageX = a(window).width() / 2, b.pageY = a(window).height() / 2 + a(window).scrollTop()) : (b.pageX = c.pageX || c.originalEvent.targetTouches[0].pageX, b.pageY = c.pageY || c.originalEvent.targetTouches[0].pageY), f(), setTimeout(function () {
          b.core.$outer.removeClass("lg-grabbing").addClass("lg-grab");
        }, 10);
      },
          h = !1;

      b.core.$el.on("onAferAppendSlide.lg.tm.zoom", function (a, c) {
        var d = b.core.$slide.eq(c).find(".lg-image");
        d.on("dblclick", function (a) {
          g(a, d, c);
        }), d.on("touchstart", function (a) {
          h ? (clearTimeout(h), h = null, g(a, d, c)) : h = setTimeout(function () {
            h = null;
          }, 300), a.preventDefault();
        });
      }), a(window).on("resize.lg.zoom scroll.lg.zoom orientationchange.lg.zoom", function () {
        b.pageX = a(window).width() / 2, b.pageY = a(window).height() / 2 + a(window).scrollTop(), e(d);
      }), a("#lg-zoom-out").on("click.lg", function () {
        b.core.$outer.find(".lg-current .lg-image").length && (d -= b.core.s.scale, f());
      }), a("#lg-zoom-in").on("click.lg", function () {
        b.core.$outer.find(".lg-current .lg-image").length && (d += b.core.s.scale, f());
      }), a("#lg-actual-size").on("click.lg", function (a) {
        g(a, b.core.$slide.eq(b.core.index).find(".lg-image"), b.core.index, !0);
      }), b.core.$el.on("onBeforeSlide.lg.tm", function () {
        d = 1, b.resetZoom();
      }), b.zoomDrag(), b.zoomSwipe();
    }, d.prototype.resetZoom = function () {
      this.core.$outer.removeClass("lg-zoomed"), this.core.$slide.find(".lg-img-wrap").removeAttr("style data-x data-y"), this.core.$slide.find(".lg-image").removeAttr("style data-scale"), this.pageX = a(window).width() / 2, this.pageY = a(window).height() / 2 + a(window).scrollTop();
    }, d.prototype.zoomSwipe = function () {
      var a = this,
          b = {},
          c = {},
          d = !1,
          e = !1,
          f = !1;
      a.core.$slide.on("touchstart.lg", function (c) {
        if (a.core.$outer.hasClass("lg-zoomed")) {
          var d = a.core.$slide.eq(a.core.index).find(".lg-object");
          f = d.prop("offsetHeight") * d.attr("data-scale") > a.core.$outer.find(".lg").height(), e = d.prop("offsetWidth") * d.attr("data-scale") > a.core.$outer.find(".lg").width(), (e || f) && (c.preventDefault(), b = {
            x: c.originalEvent.targetTouches[0].pageX,
            y: c.originalEvent.targetTouches[0].pageY
          });
        }
      }), a.core.$slide.on("touchmove.lg", function (g) {
        if (a.core.$outer.hasClass("lg-zoomed")) {
          var h,
              i,
              j = a.core.$slide.eq(a.core.index).find(".lg-img-wrap");
          g.preventDefault(), d = !0, c = {
            x: g.originalEvent.targetTouches[0].pageX,
            y: g.originalEvent.targetTouches[0].pageY
          }, a.core.$outer.addClass("lg-zoom-dragging"), i = f ? -Math.abs(j.attr("data-y")) + (c.y - b.y) : -Math.abs(j.attr("data-y")), h = e ? -Math.abs(j.attr("data-x")) + (c.x - b.x) : -Math.abs(j.attr("data-x")), (Math.abs(c.x - b.x) > 15 || Math.abs(c.y - b.y) > 15) && (a.core.s.useLeftForZoom ? j.css({
            left: h + "px",
            top: i + "px"
          }) : j.css("transform", "translate3d(" + h + "px, " + i + "px, 0)"));
        }
      }), a.core.$slide.on("touchend.lg", function () {
        a.core.$outer.hasClass("lg-zoomed") && d && (d = !1, a.core.$outer.removeClass("lg-zoom-dragging"), a.touchendZoom(b, c, e, f));
      });
    }, d.prototype.zoomDrag = function () {
      var b = this,
          c = {},
          d = {},
          e = !1,
          f = !1,
          g = !1,
          h = !1;
      b.core.$slide.on("mousedown.lg.zoom", function (d) {
        var f = b.core.$slide.eq(b.core.index).find(".lg-object");
        h = f.prop("offsetHeight") * f.attr("data-scale") > b.core.$outer.find(".lg").height(), g = f.prop("offsetWidth") * f.attr("data-scale") > b.core.$outer.find(".lg").width(), b.core.$outer.hasClass("lg-zoomed") && a(d.target).hasClass("lg-object") && (g || h) && (d.preventDefault(), c = {
          x: d.pageX,
          y: d.pageY
        }, e = !0, b.core.$outer.scrollLeft += 1, b.core.$outer.scrollLeft -= 1, b.core.$outer.removeClass("lg-grab").addClass("lg-grabbing"));
      }), a(window).on("mousemove.lg.zoom", function (a) {
        if (e) {
          var i,
              j,
              k = b.core.$slide.eq(b.core.index).find(".lg-img-wrap");
          f = !0, d = {
            x: a.pageX,
            y: a.pageY
          }, b.core.$outer.addClass("lg-zoom-dragging"), j = h ? -Math.abs(k.attr("data-y")) + (d.y - c.y) : -Math.abs(k.attr("data-y")), i = g ? -Math.abs(k.attr("data-x")) + (d.x - c.x) : -Math.abs(k.attr("data-x")), b.core.s.useLeftForZoom ? k.css({
            left: i + "px",
            top: j + "px"
          }) : k.css("transform", "translate3d(" + i + "px, " + j + "px, 0)");
        }
      }), a(window).on("mouseup.lg.zoom", function (a) {
        e && (e = !1, b.core.$outer.removeClass("lg-zoom-dragging"), !f || c.x === d.x && c.y === d.y || (d = {
          x: a.pageX,
          y: a.pageY
        }, b.touchendZoom(c, d, g, h)), f = !1), b.core.$outer.removeClass("lg-grabbing").addClass("lg-grab");
      });
    }, d.prototype.touchendZoom = function (a, b, c, d) {
      var e = this,
          f = e.core.$slide.eq(e.core.index).find(".lg-img-wrap"),
          g = e.core.$slide.eq(e.core.index).find(".lg-object"),
          h = -Math.abs(f.attr("data-x")) + (b.x - a.x),
          i = -Math.abs(f.attr("data-y")) + (b.y - a.y),
          j = (e.core.$outer.find(".lg").height() - g.prop("offsetHeight")) / 2,
          k = Math.abs(g.prop("offsetHeight") * Math.abs(g.attr("data-scale")) - e.core.$outer.find(".lg").height() + j),
          l = (e.core.$outer.find(".lg").width() - g.prop("offsetWidth")) / 2,
          m = Math.abs(g.prop("offsetWidth") * Math.abs(g.attr("data-scale")) - e.core.$outer.find(".lg").width() + l);
      (Math.abs(b.x - a.x) > 15 || Math.abs(b.y - a.y) > 15) && (d && (i <= -k ? i = -k : i >= -j && (i = -j)), c && (h <= -m ? h = -m : h >= -l && (h = -l)), d ? f.attr("data-y", Math.abs(i)) : i = -Math.abs(f.attr("data-y")), c ? f.attr("data-x", Math.abs(h)) : h = -Math.abs(f.attr("data-x")), e.core.s.useLeftForZoom ? f.css({
        left: h + "px",
        top: i + "px"
      }) : f.css("transform", "translate3d(" + h + "px, " + i + "px, 0)"));
    }, d.prototype.destroy = function () {
      var b = this;
      b.core.$el.off(".lg.zoom"), a(window).off(".lg.zoom"), b.core.$slide.off(".lg.zoom"), b.core.$el.off(".lg.tm.zoom"), b.resetZoom(), clearTimeout(b.zoomabletimeout), b.zoomabletimeout = !1;
    }, a.fn.lightGallery.modules.zoom = d;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = {
      hash: !0
    },
        c = function c(_c5) {
      return this.core = a(_c5).data("lightGallery"), this.core.s = a.extend({}, b, this.core.s), this.core.s.hash && (this.oldHash = window.location.hash, this.init()), this;
    };

    c.prototype.init = function () {
      var b,
          c = this;
      c.core.$el.on("onAfterSlide.lg.tm", function (a, b, d) {
        history.replaceState ? history.replaceState(null, null, window.location.pathname + window.location.search + "#lg=" + c.core.s.galleryId + "&slide=" + d) : window.location.hash = "lg=" + c.core.s.galleryId + "&slide=" + d;
      }), a(window).on("hashchange.lg.hash", function () {
        b = window.location.hash;
        var a = parseInt(b.split("&slide=")[1], 10);
        b.indexOf("lg=" + c.core.s.galleryId) > -1 ? c.core.slide(a, !1, !1) : c.core.lGalleryOn && c.core.destroy();
      });
    }, c.prototype.destroy = function () {
      this.core.s.hash && (this.oldHash && this.oldHash.indexOf("lg=" + this.core.s.galleryId) < 0 ? history.replaceState ? history.replaceState(null, null, this.oldHash) : window.location.hash = this.oldHash : history.replaceState ? history.replaceState(null, document.title, window.location.pathname + window.location.search) : window.location.hash = "", this.core.$el.off(".lg.hash"));
    }, a.fn.lightGallery.modules.hash = c;
  }();
}), function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b(require("jquery")) : b(jQuery);
}(void 0, function (a) {
  !function () {
    "use strict";

    var b = {
      share: !0,
      facebook: !0,
      facebookDropdownText: "Facebook",
      twitter: !0,
      twitterDropdownText: "Twitter",
      googlePlus: !0,
      googlePlusDropdownText: "GooglePlus",
      pinterest: !0,
      pinterestDropdownText: "Pinterest"
    },
        c = function c(_c6) {
      return this.core = a(_c6).data("lightGallery"), this.core.s = a.extend({}, b, this.core.s), this.core.s.share && this.init(), this;
    };

    c.prototype.init = function () {
      var b = this,
          c = '<span id="lg-share" class="lg-icon"><ul class="lg-dropdown" style="position: absolute;">';
      c += b.core.s.facebook ? '<li><a id="lg-share-facebook" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.facebookDropdownText + "</span></a></li>" : "", c += b.core.s.twitter ? '<li><a id="lg-share-twitter" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.twitterDropdownText + "</span></a></li>" : "", c += b.core.s.googlePlus ? '<li><a id="lg-share-googleplus" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.googlePlusDropdownText + "</span></a></li>" : "", c += b.core.s.pinterest ? '<li><a id="lg-share-pinterest" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.pinterestDropdownText + "</span></a></li>" : "", c += "</ul></span>", this.core.$outer.find(".lg-toolbar").append(c), this.core.$outer.find(".lg").append('<div id="lg-dropdown-overlay"></div>'), a("#lg-share").on("click.lg", function () {
        b.core.$outer.toggleClass("lg-dropdown-active");
      }), a("#lg-dropdown-overlay").on("click.lg", function () {
        b.core.$outer.removeClass("lg-dropdown-active");
      }), b.core.$el.on("onAfterSlide.lg.tm", function (c, d, e) {
        setTimeout(function () {
          a("#lg-share-facebook").attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(b.getSahreProps(e, "facebookShareUrl") || window.location.href)), a("#lg-share-twitter").attr("href", "https://twitter.com/intent/tweet?text=" + b.getSahreProps(e, "tweetText") + "&url=" + encodeURIComponent(b.getSahreProps(e, "twitterShareUrl") || window.location.href)), a("#lg-share-googleplus").attr("href", "https://plus.google.com/share?url=" + encodeURIComponent(b.getSahreProps(e, "googleplusShareUrl") || window.location.href)), a("#lg-share-pinterest").attr("href", "http://www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(b.getSahreProps(e, "pinterestShareUrl") || window.location.href) + "&media=" + encodeURIComponent(b.getSahreProps(e, "src")) + "&description=" + b.getSahreProps(e, "pinterestText"));
        }, 100);
      });
    }, c.prototype.getSahreProps = function (a, b) {
      var c = "";
      if (this.core.s.dynamic) c = this.core.s.dynamicEl[a][b];else {
        var d = this.core.$items.eq(a).attr("href"),
            e = this.core.$items.eq(a).data(b);
        c = "src" === b ? d || e : e;
      }
      return c;
    }, c.prototype.destroy = function () {}, a.fn.lightGallery.modules.share = c;
  }();
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * jquery-match-height 0.7.2 by @liabru
 * http://brm.io/jquery-match-height/
 * License MIT
 */
!function (t) {
  "use strict";

  "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof module && module.exports ? module.exports = t(require("jquery")) : t(jQuery);
}(function (t) {
  var e = -1,
      o = -1,
      n = function n(t) {
    return parseFloat(t) || 0;
  },
      a = function a(e) {
    var o = 1,
        a = t(e),
        i = null,
        r = [];
    return a.each(function () {
      var e = t(this),
          a = e.offset().top - n(e.css("margin-top")),
          s = r.length > 0 ? r[r.length - 1] : null;
      null === s ? r.push(e) : Math.floor(Math.abs(i - a)) <= o ? r[r.length - 1] = s.add(e) : r.push(e), i = a;
    }), r;
  },
      i = function i(e) {
    var o = {
      byRow: !0,
      property: "height",
      target: null,
      remove: !1
    };
    return "object" == _typeof(e) ? t.extend(o, e) : ("boolean" == typeof e ? o.byRow = e : "remove" === e && (o.remove = !0), o);
  },
      r = t.fn.matchHeight = function (e) {
    var o = i(e);

    if (o.remove) {
      var n = this;
      return this.css(o.property, ""), t.each(r._groups, function (t, e) {
        e.elements = e.elements.not(n);
      }), this;
    }

    return this.length <= 1 && !o.target ? this : (r._groups.push({
      elements: this,
      options: o
    }), r._apply(this, o), this);
  };

  r.version = "0.7.2", r._groups = [], r._throttle = 80, r._maintainScroll = !1, r._beforeUpdate = null, r._afterUpdate = null, r._rows = a, r._parse = n, r._parseOptions = i, r._apply = function (e, o) {
    var s = i(o),
        h = t(e),
        l = [h],
        c = t(window).scrollTop(),
        p = t("html").outerHeight(!0),
        u = h.parents().filter(":hidden");
    return u.each(function () {
      var e = t(this);
      e.data("style-cache", e.attr("style"));
    }), u.css("display", "block"), s.byRow && !s.target && (h.each(function () {
      var e = t(this),
          o = e.css("display");
      "inline-block" !== o && "flex" !== o && "inline-flex" !== o && (o = "block"), e.data("style-cache", e.attr("style")), e.css({
        display: o,
        "padding-top": "0",
        "padding-bottom": "0",
        "margin-top": "0",
        "margin-bottom": "0",
        "border-top-width": "0",
        "border-bottom-width": "0",
        height: "100px",
        overflow: "hidden"
      });
    }), l = a(h), h.each(function () {
      var e = t(this);
      e.attr("style", e.data("style-cache") || "");
    })), t.each(l, function (e, o) {
      var a = t(o),
          i = 0;
      if (s.target) i = s.target.outerHeight(!1);else {
        if (s.byRow && a.length <= 1) return void a.css(s.property, "");
        a.each(function () {
          var e = t(this),
              o = e.attr("style"),
              n = e.css("display");
          "inline-block" !== n && "flex" !== n && "inline-flex" !== n && (n = "block");
          var a = {
            display: n
          };
          a[s.property] = "", e.css(a), e.outerHeight(!1) > i && (i = e.outerHeight(!1)), o ? e.attr("style", o) : e.css("display", "");
        });
      }
      a.each(function () {
        var e = t(this),
            o = 0;
        s.target && e.is(s.target) || ("border-box" !== e.css("box-sizing") && (o += n(e.css("border-top-width")) + n(e.css("border-bottom-width")), o += n(e.css("padding-top")) + n(e.css("padding-bottom"))), e.css(s.property, i - o + "px"));
      });
    }), u.each(function () {
      var e = t(this);
      e.attr("style", e.data("style-cache") || null);
    }), r._maintainScroll && t(window).scrollTop(c / p * t("html").outerHeight(!0)), this;
  }, r._applyDataApi = function () {
    var e = {};
    t("[data-match-height], [data-mh]").each(function () {
      var o = t(this),
          n = o.attr("data-mh") || o.attr("data-match-height");
      n in e ? e[n] = e[n].add(o) : e[n] = o;
    }), t.each(e, function () {
      this.matchHeight(!0);
    });
  };

  var s = function s(e) {
    r._beforeUpdate && r._beforeUpdate(e, r._groups), t.each(r._groups, function () {
      r._apply(this.elements, this.options);
    }), r._afterUpdate && r._afterUpdate(e, r._groups);
  };

  r._update = function (n, a) {
    if (a && "resize" === a.type) {
      var i = t(window).width();
      if (i === e) return;
      e = i;
    }

    n ? o === -1 && (o = setTimeout(function () {
      s(a), o = -1;
    }, r._throttle)) : s(a);
  }, t(r._applyDataApi);
  var h = t.fn.on ? "on" : "bind";
  t(window)[h]("load", function (t) {
    r._update(!1, t);
  }), t(window)[h]("resize orientationchange", function (t) {
    r._update(!0, t);
  });
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Materialize v0.100.2 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */
function _classCallCheck(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

var _createClass = function () {
  function t(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }

  return function (e, i, n) {
    return i && t(e.prototype, i), n && t(e, n), e;
  };
}();

"undefined" == typeof jQuery && ("function" == typeof require ? jQuery = $ = require("jquery") : jQuery = $), function (t) {
  "function" == typeof define && define.amd ? define(["jquery"], function (e) {
    return t(e);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? exports = t(require("jquery")) : t(jQuery);
}(function (t) {
  function e(t) {
    var e = 7.5625,
        i = 2.75;
    return t < 1 / i ? e * t * t : t < 2 / i ? e * (t -= 1.5 / i) * t + .75 : t < 2.5 / i ? e * (t -= 2.25 / i) * t + .9375 : e * (t -= 2.625 / i) * t + .984375;
  }

  t.easing.jswing = t.easing.swing;
  var i = Math.pow,
      n = Math.sqrt,
      o = Math.sin,
      a = Math.cos,
      r = Math.PI,
      s = 1.70158,
      l = 1.525 * s,
      c = 2 * r / 3,
      u = 2 * r / 4.5;
  t.extend(t.easing, {
    def: "easeOutQuad",
    swing: function swing(e) {
      return t.easing[t.easing.def](e);
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return 1 - (1 - t) * (1 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < .5 ? 2 * t * t : 1 - i(-2 * t + 2, 2) / 2;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return 1 - i(1 - t, 3);
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < .5 ? 4 * t * t * t : 1 - i(-2 * t + 2, 3) / 2;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - i(1 - t, 4);
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < .5 ? 8 * t * t * t * t : 1 - i(-2 * t + 2, 4) / 2;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 - i(1 - t, 5);
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < .5 ? 16 * t * t * t * t * t : 1 - i(-2 * t + 2, 5) / 2;
    },
    easeInSine: function easeInSine(t) {
      return 1 - a(t * r / 2);
    },
    easeOutSine: function easeOutSine(t) {
      return o(t * r / 2);
    },
    easeInOutSine: function easeInOutSine(t) {
      return -(a(r * t) - 1) / 2;
    },
    easeInExpo: function easeInExpo(t) {
      return 0 === t ? 0 : i(2, 10 * t - 10);
    },
    easeOutExpo: function easeOutExpo(t) {
      return 1 === t ? 1 : 1 - i(2, -10 * t);
    },
    easeInOutExpo: function easeInOutExpo(t) {
      return 0 === t ? 0 : 1 === t ? 1 : t < .5 ? i(2, 20 * t - 10) / 2 : (2 - i(2, -20 * t + 10)) / 2;
    },
    easeInCirc: function easeInCirc(t) {
      return 1 - n(1 - i(t, 2));
    },
    easeOutCirc: function easeOutCirc(t) {
      return n(1 - i(t - 1, 2));
    },
    easeInOutCirc: function easeInOutCirc(t) {
      return t < .5 ? (1 - n(1 - i(2 * t, 2))) / 2 : (n(1 - i(-2 * t + 2, 2)) + 1) / 2;
    },
    easeInElastic: function easeInElastic(t) {
      return 0 === t ? 0 : 1 === t ? 1 : -i(2, 10 * t - 10) * o((10 * t - 10.75) * c);
    },
    easeOutElastic: function easeOutElastic(t) {
      return 0 === t ? 0 : 1 === t ? 1 : i(2, -10 * t) * o((10 * t - .75) * c) + 1;
    },
    easeInOutElastic: function easeInOutElastic(t) {
      return 0 === t ? 0 : 1 === t ? 1 : t < .5 ? -i(2, 20 * t - 10) * o((20 * t - 11.125) * u) / 2 : i(2, -20 * t + 10) * o((20 * t - 11.125) * u) / 2 + 1;
    },
    easeInBack: function easeInBack(t) {
      return 2.70158 * t * t * t - s * t * t;
    },
    easeOutBack: function easeOutBack(t) {
      return 1 + 2.70158 * i(t - 1, 3) + s * i(t - 1, 2);
    },
    easeInOutBack: function easeInOutBack(t) {
      return t < .5 ? i(2 * t, 2) * (7.189819 * t - l) / 2 : (i(2 * t - 2, 2) * ((l + 1) * (2 * t - 2) + l) + 2) / 2;
    },
    easeInBounce: function easeInBounce(t) {
      return 1 - e(1 - t);
    },
    easeOutBounce: e,
    easeInOutBounce: function easeInOutBounce(t) {
      return t < .5 ? (1 - e(1 - 2 * t)) / 2 : (1 + e(2 * t - 1)) / 2;
    }
  });
}), jQuery.extend(jQuery.easing, {
  easeInOutMaterial: function easeInOutMaterial(t, e, i, n, o) {
    return (e /= o / 2) < 1 ? n / 2 * e * e + i : n / 4 * ((e -= 2) * e * e + 2) + i;
  }
}), jQuery.Velocity ? console.log("Velocity is already loaded. You may be needlessly importing Velocity again; note that Materialize includes Velocity.") : (function (t) {
  function e(t) {
    var e = t.length,
        n = i.type(t);
    return "function" !== n && !i.isWindow(t) && (!(1 !== t.nodeType || !e) || "array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t);
  }

  if (!t.jQuery) {
    var i = function i(t, e) {
      return new i.fn.init(t, e);
    };

    i.isWindow = function (t) {
      return null != t && t == t.window;
    }, i.type = function (t) {
      return null == t ? t + "" : "object" == _typeof(t) || "function" == typeof t ? o[r.call(t)] || "object" : _typeof(t);
    }, i.isArray = Array.isArray || function (t) {
      return "array" === i.type(t);
    }, i.isPlainObject = function (t) {
      var e;
      if (!t || "object" !== i.type(t) || t.nodeType || i.isWindow(t)) return !1;

      try {
        if (t.constructor && !a.call(t, "constructor") && !a.call(t.constructor.prototype, "isPrototypeOf")) return !1;
      } catch (t) {
        return !1;
      }

      for (e in t) {
        ;
      }

      return void 0 === e || a.call(t, e);
    }, i.each = function (t, i, n) {
      var o = 0,
          a = t.length,
          r = e(t);

      if (n) {
        if (r) for (; a > o && !1 !== i.apply(t[o], n); o++) {
          ;
        } else for (o in t) {
          if (!1 === i.apply(t[o], n)) break;
        }
      } else if (r) for (; a > o && !1 !== i.call(t[o], o, t[o]); o++) {
        ;
      } else for (o in t) {
        if (!1 === i.call(t[o], o, t[o])) break;
      }

      return t;
    }, i.data = function (t, e, o) {
      if (void 0 === o) {
        var a = (r = t[i.expando]) && n[r];
        if (void 0 === e) return a;
        if (a && e in a) return a[e];
      } else if (void 0 !== e) {
        var r = t[i.expando] || (t[i.expando] = ++i.uuid);
        return n[r] = n[r] || {}, n[r][e] = o, o;
      }
    }, i.removeData = function (t, e) {
      var o = t[i.expando],
          a = o && n[o];
      a && i.each(e, function (t, e) {
        delete a[e];
      });
    }, i.extend = function () {
      var t,
          e,
          n,
          o,
          a,
          r,
          s = arguments[0] || {},
          l = 1,
          c = arguments.length,
          u = !1;

      for ("boolean" == typeof s && (u = s, s = arguments[l] || {}, l++), "object" != _typeof(s) && "function" !== i.type(s) && (s = {}), l === c && (s = this, l--); c > l; l++) {
        if (null != (a = arguments[l])) for (o in a) {
          t = s[o], s !== (n = a[o]) && (u && n && (i.isPlainObject(n) || (e = i.isArray(n))) ? (e ? (e = !1, r = t && i.isArray(t) ? t : []) : r = t && i.isPlainObject(t) ? t : {}, s[o] = i.extend(u, r, n)) : void 0 !== n && (s[o] = n));
        }
      }

      return s;
    }, i.queue = function (t, n, o) {
      if (t) {
        n = (n || "fx") + "queue";
        var a = i.data(t, n);
        return o ? (!a || i.isArray(o) ? a = i.data(t, n, function (t, i) {
          var n = i || [];
          return null != t && (e(Object(t)) ? function (t, e) {
            for (var i = +e.length, n = 0, o = t.length; i > n;) {
              t[o++] = e[n++];
            }

            if (i !== i) for (; void 0 !== e[n];) {
              t[o++] = e[n++];
            }
            t.length = o;
          }(n, "string" == typeof t ? [t] : t) : [].push.call(n, t)), n;
        }(o)) : a.push(o), a) : a || [];
      }
    }, i.dequeue = function (t, e) {
      i.each(t.nodeType ? [t] : t, function (t, n) {
        e = e || "fx";
        var o = i.queue(n, e),
            a = o.shift();
        "inprogress" === a && (a = o.shift()), a && ("fx" === e && o.unshift("inprogress"), a.call(n, function () {
          i.dequeue(n, e);
        }));
      });
    }, i.fn = i.prototype = {
      init: function init(t) {
        if (t.nodeType) return this[0] = t, this;
        throw new Error("Not a DOM node.");
      },
      offset: function offset() {
        var e = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
          top: 0,
          left: 0
        };
        return {
          top: e.top + (t.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
          left: e.left + (t.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
        };
      },
      position: function position() {
        function t() {
          for (var t = this.offsetParent || document; t && "html" === !t.nodeType.toLowerCase && "static" === t.style.position;) {
            t = t.offsetParent;
          }

          return t || document;
        }

        var e = this[0],
            t = t.apply(e),
            n = this.offset(),
            o = /^(?:body|html)$/i.test(t.nodeName) ? {
          top: 0,
          left: 0
        } : i(t).offset();
        return n.top -= parseFloat(e.style.marginTop) || 0, n.left -= parseFloat(e.style.marginLeft) || 0, t.style && (o.top += parseFloat(t.style.borderTopWidth) || 0, o.left += parseFloat(t.style.borderLeftWidth) || 0), {
          top: n.top - o.top,
          left: n.left - o.left
        };
      }
    };
    var n = {};
    i.expando = "velocity" + new Date().getTime(), i.uuid = 0;

    for (var o = {}, a = o.hasOwnProperty, r = o.toString, s = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < s.length; l++) {
      o["[object " + s[l] + "]"] = s[l].toLowerCase();
    }

    i.fn.init.prototype = i.fn, t.Velocity = {
      Utilities: i
    };
  }
}(window), function (t) {
  "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : t();
}(function () {
  return function (t, e, i, n) {
    function o(t) {
      for (var e = -1, i = t ? t.length : 0, n = []; ++e < i;) {
        var o = t[e];
        o && n.push(o);
      }

      return n;
    }

    function a(t) {
      return v.isWrapped(t) ? t = [].slice.call(t) : v.isNode(t) && (t = [t]), t;
    }

    function r(t) {
      var e = p.data(t, "velocity");
      return null === e ? n : e;
    }

    function s(t) {
      return function (e) {
        return Math.round(e * t) * (1 / t);
      };
    }

    function l(t, i, n, o) {
      function a(t, e) {
        return 1 - 3 * e + 3 * t;
      }

      function r(t, e) {
        return 3 * e - 6 * t;
      }

      function s(t) {
        return 3 * t;
      }

      function l(t, e, i) {
        return ((a(e, i) * t + r(e, i)) * t + s(e)) * t;
      }

      function c(t, e, i) {
        return 3 * a(e, i) * t * t + 2 * r(e, i) * t + s(e);
      }

      function u(e, i) {
        for (var o = 0; v > o; ++o) {
          var a = c(i, t, n);
          if (0 === a) return i;
          i -= (l(i, t, n) - e) / a;
        }

        return i;
      }

      function d() {
        for (var e = 0; b > e; ++e) {
          C[e] = l(e * w, t, n);
        }
      }

      function p(e, i, o) {
        var a,
            r,
            s = 0;

        do {
          (a = l(r = i + (o - i) / 2, t, n) - e) > 0 ? o = r : i = r;
        } while (Math.abs(a) > g && ++s < y);

        return r;
      }

      function h(e) {
        for (var i = 0, o = 1, a = b - 1; o != a && C[o] <= e; ++o) {
          i += w;
        }

        var r = i + (e - C[--o]) / (C[o + 1] - C[o]) * w,
            s = c(r, t, n);
        return s >= m ? u(e, r) : 0 == s ? r : p(e, i, i + w);
      }

      function f() {
        T = !0, (t != i || n != o) && d();
      }

      var v = 4,
          m = .001,
          g = 1e-7,
          y = 10,
          b = 11,
          w = 1 / (b - 1),
          k = ("Float32Array" in e);
      if (4 !== arguments.length) return !1;

      for (var x = 0; 4 > x; ++x) {
        if ("number" != typeof arguments[x] || isNaN(arguments[x]) || !isFinite(arguments[x])) return !1;
      }

      t = Math.min(t, 1), n = Math.min(n, 1), t = Math.max(t, 0), n = Math.max(n, 0);

      var C = k ? new Float32Array(b) : new Array(b),
          T = !1,
          S = function S(e) {
        return T || f(), t === i && n === o ? e : 0 === e ? 0 : 1 === e ? 1 : l(h(e), i, o);
      };

      S.getControlPoints = function () {
        return [{
          x: t,
          y: i
        }, {
          x: n,
          y: o
        }];
      };

      var P = "generateBezier(" + [t, i, n, o] + ")";
      return S.toString = function () {
        return P;
      }, S;
    }

    function c(t, e) {
      var i = t;
      return v.isString(t) ? b.Easings[t] || (i = !1) : i = v.isArray(t) && 1 === t.length ? s.apply(null, t) : v.isArray(t) && 2 === t.length ? w.apply(null, t.concat([e])) : !(!v.isArray(t) || 4 !== t.length) && l.apply(null, t), !1 === i && (i = b.Easings[b.defaults.easing] ? b.defaults.easing : y), i;
    }

    function u(t) {
      if (t) {
        var e = new Date().getTime(),
            i = b.State.calls.length;
        i > 1e4 && (b.State.calls = o(b.State.calls));

        for (var a = 0; i > a; a++) {
          if (b.State.calls[a]) {
            var s = b.State.calls[a],
                l = s[0],
                c = s[2],
                h = s[3],
                f = !!h,
                m = null;
            h || (h = b.State.calls[a][3] = e - 16);

            for (var g = Math.min((e - h) / c.duration, 1), y = 0, w = l.length; w > y; y++) {
              var x = l[y],
                  T = x.element;

              if (r(T)) {
                var S = !1;

                if (c.display !== n && null !== c.display && "none" !== c.display) {
                  if ("flex" === c.display) {
                    var P = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
                    p.each(P, function (t, e) {
                      k.setPropertyValue(T, "display", e);
                    });
                  }

                  k.setPropertyValue(T, "display", c.display);
                }

                c.visibility !== n && "hidden" !== c.visibility && k.setPropertyValue(T, "visibility", c.visibility);

                for (var A in x) {
                  if ("element" !== A) {
                    var O,
                        E = x[A],
                        _ = v.isString(E.easing) ? b.Easings[E.easing] : E.easing;

                    if (1 === g) O = E.endValue;else {
                      var M = E.endValue - E.startValue;
                      if (O = E.startValue + M * _(g, c, M), !f && O === E.currentValue) continue;
                    }
                    if (E.currentValue = O, "tween" === A) m = O;else {
                      if (k.Hooks.registered[A]) {
                        var I = k.Hooks.getRoot(A),
                            D = r(T).rootPropertyValueCache[I];
                        D && (E.rootPropertyValue = D);
                      }

                      var q = k.setPropertyValue(T, A, E.currentValue + (0 === parseFloat(O) ? "" : E.unitType), E.rootPropertyValue, E.scrollData);
                      k.Hooks.registered[A] && (r(T).rootPropertyValueCache[I] = k.Normalizations.registered[I] ? k.Normalizations.registered[I]("extract", null, q[1]) : q[1]), "transform" === q[0] && (S = !0);
                    }
                  }
                }

                c.mobileHA && r(T).transformCache.translate3d === n && (r(T).transformCache.translate3d = "(0px, 0px, 0px)", S = !0), S && k.flushTransformCache(T);
              }
            }

            c.display !== n && "none" !== c.display && (b.State.calls[a][2].display = !1), c.visibility !== n && "hidden" !== c.visibility && (b.State.calls[a][2].visibility = !1), c.progress && c.progress.call(s[1], s[1], g, Math.max(0, h + c.duration - e), h, m), 1 === g && d(a);
          }
        }
      }

      b.State.isTicking && C(u);
    }

    function d(t, e) {
      if (!b.State.calls[t]) return !1;

      for (var i = b.State.calls[t][0], o = b.State.calls[t][1], a = b.State.calls[t][2], s = b.State.calls[t][4], l = !1, c = 0, u = i.length; u > c; c++) {
        var d = i[c].element;

        if (e || a.loop || ("none" === a.display && k.setPropertyValue(d, "display", a.display), "hidden" === a.visibility && k.setPropertyValue(d, "visibility", a.visibility)), !0 !== a.loop && (p.queue(d)[1] === n || !/\.velocityQueueEntryFlag/i.test(p.queue(d)[1])) && r(d)) {
          r(d).isAnimating = !1, r(d).rootPropertyValueCache = {};
          var h = !1;
          p.each(k.Lists.transforms3D, function (t, e) {
            var i = /^scale/.test(e) ? 1 : 0,
                o = r(d).transformCache[e];
            r(d).transformCache[e] !== n && new RegExp("^\\(" + i + "[^.]").test(o) && (h = !0, delete r(d).transformCache[e]);
          }), a.mobileHA && (h = !0, delete r(d).transformCache.translate3d), h && k.flushTransformCache(d), k.Values.removeClass(d, "velocity-animating");
        }

        if (!e && a.complete && !a.loop && c === u - 1) try {
          a.complete.call(o, o);
        } catch (t) {
          setTimeout(function () {
            throw t;
          }, 1);
        }
        s && !0 !== a.loop && s(o), r(d) && !0 === a.loop && !e && (p.each(r(d).tweensContainer, function (t, e) {
          /^rotate/.test(t) && 360 === parseFloat(e.endValue) && (e.endValue = 0, e.startValue = 360), /^backgroundPosition/.test(t) && 100 === parseFloat(e.endValue) && "%" === e.unitType && (e.endValue = 0, e.startValue = 100);
        }), b(d, "reverse", {
          loop: !0,
          delay: a.delay
        })), !1 !== a.queue && p.dequeue(d, a.queue);
      }

      b.State.calls[t] = !1;

      for (var f = 0, v = b.State.calls.length; v > f; f++) {
        if (!1 !== b.State.calls[f]) {
          l = !0;
          break;
        }
      }

      !1 === l && (b.State.isTicking = !1, delete b.State.calls, b.State.calls = []);
    }

    var p,
        h = function () {
      if (i.documentMode) return i.documentMode;

      for (var t = 7; t > 4; t--) {
        var e = i.createElement("div");
        if (e.innerHTML = "\x3c!--[if IE " + t + "]><span></span><![endif]--\x3e", e.getElementsByTagName("span").length) return e = null, t;
      }

      return n;
    }(),
        f = function () {
      var t = 0;
      return e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || function (e) {
        var i,
            n = new Date().getTime();
        return i = Math.max(0, 16 - (n - t)), t = n + i, setTimeout(function () {
          e(n + i);
        }, i);
      };
    }(),
        v = {
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isArray: Array.isArray || function (t) {
        return "[object Array]" === Object.prototype.toString.call(t);
      },
      isFunction: function isFunction(t) {
        return "[object Function]" === Object.prototype.toString.call(t);
      },
      isNode: function isNode(t) {
        return t && t.nodeType;
      },
      isNodeList: function isNodeList(t) {
        return "object" == _typeof(t) && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(t)) && t.length !== n && (0 === t.length || "object" == _typeof(t[0]) && t[0].nodeType > 0);
      },
      isWrapped: function isWrapped(t) {
        return t && (t.jquery || e.Zepto && e.Zepto.zepto.isZ(t));
      },
      isSVG: function isSVG(t) {
        return e.SVGElement && t instanceof e.SVGElement;
      },
      isEmptyObject: function isEmptyObject(t) {
        for (var e in t) {
          return !1;
        }

        return !0;
      }
    },
        m = !1;

    if (t.fn && t.fn.jquery ? (p = t, m = !0) : p = e.Velocity.Utilities, 8 >= h && !m) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
    {
      if (!(7 >= h)) {
        var g = 400,
            y = "swing",
            b = {
          State: {
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            isAndroid: /Android/i.test(navigator.userAgent),
            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
            isChrome: e.chrome,
            isFirefox: /Firefox/i.test(navigator.userAgent),
            prefixElement: i.createElement("div"),
            prefixMatches: {},
            scrollAnchor: null,
            scrollPropertyLeft: null,
            scrollPropertyTop: null,
            isTicking: !1,
            calls: []
          },
          CSS: {},
          Utilities: p,
          Redirects: {},
          Easings: {},
          Promise: e.Promise,
          defaults: {
            queue: "",
            duration: g,
            easing: y,
            begin: n,
            complete: n,
            progress: n,
            display: n,
            visibility: n,
            loop: !1,
            delay: !1,
            mobileHA: !0,
            _cacheValues: !0
          },
          init: function init(t) {
            p.data(t, "velocity", {
              isSVG: v.isSVG(t),
              isAnimating: !1,
              computedStyle: null,
              tweensContainer: null,
              rootPropertyValueCache: {},
              transformCache: {}
            });
          },
          hook: null,
          mock: !1,
          version: {
            major: 1,
            minor: 2,
            patch: 2
          },
          debug: !1
        };
        e.pageYOffset !== n ? (b.State.scrollAnchor = e, b.State.scrollPropertyLeft = "pageXOffset", b.State.scrollPropertyTop = "pageYOffset") : (b.State.scrollAnchor = i.documentElement || i.body.parentNode || i.body, b.State.scrollPropertyLeft = "scrollLeft", b.State.scrollPropertyTop = "scrollTop");

        var w = function () {
          function t(t) {
            return -t.tension * t.x - t.friction * t.v;
          }

          function e(e, i, n) {
            var o = {
              x: e.x + n.dx * i,
              v: e.v + n.dv * i,
              tension: e.tension,
              friction: e.friction
            };
            return {
              dx: o.v,
              dv: t(o)
            };
          }

          function i(i, n) {
            var o = {
              dx: i.v,
              dv: t(i)
            },
                a = e(i, .5 * n, o),
                r = e(i, .5 * n, a),
                s = e(i, n, r),
                l = 1 / 6 * (o.dx + 2 * (a.dx + r.dx) + s.dx),
                c = 1 / 6 * (o.dv + 2 * (a.dv + r.dv) + s.dv);
            return i.x = i.x + l * n, i.v = i.v + c * n, i;
          }

          return function t(e, n, o) {
            var a,
                r,
                s,
                l = {
              x: -1,
              v: 0,
              tension: null,
              friction: null
            },
                c = [0],
                u = 0;

            for (e = parseFloat(e) || 500, n = parseFloat(n) || 20, o = o || null, l.tension = e, l.friction = n, (a = null !== o) ? (u = t(e, n), r = u / o * .016) : r = .016; s = i(s || l, r), c.push(1 + s.x), u += 16, Math.abs(s.x) > 1e-4 && Math.abs(s.v) > 1e-4;) {
              ;
            }

            return a ? function (t) {
              return c[t * (c.length - 1) | 0];
            } : u;
          };
        }();

        b.Easings = {
          linear: function linear(t) {
            return t;
          },
          swing: function swing(t) {
            return .5 - Math.cos(t * Math.PI) / 2;
          },
          spring: function spring(t) {
            return 1 - Math.cos(4.5 * t * Math.PI) * Math.exp(6 * -t);
          }
        }, p.each([["ease", [.25, .1, .25, 1]], ["ease-in", [.42, 0, 1, 1]], ["ease-out", [0, 0, .58, 1]], ["ease-in-out", [.42, 0, .58, 1]], ["easeInSine", [.47, 0, .745, .715]], ["easeOutSine", [.39, .575, .565, 1]], ["easeInOutSine", [.445, .05, .55, .95]], ["easeInQuad", [.55, .085, .68, .53]], ["easeOutQuad", [.25, .46, .45, .94]], ["easeInOutQuad", [.455, .03, .515, .955]], ["easeInCubic", [.55, .055, .675, .19]], ["easeOutCubic", [.215, .61, .355, 1]], ["easeInOutCubic", [.645, .045, .355, 1]], ["easeInQuart", [.895, .03, .685, .22]], ["easeOutQuart", [.165, .84, .44, 1]], ["easeInOutQuart", [.77, 0, .175, 1]], ["easeInQuint", [.755, .05, .855, .06]], ["easeOutQuint", [.23, 1, .32, 1]], ["easeInOutQuint", [.86, 0, .07, 1]], ["easeInExpo", [.95, .05, .795, .035]], ["easeOutExpo", [.19, 1, .22, 1]], ["easeInOutExpo", [1, 0, 0, 1]], ["easeInCirc", [.6, .04, .98, .335]], ["easeOutCirc", [.075, .82, .165, 1]], ["easeInOutCirc", [.785, .135, .15, .86]]], function (t, e) {
          b.Easings[e[0]] = l.apply(null, e[1]);
        });
        var k = b.CSS = {
          RegEx: {
            isHex: /^#([A-f\d]{3}){1,2}$/i,
            valueUnwrap: /^[A-z]+\((.*)\)$/i,
            wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
            valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
          },
          Lists: {
            colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
            transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
            transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"]
          },
          Hooks: {
            templates: {
              textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
              boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
              clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
              backgroundPosition: ["X Y", "0% 0%"],
              transformOrigin: ["X Y Z", "50% 50% 0px"],
              perspectiveOrigin: ["X Y", "50% 50%"]
            },
            registered: {},
            register: function register() {
              for (a = 0; a < k.Lists.colors.length; a++) {
                var t = "color" === k.Lists.colors[a] ? "0 0 0 1" : "255 255 255 1";
                k.Hooks.templates[k.Lists.colors[a]] = ["Red Green Blue Alpha", t];
              }

              var e, i, n;
              if (h) for (e in k.Hooks.templates) {
                n = (i = k.Hooks.templates[e])[0].split(" ");
                var o = i[1].match(k.RegEx.valueSplit);
                "Color" === n[0] && (n.push(n.shift()), o.push(o.shift()), k.Hooks.templates[e] = [n.join(" "), o.join(" ")]);
              }

              for (e in k.Hooks.templates) {
                n = (i = k.Hooks.templates[e])[0].split(" ");

                for (var a in n) {
                  var r = e + n[a],
                      s = a;
                  k.Hooks.registered[r] = [e, s];
                }
              }
            },
            getRoot: function getRoot(t) {
              var e = k.Hooks.registered[t];
              return e ? e[0] : t;
            },
            cleanRootPropertyValue: function cleanRootPropertyValue(t, e) {
              return k.RegEx.valueUnwrap.test(e) && (e = e.match(k.RegEx.valueUnwrap)[1]), k.Values.isCSSNullValue(e) && (e = k.Hooks.templates[t][1]), e;
            },
            extractValue: function extractValue(t, e) {
              var i = k.Hooks.registered[t];

              if (i) {
                var n = i[0],
                    o = i[1];
                return (e = k.Hooks.cleanRootPropertyValue(n, e)).toString().match(k.RegEx.valueSplit)[o];
              }

              return e;
            },
            injectValue: function injectValue(t, e, i) {
              var n = k.Hooks.registered[t];

              if (n) {
                var o,
                    a = n[0],
                    r = n[1];
                return i = k.Hooks.cleanRootPropertyValue(a, i), o = i.toString().match(k.RegEx.valueSplit), o[r] = e, o.join(" ");
              }

              return i;
            }
          },
          Normalizations: {
            registered: {
              clip: function clip(t, e, i) {
                switch (t) {
                  case "name":
                    return "clip";

                  case "extract":
                    var n;
                    return k.RegEx.wrappedValueAlreadyExtracted.test(i) ? n = i : (n = i.toString().match(k.RegEx.valueUnwrap), n = n ? n[1].replace(/,(\s+)?/g, " ") : i), n;

                  case "inject":
                    return "rect(" + i + ")";
                }
              },
              blur: function blur(t, e, i) {
                switch (t) {
                  case "name":
                    return b.State.isFirefox ? "filter" : "-webkit-filter";

                  case "extract":
                    var n = parseFloat(i);

                    if (!n && 0 !== n) {
                      var o = i.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                      n = o ? o[1] : 0;
                    }

                    return n;

                  case "inject":
                    return parseFloat(i) ? "blur(" + i + ")" : "none";
                }
              },
              opacity: function opacity(t, e, i) {
                if (8 >= h) switch (t) {
                  case "name":
                    return "filter";

                  case "extract":
                    var n = i.toString().match(/alpha\(opacity=(.*)\)/i);
                    return i = n ? n[1] / 100 : 1;

                  case "inject":
                    return e.style.zoom = 1, parseFloat(i) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(i), 10) + ")";
                } else switch (t) {
                  case "name":
                    return "opacity";

                  case "extract":
                  case "inject":
                    return i;
                }
              }
            },
            register: function register() {
              9 >= h || b.State.isGingerbread || (k.Lists.transformsBase = k.Lists.transformsBase.concat(k.Lists.transforms3D));

              for (t = 0; t < k.Lists.transformsBase.length; t++) {
                !function () {
                  var e = k.Lists.transformsBase[t];

                  k.Normalizations.registered[e] = function (t, i, o) {
                    switch (t) {
                      case "name":
                        return "transform";

                      case "extract":
                        return r(i) === n || r(i).transformCache[e] === n ? /^scale/i.test(e) ? 1 : 0 : r(i).transformCache[e].replace(/[()]/g, "");

                      case "inject":
                        var a = !1;

                        switch (e.substr(0, e.length - 1)) {
                          case "translate":
                            a = !/(%|px|em|rem|vw|vh|\d)$/i.test(o);
                            break;

                          case "scal":
                          case "scale":
                            b.State.isAndroid && r(i).transformCache[e] === n && 1 > o && (o = 1), a = !/(\d)$/i.test(o);
                            break;

                          case "skew":
                            a = !/(deg|\d)$/i.test(o);
                            break;

                          case "rotate":
                            a = !/(deg|\d)$/i.test(o);
                        }

                        return a || (r(i).transformCache[e] = "(" + o + ")"), r(i).transformCache[e];
                    }
                  };
                }();
              }

              for (var t = 0; t < k.Lists.colors.length; t++) {
                !function () {
                  var e = k.Lists.colors[t];

                  k.Normalizations.registered[e] = function (t, i, o) {
                    switch (t) {
                      case "name":
                        return e;

                      case "extract":
                        var a;
                        if (k.RegEx.wrappedValueAlreadyExtracted.test(o)) a = o;else {
                          var r,
                              s = {
                            black: "rgb(0, 0, 0)",
                            blue: "rgb(0, 0, 255)",
                            gray: "rgb(128, 128, 128)",
                            green: "rgb(0, 128, 0)",
                            red: "rgb(255, 0, 0)",
                            white: "rgb(255, 255, 255)"
                          };
                          /^[A-z]+$/i.test(o) ? r = s[o] !== n ? s[o] : s.black : k.RegEx.isHex.test(o) ? r = "rgb(" + k.Values.hexToRgb(o).join(" ") + ")" : /^rgba?\(/i.test(o) || (r = s.black), a = (r || o).toString().match(k.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
                        }
                        return 8 >= h || 3 !== a.split(" ").length || (a += " 1"), a;

                      case "inject":
                        return 8 >= h ? 4 === o.split(" ").length && (o = o.split(/\s+/).slice(0, 3).join(" ")) : 3 === o.split(" ").length && (o += " 1"), (8 >= h ? "rgb" : "rgba") + "(" + o.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
                    }
                  };
                }();
              }
            }
          },
          Names: {
            camelCase: function camelCase(t) {
              return t.replace(/-(\w)/g, function (t, e) {
                return e.toUpperCase();
              });
            },
            SVGAttribute: function SVGAttribute(t) {
              var e = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
              return (h || b.State.isAndroid && !b.State.isChrome) && (e += "|transform"), new RegExp("^(" + e + ")$", "i").test(t);
            },
            prefixCheck: function prefixCheck(t) {
              if (b.State.prefixMatches[t]) return [b.State.prefixMatches[t], !0];

              for (var e = ["", "Webkit", "Moz", "ms", "O"], i = 0, n = e.length; n > i; i++) {
                var o;
                if (o = 0 === i ? t : e[i] + t.replace(/^\w/, function (t) {
                  return t.toUpperCase();
                }), v.isString(b.State.prefixElement.style[o])) return b.State.prefixMatches[t] = o, [o, !0];
              }

              return [t, !1];
            }
          },
          Values: {
            hexToRgb: function hexToRgb(t) {
              var e,
                  i = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                  n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
              return t = t.replace(i, function (t, e, i, n) {
                return e + e + i + i + n + n;
              }), e = n.exec(t), e ? [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)] : [0, 0, 0];
            },
            isCSSNullValue: function isCSSNullValue(t) {
              return 0 == t || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(t);
            },
            getUnitType: function getUnitType(t) {
              return /^(rotate|skew)/i.test(t) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(t) ? "" : "px";
            },
            getDisplayType: function getDisplayType(t) {
              var e = t && t.tagName.toString().toLowerCase();
              return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e) ? "inline" : /^(li)$/i.test(e) ? "list-item" : /^(tr)$/i.test(e) ? "table-row" : /^(table)$/i.test(e) ? "table" : /^(tbody)$/i.test(e) ? "table-row-group" : "block";
            },
            addClass: function addClass(t, e) {
              t.classList ? t.classList.add(e) : t.className += (t.className.length ? " " : "") + e;
            },
            removeClass: function removeClass(t, e) {
              t.classList ? t.classList.remove(e) : t.className = t.className.toString().replace(new RegExp("(^|\\s)" + e.split(" ").join("|") + "(\\s|$)", "gi"), " ");
            }
          },
          getPropertyValue: function getPropertyValue(t, i, o, a) {
            function s(t, i) {
              function o() {
                c && k.setPropertyValue(t, "display", "none");
              }

              var l = 0;
              if (8 >= h) l = p.css(t, i);else {
                var c = !1;

                if (/^(width|height)$/.test(i) && 0 === k.getPropertyValue(t, "display") && (c = !0, k.setPropertyValue(t, "display", k.Values.getDisplayType(t))), !a) {
                  if ("height" === i && "border-box" !== k.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                    var u = t.offsetHeight - (parseFloat(k.getPropertyValue(t, "borderTopWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "borderBottomWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingTop")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingBottom")) || 0);
                    return o(), u;
                  }

                  if ("width" === i && "border-box" !== k.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                    var d = t.offsetWidth - (parseFloat(k.getPropertyValue(t, "borderLeftWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "borderRightWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingLeft")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingRight")) || 0);
                    return o(), d;
                  }
                }

                var f;
                f = r(t) === n ? e.getComputedStyle(t, null) : r(t).computedStyle ? r(t).computedStyle : r(t).computedStyle = e.getComputedStyle(t, null), "borderColor" === i && (i = "borderTopColor"), ("" === (l = 9 === h && "filter" === i ? f.getPropertyValue(i) : f[i]) || null === l) && (l = t.style[i]), o();
              }

              if ("auto" === l && /^(top|right|bottom|left)$/i.test(i)) {
                var v = s(t, "position");
                ("fixed" === v || "absolute" === v && /top|left/i.test(i)) && (l = p(t).position()[i] + "px");
              }

              return l;
            }

            var l;

            if (k.Hooks.registered[i]) {
              var c = i,
                  u = k.Hooks.getRoot(c);
              o === n && (o = k.getPropertyValue(t, k.Names.prefixCheck(u)[0])), k.Normalizations.registered[u] && (o = k.Normalizations.registered[u]("extract", t, o)), l = k.Hooks.extractValue(c, o);
            } else if (k.Normalizations.registered[i]) {
              var d, f;
              "transform" !== (d = k.Normalizations.registered[i]("name", t)) && (f = s(t, k.Names.prefixCheck(d)[0]), k.Values.isCSSNullValue(f) && k.Hooks.templates[i] && (f = k.Hooks.templates[i][1])), l = k.Normalizations.registered[i]("extract", t, f);
            }

            if (!/^[\d-]/.test(l)) if (r(t) && r(t).isSVG && k.Names.SVGAttribute(i)) {
              if (/^(height|width)$/i.test(i)) try {
                l = t.getBBox()[i];
              } catch (t) {
                l = 0;
              } else l = t.getAttribute(i);
            } else l = s(t, k.Names.prefixCheck(i)[0]);
            return k.Values.isCSSNullValue(l) && (l = 0), b.debug >= 2 && console.log("Get " + i + ": " + l), l;
          },
          setPropertyValue: function setPropertyValue(t, i, n, o, a) {
            var s = i;
            if ("scroll" === i) a.container ? a.container["scroll" + a.direction] = n : "Left" === a.direction ? e.scrollTo(n, a.alternateValue) : e.scrollTo(a.alternateValue, n);else if (k.Normalizations.registered[i] && "transform" === k.Normalizations.registered[i]("name", t)) k.Normalizations.registered[i]("inject", t, n), s = "transform", n = r(t).transformCache[i];else {
              if (k.Hooks.registered[i]) {
                var l = i,
                    c = k.Hooks.getRoot(i);
                o = o || k.getPropertyValue(t, c), n = k.Hooks.injectValue(l, n, o), i = c;
              }

              if (k.Normalizations.registered[i] && (n = k.Normalizations.registered[i]("inject", t, n), i = k.Normalizations.registered[i]("name", t)), s = k.Names.prefixCheck(i)[0], 8 >= h) try {
                t.style[s] = n;
              } catch (t) {
                b.debug && console.log("Browser does not support [" + n + "] for [" + s + "]");
              } else r(t) && r(t).isSVG && k.Names.SVGAttribute(i) ? t.setAttribute(i, n) : t.style[s] = n;
              b.debug >= 2 && console.log("Set " + i + " (" + s + "): " + n);
            }
            return [s, n];
          },
          flushTransformCache: function flushTransformCache(t) {
            function e(e) {
              return parseFloat(k.getPropertyValue(t, e));
            }

            var i = "";

            if ((h || b.State.isAndroid && !b.State.isChrome) && r(t).isSVG) {
              var n = {
                translate: [e("translateX"), e("translateY")],
                skewX: [e("skewX")],
                skewY: [e("skewY")],
                scale: 1 !== e("scale") ? [e("scale"), e("scale")] : [e("scaleX"), e("scaleY")],
                rotate: [e("rotateZ"), 0, 0]
              };
              p.each(r(t).transformCache, function (t) {
                /^translate/i.test(t) ? t = "translate" : /^scale/i.test(t) ? t = "scale" : /^rotate/i.test(t) && (t = "rotate"), n[t] && (i += t + "(" + n[t].join(" ") + ") ", delete n[t]);
              });
            } else {
              var o, a;
              p.each(r(t).transformCache, function (e) {
                return o = r(t).transformCache[e], "transformPerspective" === e ? (a = o, !0) : (9 === h && "rotateZ" === e && (e = "rotate"), void (i += e + o + " "));
              }), a && (i = "perspective" + a + " " + i);
            }

            k.setPropertyValue(t, "transform", i);
          }
        };
        k.Hooks.register(), k.Normalizations.register(), b.hook = function (t, e, i) {
          var o = n;
          return t = a(t), p.each(t, function (t, a) {
            if (r(a) === n && b.init(a), i === n) o === n && (o = b.CSS.getPropertyValue(a, e));else {
              var s = b.CSS.setPropertyValue(a, e, i);
              "transform" === s[0] && b.CSS.flushTransformCache(a), o = s;
            }
          }), o;
        };

        var x = function x() {
          function t() {
            return s ? P.promise || null : l;
          }

          function o() {
            function t(t) {
              function d(t, e) {
                var i = n,
                    o = n,
                    r = n;
                return v.isArray(t) ? (i = t[0], !v.isArray(t[1]) && /^[\d-]/.test(t[1]) || v.isFunction(t[1]) || k.RegEx.isHex.test(t[1]) ? r = t[1] : (v.isString(t[1]) && !k.RegEx.isHex.test(t[1]) || v.isArray(t[1])) && (o = e ? t[1] : c(t[1], s.duration), t[2] !== n && (r = t[2]))) : i = t, e || (o = o || s.easing), v.isFunction(i) && (i = i.call(a, T, C)), v.isFunction(r) && (r = r.call(a, T, C)), [i || 0, o, r];
              }

              function h(t, e) {
                var i, n;
                return n = (e || "0").toString().toLowerCase().replace(/[%A-z]+$/, function (t) {
                  return i = t, "";
                }), i || (i = k.Values.getUnitType(t)), [n, i];
              }

              if (s.begin && 0 === T) try {
                s.begin.call(f, f);
              } catch (t) {
                setTimeout(function () {
                  throw t;
                }, 1);
              }

              if ("scroll" === A) {
                var g,
                    w,
                    x,
                    S = /^x$/i.test(s.axis) ? "Left" : "Top",
                    O = parseFloat(s.offset) || 0;
                s.container ? v.isWrapped(s.container) || v.isNode(s.container) ? (s.container = s.container[0] || s.container, g = s.container["scroll" + S], x = g + p(a).position()[S.toLowerCase()] + O) : s.container = null : (g = b.State.scrollAnchor[b.State["scrollProperty" + S]], w = b.State.scrollAnchor[b.State["scrollProperty" + ("Left" === S ? "Top" : "Left")]], x = p(a).offset()[S.toLowerCase()] + O), l = {
                  scroll: {
                    rootPropertyValue: !1,
                    startValue: g,
                    currentValue: g,
                    endValue: x,
                    unitType: "",
                    easing: s.easing,
                    scrollData: {
                      container: s.container,
                      direction: S,
                      alternateValue: w
                    }
                  },
                  element: a
                }, b.debug && console.log("tweensContainer (scroll): ", l.scroll, a);
              } else if ("reverse" === A) {
                if (!r(a).tweensContainer) return void p.dequeue(a, s.queue);
                "none" === r(a).opts.display && (r(a).opts.display = "auto"), "hidden" === r(a).opts.visibility && (r(a).opts.visibility = "visible"), r(a).opts.loop = !1, r(a).opts.begin = null, r(a).opts.complete = null, y.easing || delete s.easing, y.duration || delete s.duration, s = p.extend({}, r(a).opts, s);
                M = p.extend(!0, {}, r(a).tweensContainer);

                for (var E in M) {
                  if ("element" !== E) {
                    var _ = M[E].startValue;
                    M[E].startValue = M[E].currentValue = M[E].endValue, M[E].endValue = _, v.isEmptyObject(y) || (M[E].easing = s.easing), b.debug && console.log("reverse tweensContainer (" + E + "): " + JSON.stringify(M[E]), a);
                  }
                }

                l = M;
              } else if ("start" === A) {
                var M;
                r(a).tweensContainer && !0 === r(a).isAnimating && (M = r(a).tweensContainer), p.each(m, function (t, e) {
                  if (RegExp("^" + k.Lists.colors.join("$|^") + "$").test(t)) {
                    var i = d(e, !0),
                        o = i[0],
                        a = i[1],
                        r = i[2];

                    if (k.RegEx.isHex.test(o)) {
                      for (var s = ["Red", "Green", "Blue"], l = k.Values.hexToRgb(o), c = r ? k.Values.hexToRgb(r) : n, u = 0; u < s.length; u++) {
                        var p = [l[u]];
                        a && p.push(a), c !== n && p.push(c[u]), m[t + s[u]] = p;
                      }

                      delete m[t];
                    }
                  }
                });

                for (var q in m) {
                  var z = d(m[q]),
                      V = z[0],
                      H = z[1],
                      L = z[2];
                  q = k.Names.camelCase(q);
                  var j = k.Hooks.getRoot(q),
                      $ = !1;

                  if (r(a).isSVG || "tween" === j || !1 !== k.Names.prefixCheck(j)[1] || k.Normalizations.registered[j] !== n) {
                    (s.display !== n && null !== s.display && "none" !== s.display || s.visibility !== n && "hidden" !== s.visibility) && /opacity|filter/.test(q) && !L && 0 !== V && (L = 0), s._cacheValues && M && M[q] ? (L === n && (L = M[q].endValue + M[q].unitType), $ = r(a).rootPropertyValueCache[j]) : k.Hooks.registered[q] ? L === n ? ($ = k.getPropertyValue(a, j), L = k.getPropertyValue(a, q, $)) : $ = k.Hooks.templates[j][1] : L === n && (L = k.getPropertyValue(a, q));
                    var N,
                        W,
                        F,
                        Q = !1;
                    if (N = h(q, L), L = N[0], F = N[1], N = h(q, V), V = N[0].replace(/^([+-\/*])=/, function (t, e) {
                      return Q = e, "";
                    }), W = N[1], L = parseFloat(L) || 0, V = parseFloat(V) || 0, "%" === W && (/^(fontSize|lineHeight)$/.test(q) ? (V /= 100, W = "em") : /^scale/.test(q) ? (V /= 100, W = "") : /(Red|Green|Blue)$/i.test(q) && (V = V / 100 * 255, W = "")), /[\/*]/.test(Q)) W = F;else if (F !== W && 0 !== L) if (0 === V) W = F;else {
                      o = o || function () {
                        var t = {
                          myParent: a.parentNode || i.body,
                          position: k.getPropertyValue(a, "position"),
                          fontSize: k.getPropertyValue(a, "fontSize")
                        },
                            n = t.position === I.lastPosition && t.myParent === I.lastParent,
                            o = t.fontSize === I.lastFontSize;
                        I.lastParent = t.myParent, I.lastPosition = t.position, I.lastFontSize = t.fontSize;
                        var s = 100,
                            l = {};
                        if (o && n) l.emToPx = I.lastEmToPx, l.percentToPxWidth = I.lastPercentToPxWidth, l.percentToPxHeight = I.lastPercentToPxHeight;else {
                          var c = r(a).isSVG ? i.createElementNS("http://www.w3.org/2000/svg", "rect") : i.createElement("div");
                          b.init(c), t.myParent.appendChild(c), p.each(["overflow", "overflowX", "overflowY"], function (t, e) {
                            b.CSS.setPropertyValue(c, e, "hidden");
                          }), b.CSS.setPropertyValue(c, "position", t.position), b.CSS.setPropertyValue(c, "fontSize", t.fontSize), b.CSS.setPropertyValue(c, "boxSizing", "content-box"), p.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function (t, e) {
                            b.CSS.setPropertyValue(c, e, s + "%");
                          }), b.CSS.setPropertyValue(c, "paddingLeft", s + "em"), l.percentToPxWidth = I.lastPercentToPxWidth = (parseFloat(k.getPropertyValue(c, "width", null, !0)) || 1) / s, l.percentToPxHeight = I.lastPercentToPxHeight = (parseFloat(k.getPropertyValue(c, "height", null, !0)) || 1) / s, l.emToPx = I.lastEmToPx = (parseFloat(k.getPropertyValue(c, "paddingLeft")) || 1) / s, t.myParent.removeChild(c);
                        }
                        return null === I.remToPx && (I.remToPx = parseFloat(k.getPropertyValue(i.body, "fontSize")) || 16), null === I.vwToPx && (I.vwToPx = parseFloat(e.innerWidth) / 100, I.vhToPx = parseFloat(e.innerHeight) / 100), l.remToPx = I.remToPx, l.vwToPx = I.vwToPx, l.vhToPx = I.vhToPx, b.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(l), a), l;
                      }();

                      var X = /margin|padding|left|right|width|text|word|letter/i.test(q) || /X$/.test(q) || "x" === q ? "x" : "y";

                      switch (F) {
                        case "%":
                          L *= "x" === X ? o.percentToPxWidth : o.percentToPxHeight;
                          break;

                        case "px":
                          break;

                        default:
                          L *= o[F + "ToPx"];
                      }

                      switch (W) {
                        case "%":
                          L *= 1 / ("x" === X ? o.percentToPxWidth : o.percentToPxHeight);
                          break;

                        case "px":
                          break;

                        default:
                          L *= 1 / o[W + "ToPx"];
                      }
                    }

                    switch (Q) {
                      case "+":
                        V = L + V;
                        break;

                      case "-":
                        V = L - V;
                        break;

                      case "*":
                        V *= L;
                        break;

                      case "/":
                        V = L / V;
                    }

                    l[q] = {
                      rootPropertyValue: $,
                      startValue: L,
                      currentValue: L,
                      endValue: V,
                      unitType: W,
                      easing: H
                    }, b.debug && console.log("tweensContainer (" + q + "): " + JSON.stringify(l[q]), a);
                  } else b.debug && console.log("Skipping [" + j + "] due to a lack of browser support.");
                }

                l.element = a;
              }

              l.element && (k.Values.addClass(a, "velocity-animating"), D.push(l), "" === s.queue && (r(a).tweensContainer = l, r(a).opts = s), r(a).isAnimating = !0, T === C - 1 ? (b.State.calls.push([D, f, s, null, P.resolver]), !1 === b.State.isTicking && (b.State.isTicking = !0, u())) : T++);
            }

            var o,
                a = this,
                s = p.extend({}, b.defaults, y),
                l = {};

            switch (r(a) === n && b.init(a), parseFloat(s.delay) && !1 !== s.queue && p.queue(a, s.queue, function (t) {
              b.velocityQueueEntryFlag = !0, r(a).delayTimer = {
                setTimeout: setTimeout(t, parseFloat(s.delay)),
                next: t
              };
            }), s.duration.toString().toLowerCase()) {
              case "fast":
                s.duration = 200;
                break;

              case "normal":
                s.duration = g;
                break;

              case "slow":
                s.duration = 600;
                break;

              default:
                s.duration = parseFloat(s.duration) || 1;
            }

            !1 !== b.mock && (!0 === b.mock ? s.duration = s.delay = 1 : (s.duration *= parseFloat(b.mock) || 1, s.delay *= parseFloat(b.mock) || 1)), s.easing = c(s.easing, s.duration), s.begin && !v.isFunction(s.begin) && (s.begin = null), s.progress && !v.isFunction(s.progress) && (s.progress = null), s.complete && !v.isFunction(s.complete) && (s.complete = null), s.display !== n && null !== s.display && (s.display = s.display.toString().toLowerCase(), "auto" === s.display && (s.display = b.CSS.Values.getDisplayType(a))), s.visibility !== n && null !== s.visibility && (s.visibility = s.visibility.toString().toLowerCase()), s.mobileHA = s.mobileHA && b.State.isMobile && !b.State.isGingerbread, !1 === s.queue ? s.delay ? setTimeout(t, s.delay) : t() : p.queue(a, s.queue, function (e, i) {
              return !0 === i ? (P.promise && P.resolver(f), !0) : (b.velocityQueueEntryFlag = !0, void t(e));
            }), "" !== s.queue && "fx" !== s.queue || "inprogress" === p.queue(a)[0] || p.dequeue(a);
          }

          var s,
              l,
              h,
              f,
              m,
              y,
              w = arguments[0] && (arguments[0].p || p.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || v.isString(arguments[0].properties));

          if (v.isWrapped(this) ? (s = !1, h = 0, f = this, l = this) : (s = !0, h = 1, f = w ? arguments[0].elements || arguments[0].e : arguments[0]), f = a(f)) {
            w ? (m = arguments[0].properties || arguments[0].p, y = arguments[0].options || arguments[0].o) : (m = arguments[h], y = arguments[h + 1]);
            var C = f.length,
                T = 0;

            if (!/^(stop|finish)$/i.test(m) && !p.isPlainObject(y)) {
              y = {};

              for (var S = h + 1; S < arguments.length; S++) {
                v.isArray(arguments[S]) || !/^(fast|normal|slow)$/i.test(arguments[S]) && !/^\d/.test(arguments[S]) ? v.isString(arguments[S]) || v.isArray(arguments[S]) ? y.easing = arguments[S] : v.isFunction(arguments[S]) && (y.complete = arguments[S]) : y.duration = arguments[S];
              }
            }

            var P = {
              promise: null,
              resolver: null,
              rejecter: null
            };
            s && b.Promise && (P.promise = new b.Promise(function (t, e) {
              P.resolver = t, P.rejecter = e;
            }));
            var A;

            switch (m) {
              case "scroll":
                A = "scroll";
                break;

              case "reverse":
                A = "reverse";
                break;

              case "finish":
              case "stop":
                p.each(f, function (t, e) {
                  r(e) && r(e).delayTimer && (clearTimeout(r(e).delayTimer.setTimeout), r(e).delayTimer.next && r(e).delayTimer.next(), delete r(e).delayTimer);
                });
                var O = [];
                return p.each(b.State.calls, function (t, e) {
                  e && p.each(e[1], function (i, o) {
                    var a = y === n ? "" : y;
                    return !0 !== a && e[2].queue !== a && (y !== n || !1 !== e[2].queue) || void p.each(f, function (i, n) {
                      n === o && ((!0 === y || v.isString(y)) && (p.each(p.queue(n, v.isString(y) ? y : ""), function (t, e) {
                        v.isFunction(e) && e(null, !0);
                      }), p.queue(n, v.isString(y) ? y : "", [])), "stop" === m ? (r(n) && r(n).tweensContainer && !1 !== a && p.each(r(n).tweensContainer, function (t, e) {
                        e.endValue = e.currentValue;
                      }), O.push(t)) : "finish" === m && (e[2].duration = 1));
                    });
                  });
                }), "stop" === m && (p.each(O, function (t, e) {
                  d(e, !0);
                }), P.promise && P.resolver(f)), t();

              default:
                if (!p.isPlainObject(m) || v.isEmptyObject(m)) {
                  if (v.isString(m) && b.Redirects[m]) {
                    var E = (z = p.extend({}, y)).duration,
                        _ = z.delay || 0;

                    return !0 === z.backwards && (f = p.extend(!0, [], f).reverse()), p.each(f, function (t, e) {
                      parseFloat(z.stagger) ? z.delay = _ + parseFloat(z.stagger) * t : v.isFunction(z.stagger) && (z.delay = _ + z.stagger.call(e, t, C)), z.drag && (z.duration = parseFloat(E) || (/^(callout|transition)/.test(m) ? 1e3 : g), z.duration = Math.max(z.duration * (z.backwards ? 1 - t / C : (t + 1) / C), .75 * z.duration, 200)), b.Redirects[m].call(e, e, z || {}, t, C, f, P.promise ? P : n);
                    }), t();
                  }

                  var M = "Velocity: First argument (" + m + ") was not a property map, a known action, or a registered redirect. Aborting.";
                  return P.promise ? P.rejecter(new Error(M)) : console.log(M), t();
                }

                A = "start";
            }

            var I = {
              lastParent: null,
              lastPosition: null,
              lastFontSize: null,
              lastPercentToPxWidth: null,
              lastPercentToPxHeight: null,
              lastEmToPx: null,
              remToPx: null,
              vwToPx: null,
              vhToPx: null
            },
                D = [];
            p.each(f, function (t, e) {
              v.isNode(e) && o.call(e);
            });
            var q,
                z = p.extend({}, b.defaults, y);
            if (z.loop = parseInt(z.loop), q = 2 * z.loop - 1, z.loop) for (var V = 0; q > V; V++) {
              var H = {
                delay: z.delay,
                progress: z.progress
              };
              V === q - 1 && (H.display = z.display, H.visibility = z.visibility, H.complete = z.complete), x(f, "reverse", H);
            }
            return t();
          }
        };

        (b = p.extend(x, b)).animate = x;
        var C = e.requestAnimationFrame || f;
        return b.State.isMobile || i.hidden === n || i.addEventListener("visibilitychange", function () {
          i.hidden ? (C = function C(t) {
            return setTimeout(function () {
              t(!0);
            }, 16);
          }, u()) : C = e.requestAnimationFrame || f;
        }), t.Velocity = b, t !== e && (t.fn.velocity = x, t.fn.velocity.defaults = b.defaults), p.each(["Down", "Up"], function (t, e) {
          b.Redirects["slide" + e] = function (t, i, o, a, r, s) {
            var l = p.extend({}, i),
                c = l.begin,
                u = l.complete,
                d = {
              height: "",
              marginTop: "",
              marginBottom: "",
              paddingTop: "",
              paddingBottom: ""
            },
                h = {};
            l.display === n && (l.display = "Down" === e ? "inline" === b.CSS.Values.getDisplayType(t) ? "inline-block" : "block" : "none"), l.begin = function () {
              c && c.call(r, r);

              for (var i in d) {
                h[i] = t.style[i];
                var n = b.CSS.getPropertyValue(t, i);
                d[i] = "Down" === e ? [n, 0] : [0, n];
              }

              h.overflow = t.style.overflow, t.style.overflow = "hidden";
            }, l.complete = function () {
              for (var e in h) {
                t.style[e] = h[e];
              }

              u && u.call(r, r), s && s.resolver(r);
            }, b(t, d, l);
          };
        }), p.each(["In", "Out"], function (t, e) {
          b.Redirects["fade" + e] = function (t, i, o, a, r, s) {
            var l = p.extend({}, i),
                c = {
              opacity: "In" === e ? 1 : 0
            },
                u = l.complete;
            l.complete = o !== a - 1 ? l.begin = null : function () {
              u && u.call(r, r), s && s.resolver(r);
            }, l.display === n && (l.display = "In" === e ? "auto" : "none"), b(this, c, l);
          };
        }), b;
      }

      jQuery.fn.velocity = jQuery.fn.animate;
    }
  }(window.jQuery || window.Zepto || window, window, document);
})), function (t, e, i, n) {
  "use strict";

  function o(t, e, i) {
    return setTimeout(u(t, i), e);
  }

  function a(t, e, i) {
    return !!Array.isArray(t) && (r(t, i[e], i), !0);
  }

  function r(t, e, i) {
    var o;
    if (t) if (t.forEach) t.forEach(e, i);else if (t.length !== n) for (o = 0; o < t.length;) {
      e.call(i, t[o], o, t), o++;
    } else for (o in t) {
      t.hasOwnProperty(o) && e.call(i, t[o], o, t);
    }
  }

  function s(t, e, i) {
    for (var o = Object.keys(e), a = 0; a < o.length;) {
      (!i || i && t[o[a]] === n) && (t[o[a]] = e[o[a]]), a++;
    }

    return t;
  }

  function l(t, e) {
    return s(t, e, !0);
  }

  function c(t, e, i) {
    var n,
        o = e.prototype;
    (n = t.prototype = Object.create(o)).constructor = t, n._super = o, i && s(n, i);
  }

  function u(t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }

  function d(t, e) {
    return _typeof(t) == ut ? t.apply(e ? e[0] || n : n, e) : t;
  }

  function p(t, e) {
    return t === n ? e : t;
  }

  function h(t, e, i) {
    r(g(e), function (e) {
      t.addEventListener(e, i, !1);
    });
  }

  function f(t, e, i) {
    r(g(e), function (e) {
      t.removeEventListener(e, i, !1);
    });
  }

  function v(t, e) {
    for (; t;) {
      if (t == e) return !0;
      t = t.parentNode;
    }

    return !1;
  }

  function m(t, e) {
    return t.indexOf(e) > -1;
  }

  function g(t) {
    return t.trim().split(/\s+/g);
  }

  function y(t, e, i) {
    if (t.indexOf && !i) return t.indexOf(e);

    for (var n = 0; n < t.length;) {
      if (i && t[n][i] == e || !i && t[n] === e) return n;
      n++;
    }

    return -1;
  }

  function b(t) {
    return Array.prototype.slice.call(t, 0);
  }

  function w(t, e, i) {
    for (var n = [], o = [], a = 0; a < t.length;) {
      var r = e ? t[a][e] : t[a];
      y(o, r) < 0 && n.push(t[a]), o[a] = r, a++;
    }

    return i && (n = e ? n.sort(function (t, i) {
      return t[e] > i[e];
    }) : n.sort()), n;
  }

  function k(t, e) {
    for (var i, o, a = e[0].toUpperCase() + e.slice(1), r = 0; r < lt.length;) {
      if (i = lt[r], (o = i ? i + a : e) in t) return o;
      r++;
    }

    return n;
  }

  function x() {
    return ft++;
  }

  function C(t) {
    var e = t.ownerDocument;
    return e.defaultView || e.parentWindow;
  }

  function T(t, e) {
    var i = this;
    this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function (e) {
      d(t.options.enable, [t]) && i.handler(e);
    }, this.init();
  }

  function S(t) {
    var e = t.options.inputClass;
    return new (e || (gt ? j : yt ? W : mt ? Q : L))(t, P);
  }

  function P(t, e, i) {
    var n = i.pointers.length,
        o = i.changedPointers.length,
        a = e & xt && 0 == n - o,
        r = e & (Tt | St) && 0 == n - o;
    i.isFirst = !!a, i.isFinal = !!r, a && (t.session = {}), i.eventType = e, A(t, i), t.emit("hammer.input", i), t.recognize(i), t.session.prevInput = i;
  }

  function A(t, e) {
    var i = t.session,
        n = e.pointers,
        o = n.length;
    i.firstInput || (i.firstInput = _(e)), o > 1 && !i.firstMultiple ? i.firstMultiple = _(e) : 1 === o && (i.firstMultiple = !1);
    var a = i.firstInput,
        r = i.firstMultiple,
        s = r ? r.center : a.center,
        l = e.center = M(n);
    e.timeStamp = ht(), e.deltaTime = e.timeStamp - a.timeStamp, e.angle = z(s, l), e.distance = q(s, l), O(i, e), e.offsetDirection = D(e.deltaX, e.deltaY), e.scale = r ? H(r.pointers, n) : 1, e.rotation = r ? V(r.pointers, n) : 0, E(i, e);
    var c = t.element;
    v(e.srcEvent.target, c) && (c = e.srcEvent.target), e.target = c;
  }

  function O(t, e) {
    var i = e.center,
        n = t.offsetDelta || {},
        o = t.prevDelta || {},
        a = t.prevInput || {};
    (e.eventType === xt || a.eventType === Tt) && (o = t.prevDelta = {
      x: a.deltaX || 0,
      y: a.deltaY || 0
    }, n = t.offsetDelta = {
      x: i.x,
      y: i.y
    }), e.deltaX = o.x + (i.x - n.x), e.deltaY = o.y + (i.y - n.y);
  }

  function E(t, e) {
    var i,
        o,
        a,
        r,
        s = t.lastInterval || e,
        l = e.timeStamp - s.timeStamp;

    if (e.eventType != St && (l > kt || s.velocity === n)) {
      var c = s.deltaX - e.deltaX,
          u = s.deltaY - e.deltaY,
          d = I(l, c, u);
      o = d.x, a = d.y, i = pt(d.x) > pt(d.y) ? d.x : d.y, r = D(c, u), t.lastInterval = e;
    } else i = s.velocity, o = s.velocityX, a = s.velocityY, r = s.direction;

    e.velocity = i, e.velocityX = o, e.velocityY = a, e.direction = r;
  }

  function _(t) {
    for (var e = [], i = 0; i < t.pointers.length;) {
      e[i] = {
        clientX: dt(t.pointers[i].clientX),
        clientY: dt(t.pointers[i].clientY)
      }, i++;
    }

    return {
      timeStamp: ht(),
      pointers: e,
      center: M(e),
      deltaX: t.deltaX,
      deltaY: t.deltaY
    };
  }

  function M(t) {
    var e = t.length;
    if (1 === e) return {
      x: dt(t[0].clientX),
      y: dt(t[0].clientY)
    };

    for (var i = 0, n = 0, o = 0; e > o;) {
      i += t[o].clientX, n += t[o].clientY, o++;
    }

    return {
      x: dt(i / e),
      y: dt(n / e)
    };
  }

  function I(t, e, i) {
    return {
      x: e / t || 0,
      y: i / t || 0
    };
  }

  function D(t, e) {
    return t === e ? Pt : pt(t) >= pt(e) ? t > 0 ? At : Ot : e > 0 ? Et : _t;
  }

  function q(t, e, i) {
    i || (i = qt);
    var n = e[i[0]] - t[i[0]],
        o = e[i[1]] - t[i[1]];
    return Math.sqrt(n * n + o * o);
  }

  function z(t, e, i) {
    i || (i = qt);
    var n = e[i[0]] - t[i[0]],
        o = e[i[1]] - t[i[1]];
    return 180 * Math.atan2(o, n) / Math.PI;
  }

  function V(t, e) {
    return z(e[1], e[0], zt) - z(t[1], t[0], zt);
  }

  function H(t, e) {
    return q(e[0], e[1], zt) / q(t[0], t[1], zt);
  }

  function L() {
    this.evEl = Ht, this.evWin = Lt, this.allow = !0, this.pressed = !1, T.apply(this, arguments);
  }

  function j() {
    this.evEl = Nt, this.evWin = Wt, T.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
  }

  function $() {
    this.evTarget = Qt, this.evWin = Xt, this.started = !1, T.apply(this, arguments);
  }

  function N(t, e) {
    var i = b(t.touches),
        n = b(t.changedTouches);
    return e & (Tt | St) && (i = w(i.concat(n), "identifier", !0)), [i, n];
  }

  function W() {
    this.evTarget = Yt, this.targetIds = {}, T.apply(this, arguments);
  }

  function F(t, e) {
    var i = b(t.touches),
        n = this.targetIds;
    if (e & (xt | Ct) && 1 === i.length) return n[i[0].identifier] = !0, [i, i];
    var o,
        a,
        r = b(t.changedTouches),
        s = [],
        l = this.target;
    if (a = i.filter(function (t) {
      return v(t.target, l);
    }), e === xt) for (o = 0; o < a.length;) {
      n[a[o].identifier] = !0, o++;
    }

    for (o = 0; o < r.length;) {
      n[r[o].identifier] && s.push(r[o]), e & (Tt | St) && delete n[r[o].identifier], o++;
    }

    return s.length ? [w(a.concat(s), "identifier", !0), s] : void 0;
  }

  function Q() {
    T.apply(this, arguments);
    var t = u(this.handler, this);
    this.touch = new W(this.manager, t), this.mouse = new L(this.manager, t);
  }

  function X(t, e) {
    this.manager = t, this.set(e);
  }

  function R(t) {
    if (m(t, Kt)) return Kt;
    var e = m(t, te),
        i = m(t, ee);
    return e && i ? te + " " + ee : e || i ? e ? te : ee : m(t, Jt) ? Jt : Zt;
  }

  function Y(t) {
    this.id = x(), this.manager = null, this.options = l(t || {}, this.defaults), this.options.enable = p(this.options.enable, !0), this.state = ie, this.simultaneous = {}, this.requireFail = [];
  }

  function B(t) {
    return t & se ? "cancel" : t & ae ? "end" : t & oe ? "move" : t & ne ? "start" : "";
  }

  function U(t) {
    return t == _t ? "down" : t == Et ? "up" : t == At ? "left" : t == Ot ? "right" : "";
  }

  function G(t, e) {
    var i = e.manager;
    return i ? i.get(t) : t;
  }

  function Z() {
    Y.apply(this, arguments);
  }

  function J() {
    Z.apply(this, arguments), this.pX = null, this.pY = null;
  }

  function K() {
    Z.apply(this, arguments);
  }

  function tt() {
    Y.apply(this, arguments), this._timer = null, this._input = null;
  }

  function et() {
    Z.apply(this, arguments);
  }

  function it() {
    Z.apply(this, arguments);
  }

  function nt() {
    Y.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
  }

  function ot(t, e) {
    return e = e || {}, e.recognizers = p(e.recognizers, ot.defaults.preset), new at(t, e);
  }

  function at(t, e) {
    e = e || {}, this.options = l(e, ot.defaults), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.element = t, this.input = S(this), this.touchAction = new X(this, this.options.touchAction), rt(this, !0), r(e.recognizers, function (t) {
      var e = this.add(new t[0](t[1]));
      t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
    }, this);
  }

  function rt(t, e) {
    var i = t.element;
    r(t.options.cssProps, function (t, n) {
      i.style[k(i.style, n)] = e ? t : "";
    });
  }

  function st(t, i) {
    var n = e.createEvent("Event");
    n.initEvent(t, !0, !0), n.gesture = i, i.target.dispatchEvent(n);
  }

  var lt = ["", "webkit", "moz", "MS", "ms", "o"],
      ct = e.createElement("div"),
      ut = "function",
      dt = Math.round,
      pt = Math.abs,
      ht = Date.now,
      ft = 1,
      vt = /mobile|tablet|ip(ad|hone|od)|android/i,
      mt = ("ontouchstart" in t),
      gt = k(t, "PointerEvent") !== n,
      yt = mt && vt.test(navigator.userAgent),
      bt = "touch",
      wt = "mouse",
      kt = 25,
      xt = 1,
      Ct = 2,
      Tt = 4,
      St = 8,
      Pt = 1,
      At = 2,
      Ot = 4,
      Et = 8,
      _t = 16,
      Mt = At | Ot,
      It = Et | _t,
      Dt = Mt | It,
      qt = ["x", "y"],
      zt = ["clientX", "clientY"];
  T.prototype = {
    handler: function handler() {},
    init: function init() {
      this.evEl && h(this.element, this.evEl, this.domHandler), this.evTarget && h(this.target, this.evTarget, this.domHandler), this.evWin && h(C(this.element), this.evWin, this.domHandler);
    },
    destroy: function destroy() {
      this.evEl && f(this.element, this.evEl, this.domHandler), this.evTarget && f(this.target, this.evTarget, this.domHandler), this.evWin && f(C(this.element), this.evWin, this.domHandler);
    }
  };
  var Vt = {
    mousedown: xt,
    mousemove: Ct,
    mouseup: Tt
  },
      Ht = "mousedown",
      Lt = "mousemove mouseup";
  c(L, T, {
    handler: function handler(t) {
      var e = Vt[t.type];
      e & xt && 0 === t.button && (this.pressed = !0), e & Ct && 1 !== t.which && (e = Tt), this.pressed && this.allow && (e & Tt && (this.pressed = !1), this.callback(this.manager, e, {
        pointers: [t],
        changedPointers: [t],
        pointerType: wt,
        srcEvent: t
      }));
    }
  });
  var jt = {
    pointerdown: xt,
    pointermove: Ct,
    pointerup: Tt,
    pointercancel: St,
    pointerout: St
  },
      $t = {
    2: bt,
    3: "pen",
    4: wt,
    5: "kinect"
  },
      Nt = "pointerdown",
      Wt = "pointermove pointerup pointercancel";
  t.MSPointerEvent && (Nt = "MSPointerDown", Wt = "MSPointerMove MSPointerUp MSPointerCancel"), c(j, T, {
    handler: function handler(t) {
      var e = this.store,
          i = !1,
          n = t.type.toLowerCase().replace("ms", ""),
          o = jt[n],
          a = $t[t.pointerType] || t.pointerType,
          r = a == bt,
          s = y(e, t.pointerId, "pointerId");
      o & xt && (0 === t.button || r) ? 0 > s && (e.push(t), s = e.length - 1) : o & (Tt | St) && (i = !0), 0 > s || (e[s] = t, this.callback(this.manager, o, {
        pointers: e,
        changedPointers: [t],
        pointerType: a,
        srcEvent: t
      }), i && e.splice(s, 1));
    }
  });
  var Ft = {
    touchstart: xt,
    touchmove: Ct,
    touchend: Tt,
    touchcancel: St
  },
      Qt = "touchstart",
      Xt = "touchstart touchmove touchend touchcancel";
  c($, T, {
    handler: function handler(t) {
      var e = Ft[t.type];

      if (e === xt && (this.started = !0), this.started) {
        var i = N.call(this, t, e);
        e & (Tt | St) && 0 == i[0].length - i[1].length && (this.started = !1), this.callback(this.manager, e, {
          pointers: i[0],
          changedPointers: i[1],
          pointerType: bt,
          srcEvent: t
        });
      }
    }
  });
  var Rt = {
    touchstart: xt,
    touchmove: Ct,
    touchend: Tt,
    touchcancel: St
  },
      Yt = "touchstart touchmove touchend touchcancel";
  c(W, T, {
    handler: function handler(t) {
      var e = Rt[t.type],
          i = F.call(this, t, e);
      i && this.callback(this.manager, e, {
        pointers: i[0],
        changedPointers: i[1],
        pointerType: bt,
        srcEvent: t
      });
    }
  }), c(Q, T, {
    handler: function handler(t, e, i) {
      var n = i.pointerType == bt,
          o = i.pointerType == wt;
      if (n) this.mouse.allow = !1;else if (o && !this.mouse.allow) return;
      e & (Tt | St) && (this.mouse.allow = !0), this.callback(t, e, i);
    },
    destroy: function destroy() {
      this.touch.destroy(), this.mouse.destroy();
    }
  });
  var Bt = k(ct.style, "touchAction"),
      Ut = Bt !== n,
      Gt = "compute",
      Zt = "auto",
      Jt = "manipulation",
      Kt = "none",
      te = "pan-x",
      ee = "pan-y";
  X.prototype = {
    set: function set(t) {
      t == Gt && (t = this.compute()), Ut && (this.manager.element.style[Bt] = t), this.actions = t.toLowerCase().trim();
    },
    update: function update() {
      this.set(this.manager.options.touchAction);
    },
    compute: function compute() {
      var t = [];
      return r(this.manager.recognizers, function (e) {
        d(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
      }), R(t.join(" "));
    },
    preventDefaults: function preventDefaults(t) {
      if (!Ut) {
        var e = t.srcEvent,
            i = t.offsetDirection;
        if (this.manager.session.prevented) return void e.preventDefault();
        var n = this.actions,
            o = m(n, Kt),
            a = m(n, ee),
            r = m(n, te);
        return o || a && i & Mt || r && i & It ? this.preventSrc(e) : void 0;
      }
    },
    preventSrc: function preventSrc(t) {
      this.manager.session.prevented = !0, t.preventDefault();
    }
  };
  var ie = 1,
      ne = 2,
      oe = 4,
      ae = 8,
      re = ae,
      se = 16;
  Y.prototype = {
    defaults: {},
    set: function set(t) {
      return s(this.options, t), this.manager && this.manager.touchAction.update(), this;
    },
    recognizeWith: function recognizeWith(t) {
      if (a(t, "recognizeWith", this)) return this;
      var e = this.simultaneous;
      return t = G(t, this), e[t.id] || (e[t.id] = t, t.recognizeWith(this)), this;
    },
    dropRecognizeWith: function dropRecognizeWith(t) {
      return a(t, "dropRecognizeWith", this) ? this : (t = G(t, this), delete this.simultaneous[t.id], this);
    },
    requireFailure: function requireFailure(t) {
      if (a(t, "requireFailure", this)) return this;
      var e = this.requireFail;
      return t = G(t, this), -1 === y(e, t) && (e.push(t), t.requireFailure(this)), this;
    },
    dropRequireFailure: function dropRequireFailure(t) {
      if (a(t, "dropRequireFailure", this)) return this;
      t = G(t, this);
      var e = y(this.requireFail, t);
      return e > -1 && this.requireFail.splice(e, 1), this;
    },
    hasRequireFailures: function hasRequireFailures() {
      return this.requireFail.length > 0;
    },
    canRecognizeWith: function canRecognizeWith(t) {
      return !!this.simultaneous[t.id];
    },
    emit: function emit(t) {
      function e(e) {
        i.manager.emit(i.options.event + (e ? B(n) : ""), t);
      }

      var i = this,
          n = this.state;
      ae > n && e(!0), e(), n >= ae && e(!0);
    },
    tryEmit: function tryEmit(t) {
      return this.canEmit() ? this.emit(t) : void (this.state = 32);
    },
    canEmit: function canEmit() {
      for (var t = 0; t < this.requireFail.length;) {
        if (!(this.requireFail[t].state & (32 | ie))) return !1;
        t++;
      }

      return !0;
    },
    recognize: function recognize(t) {
      var e = s({}, t);
      return d(this.options.enable, [this, e]) ? (this.state & (re | se | 32) && (this.state = ie), this.state = this.process(e), void (this.state & (ne | oe | ae | se) && this.tryEmit(e))) : (this.reset(), void (this.state = 32));
    },
    process: function process() {},
    getTouchAction: function getTouchAction() {},
    reset: function reset() {}
  }, c(Z, Y, {
    defaults: {
      pointers: 1
    },
    attrTest: function attrTest(t) {
      var e = this.options.pointers;
      return 0 === e || t.pointers.length === e;
    },
    process: function process(t) {
      var e = this.state,
          i = t.eventType,
          n = e & (ne | oe),
          o = this.attrTest(t);
      return n && (i & St || !o) ? e | se : n || o ? i & Tt ? e | ae : e & ne ? e | oe : ne : 32;
    }
  }), c(J, Z, {
    defaults: {
      event: "pan",
      threshold: 10,
      pointers: 1,
      direction: Dt
    },
    getTouchAction: function getTouchAction() {
      var t = this.options.direction,
          e = [];
      return t & Mt && e.push(ee), t & It && e.push(te), e;
    },
    directionTest: function directionTest(t) {
      var e = this.options,
          i = !0,
          n = t.distance,
          o = t.direction,
          a = t.deltaX,
          r = t.deltaY;
      return o & e.direction || (e.direction & Mt ? (o = 0 === a ? Pt : 0 > a ? At : Ot, i = a != this.pX, n = Math.abs(t.deltaX)) : (o = 0 === r ? Pt : 0 > r ? Et : _t, i = r != this.pY, n = Math.abs(t.deltaY))), t.direction = o, i && n > e.threshold && o & e.direction;
    },
    attrTest: function attrTest(t) {
      return Z.prototype.attrTest.call(this, t) && (this.state & ne || !(this.state & ne) && this.directionTest(t));
    },
    emit: function emit(t) {
      this.pX = t.deltaX, this.pY = t.deltaY;
      var e = U(t.direction);
      e && this.manager.emit(this.options.event + e, t), this._super.emit.call(this, t);
    }
  }), c(K, Z, {
    defaults: {
      event: "pinch",
      threshold: 0,
      pointers: 2
    },
    getTouchAction: function getTouchAction() {
      return [Kt];
    },
    attrTest: function attrTest(t) {
      return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & ne);
    },
    emit: function emit(t) {
      if (this._super.emit.call(this, t), 1 !== t.scale) {
        var e = t.scale < 1 ? "in" : "out";
        this.manager.emit(this.options.event + e, t);
      }
    }
  }), c(tt, Y, {
    defaults: {
      event: "press",
      pointers: 1,
      time: 500,
      threshold: 5
    },
    getTouchAction: function getTouchAction() {
      return [Zt];
    },
    process: function process(t) {
      var e = this.options,
          i = t.pointers.length === e.pointers,
          n = t.distance < e.threshold,
          a = t.deltaTime > e.time;
      if (this._input = t, !n || !i || t.eventType & (Tt | St) && !a) this.reset();else if (t.eventType & xt) this.reset(), this._timer = o(function () {
        this.state = re, this.tryEmit();
      }, e.time, this);else if (t.eventType & Tt) return re;
      return 32;
    },
    reset: function reset() {
      clearTimeout(this._timer);
    },
    emit: function emit(t) {
      this.state === re && (t && t.eventType & Tt ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = ht(), this.manager.emit(this.options.event, this._input)));
    }
  }), c(et, Z, {
    defaults: {
      event: "rotate",
      threshold: 0,
      pointers: 2
    },
    getTouchAction: function getTouchAction() {
      return [Kt];
    },
    attrTest: function attrTest(t) {
      return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & ne);
    }
  }), c(it, Z, {
    defaults: {
      event: "swipe",
      threshold: 10,
      velocity: .65,
      direction: Mt | It,
      pointers: 1
    },
    getTouchAction: function getTouchAction() {
      return J.prototype.getTouchAction.call(this);
    },
    attrTest: function attrTest(t) {
      var e,
          i = this.options.direction;
      return i & (Mt | It) ? e = t.velocity : i & Mt ? e = t.velocityX : i & It && (e = t.velocityY), this._super.attrTest.call(this, t) && i & t.direction && t.distance > this.options.threshold && pt(e) > this.options.velocity && t.eventType & Tt;
    },
    emit: function emit(t) {
      var e = U(t.direction);
      e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
    }
  }), c(nt, Y, {
    defaults: {
      event: "tap",
      pointers: 1,
      taps: 1,
      interval: 300,
      time: 250,
      threshold: 2,
      posThreshold: 10
    },
    getTouchAction: function getTouchAction() {
      return [Jt];
    },
    process: function process(t) {
      var e = this.options,
          i = t.pointers.length === e.pointers,
          n = t.distance < e.threshold,
          a = t.deltaTime < e.time;
      if (this.reset(), t.eventType & xt && 0 === this.count) return this.failTimeout();

      if (n && a && i) {
        if (t.eventType != Tt) return this.failTimeout();
        var r = !this.pTime || t.timeStamp - this.pTime < e.interval,
            s = !this.pCenter || q(this.pCenter, t.center) < e.posThreshold;
        if (this.pTime = t.timeStamp, this.pCenter = t.center, s && r ? this.count += 1 : this.count = 1, this._input = t, 0 === this.count % e.taps) return this.hasRequireFailures() ? (this._timer = o(function () {
          this.state = re, this.tryEmit();
        }, e.interval, this), ne) : re;
      }

      return 32;
    },
    failTimeout: function failTimeout() {
      return this._timer = o(function () {
        this.state = 32;
      }, this.options.interval, this), 32;
    },
    reset: function reset() {
      clearTimeout(this._timer);
    },
    emit: function emit() {
      this.state == re && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
    }
  }), ot.VERSION = "2.0.4", ot.defaults = {
    domEvents: !1,
    touchAction: Gt,
    enable: !0,
    inputTarget: null,
    inputClass: null,
    preset: [[et, {
      enable: !1
    }], [K, {
      enable: !1
    }, ["rotate"]], [it, {
      direction: Mt
    }], [J, {
      direction: Mt
    }, ["swipe"]], [nt], [nt, {
      event: "doubletap",
      taps: 2
    }, ["tap"]], [tt]],
    cssProps: {
      userSelect: "default",
      touchSelect: "none",
      touchCallout: "none",
      contentZooming: "none",
      userDrag: "none",
      tapHighlightColor: "rgba(0,0,0,0)"
    }
  };
  at.prototype = {
    set: function set(t) {
      return s(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
    },
    stop: function stop(t) {
      this.session.stopped = t ? 2 : 1;
    },
    recognize: function recognize(t) {
      var e = this.session;

      if (!e.stopped) {
        this.touchAction.preventDefaults(t);
        var i,
            n = this.recognizers,
            o = e.curRecognizer;
        (!o || o && o.state & re) && (o = e.curRecognizer = null);

        for (var a = 0; a < n.length;) {
          i = n[a], 2 === e.stopped || o && i != o && !i.canRecognizeWith(o) ? i.reset() : i.recognize(t), !o && i.state & (ne | oe | ae) && (o = e.curRecognizer = i), a++;
        }
      }
    },
    get: function get(t) {
      if (t instanceof Y) return t;

      for (var e = this.recognizers, i = 0; i < e.length; i++) {
        if (e[i].options.event == t) return e[i];
      }

      return null;
    },
    add: function add(t) {
      if (a(t, "add", this)) return this;
      var e = this.get(t.options.event);
      return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
    },
    remove: function remove(t) {
      if (a(t, "remove", this)) return this;
      var e = this.recognizers;
      return t = this.get(t), e.splice(y(e, t), 1), this.touchAction.update(), this;
    },
    on: function on(t, e) {
      var i = this.handlers;
      return r(g(t), function (t) {
        i[t] = i[t] || [], i[t].push(e);
      }), this;
    },
    off: function off(t, e) {
      var i = this.handlers;
      return r(g(t), function (t) {
        e ? i[t].splice(y(i[t], e), 1) : delete i[t];
      }), this;
    },
    emit: function emit(t, e) {
      this.options.domEvents && st(t, e);
      var i = this.handlers[t] && this.handlers[t].slice();

      if (i && i.length) {
        e.type = t, e.preventDefault = function () {
          e.srcEvent.preventDefault();
        };

        for (var n = 0; n < i.length;) {
          i[n](e), n++;
        }
      }
    },
    destroy: function destroy() {
      this.element && rt(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
    }
  }, s(ot, {
    INPUT_START: xt,
    INPUT_MOVE: Ct,
    INPUT_END: Tt,
    INPUT_CANCEL: St,
    STATE_POSSIBLE: ie,
    STATE_BEGAN: ne,
    STATE_CHANGED: oe,
    STATE_ENDED: ae,
    STATE_RECOGNIZED: re,
    STATE_CANCELLED: se,
    STATE_FAILED: 32,
    DIRECTION_NONE: Pt,
    DIRECTION_LEFT: At,
    DIRECTION_RIGHT: Ot,
    DIRECTION_UP: Et,
    DIRECTION_DOWN: _t,
    DIRECTION_HORIZONTAL: Mt,
    DIRECTION_VERTICAL: It,
    DIRECTION_ALL: Dt,
    Manager: at,
    Input: T,
    TouchAction: X,
    TouchInput: W,
    MouseInput: L,
    PointerEventInput: j,
    TouchMouseInput: Q,
    SingleTouchInput: $,
    Recognizer: Y,
    AttrRecognizer: Z,
    Tap: nt,
    Pan: J,
    Swipe: it,
    Pinch: K,
    Rotate: et,
    Press: tt,
    on: h,
    off: f,
    each: r,
    merge: l,
    extend: s,
    inherit: c,
    bindFn: u,
    prefixed: k
  }), (typeof define === "undefined" ? "undefined" : _typeof(define)) == ut && define.amd ? define(function () {
    return ot;
  }) : "undefined" != typeof module && module.exports ? module.exports = ot : t.Hammer = ot;
}(window, document), function (t) {
  "function" == typeof define && define.amd ? define(["jquery", "hammerjs"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? t(require("jquery"), require("hammerjs")) : t(jQuery, Hammer);
}(function (t, e) {
  function i(i, n) {
    var o = t(i);
    o.data("hammer") || o.data("hammer", new e(o[0], n));
  }

  t.fn.hammer = function (t) {
    return this.each(function () {
      i(this, t);
    });
  }, e.Manager.prototype.emit = function (e) {
    return function (i, n) {
      e.call(this, i, n), t(this.element).trigger({
        type: i,
        gesture: n
      });
    };
  }(e.Manager.prototype.emit);
}), function (t) {
  t.Package ? Materialize = {} : t.Materialize = {};
}(window), "undefined" == typeof exports || exports.nodeType || ("undefined" != typeof module && !module.nodeType && module.exports && (exports = module.exports = Materialize), exports["default"] = Materialize), function (t) {
  for (var e = 0, i = ["webkit", "moz"], n = t.requestAnimationFrame, o = t.cancelAnimationFrame, a = i.length; --a >= 0 && !n;) {
    n = t[i[a] + "RequestAnimationFrame"], o = t[i[a] + "CancelRequestAnimationFrame"];
  }

  n && o || (n = function n(t) {
    var i = +Date.now(),
        n = Math.max(e + 16, i);
    return setTimeout(function () {
      t(e = n);
    }, n - i);
  }, o = clearTimeout), t.requestAnimationFrame = n, t.cancelAnimationFrame = o;
}(window), Materialize.objectSelectorString = function (t) {
  return ((t.prop("tagName") || "") + (t.attr("id") || "") + (t.attr("class") || "")).replace(/\s/g, "");
}, Materialize.guid = function () {
  function t() {
    return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
  }

  return function () {
    return t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t();
  };
}(), Materialize.escapeHash = function (t) {
  return t.replace(/(:|\.|\[|\]|,|=)/g, "\\$1");
}, Materialize.elementOrParentIsFixed = function (t) {
  var e = $(t),
      i = !1;
  return e.add(e.parents()).each(function () {
    if ("fixed" === $(this).css("position")) return i = !0, !1;
  }), i;
};

var getTime = Date.now || function () {
  return new Date().getTime();
};

Materialize.throttle = function (t, e, i) {
  var n,
      o,
      a,
      r = null,
      s = 0;
  i || (i = {});

  var l = function l() {
    s = !1 === i.leading ? 0 : getTime(), r = null, a = t.apply(n, o), n = o = null;
  };

  return function () {
    var c = getTime();
    s || !1 !== i.leading || (s = c);
    var u = e - (c - s);
    return n = this, o = arguments, u <= 0 ? (clearTimeout(r), r = null, s = c, a = t.apply(n, o), n = o = null) : r || !1 === i.trailing || (r = setTimeout(l, u)), a;
  };
};

var Vel;
Vel = jQuery ? jQuery.Velocity : $ ? $.Velocity : Velocity, Materialize.Vel = Vel || Velocity, function (t) {
  t.fn.collapsible = function (e, i) {
    var n = {
      accordion: void 0,
      onOpen: void 0,
      onClose: void 0
    },
        o = e;
    return e = t.extend(n, e), this.each(function () {
      function n(e) {
        p = d.find("> li > .collapsible-header"), e.hasClass("active") ? e.parent().addClass("active") : e.parent().removeClass("active"), e.parent().hasClass("active") ? e.siblings(".collapsible-body").stop(!0, !1).slideDown({
          duration: 350,
          easing: "easeOutQuart",
          queue: !1,
          complete: function complete() {
            t(this).css("height", "");
          }
        }) : e.siblings(".collapsible-body").stop(!0, !1).slideUp({
          duration: 350,
          easing: "easeOutQuart",
          queue: !1,
          complete: function complete() {
            t(this).css("height", "");
          }
        }), p.not(e).removeClass("active").parent().removeClass("active"), p.not(e).parent().children(".collapsible-body").stop(!0, !1).each(function () {
          t(this).is(":visible") && t(this).slideUp({
            duration: 350,
            easing: "easeOutQuart",
            queue: !1,
            complete: function complete() {
              t(this).css("height", ""), s(t(this).siblings(".collapsible-header"));
            }
          });
        });
      }

      function a(e) {
        e.hasClass("active") ? e.parent().addClass("active") : e.parent().removeClass("active"), e.parent().hasClass("active") ? e.siblings(".collapsible-body").stop(!0, !1).slideDown({
          duration: 350,
          easing: "easeOutQuart",
          queue: !1,
          complete: function complete() {
            t(this).css("height", "");
          }
        }) : e.siblings(".collapsible-body").stop(!0, !1).slideUp({
          duration: 350,
          easing: "easeOutQuart",
          queue: !1,
          complete: function complete() {
            t(this).css("height", "");
          }
        });
      }

      function r(t, i) {
        i || t.toggleClass("active"), e.accordion || "accordion" === h || void 0 === h ? n(t) : a(t), s(t);
      }

      function s(t) {
        t.hasClass("active") ? "function" == typeof e.onOpen && e.onOpen.call(this, t.parent()) : "function" == typeof e.onClose && e.onClose.call(this, t.parent());
      }

      function l(t) {
        return c(t).length > 0;
      }

      function c(t) {
        return t.closest("li > .collapsible-header");
      }

      function u() {
        d.off("click.collapse", "> li > .collapsible-header");
      }

      var d = t(this),
          p = t(this).find("> li > .collapsible-header"),
          h = d.data("collapsible");
      if ("destroy" !== o) {
        if (i >= 0 && i < p.length) {
          var f = p.eq(i);
          f.length && ("open" === o || "close" === o && f.hasClass("active")) && r(f);
        } else u(), d.on("click.collapse", "> li > .collapsible-header", function (e) {
          var i = t(e.target);
          l(i) && (i = c(i)), r(i);
        }), e.accordion || "accordion" === h || void 0 === h ? r(p.filter(".active").first(), !0) : p.filter(".active").each(function () {
          r(t(this), !0);
        });
      } else u();
    });
  }, t(document).ready(function () {
    t(".collapsible").collapsible();
  });
}(jQuery), function (t) {
  t.fn.scrollTo = function (e) {
    return t(this).scrollTop(t(this).scrollTop() - t(this).offset().top + t(e).offset().top), this;
  }, t.fn.dropdown = function (e) {
    var i = {
      inDuration: 300,
      outDuration: 225,
      constrainWidth: !0,
      hover: !1,
      gutter: 0,
      belowOrigin: !1,
      alignment: "left",
      stopPropagation: !1
    };
    return "open" === e ? (this.each(function () {
      t(this).trigger("open");
    }), !1) : "close" === e ? (this.each(function () {
      t(this).trigger("close");
    }), !1) : void this.each(function () {
      function n() {
        void 0 !== r.data("induration") && (s.inDuration = r.data("induration")), void 0 !== r.data("outduration") && (s.outDuration = r.data("outduration")), void 0 !== r.data("constrainwidth") && (s.constrainWidth = r.data("constrainwidth")), void 0 !== r.data("hover") && (s.hover = r.data("hover")), void 0 !== r.data("gutter") && (s.gutter = r.data("gutter")), void 0 !== r.data("beloworigin") && (s.belowOrigin = r.data("beloworigin")), void 0 !== r.data("alignment") && (s.alignment = r.data("alignment")), void 0 !== r.data("stoppropagation") && (s.stopPropagation = r.data("stoppropagation"));
      }

      function o(e) {
        "focus" === e && (l = !0), n(), c.addClass("active"), r.addClass("active");
        var i = r[0].getBoundingClientRect().width;
        !0 === s.constrainWidth ? c.css("width", i) : c.css("white-space", "nowrap");
        var o = window.innerHeight,
            u = r.innerHeight(),
            d = r.offset().left,
            p = r.offset().top - t(window).scrollTop(),
            h = s.alignment,
            f = 0,
            v = 0,
            m = 0;
        !0 === s.belowOrigin && (m = u);
        var g = 0,
            y = 0,
            b = r.parent();
        if (b.is("body") || (b[0].scrollHeight > b[0].clientHeight && (g = b[0].scrollTop), b[0].scrollWidth > b[0].clientWidth && (y = b[0].scrollLeft)), d + c.innerWidth() > t(window).width() ? h = "right" : d - c.innerWidth() + r.innerWidth() < 0 && (h = "left"), p + c.innerHeight() > o) if (p + u - c.innerHeight() < 0) {
          var w = o - p - m;
          c.css("max-height", w);
        } else m || (m += u), m -= c.innerHeight();
        "left" === h ? (f = s.gutter, v = r.position().left + f) : "right" === h && (c.stop(!0, !0).css({
          opacity: 0,
          left: 0
        }), v = r.position().left + i - c.width() + (f = -s.gutter)), c.css({
          position: "absolute",
          top: r.position().top + m + g,
          left: v + y
        }), c.slideDown({
          queue: !1,
          duration: s.inDuration,
          easing: "easeOutCubic",
          complete: function complete() {
            t(this).css("height", "");
          }
        }).animate({
          opacity: 1
        }, {
          queue: !1,
          duration: s.inDuration,
          easing: "easeOutSine"
        }), setTimeout(function () {
          t(document).on("click." + c.attr("id"), function (e) {
            a(), t(document).off("click." + c.attr("id"));
          });
        }, 0);
      }

      function a() {
        l = !1, c.fadeOut(s.outDuration), c.removeClass("active"), r.removeClass("active"), t(document).off("click." + c.attr("id")), setTimeout(function () {
          c.css("max-height", "");
        }, s.outDuration);
      }

      var r = t(this),
          s = t.extend({}, i, e),
          l = !1,
          c = t("#" + r.attr("data-activates"));

      if (n(), r.after(c), s.hover) {
        var u = !1;
        r.off("click." + r.attr("id")), r.on("mouseenter", function (t) {
          !1 === u && (o(), u = !0);
        }), r.on("mouseleave", function (e) {
          var i = e.toElement || e.relatedTarget;
          t(i).closest(".dropdown-content").is(c) || (c.stop(!0, !0), a(), u = !1);
        }), c.on("mouseleave", function (e) {
          var i = e.toElement || e.relatedTarget;
          t(i).closest(".dropdown-button").is(r) || (c.stop(!0, !0), a(), u = !1);
        });
      } else r.off("click." + r.attr("id")), r.on("click." + r.attr("id"), function (e) {
        l || (r[0] != e.currentTarget || r.hasClass("active") || 0 !== t(e.target).closest(".dropdown-content").length ? r.hasClass("active") && (a(), t(document).off("click." + c.attr("id"))) : (e.preventDefault(), s.stopPropagation && e.stopPropagation(), o("click")));
      });

      r.on("open", function (t, e) {
        o(e);
      }), r.on("close", a);
    });
  }, t(document).ready(function () {
    t(".dropdown-button").dropdown();
  });
}(jQuery), function (t, e) {
  "use strict";

  var i = {
    opacity: .5,
    inDuration: 250,
    outDuration: 250,
    ready: void 0,
    complete: void 0,
    dismissible: !0,
    startingTop: "4%",
    endingTop: "10%"
  },
      n = function () {
    function n(e, i) {
      _classCallCheck(this, n), e[0].M_Modal && e[0].M_Modal.destroy(), this.$el = e, this.options = t.extend({}, n.defaults, i), this.isOpen = !1, this.$el[0].M_Modal = this, this.id = e.attr("id"), this.openingTrigger = void 0, this.$overlay = t('<div class="modal-overlay"></div>'), n._increment++, n._count++, this.$overlay[0].style.zIndex = 1e3 + 2 * n._increment, this.$el[0].style.zIndex = 1e3 + 2 * n._increment + 1, this.setupEventHandlers();
    }

    return _createClass(n, [{
      key: "getInstance",
      value: function value() {
        return this;
      }
    }, {
      key: "destroy",
      value: function value() {
        this.removeEventHandlers(), this.$el[0].removeAttribute("style"), this.$overlay[0].parentNode && this.$overlay[0].parentNode.removeChild(this.$overlay[0]), this.$el[0].M_Modal = void 0, n._count--;
      }
    }, {
      key: "setupEventHandlers",
      value: function value() {
        this.handleOverlayClickBound = this.handleOverlayClick.bind(this), this.handleModalCloseClickBound = this.handleModalCloseClick.bind(this), 1 === n._count && document.body.addEventListener("click", this.handleTriggerClick), this.$overlay[0].addEventListener("click", this.handleOverlayClickBound), this.$el[0].addEventListener("click", this.handleModalCloseClickBound);
      }
    }, {
      key: "removeEventHandlers",
      value: function value() {
        0 === n._count && document.body.removeEventListener("click", this.handleTriggerClick), this.$overlay[0].removeEventListener("click", this.handleOverlayClickBound), this.$el[0].removeEventListener("click", this.handleModalCloseClickBound);
      }
    }, {
      key: "handleTriggerClick",
      value: function value(e) {
        var i = t(e.target).closest(".modal-trigger");

        if (e.target && i.length) {
          var n = i[0].getAttribute("href");
          n = n ? n.slice(1) : i[0].getAttribute("data-target");
          var o = document.getElementById(n).M_Modal;
          o && o.open(i), e.preventDefault();
        }
      }
    }, {
      key: "handleOverlayClick",
      value: function value() {
        this.options.dismissible && this.close();
      }
    }, {
      key: "handleModalCloseClick",
      value: function value(e) {
        var i = t(e.target).closest(".modal-close");
        e.target && i.length && this.close();
      }
    }, {
      key: "handleKeydown",
      value: function value(t) {
        27 === t.keyCode && this.options.dismissible && this.close();
      }
    }, {
      key: "animateIn",
      value: function value() {
        var i = this;
        t.extend(this.$el[0].style, {
          display: "block",
          opacity: 0
        }), t.extend(this.$overlay[0].style, {
          display: "block",
          opacity: 0
        }), e(this.$overlay[0], {
          opacity: this.options.opacity
        }, {
          duration: this.options.inDuration,
          queue: !1,
          ease: "easeOutCubic"
        });
        var n = {
          duration: this.options.inDuration,
          queue: !1,
          ease: "easeOutCubic",
          complete: function complete() {
            "function" == typeof i.options.ready && i.options.ready.call(i, i.$el, i.openingTrigger);
          }
        };
        this.$el[0].classList.contains("bottom-sheet") ? e(this.$el[0], {
          bottom: 0,
          opacity: 1
        }, n) : (e.hook(this.$el[0], "scaleX", .7), this.$el[0].style.top = this.options.startingTop, e(this.$el[0], {
          top: this.options.endingTop,
          opacity: 1,
          scaleX: 1
        }, n));
      }
    }, {
      key: "animateOut",
      value: function value() {
        var t = this;
        e(this.$overlay[0], {
          opacity: 0
        }, {
          duration: this.options.outDuration,
          queue: !1,
          ease: "easeOutQuart"
        });
        var i = {
          duration: this.options.outDuration,
          queue: !1,
          ease: "easeOutCubic",
          complete: function complete() {
            t.$el[0].style.display = "none", "function" == typeof t.options.complete && t.options.complete.call(t, t.$el), t.$overlay[0].parentNode.removeChild(t.$overlay[0]);
          }
        };
        this.$el[0].classList.contains("bottom-sheet") ? e(this.$el[0], {
          bottom: "-100%",
          opacity: 0
        }, i) : e(this.$el[0], {
          top: this.options.startingTop,
          opacity: 0,
          scaleX: .7
        }, i);
      }
    }, {
      key: "open",
      value: function value(t) {
        if (!this.isOpen) {
          this.isOpen = !0;
          var e = document.body;
          return e.style.overflow = "hidden", this.$el[0].classList.add("open"), e.appendChild(this.$overlay[0]), this.openingTrigger = t || void 0, this.options.dismissible && (this.handleKeydownBound = this.handleKeydown.bind(this), document.addEventListener("keydown", this.handleKeydownBound)), this.animateIn(), this;
        }
      }
    }, {
      key: "close",
      value: function value() {
        if (this.isOpen) return this.isOpen = !1, this.$el[0].classList.remove("open"), document.body.style.overflow = "", this.options.dismissible && document.removeEventListener("keydown", this.handleKeydownBound), this.animateOut(), this;
      }
    }], [{
      key: "init",
      value: function value(e, i) {
        var o = [];
        return e.each(function () {
          o.push(new n(t(this), i));
        }), o;
      }
    }, {
      key: "defaults",
      get: function get() {
        return i;
      }
    }]), n;
  }();

  n._increment = 0, n._count = 0, Materialize.Modal = n, t.fn.modal = function (e) {
    return n.prototype[e] ? "get" === e.slice(0, 3) ? this.first()[0].M_Modal[e]() : this.each(function () {
      this.M_Modal[e]();
    }) : "object" != _typeof(e) && e ? void t.error("Method " + e + " does not exist on jQuery.modal") : (n.init(this, arguments[0]), this);
  };
}(jQuery, Materialize.Vel), function (t) {
  t.fn.materialbox = function () {
    return this.each(function () {
      function e() {
        a = !1;
        var e = s.parent(".material-placeholder"),
            n = (window.innerWidth, window.innerHeight, s.data("width")),
            l = s.data("height");
        s.velocity("stop", !0), t("#materialbox-overlay").velocity("stop", !0), t(".materialbox-caption").velocity("stop", !0), t(window).off("scroll.materialbox"), t(document).off("keyup.materialbox"), t(window).off("resize.materialbox"), t("#materialbox-overlay").velocity({
          opacity: 0
        }, {
          duration: r,
          queue: !1,
          easing: "easeOutQuad",
          complete: function complete() {
            o = !1, t(this).remove();
          }
        }), s.velocity({
          width: n,
          height: l,
          left: 0,
          top: 0
        }, {
          duration: r,
          queue: !1,
          easing: "easeOutQuad",
          complete: function complete() {
            e.css({
              height: "",
              width: "",
              position: "",
              top: "",
              left: ""
            }), s.removeAttr("style"), s.attr("style", c), s.removeClass("active"), a = !0, i && i.css("overflow", "");
          }
        }), t(".materialbox-caption").velocity({
          opacity: 0
        }, {
          duration: r,
          queue: !1,
          easing: "easeOutQuad",
          complete: function complete() {
            t(this).remove();
          }
        });
      }

      if (!t(this).hasClass("initialized")) {
        t(this).addClass("initialized");
        var i,
            n,
            o = !1,
            a = !0,
            r = 200,
            s = t(this),
            l = t("<div></div>").addClass("material-placeholder"),
            c = s.attr("style");
        s.wrap(l), s.on("click", function () {
          var r = s.parent(".material-placeholder"),
              l = window.innerWidth,
              c = window.innerHeight,
              u = s.width(),
              d = s.height();
          if (!1 === a) return e(), !1;
          if (o && !0 === a) return e(), !1;
          a = !1, s.addClass("active"), o = !0, r.css({
            width: r[0].getBoundingClientRect().width,
            height: r[0].getBoundingClientRect().height,
            position: "relative",
            top: 0,
            left: 0
          }), i = void 0, n = r[0].parentNode;

          for (; null !== n && !t(n).is(document);) {
            var p = t(n);
            "visible" !== p.css("overflow") && (p.css("overflow", "visible"), i = void 0 === i ? p : i.add(p)), n = n.parentNode;
          }

          s.css({
            position: "absolute",
            "z-index": 1e3,
            "will-change": "left, top, width, height"
          }).data("width", u).data("height", d);
          var h = t('<div id="materialbox-overlay"></div>').css({
            opacity: 0
          }).click(function () {
            !0 === a && e();
          });
          s.before(h);
          var f = h[0].getBoundingClientRect();

          if (h.css({
            width: l,
            height: c,
            left: -1 * f.left,
            top: -1 * f.top
          }), h.velocity({
            opacity: 1
          }, {
            duration: 275,
            queue: !1,
            easing: "easeOutQuad"
          }), "" !== s.data("caption")) {
            var v = t('<div class="materialbox-caption"></div>');
            v.text(s.data("caption")), t("body").append(v), v.css({
              display: "inline"
            }), v.velocity({
              opacity: 1
            }, {
              duration: 275,
              queue: !1,
              easing: "easeOutQuad"
            });
          }

          var m = 0,
              g = 0;
          u / l > d / c ? (m = .9 * l, g = .9 * l * (d / u)) : (m = .9 * c * (u / d), g = .9 * c), s.hasClass("responsive-img") ? s.velocity({
            "max-width": m,
            width: u
          }, {
            duration: 0,
            queue: !1,
            complete: function complete() {
              s.css({
                left: 0,
                top: 0
              }).velocity({
                height: g,
                width: m,
                left: t(document).scrollLeft() + l / 2 - s.parent(".material-placeholder").offset().left - m / 2,
                top: t(document).scrollTop() + c / 2 - s.parent(".material-placeholder").offset().top - g / 2
              }, {
                duration: 275,
                queue: !1,
                easing: "easeOutQuad",
                complete: function complete() {
                  a = !0;
                }
              });
            }
          }) : s.css("left", 0).css("top", 0).velocity({
            height: g,
            width: m,
            left: t(document).scrollLeft() + l / 2 - s.parent(".material-placeholder").offset().left - m / 2,
            top: t(document).scrollTop() + c / 2 - s.parent(".material-placeholder").offset().top - g / 2
          }, {
            duration: 275,
            queue: !1,
            easing: "easeOutQuad",
            complete: function complete() {
              a = !0;
            }
          }), t(window).on("scroll.materialbox", function () {
            o && e();
          }), t(window).on("resize.materialbox", function () {
            o && e();
          }), t(document).on("keyup.materialbox", function (t) {
            27 === t.keyCode && !0 === a && o && e();
          });
        });
      }
    });
  }, t(document).ready(function () {
    t(".materialboxed").materialbox();
  });
}(jQuery), function (t) {
  t.fn.parallax = function () {
    var e = t(window).width();
    return this.each(function (i) {
      function n(i) {
        var n;
        n = e < 601 ? o.height() > 0 ? o.height() : o.children("img").height() : o.height() > 0 ? o.height() : 500;
        var a = o.children("img").first(),
            r = a.height() - n,
            s = o.offset().top + n,
            l = o.offset().top,
            c = t(window).scrollTop(),
            u = window.innerHeight,
            d = (c + u - l) / (n + u),
            p = Math.round(r * d);
        i && a.css("display", "block"), s > c && l < c + u && a.css("transform", "translate3D(-50%," + p + "px, 0)");
      }

      var o = t(this);
      o.addClass("parallax"), o.children("img").one("load", function () {
        n(!0);
      }).each(function () {
        this.complete && t(this).trigger("load");
      }), t(window).scroll(function () {
        e = t(window).width(), n(!1);
      }), t(window).resize(function () {
        e = t(window).width(), n(!1);
      });
    });
  };
}(jQuery), function (t) {
  var e = {
    init: function init(e) {
      var i = {
        onShow: null,
        swipeable: !1,
        responsiveThreshold: 1 / 0
      };
      e = t.extend(i, e);
      var n = Materialize.objectSelectorString(t(this));
      return this.each(function (i) {
        var o,
            a,
            r,
            s,
            l,
            c = n + i,
            u = t(this),
            d = t(window).width(),
            p = u.find("li.tab a"),
            h = u.width(),
            f = t(),
            v = Math.max(h, u[0].scrollWidth) / p.length,
            m = 0,
            g = 0,
            y = !1,
            b = function b(t) {
          return Math.ceil(h - t.position().left - t[0].getBoundingClientRect().width - u.scrollLeft());
        },
            w = function w(t) {
          return Math.floor(t.position().left + u.scrollLeft());
        },
            k = function k(t) {
          m - t >= 0 ? (s.velocity({
            right: b(o)
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad"
          }), s.velocity({
            left: w(o)
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad",
            delay: 90
          })) : (s.velocity({
            left: w(o)
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad"
          }), s.velocity({
            right: b(o)
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad",
            delay: 90
          }));
        };

        e.swipeable && d > e.responsiveThreshold && (e.swipeable = !1), 0 === (o = t(p.filter('[href="' + location.hash + '"]'))).length && (o = t(this).find("li.tab a.active").first()), 0 === o.length && (o = t(this).find("li.tab a").first()), o.addClass("active"), (m = p.index(o)) < 0 && (m = 0), void 0 !== o[0] && (a = t(o[0].hash)).addClass("active"), u.find(".indicator").length || u.append('<li class="indicator"></li>'), s = u.find(".indicator"), u.append(s), u.is(":visible") && setTimeout(function () {
          s.css({
            right: b(o)
          }), s.css({
            left: w(o)
          });
        }, 0), t(window).off("resize.tabs-" + c).on("resize.tabs-" + c, function () {
          h = u.width(), v = Math.max(h, u[0].scrollWidth) / p.length, m < 0 && (m = 0), 0 !== v && 0 !== h && (s.css({
            right: b(o)
          }), s.css({
            left: w(o)
          }));
        }), e.swipeable ? (p.each(function () {
          var e = t(Materialize.escapeHash(this.hash));
          e.addClass("carousel-item"), f = f.add(e);
        }), r = f.wrapAll('<div class="tabs-content carousel"></div>'), f.css("display", ""), t(".tabs-content.carousel").carousel({
          fullWidth: !0,
          noWrap: !0,
          onCycleTo: function onCycleTo(t) {
            if (!y) {
              var i = m;
              m = r.index(t), o.removeClass("active"), (o = p.eq(m)).addClass("active"), k(i), "function" == typeof e.onShow && e.onShow.call(u[0], a);
            }
          }
        })) : p.not(o).each(function () {
          t(Materialize.escapeHash(this.hash)).hide();
        }), u.off("click.tabs").on("click.tabs", "a", function (i) {
          if (t(this).parent().hasClass("disabled")) i.preventDefault();else if (!t(this).attr("target")) {
            y = !0, h = u.width(), v = Math.max(h, u[0].scrollWidth) / p.length, o.removeClass("active");
            var n = a;
            o = t(this), a = t(Materialize.escapeHash(this.hash)), p = u.find("li.tab a");
            o.position();
            o.addClass("active"), g = m, (m = p.index(t(this))) < 0 && (m = 0), e.swipeable ? f.length && f.carousel("set", m, function () {
              "function" == typeof e.onShow && e.onShow.call(u[0], a);
            }) : (void 0 !== a && (a.show(), a.addClass("active"), "function" == typeof e.onShow && e.onShow.call(this, a)), void 0 === n || n.is(a) || (n.hide(), n.removeClass("active"))), l = setTimeout(function () {
              y = !1;
            }, 300), k(g), i.preventDefault();
          }
        });
      });
    },
    select_tab: function select_tab(t) {
      this.find('a[href="#' + t + '"]').trigger("click");
    }
  };
  t.fn.tabs = function (i) {
    return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != _typeof(i) && i ? void t.error("Method " + i + " does not exist on jQuery.tabs") : e.init.apply(this, arguments);
  }, t(document).ready(function () {
    t("ul.tabs").tabs();
  });
}(jQuery), function (t) {
  t.fn.tooltip = function (i) {
    var n = {
      delay: 350,
      tooltip: "",
      position: "bottom",
      html: !1
    };
    return "remove" === i ? (this.each(function () {
      t("#" + t(this).attr("data-tooltip-id")).remove(), t(this).removeAttr("data-tooltip-id"), t(this).off("mouseenter.tooltip mouseleave.tooltip");
    }), !1) : (i = t.extend(n, i), this.each(function () {
      var n = Materialize.guid(),
          o = t(this);
      o.attr("data-tooltip-id") && t("#" + o.attr("data-tooltip-id")).remove(), o.attr("data-tooltip-id", n);

      var a,
          r,
          s,
          l,
          c,
          u,
          d = function d() {
        a = o.attr("data-html") ? "true" === o.attr("data-html") : i.html, r = o.attr("data-delay"), r = void 0 === r || "" === r ? i.delay : r, s = o.attr("data-position"), s = void 0 === s || "" === s ? i.position : s, l = o.attr("data-tooltip"), l = void 0 === l || "" === l ? i.tooltip : l;
      };

      d();
      c = function () {
        var e = t('<div class="material-tooltip"></div>');
        return l = a ? t("<span></span>").html(l) : t("<span></span>").text(l), e.append(l).appendTo(t("body")).attr("id", n), (u = t('<div class="backdrop"></div>')).appendTo(e), e;
      }(), o.off("mouseenter.tooltip mouseleave.tooltip");
      var p,
          h = !1;
      o.on({
        "mouseenter.tooltip": function mouseenterTooltip(t) {
          p = setTimeout(function () {
            d(), h = !0, c.velocity("stop"), u.velocity("stop"), c.css({
              visibility: "visible",
              left: "0px",
              top: "0px"
            });
            var t,
                i,
                n,
                a = o.outerWidth(),
                r = o.outerHeight(),
                l = c.outerHeight(),
                p = c.outerWidth(),
                f = "0px",
                v = "0px",
                m = u[0].offsetWidth,
                g = u[0].offsetHeight,
                y = 8,
                b = 8,
                w = 0;
            "top" === s ? (t = o.offset().top - l - 5, i = o.offset().left + a / 2 - p / 2, n = e(i, t, p, l), f = "-10px", u.css({
              bottom: 0,
              left: 0,
              borderRadius: "14px 14px 0 0",
              transformOrigin: "50% 100%",
              marginTop: l,
              marginLeft: p / 2 - m / 2
            })) : "left" === s ? (t = o.offset().top + r / 2 - l / 2, i = o.offset().left - p - 5, n = e(i, t, p, l), v = "-10px", u.css({
              top: "-7px",
              right: 0,
              width: "14px",
              height: "14px",
              borderRadius: "14px 0 0 14px",
              transformOrigin: "95% 50%",
              marginTop: l / 2,
              marginLeft: p
            })) : "right" === s ? (t = o.offset().top + r / 2 - l / 2, i = o.offset().left + a + 5, n = e(i, t, p, l), v = "+10px", u.css({
              top: "-7px",
              left: 0,
              width: "14px",
              height: "14px",
              borderRadius: "0 14px 14px 0",
              transformOrigin: "5% 50%",
              marginTop: l / 2,
              marginLeft: "0px"
            })) : (t = o.offset().top + o.outerHeight() + 5, i = o.offset().left + a / 2 - p / 2, n = e(i, t, p, l), f = "+10px", u.css({
              top: 0,
              left: 0,
              marginLeft: p / 2 - m / 2
            })), c.css({
              top: n.y,
              left: n.x
            }), y = Math.SQRT2 * p / parseInt(m), b = Math.SQRT2 * l / parseInt(g), w = Math.max(y, b), c.velocity({
              translateY: f,
              translateX: v
            }, {
              duration: 350,
              queue: !1
            }).velocity({
              opacity: 1
            }, {
              duration: 300,
              delay: 50,
              queue: !1
            }), u.css({
              visibility: "visible"
            }).velocity({
              opacity: 1
            }, {
              duration: 55,
              delay: 0,
              queue: !1
            }).velocity({
              scaleX: w,
              scaleY: w
            }, {
              duration: 300,
              delay: 0,
              queue: !1,
              easing: "easeInOutQuad"
            });
          }, r);
        },
        "mouseleave.tooltip": function mouseleaveTooltip() {
          h = !1, clearTimeout(p), setTimeout(function () {
            !0 !== h && (c.velocity({
              opacity: 0,
              translateY: 0,
              translateX: 0
            }, {
              duration: 225,
              queue: !1
            }), u.velocity({
              opacity: 0,
              scaleX: 1,
              scaleY: 1
            }, {
              duration: 225,
              queue: !1,
              complete: function complete() {
                u.css({
                  visibility: "hidden"
                }), c.css({
                  visibility: "hidden"
                }), h = !1;
              }
            }));
          }, 225);
        }
      });
    }));
  };

  var e = function e(_e, i, n, o) {
    var a = _e,
        r = i;
    return a < 0 ? a = 4 : a + n > window.innerWidth && (a -= a + n - window.innerWidth), r < 0 ? r = 4 : r + o > window.innerHeight + t(window).scrollTop && (r -= r + o - window.innerHeight), {
      x: a,
      y: r
    };
  };

  t(document).ready(function () {
    t(".tooltipped").tooltip();
  });
}(jQuery), function (t) {
  "use strict";

  function e(t) {
    return null !== t && t === t.window;
  }

  function i(t) {
    return e(t) ? t : 9 === t.nodeType && t.defaultView;
  }

  function n(t) {
    var e,
        n,
        o = {
      top: 0,
      left: 0
    },
        a = t && t.ownerDocument;
    return e = a.documentElement, void 0 !== t.getBoundingClientRect && (o = t.getBoundingClientRect()), n = i(a), {
      top: o.top + n.pageYOffset - e.clientTop,
      left: o.left + n.pageXOffset - e.clientLeft
    };
  }

  function o(t) {
    var e = "";

    for (var i in t) {
      t.hasOwnProperty(i) && (e += i + ":" + t[i] + ";");
    }

    return e;
  }

  function a(t) {
    if (!1 === u.allowEvent(t)) return null;

    for (var e = null, i = t.target || t.srcElement; null !== i.parentNode;) {
      if (!(i instanceof SVGElement) && -1 !== i.className.indexOf("waves-effect")) {
        e = i;
        break;
      }

      i = i.parentNode;
    }

    return e;
  }

  function r(e) {
    var i = a(e);
    null !== i && (c.show(e, i), "ontouchstart" in t && (i.addEventListener("touchend", c.hide, !1), i.addEventListener("touchcancel", c.hide, !1)), i.addEventListener("mouseup", c.hide, !1), i.addEventListener("mouseleave", c.hide, !1), i.addEventListener("dragend", c.hide, !1));
  }

  var s = s || {},
      l = document.querySelectorAll.bind(document),
      c = {
    duration: 750,
    show: function show(t, e) {
      if (2 === t.button) return !1;
      var i = e || this,
          a = document.createElement("div");
      a.className = "waves-ripple", i.appendChild(a);
      var r = n(i),
          s = t.pageY - r.top,
          l = t.pageX - r.left,
          u = "scale(" + i.clientWidth / 100 * 10 + ")";
      "touches" in t && (s = t.touches[0].pageY - r.top, l = t.touches[0].pageX - r.left), a.setAttribute("data-hold", Date.now()), a.setAttribute("data-scale", u), a.setAttribute("data-x", l), a.setAttribute("data-y", s);
      var d = {
        top: s + "px",
        left: l + "px"
      };
      a.className = a.className + " waves-notransition", a.setAttribute("style", o(d)), a.className = a.className.replace("waves-notransition", ""), d["-webkit-transform"] = u, d["-moz-transform"] = u, d["-ms-transform"] = u, d["-o-transform"] = u, d.transform = u, d.opacity = "1", d["-webkit-transition-duration"] = c.duration + "ms", d["-moz-transition-duration"] = c.duration + "ms", d["-o-transition-duration"] = c.duration + "ms", d["transition-duration"] = c.duration + "ms", d["-webkit-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", d["-moz-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", d["-o-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", d["transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", a.setAttribute("style", o(d));
    },
    hide: function hide(t) {
      u.touchup(t);
      var e = this,
          i = (e.clientWidth, null),
          n = e.getElementsByClassName("waves-ripple");
      if (!(n.length > 0)) return !1;
      var a = (i = n[n.length - 1]).getAttribute("data-x"),
          r = i.getAttribute("data-y"),
          s = i.getAttribute("data-scale"),
          l = 350 - (Date.now() - Number(i.getAttribute("data-hold")));
      l < 0 && (l = 0), setTimeout(function () {
        var t = {
          top: r + "px",
          left: a + "px",
          opacity: "0",
          "-webkit-transition-duration": c.duration + "ms",
          "-moz-transition-duration": c.duration + "ms",
          "-o-transition-duration": c.duration + "ms",
          "transition-duration": c.duration + "ms",
          "-webkit-transform": s,
          "-moz-transform": s,
          "-ms-transform": s,
          "-o-transform": s,
          transform: s
        };
        i.setAttribute("style", o(t)), setTimeout(function () {
          try {
            e.removeChild(i);
          } catch (t) {
            return !1;
          }
        }, c.duration);
      }, l);
    },
    wrapInput: function wrapInput(t) {
      for (var e = 0; e < t.length; e++) {
        var i = t[e];

        if ("input" === i.tagName.toLowerCase()) {
          var n = i.parentNode;
          if ("i" === n.tagName.toLowerCase() && -1 !== n.className.indexOf("waves-effect")) continue;
          var o = document.createElement("i");
          o.className = i.className + " waves-input-wrapper";
          var a = i.getAttribute("style");
          a || (a = ""), o.setAttribute("style", a), i.className = "waves-button-input", i.removeAttribute("style"), n.replaceChild(o, i), o.appendChild(i);
        }
      }
    }
  },
      u = {
    touches: 0,
    allowEvent: function allowEvent(t) {
      var e = !0;
      return "touchstart" === t.type ? u.touches += 1 : "touchend" === t.type || "touchcancel" === t.type ? setTimeout(function () {
        u.touches > 0 && (u.touches -= 1);
      }, 500) : "mousedown" === t.type && u.touches > 0 && (e = !1), e;
    },
    touchup: function touchup(t) {
      u.allowEvent(t);
    }
  };
  s.displayEffect = function (e) {
    "duration" in (e = e || {}) && (c.duration = e.duration), c.wrapInput(l(".waves-effect")), "ontouchstart" in t && document.body.addEventListener("touchstart", r, !1), document.body.addEventListener("mousedown", r, !1);
  }, s.attach = function (e) {
    "input" === e.tagName.toLowerCase() && (c.wrapInput([e]), e = e.parentNode), "ontouchstart" in t && e.addEventListener("touchstart", r, !1), e.addEventListener("mousedown", r, !1);
  }, t.Waves = s, document.addEventListener("DOMContentLoaded", function () {
    s.displayEffect();
  }, !1);
}(window), function (t, e) {
  "use strict";

  var i = {
    displayLength: 1 / 0,
    inDuration: 300,
    outDuration: 375,
    className: void 0,
    completeCallback: void 0,
    activationPercent: .8
  },
      n = function () {
    function n(e, i, o, a) {
      if (_classCallCheck(this, n), e) {
        this.options = {
          displayLength: i,
          className: o,
          completeCallback: a
        }, this.options = t.extend({}, n.defaults, this.options), this.message = e, this.panning = !1, this.timeRemaining = this.options.displayLength, 0 === n._toasts.length && n._createContainer(), n._toasts.push(this);
        var r = this.createToast();
        r.M_Toast = this, this.el = r, this._animateIn(), this.setTimer();
      }
    }

    return _createClass(n, [{
      key: "createToast",
      value: function value() {
        var e = document.createElement("div");

        if (e.classList.add("toast"), this.options.className) {
          var i = this.options.className.split(" "),
              o = void 0,
              a = void 0;

          for (o = 0, a = i.length; o < a; o++) {
            e.classList.add(i[o]);
          }
        }

        return ("object" == (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) ? this.message instanceof HTMLElement : this.message && "object" == _typeof(this.message) && null !== this.message && 1 === this.message.nodeType && "string" == typeof this.message.nodeName) ? e.appendChild(this.message) : this.message instanceof jQuery ? t(e).append(this.message) : e.innerHTML = this.message, n._container.appendChild(e), e;
      }
    }, {
      key: "_animateIn",
      value: function value() {
        e(this.el, {
          top: 0,
          opacity: 1
        }, {
          duration: 300,
          easing: "easeOutCubic",
          queue: !1
        });
      }
    }, {
      key: "setTimer",
      value: function value() {
        var t = this;
        this.timeRemaining !== 1 / 0 && (this.counterInterval = setInterval(function () {
          t.panning || (t.timeRemaining -= 20), t.timeRemaining <= 0 && t.remove();
        }, 20));
      }
    }, {
      key: "remove",
      value: function value() {
        var t = this;
        window.clearInterval(this.counterInterval);
        var i = this.el.offsetWidth * this.options.activationPercent;
        this.wasSwiped && (this.el.style.transition = "transform .05s, opacity .05s", this.el.style.transform = "translateX(" + i + "px)", this.el.style.opacity = 0), e(this.el, {
          opacity: 0,
          marginTop: "-40px"
        }, {
          duration: this.options.outDuration,
          easing: "easeOutExpo",
          queue: !1,
          complete: function complete() {
            "function" == typeof t.options.completeCallback && t.options.completeCallback(), t.el.parentNode.removeChild(t.el), n._toasts.splice(n._toasts.indexOf(t), 1), 0 === n._toasts.length && n._removeContainer();
          }
        });
      }
    }], [{
      key: "_createContainer",
      value: function value() {
        var t = document.createElement("div");
        t.setAttribute("id", "toast-container"), t.addEventListener("touchstart", n._onDragStart), t.addEventListener("touchmove", n._onDragMove), t.addEventListener("touchend", n._onDragEnd), t.addEventListener("mousedown", n._onDragStart), document.addEventListener("mousemove", n._onDragMove), document.addEventListener("mouseup", n._onDragEnd), document.body.appendChild(t), n._container = t;
      }
    }, {
      key: "_removeContainer",
      value: function value() {
        document.removeEventListener("mousemove", n._onDragMove), document.removeEventListener("mouseup", n._onDragEnd), n._container.parentNode.removeChild(n._container), n._container = null;
      }
    }, {
      key: "_onDragStart",
      value: function value(e) {
        if (e.target && t(e.target).closest(".toast").length) {
          var i = t(e.target).closest(".toast")[0].M_Toast;
          i.panning = !0, n._draggedToast = i, i.el.classList.add("panning"), i.el.style.transition = "", i.startingXPos = n._xPos(e), i.time = Date.now(), i.xPos = n._xPos(e);
        }
      }
    }, {
      key: "_onDragMove",
      value: function value(t) {
        if (n._draggedToast) {
          t.preventDefault();
          var e = n._draggedToast;
          e.deltaX = Math.abs(e.xPos - n._xPos(t)), e.xPos = n._xPos(t), e.velocityX = e.deltaX / (Date.now() - e.time), e.time = Date.now();
          var i = e.xPos - e.startingXPos,
              o = e.el.offsetWidth * e.options.activationPercent;
          e.el.style.transform = "translateX(" + i + "px)", e.el.style.opacity = 1 - Math.abs(i / o);
        }
      }
    }, {
      key: "_onDragEnd",
      value: function value(t) {
        if (n._draggedToast) {
          var e = n._draggedToast;
          e.panning = !1, e.el.classList.remove("panning");
          var i = e.xPos - e.startingXPos,
              o = e.el.offsetWidth * e.options.activationPercent;
          Math.abs(i) > o || e.velocityX > 1 ? (e.wasSwiped = !0, e.remove()) : (e.el.style.transition = "transform .2s, opacity .2s", e.el.style.transform = "", e.el.style.opacity = ""), n._draggedToast = null;
        }
      }
    }, {
      key: "_xPos",
      value: function value(t) {
        return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
      }
    }, {
      key: "removeAll",
      value: function value() {
        for (var t in n._toasts) {
          n._toasts[t].remove();
        }
      }
    }, {
      key: "defaults",
      get: function get() {
        return i;
      }
    }]), n;
  }();

  n._toasts = [], n._container = null, n._draggedToast = null, Materialize.Toast = n, Materialize.toast = function (t, e, i, o) {
    return new n(t, e, i, o);
  };
}(jQuery, Materialize.Vel), function (t) {
  var e = {
    init: function init(e) {
      var i = {
        menuWidth: 300,
        edge: "left",
        closeOnClick: !1,
        draggable: !0,
        onOpen: null,
        onClose: null
      };
      e = t.extend(i, e), t(this).each(function () {
        var i = t(this),
            n = i.attr("data-activates"),
            o = t("#" + n);
        300 != e.menuWidth && o.css("width", e.menuWidth);
        var a = t('.drag-target[data-sidenav="' + n + '"]');
        e.draggable ? (a.length && a.remove(), a = t('<div class="drag-target"></div>').attr("data-sidenav", n), t("body").append(a)) : a = t(), "left" == e.edge ? (o.css("transform", "translateX(-100%)"), a.css({
          left: 0
        })) : (o.addClass("right-aligned").css("transform", "translateX(100%)"), a.css({
          right: 0
        })), o.hasClass("fixed") && window.innerWidth > 992 && o.css("transform", "translateX(0)"), o.hasClass("fixed") && t(window).resize(function () {
          window.innerWidth > 992 ? 0 !== t("#sidenav-overlay").length && l ? r(!0) : o.css("transform", "translateX(0%)") : !1 === l && ("left" === e.edge ? o.css("transform", "translateX(-100%)") : o.css("transform", "translateX(100%)"));
        }), !0 === e.closeOnClick && o.on("click.itemclick", "a:not(.collapsible-header)", function () {
          window.innerWidth > 992 && o.hasClass("fixed") || r();
        });

        var r = function r(i) {
          s = !1, l = !1, t("body").css({
            overflow: "",
            width: ""
          }), t("#sidenav-overlay").velocity({
            opacity: 0
          }, {
            duration: 200,
            queue: !1,
            easing: "easeOutQuad",
            complete: function complete() {
              t(this).remove();
            }
          }), "left" === e.edge ? (a.css({
            width: "",
            right: "",
            left: "0"
          }), o.velocity({
            translateX: "-100%"
          }, {
            duration: 200,
            queue: !1,
            easing: "easeOutCubic",
            complete: function complete() {
              !0 === i && (o.removeAttr("style"), o.css("width", e.menuWidth));
            }
          })) : (a.css({
            width: "",
            right: "0",
            left: ""
          }), o.velocity({
            translateX: "100%"
          }, {
            duration: 200,
            queue: !1,
            easing: "easeOutCubic",
            complete: function complete() {
              !0 === i && (o.removeAttr("style"), o.css("width", e.menuWidth));
            }
          })), "function" == typeof e.onClose && e.onClose.call(this, o);
        },
            s = !1,
            l = !1;

        e.draggable && (a.on("click", function () {
          l && r();
        }), a.hammer({
          prevent_default: !1
        }).on("pan", function (i) {
          if ("touch" == i.gesture.pointerType) {
            i.gesture.direction;
            var n = i.gesture.center.x,
                a = i.gesture.center.y;
            i.gesture.velocityX;
            if (0 === n && 0 === a) return;
            var s = t("body"),
                c = t("#sidenav-overlay"),
                u = s.innerWidth();
            if (s.css("overflow", "hidden"), s.width(u), 0 === c.length && ((c = t('<div id="sidenav-overlay"></div>')).css("opacity", 0).click(function () {
              r();
            }), "function" == typeof e.onOpen && e.onOpen.call(this, o), t("body").append(c)), "left" === e.edge && (n > e.menuWidth ? n = e.menuWidth : n < 0 && (n = 0)), "left" === e.edge) n < e.menuWidth / 2 ? l = !1 : n >= e.menuWidth / 2 && (l = !0), o.css("transform", "translateX(" + (n - e.menuWidth) + "px)");else {
              n < window.innerWidth - e.menuWidth / 2 ? l = !0 : n >= window.innerWidth - e.menuWidth / 2 && (l = !1);
              var d = n - e.menuWidth / 2;
              d < 0 && (d = 0), o.css("transform", "translateX(" + d + "px)");
            }
            var p;
            "left" === e.edge ? (p = n / e.menuWidth, c.velocity({
              opacity: p
            }, {
              duration: 10,
              queue: !1,
              easing: "easeOutQuad"
            })) : (p = Math.abs((n - window.innerWidth) / e.menuWidth), c.velocity({
              opacity: p
            }, {
              duration: 10,
              queue: !1,
              easing: "easeOutQuad"
            }));
          }
        }).on("panend", function (i) {
          if ("touch" == i.gesture.pointerType) {
            var n = t("#sidenav-overlay"),
                r = i.gesture.velocityX,
                c = i.gesture.center.x,
                u = c - e.menuWidth,
                d = c - e.menuWidth / 2;
            u > 0 && (u = 0), d < 0 && (d = 0), s = !1, "left" === e.edge ? l && r <= .3 || r < -.5 ? (0 !== u && o.velocity({
              translateX: [0, u]
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad"
            }), n.velocity({
              opacity: 1
            }, {
              duration: 50,
              queue: !1,
              easing: "easeOutQuad"
            }), a.css({
              width: "50%",
              right: 0,
              left: ""
            }), l = !0) : (!l || r > .3) && (t("body").css({
              overflow: "",
              width: ""
            }), o.velocity({
              translateX: [-1 * e.menuWidth - 10, u]
            }, {
              duration: 200,
              queue: !1,
              easing: "easeOutQuad"
            }), n.velocity({
              opacity: 0
            }, {
              duration: 200,
              queue: !1,
              easing: "easeOutQuad",
              complete: function complete() {
                "function" == typeof e.onClose && e.onClose.call(this, o), t(this).remove();
              }
            }), a.css({
              width: "10px",
              right: "",
              left: 0
            })) : l && r >= -.3 || r > .5 ? (0 !== d && o.velocity({
              translateX: [0, d]
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad"
            }), n.velocity({
              opacity: 1
            }, {
              duration: 50,
              queue: !1,
              easing: "easeOutQuad"
            }), a.css({
              width: "50%",
              right: "",
              left: 0
            }), l = !0) : (!l || r < -.3) && (t("body").css({
              overflow: "",
              width: ""
            }), o.velocity({
              translateX: [e.menuWidth + 10, d]
            }, {
              duration: 200,
              queue: !1,
              easing: "easeOutQuad"
            }), n.velocity({
              opacity: 0
            }, {
              duration: 200,
              queue: !1,
              easing: "easeOutQuad",
              complete: function complete() {
                "function" == typeof e.onClose && e.onClose.call(this, o), t(this).remove();
              }
            }), a.css({
              width: "10px",
              right: 0,
              left: ""
            }));
          }
        })), i.off("click.sidenav").on("click.sidenav", function () {
          if (!0 === l) l = !1, s = !1, r();else {
            var i = t("body"),
                n = t('<div id="sidenav-overlay"></div>'),
                c = i.innerWidth();
            i.css("overflow", "hidden"), i.width(c), t("body").append(a), "left" === e.edge ? (a.css({
              width: "50%",
              right: 0,
              left: ""
            }), o.velocity({
              translateX: [0, -1 * e.menuWidth]
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad"
            })) : (a.css({
              width: "50%",
              right: "",
              left: 0
            }), o.velocity({
              translateX: [0, e.menuWidth]
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad"
            })), n.css("opacity", 0).click(function () {
              l = !1, s = !1, r(), n.velocity({
                opacity: 0
              }, {
                duration: 300,
                queue: !1,
                easing: "easeOutQuad",
                complete: function complete() {
                  t(this).remove();
                }
              });
            }), t("body").append(n), n.velocity({
              opacity: 1
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad",
              complete: function complete() {
                l = !0, s = !1;
              }
            }), "function" == typeof e.onOpen && e.onOpen.call(this, o);
          }
          return !1;
        });
      });
    },
    destroy: function destroy() {
      var e = t("#sidenav-overlay"),
          i = t('.drag-target[data-sidenav="' + t(this).attr("data-activates") + '"]');
      e.trigger("click"), i.remove(), t(this).off("click"), e.remove();
    },
    show: function show() {
      this.trigger("click");
    },
    hide: function hide() {
      t("#sidenav-overlay").trigger("click");
    }
  };

  t.fn.sideNav = function (i) {
    return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != _typeof(i) && i ? void t.error("Method " + i + " does not exist on jQuery.sideNav") : e.init.apply(this, arguments);
  };
}(jQuery), function (t) {
  function e(e, i, n, o) {
    var r = t();
    return t.each(a, function (t, a) {
      if (a.height() > 0) {
        var s = a.offset().top,
            l = a.offset().left,
            c = l + a.width(),
            u = s + a.height();
        !(l > i || c < o || s > n || u < e) && r.push(a);
      }
    }), r;
  }

  function i(i) {
    ++l;
    var n = o.scrollTop(),
        a = o.scrollLeft(),
        s = a + o.width(),
        u = n + o.height(),
        d = e(n + c.top + i || 200, s + c.right, u + c.bottom, a + c.left);
    t.each(d, function (t, e) {
      "number" != typeof e.data("scrollSpy:ticks") && e.triggerHandler("scrollSpy:enter"), e.data("scrollSpy:ticks", l);
    }), t.each(r, function (t, e) {
      var i = e.data("scrollSpy:ticks");
      "number" == typeof i && i !== l && (e.triggerHandler("scrollSpy:exit"), e.data("scrollSpy:ticks", null));
    }), r = d;
  }

  function n() {
    o.trigger("scrollSpy:winSize");
  }

  var o = t(window),
      a = [],
      r = [],
      s = !1,
      l = 0,
      c = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  t.scrollSpy = function (e, n) {
    var r = {
      throttle: 100,
      scrollOffset: 200,
      activeClass: "active",
      getActiveElement: function getActiveElement(t) {
        return 'a[href="#' + t + '"]';
      }
    };
    n = t.extend(r, n);
    var l = [];
    (e = t(e)).each(function (e, i) {
      a.push(t(i)), t(i).data("scrollSpy:id", e), t('a[href="#' + t(i).attr("id") + '"]').click(function (e) {
        e.preventDefault();
        var i = t(Materialize.escapeHash(this.hash)).offset().top + 1;
        t("html, body").animate({
          scrollTop: i - n.scrollOffset
        }, {
          duration: 400,
          queue: !1,
          easing: "easeOutCubic"
        });
      });
    }), c.top = n.offsetTop || 0, c.right = n.offsetRight || 0, c.bottom = n.offsetBottom || 0, c.left = n.offsetLeft || 0;

    var u = Materialize.throttle(function () {
      i(n.scrollOffset);
    }, n.throttle || 100),
        d = function d() {
      t(document).ready(u);
    };

    return s || (o.on("scroll", d), o.on("resize", d), s = !0), setTimeout(d, 0), e.on("scrollSpy:enter", function () {
      l = t.grep(l, function (t) {
        return 0 != t.height();
      });
      var e = t(this);
      l[0] ? (t(n.getActiveElement(l[0].attr("id"))).removeClass(n.activeClass), e.data("scrollSpy:id") < l[0].data("scrollSpy:id") ? l.unshift(t(this)) : l.push(t(this))) : l.push(t(this)), t(n.getActiveElement(l[0].attr("id"))).addClass(n.activeClass);
    }), e.on("scrollSpy:exit", function () {
      if ((l = t.grep(l, function (t) {
        return 0 != t.height();
      }))[0]) {
        t(n.getActiveElement(l[0].attr("id"))).removeClass(n.activeClass);
        var e = t(this);
        (l = t.grep(l, function (t) {
          return t.attr("id") != e.attr("id");
        }))[0] && t(n.getActiveElement(l[0].attr("id"))).addClass(n.activeClass);
      }
    }), e;
  }, t.winSizeSpy = function (e) {
    return t.winSizeSpy = function () {
      return o;
    }, e = e || {
      throttle: 100
    }, o.on("resize", Materialize.throttle(n, e.throttle || 100));
  }, t.fn.scrollSpy = function (e) {
    return t.scrollSpy(t(this), e);
  };
}(jQuery), function (t) {
  t(document).ready(function () {
    function e(e) {
      var i = e.css("font-family"),
          o = e.css("font-size"),
          a = e.css("line-height"),
          r = e.css("padding");
      o && n.css("font-size", o), i && n.css("font-family", i), a && n.css("line-height", a), r && n.css("padding", r), e.data("original-height") || e.data("original-height", e.height()), "off" === e.attr("wrap") && n.css("overflow-wrap", "normal").css("white-space", "pre"), n.text(e.val() + "\n");
      var s = n.html().replace(/\n/g, "<br>");
      n.html(s), e.is(":visible") ? n.css("width", e.width()) : n.css("width", t(window).width() / 2), e.data("original-height") <= n.height() ? e.css("height", n.height()) : e.val().length < e.data("previous-length") && e.css("height", e.data("original-height")), e.data("previous-length", e.val().length);
    }

    Materialize.updateTextFields = function () {
      t("input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea").each(function (e, i) {
        var n = t(this);
        t(i).val().length > 0 || t(i).is(":focus") || i.autofocus || void 0 !== n.attr("placeholder") ? n.siblings("label").addClass("active") : t(i)[0].validity ? n.siblings("label").toggleClass("active", !0 === t(i)[0].validity.badInput) : n.siblings("label").removeClass("active");
      });
    };

    var i = "input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea";
    t(document).on("change", i, function () {
      0 === t(this).val().length && void 0 === t(this).attr("placeholder") || t(this).siblings("label").addClass("active"), validate_field(t(this));
    }), t(document).ready(function () {
      Materialize.updateTextFields();
    }), t(document).on("reset", function (e) {
      var n = t(e.target);
      n.is("form") && (n.find(i).removeClass("valid").removeClass("invalid"), n.find(i).each(function () {
        "" === t(this).attr("value") && t(this).siblings("label").removeClass("active");
      }), n.find("select.initialized").each(function () {
        var t = n.find("option[selected]").text();
        n.siblings("input.select-dropdown").val(t);
      }));
    }), t(document).on("focus", i, function () {
      t(this).siblings("label, .prefix").addClass("active");
    }), t(document).on("blur", i, function () {
      var e = t(this),
          i = ".prefix";
      0 === e.val().length && !0 !== e[0].validity.badInput && void 0 === e.attr("placeholder") && (i += ", label"), e.siblings(i).removeClass("active"), validate_field(e);
    }), window.validate_field = function (t) {
      var e = void 0 !== t.attr("data-length"),
          i = parseInt(t.attr("data-length")),
          n = t.val().length;
      0 !== t.val().length || !1 !== t[0].validity.badInput || t.is(":required") ? t.hasClass("validate") && (t.is(":valid") && e && n <= i || t.is(":valid") && !e ? (t.removeClass("invalid"), t.addClass("valid")) : (t.removeClass("valid"), t.addClass("invalid"))) : t.hasClass("validate") && (t.removeClass("valid"), t.removeClass("invalid"));
    };
    t(document).on("keyup.radio", "input[type=radio], input[type=checkbox]", function (e) {
      if (9 === e.which) return t(this).addClass("tabbed"), void t(this).one("blur", function (e) {
        t(this).removeClass("tabbed");
      });
    });
    var n = t(".hiddendiv").first();
    n.length || (n = t('<div class="hiddendiv common"></div>'), t("body").append(n));
    t(".materialize-textarea").each(function () {
      var e = t(this);
      e.data("original-height", e.height()), e.data("previous-length", e.val().length);
    }), t("body").on("keyup keydown autoresize", ".materialize-textarea", function () {
      e(t(this));
    }), t(document).on("change", '.file-field input[type="file"]', function () {
      for (var e = t(this).closest(".file-field").find("input.file-path"), i = t(this)[0].files, n = [], o = 0; o < i.length; o++) {
        n.push(i[o].name);
      }

      e.val(n.join(", ")), e.trigger("change");
    });
    var o = "input[type=range]",
        a = !1;
    t(o).each(function () {
      var e = t('<span class="thumb"><span class="value"></span></span>');
      t(this).after(e);
    });

    var r = function r(t) {
      var e = -7 + parseInt(t.parent().css("padding-left")) + "px";
      t.velocity({
        height: "30px",
        width: "30px",
        top: "-30px",
        marginLeft: e
      }, {
        duration: 300,
        easing: "easeOutExpo"
      });
    },
        s = function s(t) {
      var e = t.width() - 15,
          i = parseFloat(t.attr("max")),
          n = parseFloat(t.attr("min"));
      return (parseFloat(t.val()) - n) / (i - n) * e;
    };

    t(document).on("change", o, function (e) {
      var i = t(this).siblings(".thumb");
      i.find(".value").html(t(this).val()), i.hasClass("active") || r(i);
      var n = s(t(this));
      i.addClass("active").css("left", n);
    }), t(document).on("mousedown touchstart", o, function (e) {
      var i = t(this).siblings(".thumb");

      if (i.length <= 0 && (i = t('<span class="thumb"><span class="value"></span></span>'), t(this).after(i)), i.find(".value").html(t(this).val()), a = !0, t(this).addClass("active"), i.hasClass("active") || r(i), "input" !== e.type) {
        var n = s(t(this));
        i.addClass("active").css("left", n);
      }
    }), t(document).on("mouseup touchend", ".range-field", function () {
      a = !1, t(this).removeClass("active");
    }), t(document).on("input mousemove touchmove", ".range-field", function (e) {
      var i = t(this).children(".thumb"),
          n = t(this).find(o);

      if (a) {
        i.hasClass("active") || r(i);
        var l = s(n);
        i.addClass("active").css("left", l), i.find(".value").html(i.siblings(o).val());
      }
    }), t(document).on("mouseout touchleave", ".range-field", function () {
      if (!a) {
        var e = t(this).children(".thumb"),
            i = 7 + parseInt(t(this).css("padding-left")) + "px";
        e.hasClass("active") && e.velocity({
          height: "0",
          width: "0",
          top: "10px",
          marginLeft: i
        }, {
          duration: 100
        }), e.removeClass("active");
      }
    }), t.fn.autocomplete = function (e) {
      var i = {
        data: {},
        limit: 1 / 0,
        onAutocomplete: null,
        minLength: 1
      };
      return e = t.extend(i, e), this.each(function () {
        var i,
            n = t(this),
            o = e.data,
            a = 0,
            r = -1,
            s = n.closest(".input-field");
        if (t.isEmptyObject(o)) n.off("keyup.autocomplete focus.autocomplete");else {
          var l,
              c = t('<ul class="autocomplete-content dropdown-content"></ul>');
          s.length ? (l = s.children(".autocomplete-content.dropdown-content").first()).length || s.append(c) : (l = n.next(".autocomplete-content.dropdown-content")).length || n.after(c), l.length && (c = l);

          var u = function u(t, e) {
            var i = e.find("img"),
                n = e.text().toLowerCase().indexOf("" + t.toLowerCase()),
                o = n + t.length - 1,
                a = e.text().slice(0, n),
                r = e.text().slice(n, o + 1),
                s = e.text().slice(o + 1);
            e.html("<span>" + a + "<span class='highlight'>" + r + "</span>" + s + "</span>"), i.length && e.prepend(i);
          },
              d = function d() {
            r = -1, c.find(".active").removeClass("active");
          },
              p = function p() {
            c.empty(), d(), i = void 0;
          };

          n.off("blur.autocomplete").on("blur.autocomplete", function () {
            p();
          }), n.off("keyup.autocomplete focus.autocomplete").on("keyup.autocomplete focus.autocomplete", function (r) {
            a = 0;
            var s = n.val().toLowerCase();

            if (13 !== r.which && 38 !== r.which && 40 !== r.which) {
              if (i !== s && (p(), s.length >= e.minLength)) for (var l in o) {
                if (o.hasOwnProperty(l) && -1 !== l.toLowerCase().indexOf(s)) {
                  if (a >= e.limit) break;
                  var d = t("<li></li>");
                  o[l] ? d.append('<img src="' + o[l] + '" class="right circle"><span>' + l + "</span>") : d.append("<span>" + l + "</span>"), c.append(d), u(s, d), a++;
                }
              }
              i = s;
            }
          }), n.off("keydown.autocomplete").on("keydown.autocomplete", function (t) {
            var e,
                i = t.which,
                n = c.children("li").length,
                o = c.children(".active").first();
            13 === i && r >= 0 ? (e = c.children("li").eq(r)).length && (e.trigger("mousedown.autocomplete"), t.preventDefault()) : 38 !== i && 40 !== i || (t.preventDefault(), 38 === i && r > 0 && r--, 40 === i && r < n - 1 && r++, o.removeClass("active"), r >= 0 && c.children("li").eq(r).addClass("active"));
          }), c.off("mousedown.autocomplete touchstart.autocomplete").on("mousedown.autocomplete touchstart.autocomplete", "li", function () {
            var i = t(this).text().trim();
            n.val(i), n.trigger("change"), p(), "function" == typeof e.onAutocomplete && e.onAutocomplete.call(this, i);
          });
        }
      });
    };
  }), t.fn.material_select = function (e) {
    function i(t, e, i) {
      var o = t.indexOf(e),
          a = -1 === o;
      return a ? t.push(e) : t.splice(o, 1), i.siblings("ul.dropdown-content").find("li:not(.optgroup)").eq(e).toggleClass("active"), i.find("option").eq(e).prop("selected", a), n(t, i), a;
    }

    function n(t, e) {
      for (var i = "", n = 0, o = t.length; n < o; n++) {
        var a = e.find("option").eq(t[n]).text();
        i += 0 === n ? a : ", " + a;
      }

      "" === i && (i = e.find("option:disabled").eq(0).text()), e.siblings("input.select-dropdown").val(i);
    }

    t(this).each(function () {
      var n = t(this);

      if (!n.hasClass("browser-default")) {
        var o = !!n.attr("multiple"),
            a = n.attr("data-select-id");
        if (a && (n.parent().find("span.caret").remove(), n.parent().find("input").remove(), n.unwrap(), t("ul#select-options-" + a).remove()), "destroy" === e) return n.removeAttr("data-select-id").removeClass("initialized"), void t(window).off("click.select");
        var r = Materialize.guid();
        n.attr("data-select-id", r);
        var s = t('<div class="select-wrapper"></div>');
        s.addClass(n.attr("class")), n.is(":disabled") && s.addClass("disabled");

        var l = t('<ul id="select-options-' + r + '" class="dropdown-content select-dropdown ' + (o ? "multiple-select-dropdown" : "") + '"></ul>'),
            c = n.children("option, optgroup"),
            u = [],
            d = !1,
            p = n.find("option:selected").html() || n.find("option:first").html() || "",
            h = function h(e, i, n) {
          var a = i.is(":disabled") ? "disabled " : "",
              r = "optgroup-option" === n ? "optgroup-option " : "",
              s = o ? '<input type="checkbox"' + a + "/><label></label>" : "",
              c = i.data("icon"),
              u = i.attr("class");

          if (c) {
            var d = "";
            return u && (d = ' class="' + u + '"'), l.append(t('<li class="' + a + r + '"><img alt="" src="' + c + '"' + d + "><span>" + s + i.html() + "</span></li>")), !0;
          }

          l.append(t('<li class="' + a + r + '"><span>' + s + i.html() + "</span></li>"));
        };

        c.length && c.each(function () {
          if (t(this).is("option")) o ? h(0, t(this), "multiple") : h(0, t(this));else if (t(this).is("optgroup")) {
            var e = t(this).children("option");
            l.append(t('<li class="optgroup"><span>' + t(this).attr("label") + "</span></li>")), e.each(function () {
              h(0, t(this), "optgroup-option");
            });
          }
        }), l.find("li:not(.optgroup)").each(function (a) {
          t(this).click(function (r) {
            if (!t(this).hasClass("disabled") && !t(this).hasClass("optgroup")) {
              var s = !0;
              o ? (t('input[type="checkbox"]', this).prop("checked", function (t, e) {
                return !e;
              }), s = i(u, a, n), m.trigger("focus")) : (l.find("li").removeClass("active"), t(this).toggleClass("active"), m.val(t(this).text())), g(l, t(this)), n.find("option").eq(a).prop("selected", s), n.trigger("change"), void 0 !== e && e();
            }

            r.stopPropagation();
          });
        }), n.wrap(s);
        var f = t('<span class="caret">&#9660;</span>'),
            v = p.replace(/"/g, "&quot;"),
            m = t('<input type="text" class="select-dropdown" readonly="true" ' + (n.is(":disabled") ? "disabled" : "") + ' data-activates="select-options-' + r + '" value="' + v + '"/>');
        n.before(m), m.before(f), m.after(l), n.is(":disabled") || m.dropdown({
          hover: !1
        }), n.attr("tabindex") && t(m[0]).attr("tabindex", n.attr("tabindex")), n.addClass("initialized"), m.on({
          focus: function focus() {
            if (t("ul.select-dropdown").not(l[0]).is(":visible") && (t("input.select-dropdown").trigger("close"), t(window).off("click.select")), !l.is(":visible")) {
              t(this).trigger("open", ["focus"]);
              var e = t(this).val();
              o && e.indexOf(",") >= 0 && (e = e.split(",")[0]);
              var i = l.find("li").filter(function () {
                return t(this).text().toLowerCase() === e.toLowerCase();
              })[0];
              g(l, i, !0), t(window).off("click.select").on("click.select", function () {
                o && (d || m.trigger("close")), t(window).off("click.select");
              });
            }
          },
          click: function click(t) {
            t.stopPropagation();
          }
        }), m.on("blur", function () {
          o || (t(this).trigger("close"), t(window).off("click.select")), l.find("li.selected").removeClass("selected");
        }), l.hover(function () {
          d = !0;
        }, function () {
          d = !1;
        }), o && n.find("option:selected:not(:disabled)").each(function () {
          var t = this.index;
          i(u, t, n), l.find("li:not(.optgroup)").eq(t).find(":checkbox").prop("checked", !0);
        });

        var g = function g(e, i, n) {
          if (i) {
            e.find("li.selected").removeClass("selected");
            var a = t(i);
            a.addClass("selected"), o && !n || l.scrollTo(a);
          }
        },
            y = [];

        m.on("keydown", function (e) {
          if (9 != e.which) {
            if (40 != e.which || l.is(":visible")) {
              if (13 != e.which || l.is(":visible")) {
                e.preventDefault();
                var i = String.fromCharCode(e.which).toLowerCase(),
                    n = [9, 13, 27, 38, 40];

                if (i && -1 === n.indexOf(e.which)) {
                  y.push(i);
                  var a = y.join(""),
                      r = l.find("li").filter(function () {
                    return 0 === t(this).text().toLowerCase().indexOf(a);
                  })[0];
                  r && g(l, r);
                }

                if (13 == e.which) {
                  var s = l.find("li.selected:not(.disabled)")[0];
                  s && (t(s).trigger("click"), o || m.trigger("close"));
                }

                40 == e.which && (r = l.find("li.selected").length ? l.find("li.selected").next("li:not(.disabled)")[0] : l.find("li:not(.disabled)")[0], g(l, r)), 27 == e.which && m.trigger("close"), 38 == e.which && (r = l.find("li.selected").prev("li:not(.disabled)")[0]) && g(l, r), setTimeout(function () {
                  y = [];
                }, 1e3);
              }
            } else m.trigger("open");
          } else m.trigger("close");
        });
      }
    });
  };
}(jQuery), function (t) {
  var e = {
    init: function init(e) {
      var i = {
        indicators: !0,
        height: 400,
        transition: 500,
        interval: 6e3
      };
      return e = t.extend(i, e), this.each(function () {
        function i(t, e) {
          t.hasClass("center-align") ? t.velocity({
            opacity: 0,
            translateY: -100
          }, {
            duration: e,
            queue: !1
          }) : t.hasClass("right-align") ? t.velocity({
            opacity: 0,
            translateX: 100
          }, {
            duration: e,
            queue: !1
          }) : t.hasClass("left-align") && t.velocity({
            opacity: 0,
            translateX: -100
          }, {
            duration: e,
            queue: !1
          });
        }

        function n(t) {
          t >= c.length ? t = 0 : t < 0 && (t = c.length - 1), (u = l.find(".active").index()) != t && (o = c.eq(u), $caption = o.find(".caption"), o.removeClass("active"), o.velocity({
            opacity: 0
          }, {
            duration: e.transition,
            queue: !1,
            easing: "easeOutQuad",
            complete: function complete() {
              c.not(".active").velocity({
                opacity: 0,
                translateX: 0,
                translateY: 0
              }, {
                duration: 0,
                queue: !1
              });
            }
          }), i($caption, e.transition), e.indicators && a.eq(u).removeClass("active"), c.eq(t).velocity({
            opacity: 1
          }, {
            duration: e.transition,
            queue: !1,
            easing: "easeOutQuad"
          }), c.eq(t).find(".caption").velocity({
            opacity: 1,
            translateX: 0,
            translateY: 0
          }, {
            duration: e.transition,
            delay: e.transition,
            queue: !1,
            easing: "easeOutQuad"
          }), c.eq(t).addClass("active"), e.indicators && a.eq(t).addClass("active"));
        }

        var o,
            a,
            r,
            s = t(this),
            l = s.find("ul.slides").first(),
            c = l.find("> li"),
            u = l.find(".active").index();
        -1 != u && (o = c.eq(u)), s.hasClass("fullscreen") || (e.indicators ? s.height(e.height + 40) : s.height(e.height), l.height(e.height)), c.find(".caption").each(function () {
          i(t(this), 0);
        }), c.find("img").each(function () {
          var e = "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
          t(this).attr("src") !== e && (t(this).css("background-image", 'url("' + t(this).attr("src") + '")'), t(this).attr("src", e));
        }), e.indicators && (a = t('<ul class="indicators"></ul>'), c.each(function (i) {
          var o = t('<li class="indicator-item"></li>');
          o.click(function () {
            n(l.parent().find(t(this)).index()), clearInterval(r), r = setInterval(function () {
              u = l.find(".active").index(), c.length == u + 1 ? u = 0 : u += 1, n(u);
            }, e.transition + e.interval);
          }), a.append(o);
        }), s.append(a), a = s.find("ul.indicators").find("li.indicator-item")), o ? o.show() : (c.first().addClass("active").velocity({
          opacity: 1
        }, {
          duration: e.transition,
          queue: !1,
          easing: "easeOutQuad"
        }), u = 0, o = c.eq(u), e.indicators && a.eq(u).addClass("active")), o.find("img").each(function () {
          o.find(".caption").velocity({
            opacity: 1,
            translateX: 0,
            translateY: 0
          }, {
            duration: e.transition,
            queue: !1,
            easing: "easeOutQuad"
          });
        }), r = setInterval(function () {
          n((u = l.find(".active").index()) + 1);
        }, e.transition + e.interval);
        var d = !1,
            p = !1,
            h = !1;
        s.hammer({
          prevent_default: !1
        }).on("pan", function (t) {
          if ("touch" === t.gesture.pointerType) {
            clearInterval(r);
            var e = t.gesture.direction,
                i = t.gesture.deltaX,
                n = t.gesture.velocityX,
                o = t.gesture.velocityY;
            $curr_slide = l.find(".active"), Math.abs(n) > Math.abs(o) && $curr_slide.velocity({
              translateX: i
            }, {
              duration: 50,
              queue: !1,
              easing: "easeOutQuad"
            }), 4 === e && (i > s.innerWidth() / 2 || n < -.65) ? h = !0 : 2 === e && (i < -1 * s.innerWidth() / 2 || n > .65) && (p = !0);
            var a;
            p && (0 === (a = $curr_slide.next()).length && (a = c.first()), a.velocity({
              opacity: 1
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad"
            })), h && (0 === (a = $curr_slide.prev()).length && (a = c.last()), a.velocity({
              opacity: 1
            }, {
              duration: 300,
              queue: !1,
              easing: "easeOutQuad"
            }));
          }
        }).on("panend", function (t) {
          "touch" === t.gesture.pointerType && ($curr_slide = l.find(".active"), d = !1, curr_index = l.find(".active").index(), !h && !p || c.length <= 1 ? $curr_slide.velocity({
            translateX: 0
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad"
          }) : p ? (n(curr_index + 1), $curr_slide.velocity({
            translateX: -1 * s.innerWidth()
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad",
            complete: function complete() {
              $curr_slide.velocity({
                opacity: 0,
                translateX: 0
              }, {
                duration: 0,
                queue: !1
              });
            }
          })) : h && (n(curr_index - 1), $curr_slide.velocity({
            translateX: s.innerWidth()
          }, {
            duration: 300,
            queue: !1,
            easing: "easeOutQuad",
            complete: function complete() {
              $curr_slide.velocity({
                opacity: 0,
                translateX: 0
              }, {
                duration: 0,
                queue: !1
              });
            }
          })), p = !1, h = !1, clearInterval(r), r = setInterval(function () {
            u = l.find(".active").index(), c.length == u + 1 ? u = 0 : u += 1, n(u);
          }, e.transition + e.interval));
        }), s.on("sliderPause", function () {
          clearInterval(r);
        }), s.on("sliderStart", function () {
          clearInterval(r), r = setInterval(function () {
            u = l.find(".active").index(), c.length == u + 1 ? u = 0 : u += 1, n(u);
          }, e.transition + e.interval);
        }), s.on("sliderNext", function () {
          n((u = l.find(".active").index()) + 1);
        }), s.on("sliderPrev", function () {
          n((u = l.find(".active").index()) - 1);
        });
      });
    },
    pause: function pause() {
      t(this).trigger("sliderPause");
    },
    start: function start() {
      t(this).trigger("sliderStart");
    },
    next: function next() {
      t(this).trigger("sliderNext");
    },
    prev: function prev() {
      t(this).trigger("sliderPrev");
    }
  };

  t.fn.slider = function (i) {
    return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != _typeof(i) && i ? void t.error("Method " + i + " does not exist on jQuery.tooltip") : e.init.apply(this, arguments);
  };
}(jQuery), function (t) {
  t(document).ready(function () {
    t(document).on("click.card", ".card", function (e) {
      if (t(this).find("> .card-reveal").length) {
        var i = t(e.target).closest(".card");
        void 0 === i.data("initialOverflow") && i.data("initialOverflow", void 0 === i.css("overflow") ? "" : i.css("overflow")), t(e.target).is(t(".card-reveal .card-title")) || t(e.target).is(t(".card-reveal .card-title i")) ? t(this).find(".card-reveal").velocity({
          translateY: 0
        }, {
          duration: 225,
          queue: !1,
          easing: "easeInOutQuad",
          complete: function complete() {
            t(this).css({
              display: "none"
            }), i.css("overflow", i.data("initialOverflow"));
          }
        }) : (t(e.target).is(t(".card .activator")) || t(e.target).is(t(".card .activator i"))) && (i.css("overflow", "hidden"), t(this).find(".card-reveal").css({
          display: "block"
        }).velocity("stop", !1).velocity({
          translateY: "-100%"
        }, {
          duration: 300,
          queue: !1,
          easing: "easeInOutQuad"
        }));
      }
    });
  });
}(jQuery), function (t) {
  var e = {
    data: [],
    placeholder: "",
    secondaryPlaceholder: "",
    autocompleteOptions: {}
  };
  t(document).ready(function () {
    t(document).on("click", ".chip .close", function (e) {
      t(this).closest(".chips").attr("data-initialized") || t(this).closest(".chip").remove();
    });
  }), t.fn.material_chip = function (i) {
    var n = this;
    if (this.$el = t(this), this.$document = t(document), this.SELS = {
      CHIPS: ".chips",
      CHIP: ".chip",
      INPUT: "input",
      DELETE: ".material-icons",
      SELECTED_CHIP: ".selected"
    }, "data" === i) return this.$el.data("chips");
    var o = t.extend({}, e, i);
    n.hasAutocomplete = !t.isEmptyObject(o.autocompleteOptions.data), this.init = function () {
      var e = 0;
      n.$el.each(function () {
        var i = t(this),
            a = Materialize.guid();
        n.chipId = a, o.data && o.data instanceof Array || (o.data = []), i.data("chips", o.data), i.attr("data-index", e), i.attr("data-initialized", !0), i.hasClass(n.SELS.CHIPS) || i.addClass("chips"), n.chips(i, a), e++;
      });
    }, this.handleEvents = function () {
      var e = n.SELS;
      n.$document.off("click.chips-focus", e.CHIPS).on("click.chips-focus", e.CHIPS, function (i) {
        t(i.target).find(e.INPUT).focus();
      }), n.$document.off("click.chips-select", e.CHIP).on("click.chips-select", e.CHIP, function (i) {
        var o = t(i.target);

        if (o.length) {
          var a = o.hasClass("selected"),
              r = o.closest(e.CHIPS);
          t(e.CHIP).removeClass("selected"), a || n.selectChip(o.index(), r);
        }
      }), n.$document.off("keydown.chips").on("keydown.chips", function (i) {
        if (!t(i.target).is("input, textarea")) {
          var o,
              a = n.$document.find(e.CHIP + e.SELECTED_CHIP),
              r = a.closest(e.CHIPS),
              s = a.siblings(e.CHIP).length;
          if (a.length) if (8 === i.which || 46 === i.which) {
            i.preventDefault(), o = a.index(), n.deleteChip(o, r);
            var l = null;
            o + 1 < s ? l = o : o !== s && o + 1 !== s || (l = s - 1), l < 0 && (l = null), null !== l && n.selectChip(l, r), s || r.find("input").focus();
          } else if (37 === i.which) {
            if ((o = a.index() - 1) < 0) return;
            t(e.CHIP).removeClass("selected"), n.selectChip(o, r);
          } else if (39 === i.which) {
            if (o = a.index() + 1, t(e.CHIP).removeClass("selected"), o > s) return void r.find("input").focus();
            n.selectChip(o, r);
          }
        }
      }), n.$document.off("focusin.chips", e.CHIPS + " " + e.INPUT).on("focusin.chips", e.CHIPS + " " + e.INPUT, function (i) {
        var n = t(i.target).closest(e.CHIPS);
        n.addClass("focus"), n.siblings("label, .prefix").addClass("active"), t(e.CHIP).removeClass("selected");
      }), n.$document.off("focusout.chips", e.CHIPS + " " + e.INPUT).on("focusout.chips", e.CHIPS + " " + e.INPUT, function (i) {
        var n = t(i.target).closest(e.CHIPS);
        n.removeClass("focus"), void 0 !== n.data("chips") && n.data("chips").length || n.siblings("label").removeClass("active"), n.siblings(".prefix").removeClass("active");
      }), n.$document.off("keydown.chips-add", e.CHIPS + " " + e.INPUT).on("keydown.chips-add", e.CHIPS + " " + e.INPUT, function (i) {
        var o = t(i.target),
            a = o.closest(e.CHIPS),
            r = a.children(e.CHIP).length;

        if (13 === i.which) {
          if (n.hasAutocomplete && a.find(".autocomplete-content.dropdown-content").length && a.find(".autocomplete-content.dropdown-content").children().length) return;
          return i.preventDefault(), n.addChip({
            tag: o.val()
          }, a), void o.val("");
        }

        if ((8 === i.keyCode || 37 === i.keyCode) && "" === o.val() && r) return i.preventDefault(), n.selectChip(r - 1, a), void o.blur();
      }), n.$document.off("click.chips-delete", e.CHIPS + " " + e.DELETE).on("click.chips-delete", e.CHIPS + " " + e.DELETE, function (i) {
        var o = t(i.target),
            a = o.closest(e.CHIPS),
            r = o.closest(e.CHIP);
        i.stopPropagation(), n.deleteChip(r.index(), a), a.find("input").focus();
      });
    }, this.chips = function (e, i) {
      e.empty(), e.data("chips").forEach(function (t) {
        e.append(n.renderChip(t));
      }), e.append(t('<input id="' + i + '" class="input" placeholder="">')), n.setPlaceholder(e);
      var a = e.next("label");
      a.length && (a.attr("for", i), void 0 !== e.data("chips") && e.data("chips").length && a.addClass("active"));
      var r = t("#" + i);
      n.hasAutocomplete && (o.autocompleteOptions.onAutocomplete = function (t) {
        n.addChip({
          tag: t
        }, e), r.val(""), r.focus();
      }, r.autocomplete(o.autocompleteOptions));
    }, this.renderChip = function (e) {
      if (e.tag) {
        var i = t('<div class="chip"></div>');
        return i.text(e.tag), e.image && i.prepend(t("<img />").attr("src", e.image)), i.append(t('<i class="material-icons close">close</i>')), i;
      }
    }, this.setPlaceholder = function (t) {
      void 0 !== t.data("chips") && !t.data("chips").length && o.placeholder ? t.find("input").prop("placeholder", o.placeholder) : (void 0 === t.data("chips") || t.data("chips").length) && o.secondaryPlaceholder && t.find("input").prop("placeholder", o.secondaryPlaceholder);
    }, this.isValid = function (t, e) {
      for (var i = t.data("chips"), n = !1, o = 0; o < i.length; o++) {
        if (i[o].tag === e.tag) return void (n = !0);
      }

      return "" !== e.tag && !n;
    }, this.addChip = function (t, e) {
      if (n.isValid(e, t)) {
        for (var i = n.renderChip(t), o = [], a = e.data("chips"), r = 0; r < a.length; r++) {
          o.push(a[r]);
        }

        o.push(t), e.data("chips", o), i.insertBefore(e.find("input")), e.trigger("chip.add", t), n.setPlaceholder(e);
      }
    }, this.deleteChip = function (t, e) {
      var i = e.data("chips")[t];
      e.find(".chip").eq(t).remove();

      for (var o = [], a = e.data("chips"), r = 0; r < a.length; r++) {
        r !== t && o.push(a[r]);
      }

      e.data("chips", o), e.trigger("chip.delete", i), n.setPlaceholder(e);
    }, this.selectChip = function (t, e) {
      var i = e.find(".chip").eq(t);
      i && !1 === i.hasClass("selected") && (i.addClass("selected"), e.trigger("chip.select", e.data("chips")[t]));
    }, this.getChipsElement = function (t, e) {
      return e.eq(t);
    }, this.init(), this.handleEvents();
  };
}(jQuery), function (t) {
  t.fn.pushpin = function (e) {
    var i = {
      top: 0,
      bottom: 1 / 0,
      offset: 0
    };
    return "remove" === e ? (this.each(function () {
      (id = t(this).data("pushpin-id")) && (t(window).off("scroll." + id), t(this).removeData("pushpin-id").removeClass("pin-top pinned pin-bottom").removeAttr("style"));
    }), !1) : (e = t.extend(i, e), $index = 0, this.each(function () {
      function i(t) {
        t.removeClass("pin-top"), t.removeClass("pinned"), t.removeClass("pin-bottom");
      }

      function n(n, o) {
        n.each(function () {
          e.top <= o && e.bottom >= o && !t(this).hasClass("pinned") && (i(t(this)), t(this).css("top", e.offset), t(this).addClass("pinned")), o < e.top && !t(this).hasClass("pin-top") && (i(t(this)), t(this).css("top", 0), t(this).addClass("pin-top")), o > e.bottom && !t(this).hasClass("pin-bottom") && (i(t(this)), t(this).addClass("pin-bottom"), t(this).css("top", e.bottom - r));
        });
      }

      var o = Materialize.guid(),
          a = t(this),
          r = t(this).offset().top;
      t(this).data("pushpin-id", o), n(a, t(window).scrollTop()), t(window).on("scroll." + o, function () {
        var i = t(window).scrollTop() + e.offset;
        n(a, i);
      });
    }));
  };
}(jQuery), function (t) {
  t(document).ready(function () {
    t.fn.reverse = [].reverse, t(document).on("mouseenter.fixedActionBtn", ".fixed-action-btn:not(.click-to-toggle):not(.toolbar)", function (i) {
      var n = t(this);
      e(n);
    }), t(document).on("mouseleave.fixedActionBtn", ".fixed-action-btn:not(.click-to-toggle):not(.toolbar)", function (e) {
      var n = t(this);
      i(n);
    }), t(document).on("click.fabClickToggle", ".fixed-action-btn.click-to-toggle > a", function (n) {
      var o = t(this).parent();
      o.hasClass("active") ? i(o) : e(o);
    }), t(document).on("click.fabToolbar", ".fixed-action-btn.toolbar > a", function (e) {
      var i = t(this).parent();
      n(i);
    });
  }), t.fn.extend({
    openFAB: function openFAB() {
      e(t(this));
    },
    closeFAB: function closeFAB() {
      i(t(this));
    },
    openToolbar: function openToolbar() {
      n(t(this));
    },
    closeToolbar: function closeToolbar() {
      o(t(this));
    }
  });

  var e = function e(_e2) {
    var i = _e2;

    if (!1 === i.hasClass("active")) {
      var n, o;
      !0 === i.hasClass("horizontal") ? o = 40 : n = 40, i.addClass("active"), i.find("ul .btn-floating").velocity({
        scaleY: ".4",
        scaleX: ".4",
        translateY: n + "px",
        translateX: o + "px"
      }, {
        duration: 0
      });
      var a = 0;
      i.find("ul .btn-floating").reverse().each(function () {
        t(this).velocity({
          opacity: "1",
          scaleX: "1",
          scaleY: "1",
          translateY: "0",
          translateX: "0"
        }, {
          duration: 80,
          delay: a
        }), a += 40;
      });
    }
  },
      i = function i(t) {
    var e,
        i,
        n = t;
    !0 === n.hasClass("horizontal") ? i = 40 : e = 40, n.removeClass("active");
    n.find("ul .btn-floating").velocity("stop", !0), n.find("ul .btn-floating").velocity({
      opacity: "0",
      scaleX: ".4",
      scaleY: ".4",
      translateY: e + "px",
      translateX: i + "px"
    }, {
      duration: 80
    });
  },
      n = function n(e) {
    if ("true" !== e.attr("data-open")) {
      var i,
          n,
          a,
          r = window.innerWidth,
          s = window.innerHeight,
          l = e[0].getBoundingClientRect(),
          c = e.find("> a").first(),
          u = e.find("> ul").first(),
          d = t('<div class="fab-backdrop"></div>'),
          p = c.css("background-color");
      c.append(d), i = l.left - r / 2 + l.width / 2, n = s - l.bottom, a = r / d.width(), e.attr("data-origin-bottom", l.bottom), e.attr("data-origin-left", l.left), e.attr("data-origin-width", l.width), e.addClass("active"), e.attr("data-open", !0), e.css({
        "text-align": "center",
        width: "100%",
        bottom: 0,
        left: 0,
        transform: "translateX(" + i + "px)",
        transition: "none"
      }), c.css({
        transform: "translateY(" + -n + "px)",
        transition: "none"
      }), d.css({
        "background-color": p
      }), setTimeout(function () {
        e.css({
          transform: "",
          transition: "transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s"
        }), c.css({
          overflow: "visible",
          transform: "",
          transition: "transform .2s"
        }), setTimeout(function () {
          e.css({
            overflow: "hidden",
            "background-color": p
          }), d.css({
            transform: "scale(" + a + ")",
            transition: "transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)"
          }), u.find("> li > a").css({
            opacity: 1
          }), t(window).on("scroll.fabToolbarClose", function () {
            o(e), t(window).off("scroll.fabToolbarClose"), t(document).off("click.fabToolbarClose");
          }), t(document).on("click.fabToolbarClose", function (i) {
            t(i.target).closest(u).length || (o(e), t(window).off("scroll.fabToolbarClose"), t(document).off("click.fabToolbarClose"));
          });
        }, 100);
      }, 0);
    }
  },
      o = function o(t) {
    if ("true" === t.attr("data-open")) {
      var e,
          i,
          n = window.innerWidth,
          o = window.innerHeight,
          a = t.attr("data-origin-width"),
          r = t.attr("data-origin-bottom"),
          s = t.attr("data-origin-left"),
          l = t.find("> .btn-floating").first(),
          c = t.find("> ul").first(),
          u = t.find(".fab-backdrop"),
          d = l.css("background-color");
      e = s - n / 2 + a / 2, i = o - r, n / u.width(), t.removeClass("active"), t.attr("data-open", !1), t.css({
        "background-color": "transparent",
        transition: "none"
      }), l.css({
        transition: "none"
      }), u.css({
        transform: "scale(0)",
        "background-color": d
      }), c.find("> li > a").css({
        opacity: ""
      }), setTimeout(function () {
        u.remove(), t.css({
          "text-align": "",
          width: "",
          bottom: "",
          left: "",
          overflow: "",
          "background-color": "",
          transform: "translate3d(" + -e + "px,0,0)"
        }), l.css({
          overflow: "",
          transform: "translate3d(0," + i + "px,0)"
        }), setTimeout(function () {
          t.css({
            transform: "translate3d(0,0,0)",
            transition: "transform .2s"
          }), l.css({
            transform: "translate3d(0,0,0)",
            transition: "transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)"
          });
        }, 20);
      }, 200);
    }
  };
}(jQuery), function (t) {
  Materialize.fadeInImage = function (e) {
    var i;
    if ("string" == typeof e) i = t(e);else {
      if ("object" != _typeof(e)) return;
      i = e;
    }
    i.css({
      opacity: 0
    }), t(i).velocity({
      opacity: 1
    }, {
      duration: 650,
      queue: !1,
      easing: "easeOutSine"
    }), t(i).velocity({
      opacity: 1
    }, {
      duration: 1300,
      queue: !1,
      easing: "swing",
      step: function step(e, i) {
        i.start = 100;
        var n = e / 100,
            o = 150 - (100 - e) / 1.75;
        o < 100 && (o = 100), e >= 0 && t(this).css({
          "-webkit-filter": "grayscale(" + n + ")brightness(" + o + "%)",
          filter: "grayscale(" + n + ")brightness(" + o + "%)"
        });
      }
    });
  }, Materialize.showStaggeredList = function (e) {
    var i;
    if ("string" == typeof e) i = t(e);else {
      if ("object" != _typeof(e)) return;
      i = e;
    }
    var n = 0;
    i.find("li").velocity({
      translateX: "-100px"
    }, {
      duration: 0
    }), i.find("li").each(function () {
      t(this).velocity({
        opacity: "1",
        translateX: "0"
      }, {
        duration: 800,
        delay: n,
        easing: [60, 10]
      }), n += 120;
    });
  }, t(document).ready(function () {
    var e = !1,
        i = !1;
    t(".dismissable").each(function () {
      t(this).hammer({
        prevent_default: !1
      }).on("pan", function (n) {
        if ("touch" === n.gesture.pointerType) {
          var o = t(this),
              a = n.gesture.direction,
              r = n.gesture.deltaX,
              s = n.gesture.velocityX;
          o.velocity({
            translateX: r
          }, {
            duration: 50,
            queue: !1,
            easing: "easeOutQuad"
          }), 4 === a && (r > o.innerWidth() / 2 || s < -.75) && (e = !0), 2 === a && (r < -1 * o.innerWidth() / 2 || s > .75) && (i = !0);
        }
      }).on("panend", function (n) {
        if (Math.abs(n.gesture.deltaX) < t(this).innerWidth() / 2 && (i = !1, e = !1), "touch" === n.gesture.pointerType) {
          var o = t(this);

          if (e || i) {
            var a;
            a = e ? o.innerWidth() : -1 * o.innerWidth(), o.velocity({
              translateX: a
            }, {
              duration: 100,
              queue: !1,
              easing: "easeOutQuad",
              complete: function complete() {
                o.css("border", "none"), o.velocity({
                  height: 0,
                  padding: 0
                }, {
                  duration: 200,
                  queue: !1,
                  easing: "easeOutQuad",
                  complete: function complete() {
                    o.remove();
                  }
                });
              }
            });
          } else o.velocity({
            translateX: 0
          }, {
            duration: 100,
            queue: !1,
            easing: "easeOutQuad"
          });

          e = !1, i = !1;
        }
      });
    });
  });
}(jQuery), function (t) {
  var e = !1;

  Materialize.scrollFire = function (t) {
    var i = function i() {
      for (var e = window.pageYOffset + window.innerHeight, i = 0; i < t.length; i++) {
        var n = t[i],
            o = n.selector,
            a = n.offset,
            r = n.callback,
            s = document.querySelector(o);
        null !== s && e > s.getBoundingClientRect().top + window.pageYOffset + a && !0 !== n.done && ("function" == typeof r ? r.call(this, s) : "string" == typeof r && new Function(r)(s), n.done = !0);
      }
    },
        n = Materialize.throttle(function () {
      i();
    }, t.throttle || 100);

    e || (window.addEventListener("scroll", n), window.addEventListener("resize", n), e = !0), setTimeout(n, 0);
  };
}(jQuery), function (t) {
  Materialize.Picker = t(jQuery);
}(function (t) {
  function e(a, s, u, d) {
    function p() {
      return e._.node("div", e._.node("div", e._.node("div", e._.node("div", T.component.nodes(b.open), k.box), k.wrap), k.frame), k.holder);
    }

    function h() {
      x.data(s, T).addClass(k.input).attr("tabindex", -1).val(x.data("value") ? T.get("select", w.format) : a.value), w.editable || x.on("focus." + b.id + " click." + b.id, function (t) {
        t.preventDefault(), T.$root.eq(0).focus();
      }).on("keydown." + b.id, m), o(a, {
        haspopup: !0,
        expanded: !1,
        readonly: !1,
        owns: a.id + "_root"
      });
    }

    function f() {
      T.$root.on({
        keydown: m,
        focusin: function focusin(t) {
          T.$root.removeClass(k.focused), t.stopPropagation();
        },
        "mousedown click": function mousedownClick(e) {
          var i = e.target;
          i != T.$root.children()[0] && (e.stopPropagation(), "mousedown" != e.type || t(i).is("input, select, textarea, button, option") || (e.preventDefault(), T.$root.eq(0).focus()));
        }
      }).on({
        focus: function focus() {
          x.addClass(k.target);
        },
        blur: function blur() {
          x.removeClass(k.target);
        }
      }).on("focus.toOpen", g).on("click", "[data-pick], [data-nav], [data-clear], [data-close]", function () {
        var e = t(this),
            i = e.data(),
            n = e.hasClass(k.navDisabled) || e.hasClass(k.disabled),
            o = r();
        o = o && (o.type || o.href) && o, (n || o && !t.contains(T.$root[0], o)) && T.$root.eq(0).focus(), !n && i.nav ? T.set("highlight", T.component.item.highlight, {
          nav: i.nav
        }) : !n && "pick" in i ? (T.set("select", i.pick), w.closeOnSelect && T.close(!0)) : i.clear ? (T.clear(), w.closeOnSelect && T.close(!0)) : i.close && T.close(!0);
      }), o(T.$root[0], "hidden", !0);
    }

    function v() {
      var e;
      !0 === w.hiddenName ? (e = a.name, a.name = "") : e = (e = ["string" == typeof w.hiddenPrefix ? w.hiddenPrefix : "", "string" == typeof w.hiddenSuffix ? w.hiddenSuffix : "_submit"])[0] + a.name + e[1], T._hidden = t('<input type=hidden name="' + e + '"' + (x.data("value") || a.value ? ' value="' + T.get("select", w.formatSubmit) + '"' : "") + ">")[0], x.on("change." + b.id, function () {
        T._hidden.value = a.value ? T.get("select", w.formatSubmit) : "";
      }), w.container ? t(w.container).append(T._hidden) : x.before(T._hidden);
    }

    function m(t) {
      var e = t.keyCode,
          i = /^(8|46)$/.test(e);
      if (27 == e) return T.close(), !1;
      (32 == e || i || !b.open && T.component.key[e]) && (t.preventDefault(), t.stopPropagation(), i ? T.clear().close() : T.open());
    }

    function g(t) {
      t.stopPropagation(), "focus" == t.type && T.$root.addClass(k.focused), T.open();
    }

    if (!a) return e;

    var y = !1,
        b = {
      id: a.id || "P" + Math.abs(~~(Math.random() * new Date()))
    },
        w = u ? t.extend(!0, {}, u.defaults, d) : d || {},
        k = t.extend({}, e.klasses(), w.klass),
        x = t(a),
        C = function C() {
      return this.start();
    },
        T = C.prototype = {
      constructor: C,
      $node: x,
      start: function start() {
        return b && b.start ? T : (b.methods = {}, b.start = !0, b.open = !1, b.type = a.type, a.autofocus = a == r(), a.readOnly = !w.editable, a.id = a.id || b.id, "text" != a.type && (a.type = "text"), T.component = new u(T, w), T.$root = t(e._.node("div", p(), k.picker, 'id="' + a.id + '_root" tabindex="0"')), f(), w.formatSubmit && v(), h(), w.container ? t(w.container).append(T.$root) : x.before(T.$root), T.on({
          start: T.component.onStart,
          render: T.component.onRender,
          stop: T.component.onStop,
          open: T.component.onOpen,
          close: T.component.onClose,
          set: T.component.onSet
        }).on({
          start: w.onStart,
          render: w.onRender,
          stop: w.onStop,
          open: w.onOpen,
          close: w.onClose,
          set: w.onSet
        }), y = i(T.$root.children()[0]), a.autofocus && T.open(), T.trigger("start").trigger("render"));
      },
      render: function render(t) {
        return t ? T.$root.html(p()) : T.$root.find("." + k.box).html(T.component.nodes(b.open)), T.trigger("render");
      },
      stop: function stop() {
        return b.start ? (T.close(), T._hidden && T._hidden.parentNode.removeChild(T._hidden), T.$root.remove(), x.removeClass(k.input).removeData(s), setTimeout(function () {
          x.off("." + b.id);
        }, 0), a.type = b.type, a.readOnly = !1, T.trigger("stop"), b.methods = {}, b.start = !1, T) : T;
      },
      open: function open(i) {
        return b.open ? T : (x.addClass(k.active), o(a, "expanded", !0), setTimeout(function () {
          T.$root.addClass(k.opened), o(T.$root[0], "hidden", !1);
        }, 0), !1 !== i && (b.open = !0, y && c.css("overflow", "hidden").css("padding-right", "+=" + n()), T.$root.eq(0).focus(), l.on("click." + b.id + " focusin." + b.id, function (t) {
          var e = t.target;
          e != a && e != document && 3 != t.which && T.close(e === T.$root.children()[0]);
        }).on("keydown." + b.id, function (i) {
          var n = i.keyCode,
              o = T.component.key[n],
              a = i.target;
          27 == n ? T.close(!0) : a != T.$root[0] || !o && 13 != n ? t.contains(T.$root[0], a) && 13 == n && (i.preventDefault(), a.click()) : (i.preventDefault(), o ? e._.trigger(T.component.key.go, T, [e._.trigger(o)]) : T.$root.find("." + k.highlighted).hasClass(k.disabled) || (T.set("select", T.component.item.highlight), w.closeOnSelect && T.close(!0)));
        })), T.trigger("open"));
      },
      close: function close(t) {
        return t && (T.$root.off("focus.toOpen").eq(0).focus(), setTimeout(function () {
          T.$root.on("focus.toOpen", g);
        }, 0)), x.removeClass(k.active), o(a, "expanded", !1), setTimeout(function () {
          T.$root.removeClass(k.opened + " " + k.focused), o(T.$root[0], "hidden", !0);
        }, 0), b.open ? (b.open = !1, y && c.css("overflow", "").css("padding-right", "-=" + n()), l.off("." + b.id), T.trigger("close")) : T;
      },
      clear: function clear(t) {
        return T.set("clear", null, t);
      },
      set: function set(e, i, n) {
        var o,
            a,
            r = t.isPlainObject(e),
            s = r ? e : {};

        if (n = r && t.isPlainObject(i) ? i : n || {}, e) {
          r || (s[e] = i);

          for (o in s) {
            a = s[o], o in T.component.item && (void 0 === a && (a = null), T.component.set(o, a, n)), "select" != o && "clear" != o || x.val("clear" == o ? "" : T.get(o, w.format)).trigger("change");
          }

          T.render();
        }

        return n.muted ? T : T.trigger("set", s);
      },
      get: function get(t, i) {
        if (t = t || "value", null != b[t]) return b[t];

        if ("valueSubmit" == t) {
          if (T._hidden) return T._hidden.value;
          t = "value";
        }

        if ("value" == t) return a.value;

        if (t in T.component.item) {
          if ("string" == typeof i) {
            var n = T.component.get(t);
            return n ? e._.trigger(T.component.formats.toString, T.component, [i, n]) : "";
          }

          return T.component.get(t);
        }
      },
      on: function on(e, i, n) {
        var o,
            a,
            r = t.isPlainObject(e),
            s = r ? e : {};

        if (e) {
          r || (s[e] = i);

          for (o in s) {
            a = s[o], n && (o = "_" + o), b.methods[o] = b.methods[o] || [], b.methods[o].push(a);
          }
        }

        return T;
      },
      off: function off() {
        var t,
            e,
            i = arguments;

        for (t = 0, namesCount = i.length; t < namesCount; t += 1) {
          (e = i[t]) in b.methods && delete b.methods[e];
        }

        return T;
      },
      trigger: function trigger(t, i) {
        var n = function n(t) {
          var n = b.methods[t];
          n && n.map(function (t) {
            e._.trigger(t, T, [i]);
          });
        };

        return n("_" + t), n(t), T;
      }
    };

    return new C();
  }

  function i(t) {
    var e;
    return t.currentStyle ? e = t.currentStyle.position : window.getComputedStyle && (e = getComputedStyle(t).position), "fixed" == e;
  }

  function n() {
    if (c.height() <= s.height()) return 0;
    var e = t('<div style="visibility:hidden;width:100px" />').appendTo("body"),
        i = e[0].offsetWidth;
    e.css("overflow", "scroll");
    var n = t('<div style="width:100%" />').appendTo(e)[0].offsetWidth;
    return e.remove(), i - n;
  }

  function o(e, i, n) {
    if (t.isPlainObject(i)) for (var o in i) {
      a(e, o, i[o]);
    } else a(e, i, n);
  }

  function a(t, e, i) {
    t.setAttribute(("role" == e ? "" : "aria-") + e, i);
  }

  function r() {
    try {
      return document.activeElement;
    } catch (t) {}
  }

  var s = t(window),
      l = t(document),
      c = t(document.documentElement);
  return e.klasses = function (t) {
    return t = t || "picker", {
      picker: t,
      opened: t + "--opened",
      focused: t + "--focused",
      input: t + "__input",
      active: t + "__input--active",
      target: t + "__input--target",
      holder: t + "__holder",
      frame: t + "__frame",
      wrap: t + "__wrap",
      box: t + "__box"
    };
  }, e._ = {
    group: function group(t) {
      for (var i, n = "", o = e._.trigger(t.min, t); o <= e._.trigger(t.max, t, [o]); o += t.i) {
        i = e._.trigger(t.item, t, [o]), n += e._.node(t.node, i[0], i[1], i[2]);
      }

      return n;
    },
    node: function node(e, i, n, o) {
      return i ? (i = t.isArray(i) ? i.join("") : i, n = n ? ' class="' + n + '"' : "", o = o ? " " + o : "", "<" + e + n + o + ">" + i + "</" + e + ">") : "";
    },
    lead: function lead(t) {
      return (t < 10 ? "0" : "") + t;
    },
    trigger: function trigger(t, e, i) {
      return "function" == typeof t ? t.apply(e, i || []) : t;
    },
    digits: function digits(t) {
      return /\d/.test(t[1]) ? 2 : 1;
    },
    isDate: function isDate(t) {
      return {}.toString.call(t).indexOf("Date") > -1 && this.isInteger(t.getDate());
    },
    isInteger: function isInteger(t) {
      return {}.toString.call(t).indexOf("Number") > -1 && t % 1 == 0;
    },
    ariaAttr: function ariaAttr(e, i) {
      t.isPlainObject(e) || (e = {
        attribute: i
      }), i = "";

      for (var n in e) {
        var o = ("role" == n ? "" : "aria-") + n;
        i += null == e[n] ? "" : o + '="' + e[n] + '"';
      }

      return i;
    }
  }, e.extend = function (i, n) {
    t.fn[i] = function (o, a) {
      var r = this.data(i);
      return "picker" == o ? r : r && "string" == typeof o ? e._.trigger(r[o], r, [a]) : this.each(function () {
        t(this).data(i) || new e(this, i, n, o);
      });
    }, t.fn[i].defaults = n.defaults;
  }, e;
}), function (t) {
  t(Materialize.Picker, jQuery);
}(function (t, e) {
  function i(t, e) {
    var i = this,
        n = t.$node[0],
        o = n.value,
        a = t.$node.data("value"),
        r = a || o,
        s = a ? e.formatSubmit : e.format,
        l = function l() {
      return n.currentStyle ? "rtl" == n.currentStyle.direction : "rtl" == getComputedStyle(t.$root[0]).direction;
    };

    i.settings = e, i.$node = t.$node, i.queue = {
      min: "measure create",
      max: "measure create",
      now: "now create",
      select: "parse create validate",
      highlight: "parse navigate create validate",
      view: "parse create validate viewset",
      disable: "deactivate",
      enable: "activate"
    }, i.item = {}, i.item.clear = null, i.item.disable = (e.disable || []).slice(0), i.item.enable = -function (t) {
      return !0 === t[0] ? t.shift() : -1;
    }(i.item.disable), i.set("min", e.min).set("max", e.max).set("now"), r ? i.set("select", r, {
      format: s
    }) : i.set("select", null).set("highlight", i.item.now), i.key = {
      40: 7,
      38: -7,
      39: function _() {
        return l() ? -1 : 1;
      },
      37: function _() {
        return l() ? 1 : -1;
      },
      go: function go(t) {
        var e = i.item.highlight,
            n = new Date(e.year, e.month, e.date + t);
        i.set("highlight", n, {
          interval: t
        }), this.render();
      }
    }, t.on("render", function () {
      t.$root.find("." + e.klass.selectMonth).on("change", function () {
        var i = this.value;
        i && (t.set("highlight", [t.get("view").year, i, t.get("highlight").date]), t.$root.find("." + e.klass.selectMonth).trigger("focus"));
      }), t.$root.find("." + e.klass.selectYear).on("change", function () {
        var i = this.value;
        i && (t.set("highlight", [i, t.get("view").month, t.get("highlight").date]), t.$root.find("." + e.klass.selectYear).trigger("focus"));
      });
    }, 1).on("open", function () {
      var n = "";
      i.disabled(i.get("now")) && (n = ":not(." + e.klass.buttonToday + ")"), t.$root.find("button" + n + ", select").attr("disabled", !1);
    }, 1).on("close", function () {
      t.$root.find("button, select").attr("disabled", !0);
    }, 1);
  }

  var n = t._;
  i.prototype.set = function (t, e, i) {
    var n = this,
        o = n.item;
    return null === e ? ("clear" == t && (t = "select"), o[t] = e, n) : (o["enable" == t ? "disable" : "flip" == t ? "enable" : t] = n.queue[t].split(" ").map(function (o) {
      return e = n[o](t, e, i);
    }).pop(), "select" == t ? n.set("highlight", o.select, i) : "highlight" == t ? n.set("view", o.highlight, i) : t.match(/^(flip|min|max|disable|enable)$/) && (o.select && n.disabled(o.select) && n.set("select", o.select, i), o.highlight && n.disabled(o.highlight) && n.set("highlight", o.highlight, i)), n);
  }, i.prototype.get = function (t) {
    return this.item[t];
  }, i.prototype.create = function (t, i, o) {
    var a,
        r = this;
    return i = void 0 === i ? t : i, i == -1 / 0 || i == 1 / 0 ? a = i : e.isPlainObject(i) && n.isInteger(i.pick) ? i = i.obj : e.isArray(i) ? (i = new Date(i[0], i[1], i[2]), i = n.isDate(i) ? i : r.create().obj) : i = n.isInteger(i) || n.isDate(i) ? r.normalize(new Date(i), o) : r.now(t, i, o), {
      year: a || i.getFullYear(),
      month: a || i.getMonth(),
      date: a || i.getDate(),
      day: a || i.getDay(),
      obj: a || i,
      pick: a || i.getTime()
    };
  }, i.prototype.createRange = function (t, i) {
    var o = this,
        a = function a(t) {
      return !0 === t || e.isArray(t) || n.isDate(t) ? o.create(t) : t;
    };

    return n.isInteger(t) || (t = a(t)), n.isInteger(i) || (i = a(i)), n.isInteger(t) && e.isPlainObject(i) ? t = [i.year, i.month, i.date + t] : n.isInteger(i) && e.isPlainObject(t) && (i = [t.year, t.month, t.date + i]), {
      from: a(t),
      to: a(i)
    };
  }, i.prototype.withinRange = function (t, e) {
    return t = this.createRange(t.from, t.to), e.pick >= t.from.pick && e.pick <= t.to.pick;
  }, i.prototype.overlapRanges = function (t, e) {
    var i = this;
    return t = i.createRange(t.from, t.to), e = i.createRange(e.from, e.to), i.withinRange(t, e.from) || i.withinRange(t, e.to) || i.withinRange(e, t.from) || i.withinRange(e, t.to);
  }, i.prototype.now = function (t, e, i) {
    return e = new Date(), i && i.rel && e.setDate(e.getDate() + i.rel), this.normalize(e, i);
  }, i.prototype.navigate = function (t, i, n) {
    var o,
        a,
        r,
        s,
        l = e.isArray(i),
        c = e.isPlainObject(i),
        u = this.item.view;

    if (l || c) {
      for (c ? (a = i.year, r = i.month, s = i.date) : (a = +i[0], r = +i[1], s = +i[2]), n && n.nav && u && u.month !== r && (a = u.year, r = u.month), a = (o = new Date(a, r + (n && n.nav ? n.nav : 0), 1)).getFullYear(), r = o.getMonth(); new Date(a, r, s).getMonth() !== r;) {
        s -= 1;
      }

      i = [a, r, s];
    }

    return i;
  }, i.prototype.normalize = function (t) {
    return t.setHours(0, 0, 0, 0), t;
  }, i.prototype.measure = function (t, e) {
    var i = this;
    return e ? "string" == typeof e ? e = i.parse(t, e) : n.isInteger(e) && (e = i.now(t, e, {
      rel: e
    })) : e = "min" == t ? -1 / 0 : 1 / 0, e;
  }, i.prototype.viewset = function (t, e) {
    return this.create([e.year, e.month, 1]);
  }, i.prototype.validate = function (t, i, o) {
    var a,
        r,
        s,
        l,
        c = this,
        u = i,
        d = o && o.interval ? o.interval : 1,
        p = -1 === c.item.enable,
        h = c.item.min,
        f = c.item.max,
        v = p && c.item.disable.filter(function (t) {
      if (e.isArray(t)) {
        var o = c.create(t).pick;
        o < i.pick ? a = !0 : o > i.pick && (r = !0);
      }

      return n.isInteger(t);
    }).length;
    if ((!o || !o.nav) && (!p && c.disabled(i) || p && c.disabled(i) && (v || a || r) || !p && (i.pick <= h.pick || i.pick >= f.pick))) for (p && !v && (!r && d > 0 || !a && d < 0) && (d *= -1); c.disabled(i) && (Math.abs(d) > 1 && (i.month < u.month || i.month > u.month) && (i = u, d = d > 0 ? 1 : -1), i.pick <= h.pick ? (s = !0, d = 1, i = c.create([h.year, h.month, h.date + (i.pick === h.pick ? 0 : -1)])) : i.pick >= f.pick && (l = !0, d = -1, i = c.create([f.year, f.month, f.date + (i.pick === f.pick ? 0 : 1)])), !s || !l);) {
      i = c.create([i.year, i.month, i.date + d]);
    }
    return i;
  }, i.prototype.disabled = function (t) {
    var i = this,
        o = i.item.disable.filter(function (o) {
      return n.isInteger(o) ? t.day === (i.settings.firstDay ? o : o - 1) % 7 : e.isArray(o) || n.isDate(o) ? t.pick === i.create(o).pick : e.isPlainObject(o) ? i.withinRange(o, t) : void 0;
    });
    return o = o.length && !o.filter(function (t) {
      return e.isArray(t) && "inverted" == t[3] || e.isPlainObject(t) && t.inverted;
    }).length, -1 === i.item.enable ? !o : o || t.pick < i.item.min.pick || t.pick > i.item.max.pick;
  }, i.prototype.parse = function (t, e, i) {
    var o = this,
        a = {};
    return e && "string" == typeof e ? (i && i.format || ((i = i || {}).format = o.settings.format), o.formats.toArray(i.format).map(function (t) {
      var i = o.formats[t],
          r = i ? n.trigger(i, o, [e, a]) : t.replace(/^!/, "").length;
      i && (a[t] = e.substr(0, r)), e = e.substr(r);
    }), [a.yyyy || a.yy, +(a.mm || a.m) - 1, a.dd || a.d]) : e;
  }, i.prototype.formats = function () {
    function t(t, e, i) {
      var n = t.match(/\w+/)[0];
      return i.mm || i.m || (i.m = e.indexOf(n) + 1), n.length;
    }

    function e(t) {
      return t.match(/\w+/)[0].length;
    }

    return {
      d: function d(t, e) {
        return t ? n.digits(t) : e.date;
      },
      dd: function dd(t, e) {
        return t ? 2 : n.lead(e.date);
      },
      ddd: function ddd(t, i) {
        return t ? e(t) : this.settings.weekdaysShort[i.day];
      },
      dddd: function dddd(t, i) {
        return t ? e(t) : this.settings.weekdaysFull[i.day];
      },
      m: function m(t, e) {
        return t ? n.digits(t) : e.month + 1;
      },
      mm: function mm(t, e) {
        return t ? 2 : n.lead(e.month + 1);
      },
      mmm: function mmm(e, i) {
        var n = this.settings.monthsShort;
        return e ? t(e, n, i) : n[i.month];
      },
      mmmm: function mmmm(e, i) {
        var n = this.settings.monthsFull;
        return e ? t(e, n, i) : n[i.month];
      },
      yy: function yy(t, e) {
        return t ? 2 : ("" + e.year).slice(2);
      },
      yyyy: function yyyy(t, e) {
        return t ? 4 : e.year;
      },
      toArray: function toArray(t) {
        return t.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
      },
      toString: function toString(t, e) {
        var i = this;
        return i.formats.toArray(t).map(function (t) {
          return n.trigger(i.formats[t], i, [0, e]) || t.replace(/^!/, "");
        }).join("");
      }
    };
  }(), i.prototype.isDateExact = function (t, i) {
    var o = this;
    return n.isInteger(t) && n.isInteger(i) || "boolean" == typeof t && "boolean" == typeof i ? t === i : (n.isDate(t) || e.isArray(t)) && (n.isDate(i) || e.isArray(i)) ? o.create(t).pick === o.create(i).pick : !(!e.isPlainObject(t) || !e.isPlainObject(i)) && o.isDateExact(t.from, i.from) && o.isDateExact(t.to, i.to);
  }, i.prototype.isDateOverlap = function (t, i) {
    var o = this,
        a = o.settings.firstDay ? 1 : 0;
    return n.isInteger(t) && (n.isDate(i) || e.isArray(i)) ? (t = t % 7 + a) === o.create(i).day + 1 : n.isInteger(i) && (n.isDate(t) || e.isArray(t)) ? (i = i % 7 + a) === o.create(t).day + 1 : !(!e.isPlainObject(t) || !e.isPlainObject(i)) && o.overlapRanges(t, i);
  }, i.prototype.flipEnable = function (t) {
    var e = this.item;
    e.enable = t || (-1 == e.enable ? 1 : -1);
  }, i.prototype.deactivate = function (t, i) {
    var o = this,
        a = o.item.disable.slice(0);
    return "flip" == i ? o.flipEnable() : !1 === i ? (o.flipEnable(1), a = []) : !0 === i ? (o.flipEnable(-1), a = []) : i.map(function (t) {
      for (var i, r = 0; r < a.length; r += 1) {
        if (o.isDateExact(t, a[r])) {
          i = !0;
          break;
        }
      }

      i || (n.isInteger(t) || n.isDate(t) || e.isArray(t) || e.isPlainObject(t) && t.from && t.to) && a.push(t);
    }), a;
  }, i.prototype.activate = function (t, i) {
    var o = this,
        a = o.item.disable,
        r = a.length;
    return "flip" == i ? o.flipEnable() : !0 === i ? (o.flipEnable(1), a = []) : !1 === i ? (o.flipEnable(-1), a = []) : i.map(function (t) {
      var i, s, l, c;

      for (l = 0; l < r; l += 1) {
        if (s = a[l], o.isDateExact(s, t)) {
          i = a[l] = null, c = !0;
          break;
        }

        if (o.isDateOverlap(s, t)) {
          e.isPlainObject(t) ? (t.inverted = !0, i = t) : e.isArray(t) ? (i = t)[3] || i.push("inverted") : n.isDate(t) && (i = [t.getFullYear(), t.getMonth(), t.getDate(), "inverted"]);
          break;
        }
      }

      if (i) for (l = 0; l < r; l += 1) {
        if (o.isDateExact(a[l], t)) {
          a[l] = null;
          break;
        }
      }
      if (c) for (l = 0; l < r; l += 1) {
        if (o.isDateOverlap(a[l], t)) {
          a[l] = null;
          break;
        }
      }
      i && a.push(i);
    }), a.filter(function (t) {
      return null != t;
    });
  }, i.prototype.nodes = function (t) {
    var e = this,
        i = e.settings,
        o = e.item,
        a = o.now,
        r = o.select,
        s = o.highlight,
        l = o.view,
        c = o.disable,
        u = o.min,
        d = o.max,
        p = function (t, e) {
      return i.firstDay && (t.push(t.shift()), e.push(e.shift())), n.node("thead", n.node("tr", n.group({
        min: 0,
        max: 6,
        i: 1,
        node: "th",
        item: function item(n) {
          return [t[n], i.klass.weekdays, 'scope=col title="' + e[n] + '"'];
        }
      })));
    }((i.showWeekdaysFull ? i.weekdaysFull : i.weekdaysLetter).slice(0), i.weekdaysFull.slice(0)),
        h = function h(t) {
      return n.node("div", " ", i.klass["nav" + (t ? "Next" : "Prev")] + (t && l.year >= d.year && l.month >= d.month || !t && l.year <= u.year && l.month <= u.month ? " " + i.klass.navDisabled : ""), "data-nav=" + (t || -1) + " " + n.ariaAttr({
        role: "button",
        controls: e.$node[0].id + "_table"
      }) + ' title="' + (t ? i.labelMonthNext : i.labelMonthPrev) + '"');
    },
        f = function f(o) {
      var a = i.showMonthsShort ? i.monthsShort : i.monthsFull;
      return "short_months" == o && (a = i.monthsShort), i.selectMonths && void 0 == o ? n.node("select", n.group({
        min: 0,
        max: 11,
        i: 1,
        node: "option",
        item: function item(t) {
          return [a[t], 0, "value=" + t + (l.month == t ? " selected" : "") + (l.year == u.year && t < u.month || l.year == d.year && t > d.month ? " disabled" : "")];
        }
      }), i.klass.selectMonth + " browser-default", (t ? "" : "disabled") + " " + n.ariaAttr({
        controls: e.$node[0].id + "_table"
      }) + ' title="' + i.labelMonthSelect + '"') : "short_months" == o ? null != r ? a[r.month] : a[l.month] : n.node("div", a[l.month], i.klass.month);
    },
        v = function v(o) {
      var a = l.year,
          s = !0 === i.selectYears ? 5 : ~~(i.selectYears / 2);

      if (s) {
        var c = u.year,
            p = d.year,
            h = a - s,
            f = a + s;

        if (c > h && (f += c - h, h = c), p < f) {
          var v = h - c,
              m = f - p;
          h -= v > m ? m : v, f = p;
        }

        if (i.selectYears && void 0 == o) return n.node("select", n.group({
          min: h,
          max: f,
          i: 1,
          node: "option",
          item: function item(t) {
            return [t, 0, "value=" + t + (a == t ? " selected" : "")];
          }
        }), i.klass.selectYear + " browser-default", (t ? "" : "disabled") + " " + n.ariaAttr({
          controls: e.$node[0].id + "_table"
        }) + ' title="' + i.labelYearSelect + '"');
      }

      return "raw" === o && null != r ? n.node("div", r.year) : n.node("div", a, i.klass.year);
    };

    return createDayLabel = function createDayLabel() {
      return null != r ? r.date : a.date;
    }, createWeekdayLabel = function createWeekdayLabel() {
      var t;
      return t = null != r ? r.day : a.day, i.weekdaysShort[t];
    }, n.node("div", n.node("div", v("raw"), i.klass.year_display) + n.node("span", createWeekdayLabel() + ", ", "picker__weekday-display") + n.node("span", f("short_months") + " ", i.klass.month_display) + n.node("span", createDayLabel(), i.klass.day_display), i.klass.date_display) + n.node("div", n.node("div", n.node("div", (i.selectYears, f() + v() + h() + h(1)), i.klass.header) + n.node("table", p + n.node("tbody", n.group({
      min: 0,
      max: 5,
      i: 1,
      node: "tr",
      item: function item(t) {
        var o = i.firstDay && 0 === e.create([l.year, l.month, 1]).day ? -7 : 0;
        return [n.group({
          min: 7 * t - l.day + o + 1,
          max: function max() {
            return this.min + 7 - 1;
          },
          i: 1,
          node: "td",
          item: function item(t) {
            t = e.create([l.year, l.month, t + (i.firstDay ? 1 : 0)]);
            var o = r && r.pick == t.pick,
                p = s && s.pick == t.pick,
                h = c && e.disabled(t) || t.pick < u.pick || t.pick > d.pick,
                f = n.trigger(e.formats.toString, e, [i.format, t]);
            return [n.node("div", t.date, function (e) {
              return e.push(l.month == t.month ? i.klass.infocus : i.klass.outfocus), a.pick == t.pick && e.push(i.klass.now), o && e.push(i.klass.selected), p && e.push(i.klass.highlighted), h && e.push(i.klass.disabled), e.join(" ");
            }([i.klass.day]), "data-pick=" + t.pick + " " + n.ariaAttr({
              role: "gridcell",
              label: f,
              selected: !(!o || e.$node.val() !== f) || null,
              activedescendant: !!p || null,
              disabled: !!h || null
            }) + " " + (h ? "" : 'tabindex="0"')), "", n.ariaAttr({
              role: "presentation"
            })];
          }
        })];
      }
    })), i.klass.table, 'id="' + e.$node[0].id + '_table" ' + n.ariaAttr({
      role: "grid",
      controls: e.$node[0].id,
      readonly: !0
    })), i.klass.calendar_container) + n.node("div", n.node("button", i.today, "btn-flat picker__today waves-effect", "type=button data-pick=" + a.pick + (t && !e.disabled(a) ? "" : " disabled") + " " + n.ariaAttr({
      controls: e.$node[0].id
    })) + n.node("button", i.clear, "btn-flat picker__clear waves-effect", "type=button data-clear=1" + (t ? "" : " disabled") + " " + n.ariaAttr({
      controls: e.$node[0].id
    })) + n.node("button", i.close, "btn-flat picker__close waves-effect", "type=button data-close=true " + (t ? "" : " disabled") + " " + n.ariaAttr({
      controls: e.$node[0].id
    })), i.klass.footer), "picker__container__wrapper");
  }, i.defaults = function (t) {
    return {
      labelMonthNext: "Next month",
      labelMonthPrev: "Previous month",
      labelMonthSelect: "Select a month",
      labelYearSelect: "Select a year",
      monthsFull: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      weekdaysFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      weekdaysLetter: ["S", "M", "T", "W", "T", "F", "S"],
      today: "Today",
      clear: "Clear",
      close: "Ok",
      closeOnSelect: !1,
      format: "d mmmm, yyyy",
      klass: {
        table: t + "table",
        header: t + "header",
        date_display: t + "date-display",
        day_display: t + "day-display",
        month_display: t + "month-display",
        year_display: t + "year-display",
        calendar_container: t + "calendar-container",
        navPrev: t + "nav--prev",
        navNext: t + "nav--next",
        navDisabled: t + "nav--disabled",
        month: t + "month",
        year: t + "year",
        selectMonth: t + "select--month",
        selectYear: t + "select--year",
        weekdays: t + "weekday",
        day: t + "day",
        disabled: t + "day--disabled",
        selected: t + "day--selected",
        highlighted: t + "day--highlighted",
        now: t + "day--today",
        infocus: t + "day--infocus",
        outfocus: t + "day--outfocus",
        footer: t + "footer",
        buttonClear: t + "button--clear",
        buttonToday: t + "button--today",
        buttonClose: t + "button--close"
      }
    };
  }(t.klasses().picker + "__"), t.extend("pickadate", i);
}), function (t) {
  function e(t) {
    return document.createElementNS(l, t);
  }

  function i(t) {
    return (t < 10 ? "0" : "") + t;
  }

  function n(t) {
    var e = ++m + "";
    return t ? t + e : e;
  }

  function o(o, r) {
    function l(t, e) {
      var i = d.offset(),
          n = /^touch/.test(t.type),
          o = i.left + g,
          a = i.top + g,
          l = (n ? t.originalEvent.touches[0] : t).pageX - o,
          c = (n ? t.originalEvent.touches[0] : t).pageY - a,
          u = Math.sqrt(l * l + c * c),
          p = !1;

      if (!e || !(u < y - w || u > y + w)) {
        t.preventDefault();
        var v = setTimeout(function () {
          E.popover.addClass("clockpicker-moving");
        }, 200);
        E.setHand(l, c, !e, !0), s.off(h).on(h, function (t) {
          t.preventDefault();
          var e = /^touch/.test(t.type),
              i = (e ? t.originalEvent.touches[0] : t).pageX - o,
              n = (e ? t.originalEvent.touches[0] : t).pageY - a;
          (p || i !== l || n !== c) && (p = !0, E.setHand(i, n, !1, !0));
        }), s.off(f).on(f, function (t) {
          s.off(f), t.preventDefault();
          var i = /^touch/.test(t.type),
              n = (i ? t.originalEvent.changedTouches[0] : t).pageX - o,
              u = (i ? t.originalEvent.changedTouches[0] : t).pageY - a;
          (e || p) && n === l && u === c && E.setHand(n, u), "hours" === E.currentView ? E.toggleView("minutes", x / 2) : r.autoclose && (E.minutesView.addClass("clockpicker-dial-out"), setTimeout(function () {
            E.done();
          }, x / 2)), d.prepend(z), clearTimeout(v), E.popover.removeClass("clockpicker-moving"), s.off(h);
        });
      }
    }

    var u = t(C),
        d = u.find(".clockpicker-plate"),
        v = u.find(".picker__holder"),
        m = u.find(".clockpicker-hours"),
        T = u.find(".clockpicker-minutes"),
        S = u.find(".clockpicker-am-pm-block"),
        P = "INPUT" === o.prop("tagName"),
        A = P ? o : o.find("input"),
        O = t("label[for=" + A.attr("id") + "]"),
        E = this;
    this.id = n("cp"), this.element = o, this.holder = v, this.options = r, this.isAppended = !1, this.isShown = !1, this.currentView = "hours", this.isInput = P, this.input = A, this.label = O, this.popover = u, this.plate = d, this.hoursView = m, this.minutesView = T, this.amPmBlock = S, this.spanHours = u.find(".clockpicker-span-hours"), this.spanMinutes = u.find(".clockpicker-span-minutes"), this.spanAmPm = u.find(".clockpicker-span-am-pm"), this.footer = u.find(".picker__footer"), this.amOrPm = "PM", r.twelvehour && (r.ampmclickable ? (this.spanAmPm.empty(), t('<div id="click-am">AM</div>').on("click", function () {
      E.spanAmPm.children("#click-am").addClass("text-primary"), E.spanAmPm.children("#click-pm").removeClass("text-primary"), E.amOrPm = "AM";
    }).appendTo(this.spanAmPm), t('<div id="click-pm">PM</div>').on("click", function () {
      E.spanAmPm.children("#click-pm").addClass("text-primary"), E.spanAmPm.children("#click-am").removeClass("text-primary"), E.amOrPm = "PM";
    }).appendTo(this.spanAmPm)) : (this.spanAmPm.empty(), t('<div id="click-am">AM</div>').appendTo(this.spanAmPm), t('<div id="click-pm">PM</div>').appendTo(this.spanAmPm))), t('<button type="button" class="btn-flat picker__clear" tabindex="' + (r.twelvehour ? "3" : "1") + '">' + r.cleartext + "</button>").click(t.proxy(this.clear, this)).appendTo(this.footer), t('<button type="button" class="btn-flat picker__close" tabindex="' + (r.twelvehour ? "3" : "1") + '">' + r.canceltext + "</button>").click(t.proxy(this.hide, this)).appendTo(this.footer), t('<button type="button" class="btn-flat picker__close" tabindex="' + (r.twelvehour ? "3" : "1") + '">' + r.donetext + "</button>").click(t.proxy(this.done, this)).appendTo(this.footer), this.spanHours.click(t.proxy(this.toggleView, this, "hours")), this.spanMinutes.click(t.proxy(this.toggleView, this, "minutes")), A.on("focus.clockpicker click.clockpicker", t.proxy(this.show, this));

    var _,
        M,
        I,
        D,
        q = t('<div class="clockpicker-tick"></div>');

    if (r.twelvehour) for (_ = 1; _ < 13; _ += 1) {
      M = q.clone(), I = _ / 6 * Math.PI, D = y, M.css({
        left: g + Math.sin(I) * D - w,
        top: g - Math.cos(I) * D - w
      }), M.html(0 === _ ? "00" : _), m.append(M), M.on(p, l);
    } else for (_ = 0; _ < 24; _ += 1) {
      M = q.clone(), I = _ / 6 * Math.PI, D = _ > 0 && _ < 13 ? b : y, M.css({
        left: g + Math.sin(I) * D - w,
        top: g - Math.cos(I) * D - w
      }), M.html(0 === _ ? "00" : _), m.append(M), M.on(p, l);
    }

    for (_ = 0; _ < 60; _ += 5) {
      M = q.clone(), I = _ / 30 * Math.PI, M.css({
        left: g + Math.sin(I) * y - w,
        top: g - Math.cos(I) * y - w
      }), M.html(i(_)), T.append(M), M.on(p, l);
    }

    if (d.on(p, function (e) {
      0 === t(e.target).closest(".clockpicker-tick").length && l(e, !0);
    }), c) {
      var z = u.find(".clockpicker-canvas"),
          V = e("svg");
      V.setAttribute("class", "clockpicker-svg"), V.setAttribute("width", k), V.setAttribute("height", k);
      var H = e("g");
      H.setAttribute("transform", "translate(" + g + "," + g + ")");
      var L = e("circle");
      L.setAttribute("class", "clockpicker-canvas-bearing"), L.setAttribute("cx", 0), L.setAttribute("cy", 0), L.setAttribute("r", 4);
      var j = e("line");
      j.setAttribute("x1", 0), j.setAttribute("y1", 0);
      var $ = e("circle");
      $.setAttribute("class", "clockpicker-canvas-bg"), $.setAttribute("r", w), H.appendChild(j), H.appendChild($), H.appendChild(L), V.appendChild(H), z.append(V), this.hand = j, this.bg = $, this.bearing = L, this.g = H, this.canvas = z;
    }

    a(this.options.init);
  }

  function a(t) {
    t && "function" == typeof t && t();
  }

  var r = t(window),
      s = t(document),
      l = "http://www.w3.org/2000/svg",
      c = "SVGAngle" in window && function () {
    var t,
        e = document.createElement("div");
    return e.innerHTML = "<svg/>", t = (e.firstChild && e.firstChild.namespaceURI) == l, e.innerHTML = "", t;
  }(),
      u = function () {
    var t = document.createElement("div").style;
    return "transition" in t || "WebkitTransition" in t || "MozTransition" in t || "msTransition" in t || "OTransition" in t;
  }(),
      d = ("ontouchstart" in window),
      p = "mousedown" + (d ? " touchstart" : ""),
      h = "mousemove.clockpicker" + (d ? " touchmove.clockpicker" : ""),
      f = "mouseup.clockpicker" + (d ? " touchend.clockpicker" : ""),
      v = navigator.vibrate ? "vibrate" : navigator.webkitVibrate ? "webkitVibrate" : null,
      m = 0,
      g = 135,
      y = 105,
      b = 70,
      w = 20,
      k = 2 * g,
      x = u ? 350 : 1,
      C = ['<div class="clockpicker picker">', '<div class="picker__holder">', '<div class="picker__frame">', '<div class="picker__wrap">', '<div class="picker__box">', '<div class="picker__date-display">', '<div class="clockpicker-display">', '<div class="clockpicker-display-column">', '<span class="clockpicker-span-hours text-primary"></span>', ":", '<span class="clockpicker-span-minutes"></span>', "</div>", '<div class="clockpicker-display-column clockpicker-display-am-pm">', '<div class="clockpicker-span-am-pm"></div>', "</div>", "</div>", "</div>", '<div class="picker__container__wrapper">', '<div class="picker__calendar-container">', '<div class="clockpicker-plate">', '<div class="clockpicker-canvas"></div>', '<div class="clockpicker-dial clockpicker-hours"></div>', '<div class="clockpicker-dial clockpicker-minutes clockpicker-dial-out"></div>', "</div>", '<div class="clockpicker-am-pm-block">', "</div>", "</div>", '<div class="picker__footer">', "</div>", "</div>", "</div>", "</div>", "</div>", "</div>", "</div>"].join("");

  o.DEFAULTS = {
    "default": "",
    fromnow: 0,
    donetext: "Ok",
    cleartext: "Clear",
    canceltext: "Cancel",
    autoclose: !1,
    ampmclickable: !0,
    darktheme: !1,
    twelvehour: !0,
    vibrate: !0
  }, o.prototype.toggle = function () {
    this[this.isShown ? "hide" : "show"]();
  }, o.prototype.locate = function () {
    var t = this.element,
        e = this.popover;
    t.offset(), t.outerWidth(), t.outerHeight(), this.options.align;
    e.show();
  }, o.prototype.show = function (e) {
    if (!this.isShown) {
      a(this.options.beforeShow), t(":input").each(function () {
        t(this).attr("tabindex", -1);
      });
      var n = this;
      this.input.blur(), this.popover.addClass("picker--opened"), this.input.addClass("picker__input picker__input--active"), t(document.body).css("overflow", "hidden");
      var o = ((this.input.prop("value") || this.options["default"] || "") + "").split(":");

      if (this.options.twelvehour && void 0 !== o[1] && (o[1].indexOf("AM") > 0 ? this.amOrPm = "AM" : this.amOrPm = "PM", o[1] = o[1].replace("AM", "").replace("PM", "")), "now" === o[0]) {
        var l = new Date(+new Date() + this.options.fromnow);
        o = [l.getHours(), l.getMinutes()], this.options.twelvehour && (this.amOrPm = o[0] >= 12 && o[0] < 24 ? "PM" : "AM");
      }

      if (this.hours = +o[0] || 0, this.minutes = +o[1] || 0, this.spanHours.html(this.hours), this.spanMinutes.html(i(this.minutes)), !this.isAppended) {
        var c = document.querySelector(this.options.container);
        this.options.container && c ? c.appendChild(this.popover[0]) : this.popover.insertAfter(this.input), this.options.twelvehour && ("PM" === this.amOrPm ? (this.spanAmPm.children("#click-pm").addClass("text-primary"), this.spanAmPm.children("#click-am").removeClass("text-primary")) : (this.spanAmPm.children("#click-am").addClass("text-primary"), this.spanAmPm.children("#click-pm").removeClass("text-primary"))), r.on("resize.clockpicker" + this.id, function () {
          n.isShown && n.locate();
        }), this.isAppended = !0;
      }

      this.toggleView("hours"), this.locate(), this.isShown = !0, s.on("click.clockpicker." + this.id + " focusin.clockpicker." + this.id, function (e) {
        var i = t(e.target);
        0 === i.closest(n.popover.find(".picker__wrap")).length && 0 === i.closest(n.input).length && n.hide();
      }), s.on("keyup.clockpicker." + this.id, function (t) {
        27 === t.keyCode && n.hide();
      }), a(this.options.afterShow);
    }
  }, o.prototype.hide = function () {
    a(this.options.beforeHide), this.input.removeClass("picker__input picker__input--active"), this.popover.removeClass("picker--opened"), t(document.body).css("overflow", "visible"), this.isShown = !1, t(":input").each(function (e) {
      t(this).attr("tabindex", e + 1);
    }), s.off("click.clockpicker." + this.id + " focusin.clockpicker." + this.id), s.off("keyup.clockpicker." + this.id), this.popover.hide(), a(this.options.afterHide);
  }, o.prototype.toggleView = function (e, i) {
    var n = !1;
    "minutes" === e && "visible" === t(this.hoursView).css("visibility") && (a(this.options.beforeHourSelect), n = !0);
    var o = "hours" === e,
        r = o ? this.hoursView : this.minutesView,
        s = o ? this.minutesView : this.hoursView;
    this.currentView = e, this.spanHours.toggleClass("text-primary", o), this.spanMinutes.toggleClass("text-primary", !o), s.addClass("clockpicker-dial-out"), r.css("visibility", "visible").removeClass("clockpicker-dial-out"), this.resetClock(i), clearTimeout(this.toggleViewTimer), this.toggleViewTimer = setTimeout(function () {
      s.css("visibility", "hidden");
    }, x), n && a(this.options.afterHourSelect);
  }, o.prototype.resetClock = function (t) {
    var e = this.currentView,
        i = this[e],
        n = "hours" === e,
        o = i * (Math.PI / (n ? 6 : 30)),
        a = n && i > 0 && i < 13 ? b : y,
        r = Math.sin(o) * a,
        s = -Math.cos(o) * a,
        l = this;
    c && t ? (l.canvas.addClass("clockpicker-canvas-out"), setTimeout(function () {
      l.canvas.removeClass("clockpicker-canvas-out"), l.setHand(r, s);
    }, t)) : this.setHand(r, s);
  }, o.prototype.setHand = function (e, n, o, a) {
    var r,
        s = Math.atan2(e, -n),
        l = "hours" === this.currentView,
        u = Math.PI / (l || o ? 6 : 30),
        d = Math.sqrt(e * e + n * n),
        p = this.options,
        h = l && d < (y + b) / 2,
        f = h ? b : y;

    if (p.twelvehour && (f = y), s < 0 && (s = 2 * Math.PI + s), r = Math.round(s / u), s = r * u, p.twelvehour ? l ? 0 === r && (r = 12) : (o && (r *= 5), 60 === r && (r = 0)) : l ? (12 === r && (r = 0), r = h ? 0 === r ? 12 : r : 0 === r ? 0 : r + 12) : (o && (r *= 5), 60 === r && (r = 0)), this[this.currentView] !== r && v && this.options.vibrate && (this.vibrateTimer || (navigator[v](10), this.vibrateTimer = setTimeout(t.proxy(function () {
      this.vibrateTimer = null;
    }, this), 100))), this[this.currentView] = r, l ? this.spanHours.html(r) : this.spanMinutes.html(i(r)), c) {
      var m = Math.sin(s) * (f - w),
          g = -Math.cos(s) * (f - w),
          k = Math.sin(s) * f,
          x = -Math.cos(s) * f;
      this.hand.setAttribute("x2", m), this.hand.setAttribute("y2", g), this.bg.setAttribute("cx", k), this.bg.setAttribute("cy", x);
    } else this[l ? "hoursView" : "minutesView"].find(".clockpicker-tick").each(function () {
      var e = t(this);
      e.toggleClass("active", r === +e.html());
    });
  }, o.prototype.done = function () {
    a(this.options.beforeDone), this.hide(), this.label.addClass("active");
    var t = this.input.prop("value"),
        e = i(this.hours) + ":" + i(this.minutes);
    this.options.twelvehour && (e += this.amOrPm), this.input.prop("value", e), e !== t && (this.input.triggerHandler("change"), this.isInput || this.element.trigger("change")), this.options.autoclose && this.input.trigger("blur"), a(this.options.afterDone);
  }, o.prototype.clear = function () {
    this.hide(), this.label.removeClass("active");
    var t = this.input.prop("value");
    this.input.prop("value", ""), "" !== t && (this.input.triggerHandler("change"), this.isInput || this.element.trigger("change")), this.options.autoclose && this.input.trigger("blur");
  }, o.prototype.remove = function () {
    this.element.removeData("clockpicker"), this.input.off("focus.clockpicker click.clockpicker"), this.isShown && this.hide(), this.isAppended && (r.off("resize.clockpicker" + this.id), this.popover.remove());
  }, t.fn.pickatime = function (e) {
    var i = Array.prototype.slice.call(arguments, 1);
    return this.each(function () {
      var n = t(this),
          a = n.data("clockpicker");
      if (a) "function" == typeof a[e] && a[e].apply(a, i);else {
        var r = t.extend({}, o.DEFAULTS, n.data(), "object" == _typeof(e) && e);
        n.data("clockpicker", new o(n, r));
      }
    });
  };
}(jQuery), function (t) {
  function e() {
    var e = +t(this).attr("data-length"),
        i = +t(this).val().length,
        n = i <= e;
    t(this).parent().find('span[class="character-counter"]').html(i + "/" + e), o(n, t(this));
  }

  function i(e) {
    var i = e.parent().find('span[class="character-counter"]');
    i.length || (i = t("<span/>").addClass("character-counter").css("float", "right").css("font-size", "12px").css("height", 1), e.parent().append(i));
  }

  function n() {
    t(this).parent().find('span[class="character-counter"]').html("");
  }

  function o(t, e) {
    var i = e.hasClass("invalid");
    t && i ? e.removeClass("invalid") : t || i || (e.removeClass("valid"), e.addClass("invalid"));
  }

  t.fn.characterCounter = function () {
    return this.each(function () {
      var o = t(this);
      o.parent().find('span[class="character-counter"]').length || void 0 !== o.attr("data-length") && (o.on("input", e), o.on("focus", e), o.on("blur", n), i(o));
    });
  }, t(document).ready(function () {
    t("input, textarea").characterCounter();
  });
}(jQuery), function (t) {
  var e = {
    init: function init(e) {
      var i = {
        duration: 200,
        dist: -100,
        shift: 0,
        padding: 0,
        fullWidth: !1,
        indicators: !1,
        noWrap: !1,
        onCycleTo: null
      };
      e = t.extend(i, e);
      var n = Materialize.objectSelectorString(t(this));
      return this.each(function (i) {
        function o(t) {
          return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
        }

        function a(t) {
          return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
        }

        function r(t) {
          return t >= C ? t % C : t < 0 ? r(C + t % C) : t;
        }

        function s(i) {
          E = !0, j.hasClass("scrolling") || j.addClass("scrolling"), null != H && window.clearTimeout(H), H = window.setTimeout(function () {
            E = !1, j.removeClass("scrolling");
          }, e.duration);
          var n,
              o,
              a,
              s,
              l,
              c,
              u,
              d = w;

          if (b = "number" == typeof i ? i : b, w = Math.floor((b + x / 2) / x), a = b - w * x, s = a < 0 ? 1 : -1, l = -s * a * 2 / x, o = C >> 1, e.fullWidth ? u = "translateX(0)" : (u = "translateX(" + (j[0].clientWidth - m) / 2 + "px) ", u += "translateY(" + (j[0].clientHeight - g) / 2 + "px)"), N) {
            var p = w % C,
                h = V.find(".indicator-item.active");
            h.index() !== p && (h.removeClass("active"), V.find(".indicator-item").eq(p).addClass("active"));
          }

          for ((!W || w >= 0 && w < C) && (c = v[r(w)], t(c).hasClass("active") || (j.find(".carousel-item").removeClass("active"), t(c).addClass("active")), c.style[_] = u + " translateX(" + -a / 2 + "px) translateX(" + s * e.shift * l * n + "px) translateZ(" + e.dist * l + "px)", c.style.zIndex = 0, e.fullWidth ? tweenedOpacity = 1 : tweenedOpacity = 1 - .2 * l, c.style.opacity = tweenedOpacity, c.style.display = "block"), n = 1; n <= o; ++n) {
            e.fullWidth ? (zTranslation = e.dist, tweenedOpacity = n === o && a < 0 ? 1 - l : 1) : (zTranslation = e.dist * (2 * n + l * s), tweenedOpacity = 1 - .2 * (2 * n + l * s)), (!W || w + n < C) && ((c = v[r(w + n)]).style[_] = u + " translateX(" + (e.shift + (x * n - a) / 2) + "px) translateZ(" + zTranslation + "px)", c.style.zIndex = -n, c.style.opacity = tweenedOpacity, c.style.display = "block"), e.fullWidth ? (zTranslation = e.dist, tweenedOpacity = n === o && a > 0 ? 1 - l : 1) : (zTranslation = e.dist * (2 * n - l * s), tweenedOpacity = 1 - .2 * (2 * n - l * s)), (!W || w - n >= 0) && ((c = v[r(w - n)]).style[_] = u + " translateX(" + (-e.shift + (-x * n - a) / 2) + "px) translateZ(" + zTranslation + "px)", c.style.zIndex = -n, c.style.opacity = tweenedOpacity, c.style.display = "block");
          }

          if ((!W || w >= 0 && w < C) && ((c = v[r(w)]).style[_] = u + " translateX(" + -a / 2 + "px) translateX(" + s * e.shift * l + "px) translateZ(" + e.dist * l + "px)", c.style.zIndex = 0, e.fullWidth ? tweenedOpacity = 1 : tweenedOpacity = 1 - .2 * l, c.style.opacity = tweenedOpacity, c.style.display = "block"), d !== w && "function" == typeof e.onCycleTo) {
            var f = j.find(".carousel-item").eq(r(w));
            e.onCycleTo.call(this, f, q);
          }

          "function" == typeof L && (L.call(this, f, q), L = null);
        }

        function l() {
          var t, e, i;
          e = (t = Date.now()) - I, I = t, i = b - M, M = b, O = .8 * (1e3 * i / (1 + e)) + .2 * O;
        }

        function c() {
          var t, i;
          P && (t = Date.now() - I, (i = P * Math.exp(-t / e.duration)) > 2 || i < -2 ? (s(A - i), requestAnimationFrame(c)) : s(A));
        }

        function u(i) {
          if (q) return i.preventDefault(), i.stopPropagation(), !1;

          if (!e.fullWidth) {
            var n = t(i.target).closest(".carousel-item").index();
            0 !== r(w) - n && (i.preventDefault(), i.stopPropagation()), d(n);
          }
        }

        function d(t) {
          var e = w % C - t;
          W || (e < 0 ? Math.abs(e + C) < Math.abs(e) && (e += C) : e > 0 && Math.abs(e - C) < e && (e -= C)), e < 0 ? j.trigger("carouselNext", [Math.abs(e)]) : e > 0 && j.trigger("carouselPrev", [e]);
        }

        function p(e) {
          "mousedown" === e.type && t(e.target).is("img") && e.preventDefault(), k = !0, q = !1, z = !1, T = o(e), S = a(e), O = P = 0, M = b, I = Date.now(), clearInterval(D), D = setInterval(l, 100);
        }

        function h(t) {
          var e, i;
          if (k) if (e = o(t), y = a(t), i = T - e, Math.abs(S - y) < 30 && !z) (i > 2 || i < -2) && (q = !0, T = e, s(b + i));else {
            if (q) return t.preventDefault(), t.stopPropagation(), !1;
            z = !0;
          }
          if (q) return t.preventDefault(), t.stopPropagation(), !1;
        }

        function f(t) {
          if (k) return k = !1, clearInterval(D), A = b, (O > 10 || O < -10) && (A = b + (P = .9 * O)), A = Math.round(A / x) * x, W && (A >= x * (C - 1) ? A = x * (C - 1) : A < 0 && (A = 0)), P = A - b, I = Date.now(), requestAnimationFrame(c), q && (t.preventDefault(), t.stopPropagation()), !1;
        }

        var v,
            m,
            g,
            b,
            w,
            k,
            x,
            C,
            T,
            S,
            P,
            A,
            O,
            E,
            _,
            M,
            I,
            D,
            q,
            z,
            V = t('<ul class="indicators"></ul>'),
            H = null,
            L = null,
            j = t(this),
            $ = j.find(".carousel-item").length > 1,
            N = (j.attr("data-indicators") || e.indicators) && $,
            W = j.attr("data-no-wrap") || e.noWrap || !$,
            F = j.attr("data-namespace") || n + i;

        j.attr("data-namespace", F);

        var Q = function Q(e) {
          var i = j.find(".carousel-item.active").length ? j.find(".carousel-item.active").first() : j.find(".carousel-item").first(),
              n = i.find("img").first();
          if (n.length) {
            if (n[0].complete) {
              if (n.height() > 0) j.css("height", n.height());else {
                var o = n[0].naturalWidth,
                    a = n[0].naturalHeight,
                    r = j.width() / o * a;
                j.css("height", r);
              }
            } else n.on("load", function () {
              j.css("height", t(this).height());
            });
          } else if (!e) {
            var s = i.height();
            j.css("height", s);
          }
        };

        if (e.fullWidth && (e.dist = 0, Q(), N && j.find(".carousel-fixed-item").addClass("with-indicators")), j.hasClass("initialized")) return t(window).trigger("resize"), j.trigger("carouselNext", [1e-6]), !0;
        j.addClass("initialized"), k = !1, b = A = 0, v = [], m = j.find(".carousel-item").first().innerWidth(), g = j.find(".carousel-item").first().innerHeight(), x = 2 * m + e.padding, j.find(".carousel-item").each(function (e) {
          if (v.push(t(this)[0]), N) {
            var i = t('<li class="indicator-item"></li>');
            0 === e && i.addClass("active"), i.click(function (e) {
              e.stopPropagation(), d(t(this).index());
            }), V.append(i);
          }
        }), N && j.append(V), C = v.length, _ = "transform", ["webkit", "Moz", "O", "ms"].every(function (t) {
          var e = t + "Transform";
          return void 0 === document.body.style[e] || (_ = e, !1);
        });
        var X = Materialize.throttle(function () {
          if (e.fullWidth) {
            m = j.find(".carousel-item").first().innerWidth();
            j.find(".carousel-item.active").height();
            x = 2 * m + e.padding, A = b = 2 * w * m, Q(!0);
          } else s();
        }, 200);
        t(window).off("resize.carousel-" + F).on("resize.carousel-" + F, X), void 0 !== window.ontouchstart && (j.on("touchstart.carousel", p), j.on("touchmove.carousel", h), j.on("touchend.carousel", f)), j.on("mousedown.carousel", p), j.on("mousemove.carousel", h), j.on("mouseup.carousel", f), j.on("mouseleave.carousel", f), j.on("click.carousel", u), s(b), t(this).on("carouselNext", function (t, e, i) {
          void 0 === e && (e = 1), "function" == typeof i && (L = i), A = x * Math.round(b / x) + x * e, b !== A && (P = A - b, I = Date.now(), requestAnimationFrame(c));
        }), t(this).on("carouselPrev", function (t, e, i) {
          void 0 === e && (e = 1), "function" == typeof i && (L = i), A = x * Math.round(b / x) - x * e, b !== A && (P = A - b, I = Date.now(), requestAnimationFrame(c));
        }), t(this).on("carouselSet", function (t, e, i) {
          void 0 === e && (e = 0), "function" == typeof i && (L = i), d(e);
        });
      });
    },
    next: function next(e, i) {
      t(this).trigger("carouselNext", [e, i]);
    },
    prev: function prev(e, i) {
      t(this).trigger("carouselPrev", [e, i]);
    },
    set: function set(e, i) {
      t(this).trigger("carouselSet", [e, i]);
    },
    destroy: function destroy() {
      var e = t(this).attr("data-namespace");
      t(this).removeAttr("data-namespace"), t(this).removeClass("initialized"), t(this).find(".indicators").remove(), t(this).off("carouselNext carouselPrev carouselSet"), t(window).off("resize.carousel-" + e), void 0 !== window.ontouchstart && t(this).off("touchstart.carousel touchmove.carousel touchend.carousel"), t(this).off("mousedown.carousel mousemove.carousel mouseup.carousel mouseleave.carousel click.carousel");
    }
  };

  t.fn.carousel = function (i) {
    return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != _typeof(i) && i ? void t.error("Method " + i + " does not exist on jQuery.carousel") : e.init.apply(this, arguments);
  };
}(jQuery), function (t) {
  var e = {
    init: function init(e) {
      return this.each(function () {
        var i = t("#" + t(this).attr("data-activates")),
            n = (t("body"), t(this)),
            o = n.parent(".tap-target-wrapper"),
            a = o.find(".tap-target-wave"),
            r = o.find(".tap-target-origin"),
            s = n.find(".tap-target-content");
        o.length || (o = n.wrap(t('<div class="tap-target-wrapper"></div>')).parent()), s.length || (s = t('<div class="tap-target-content"></div>'), n.append(s)), a.length || (a = t('<div class="tap-target-wave"></div>'), r.length || ((r = i.clone(!0, !0)).addClass("tap-target-origin"), r.removeAttr("id"), r.removeAttr("style"), a.append(r)), o.append(a));

        var l = function l() {
          o.is(".open") && (o.removeClass("open"), r.off("click.tapTarget"), t(document).off("click.tapTarget"), t(window).off("resize.tapTarget"));
        },
            c = function c() {
          var e = "fixed" === i.css("position");
          if (!e) for (var r = i.parents(), l = 0; l < r.length && !(e = "fixed" == t(r[l]).css("position")); l++) {
            ;
          }

          var c = i.outerWidth(),
              u = i.outerHeight(),
              d = e ? i.offset().top - t(document).scrollTop() : i.offset().top,
              p = e ? i.offset().left - t(document).scrollLeft() : i.offset().left,
              h = t(window).width(),
              f = t(window).height(),
              v = h / 2,
              m = f / 2,
              g = p <= v,
              y = p > v,
              b = d <= m,
              w = d > m,
              k = p >= .25 * h && p <= .75 * h,
              x = n.outerWidth(),
              C = n.outerHeight(),
              T = d + u / 2 - C / 2,
              S = p + c / 2 - x / 2,
              P = e ? "fixed" : "absolute",
              A = k ? x : x / 2 + c,
              O = C / 2,
              E = b ? C / 2 : 0,
              _ = g && !k ? x / 2 - c : 0,
              M = c,
              I = w ? "bottom" : "top",
              D = 2 * c,
              q = D,
              z = C / 2 - q / 2,
              V = x / 2 - D / 2,
              H = {};

          H.top = b ? T : "", H.right = y ? h - S - x : "", H.bottom = w ? f - T - C : "", H.left = g ? S : "", H.position = P, o.css(H), s.css({
            width: A,
            height: O,
            top: E,
            right: 0,
            bottom: 0,
            left: _,
            padding: M,
            verticalAlign: I
          }), a.css({
            top: z,
            left: V,
            width: D,
            height: q
          });
        };

        "open" == e && (c(), o.is(".open") || (o.addClass("open"), setTimeout(function () {
          r.off("click.tapTarget").on("click.tapTarget", function (t) {
            l(), r.off("click.tapTarget");
          }), t(document).off("click.tapTarget").on("click.tapTarget", function (e) {
            l(), t(document).off("click.tapTarget");
          });
          var e = Materialize.throttle(function () {
            c();
          }, 200);
          t(window).off("resize.tapTarget").on("resize.tapTarget", e);
        }, 0))), "close" == e && l();
      });
    },
    open: function open() {},
    close: function close() {}
  };

  t.fn.tapTarget = function (i) {
    if (e[i] || "object" == _typeof(i)) return e.init.apply(this, arguments);
    t.error("Method " + i + " does not exist on jQuery.tap-target");
  };
}(jQuery);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**!
 * MixItUp v3.3.0
 * A high-performance, dependency-free library for animated filtering, sorting and more
 * Build 0be05511-2264-4384-8e31-c75554304cd0
 *
 * @copyright Copyright 2014-2018 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://www.kunkalabs.com/mixitup/
 *
 * @license   Commercial use requires a commercial license.
 *            https://www.kunkalabs.com/mixitup/licenses/
 *
 *            Non-commercial use permitted under same terms as CC BY-NC 3.0 license.
 *            http://creativecommons.org/licenses/by-nc/3.0/
 */
!function (t) {
  "use strict";

  var _e = null,
      n = null;
  !function () {
    var e = ["webkit", "moz", "o", "ms"],
        n = t.document.createElement("div"),
        a = -1;

    for (a = 0; a < e.length && !t.requestAnimationFrame; a++) {
      t.requestAnimationFrame = t[e[a] + "RequestAnimationFrame"];
    }

    "undefined" == typeof n.nextElementSibling && Object.defineProperty(t.Element.prototype, "nextElementSibling", {
      get: function get() {
        for (var t = this.nextSibling; t;) {
          if (1 === t.nodeType) return t;
          t = t.nextSibling;
        }

        return null;
      }
    }), function (t) {
      t.matches = t.matches || t.machesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector || t.webkitMatchesSelector || function (t) {
        return Array.prototype.indexOf.call(this.parentElement.querySelectorAll(t), this) > -1;
      };
    }(t.Element.prototype), Object.keys || (Object.keys = function () {
      var t = Object.prototype.hasOwnProperty,
          e = !1,
          n = [],
          a = -1;
      return e = !{
        toString: null
      }.propertyIsEnumerable("toString"), n = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], a = n.length, function (i) {
        var o = [],
            r = "",
            s = -1;
        if ("object" != _typeof(i) && ("function" != typeof i || null === i)) throw new TypeError("Object.keys called on non-object");

        for (r in i) {
          t.call(i, r) && o.push(r);
        }

        if (e) for (s = 0; s < a; s++) {
          t.call(i, n[s]) && o.push(n[s]);
        }
        return o;
      };
    }()), Array.isArray || (Array.isArray = function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    }), "function" != typeof Object.create && (Object.create = function (t) {
      var e = function e() {};

      return function (n, a) {
        if (n !== Object(n) && null !== n) throw TypeError("Argument must be an object, or null");
        e.prototype = n || {};
        var i = new e();
        return e.prototype = null, a !== t && Object.defineProperties(i, a), null === n && (i.__proto__ = null), i;
      };
    }()), String.prototype.trim || (String.prototype.trim = function () {
      return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }), Array.prototype.indexOf || (Array.prototype.indexOf = function (t) {
      var e, n, a, i;
      if (null === this) throw new TypeError();
      if (a = Object(this), i = a.length >>> 0, 0 === i) return -1;
      if (e = 0, arguments.length > 1 && (e = Number(arguments[1]), e !== e ? e = 0 : 0 !== e && e !== 1 / 0 && e !== -(1 / 0) && (e = (e > 0 || -1) * Math.floor(Math.abs(e)))), e >= i) return -1;

      for (n = e >= 0 ? e : Math.max(i - Math.abs(e), 0); n < i; n++) {
        if (n in a && a[n] === t) return n;
      }

      return -1;
    }), Function.prototype.bind || (Function.prototype.bind = function (t) {
      var e, n, a, i;
      if ("function" != typeof this) throw new TypeError();
      return e = Array.prototype.slice.call(arguments, 1), n = this, a = function a() {}, i = function i() {
        return n.apply(this instanceof a ? this : t, e.concat(Array.prototype.slice.call(arguments)));
      }, this.prototype && (a.prototype = this.prototype), i.prototype = new a(), i;
    }), t.Element.prototype.dispatchEvent || (t.Element.prototype.dispatchEvent = function (t) {
      try {
        return this.fireEvent("on" + t.type, t);
      } catch (e) {}
    });
  }(), _e = function e(a, i, o) {
    var r = null,
        s = !1,
        l = null,
        c = null,
        u = null,
        f = null,
        h = [],
        d = "",
        m = [],
        g = -1;
    if (u = o || t.document, (s = arguments[3]) && (s = "boolean" == typeof s), "string" == typeof a) m = u.querySelectorAll(a);else if (a && "object" == _typeof(a) && n.isElement(a, u)) m = [a];else {
      if (!a || "object" != _typeof(a) || !a.length) throw new Error(_e.messages.errorFactoryInvalidContainer());
      m = a;
    }
    if (m.length < 1) throw new Error(_e.messages.errorFactoryContainerNotFound());

    for (g = 0; (r = m[g]) && (!(g > 0) || s); g++) {
      r.id ? d = r.id : (d = "MixItUp" + n.randomHex(), r.id = d), _e.instances[d] instanceof _e.Mixer ? (l = _e.instances[d], (!i || i && i.debug && i.debug.showWarnings !== !1) && console.warn(_e.messages.warningFactoryPreexistingInstance())) : (l = new _e.Mixer(), l.attach(r, u, d, i), _e.instances[d] = l), c = new _e.Facade(l), i && i.debug && i.debug.enable ? h.push(l) : h.push(c);
    }

    return f = s ? new _e.Collection(h) : h[0];
  }, _e.use = function (t) {
    _e.Base.prototype.callActions.call(_e, "beforeUse", arguments), "function" == typeof t && "mixitup-extension" === t.TYPE ? "undefined" == typeof _e.extensions[t.NAME] && (t(_e), _e.extensions[t.NAME] = t) : t.fn && t.fn.jquery && (_e.libraries.$ = t), _e.Base.prototype.callActions.call(_e, "afterUse", arguments);
  }, _e.instances = {}, _e.extensions = {}, _e.libraries = {}, n = {
    hasClass: function hasClass(t, e) {
      return !!t.className.match(new RegExp("(\\s|^)" + e + "(\\s|$)"));
    },
    addClass: function addClass(t, e) {
      this.hasClass(t, e) || (t.className += t.className ? " " + e : e);
    },
    removeClass: function removeClass(t, e) {
      if (this.hasClass(t, e)) {
        var n = new RegExp("(\\s|^)" + e + "(\\s|$)");
        t.className = t.className.replace(n, " ").trim();
      }
    },
    extend: function extend(t, e, n, a) {
      var i = [],
          o = "",
          r = -1;
      n = n || !1, a = a || !1;

      try {
        if (Array.isArray(e)) for (r = 0; r < e.length; r++) {
          i.push(r);
        } else e && (i = Object.keys(e));

        for (r = 0; r < i.length; r++) {
          o = i[r], !n || "object" != _typeof(e[o]) || this.isElement(e[o]) ? t[o] = e[o] : Array.isArray(e[o]) ? (t[o] || (t[o] = []), this.extend(t[o], e[o], n, a)) : (t[o] || (t[o] = {}), this.extend(t[o], e[o], n, a));
        }
      } catch (s) {
        if (!a) throw s;
        this.handleExtendError(s, t);
      }

      return t;
    },
    handleExtendError: function handleExtendError(t, n) {
      var a = /property "?(\w*)"?[,:] object/i,
          i = null,
          o = "",
          r = "",
          s = "",
          l = "",
          c = "",
          u = -1,
          f = -1;

      if (t instanceof TypeError && (i = a.exec(t.message))) {
        o = i[1];

        for (c in n) {
          for (f = 0; f < o.length && o.charAt(f) === c.charAt(f);) {
            f++;
          }

          f > u && (u = f, l = c);
        }

        throw u > 1 && (s = _e.messages.errorConfigInvalidPropertySuggestion({
          probableMatch: l
        })), r = _e.messages.errorConfigInvalidProperty({
          erroneous: o,
          suggestion: s
        }), new TypeError(r);
      }

      throw t;
    },
    template: function template(t) {
      for (var e = /\${([\w]*)}/g, n = {}, a = null; a = e.exec(t);) {
        n[a[1]] = new RegExp("\\${" + a[1] + "}", "g");
      }

      return function (e) {
        var a = "",
            i = t;
        e = e || {};

        for (a in n) {
          i = i.replace(n[a], "undefined" != typeof e[a] ? e[a] : "");
        }

        return i;
      };
    },
    on: function on(e, n, a, i) {
      e && (e.addEventListener ? e.addEventListener(n, a, i) : e.attachEvent && (e["e" + n + a] = a, e[n + a] = function () {
        e["e" + n + a](t.event);
      }, e.attachEvent("on" + n, e[n + a])));
    },
    off: function off(t, e, n) {
      t && (t.removeEventListener ? t.removeEventListener(e, n, !1) : t.detachEvent && (t.detachEvent("on" + e, t[e + n]), t[e + n] = null));
    },
    getCustomEvent: function getCustomEvent(e, n, a) {
      var i = null;
      return a = a || t.document, "function" == typeof t.CustomEvent ? i = new t.CustomEvent(e, {
        detail: n,
        bubbles: !0,
        cancelable: !0
      }) : "function" == typeof a.createEvent ? (i = a.createEvent("CustomEvent"), i.initCustomEvent(e, !0, !0, n)) : (i = a.createEventObject(), i.type = e, i.returnValue = !1, i.cancelBubble = !1, i.detail = n), i;
    },
    getOriginalEvent: function getOriginalEvent(t) {
      return t.touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t;
    },
    index: function index(t, e) {
      for (var n = 0; null !== (t = t.previousElementSibling);) {
        e && !t.matches(e) || ++n;
      }

      return n;
    },
    camelCase: function camelCase(t) {
      return t.toLowerCase().replace(/([_-][a-z])/g, function (t) {
        return t.toUpperCase().replace(/[_-]/, "");
      });
    },
    pascalCase: function pascalCase(t) {
      return (t = this.camelCase(t)).charAt(0).toUpperCase() + t.slice(1);
    },
    dashCase: function dashCase(t) {
      return t.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase();
    },
    isElement: function isElement(e, n) {
      return n = n || t.document, !!(t.HTMLElement && e instanceof t.HTMLElement) || !!(n.defaultView && n.defaultView.HTMLElement && e instanceof n.defaultView.HTMLElement) || null !== e && 1 === e.nodeType && "string" == typeof e.nodeName;
    },
    createElement: function createElement(e, n) {
      var a = null,
          i = null;

      for (n = n || t.document, a = n.createDocumentFragment(), i = n.createElement("div"), i.innerHTML = e.trim(); i.firstChild;) {
        a.appendChild(i.firstChild);
      }

      return a;
    },
    removeWhitespace: function removeWhitespace(t) {
      for (var e; t && "#text" === t.nodeName;) {
        e = t, t = t.previousSibling, e.parentElement && e.parentElement.removeChild(e);
      }
    },
    isEqualArray: function isEqualArray(t, e) {
      var n = t.length;
      if (n !== e.length) return !1;

      for (; n--;) {
        if (t[n] !== e[n]) return !1;
      }

      return !0;
    },
    deepEquals: function deepEquals(t, e) {
      var n;

      if ("object" == _typeof(t) && t && "object" == _typeof(e) && e) {
        if (Object.keys(t).length !== Object.keys(e).length) return !1;

        for (n in t) {
          if (!e.hasOwnProperty(n) || !this.deepEquals(t[n], e[n])) return !1;
        }
      } else if (t !== e) return !1;

      return !0;
    },
    arrayShuffle: function arrayShuffle(t) {
      for (var e = t.slice(), n = e.length, a = n, i = -1, o = []; a--;) {
        i = ~~(Math.random() * n), o = e[a], e[a] = e[i], e[i] = o;
      }

      return e;
    },
    arrayFromList: function arrayFromList(t) {
      var e, n;

      try {
        return Array.prototype.slice.call(t);
      } catch (a) {
        for (e = [], n = 0; n < t.length; n++) {
          e.push(t[n]);
        }

        return e;
      }
    },
    debounce: function debounce(t, e, n) {
      var a;
      return function () {
        var i = this,
            o = arguments,
            r = n && !a,
            s = null;
        s = function s() {
          a = null, n || t.apply(i, o);
        }, clearTimeout(a), a = setTimeout(s, e), r && t.apply(i, o);
      };
    },
    position: function position(t) {
      for (var e = 0, n = 0, a = t; t;) {
        e -= t.scrollLeft, n -= t.scrollTop, t === a && (e += t.offsetLeft, n += t.offsetTop, a = t.offsetParent), t = t.parentElement;
      }

      return {
        x: e,
        y: n
      };
    },
    getHypotenuse: function getHypotenuse(t, e) {
      var n = t.x - e.x,
          a = t.y - e.y;
      return n = n < 0 ? n * -1 : n, a = a < 0 ? a * -1 : a, Math.sqrt(Math.pow(n, 2) + Math.pow(a, 2));
    },
    getIntersectionRatio: function getIntersectionRatio(t, e) {
      var n = t.width * t.height,
          a = -1,
          i = -1,
          o = -1,
          r = -1;
      return a = Math.max(0, Math.min(t.left + t.width, e.left + e.width) - Math.max(t.left, e.left)), i = Math.max(0, Math.min(t.top + t.height, e.top + e.height) - Math.max(t.top, e.top)), o = i * a, r = o / n;
    },
    closestParent: function closestParent(e, n, a, i) {
      var o = e.parentNode;
      if (i = i || t.document, a && e.matches(n)) return e;

      for (; o && o != i.body;) {
        if (o.matches && o.matches(n)) return o;
        if (!o.parentNode) return null;
        o = o.parentNode;
      }

      return null;
    },
    children: function children(e, n, a) {
      var i = [],
          o = "";
      return a = a || t.doc, e && (e.id || (o = "Temp" + this.randomHexKey(), e.id = o), i = a.querySelectorAll("#" + e.id + " > " + n), o && e.removeAttribute("id")), i;
    },
    clean: function clean(t) {
      var e = [],
          n = -1;

      for (n = 0; n < t.length; n++) {
        "" !== t[n] && e.push(t[n]);
      }

      return e;
    },
    defer: function defer(n) {
      var a = null,
          i = null,
          o = null;
      return i = new this.Deferred(), _e.features.has.promises ? i.promise = new Promise(function (t, e) {
        i.resolve = t, i.reject = e;
      }) : (o = t.jQuery || n.$) && "function" == typeof o.Deferred ? (a = o.Deferred(), i.promise = a.promise(), i.resolve = a.resolve, i.reject = a.reject) : t.console && console.warn(_e.messages.warningNoPromiseImplementation()), i;
    },
    all: function all(n, a) {
      var i = null;
      return _e.features.has.promises ? Promise.all(n) : (i = t.jQuery || a.$) && "function" == typeof i.when ? i.when.apply(i, n).done(function () {
        return arguments;
      }) : (t.console && console.warn(_e.messages.warningNoPromiseImplementation()), []);
    },
    getPrefix: function getPrefix(t, e, a) {
      var i = -1,
          o = "";
      if (n.dashCase(e) in t.style) return "";

      for (i = 0; o = a[i]; i++) {
        if (o + e in t.style) return o.toLowerCase();
      }

      return "unsupported";
    },
    randomHex: function randomHex() {
      return ("00000" + (16777216 * Math.random() << 0).toString(16)).substr(-6).toUpperCase();
    },
    getDocumentState: function getDocumentState(e) {
      return e = "object" == _typeof(e.body) ? e : t.document, {
        scrollTop: t.pageYOffset,
        scrollLeft: t.pageXOffset,
        docHeight: e.documentElement.scrollHeight,
        docWidth: e.documentElement.scrollWidth,
        viewportHeight: e.documentElement.clientHeight,
        viewportWidth: e.documentElement.clientWidth
      };
    },
    bind: function bind(t, e) {
      return function () {
        return e.apply(t, arguments);
      };
    },
    isVisible: function isVisible(e) {
      var n = null;
      return !!e.offsetParent || (n = t.getComputedStyle(e), "fixed" === n.position && "hidden" !== n.visibility && "0" !== n.opacity);
    },
    seal: function seal(t) {
      "function" == typeof Object.seal && Object.seal(t);
    },
    freeze: function freeze(t) {
      "function" == typeof Object.freeze && Object.freeze(t);
    },
    compareVersions: function compareVersions(t, e) {
      var n = t.split("."),
          a = e.split("."),
          i = -1,
          o = -1,
          r = -1;

      for (r = 0; r < n.length; r++) {
        if (i = parseInt(n[r].replace(/[^\d.]/g, "")), o = parseInt(a[r].replace(/[^\d.]/g, "") || 0), o < i) return !1;
        if (o > i) return !0;
      }

      return !0;
    },
    Deferred: function Deferred() {
      this.promise = null, this.resolve = null, this.reject = null, this.id = n.randomHex();
    },
    isEmptyObject: function isEmptyObject(t) {
      var e = "";
      if ("function" == typeof Object.keys) return 0 === Object.keys(t).length;

      for (e in t) {
        if (t.hasOwnProperty(e)) return !1;
      }

      return !0;
    },
    getClassname: function getClassname(t, e, n) {
      var a = "";
      return a += t.block, a.length && (a += t.delineatorElement), a += t["element" + this.pascalCase(e)], n ? (a.length && (a += t.delineatorModifier), a += n) : a;
    },
    getProperty: function getProperty(t, e) {
      var n = e.split("."),
          a = null,
          i = "",
          o = 0;
      if (!e) return t;

      for (a = function a(t) {
        return t ? t[i] : null;
      }; o < n.length;) {
        i = n[o], t = a(t), o++;
      }

      return "undefined" != typeof t ? t : null;
    }
  }, _e.h = n, _e.Base = function () {}, _e.Base.prototype = {
    constructor: _e.Base,
    callActions: function callActions(t, e) {
      var a = this,
          i = a.constructor.actions[t],
          o = "";
      if (i && !n.isEmptyObject(i)) for (o in i) {
        i[o].apply(a, e);
      }
    },
    callFilters: function callFilters(t, e, a) {
      var i = this,
          o = i.constructor.filters[t],
          r = e,
          s = "";
      if (!o || n.isEmptyObject(o)) return r;
      a = a || [];

      for (s in o) {
        a = n.arrayFromList(a), a.unshift(r), r = o[s].apply(i, a);
      }

      return r;
    }
  }, _e.BaseStatic = function () {
    this.actions = {}, this.filters = {}, this.extend = function (t) {
      n.extend(this.prototype, t);
    }, this.registerAction = function (t, e, n) {
      (this.actions[t] = this.actions[t] || {})[e] = n;
    }, this.registerFilter = function (t, e, n) {
      (this.filters[t] = this.filters[t] || {})[e] = n;
    };
  }, _e.Features = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.boxSizingPrefix = "", this.transformPrefix = "", this.transitionPrefix = "", this.boxSizingPrefix = "", this.transformProp = "", this.transformRule = "", this.transitionProp = "", this.perspectiveProp = "", this.perspectiveOriginProp = "", this.has = new _e.Has(), this.canary = null, this.BOX_SIZING_PROP = "boxSizing", this.TRANSITION_PROP = "transition", this.TRANSFORM_PROP = "transform", this.PERSPECTIVE_PROP = "perspective", this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin", this.VENDORS = ["Webkit", "moz", "O", "ms"], this.TWEENABLE = ["opacity", "width", "height", "marginRight", "marginBottom", "x", "y", "scale", "translateX", "translateY", "translateZ", "rotateX", "rotateY", "rotateZ"], this.callActions("afterConstruct");
  }, _e.BaseStatic.call(_e.Features), _e.Features.prototype = Object.create(_e.Base.prototype), n.extend(_e.Features.prototype, {
    constructor: _e.Features,
    init: function init() {
      var t = this;
      t.callActions("beforeInit", arguments), t.canary = document.createElement("div"), t.setPrefixes(), t.runTests(), t.callActions("beforeInit", arguments);
    },
    runTests: function runTests() {
      var e = this;
      e.callActions("beforeRunTests", arguments), e.has.promises = "function" == typeof t.Promise, e.has.transitions = "unsupported" !== e.transitionPrefix, e.callActions("afterRunTests", arguments), n.freeze(e.has);
    },
    setPrefixes: function setPrefixes() {
      var t = this;
      t.callActions("beforeSetPrefixes", arguments), t.transitionPrefix = n.getPrefix(t.canary, "Transition", t.VENDORS), t.transformPrefix = n.getPrefix(t.canary, "Transform", t.VENDORS), t.boxSizingPrefix = n.getPrefix(t.canary, "BoxSizing", t.VENDORS), t.boxSizingProp = t.boxSizingPrefix ? t.boxSizingPrefix + n.pascalCase(t.BOX_SIZING_PROP) : t.BOX_SIZING_PROP, t.transitionProp = t.transitionPrefix ? t.transitionPrefix + n.pascalCase(t.TRANSITION_PROP) : t.TRANSITION_PROP, t.transformProp = t.transformPrefix ? t.transformPrefix + n.pascalCase(t.TRANSFORM_PROP) : t.TRANSFORM_PROP, t.transformRule = t.transformPrefix ? "-" + t.transformPrefix + "-" + t.TRANSFORM_PROP : t.TRANSFORM_PROP, t.perspectiveProp = t.transformPrefix ? t.transformPrefix + n.pascalCase(t.PERSPECTIVE_PROP) : t.PERSPECTIVE_PROP, t.perspectiveOriginProp = t.transformPrefix ? t.transformPrefix + n.pascalCase(t.PERSPECTIVE_ORIGIN_PROP) : t.PERSPECTIVE_ORIGIN_PROP, t.callActions("afterSetPrefixes", arguments);
    }
  }), _e.Has = function () {
    this.transitions = !1, this.promises = !1, n.seal(this);
  }, _e.features = new _e.Features(), _e.features.init(), _e.ConfigAnimation = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.enable = !0, this.effects = "fade scale", this.effectsIn = "", this.effectsOut = "", this.duration = 600, this.easing = "ease", this.applyPerspective = !0, this.perspectiveDistance = "3000px", this.perspectiveOrigin = "50% 50%", this.queue = !0, this.queueLimit = 3, this.animateResizeContainer = !0, this.animateResizeTargets = !1, this.staggerSequence = null, this.reverseOut = !1, this.nudge = !0, this.clampHeight = !0, this.clampWidth = !0, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigAnimation), _e.ConfigAnimation.prototype = Object.create(_e.Base.prototype), _e.ConfigAnimation.prototype.constructor = _e.ConfigAnimation, _e.ConfigBehavior = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.liveSort = !1, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigBehavior), _e.ConfigBehavior.prototype = Object.create(_e.Base.prototype), _e.ConfigBehavior.prototype.constructor = _e.ConfigBehavior, _e.ConfigCallbacks = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.onMixStart = null, this.onMixBusy = null, this.onMixEnd = null, this.onMixFail = null, this.onMixClick = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigCallbacks), _e.ConfigCallbacks.prototype = Object.create(_e.Base.prototype), _e.ConfigCallbacks.prototype.constructor = _e.ConfigCallbacks, _e.ConfigControls = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.enable = !0, this.live = !1, this.scope = "global", this.toggleLogic = "or", this.toggleDefault = "all", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigControls), _e.ConfigControls.prototype = Object.create(_e.Base.prototype), _e.ConfigControls.prototype.constructor = _e.ConfigControls, _e.ConfigClassNames = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.block = "mixitup", this.elementContainer = "container", this.elementFilter = "control", this.elementSort = "control", this.elementMultimix = "control", this.elementToggle = "control", this.modifierActive = "active", this.modifierDisabled = "disabled", this.modifierFailed = "failed", this.delineatorElement = "-", this.delineatorModifier = "-", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigClassNames), _e.ConfigClassNames.prototype = Object.create(_e.Base.prototype), _e.ConfigClassNames.prototype.constructor = _e.ConfigClassNames, _e.ConfigData = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.uidKey = "", this.dirtyCheck = !1, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigData), _e.ConfigData.prototype = Object.create(_e.Base.prototype), _e.ConfigData.prototype.constructor = _e.ConfigData, _e.ConfigDebug = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.enable = !1, this.showWarnings = !0, this.fauxAsync = !1, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigDebug), _e.ConfigDebug.prototype = Object.create(_e.Base.prototype), _e.ConfigDebug.prototype.constructor = _e.ConfigDebug, _e.ConfigLayout = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.allowNestedTargets = !0, this.containerClassName = "", this.siblingBefore = null, this.siblingAfter = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigLayout), _e.ConfigLayout.prototype = Object.create(_e.Base.prototype), _e.ConfigLayout.prototype.constructor = _e.ConfigLayout, _e.ConfigLoad = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.filter = "all", this.sort = "default:asc", this.dataset = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigLoad), _e.ConfigLoad.prototype = Object.create(_e.Base.prototype), _e.ConfigLoad.prototype.constructor = _e.ConfigLoad, _e.ConfigSelectors = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.target = ".mix", this.control = "", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigSelectors), _e.ConfigSelectors.prototype = Object.create(_e.Base.prototype), _e.ConfigSelectors.prototype.constructor = _e.ConfigSelectors, _e.ConfigRender = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.target = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigRender), _e.ConfigRender.prototype = Object.create(_e.Base.prototype), _e.ConfigRender.prototype.constructor = _e.ConfigRender, _e.ConfigTemplates = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.ConfigTemplates), _e.ConfigTemplates.prototype = Object.create(_e.Base.prototype), _e.ConfigTemplates.prototype.constructor = _e.ConfigTemplates, _e.Config = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.animation = new _e.ConfigAnimation(), this.behavior = new _e.ConfigBehavior(), this.callbacks = new _e.ConfigCallbacks(), this.controls = new _e.ConfigControls(), this.classNames = new _e.ConfigClassNames(), this.data = new _e.ConfigData(), this.debug = new _e.ConfigDebug(), this.layout = new _e.ConfigLayout(), this.load = new _e.ConfigLoad(), this.selectors = new _e.ConfigSelectors(), this.render = new _e.ConfigRender(), this.templates = new _e.ConfigTemplates(), this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.Config), _e.Config.prototype = Object.create(_e.Base.prototype), _e.Config.prototype.constructor = _e.Config, _e.MixerDom = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.document = null, this.body = null, this.container = null, this.parent = null, this.targets = [], this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.MixerDom), _e.MixerDom.prototype = Object.create(_e.Base.prototype), _e.MixerDom.prototype.constructor = _e.MixerDom, _e.UiClassNames = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.base = "", this.active = "", this.disabled = "", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.UiClassNames), _e.UiClassNames.prototype = Object.create(_e.Base.prototype), _e.UiClassNames.prototype.constructor = _e.UiClassNames, _e.CommandDataset = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.dataset = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandDataset), _e.CommandDataset.prototype = Object.create(_e.Base.prototype), _e.CommandDataset.prototype.constructor = _e.CommandDataset, _e.CommandMultimix = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.filter = null, this.sort = null, this.insert = null, this.remove = null, this.changeLayout = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandMultimix), _e.CommandMultimix.prototype = Object.create(_e.Base.prototype), _e.CommandMultimix.prototype.constructor = _e.CommandMultimix, _e.CommandFilter = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.selector = "", this.collection = null, this.action = "show", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandFilter), _e.CommandFilter.prototype = Object.create(_e.Base.prototype), _e.CommandFilter.prototype.constructor = _e.CommandFilter, _e.CommandSort = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.sortString = "", this.attribute = "", this.order = "asc", this.collection = null, this.next = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandSort), _e.CommandSort.prototype = Object.create(_e.Base.prototype), _e.CommandSort.prototype.constructor = _e.CommandSort, _e.CommandInsert = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.index = 0, this.collection = [], this.position = "before", this.sibling = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandInsert), _e.CommandInsert.prototype = Object.create(_e.Base.prototype), _e.CommandInsert.prototype.constructor = _e.CommandInsert, _e.CommandRemove = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.targets = [], this.collection = [], this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandRemove), _e.CommandRemove.prototype = Object.create(_e.Base.prototype), _e.CommandRemove.prototype.constructor = _e.CommandRemove, _e.CommandChangeLayout = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.containerClassName = "", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.CommandChangeLayout), _e.CommandChangeLayout.prototype = Object.create(_e.Base.prototype), _e.CommandChangeLayout.prototype.constructor = _e.CommandChangeLayout, _e.ControlDefinition = function (t, a, i, o) {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.type = t, this.selector = a, this.live = i || !1, this.parent = o || "", this.callActions("afterConstruct"), n.freeze(this), n.seal(this);
  }, _e.BaseStatic.call(_e.ControlDefinition), _e.ControlDefinition.prototype = Object.create(_e.Base.prototype), _e.ControlDefinition.prototype.constructor = _e.ControlDefinition, _e.controlDefinitions = [], _e.controlDefinitions.push(new _e.ControlDefinition("multimix", "[data-filter][data-sort]")), _e.controlDefinitions.push(new _e.ControlDefinition("filter", "[data-filter]")), _e.controlDefinitions.push(new _e.ControlDefinition("sort", "[data-sort]")), _e.controlDefinitions.push(new _e.ControlDefinition("toggle", "[data-toggle]")), _e.Control = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.el = null, this.selector = "", this.bound = [], this.pending = -1, this.type = "", this.status = "inactive", this.filter = "", this.sort = "", this.canDisable = !1, this.handler = null, this.classNames = new _e.UiClassNames(), this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.Control), _e.Control.prototype = Object.create(_e.Base.prototype), n.extend(_e.Control.prototype, {
    constructor: _e.Control,
    init: function init(t, n, a) {
      var i = this;
      if (this.callActions("beforeInit", arguments), i.el = t, i.type = n, i.selector = a, i.selector) i.status = "live";else switch (i.canDisable = "boolean" == typeof i.el.disable, i.type) {
        case "filter":
          i.filter = i.el.getAttribute("data-filter");
          break;

        case "toggle":
          i.filter = i.el.getAttribute("data-toggle");
          break;

        case "sort":
          i.sort = i.el.getAttribute("data-sort");
          break;

        case "multimix":
          i.filter = i.el.getAttribute("data-filter"), i.sort = i.el.getAttribute("data-sort");
      }
      i.bindClick(), _e.controls.push(i), this.callActions("afterInit", arguments);
    },
    isBound: function isBound(t) {
      var e = this,
          n = !1;
      return this.callActions("beforeIsBound", arguments), n = e.bound.indexOf(t) > -1, e.callFilters("afterIsBound", n, arguments);
    },
    addBinding: function addBinding(t) {
      var e = this;
      this.callActions("beforeAddBinding", arguments), e.isBound() || e.bound.push(t), this.callActions("afterAddBinding", arguments);
    },
    removeBinding: function removeBinding(t) {
      var n = this,
          a = -1;
      this.callActions("beforeRemoveBinding", arguments), (a = n.bound.indexOf(t)) > -1 && n.bound.splice(a, 1), n.bound.length < 1 && (n.unbindClick(), a = _e.controls.indexOf(n), _e.controls.splice(a, 1), "active" === n.status && n.renderStatus(n.el, "inactive")), this.callActions("afterRemoveBinding", arguments);
    },
    bindClick: function bindClick() {
      var t = this;
      this.callActions("beforeBindClick", arguments), t.handler = function (e) {
        t.handleClick(e);
      }, n.on(t.el, "click", t.handler), this.callActions("afterBindClick", arguments);
    },
    unbindClick: function unbindClick() {
      var t = this;
      this.callActions("beforeUnbindClick", arguments), n.off(t.el, "click", t.handler), t.handler = null, this.callActions("afterUnbindClick", arguments);
    },
    handleClick: function handleClick(t) {
      var a = this,
          i = null,
          o = null,
          r = !1,
          s = void 0,
          l = {},
          c = null,
          u = [],
          f = -1;
      if (this.callActions("beforeHandleClick", arguments), this.pending = 0, o = a.bound[0], i = a.selector ? n.closestParent(t.target, o.config.selectors.control + a.selector, !0, o.dom.document) : a.el, !i) return void a.callActions("afterHandleClick", arguments);

      switch (a.type) {
        case "filter":
          l.filter = a.filter || i.getAttribute("data-filter");
          break;

        case "sort":
          l.sort = a.sort || i.getAttribute("data-sort");
          break;

        case "multimix":
          l.filter = a.filter || i.getAttribute("data-filter"), l.sort = a.sort || i.getAttribute("data-sort");
          break;

        case "toggle":
          l.filter = a.filter || i.getAttribute("data-toggle"), r = "live" === a.status ? n.hasClass(i, a.classNames.active) : "active" === a.status;
      }

      for (f = 0; f < a.bound.length; f++) {
        c = new _e.CommandMultimix(), n.extend(c, l), u.push(c);
      }

      for (u = a.callFilters("commandsHandleClick", u, arguments), a.pending = a.bound.length, f = 0; o = a.bound[f]; f++) {
        l = u[f], l && (o.lastClicked || (o.lastClicked = i), _e.events.fire("mixClick", o.dom.container, {
          state: o.state,
          instance: o,
          originalEvent: t,
          control: o.lastClicked
        }, o.dom.document), "function" == typeof o.config.callbacks.onMixClick && (s = o.config.callbacks.onMixClick.call(o.lastClicked, o.state, t, o), s === !1) || ("toggle" === a.type ? r ? o.toggleOff(l.filter) : o.toggleOn(l.filter) : o.multimix(l)));
      }

      this.callActions("afterHandleClick", arguments);
    },
    update: function update(t, n) {
      var a = this,
          i = new _e.CommandMultimix();
      a.callActions("beforeUpdate", arguments), a.pending--, a.pending = Math.max(0, a.pending), a.pending > 0 || ("live" === a.status ? a.updateLive(t, n) : (i.sort = a.sort, i.filter = a.filter, a.callFilters("actionsUpdate", i, arguments), a.parseStatusChange(a.el, t, i, n)), a.callActions("afterUpdate", arguments));
    },
    updateLive: function updateLive(t, n) {
      var a = this,
          i = null,
          o = null,
          r = null,
          s = -1;

      if (a.callActions("beforeUpdateLive", arguments), a.el) {
        for (i = a.el.querySelectorAll(a.selector), s = 0; r = i[s]; s++) {
          switch (o = new _e.CommandMultimix(), a.type) {
            case "filter":
              o.filter = r.getAttribute("data-filter");
              break;

            case "sort":
              o.sort = r.getAttribute("data-sort");
              break;

            case "multimix":
              o.filter = r.getAttribute("data-filter"), o.sort = r.getAttribute("data-sort");
              break;

            case "toggle":
              o.filter = r.getAttribute("data-toggle");
          }

          o = a.callFilters("actionsUpdateLive", o, arguments), a.parseStatusChange(r, t, o, n);
        }

        a.callActions("afterUpdateLive", arguments);
      }
    },
    parseStatusChange: function parseStatusChange(t, e, n, a) {
      var i = this,
          o = "",
          r = "",
          s = -1;

      switch (i.callActions("beforeParseStatusChange", arguments), i.type) {
        case "filter":
          e.filter === n.filter ? i.renderStatus(t, "active") : i.renderStatus(t, "inactive");
          break;

        case "multimix":
          e.sort === n.sort && e.filter === n.filter ? i.renderStatus(t, "active") : i.renderStatus(t, "inactive");
          break;

        case "sort":
          e.sort.match(/:asc/g) && (o = e.sort.replace(/:asc/g, "")), e.sort === n.sort || o === n.sort ? i.renderStatus(t, "active") : i.renderStatus(t, "inactive");
          break;

        case "toggle":
          for (a.length < 1 && i.renderStatus(t, "inactive"), e.filter === n.filter && i.renderStatus(t, "active"), s = 0; s < a.length; s++) {
            if (r = a[s], r === n.filter) {
              i.renderStatus(t, "active");
              break;
            }

            i.renderStatus(t, "inactive");
          }

      }

      i.callActions("afterParseStatusChange", arguments);
    },
    renderStatus: function renderStatus(t, e) {
      var a = this;

      switch (a.callActions("beforeRenderStatus", arguments), e) {
        case "active":
          n.addClass(t, a.classNames.active), n.removeClass(t, a.classNames.disabled), a.canDisable && (a.el.disabled = !1);
          break;

        case "inactive":
          n.removeClass(t, a.classNames.active), n.removeClass(t, a.classNames.disabled), a.canDisable && (a.el.disabled = !1);
          break;

        case "disabled":
          a.canDisable && (a.el.disabled = !0), n.addClass(t, a.classNames.disabled), n.removeClass(t, a.classNames.active);
      }

      "live" !== a.status && (a.status = e), a.callActions("afterRenderStatus", arguments);
    }
  }), _e.controls = [], _e.StyleData = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.x = 0, this.y = 0, this.top = 0, this.right = 0, this.bottom = 0, this.left = 0, this.width = 0, this.height = 0, this.marginRight = 0, this.marginBottom = 0, this.opacity = 0, this.scale = new _e.TransformData(), this.translateX = new _e.TransformData(), this.translateY = new _e.TransformData(), this.translateZ = new _e.TransformData(), this.rotateX = new _e.TransformData(), this.rotateY = new _e.TransformData(), this.rotateZ = new _e.TransformData(), this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.StyleData), _e.StyleData.prototype = Object.create(_e.Base.prototype), _e.StyleData.prototype.constructor = _e.StyleData, _e.TransformData = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.value = 0, this.unit = "", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.TransformData), _e.TransformData.prototype = Object.create(_e.Base.prototype), _e.TransformData.prototype.constructor = _e.TransformData, _e.TransformDefaults = function () {
    _e.StyleData.apply(this), this.callActions("beforeConstruct"), this.scale.value = .01, this.scale.unit = "", this.translateX.value = 20, this.translateX.unit = "px", this.translateY.value = 20, this.translateY.unit = "px", this.translateZ.value = 20, this.translateZ.unit = "px", this.rotateX.value = 90, this.rotateX.unit = "deg", this.rotateY.value = 90, this.rotateY.unit = "deg", this.rotateX.value = 90, this.rotateX.unit = "deg", this.rotateZ.value = 180, this.rotateZ.unit = "deg", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.TransformDefaults), _e.TransformDefaults.prototype = Object.create(_e.StyleData.prototype), _e.TransformDefaults.prototype.constructor = _e.TransformDefaults, _e.transformDefaults = new _e.TransformDefaults(), _e.EventDetail = function () {
    this.state = null, this.futureState = null, this.instance = null, this.originalEvent = null;
  }, _e.Events = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.mixStart = null, this.mixBusy = null, this.mixEnd = null, this.mixFail = null, this.mixClick = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.Events), _e.Events.prototype = Object.create(_e.Base.prototype), _e.Events.prototype.constructor = _e.Events, _e.Events.prototype.fire = function (t, a, i, o) {
    var r = this,
        s = null,
        l = new _e.EventDetail();
    if (r.callActions("beforeFire", arguments), "undefined" == typeof r[t]) throw new Error('Event type "' + t + '" not found.');
    l.state = new _e.State(), n.extend(l.state, i.state), i.futureState && (l.futureState = new _e.State(), n.extend(l.futureState, i.futureState)), l.instance = i.instance, i.originalEvent && (l.originalEvent = i.originalEvent), s = n.getCustomEvent(t, l, o), r.callFilters("eventFire", s, arguments), a.dispatchEvent(s);
  }, _e.events = new _e.Events(), _e.QueueItem = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.args = [], this.instruction = null, this.triggerElement = null, this.deferred = null, this.isToggling = !1, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.QueueItem), _e.QueueItem.prototype = Object.create(_e.Base.prototype), _e.QueueItem.prototype.constructor = _e.QueueItem, _e.Mixer = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.config = new _e.Config(), this.id = "", this.isBusy = !1, this.isToggling = !1, this.incPadding = !0, this.controls = [], this.targets = [], this.origOrder = [], this.cache = {}, this.toggleArray = [], this.targetsMoved = 0, this.targetsImmovable = 0, this.targetsBound = 0, this.targetsDone = 0, this.staggerDuration = 0, this.effectsIn = null, this.effectsOut = null, this.transformIn = [], this.transformOut = [], this.queue = [], this.state = null, this.lastOperation = null, this.lastClicked = null, this.userCallback = null, this.userDeferred = null, this.dom = new _e.MixerDom(), this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.Mixer), _e.Mixer.prototype = Object.create(_e.Base.prototype), n.extend(_e.Mixer.prototype, {
    constructor: _e.Mixer,
    attach: function attach(a, i, o, r) {
      var s = this,
          l = null,
          c = -1;

      for (s.callActions("beforeAttach", arguments), s.id = o, r && n.extend(s.config, r, !0, !0), s.sanitizeConfig(), s.cacheDom(a, i), s.config.layout.containerClassName && n.addClass(s.dom.container, s.config.layout.containerClassName), _e.features.has.transitions || (s.config.animation.enable = !1), "undefined" == typeof t.console && (s.config.debug.showWarnings = !1), s.config.data.uidKey && (s.config.controls.enable = !1), s.indexTargets(), s.state = s.getInitialState(), c = 0; l = s.lastOperation.toHide[c]; c++) {
        l.hide();
      }

      s.config.controls.enable && (s.initControls(), s.buildToggleArray(null, s.state), s.updateControls({
        filter: s.state.activeFilter,
        sort: s.state.activeSort
      })), s.parseEffects(), s.callActions("afterAttach", arguments);
    },
    sanitizeConfig: function sanitizeConfig() {
      var t = this;
      t.callActions("beforeSanitizeConfig", arguments), t.config.controls.scope = t.config.controls.scope.toLowerCase().trim(), t.config.controls.toggleLogic = t.config.controls.toggleLogic.toLowerCase().trim(), t.config.controls.toggleDefault = t.config.controls.toggleDefault.toLowerCase().trim(), t.config.animation.effects = t.config.animation.effects.trim(), t.callActions("afterSanitizeConfig", arguments);
    },
    getInitialState: function getInitialState() {
      var t = this,
          n = new _e.State(),
          a = new _e.Operation();

      if (t.callActions("beforeGetInitialState", arguments), n.activeContainerClassName = t.config.layout.containerClassName, t.config.load.dataset) {
        if (!t.config.data.uidKey || "string" != typeof t.config.data.uidKey) throw new TypeError(_e.messages.errorConfigDataUidKeyNotSet());
        a.startDataset = a.newDataset = n.activeDataset = t.config.load.dataset.slice(), a.startContainerClassName = a.newContainerClassName = n.activeContainerClassName, a.show = t.targets.slice(), n = t.callFilters("stateGetInitialState", n, arguments);
      } else n.activeFilter = t.parseFilterArgs([t.config.load.filter]).command, n.activeSort = t.parseSortArgs([t.config.load.sort]).command, n.totalTargets = t.targets.length, n = t.callFilters("stateGetInitialState", n, arguments), n.activeSort.collection || n.activeSort.attribute || "random" === n.activeSort.order || "desc" === n.activeSort.order ? (a.newSort = n.activeSort, t.sortOperation(a), t.printSort(!1, a), t.targets = a.newOrder) : a.startOrder = a.newOrder = t.targets, a.startFilter = a.newFilter = n.activeFilter, a.startSort = a.newSort = n.activeSort, a.startContainerClassName = a.newContainerClassName = n.activeContainerClassName, "all" === a.newFilter.selector ? a.newFilter.selector = t.config.selectors.target : "none" === a.newFilter.selector && (a.newFilter.selector = "");

      return a = t.callFilters("operationGetInitialState", a, [n]), t.lastOperation = a, a.newFilter && t.filterOperation(a), n = t.buildState(a);
    },
    cacheDom: function cacheDom(t, e) {
      var n = this;
      n.callActions("beforeCacheDom", arguments), n.dom.document = e, n.dom.body = n.dom.document.querySelector("body"), n.dom.container = t, n.dom.parent = t, n.callActions("afterCacheDom", arguments);
    },
    indexTargets: function indexTargets() {
      var t = this,
          a = null,
          i = null,
          o = null,
          r = -1;
      if (t.callActions("beforeIndexTargets", arguments), t.dom.targets = t.config.layout.allowNestedTargets ? t.dom.container.querySelectorAll(t.config.selectors.target) : n.children(t.dom.container, t.config.selectors.target, t.dom.document), t.dom.targets = n.arrayFromList(t.dom.targets), t.targets = [], (o = t.config.load.dataset) && o.length !== t.dom.targets.length) throw new Error(_e.messages.errorDatasetPrerenderedMismatch());

      if (t.dom.targets.length) {
        for (r = 0; i = t.dom.targets[r]; r++) {
          a = new _e.Target(), a.init(i, t, o ? o[r] : void 0), a.isInDom = !0, t.targets.push(a);
        }

        t.dom.parent = t.dom.targets[0].parentElement === t.dom.container ? t.dom.container : t.dom.targets[0].parentElement;
      }

      t.origOrder = t.targets, t.callActions("afterIndexTargets", arguments);
    },
    initControls: function initControls() {
      var t = this,
          n = "",
          a = null,
          i = null,
          o = null,
          r = null,
          s = null,
          l = -1,
          c = -1;

      switch (t.callActions("beforeInitControls", arguments), t.config.controls.scope) {
        case "local":
          o = t.dom.container;
          break;

        case "global":
          o = t.dom.document;
          break;

        default:
          throw new Error(_e.messages.errorConfigInvalidControlsScope());
      }

      for (l = 0; n = _e.controlDefinitions[l]; l++) {
        if (t.config.controls.live || n.live) {
          if (n.parent) {
            if (r = t.dom[n.parent], !r || r.length < 0) continue;
            "number" != typeof r.length && (r = [r]);
          } else r = [o];

          for (c = 0; i = r[c]; c++) {
            s = t.getControl(i, n.type, n.selector), t.controls.push(s);
          }
        } else for (a = o.querySelectorAll(t.config.selectors.control + n.selector), c = 0; i = a[c]; c++) {
          s = t.getControl(i, n.type, ""), s && t.controls.push(s);
        }
      }

      t.callActions("afterInitControls", arguments);
    },
    getControl: function getControl(t, a, i) {
      var o = this,
          r = null,
          s = -1;
      if (o.callActions("beforeGetControl", arguments), !i) for (s = 0; r = _e.controls[s]; s++) {
        if (r.el === t && r.isBound(o)) return o.callFilters("controlGetControl", null, arguments);
        if (r.el === t && r.type === a && r.selector === i) return r.addBinding(o), o.callFilters("controlGetControl", r, arguments);
      }
      return r = new _e.Control(), r.init(t, a, i), r.classNames.base = n.getClassname(o.config.classNames, a), r.classNames.active = n.getClassname(o.config.classNames, a, o.config.classNames.modifierActive), r.classNames.disabled = n.getClassname(o.config.classNames, a, o.config.classNames.modifierDisabled), r.addBinding(o), o.callFilters("controlGetControl", r, arguments);
    },
    getToggleSelector: function getToggleSelector() {
      var t = this,
          e = "or" === t.config.controls.toggleLogic ? ", " : "",
          a = "";
      return t.callActions("beforeGetToggleSelector", arguments), t.toggleArray = n.clean(t.toggleArray), a = t.toggleArray.join(e), "" === a && (a = t.config.controls.toggleDefault), t.callFilters("selectorGetToggleSelector", a, arguments);
    },
    buildToggleArray: function buildToggleArray(t, e) {
      var a = this,
          i = "";
      if (a.callActions("beforeBuildToggleArray", arguments), t && t.filter) i = t.filter.selector.replace(/\s/g, "");else {
        if (!e) return;
        i = e.activeFilter.selector.replace(/\s/g, "");
      }
      i !== a.config.selectors.target && "all" !== i || (i = ""), "or" === a.config.controls.toggleLogic ? a.toggleArray = i.split(",") : a.toggleArray = a.splitCompoundSelector(i), a.toggleArray = n.clean(a.toggleArray), a.callActions("afterBuildToggleArray", arguments);
    },
    splitCompoundSelector: function splitCompoundSelector(t) {
      var e = t.split(/([\.\[])/g),
          n = [],
          a = "",
          i = -1;

      for ("" === e[0] && e.shift(), i = 0; i < e.length; i++) {
        i % 2 === 0 && (a = ""), a += e[i], i % 2 !== 0 && n.push(a);
      }

      return n;
    },
    updateControls: function updateControls(t) {
      var a = this,
          i = null,
          o = new _e.CommandMultimix(),
          r = -1;

      for (a.callActions("beforeUpdateControls", arguments), t.filter ? o.filter = t.filter.selector : o.filter = a.state.activeFilter.selector, t.sort ? o.sort = a.buildSortString(t.sort) : o.sort = a.buildSortString(a.state.activeSort), o.filter === a.config.selectors.target && (o.filter = "all"), "" === o.filter && (o.filter = "none"), n.freeze(o), r = 0; i = a.controls[r]; r++) {
        i.update(o, a.toggleArray);
      }

      a.callActions("afterUpdateControls", arguments);
    },
    buildSortString: function buildSortString(t) {
      var e = this,
          n = "";
      return n += t.sortString, t.next && (n += " " + e.buildSortString(t.next)), n;
    },
    insertTargets: function insertTargets(t, a) {
      var i = this,
          o = null,
          r = -1,
          s = null,
          l = null,
          c = null,
          u = -1;

      if (i.callActions("beforeInsertTargets", arguments), "undefined" == typeof t.index && (t.index = 0), o = i.getNextSibling(t.index, t.sibling, t.position), s = i.dom.document.createDocumentFragment(), r = o ? n.index(o, i.config.selectors.target) : i.targets.length, t.collection) {
        for (u = 0; c = t.collection[u]; u++) {
          if (i.dom.targets.indexOf(c) > -1) throw new Error(_e.messages.errorInsertPreexistingElement());
          c.style.display = "none", s.appendChild(c), s.appendChild(i.dom.document.createTextNode(" ")), n.isElement(c, i.dom.document) && c.matches(i.config.selectors.target) && (l = new _e.Target(), l.init(c, i), l.isInDom = !0, i.targets.splice(r, 0, l), r++);
        }

        i.dom.parent.insertBefore(s, o);
      }

      a.startOrder = i.origOrder = i.targets, i.callActions("afterInsertTargets", arguments);
    },
    getNextSibling: function getNextSibling(t, e, n) {
      var a = this,
          i = null;
      return t = Math.max(t, 0), e && "before" === n ? i = e : e && "after" === n ? i = e.nextElementSibling || null : a.targets.length > 0 && "undefined" != typeof t ? i = t < a.targets.length || !a.targets.length ? a.targets[t].dom.el : a.targets[a.targets.length - 1].dom.el.nextElementSibling : 0 === a.targets.length && a.dom.parent.children.length > 0 && (a.config.layout.siblingAfter ? i = a.config.layout.siblingAfter : a.config.layout.siblingBefore ? i = a.config.layout.siblingBefore.nextElementSibling : a.dom.parent.children[0]), a.callFilters("elementGetNextSibling", i, arguments);
    },
    filterOperation: function filterOperation(t) {
      var e = this,
          n = !1,
          a = -1,
          i = "",
          o = null,
          r = -1;

      for (e.callActions("beforeFilterOperation", arguments), i = t.newFilter.action, r = 0; o = t.newOrder[r]; r++) {
        n = t.newFilter.collection ? t.newFilter.collection.indexOf(o.dom.el) > -1 : "" !== t.newFilter.selector && o.dom.el.matches(t.newFilter.selector), e.evaluateHideShow(n, o, i, t);
      }

      if (t.toRemove.length) for (r = 0; o = t.show[r]; r++) {
        t.toRemove.indexOf(o) > -1 && (t.show.splice(r, 1), (a = t.toShow.indexOf(o)) > -1 && t.toShow.splice(a, 1), t.toHide.push(o), t.hide.push(o), r--);
      }
      t.matching = t.show.slice(), 0 === t.show.length && "" !== t.newFilter.selector && 0 !== e.targets.length && (t.hasFailed = !0), e.callActions("afterFilterOperation", arguments);
    },
    evaluateHideShow: function evaluateHideShow(t, e, n, a) {
      var i = this,
          o = !1,
          r = Array.prototype.slice.call(arguments, 1);
      o = i.callFilters("testResultEvaluateHideShow", t, r), i.callActions("beforeEvaluateHideShow", arguments), o === !0 && "show" === n || o === !1 && "hide" === n ? (a.show.push(e), !e.isShown && a.toShow.push(e)) : (a.hide.push(e), e.isShown && a.toHide.push(e)), i.callActions("afterEvaluateHideShow", arguments);
    },
    sortOperation: function sortOperation(t) {
      var e = this;
      e.callActions("beforeSortOperation", arguments), t.startOrder = e.targets, t.newSort.collection ? t.newOrder = t.newSort.collection : "random" === t.newSort.order ? t.newOrder = n.arrayShuffle(t.startOrder) : "" === t.newSort.attribute ? (t.newOrder = e.origOrder.slice(), "desc" === t.newSort.order && t.newOrder.reverse()) : (t.newOrder = t.startOrder.slice(), t.newOrder.sort(function (n, a) {
        return e.compare(n, a, t.newSort);
      })), n.isEqualArray(t.newOrder, t.startOrder) && (t.willSort = !1), e.callActions("afterSortOperation", arguments);
    },
    compare: function compare(t, e, n) {
      var a = this,
          i = n.order,
          o = a.getAttributeValue(t, n.attribute),
          r = a.getAttributeValue(e, n.attribute);
      return isNaN(1 * o) || isNaN(1 * r) ? (o = o.toLowerCase(), r = r.toLowerCase()) : (o = 1 * o, r = 1 * r), o < r ? "asc" === i ? -1 : 1 : o > r ? "asc" === i ? 1 : -1 : o === r && n.next ? a.compare(t, e, n.next) : 0;
    },
    getAttributeValue: function getAttributeValue(t, n) {
      var a = this,
          i = "";
      return i = t.dom.el.getAttribute("data-" + n), null === i && a.config.debug.showWarnings && console.warn(_e.messages.warningInconsistentSortingAttributes({
        attribute: "data-" + n
      })), a.callFilters("valueGetAttributeValue", i || 0, arguments);
    },
    printSort: function printSort(e, a) {
      var i = this,
          o = e ? a.newOrder : a.startOrder,
          r = e ? a.startOrder : a.newOrder,
          s = o.length ? o[o.length - 1].dom.el.nextElementSibling : null,
          l = t.document.createDocumentFragment(),
          c = null,
          u = null,
          f = null,
          h = -1;

      for (i.callActions("beforePrintSort", arguments), h = 0; u = o[h]; h++) {
        f = u.dom.el, "absolute" !== f.style.position && (n.removeWhitespace(f.previousSibling), f.parentElement.removeChild(f));
      }

      for (c = s ? s.previousSibling : i.dom.parent.lastChild, c && "#text" === c.nodeName && n.removeWhitespace(c), h = 0; u = r[h]; h++) {
        f = u.dom.el, n.isElement(l.lastChild) && l.appendChild(t.document.createTextNode(" ")), l.appendChild(f);
      }

      i.dom.parent.firstChild && i.dom.parent.firstChild !== s && l.insertBefore(t.document.createTextNode(" "), l.childNodes[0]), s ? (l.appendChild(t.document.createTextNode(" ")), i.dom.parent.insertBefore(l, s)) : i.dom.parent.appendChild(l), i.callActions("afterPrintSort", arguments);
    },
    parseSortString: function parseSortString(t, a) {
      var i = this,
          o = t.split(" "),
          r = a,
          s = [],
          l = -1;

      for (l = 0; l < o.length; l++) {
        switch (s = o[l].split(":"), r.sortString = o[l], r.attribute = n.dashCase(s[0]), r.order = s[1] || "asc", r.attribute) {
          case "default":
            r.attribute = "";
            break;

          case "random":
            r.attribute = "", r.order = "random";
        }

        if (!r.attribute || "random" === r.order) break;
        l < o.length - 1 && (r.next = new _e.CommandSort(), n.freeze(r), r = r.next);
      }

      return i.callFilters("commandsParseSort", a, arguments);
    },
    parseEffects: function parseEffects() {
      var t = this,
          n = "",
          a = t.config.animation.effectsIn || t.config.animation.effects,
          i = t.config.animation.effectsOut || t.config.animation.effects;
      t.callActions("beforeParseEffects", arguments), t.effectsIn = new _e.StyleData(), t.effectsOut = new _e.StyleData(), t.transformIn = [], t.transformOut = [], t.effectsIn.opacity = t.effectsOut.opacity = 1, t.parseEffect("fade", a, t.effectsIn, t.transformIn), t.parseEffect("fade", i, t.effectsOut, t.transformOut, !0);

      for (n in _e.transformDefaults) {
        _e.transformDefaults[n] instanceof _e.TransformData && (t.parseEffect(n, a, t.effectsIn, t.transformIn), t.parseEffect(n, i, t.effectsOut, t.transformOut, !0));
      }

      t.parseEffect("stagger", a, t.effectsIn, t.transformIn), t.parseEffect("stagger", i, t.effectsOut, t.transformOut, !0), t.callActions("afterParseEffects", arguments);
    },
    parseEffect: function parseEffect(t, n, a, i, o) {
      var r = this,
          s = /\(([^)]+)\)/,
          l = -1,
          c = "",
          u = [],
          f = "",
          h = ["%", "px", "em", "rem", "vh", "vw", "deg"],
          d = "",
          m = -1;
      if (r.callActions("beforeParseEffect", arguments), "string" != typeof n) throw new TypeError(_e.messages.errorConfigInvalidAnimationEffects());
      if (n.indexOf(t) < 0) return void ("stagger" === t && (r.staggerDuration = 0));

      switch (l = n.indexOf(t + "("), l > -1 && (c = n.substring(l), u = s.exec(c), f = u[1]), t) {
        case "fade":
          a.opacity = f ? parseFloat(f) : 0;
          break;

        case "stagger":
          r.staggerDuration = f ? parseFloat(f) : 100;
          break;

        default:
          if (o && r.config.animation.reverseOut && "scale" !== t ? a[t].value = (f ? parseFloat(f) : _e.transformDefaults[t].value) * -1 : a[t].value = f ? parseFloat(f) : _e.transformDefaults[t].value, f) {
            for (m = 0; d = h[m]; m++) {
              if (f.indexOf(d) > -1) {
                a[t].unit = d;
                break;
              }
            }
          } else a[t].unit = _e.transformDefaults[t].unit;

          i.push(t + "(" + a[t].value + a[t].unit + ")");
      }

      r.callActions("afterParseEffect", arguments);
    },
    buildState: function buildState(t) {
      var n = this,
          a = new _e.State(),
          i = null,
          o = -1;

      for (n.callActions("beforeBuildState", arguments), o = 0; i = n.targets[o]; o++) {
        (!t.toRemove.length || t.toRemove.indexOf(i) < 0) && a.targets.push(i.dom.el);
      }

      for (o = 0; i = t.matching[o]; o++) {
        a.matching.push(i.dom.el);
      }

      for (o = 0; i = t.show[o]; o++) {
        a.show.push(i.dom.el);
      }

      for (o = 0; i = t.hide[o]; o++) {
        (!t.toRemove.length || t.toRemove.indexOf(i) < 0) && a.hide.push(i.dom.el);
      }

      return a.id = n.id, a.container = n.dom.container, a.activeFilter = t.newFilter, a.activeSort = t.newSort, a.activeDataset = t.newDataset, a.activeContainerClassName = t.newContainerClassName, a.hasFailed = t.hasFailed, a.totalTargets = n.targets.length, a.totalShow = t.show.length, a.totalHide = t.hide.length, a.totalMatching = t.matching.length, a.triggerElement = t.triggerElement, n.callFilters("stateBuildState", a, arguments);
    },
    goMix: function goMix(a, i) {
      var o = this,
          r = null;
      return o.callActions("beforeGoMix", arguments), o.config.animation.duration && o.config.animation.effects && n.isVisible(o.dom.container) || (a = !1), i.toShow.length || i.toHide.length || i.willSort || i.willChangeLayout || (a = !1), i.startState.show.length || i.show.length || (a = !1), _e.events.fire("mixStart", o.dom.container, {
        state: i.startState,
        futureState: i.newState,
        instance: o
      }, o.dom.document), "function" == typeof o.config.callbacks.onMixStart && o.config.callbacks.onMixStart.call(o.dom.container, i.startState, i.newState, o), n.removeClass(o.dom.container, n.getClassname(o.config.classNames, "container", o.config.classNames.modifierFailed)), r = o.userDeferred ? o.userDeferred : o.userDeferred = n.defer(_e.libraries), o.isBusy = !0, a && _e.features.has.transitions ? (t.pageYOffset !== i.docState.scrollTop && t.scrollTo(i.docState.scrollLeft, i.docState.scrollTop), o.config.animation.applyPerspective && (o.dom.parent.style[_e.features.perspectiveProp] = o.config.animation.perspectiveDistance, o.dom.parent.style[_e.features.perspectiveOriginProp] = o.config.animation.perspectiveOrigin), o.config.animation.animateResizeContainer && i.startHeight !== i.newHeight && i.viewportDeltaY !== i.startHeight - i.newHeight && (o.dom.parent.style.height = i.startHeight + "px"), o.config.animation.animateResizeContainer && i.startWidth !== i.newWidth && i.viewportDeltaX !== i.startWidth - i.newWidth && (o.dom.parent.style.width = i.startWidth + "px"), i.startHeight === i.newHeight && (o.dom.parent.style.height = i.startHeight + "px"), i.startWidth === i.newWidth && (o.dom.parent.style.width = i.startWidth + "px"), i.startHeight === i.newHeight && i.startWidth === i.newWidth && (o.dom.parent.style.overflow = "hidden"), requestAnimationFrame(function () {
        o.moveTargets(i);
      }), o.callFilters("promiseGoMix", r.promise, arguments)) : (o.config.debug.fauxAsync ? setTimeout(function () {
        o.cleanUp(i);
      }, o.config.animation.duration) : o.cleanUp(i), o.callFilters("promiseGoMix", r.promise, arguments));
    },
    getStartMixData: function getStartMixData(n) {
      var a = this,
          i = t.getComputedStyle(a.dom.parent),
          o = a.dom.parent.getBoundingClientRect(),
          r = null,
          s = {},
          l = -1,
          c = i[_e.features.boxSizingProp];

      for (a.incPadding = "border-box" === c, a.callActions("beforeGetStartMixData", arguments), l = 0; r = n.show[l]; l++) {
        s = r.getPosData(), n.showPosData[l] = {
          startPosData: s
        };
      }

      for (l = 0; r = n.toHide[l]; l++) {
        s = r.getPosData(), n.toHidePosData[l] = {
          startPosData: s
        };
      }

      n.startX = o.left, n.startY = o.top, n.startHeight = a.incPadding ? o.height : o.height - parseFloat(i.paddingTop) - parseFloat(i.paddingBottom) - parseFloat(i.borderTop) - parseFloat(i.borderBottom), n.startWidth = a.incPadding ? o.width : o.width - parseFloat(i.paddingLeft) - parseFloat(i.paddingRight) - parseFloat(i.borderLeft) - parseFloat(i.borderRight), a.callActions("afterGetStartMixData", arguments);
    },
    setInter: function setInter(t) {
      var e = this,
          a = null,
          i = -1;

      for (e.callActions("beforeSetInter", arguments), e.config.animation.clampHeight && (e.dom.parent.style.height = t.startHeight + "px", e.dom.parent.style.overflow = "hidden"), e.config.animation.clampWidth && (e.dom.parent.style.width = t.startWidth + "px", e.dom.parent.style.overflow = "hidden"), i = 0; a = t.toShow[i]; i++) {
        a.show();
      }

      t.willChangeLayout && (n.removeClass(e.dom.container, t.startContainerClassName), n.addClass(e.dom.container, t.newContainerClassName)), e.callActions("afterSetInter", arguments);
    },
    getInterMixData: function getInterMixData(t) {
      var e = this,
          n = null,
          a = -1;

      for (e.callActions("beforeGetInterMixData", arguments), a = 0; n = t.show[a]; a++) {
        t.showPosData[a].interPosData = n.getPosData();
      }

      for (a = 0; n = t.toHide[a]; a++) {
        t.toHidePosData[a].interPosData = n.getPosData();
      }

      e.callActions("afterGetInterMixData", arguments);
    },
    setFinal: function setFinal(t) {
      var e = this,
          n = null,
          a = -1;

      for (e.callActions("beforeSetFinal", arguments), t.willSort && e.printSort(!1, t), a = 0; n = t.toHide[a]; a++) {
        n.hide();
      }

      e.callActions("afterSetFinal", arguments);
    },
    getFinalMixData: function getFinalMixData(e) {
      var a = this,
          i = null,
          o = null,
          r = null,
          s = -1;

      for (a.callActions("beforeGetFinalMixData", arguments), s = 0; r = e.show[s]; s++) {
        e.showPosData[s].finalPosData = r.getPosData();
      }

      for (s = 0; r = e.toHide[s]; s++) {
        e.toHidePosData[s].finalPosData = r.getPosData();
      }

      for ((a.config.animation.clampHeight || a.config.animation.clampWidth) && (a.dom.parent.style.height = a.dom.parent.style.width = a.dom.parent.style.overflow = ""), a.incPadding || (i = t.getComputedStyle(a.dom.parent)), o = a.dom.parent.getBoundingClientRect(), e.newX = o.left, e.newY = o.top, e.newHeight = a.incPadding ? o.height : o.height - parseFloat(i.paddingTop) - parseFloat(i.paddingBottom) - parseFloat(i.borderTop) - parseFloat(i.borderBottom), e.newWidth = a.incPadding ? o.width : o.width - parseFloat(i.paddingLeft) - parseFloat(i.paddingRight) - parseFloat(i.borderLeft) - parseFloat(i.borderRight), e.viewportDeltaX = e.docState.viewportWidth - this.dom.document.documentElement.clientWidth, e.viewportDeltaY = e.docState.viewportHeight - this.dom.document.documentElement.clientHeight, e.willSort && a.printSort(!0, e), s = 0; r = e.toShow[s]; s++) {
        r.hide();
      }

      for (s = 0; r = e.toHide[s]; s++) {
        r.show();
      }

      e.willChangeLayout && (n.removeClass(a.dom.container, e.newContainerClassName), n.addClass(a.dom.container, a.config.layout.containerClassName)), a.callActions("afterGetFinalMixData", arguments);
    },
    getTweenData: function getTweenData(t) {
      var n = this,
          a = null,
          i = null,
          o = Object.getOwnPropertyNames(n.effectsIn),
          r = "",
          s = null,
          l = -1,
          c = -1,
          u = -1,
          f = -1;

      for (n.callActions("beforeGetTweenData", arguments), u = 0; a = t.show[u]; u++) {
        for (i = t.showPosData[u], i.posIn = new _e.StyleData(), i.posOut = new _e.StyleData(), i.tweenData = new _e.StyleData(), a.isShown ? (i.posIn.x = i.startPosData.x - i.interPosData.x, i.posIn.y = i.startPosData.y - i.interPosData.y) : i.posIn.x = i.posIn.y = 0, i.posOut.x = i.finalPosData.x - i.interPosData.x, i.posOut.y = i.finalPosData.y - i.interPosData.y, i.posIn.opacity = a.isShown ? 1 : n.effectsIn.opacity, i.posOut.opacity = 1, i.tweenData.opacity = i.posOut.opacity - i.posIn.opacity, a.isShown || n.config.animation.nudge || (i.posIn.x = i.posOut.x, i.posIn.y = i.posOut.y), i.tweenData.x = i.posOut.x - i.posIn.x, i.tweenData.y = i.posOut.y - i.posIn.y, n.config.animation.animateResizeTargets && (i.posIn.width = i.startPosData.width, i.posIn.height = i.startPosData.height, l = (i.startPosData.width || i.finalPosData.width) - i.interPosData.width, i.posIn.marginRight = i.startPosData.marginRight - l, c = (i.startPosData.height || i.finalPosData.height) - i.interPosData.height, i.posIn.marginBottom = i.startPosData.marginBottom - c, i.posOut.width = i.finalPosData.width, i.posOut.height = i.finalPosData.height, l = (i.finalPosData.width || i.startPosData.width) - i.interPosData.width, i.posOut.marginRight = i.finalPosData.marginRight - l, c = (i.finalPosData.height || i.startPosData.height) - i.interPosData.height, i.posOut.marginBottom = i.finalPosData.marginBottom - c, i.tweenData.width = i.posOut.width - i.posIn.width, i.tweenData.height = i.posOut.height - i.posIn.height, i.tweenData.marginRight = i.posOut.marginRight - i.posIn.marginRight, i.tweenData.marginBottom = i.posOut.marginBottom - i.posIn.marginBottom), f = 0; r = o[f]; f++) {
          s = n.effectsIn[r], s instanceof _e.TransformData && s.value && (i.posIn[r].value = s.value, i.posOut[r].value = 0, i.tweenData[r].value = i.posOut[r].value - i.posIn[r].value, i.posIn[r].unit = i.posOut[r].unit = i.tweenData[r].unit = s.unit);
        }
      }

      for (u = 0; a = t.toHide[u]; u++) {
        for (i = t.toHidePosData[u], i.posIn = new _e.StyleData(), i.posOut = new _e.StyleData(), i.tweenData = new _e.StyleData(), i.posIn.x = a.isShown ? i.startPosData.x - i.interPosData.x : 0, i.posIn.y = a.isShown ? i.startPosData.y - i.interPosData.y : 0, i.posOut.x = n.config.animation.nudge ? 0 : i.posIn.x, i.posOut.y = n.config.animation.nudge ? 0 : i.posIn.y, i.tweenData.x = i.posOut.x - i.posIn.x, i.tweenData.y = i.posOut.y - i.posIn.y, n.config.animation.animateResizeTargets && (i.posIn.width = i.startPosData.width, i.posIn.height = i.startPosData.height, l = i.startPosData.width - i.interPosData.width, i.posIn.marginRight = i.startPosData.marginRight - l, c = i.startPosData.height - i.interPosData.height, i.posIn.marginBottom = i.startPosData.marginBottom - c), i.posIn.opacity = 1, i.posOut.opacity = n.effectsOut.opacity, i.tweenData.opacity = i.posOut.opacity - i.posIn.opacity, f = 0; r = o[f]; f++) {
          s = n.effectsOut[r], s instanceof _e.TransformData && s.value && (i.posIn[r].value = 0, i.posOut[r].value = s.value, i.tweenData[r].value = i.posOut[r].value - i.posIn[r].value, i.posIn[r].unit = i.posOut[r].unit = i.tweenData[r].unit = s.unit);
        }
      }

      n.callActions("afterGetTweenData", arguments);
    },
    moveTargets: function moveTargets(t) {
      var a = this,
          i = null,
          o = null,
          r = null,
          s = "",
          l = !1,
          c = -1,
          u = -1,
          f = a.checkProgress.bind(a);

      for (a.callActions("beforeMoveTargets", arguments), u = 0; i = t.show[u]; u++) {
        o = new _e.IMoveData(), r = t.showPosData[u], s = i.isShown ? "none" : "show", l = a.willTransition(s, t.hasEffect, r.posIn, r.posOut), l && c++, i.show(), o.posIn = r.posIn, o.posOut = r.posOut, o.statusChange = s, o.staggerIndex = c, o.operation = t, o.callback = l ? f : null, i.move(o);
      }

      for (u = 0; i = t.toHide[u]; u++) {
        r = t.toHidePosData[u], o = new _e.IMoveData(), s = "hide", l = a.willTransition(s, r.posIn, r.posOut), o.posIn = r.posIn, o.posOut = r.posOut, o.statusChange = s, o.staggerIndex = u, o.operation = t, o.callback = l ? f : null, i.move(o);
      }

      a.config.animation.animateResizeContainer && (a.dom.parent.style[_e.features.transitionProp] = "height " + a.config.animation.duration + "ms ease, width " + a.config.animation.duration + "ms ease ", requestAnimationFrame(function () {
        t.startHeight !== t.newHeight && t.viewportDeltaY !== t.startHeight - t.newHeight && (a.dom.parent.style.height = t.newHeight + "px"), t.startWidth !== t.newWidth && t.viewportDeltaX !== t.startWidth - t.newWidth && (a.dom.parent.style.width = t.newWidth + "px");
      })), t.willChangeLayout && (n.removeClass(a.dom.container, a.config.layout.ContainerClassName), n.addClass(a.dom.container, t.newContainerClassName)), a.callActions("afterMoveTargets", arguments);
    },
    hasEffect: function hasEffect() {
      var t = this,
          e = ["scale", "translateX", "translateY", "translateZ", "rotateX", "rotateY", "rotateZ"],
          n = "",
          a = null,
          i = !1,
          o = -1,
          r = -1;
      if (1 !== t.effectsIn.opacity) return t.callFilters("resultHasEffect", !0, arguments);

      for (r = 0; n = e[r]; r++) {
        if (a = t.effectsIn[n], o = "undefined" !== a.value ? a.value : a, 0 !== o) {
          i = !0;
          break;
        }
      }

      return t.callFilters("resultHasEffect", i, arguments);
    },
    willTransition: function willTransition(t, e, a, i) {
      var o = this,
          r = !1;
      return r = !!n.isVisible(o.dom.container) && (!!("none" !== t && e || a.x !== i.x || a.y !== i.y) || !!o.config.animation.animateResizeTargets && (a.width !== i.width || a.height !== i.height || a.marginRight !== i.marginRight || a.marginTop !== i.marginTop)), o.callFilters("resultWillTransition", r, arguments);
    },
    checkProgress: function checkProgress(t) {
      var e = this;
      e.targetsDone++, e.targetsBound === e.targetsDone && e.cleanUp(t);
    },
    cleanUp: function cleanUp(t) {
      var a = this,
          i = null,
          o = null,
          r = null,
          s = null,
          l = -1;

      for (a.callActions("beforeCleanUp", arguments), a.targetsMoved = a.targetsImmovable = a.targetsBound = a.targetsDone = 0, l = 0; i = t.show[l]; l++) {
        i.cleanUp(), i.show();
      }

      for (l = 0; i = t.toHide[l]; l++) {
        i.cleanUp(), i.hide();
      }

      if (t.willSort && a.printSort(!1, t), a.dom.parent.style[_e.features.transitionProp] = a.dom.parent.style.height = a.dom.parent.style.width = a.dom.parent.style.overflow = a.dom.parent.style[_e.features.perspectiveProp] = a.dom.parent.style[_e.features.perspectiveOriginProp] = "", t.willChangeLayout && (n.removeClass(a.dom.container, t.startContainerClassName), n.addClass(a.dom.container, t.newContainerClassName)), t.toRemove.length) {
        for (l = 0; i = a.targets[l]; l++) {
          t.toRemove.indexOf(i) > -1 && ((o = i.dom.el.previousSibling) && "#text" === o.nodeName && (r = i.dom.el.nextSibling) && "#text" === r.nodeName && n.removeWhitespace(o), t.willSort || a.dom.parent.removeChild(i.dom.el), a.targets.splice(l, 1), i.isInDom = !1, l--);
        }

        a.origOrder = a.targets;
      }

      t.willSort && (a.targets = t.newOrder), a.state = t.newState, a.lastOperation = t, a.dom.targets = a.state.targets, _e.events.fire("mixEnd", a.dom.container, {
        state: a.state,
        instance: a
      }, a.dom.document), "function" == typeof a.config.callbacks.onMixEnd && a.config.callbacks.onMixEnd.call(a.dom.container, a.state, a), t.hasFailed && (_e.events.fire("mixFail", a.dom.container, {
        state: a.state,
        instance: a
      }, a.dom.document), "function" == typeof a.config.callbacks.onMixFail && a.config.callbacks.onMixFail.call(a.dom.container, a.state, a), n.addClass(a.dom.container, n.getClassname(a.config.classNames, "container", a.config.classNames.modifierFailed))), "function" == typeof a.userCallback && a.userCallback.call(a.dom.container, a.state, a), "function" == typeof a.userDeferred.resolve && a.userDeferred.resolve(a.state), a.userCallback = null, a.userDeferred = null, a.lastClicked = null, a.isToggling = !1, a.isBusy = !1, a.queue.length && (a.callActions("beforeReadQueueCleanUp", arguments), s = a.queue.shift(), a.userDeferred = s.deferred, a.isToggling = s.isToggling, a.lastClicked = s.triggerElement, s.instruction.command instanceof _e.CommandMultimix ? a.multimix.apply(a, s.args) : a.dataset.apply(a, s.args)), a.callActions("afterCleanUp", arguments);
    },
    parseMultimixArgs: function parseMultimixArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandMultimix(), r = 0; r < t.length; r++) {
        o = t[r], null !== o && ("object" == _typeof(o) ? n.extend(i.command, o) : "boolean" == typeof o ? i.animate = o : "function" == typeof o && (i.callback = o));
      }

      return !i.command.insert || i.command.insert instanceof _e.CommandInsert || (i.command.insert = a.parseInsertArgs([i.command.insert]).command), !i.command.remove || i.command.remove instanceof _e.CommandRemove || (i.command.remove = a.parseRemoveArgs([i.command.remove]).command), !i.command.filter || i.command.filter instanceof _e.CommandFilter || (i.command.filter = a.parseFilterArgs([i.command.filter]).command), !i.command.sort || i.command.sort instanceof _e.CommandSort || (i.command.sort = a.parseSortArgs([i.command.sort]).command), !i.command.changeLayout || i.command.changeLayout instanceof _e.CommandChangeLayout || (i.command.changeLayout = a.parseChangeLayoutArgs([i.command.changeLayout]).command), i = a.callFilters("instructionParseMultimixArgs", i, arguments), n.freeze(i), i;
    },
    parseFilterArgs: function parseFilterArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandFilter(), r = 0; r < t.length; r++) {
        o = t[r], "string" == typeof o ? i.command.selector = o : null === o ? i.command.collection = [] : "object" == _typeof(o) && n.isElement(o, a.dom.document) ? i.command.collection = [o] : "object" == _typeof(o) && "undefined" != typeof o.length ? i.command.collection = n.arrayFromList(o) : "object" == _typeof(o) ? n.extend(i.command, o) : "boolean" == typeof o ? i.animate = o : "function" == typeof o && (i.callback = o);
      }

      if (i.command.selector && i.command.collection) throw new Error(_e.messages.errorFilterInvalidArguments());
      return i = a.callFilters("instructionParseFilterArgs", i, arguments), n.freeze(i), i;
    },
    parseSortArgs: function parseSortArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = "",
          s = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandSort(), s = 0; s < t.length; s++) {
        if (o = t[s], null !== o) switch (_typeof(o)) {
          case "string":
            r = o;
            break;

          case "object":
            o.length && (i.command.collection = n.arrayFromList(o));
            break;

          case "boolean":
            i.animate = o;
            break;

          case "function":
            i.callback = o;
        }
      }

      return r && (i.command = a.parseSortString(r, i.command)), i = a.callFilters("instructionParseSortArgs", i, arguments), n.freeze(i), i;
    },
    parseInsertArgs: function parseInsertArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandInsert(), r = 0; r < t.length; r++) {
        o = t[r], null !== o && ("number" == typeof o ? i.command.index = o : "string" == typeof o && ["before", "after"].indexOf(o) > -1 ? i.command.position = o : "string" == typeof o ? i.command.collection = n.arrayFromList(n.createElement(o).childNodes) : "object" == _typeof(o) && n.isElement(o, a.dom.document) ? i.command.collection.length ? i.command.sibling = o : i.command.collection = [o] : "object" == _typeof(o) && o.length ? i.command.collection.length ? i.command.sibling = o[0] : i.command.collection = o : "object" == _typeof(o) && o.childNodes && o.childNodes.length ? i.command.collection.length ? i.command.sibling = o.childNodes[0] : i.command.collection = n.arrayFromList(o.childNodes) : "object" == _typeof(o) ? n.extend(i.command, o) : "boolean" == typeof o ? i.animate = o : "function" == typeof o && (i.callback = o));
      }

      if (i.command.index && i.command.sibling) throw new Error(_e.messages.errorInsertInvalidArguments());
      return !i.command.collection.length && a.config.debug.showWarnings && console.warn(_e.messages.warningInsertNoElements()), i = a.callFilters("instructionParseInsertArgs", i, arguments), n.freeze(i), i;
    },
    parseRemoveArgs: function parseRemoveArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = null,
          s = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandRemove(), s = 0; s < t.length; s++) {
        if (r = t[s], null !== r) switch (_typeof(r)) {
          case "number":
            a.targets[r] && (i.command.targets[0] = a.targets[r]);
            break;

          case "string":
            i.command.collection = n.arrayFromList(a.dom.parent.querySelectorAll(r));
            break;

          case "object":
            r && r.length ? i.command.collection = r : n.isElement(r, a.dom.document) ? i.command.collection = [r] : n.extend(i.command, r);
            break;

          case "boolean":
            i.animate = r;
            break;

          case "function":
            i.callback = r;
        }
      }

      if (i.command.collection.length) for (s = 0; o = a.targets[s]; s++) {
        i.command.collection.indexOf(o.dom.el) > -1 && i.command.targets.push(o);
      }
      return !i.command.targets.length && a.config.debug.showWarnings && console.warn(_e.messages.warningRemoveNoElements()), n.freeze(i), i;
    },
    parseDatasetArgs: function parseDatasetArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandDataset(), r = 0; r < t.length; r++) {
        if (o = t[r], null !== o) switch (_typeof(o)) {
          case "object":
            Array.isArray(o) || "number" == typeof o.length ? i.command.dataset = o : n.extend(i.command, o);
            break;

          case "boolean":
            i.animate = o;
            break;

          case "function":
            i.callback = o;
        }
      }

      return n.freeze(i), i;
    },
    parseChangeLayoutArgs: function parseChangeLayoutArgs(t) {
      var a = this,
          i = new _e.UserInstruction(),
          o = null,
          r = -1;

      for (i.animate = a.config.animation.enable, i.command = new _e.CommandChangeLayout(), r = 0; r < t.length; r++) {
        if (o = t[r], null !== o) switch (_typeof(o)) {
          case "string":
            i.command.containerClassName = o;
            break;

          case "object":
            n.extend(i.command, o);
            break;

          case "boolean":
            i.animate = o;
            break;

          case "function":
            i.callback = o;
        }
      }

      return n.freeze(i), i;
    },
    queueMix: function queueMix(t) {
      var a = this,
          i = null,
          o = "";
      return a.callActions("beforeQueueMix", arguments), i = n.defer(_e.libraries), a.config.animation.queue && a.queue.length < a.config.animation.queueLimit ? (t.deferred = i, a.queue.push(t), a.config.controls.enable && (a.isToggling ? (a.buildToggleArray(t.instruction.command), o = a.getToggleSelector(), a.updateControls({
        filter: {
          selector: o
        }
      })) : a.updateControls(t.instruction.command))) : (a.config.debug.showWarnings && console.warn(_e.messages.warningMultimixInstanceQueueFull()), i.resolve(a.state), _e.events.fire("mixBusy", a.dom.container, {
        state: a.state,
        instance: a
      }, a.dom.document), "function" == typeof a.config.callbacks.onMixBusy && a.config.callbacks.onMixBusy.call(a.dom.container, a.state, a)), a.callFilters("promiseQueueMix", i.promise, arguments);
    },
    getDataOperation: function getDataOperation(t) {
      var a = this,
          i = new _e.Operation(),
          o = [];
      if (i = a.callFilters("operationUnmappedGetDataOperation", i, arguments), a.dom.targets.length && !(o = a.state.activeDataset || []).length) throw new Error(_e.messages.errorDatasetNotSet());
      return i.id = n.randomHex(), i.startState = a.state, i.startDataset = o, i.newDataset = t.slice(), a.diffDatasets(i), i.startOrder = a.targets, i.newOrder = i.show, a.config.animation.enable && (a.getStartMixData(i), a.setInter(i), i.docState = n.getDocumentState(a.dom.document), a.getInterMixData(i), a.setFinal(i), a.getFinalMixData(i), a.parseEffects(), i.hasEffect = a.hasEffect(), a.getTweenData(i)), a.targets = i.show.slice(), i.newState = a.buildState(i), Array.prototype.push.apply(a.targets, i.toRemove), i = a.callFilters("operationMappedGetDataOperation", i, arguments);
    },
    diffDatasets: function diffDatasets(t) {
      var a = this,
          i = [],
          o = [],
          r = [],
          s = null,
          l = null,
          c = null,
          u = null,
          f = null,
          h = {},
          d = "",
          m = -1;

      for (a.callActions("beforeDiffDatasets", arguments), m = 0; s = t.newDataset[m]; m++) {
        if ("undefined" == typeof (d = s[a.config.data.uidKey]) || d.toString().length < 1) throw new TypeError(_e.messages.errorDatasetInvalidUidKey({
          uidKey: a.config.data.uidKey
        }));
        if (h[d]) throw new Error(_e.messages.errorDatasetDuplicateUid({
          uid: d
        }));
        h[d] = !0, (l = a.cache[d]) instanceof _e.Target ? (a.config.data.dirtyCheck && !n.deepEquals(s, l.data) && (c = l.render(s), l.data = s, c !== l.dom.el && (l.isInDom && (l.unbindEvents(), a.dom.parent.replaceChild(c, l.dom.el)), l.isShown || (c.style.display = "none"), l.dom.el = c, l.isInDom && l.bindEvents())), c = l.dom.el) : (l = new _e.Target(), l.init(null, a, s), l.hide()), l.isInDom ? (f = l.dom.el.nextElementSibling, o.push(d), u && (u.lastElementChild && u.appendChild(a.dom.document.createTextNode(" ")), a.insertDatasetFrag(u, l.dom.el, r), u = null)) : (u || (u = a.dom.document.createDocumentFragment()), u.lastElementChild && u.appendChild(a.dom.document.createTextNode(" ")), u.appendChild(l.dom.el), l.isInDom = !0, l.unbindEvents(), l.bindEvents(), l.hide(), t.toShow.push(l), r.push(l)), t.show.push(l);
      }

      for (u && (f = f || a.config.layout.siblingAfter, f && u.appendChild(a.dom.document.createTextNode(" ")), a.insertDatasetFrag(u, f, r)), m = 0; s = t.startDataset[m]; m++) {
        d = s[a.config.data.uidKey], l = a.cache[d], t.show.indexOf(l) < 0 ? (t.hide.push(l), t.toHide.push(l), t.toRemove.push(l)) : i.push(d);
      }

      n.isEqualArray(i, o) || (t.willSort = !0), a.callActions("afterDiffDatasets", arguments);
    },
    insertDatasetFrag: function insertDatasetFrag(t, e, n) {
      var a = this,
          i = e ? Array.from(a.dom.parent.children).indexOf(e) : a.targets.length;

      for (a.dom.parent.insertBefore(t, e); n.length;) {
        a.targets.splice(i, 0, n.shift()), i++;
      }
    },
    willSort: function willSort(t, e) {
      var n = this,
          a = !1;
      return a = !!(n.config.behavior.liveSort || "random" === t.order || t.attribute !== e.attribute || t.order !== e.order || t.collection !== e.collection || null === t.next && e.next || t.next && null === e.next) || !(!t.next || !e.next) && n.willSort(t.next, e.next), n.callFilters("resultWillSort", a, arguments);
    },
    show: function show() {
      var t = this;
      return t.filter("all");
    },
    hide: function hide() {
      var t = this;
      return t.filter("none");
    },
    isMixing: function isMixing() {
      var t = this;
      return t.isBusy;
    },
    filter: function filter() {
      var t = this,
          e = t.parseFilterArgs(arguments);
      return t.multimix({
        filter: e.command
      }, e.animate, e.callback);
    },
    toggleOn: function toggleOn() {
      var t = this,
          e = t.parseFilterArgs(arguments),
          n = e.command.selector,
          a = "";
      return t.isToggling = !0, t.toggleArray.indexOf(n) < 0 && t.toggleArray.push(n), a = t.getToggleSelector(), t.multimix({
        filter: a
      }, e.animate, e.callback);
    },
    toggleOff: function toggleOff() {
      var t = this,
          e = t.parseFilterArgs(arguments),
          n = e.command.selector,
          a = t.toggleArray.indexOf(n),
          i = "";
      return t.isToggling = !0, a > -1 && t.toggleArray.splice(a, 1), i = t.getToggleSelector(), t.multimix({
        filter: i
      }, e.animate, e.callback);
    },
    sort: function sort() {
      var t = this,
          e = t.parseSortArgs(arguments);
      return t.multimix({
        sort: e.command
      }, e.animate, e.callback);
    },
    changeLayout: function changeLayout() {
      var t = this,
          e = t.parseChangeLayoutArgs(arguments);
      return t.multimix({
        changeLayout: e.command
      }, e.animate, e.callback);
    },
    dataset: function dataset() {
      var t = this,
          n = t.parseDatasetArgs(arguments),
          a = null,
          i = null,
          o = !1;
      return t.callActions("beforeDataset", arguments), t.isBusy ? (i = new _e.QueueItem(), i.args = arguments, i.instruction = n, t.queueMix(i)) : (n.callback && (t.userCallback = n.callback), o = n.animate ^ t.config.animation.enable ? n.animate : t.config.animation.enable, a = t.getDataOperation(n.command.dataset), t.goMix(o, a));
    },
    multimix: function multimix() {
      var t = this,
          n = null,
          a = !1,
          i = null,
          o = t.parseMultimixArgs(arguments);
      return t.callActions("beforeMultimix", arguments), t.isBusy ? (i = new _e.QueueItem(), i.args = arguments, i.instruction = o, i.triggerElement = t.lastClicked, i.isToggling = t.isToggling, t.queueMix(i)) : (n = t.getOperation(o.command), t.config.controls.enable && (o.command.filter && !t.isToggling && (t.toggleArray.length = 0, t.buildToggleArray(n.command)), t.queue.length < 1 && t.updateControls(n.command)), o.callback && (t.userCallback = o.callback), a = o.animate ^ t.config.animation.enable ? o.animate : t.config.animation.enable, t.callFilters("operationMultimix", n, arguments), t.goMix(a, n));
    },
    getOperation: function getOperation(t) {
      var a = this,
          i = t.sort,
          o = t.filter,
          r = t.changeLayout,
          s = t.remove,
          l = t.insert,
          c = new _e.Operation();
      return c = a.callFilters("operationUnmappedGetOperation", c, arguments), c.id = n.randomHex(), c.command = t, c.startState = a.state, c.triggerElement = a.lastClicked, a.isBusy ? (a.config.debug.showWarnings && console.warn(_e.messages.warningGetOperationInstanceBusy()), null) : (l && a.insertTargets(l, c), s && (c.toRemove = s.targets), c.startSort = c.newSort = c.startState.activeSort, c.startOrder = c.newOrder = a.targets, i && (c.startSort = c.startState.activeSort, c.newSort = i, c.willSort = a.willSort(i, c.startState.activeSort), c.willSort && a.sortOperation(c)), c.startFilter = c.startState.activeFilter, o ? c.newFilter = o : c.newFilter = n.extend(new _e.CommandFilter(), c.startFilter), "all" === c.newFilter.selector ? c.newFilter.selector = a.config.selectors.target : "none" === c.newFilter.selector && (c.newFilter.selector = ""), a.filterOperation(c), c.startContainerClassName = c.startState.activeContainerClassName, r ? (c.newContainerClassName = r.containerClassName, c.newContainerClassName !== c.startContainerClassName && (c.willChangeLayout = !0)) : c.newContainerClassName = c.startContainerClassName, a.config.animation.enable && (a.getStartMixData(c), a.setInter(c), c.docState = n.getDocumentState(a.dom.document), a.getInterMixData(c), a.setFinal(c), a.getFinalMixData(c), a.parseEffects(), c.hasEffect = a.hasEffect(), a.getTweenData(c)), c.willSort && (a.targets = c.newOrder), c.newState = a.buildState(c), a.callFilters("operationMappedGetOperation", c, arguments));
    },
    tween: function tween(t, e) {
      var n = null,
          a = null,
          i = -1,
          o = -1;

      for (e = Math.min(e, 1), e = Math.max(e, 0), o = 0; n = t.show[o]; o++) {
        a = t.showPosData[o], n.applyTween(a, e);
      }

      for (o = 0; n = t.hide[o]; o++) {
        n.isShown && n.hide(), (i = t.toHide.indexOf(n)) > -1 && (a = t.toHidePosData[i], n.isShown || n.show(), n.applyTween(a, e));
      }
    },
    insert: function insert() {
      var t = this,
          e = t.parseInsertArgs(arguments);
      return t.multimix({
        insert: e.command
      }, e.animate, e.callback);
    },
    insertBefore: function insertBefore() {
      var t = this,
          e = t.parseInsertArgs(arguments);
      return t.insert(e.command.collection, "before", e.command.sibling, e.animate, e.callback);
    },
    insertAfter: function insertAfter() {
      var t = this,
          e = t.parseInsertArgs(arguments);
      return t.insert(e.command.collection, "after", e.command.sibling, e.animate, e.callback);
    },
    prepend: function prepend() {
      var t = this,
          e = t.parseInsertArgs(arguments);
      return t.insert(0, e.command.collection, e.animate, e.callback);
    },
    append: function append() {
      var t = this,
          e = t.parseInsertArgs(arguments);
      return t.insert(t.state.totalTargets, e.command.collection, e.animate, e.callback);
    },
    remove: function remove() {
      var t = this,
          e = t.parseRemoveArgs(arguments);
      return t.multimix({
        remove: e.command
      }, e.animate, e.callback);
    },
    getConfig: function getConfig(t) {
      var e = this,
          a = null;
      return a = t ? n.getProperty(e.config, t) : e.config, e.callFilters("valueGetConfig", a, arguments);
    },
    configure: function configure(t) {
      var e = this;
      e.callActions("beforeConfigure", arguments), n.extend(e.config, t, !0, !0), e.callActions("afterConfigure", arguments);
    },
    getState: function getState() {
      var t = this,
          a = null;
      return a = new _e.State(), n.extend(a, t.state), n.freeze(a), t.callFilters("stateGetState", a, arguments);
    },
    forceRefresh: function forceRefresh() {
      var t = this;
      t.indexTargets();
    },
    forceRender: function forceRender() {
      var t = this,
          e = null,
          n = null,
          a = "";

      for (a in t.cache) {
        e = t.cache[a], n = e.render(e.data), n !== e.dom.el && (e.isInDom && (e.unbindEvents(), t.dom.parent.replaceChild(n, e.dom.el)), e.isShown || (n.style.display = "none"), e.dom.el = n, e.isInDom && e.bindEvents());
      }

      t.state = t.buildState(t.lastOperation);
    },
    destroy: function destroy(t) {
      var n = this,
          a = null,
          i = null,
          o = 0;

      for (n.callActions("beforeDestroy", arguments), o = 0; a = n.controls[o]; o++) {
        a.removeBinding(n);
      }

      for (o = 0; i = n.targets[o]; o++) {
        t && i.show(), i.unbindEvents();
      }

      n.dom.container.id.match(/^MixItUp/) && n.dom.container.removeAttribute("id"), delete _e.instances[n.id], n.callActions("afterDestroy", arguments);
    }
  }), _e.IMoveData = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.posIn = null, this.posOut = null, this.operation = null, this.callback = null, this.statusChange = "", this.duration = -1, this.staggerIndex = -1, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.IMoveData), _e.IMoveData.prototype = Object.create(_e.Base.prototype), _e.IMoveData.prototype.constructor = _e.IMoveData, _e.TargetDom = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.el = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.TargetDom), _e.TargetDom.prototype = Object.create(_e.Base.prototype), _e.TargetDom.prototype.constructor = _e.TargetDom, _e.Target = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.id = "", this.sortString = "", this.mixer = null, this.callback = null, this.isShown = !1, this.isBound = !1, this.isExcluded = !1, this.isInDom = !1, this.handler = null, this.operation = null, this.data = null, this.dom = new _e.TargetDom(), this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.Target), _e.Target.prototype = Object.create(_e.Base.prototype), n.extend(_e.Target.prototype, {
    constructor: _e.Target,
    init: function init(t, n, a) {
      var i = this,
          o = "";

      if (i.callActions("beforeInit", arguments), i.mixer = n, t || (t = i.render(a)), i.cacheDom(t), i.bindEvents(), "none" !== i.dom.el.style.display && (i.isShown = !0), a && n.config.data.uidKey) {
        if ("undefined" == typeof (o = a[n.config.data.uidKey]) || o.toString().length < 1) throw new TypeError(_e.messages.errorDatasetInvalidUidKey({
          uidKey: n.config.data.uidKey
        }));
        i.id = o, i.data = a, n.cache[o] = i;
      }

      i.callActions("afterInit", arguments);
    },
    render: function render(t) {
      var a = this,
          i = null,
          o = null,
          r = null,
          s = "";
      if (a.callActions("beforeRender", arguments), i = a.callFilters("renderRender", a.mixer.config.render.target, arguments), "function" != typeof i) throw new TypeError(_e.messages.errorDatasetRendererNotSet());
      return s = i(t), s && "object" == _typeof(s) && n.isElement(s) ? o = s : "string" == typeof s && (r = document.createElement("div"), r.innerHTML = s, o = r.firstElementChild), a.callFilters("elRender", o, arguments);
    },
    cacheDom: function cacheDom(t) {
      var e = this;
      e.callActions("beforeCacheDom", arguments), e.dom.el = t, e.callActions("afterCacheDom", arguments);
    },
    getSortString: function getSortString(t) {
      var e = this,
          n = e.dom.el.getAttribute("data-" + t) || "";
      e.callActions("beforeGetSortString", arguments), n = isNaN(1 * n) ? n.toLowerCase() : 1 * n, e.sortString = n, e.callActions("afterGetSortString", arguments);
    },
    show: function show() {
      var t = this;
      t.callActions("beforeShow", arguments), t.isShown || (t.dom.el.style.display = "", t.isShown = !0), t.callActions("afterShow", arguments);
    },
    hide: function hide() {
      var t = this;
      t.callActions("beforeHide", arguments), t.isShown && (t.dom.el.style.display = "none", t.isShown = !1), t.callActions("afterHide", arguments);
    },
    move: function move(t) {
      var e = this;
      e.callActions("beforeMove", arguments), e.isExcluded || e.mixer.targetsMoved++, e.applyStylesIn(t), requestAnimationFrame(function () {
        e.applyStylesOut(t);
      }), e.callActions("afterMove", arguments);
    },
    applyTween: function applyTween(t, n) {
      var a = this,
          i = "",
          o = null,
          r = t.posIn,
          s = [],
          l = new _e.StyleData(),
          c = -1;

      for (a.callActions("beforeApplyTween", arguments), l.x = r.x, l.y = r.y, 0 === n ? a.hide() : a.isShown || a.show(), c = 0; i = _e.features.TWEENABLE[c]; c++) {
        if (o = t.tweenData[i], "x" === i) {
          if (!o) continue;
          l.x = r.x + o * n;
        } else if ("y" === i) {
          if (!o) continue;
          l.y = r.y + o * n;
        } else if (o instanceof _e.TransformData) {
          if (!o.value) continue;
          l[i].value = r[i].value + o.value * n, l[i].unit = o.unit, s.push(i + "(" + l[i].value + o.unit + ")");
        } else {
          if (!o) continue;
          l[i] = r[i] + o * n, a.dom.el.style[i] = l[i];
        }
      }

      (l.x || l.y) && s.unshift("translate(" + l.x + "px, " + l.y + "px)"), s.length && (a.dom.el.style[_e.features.transformProp] = s.join(" ")), a.callActions("afterApplyTween", arguments);
    },
    applyStylesIn: function applyStylesIn(t) {
      var n = this,
          a = t.posIn,
          i = 1 !== n.mixer.effectsIn.opacity,
          o = [];
      n.callActions("beforeApplyStylesIn", arguments), o.push("translate(" + a.x + "px, " + a.y + "px)"), n.mixer.config.animation.animateResizeTargets && ("show" !== t.statusChange && (n.dom.el.style.width = a.width + "px", n.dom.el.style.height = a.height + "px"), n.dom.el.style.marginRight = a.marginRight + "px", n.dom.el.style.marginBottom = a.marginBottom + "px"), i && (n.dom.el.style.opacity = a.opacity), "show" === t.statusChange && (o = o.concat(n.mixer.transformIn)), n.dom.el.style[_e.features.transformProp] = o.join(" "), n.callActions("afterApplyStylesIn", arguments);
    },
    applyStylesOut: function applyStylesOut(t) {
      var n = this,
          a = [],
          i = [],
          o = n.mixer.config.animation.animateResizeTargets,
          r = "undefined" != typeof n.mixer.effectsIn.opacity;
      if (n.callActions("beforeApplyStylesOut", arguments), a.push(n.writeTransitionRule(_e.features.transformRule, t.staggerIndex)), "none" !== t.statusChange && a.push(n.writeTransitionRule("opacity", t.staggerIndex, t.duration)), o && (a.push(n.writeTransitionRule("width", t.staggerIndex, t.duration)), a.push(n.writeTransitionRule("height", t.staggerIndex, t.duration)), a.push(n.writeTransitionRule("margin", t.staggerIndex, t.duration))), !t.callback) return n.mixer.targetsImmovable++, void (n.mixer.targetsMoved === n.mixer.targetsImmovable && n.mixer.cleanUp(t.operation));

      switch (n.operation = t.operation, n.callback = t.callback, !n.isExcluded && n.mixer.targetsBound++, n.isBound = !0, n.applyTransition(a), o && t.posOut.width > 0 && t.posOut.height > 0 && (n.dom.el.style.width = t.posOut.width + "px", n.dom.el.style.height = t.posOut.height + "px", n.dom.el.style.marginRight = t.posOut.marginRight + "px", n.dom.el.style.marginBottom = t.posOut.marginBottom + "px"), n.mixer.config.animation.nudge || "hide" !== t.statusChange || i.push("translate(" + t.posOut.x + "px, " + t.posOut.y + "px)"), t.statusChange) {
        case "hide":
          r && (n.dom.el.style.opacity = n.mixer.effectsOut.opacity), i = i.concat(n.mixer.transformOut);
          break;

        case "show":
          r && (n.dom.el.style.opacity = 1);
      }

      (n.mixer.config.animation.nudge || !n.mixer.config.animation.nudge && "hide" !== t.statusChange) && i.push("translate(" + t.posOut.x + "px, " + t.posOut.y + "px)"), n.dom.el.style[_e.features.transformProp] = i.join(" "), n.callActions("afterApplyStylesOut", arguments);
    },
    writeTransitionRule: function writeTransitionRule(t, e, n) {
      var a = this,
          i = a.getDelay(e),
          o = "";
      return o = t + " " + (n > 0 ? n : a.mixer.config.animation.duration) + "ms " + i + "ms " + ("opacity" === t ? "linear" : a.mixer.config.animation.easing), a.callFilters("ruleWriteTransitionRule", o, arguments);
    },
    getDelay: function getDelay(t) {
      var e = this,
          n = -1;
      return "function" == typeof e.mixer.config.animation.staggerSequence && (t = e.mixer.config.animation.staggerSequence.call(e, t, e.state)), n = e.mixer.staggerDuration ? t * e.mixer.staggerDuration : 0, e.callFilters("delayGetDelay", n, arguments);
    },
    applyTransition: function applyTransition(t) {
      var n = this,
          a = t.join(", ");
      n.callActions("beforeApplyTransition", arguments), n.dom.el.style[_e.features.transitionProp] = a, n.callActions("afterApplyTransition", arguments);
    },
    handleTransitionEnd: function handleTransitionEnd(t) {
      var e = this,
          n = t.propertyName,
          a = e.mixer.config.animation.animateResizeTargets;
      e.callActions("beforeHandleTransitionEnd", arguments), e.isBound && t.target.matches(e.mixer.config.selectors.target) && (n.indexOf("transform") > -1 || n.indexOf("opacity") > -1 || a && n.indexOf("height") > -1 || a && n.indexOf("width") > -1 || a && n.indexOf("margin") > -1) && (e.callback.call(e, e.operation), e.isBound = !1, e.callback = null, e.operation = null), e.callActions("afterHandleTransitionEnd", arguments);
    },
    eventBus: function eventBus(t) {
      var e = this;

      switch (e.callActions("beforeEventBus", arguments), t.type) {
        case "webkitTransitionEnd":
        case "transitionend":
          e.handleTransitionEnd(t);
      }

      e.callActions("afterEventBus", arguments);
    },
    unbindEvents: function unbindEvents() {
      var t = this;
      t.callActions("beforeUnbindEvents", arguments), n.off(t.dom.el, "webkitTransitionEnd", t.handler), n.off(t.dom.el, "transitionend", t.handler), t.callActions("afterUnbindEvents", arguments);
    },
    bindEvents: function bindEvents() {
      var t = this,
          a = "";
      t.callActions("beforeBindEvents", arguments), a = "webkit" === _e.features.transitionPrefix ? "webkitTransitionEnd" : "transitionend", t.handler = function (e) {
        return t.eventBus(e);
      }, n.on(t.dom.el, a, t.handler), t.callActions("afterBindEvents", arguments);
    },
    getPosData: function getPosData(n) {
      var a = this,
          i = {},
          o = null,
          r = new _e.StyleData();
      return a.callActions("beforeGetPosData", arguments), r.x = a.dom.el.offsetLeft, r.y = a.dom.el.offsetTop, (a.mixer.config.animation.animateResizeTargets || n) && (o = a.dom.el.getBoundingClientRect(), r.top = o.top, r.right = o.right, r.bottom = o.bottom, r.left = o.left, r.width = o.width, r.height = o.height), a.mixer.config.animation.animateResizeTargets && (i = t.getComputedStyle(a.dom.el), r.marginBottom = parseFloat(i.marginBottom), r.marginRight = parseFloat(i.marginRight)), a.callFilters("posDataGetPosData", r, arguments);
    },
    cleanUp: function cleanUp() {
      var t = this;
      t.callActions("beforeCleanUp", arguments), t.dom.el.style[_e.features.transformProp] = "", t.dom.el.style[_e.features.transitionProp] = "", t.dom.el.style.opacity = "", t.mixer.config.animation.animateResizeTargets && (t.dom.el.style.width = "", t.dom.el.style.height = "", t.dom.el.style.marginRight = "", t.dom.el.style.marginBottom = ""), t.callActions("afterCleanUp", arguments);
    }
  }), _e.Collection = function (t) {
    var e = null,
        a = -1;

    for (this.callActions("beforeConstruct"), a = 0; e = t[a]; a++) {
      this[a] = e;
    }

    this.length = t.length, this.callActions("afterConstruct"), n.freeze(this);
  }, _e.BaseStatic.call(_e.Collection), _e.Collection.prototype = Object.create(_e.Base.prototype), n.extend(_e.Collection.prototype, {
    constructor: _e.Collection,
    mixitup: function mixitup(t) {
      var a = this,
          i = null,
          o = Array.prototype.slice.call(arguments),
          r = [],
          s = -1;

      for (this.callActions("beforeMixitup"), o.shift(), s = 0; i = a[s]; s++) {
        r.push(i[t].apply(i, o));
      }

      return a.callFilters("promiseMixitup", n.all(r, _e.libraries), arguments);
    }
  }), _e.Operation = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.id = "", this.args = [], this.command = null, this.showPosData = [], this.toHidePosData = [], this.startState = null, this.newState = null, this.docState = null, this.willSort = !1, this.willChangeLayout = !1, this.hasEffect = !1, this.hasFailed = !1, this.triggerElement = null, this.show = [], this.hide = [], this.matching = [], this.toShow = [], this.toHide = [], this.toMove = [], this.toRemove = [], this.startOrder = [], this.newOrder = [], this.startSort = null, this.newSort = null, this.startFilter = null, this.newFilter = null, this.startDataset = null, this.newDataset = null, this.viewportDeltaX = 0, this.viewportDeltaY = 0, this.startX = 0, this.startY = 0, this.startHeight = 0, this.startWidth = 0, this.newX = 0, this.newY = 0, this.newHeight = 0, this.newWidth = 0, this.startContainerClassName = "", this.startDisplay = "", this.newContainerClassName = "", this.newDisplay = "", this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.Operation), _e.Operation.prototype = Object.create(_e.Base.prototype), _e.Operation.prototype.constructor = _e.Operation, _e.State = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.id = "", this.activeFilter = null, this.activeSort = null, this.activeContainerClassName = "", this.container = null, this.targets = [], this.hide = [], this.show = [], this.matching = [], this.totalTargets = -1, this.totalShow = -1, this.totalHide = -1, this.totalMatching = -1, this.hasFailed = !1, this.triggerElement = null, this.activeDataset = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.State), _e.State.prototype = Object.create(_e.Base.prototype), _e.State.prototype.constructor = _e.State, _e.UserInstruction = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.command = {}, this.animate = !1, this.callback = null, this.callActions("afterConstruct"), n.seal(this);
  }, _e.BaseStatic.call(_e.UserInstruction), _e.UserInstruction.prototype = Object.create(_e.Base.prototype), _e.UserInstruction.prototype.constructor = _e.UserInstruction, _e.Messages = function () {
    _e.Base.call(this), this.callActions("beforeConstruct"), this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function", this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element", this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`", this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`", this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}', this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?', this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`", this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items', this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.', this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both", this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container", this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both", this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`", this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets", this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`", this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.", this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`", this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`", this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.", this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.", this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.", this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output', this.callActions("afterConstruct"), this.compileTemplates(), n.seal(this);
  }, _e.BaseStatic.call(_e.Messages), _e.Messages.prototype = Object.create(_e.Base.prototype), _e.Messages.prototype.constructor = _e.Messages, _e.Messages.prototype.compileTemplates = function () {
    var t = "",
        e = "";

    for (t in this) {
      "string" == typeof (e = this[t]) && (this[n.camelCase(t)] = n.template(e));
    }
  }, _e.messages = new _e.Messages(), _e.Facade = function (t) {
    _e.Base.call(this), this.callActions("beforeConstruct", arguments), this.configure = t.configure.bind(t), this.show = t.show.bind(t), this.hide = t.hide.bind(t), this.filter = t.filter.bind(t), this.toggleOn = t.toggleOn.bind(t), this.toggleOff = t.toggleOff.bind(t), this.sort = t.sort.bind(t), this.changeLayout = t.changeLayout.bind(t), this.multimix = t.multimix.bind(t), this.dataset = t.dataset.bind(t), this.tween = t.tween.bind(t), this.insert = t.insert.bind(t), this.insertBefore = t.insertBefore.bind(t), this.insertAfter = t.insertAfter.bind(t), this.prepend = t.prepend.bind(t), this.append = t.append.bind(t), this.remove = t.remove.bind(t), this.destroy = t.destroy.bind(t), this.forceRefresh = t.forceRefresh.bind(t), this.forceRender = t.forceRender.bind(t), this.isMixing = t.isMixing.bind(t), this.getOperation = t.getOperation.bind(t), this.getConfig = t.getConfig.bind(t), this.getState = t.getState.bind(t), this.callActions("afterConstruct", arguments), n.freeze(this), n.seal(this);
  }, _e.BaseStatic.call(_e.Facade), _e.Facade.prototype = Object.create(_e.Base.prototype), _e.Facade.prototype.constructor = _e.Facade, "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = _e : "function" == typeof define && define.amd ? define(function () {
    return _e;
  }) : "undefined" != typeof t.mixitup && "function" == typeof t.mixitup || (t.mixitup = _e), _e.BaseStatic.call(_e.constructor), _e.NAME = "mixitup", _e.CORE_VERSION = "3.3.0";
}(window);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Owl Carousel v2.2.1
 * Copyright 2013-2017 David Deutsch
 * Licensed under  ()
 */
!function (a, b, c, d) {
  function e(b, c) {
    this.settings = null, this.options = a.extend({}, e.Defaults, c), this.$element = a(b), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
      time: null,
      target: null,
      pointer: null,
      stage: {
        start: null,
        current: null
      },
      direction: null
    }, this._states = {
      current: {},
      tags: {
        initializing: ["busy"],
        animating: ["busy"],
        dragging: ["interacting"]
      }
    }, a.each(["onResize", "onThrottledResize"], a.proxy(function (b, c) {
      this._handlers[c] = a.proxy(this[c], this);
    }, this)), a.each(e.Plugins, a.proxy(function (a, b) {
      this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
    }, this)), a.each(e.Workers, a.proxy(function (b, c) {
      this._pipe.push({
        filter: c.filter,
        run: a.proxy(c.run, this)
      });
    }, this)), this.setup(), this.initialize();
  }

  e.Defaults = {
    items: 3,
    loop: !1,
    center: !1,
    rewind: !1,
    mouseDrag: !0,
    touchDrag: !0,
    pullDrag: !0,
    freeDrag: !1,
    margin: 0,
    stagePadding: 0,
    merge: !1,
    mergeFit: !0,
    autoWidth: !1,
    startPosition: 0,
    rtl: !1,
    smartSpeed: 250,
    fluidSpeed: !1,
    dragEndSpeed: !1,
    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: b,
    fallbackEasing: "swing",
    info: !1,
    nestedItemSelector: !1,
    itemElement: "div",
    stageElement: "div",
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    rtlClass: "owl-rtl",
    responsiveClass: "owl-responsive",
    dragClass: "owl-drag",
    itemClass: "owl-item",
    stageClass: "owl-stage",
    stageOuterClass: "owl-stage-outer",
    grabClass: "owl-grab"
  }, e.Width = {
    Default: "default",
    Inner: "inner",
    Outer: "outer"
  }, e.Type = {
    Event: "event",
    State: "state"
  }, e.Plugins = {}, e.Workers = [{
    filter: ["width", "settings"],
    run: function run() {
      this._width = this.$element.width();
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run(a) {
      a.current = this._items && this._items[this.relative(this._current)];
    }
  }, {
    filter: ["items", "settings"],
    run: function run() {
      this.$stage.children(".cloned").remove();
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run(a) {
      var b = this.settings.margin || "",
          c = !this.settings.autoWidth,
          d = this.settings.rtl,
          e = {
        width: "auto",
        "margin-left": d ? b : "",
        "margin-right": d ? "" : b
      };
      !c && this.$stage.children().css(e), a.css = e;
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run(a) {
      var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
          c = null,
          d = this._items.length,
          e = !this.settings.autoWidth,
          f = [];

      for (a.items = {
        merge: !1,
        width: b
      }; d--;) {
        c = this._mergers[d], c = this.settings.mergeFit && Math.min(c, this.settings.items) || c, a.items.merge = c > 1 || a.items.merge, f[d] = e ? b * c : this._items[d].width();
      }

      this._widths = f;
    }
  }, {
    filter: ["items", "settings"],
    run: function run() {
      var b = [],
          c = this._items,
          d = this.settings,
          e = Math.max(2 * d.items, 4),
          f = 2 * Math.ceil(c.length / 2),
          g = d.loop && c.length ? d.rewind ? e : Math.max(e, f) : 0,
          h = "",
          i = "";

      for (g /= 2; g--;) {
        b.push(this.normalize(b.length / 2, !0)), h += c[b[b.length - 1]][0].outerHTML, b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)), i = c[b[b.length - 1]][0].outerHTML + i;
      }

      this._clones = b, a(h).addClass("cloned").appendTo(this.$stage), a(i).addClass("cloned").prependTo(this.$stage);
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run() {
      for (var a = this.settings.rtl ? 1 : -1, b = this._clones.length + this._items.length, c = -1, d = 0, e = 0, f = []; ++c < b;) {
        d = f[c - 1] || 0, e = this._widths[this.relative(c)] + this.settings.margin, f.push(d + e * a);
      }

      this._coordinates = f;
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run() {
      var a = this.settings.stagePadding,
          b = this._coordinates,
          c = {
        width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
        "padding-left": a || "",
        "padding-right": a || ""
      };
      this.$stage.css(c);
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run(a) {
      var b = this._coordinates.length,
          c = !this.settings.autoWidth,
          d = this.$stage.children();
      if (c && a.items.merge) for (; b--;) {
        a.css.width = this._widths[this.relative(b)], d.eq(b).css(a.css);
      } else c && (a.css.width = a.items.width, d.css(a.css));
    }
  }, {
    filter: ["items"],
    run: function run() {
      this._coordinates.length < 1 && this.$stage.removeAttr("style");
    }
  }, {
    filter: ["width", "items", "settings"],
    run: function run(a) {
      a.current = a.current ? this.$stage.children().index(a.current) : 0, a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current)), this.reset(a.current);
    }
  }, {
    filter: ["position"],
    run: function run() {
      this.animate(this.coordinates(this._current));
    }
  }, {
    filter: ["width", "position", "items", "settings"],
    run: function run() {
      var a,
          b,
          c,
          d,
          e = this.settings.rtl ? 1 : -1,
          f = 2 * this.settings.stagePadding,
          g = this.coordinates(this.current()) + f,
          h = g + this.width() * e,
          i = [];

      for (c = 0, d = this._coordinates.length; c < d; c++) {
        a = this._coordinates[c - 1] || 0, b = Math.abs(this._coordinates[c]) + f * e, (this.op(a, "<=", g) && this.op(a, ">", h) || this.op(b, "<", g) && this.op(b, ">", h)) && i.push(c);
      }

      this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"), this.settings.center && (this.$stage.children(".center").removeClass("center"), this.$stage.children().eq(this.current()).addClass("center"));
    }
  }], e.prototype.initialize = function () {
    if (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) {
      var b, c, e;
      b = this.$element.find("img"), c = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, e = this.$element.children(c).width(), b.length && e <= 0 && this.preloadAutoWidthImages(b);
    }

    this.$element.addClass(this.options.loadingClass), this.$stage = a("<" + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>').wrap('<div class="' + this.settings.stageOuterClass + '"/>'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this.$element.is(":visible") ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized");
  }, e.prototype.setup = function () {
    var b = this.viewport(),
        c = this.options.responsive,
        d = -1,
        e = null;
    c ? (a.each(c, function (a) {
      a <= b && a > d && (d = Number(a));
    }), e = a.extend({}, this.options, c[d]), "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()), delete e.responsive, e.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d))) : e = a.extend({}, this.options), this.trigger("change", {
      property: {
        name: "settings",
        value: e
      }
    }), this._breakpoint = d, this.settings = e, this.invalidate("settings"), this.trigger("changed", {
      property: {
        name: "settings",
        value: this.settings
      }
    });
  }, e.prototype.optionsLogic = function () {
    this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1);
  }, e.prototype.prepare = function (b) {
    var c = this.trigger("prepare", {
      content: b
    });
    return c.data || (c.data = a("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(b)), this.trigger("prepared", {
      content: c.data
    }), c.data;
  }, e.prototype.update = function () {
    for (var b = 0, c = this._pipe.length, d = a.proxy(function (a) {
      return this[a];
    }, this._invalidated), e = {}; b < c;) {
      (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
    }

    this._invalidated = {}, !this.is("valid") && this.enter("valid");
  }, e.prototype.width = function (a) {
    switch (a = a || e.Width.Default) {
      case e.Width.Inner:
      case e.Width.Outer:
        return this._width;

      default:
        return this._width - 2 * this.settings.stagePadding + this.settings.margin;
    }
  }, e.prototype.refresh = function () {
    this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed");
  }, e.prototype.onThrottledResize = function () {
    b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
  }, e.prototype.onResize = function () {
    return !!this._items.length && this._width !== this.$element.width() && !!this.$element.is(":visible") && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")));
  }, e.prototype.registerEventHandlers = function () {
    a.support.transition && this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)), this.settings.responsive !== !1 && this.on(b, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
      return !1;
    })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)));
  }, e.prototype.onDragStart = function (b) {
    var d = null;
    3 !== b.which && (a.support.transform ? (d = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","), d = {
      x: d[16 === d.length ? 12 : 4],
      y: d[16 === d.length ? 13 : 5]
    }) : (d = this.$stage.position(), d = {
      x: this.settings.rtl ? d.left + this.$stage.width() - this.width() + this.settings.margin : d.left,
      y: d.top
    }), this.is("animating") && (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type), this.speed(0), this._drag.time = new Date().getTime(), this._drag.target = a(b.target), this._drag.stage.start = d, this._drag.stage.current = d, this._drag.pointer = this.pointer(b), a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)), a(c).one("mousemove.owl.core touchmove.owl.core", a.proxy(function (b) {
      var d = this.difference(this._drag.pointer, this.pointer(b));
      a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)), Math.abs(d.x) < Math.abs(d.y) && this.is("valid") || (b.preventDefault(), this.enter("dragging"), this.trigger("drag"));
    }, this)));
  }, e.prototype.onDragMove = function (a) {
    var b = null,
        c = null,
        d = null,
        e = this.difference(this._drag.pointer, this.pointer(a)),
        f = this.difference(this._drag.stage.start, e);
    this.is("dragging") && (a.preventDefault(), this.settings.loop ? (b = this.coordinates(this.minimum()), c = this.coordinates(this.maximum() + 1) - b, f.x = ((f.x - b) % c + c) % c + b) : (b = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), d = this.settings.pullDrag ? -1 * e.x / 5 : 0, f.x = Math.max(Math.min(f.x, b + d), c + d)), this._drag.stage.current = f, this.animate(f.x));
  }, e.prototype.onDragEnd = function (b) {
    var d = this.difference(this._drag.pointer, this.pointer(b)),
        e = this._drag.stage.current,
        f = d.x > 0 ^ this.settings.rtl ? "left" : "right";
    a(c).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== d.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = f, (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function () {
      return !1;
    })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
  }, e.prototype.closest = function (b, c) {
    var d = -1,
        e = 30,
        f = this.width(),
        g = this.coordinates();
    return this.settings.freeDrag || a.each(g, a.proxy(function (a, h) {
      return "left" === c && b > h - e && b < h + e ? d = a : "right" === c && b > h - f - e && b < h - f + e ? d = a + 1 : this.op(b, "<", h) && this.op(b, ">", g[a + 1] || h - f) && (d = "left" === c ? a + 1 : a), d === -1;
    }, this)), this.settings.loop || (this.op(b, ">", g[this.minimum()]) ? d = b = this.minimum() : this.op(b, "<", g[this.maximum()]) && (d = b = this.maximum())), d;
  }, e.prototype.animate = function (b) {
    var c = this.speed() > 0;
    this.is("animating") && this.onTransitionEnd(), c && (this.enter("animating"), this.trigger("translate")), a.support.transform3d && a.support.transition ? this.$stage.css({
      transform: "translate3d(" + b + "px,0px,0px)",
      transition: this.speed() / 1e3 + "s"
    }) : c ? this.$stage.animate({
      left: b + "px"
    }, this.speed(), this.settings.fallbackEasing, a.proxy(this.onTransitionEnd, this)) : this.$stage.css({
      left: b + "px"
    });
  }, e.prototype.is = function (a) {
    return this._states.current[a] && this._states.current[a] > 0;
  }, e.prototype.current = function (a) {
    if (a === d) return this._current;
    if (0 === this._items.length) return d;

    if (a = this.normalize(a), this._current !== a) {
      var b = this.trigger("change", {
        property: {
          name: "position",
          value: a
        }
      });
      b.data !== d && (a = this.normalize(b.data)), this._current = a, this.invalidate("position"), this.trigger("changed", {
        property: {
          name: "position",
          value: this._current
        }
      });
    }

    return this._current;
  }, e.prototype.invalidate = function (b) {
    return "string" === a.type(b) && (this._invalidated[b] = !0, this.is("valid") && this.leave("valid")), a.map(this._invalidated, function (a, b) {
      return b;
    });
  }, e.prototype.reset = function (a) {
    a = this.normalize(a), a !== d && (this._speed = 0, this._current = a, this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"]));
  }, e.prototype.normalize = function (a, b) {
    var c = this._items.length,
        e = b ? 0 : this._clones.length;
    return !this.isNumeric(a) || c < 1 ? a = d : (a < 0 || a >= c + e) && (a = ((a - e / 2) % c + c) % c + e / 2), a;
  }, e.prototype.relative = function (a) {
    return a -= this._clones.length / 2, this.normalize(a, !0);
  }, e.prototype.maximum = function (a) {
    var b,
        c,
        d,
        e = this.settings,
        f = this._coordinates.length;
    if (e.loop) f = this._clones.length / 2 + this._items.length - 1;else if (e.autoWidth || e.merge) {
      for (b = this._items.length, c = this._items[--b].width(), d = this.$element.width(); b-- && (c += this._items[b].width() + this.settings.margin, !(c > d));) {
        ;
      }

      f = b + 1;
    } else f = e.center ? this._items.length - 1 : this._items.length - e.items;
    return a && (f -= this._clones.length / 2), Math.max(f, 0);
  }, e.prototype.minimum = function (a) {
    return a ? 0 : this._clones.length / 2;
  }, e.prototype.items = function (a) {
    return a === d ? this._items.slice() : (a = this.normalize(a, !0), this._items[a]);
  }, e.prototype.mergers = function (a) {
    return a === d ? this._mergers.slice() : (a = this.normalize(a, !0), this._mergers[a]);
  }, e.prototype.clones = function (b) {
    var c = this._clones.length / 2,
        e = c + this._items.length,
        f = function f(a) {
      return a % 2 === 0 ? e + a / 2 : c - (a + 1) / 2;
    };

    return b === d ? a.map(this._clones, function (a, b) {
      return f(b);
    }) : a.map(this._clones, function (a, c) {
      return a === b ? f(c) : null;
    });
  }, e.prototype.speed = function (a) {
    return a !== d && (this._speed = a), this._speed;
  }, e.prototype.coordinates = function (b) {
    var c,
        e = 1,
        f = b - 1;
    return b === d ? a.map(this._coordinates, a.proxy(function (a, b) {
      return this.coordinates(b);
    }, this)) : (this.settings.center ? (this.settings.rtl && (e = -1, f = b + 1), c = this._coordinates[b], c += (this.width() - c + (this._coordinates[f] || 0)) / 2 * e) : c = this._coordinates[f] || 0, c = Math.ceil(c));
  }, e.prototype.duration = function (a, b, c) {
    return 0 === c ? 0 : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
  }, e.prototype.to = function (a, b) {
    var c = this.current(),
        d = null,
        e = a - this.relative(c),
        f = (e > 0) - (e < 0),
        g = this._items.length,
        h = this.minimum(),
        i = this.maximum();
    this.settings.loop ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += f * -1 * g), a = c + e, d = ((a - h) % g + g) % g + h, d !== a && d - e <= i && d - e > 0 && (c = d - e, a = d, this.reset(c))) : this.settings.rewind ? (i += 1, a = (a % i + i) % i) : a = Math.max(h, Math.min(i, a)), this.speed(this.duration(c, a, b)), this.current(a), this.$element.is(":visible") && this.update();
  }, e.prototype.next = function (a) {
    a = a || !1, this.to(this.relative(this.current()) + 1, a);
  }, e.prototype.prev = function (a) {
    a = a || !1, this.to(this.relative(this.current()) - 1, a);
  }, e.prototype.onTransitionEnd = function (a) {
    if (a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))) return !1;
    this.leave("animating"), this.trigger("translated");
  }, e.prototype.viewport = function () {
    var d;
    return this.options.responsiveBaseElement !== b ? d = a(this.options.responsiveBaseElement).width() : b.innerWidth ? d = b.innerWidth : c.documentElement && c.documentElement.clientWidth ? d = c.documentElement.clientWidth : console.warn("Can not detect viewport width."), d;
  }, e.prototype.replace = function (b) {
    this.$stage.empty(), this._items = [], b && (b = b instanceof jQuery ? b : a(b)), this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)), b.filter(function () {
      return 1 === this.nodeType;
    }).each(a.proxy(function (a, b) {
      b = this.prepare(b), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
    }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items");
  }, e.prototype.add = function (b, c) {
    var e = this.relative(this._current);
    c = c === d ? this._items.length : this.normalize(c, !0), b = b instanceof jQuery ? b : a(b), this.trigger("add", {
      content: b,
      position: c
    }), b = this.prepare(b), 0 === this._items.length || c === this._items.length ? (0 === this._items.length && this.$stage.append(b), 0 !== this._items.length && this._items[c - 1].after(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[c].before(b), this._items.splice(c, 0, b), this._mergers.splice(c, 0, 1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[e] && this.reset(this._items[e].index()), this.invalidate("items"), this.trigger("added", {
      content: b,
      position: c
    });
  }, e.prototype.remove = function (a) {
    a = this.normalize(a, !0), a !== d && (this.trigger("remove", {
      content: this._items[a],
      position: a
    }), this._items[a].remove(), this._items.splice(a, 1), this._mergers.splice(a, 1), this.invalidate("items"), this.trigger("removed", {
      content: null,
      position: a
    }));
  }, e.prototype.preloadAutoWidthImages = function (b) {
    b.each(a.proxy(function (b, c) {
      this.enter("pre-loading"), c = a(c), a(new Image()).one("load", a.proxy(function (a) {
        c.attr("src", a.target.src), c.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh();
      }, this)).attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina"));
    }, this));
  }, e.prototype.destroy = function () {
    this.$element.off(".owl.core"), this.$stage.off(".owl.core"), a(c).off(".owl.core"), this.settings.responsive !== !1 && (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize));

    for (var d in this._plugins) {
      this._plugins[d].destroy();
    }

    this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel");
  }, e.prototype.op = function (a, b, c) {
    var d = this.settings.rtl;

    switch (b) {
      case "<":
        return d ? a > c : a < c;

      case ">":
        return d ? a < c : a > c;

      case ">=":
        return d ? a <= c : a >= c;

      case "<=":
        return d ? a >= c : a <= c;
    }
  }, e.prototype.on = function (a, b, c, d) {
    a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c);
  }, e.prototype.off = function (a, b, c, d) {
    a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c);
  }, e.prototype.trigger = function (b, c, d, f, g) {
    var h = {
      item: {
        count: this._items.length,
        index: this.current()
      }
    },
        i = a.camelCase(a.grep(["on", b, d], function (a) {
      return a;
    }).join("-").toLowerCase()),
        j = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({
      relatedTarget: this
    }, h, c));
    return this._supress[b] || (a.each(this._plugins, function (a, b) {
      b.onTrigger && b.onTrigger(j);
    }), this.register({
      type: e.Type.Event,
      name: b
    }), this.$element.trigger(j), this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)), j;
  }, e.prototype.enter = function (b) {
    a.each([b].concat(this._states.tags[b] || []), a.proxy(function (a, b) {
      this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++;
    }, this));
  }, e.prototype.leave = function (b) {
    a.each([b].concat(this._states.tags[b] || []), a.proxy(function (a, b) {
      this._states.current[b]--;
    }, this));
  }, e.prototype.register = function (b) {
    if (b.type === e.Type.Event) {
      if (a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl) {
        var c = a.event.special[b.name]._default;
        a.event.special[b.name]._default = function (a) {
          return !c || !c.apply || a.namespace && a.namespace.indexOf("owl") !== -1 ? a.namespace && a.namespace.indexOf("owl") > -1 : c.apply(this, arguments);
        }, a.event.special[b.name].owl = !0;
      }
    } else b.type === e.Type.State && (this._states.tags[b.name] ? this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags) : this._states.tags[b.name] = b.tags, this._states.tags[b.name] = a.grep(this._states.tags[b.name], a.proxy(function (c, d) {
      return a.inArray(c, this._states.tags[b.name]) === d;
    }, this)));
  }, e.prototype.suppress = function (b) {
    a.each(b, a.proxy(function (a, b) {
      this._supress[b] = !0;
    }, this));
  }, e.prototype.release = function (b) {
    a.each(b, a.proxy(function (a, b) {
      delete this._supress[b];
    }, this));
  }, e.prototype.pointer = function (a) {
    var c = {
      x: null,
      y: null
    };
    return a = a.originalEvent || a || b.event, a = a.touches && a.touches.length ? a.touches[0] : a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a, a.pageX ? (c.x = a.pageX, c.y = a.pageY) : (c.x = a.clientX, c.y = a.clientY), c;
  }, e.prototype.isNumeric = function (a) {
    return !isNaN(parseFloat(a));
  }, e.prototype.difference = function (a, b) {
    return {
      x: a.x - b.x,
      y: a.y - b.y
    };
  }, a.fn.owlCarousel = function (b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return this.each(function () {
      var d = a(this),
          f = d.data("owl.carousel");
      f || (f = new e(this, "object" == _typeof(b) && b), d.data("owl.carousel", f), a.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (b, c) {
        f.register({
          type: e.Type.Event,
          name: c
        }), f.$element.on(c + ".owl.carousel.core", a.proxy(function (a) {
          a.namespace && a.relatedTarget !== this && (this.suppress([c]), f[c].apply(this, [].slice.call(arguments, 1)), this.release([c]));
        }, f));
      })), "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
    });
  }, a.fn.owlCarousel.Constructor = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function e(b) {
    this._core = b, this._interval = null, this._visible = null, this._handlers = {
      "initialized.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.autoRefresh && this.watch();
      }, this)
    }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
  };

  e.Defaults = {
    autoRefresh: !0,
    autoRefreshInterval: 500
  }, e.prototype.watch = function () {
    this._interval || (this._visible = this._core.$element.is(":visible"), this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval));
  }, e.prototype.refresh = function () {
    this._core.$element.is(":visible") !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
  }, e.prototype.destroy = function () {
    var a, c;
    b.clearInterval(this._interval);

    for (a in this._handlers) {
      this._core.$element.off(a, this._handlers[a]);
    }

    for (c in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[c] && (this[c] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function e(b) {
    this._core = b, this._loaded = [], this._handlers = {
      "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (b) {
        if (b.namespace && this._core.settings && this._core.settings.lazyLoad && (b.property && "position" == b.property.name || "initialized" == b.type)) for (var c = this._core.settings, e = c.center && Math.ceil(c.items / 2) || c.items, f = c.center && e * -1 || 0, g = (b.property && b.property.value !== d ? b.property.value : this._core.current()) + f, h = this._core.clones().length, i = a.proxy(function (a, b) {
          this.load(b);
        }, this); f++ < e;) {
          this.load(h / 2 + this._core.relative(g)), h && a.each(this._core.clones(this._core.relative(g)), i), g++;
        }
      }, this)
    }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
  };

  e.Defaults = {
    lazyLoad: !1
  }, e.prototype.load = function (c) {
    var d = this._core.$stage.children().eq(c),
        e = d && d.find(".owl-lazy");

    !e || a.inArray(d.get(0), this._loaded) > -1 || (e.each(a.proxy(function (c, d) {
      var e,
          f = a(d),
          g = b.devicePixelRatio > 1 && f.attr("data-src-retina") || f.attr("data-src");
      this._core.trigger("load", {
        element: f,
        url: g
      }, "lazy"), f.is("img") ? f.one("load.owl.lazy", a.proxy(function () {
        f.css("opacity", 1), this._core.trigger("loaded", {
          element: f,
          url: g
        }, "lazy");
      }, this)).attr("src", g) : (e = new Image(), e.onload = a.proxy(function () {
        f.css({
          "background-image": 'url("' + g + '")',
          opacity: "1"
        }), this._core.trigger("loaded", {
          element: f,
          url: g
        }, "lazy");
      }, this), e.src = g);
    }, this)), this._loaded.push(d.get(0)));
  }, e.prototype.destroy = function () {
    var a, b;

    for (a in this.handlers) {
      this._core.$element.off(a, this.handlers[a]);
    }

    for (b in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[b] && (this[b] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.Lazy = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function e(b) {
    this._core = b, this._handlers = {
      "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.autoHeight && this.update();
      }, this),
      "changed.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.autoHeight && "position" == a.property.name && this.update();
      }, this),
      "loaded.owl.lazy": a.proxy(function (a) {
        a.namespace && this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
      }, this)
    }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
  };

  e.Defaults = {
    autoHeight: !1,
    autoHeightClass: "owl-height"
  }, e.prototype.update = function () {
    var b = this._core._current,
        c = b + this._core.settings.items,
        d = this._core.$stage.children().toArray().slice(b, c),
        e = [],
        f = 0;

    a.each(d, function (b, c) {
      e.push(a(c).height());
    }), f = Math.max.apply(null, e), this._core.$stage.parent().height(f).addClass(this._core.settings.autoHeightClass);
  }, e.prototype.destroy = function () {
    var a, b;

    for (a in this._handlers) {
      this._core.$element.off(a, this._handlers[a]);
    }

    for (b in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[b] && (this[b] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function e(b) {
    this._core = b, this._videos = {}, this._playing = null, this._handlers = {
      "initialized.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.register({
          type: "state",
          name: "playing",
          tags: ["interacting"]
        });
      }, this),
      "resize.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault();
      }, this),
      "refreshed.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
      }, this),
      "changed.owl.carousel": a.proxy(function (a) {
        a.namespace && "position" === a.property.name && this._playing && this.stop();
      }, this),
      "prepared.owl.carousel": a.proxy(function (b) {
        if (b.namespace) {
          var c = a(b.content).find(".owl-video");
          c.length && (c.css("display", "none"), this.fetch(c, a(b.content)));
        }
      }, this)
    }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", a.proxy(function (a) {
      this.play(a);
    }, this));
  };

  e.Defaults = {
    video: !1,
    videoHeight: !1,
    videoWidth: !1
  }, e.prototype.fetch = function (a, b) {
    var c = function () {
      return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube";
    }(),
        d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"),
        e = a.attr("data-width") || this._core.settings.videoWidth,
        f = a.attr("data-height") || this._core.settings.videoHeight,
        g = a.attr("href");

    if (!g) throw new Error("Missing video URL.");
    if (d = g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), d[3].indexOf("youtu") > -1) c = "youtube";else if (d[3].indexOf("vimeo") > -1) c = "vimeo";else {
      if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
      c = "vzaar";
    }
    d = d[6], this._videos[g] = {
      type: c,
      id: d,
      width: e,
      height: f
    }, b.attr("data-video", g), this.thumbnail(a, this._videos[g]);
  }, e.prototype.thumbnail = function (b, c) {
    var d,
        e,
        f,
        g = c.width && c.height ? 'style="width:' + c.width + "px;height:" + c.height + 'px;"' : "",
        h = b.find("img"),
        i = "src",
        j = "",
        k = this._core.settings,
        l = function l(a) {
      e = '<div class="owl-video-play-icon"></div>', d = k.lazyLoad ? '<div class="owl-video-tn ' + j + '" ' + i + '="' + a + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + a + ')"></div>', b.after(d), b.after(e);
    };

    if (b.wrap('<div class="owl-video-wrapper"' + g + "></div>"), this._core.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length) return l(h.attr(i)), h.remove(), !1;
    "youtube" === c.type ? (f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg", l(f)) : "vimeo" === c.type ? a.ajax({
      type: "GET",
      url: "//vimeo.com/api/v2/video/" + c.id + ".json",
      jsonp: "callback",
      dataType: "jsonp",
      success: function success(a) {
        f = a[0].thumbnail_large, l(f);
      }
    }) : "vzaar" === c.type && a.ajax({
      type: "GET",
      url: "//vzaar.com/api/videos/" + c.id + ".json",
      jsonp: "callback",
      dataType: "jsonp",
      success: function success(a) {
        f = a.framegrab_url, l(f);
      }
    });
  }, e.prototype.stop = function () {
    this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video");
  }, e.prototype.play = function (b) {
    var c,
        d = a(b.target),
        e = d.closest("." + this._core.settings.itemClass),
        f = this._videos[e.attr("data-video")],
        g = f.width || "100%",
        h = f.height || this._core.$stage.height();

    this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), e = this._core.items(this._core.relative(e.index())), this._core.reset(e.index()), "youtube" === f.type ? c = '<iframe width="' + g + '" height="' + h + '" src="//www.youtube.com/embed/' + f.id + "?autoplay=1&rel=0&v=" + f.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === f.type ? c = '<iframe src="//player.vimeo.com/video/' + f.id + '?autoplay=1" width="' + g + '" height="' + h + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : "vzaar" === f.type && (c = '<iframe frameborder="0"height="' + h + '"width="' + g + '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' + f.id + '/player?autoplay=true"></iframe>'), a('<div class="owl-video-frame">' + c + "</div>").insertAfter(e.find(".owl-video")), this._playing = e.addClass("owl-video-playing"));
  }, e.prototype.isInFullScreen = function () {
    var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
    return b && a(b).parent().hasClass("owl-video-frame");
  }, e.prototype.destroy = function () {
    var a, b;

    this._core.$element.off("click.owl.video");

    for (a in this._handlers) {
      this._core.$element.off(a, this._handlers[a]);
    }

    for (b in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[b] && (this[b] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.Video = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function e(b) {
    this.core = b, this.core.options = a.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = d, this.next = d, this.handlers = {
      "change.owl.carousel": a.proxy(function (a) {
        a.namespace && "position" == a.property.name && (this.previous = this.core.current(), this.next = a.property.value);
      }, this),
      "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
        a.namespace && (this.swapping = "translated" == a.type);
      }, this),
      "translate.owl.carousel": a.proxy(function (a) {
        a.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
      }, this)
    }, this.core.$element.on(this.handlers);
  };

  e.Defaults = {
    animateOut: !1,
    animateIn: !1
  }, e.prototype.swap = function () {
    if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
      this.core.speed(0);
      var b,
          c = a.proxy(this.clear, this),
          d = this.core.$stage.children().eq(this.previous),
          e = this.core.$stage.children().eq(this.next),
          f = this.core.settings.animateIn,
          g = this.core.settings.animateOut;
      this.core.current() !== this.previous && (g && (b = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d.one(a.support.animation.end, c).css({
        left: b + "px"
      }).addClass("animated owl-animated-out").addClass(g)), f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f));
    }
  }, e.prototype.clear = function (b) {
    a(b.target).css({
      left: ""
    }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
  }, e.prototype.destroy = function () {
    var a, b;

    for (a in this.handlers) {
      this.core.$element.off(a, this.handlers[a]);
    }

    for (b in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[b] && (this[b] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.Animate = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function e(b) {
    this._core = b, this._timeout = null, this._paused = !1, this._handlers = {
      "changed.owl.carousel": a.proxy(function (a) {
        a.namespace && "settings" === a.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : a.namespace && "position" === a.property.name && this._core.settings.autoplay && this._setAutoPlayInterval();
      }, this),
      "initialized.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.autoplay && this.play();
      }, this),
      "play.owl.autoplay": a.proxy(function (a, b, c) {
        a.namespace && this.play(b, c);
      }, this),
      "stop.owl.autoplay": a.proxy(function (a) {
        a.namespace && this.stop();
      }, this),
      "mouseover.owl.autoplay": a.proxy(function () {
        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
      }, this),
      "mouseleave.owl.autoplay": a.proxy(function () {
        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
      }, this),
      "touchstart.owl.core": a.proxy(function () {
        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
      }, this),
      "touchend.owl.core": a.proxy(function () {
        this._core.settings.autoplayHoverPause && this.play();
      }, this)
    }, this._core.$element.on(this._handlers), this._core.options = a.extend({}, e.Defaults, this._core.options);
  };

  e.Defaults = {
    autoplay: !1,
    autoplayTimeout: 5e3,
    autoplayHoverPause: !1,
    autoplaySpeed: !1
  }, e.prototype.play = function (a, b) {
    this._paused = !1, this._core.is("rotating") || (this._core.enter("rotating"), this._setAutoPlayInterval());
  }, e.prototype._getNextTimeout = function (d, e) {
    return this._timeout && b.clearTimeout(this._timeout), b.setTimeout(a.proxy(function () {
      this._paused || this._core.is("busy") || this._core.is("interacting") || c.hidden || this._core.next(e || this._core.settings.autoplaySpeed);
    }, this), d || this._core.settings.autoplayTimeout);
  }, e.prototype._setAutoPlayInterval = function () {
    this._timeout = this._getNextTimeout();
  }, e.prototype.stop = function () {
    this._core.is("rotating") && (b.clearTimeout(this._timeout), this._core.leave("rotating"));
  }, e.prototype.pause = function () {
    this._core.is("rotating") && (this._paused = !0);
  }, e.prototype.destroy = function () {
    var a, b;
    this.stop();

    for (a in this._handlers) {
      this._core.$element.off(a, this._handlers[a]);
    }

    for (b in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[b] && (this[b] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.autoplay = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  "use strict";

  var e = function e(b) {
    this._core = b, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
      next: this._core.next,
      prev: this._core.prev,
      to: this._core.to
    }, this._handlers = {
      "prepared.owl.carousel": a.proxy(function (b) {
        b.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
      }, this),
      "added.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 0, this._templates.pop());
      }, this),
      "remove.owl.carousel": a.proxy(function (a) {
        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1);
      }, this),
      "changed.owl.carousel": a.proxy(function (a) {
        a.namespace && "position" == a.property.name && this.draw();
      }, this),
      "initialized.owl.carousel": a.proxy(function (a) {
        a.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"));
      }, this),
      "refreshed.owl.carousel": a.proxy(function (a) {
        a.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
      }, this)
    }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers);
  };

  e.Defaults = {
    nav: !1,
    navText: ["prev", "next"],
    navSpeed: !1,
    navElement: "div",
    navContainer: !1,
    navContainerClass: "owl-nav",
    navClass: ["owl-prev", "owl-next"],
    slideBy: 1,
    dotClass: "owl-dot",
    dotsClass: "owl-dots",
    dots: !0,
    dotsEach: !1,
    dotsData: !1,
    dotsSpeed: !1,
    dotsContainer: !1
  }, e.prototype.initialize = function () {
    var b,
        c = this._core.settings;
    this._controls.$relative = (c.navContainer ? a(c.navContainer) : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = a("<" + c.navElement + ">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click", a.proxy(function (a) {
      this.prev(c.navSpeed);
    }, this)), this._controls.$next = a("<" + c.navElement + ">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click", a.proxy(function (a) {
      this.next(c.navSpeed);
    }, this)), c.dotsData || (this._templates = [a("<div>").addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]), this._controls.$absolute = (c.dotsContainer ? a(c.dotsContainer) : a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "div", a.proxy(function (b) {
      var d = a(b.target).parent().is(this._controls.$absolute) ? a(b.target).index() : a(b.target).parent().index();
      b.preventDefault(), this.to(d, c.dotsSpeed);
    }, this));

    for (b in this._overrides) {
      this._core[b] = a.proxy(this[b], this);
    }
  }, e.prototype.destroy = function () {
    var a, b, c, d;

    for (a in this._handlers) {
      this.$element.off(a, this._handlers[a]);
    }

    for (b in this._controls) {
      this._controls[b].remove();
    }

    for (d in this.overides) {
      this._core[d] = this._overrides[d];
    }

    for (c in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[c] && (this[c] = null);
    }
  }, e.prototype.update = function () {
    var a,
        b,
        c,
        d = this._core.clones().length / 2,
        e = d + this._core.items().length,
        f = this._core.maximum(!0),
        g = this._core.settings,
        h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;

    if ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || "page" == g.slideBy) for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
      if (b >= h || 0 === b) {
        if (this._pages.push({
          start: Math.min(f, a - d),
          end: a - d + h - 1
        }), Math.min(f, a - d) === f) break;
        b = 0, ++c;
      }

      b += this._core.mergers(this._core.relative(a));
    }
  }, e.prototype.draw = function () {
    var b,
        c = this._core.settings,
        d = this._core.items().length <= c.items,
        e = this._core.relative(this._core.current()),
        f = c.loop || c.rewind;

    this._controls.$relative.toggleClass("disabled", !c.nav || d), c.nav && (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !c.dots || d), c.dots && (b = this._pages.length - this._controls.$absolute.children().length, c.dotsData && 0 !== b ? this._controls.$absolute.html(this._templates.join("")) : b > 0 ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0])) : b < 0 && this._controls.$absolute.children().slice(b).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass("active"));
  }, e.prototype.onTrigger = function (b) {
    var c = this._core.settings;
    b.page = {
      index: a.inArray(this.current(), this._pages),
      count: this._pages.length,
      size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items)
    };
  }, e.prototype.current = function () {
    var b = this._core.relative(this._core.current());

    return a.grep(this._pages, a.proxy(function (a, c) {
      return a.start <= b && a.end >= b;
    }, this)).pop();
  }, e.prototype.getPosition = function (b) {
    var c,
        d,
        e = this._core.settings;
    return "page" == e.slideBy ? (c = a.inArray(this.current(), this._pages), d = this._pages.length, b ? ++c : --c, c = this._pages[(c % d + d) % d].start) : (c = this._core.relative(this._core.current()), d = this._core.items().length, b ? c += e.slideBy : c -= e.slideBy), c;
  }, e.prototype.next = function (b) {
    a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
  }, e.prototype.prev = function (b) {
    a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
  }, e.prototype.to = function (b, c, d) {
    var e;
    !d && this._pages.length ? (e = this._pages.length, a.proxy(this._overrides.to, this._core)(this._pages[(b % e + e) % e].start, c)) : a.proxy(this._overrides.to, this._core)(b, c);
  }, a.fn.owlCarousel.Constructor.Plugins.Navigation = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  "use strict";

  var e = function e(c) {
    this._core = c, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
      "initialized.owl.carousel": a.proxy(function (c) {
        c.namespace && "URLHash" === this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation");
      }, this),
      "prepared.owl.carousel": a.proxy(function (b) {
        if (b.namespace) {
          var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
          if (!c) return;
          this._hashes[c] = b.content;
        }
      }, this),
      "changed.owl.carousel": a.proxy(function (c) {
        if (c.namespace && "position" === c.property.name) {
          var d = this._core.items(this._core.relative(this._core.current())),
              e = a.map(this._hashes, function (a, b) {
            return a === d ? b : null;
          }).join();

          if (!e || b.location.hash.slice(1) === e) return;
          b.location.hash = e;
        }
      }, this)
    }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers), a(b).on("hashchange.owl.navigation", a.proxy(function (a) {
      var c = b.location.hash.substring(1),
          e = this._core.$stage.children(),
          f = this._hashes[c] && e.index(this._hashes[c]);

      f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0);
    }, this));
  };

  e.Defaults = {
    URLhashListener: !1
  }, e.prototype.destroy = function () {
    var c, d;
    a(b).off("hashchange.owl.navigation");

    for (c in this._handlers) {
      this._core.$element.off(c, this._handlers[c]);
    }

    for (d in Object.getOwnPropertyNames(this)) {
      "function" != typeof this[d] && (this[d] = null);
    }
  }, a.fn.owlCarousel.Constructor.Plugins.Hash = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  function e(b, c) {
    var e = !1,
        f = b.charAt(0).toUpperCase() + b.slice(1);
    return a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
      if (g[b] !== d) return e = !c || b, !1;
    }), e;
  }

  function f(a) {
    return e(a, !0);
  }

  var g = a("<support>").get(0).style,
      h = "Webkit Moz O ms".split(" "),
      i = {
    transition: {
      end: {
        WebkitTransition: "webkitTransitionEnd",
        MozTransition: "transitionend",
        OTransition: "oTransitionEnd",
        transition: "transitionend"
      }
    },
    animation: {
      end: {
        WebkitAnimation: "webkitAnimationEnd",
        MozAnimation: "animationend",
        OAnimation: "oAnimationEnd",
        animation: "animationend"
      }
    }
  },
      j = {
    csstransforms: function csstransforms() {
      return !!e("transform");
    },
    csstransforms3d: function csstransforms3d() {
      return !!e("perspective");
    },
    csstransitions: function csstransitions() {
      return !!e("transition");
    },
    cssanimations: function cssanimations() {
      return !!e("animation");
    }
  };
  j.csstransitions() && (a.support.transition = new String(f("transition")), a.support.transition.end = i.transition.end[a.support.transition]), j.cssanimations() && (a.support.animation = new String(f("animation")), a.support.animation.end = i.animation.end[a.support.animation]), j.csstransforms() && (a.support.transform = new String(f("transform")), a.support.transform3d = j.csstransforms3d());
}(window.Zepto || window.jQuery, window, document);
"use strict";

var now = timer.split(":");
var hours = now[0];
var minutes = now[1];
var seconds = now[2];

Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

Date.prototype.isDstObserved = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};

var today = new Date();

if (!today.isDstObserved()) {
  hours++;
}

var $time = $(".time-now");

if ($time.length > 0) {
  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get todays date and time
    seconds++; //console.log('Seconds :: ', seconds);

    if (seconds === 60) {
      seconds = 0;
      minutes++;
    }

    if (minutes === 60) {
      minutes = 0;
      hours++;
    }

    if (hours === 24) hours = 0; // Display Time

    $time.text(formatTimeString(parseInt(hours)) + ":" + formatTimeString(parseInt(minutes)) + ":" + formatTimeString(parseInt(seconds)));
  }, 1000);
}

function formatTimeString(n) {
  return n < 10 ? '0' + n : n;
}
"use strict";

$.fn.datepicker.dates['fr'] = {
  days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
  daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  daysMin: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
  today: "Aujourd'hui",
  clear: "Effacer",
  format: "dd/mm/yyyy",
  titleFormat: "MM yyyy",

  /* Leverages same syntax as 'format' */
  weekStart: 0
};
$.fn.datepicker.dates['en'] = {
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  daysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  today: "Today",
  clear: "Clear",
  format: "mm/dd/yyyy",
  titleFormat: "MM yyyy",

  /* Leverages same syntax as 'format' */
  weekStart: 0
}; //- Materialize Init

$('select').material_select(); //- Dropdowns

$('.dropdown-button').dropdown(); // Modals

$('.modal').modal(); // Mobile Filters menu

$('#mobile_modal--filters').modal({
  inDuration: 300,
  outDuration: 200,
  // Transition out duration
  startingTop: 0,
  endingTop: 0
}); // Work Btns Modal

$('#job-modal').modal();
var workBtns = $('.std_gi--container-body .collapsible-body button');
workBtns.each(function () {
  var btn = this;

  btn.onclick = function () {
    $('#job-modal').modal('open');
  };
}); //- STD single Collapsable

$('.std_single--collaps').collapsible();
$('.std_single--beds-item').matchHeight({
  byRow: false
}); //$('.std_card--details .std_card--desc').matchHeight();

$('.about_activity--slider_inner .std_activity--preview').matchHeight();
$('.chalets_list--inner .std_card--fullwidth').matchHeight();
$('.std_activity--card .history-card').matchHeight(); //$('.home_chalet--slider_inner .std_card--details').matchHeight();

$('.activity-container.std_card--fullwidth .std_card--details').matchHeight({
  'byRow': false
}); // STD GI Collapsable

$('.std_gi--collaps').collapsible(); // Misc date select

$('input.form-date').datepicker({
  maxViewMode: 0,
  format: 'yyyy-mm-dd',
  startDate: new Date(),
  language: locale,
  multidate: false
}).on('changeDate', function (e) {
  $(e.target).datepicker('hide');
}); // Dev Only
//$('#mobile_modal--filters').modal('open');
// Mobile Filters Modal

var mobFiltersBtnO = $('.mob_filters--modal-o');
var mobFiltersBtnC = $('.mob_filters--modal-c');

if (mobFiltersBtnO.length) {
  mobFiltersBtnO.each(function () {
    var btn = this;

    btn.onclick = function () {
      $('#mobile_modal--filters').modal('open');
    };
  });
}

if (mobFiltersBtnC.length) {
  mobFiltersBtnC.each(function () {
    var btn = this;

    btn.onclick = function () {
      $('#mobile_modal--filters').modal('close');
      setTimeout(function () {
        $('.close-nav').trigger('click');
      }, 1);
    };
  });
} //- Main Footer


var mainFooter = $('.main_footer');
var footerPars = mainFooter.find('.mob_par--btn');
$(".questions-cond .options-cond").change(function (e) {
  var value = $(e.target).val();
  var $questions = $(e.target).closest(".questions-cond").find('.fields-cond');
  var visible = value == 'y';
  $questions.css('display', visible ? 'block' : 'none');
  $questions.find('.required-field').prop('required', visible);
});

function updateFooter() {
  if (footerPars.length) {
    footerPars.each(function () {
      var par = this;

      par.onclick = function (e) {
        e.preventDefault();
        var p = e.currentTarget;

        if (p.nodeName.toUpperCase() === 'A') {
          // Open Footer nav
          var nextsChilds = $(p).nextUntil('.main_footer--sub-title-1');
          nextsChilds.each(function () {
            var subLink = this;

            if (subLink.style.display === '') {
              p.classList.add('mob_par--btn-opened');
              subLink.style.display = 'block';
              setTimeout(function () {
                subLink.style.opacity = 1;
              }, 10);
            } else {
              p.classList.remove('mob_par--btn-opened');
              subLink.style.opacity = 0;
              setTimeout(function () {
                subLink.style.display = '';
              }, 300);
            }
          });
        }
      };
    });
  }
}

if ($(window).outerWidth() < 808) {
  updateFooter();
}

$('.home_events--slider_inner').owlCarousel({
  loop: false,
  nav: false,
  margin: 18,
  smartSpeed: 500,
  responsive: {
    0: {
      items: 1,
      margin: 6
    },
    750: {
      items: 2
    },
    1032: {
      items: 3
    },
    1290: {
      items: 3
    }
  }
}); // Fix resize probs

window.addEventListener('resize', function () {
  if (768 < window.innerWidth) {
    var parLinks = $(mainFooter).find('.main_footer--sub-title-1');
    var subLinks = $(mainFooter).find('.main_footer--sub-title-2');
    parLinks.each(function () {
      this.style.display = '';
      this.style.opacity = '';
    });
    subLinks.each(function () {
      this.style.display = '';
      this.style.opacity = '';
    });
  }

  if ($(window).outerWidth() < 808) {
    updateFooter();
  }
});

function GetSelectedArray(startDate, endDate) {
  var dateArray = [];
  var currentDate = moment(startDate.split('/').reverse().join('/'));
  var stopDate = moment(endDate.split('/').reverse().join('/'));

  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).format('DD/MM/YYYY'));
    currentDate = moment(currentDate).add(1, 'days');
  }

  return dateArray;
}

function checkForDisabled(array1, array2) {
  var test = false;

  for (var i = 0; i < array1.length; i++) {
    if (array2.indexOf(array1[i]) !== -1) {
      test = true;
      break;
    }
  }

  return test;
} //- Std Chalet res btn


var conBtn = $('.activity_single--contact-mob-btn')[0];

function conModalFunc() {
  if (conBtn) {
    if (window.innerWidth <= 808) {
      $('.activity_single--contact').addClass('as_modal').addClass('modal');
      $('.activity_single--contact').modal({
        inDuration: 300,
        // Transition in duration
        outDuration: 200,
        // Transition out duration
        startingTop: '4%',
        // Starting top style attribute
        endingTop: '10%' // Ending top style attribute

      });
      $('.activity_single--contact').modal('open');
    } else {
      $('.activity_single--contact').removeClass('as_modal').removeClass('modale');
      $('.activity_single--contact').trigger('destroy.owl.carousel');
    }
  }
}

if (conBtn) {
  conBtn.onclick = function () {
    conModalFunc();
  };
} //- STD Wiz


var wizs = $('.std_wiz--container');
wizs.each(function () {
  // fix Table on mobile
  if (window.innerWidth < 808) {
    var tables = $(this).find('table');
    tables.each(function () {
      var t = this;
      var p = t.parentNode;
      var newT = document.createElement('DIV');
      var newTC = t.cloneNode(true);
      newT.appendChild(newTC);
      newT.style.overflowX = 'auto';
      p.insertBefore(newT, t);
      p.removeChild(t);
    });
  }
});

if (/Edge/.test(navigator.userAgent)) {
  $('body').css('overflow-x', 'hidden');
}

var daysOfWeek = [];
var monthNames = [];
daysOfWeek['fr'] = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
daysOfWeek['en'] = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
monthNames['fr'] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
monthNames['en'] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function zeroPad(num, places) {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

function transformDate(da) {
  var year = da.getFullYear();
  var month = zeroPad(da.getMonth() + 1, 2);
  var day = zeroPad(da.getDate(), 2);
  return day + '/' + month + '/' + year;
}

var paramsToQuery = function paramsToQuery(params, optParams) {
  var q = '';
  var qParams = {};

  for (var k in params) {
    qParams[k] = params[k];
  }

  if (optParams) for (var l in optParams) {
    qParams[l] = optParams[l];
  }
  var keys = Object.keys(qParams);

  if (keys.length > 0) {
    var args = [];

    for (var i = 0; i < keys.length; i++) {
      if (qParams[keys[i]]) {
        args.push(keys[i] + '=' + qParams[keys[i]]);
      }
    }

    if (args.length > 0) {
      q = "?" + args.join('&');
    }
  }

  return q;
};
"use strict";
"use strict";

// Single STD Datepicker range
var chFI = '';
var chTI = '';
var reservitBaseUrl = $('.chalet_calendar--link').attr('href');
var spanUnderBtnText = $('.over-btn').first().text();
var min_capacity = parseInt($("#min_capacity").val());
var max_capacity = parseInt($("#max_capacity").val());
var nbr_children = 0;
var nbr_adulte = min_capacity;
var globalDateChanged = false;
var globalDateInited = false;
var globalBeginDate = "";
var globalEndDate = "";
/*let disabledDays = (disabledDays) ? JSON.parse(disabledDays) : [];
let datepicker = $('#datepicker').datepicker({
  language: locale,
  format: 'dd/mm/yyyy',
  datesDisabled: disabledDays,
  SingleDatePicker: true,
  startDate: new Date(),
  dateRange: true,
});
$('#datepicker').on('changeDate', function () {
  $('#datepicker-hidden').val(
    $('#datepicker').datepicker('getFormattedDate')
  );
});*/
//- Std Chalet res btn

var resBtn = $('.mobile-calendar .chalet_single--calender-mob-btn');
var modal_calendar = $('.mobile-calendar .chalet_single--calender');

function resModalFunc() {
  if (resBtn) {
    if (window.innerWidth <= 808) {
      modal_calendar.addClass('as_modal').addClass('modal');
      modal_calendar.modal({
        inDuration: 300,
        // Transition in duration
        outDuration: 200,
        // Transition out duration
        startingTop: '4%',
        // Starting top style attribute
        endingTop: '20%' // Ending top style attribute

      });
      modal_calendar.modal('open');
    } else {
      modal_calendar.removeClass('as_modal').removeClass('modal').removeAttr('style');
      modal_calendar.trigger('destroy.owl.carousel');
    }
  }
}

resBtn.on('click', function () {
  resModalFunc();
});
$(window).on('resize', function () {
  if (window.innerWidth > 808) {
    modal_calendar.removeClass('as_modal').removeClass('modal').removeAttr('style');
    modal_calendar.trigger('destroy.owl.carousel');
  }
});
var linkC = $('.chalet_calendar--link');
var textBestPrice = $('.over-btn');
var linkCTextAvaiable = linkC.attr('data-btn-text-avaiable');
var linkCTextUnavaiable = linkC.attr('data-btn-text-unavaiable');

function nextRequestForDispo(i) {
  return moment().startOf('day').add(89 * i, 'day');
}

function refreshCalendar(calendar) {
  var allClasses = [];
  var allElements = document.querySelectorAll('.' + calendar + ' *');

  for (var i = 0; i < allElements.length; i++) {
    var classes;
    var titles = [];

    if (typeof allElements[i].dataset.title != "undefined") {
      classes = allElements[i].className.toString();
      titles += allElements[i].dataset.title.toString();
    } else {
      titles += '--';
    }

    if (typeof classes != "undefined") {
      if (classes.includes("available")) classes = "available";else classes = "disabled";
    }

    if (titles != "--") allClasses.push(classes + ',' + titles);
  }

  for (var j = 1; j < allClasses.length; j++) {
    if (j + 1 < allClasses.length) {
      //console.log("j-1 " + allClasses[j - 1], "j " + allClasses[j], "j+1 " + allClasses[j + 1]);
      //console.log("j-1 " + allClasses[j - 1].includes("disabled"), "j " + allClasses[j].includes("available"), "j+1 " + allClasses[j + 1].includes("disabled"));
      if (allClasses[j - 1].includes("disabled") && allClasses[j].includes("available") && allClasses[j + 1].includes("disabled")) {
        var cell = allClasses[j].split(",", 2);
        $('[data-title=' + cell[1] + ']').addClass('full-disable disabled');
      } else if (allClasses[j - 1].includes("disabled") && allClasses[j].includes("available")) {
        cell = allClasses[j].split(",", 2);
        $('[data-title=' + cell[1] + ']').addClass('end-date-disable');
      } else if (allClasses[j + 1].includes("disabled") && allClasses[j].includes("available")) {
        cell = allClasses[j].split(",", 2);
        $('[data-title=' + cell[1] + ']').addClass('start-date-disable');
      }
    }
  }
}

function disableCalendarLink() {
  $('.chalet_calendar--link').css({
    "opacity": "0.5",
    "pointer-events": "none",
    "cursor": "default"
  }).html(linkCTextUnavaiable + '<div class="lds-dual-ring"></div>');
}

function checkCapacity(chFI, chTI) {
  linkC.removeAttr('style').toggleClass('loading', false);
  var capacity = '40,';

  if (nbr_adulte) {
    if (nbr_adulte < min_capacity) {
      $('.all_nbr').addClass("error");
      disableCalendarLink();
    } else if (nbr_adulte + nbr_children > max_capacity) {
      $('.all_nbr').addClass("error");
      disableCalendarLink();
    } else if (nbr_adulte > max_capacity) {
      $('.children_error').addClass("error");
      disableCalendarLink();
    } else {
      $('.all_nbr').removeClass("error");

      if (chFI && chTI) {
        for (var i = 1; i < nbr_adulte; i++) {
          capacity += '40,';
        }

        if (nbr_children) {
          for (var j = 0; j < nbr_children; j++) {
            capacity += '10,';
          }
        }

        $('.chalet_calendar--link').removeAttr("style");
      } else {
        disableCalendarLink();
      }
    }
  } else {
    $('.adult_nbr').addClass("error");
    disableCalendarLink();
  }
}

function updateLinkC() {
  var mewsRoomID = $(".chalet_single--calender").eq(0).attr("data-mews-room-id");
  var chFI, chTI, days, start, end;

  if (globalBeginDate && globalEndDate) {
    start = moment(globalBeginDate);
    end = moment(globalEndDate);
    chFI = start.format('DD/MM/YYYY').split("/");
    chTI = end.format('DD/MM/YYYY').split("/");
    days = end.diff(start, 'days');
  }

  if (!start || !end) {
    disableCalendarLink();
    linkC.unbind('click');
    $('.over-btn').text(spanUnderBtnText).removeAttr('style');
  } else if (days < parseInt(minimum_nights)) {
    disableCalendarLink();
    linkC.toggleClass('loading', false).unbind('click');
    $('.over-btn').text(locale == 'fr' ? 'Vous devez sélectionner au moins ' + minimum_nights + ' nuitées consécutives.' : 'You must select at least ' + minimum_nights + ' consecutive nights.').css('color', '#dc2242');
  } else {
    if (globalDateInited && globalDateChanged) {
      globalDateChanged = false;
      disableCalendarLink();
      linkC.toggleClass('loading', true).unbind('click');
      $('.over-btn .best-price').remove();
      $('.over-btn .txt-available').remove();
      $.ajax({
        type: "POST",
        url: '/index.php?p=actions/acbr/reservation/check-availability',
        data: {
          from: start.format('DD/MM/YYYY'),
          to: end.format('DD/MM/YYYY'),
          roomId: mewsRoomID
        },
        dataType: 'json',
        success: function success(data) {
          if (data && !data.isAvailable) {
            var textError = linkC.attr('data-error-text');
            console.log(textError);
            disableCalendarLink();
            linkC.toggleClass('loading', false).unbind('click');
            $('.over-btn').toggleClass('available', false).toggleClass('unavailable', true);
            $('.over-btn .txt-available').remove();
            $('.over-btn').prepend('<span class="txt-available">' + textError + '</span>').css('color', '#dc2242');
          } else {
            var textSuccess = linkC.attr('data-success-text');
            $('.over-btn').toggleClass('available', true).toggleClass('unavailable', false);
            $('.over-btn').removeAttr('style').prepend('<span class="txt-available">' + textSuccess + '</span>');
            checkCapacity(chFI, chTI);
          }
        },
        error: function error(e) {
          console.error('error fetch avaiability', e);
        }
      });

      if (mewsRoomID) {
        $.ajax({
          type: "POST",
          url: '/index.php?p=actions/acbr/reservation/check-best-price',
          data: {
            from: start.format('DD/MM/YYYY'),
            to: end.format('DD/MM/YYYY'),
            roomId: mewsRoomID,
            pers: nbr_adulte,
            nbr_adulte: nbr_adulte,
            nbr_children: nbr_children
          },
          dataType: 'json',
          success: function success(data) {
            var price = parseFloat(data.bestPrice);

            if (price) {
              price = price.toFixed(2);
              var textBefore = textBestPrice.attr('data-text-before');
              $('.over-btn').append('<span class="best-price">' + textBefore + ' ' + price + '$' + '</span>');
            }
          },
          error: function error(e) {
            console.error('error fetch best price', e);
          }
        });
      }
    } else {
      checkCapacity(chFI, chTI);
    }
  }

  window.dispatchEvent(new Event("updateLinkC"));
} // END - updateLinkC


function buildCalenndar() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : start;
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : end;

  if ($('.reservation-range .daterangepicker').length) {
    $('.reservation-range .input-daterange').datepicker({
      maxViewMode: 0,
      // inputs: $('input.date-start, input.date-end'),
      format: 'yyyy-mm-dd',
      language: locale,
      multidate: false,
      startDate: new Date()
    }).on('changeDate', function (e) {
      var isDateFrom = $(e.target).closest('input').hasClass("date-start");
      var beginDate = $(e.target).closest(".daterangepicker").find('.date-start').datepicker('getDate');
      var endDate = $(e.target).closest(".daterangepicker").find('.date-end').datepicker('getDate'); // globalDateChanged = true;

      if (globalBeginDate != beginDate) {
        globalBeginDate = beginDate;
        globalDateChanged = true;
      }

      if (isDateFrom) {
        globalEndDate = null;
        $(e.target).datepicker('hide');
        var pickerEnd = $(e.target).closest(".daterangepicker").find(".date-end");
        pickerEnd.datepicker('setStartDate', e.date);
        pickerEnd.datepicker('setDate', null);

        if (window.innerWidth >= 808) {
          pickerEnd.datepicker('show');
        }
      } else if (globalEndDate != endDate) {
        globalEndDate = endDate;
        globalDateChanged = true;
      }

      if (!isDateFrom) {
        $(e.target).datepicker('hide');
      }

      if (globalDateChanged) {
        updateLinkC();
      }
    });
    setTimeout(function () {
      var dateSearchFrom = window.sessionStorage.getItem('date_from');
      var dateSearchTo = window.sessionStorage.getItem('date_to');
      var persSearch = window.sessionStorage.getItem('pers');

      if (dateSearchFrom) {
        $('.date-start').datepicker('setDate', dateSearchFrom);
      }

      if (dateSearchTo) {
        $('.date-end').datepicker('setDate', dateSearchTo);
      }

      if (persSearch) {
        $('input[name="adult_nbr"]').val(persSearch);
        nbr_adulte = parseInt(persSearch);
      }

      globalDateInited = true;
      updateLinkC();
    }, 150);
    updateLinkC();
  }
}

buildCalenndar();
/*if ($(window).outerWidth() < 808) {
  refreshCalendar('mobile-calendar');
}
else {
  refreshCalendar('desktop-calendar');
}
$('.chalet_single--calender').on('click', '.next.available', function (e) {
  e.preventDefault();
});

function findActiveValues() {
  setTimeout(function () {
    if ($('.calendar-table td.in-range').length == 0) {
      linkC.css({
        'opacity': '0.5',
        'pointer-events': 'none',
        'cursor': 'default'
      }).unbind('click');
    }
    if ($(window).outerWidth() < 808) {
      refreshCalendar('mobile-calendar');
    }
    else {
      refreshCalendar('desktop-calendar');
    }
  }, 1);
}*/

$('.change_adult').on('input', function () {
  nbr_adulte = parseInt($(this).val());
  updateLinkC();
});
$('.change_children').on('input', function () {
  nbr_children = parseInt($(this).val());
  updateLinkC();
});
setInterval(function () {
  // return false;
  var behaviour_class = "JS_SYNC_LINK_FIELD";
  $(".chalet_single--calender:not(." + behaviour_class + ")").each(function () {
    var self = this;
    var $self = $(self);
    $self.addClass(behaviour_class);
    var mewsHotelID = "10859ef3-19d0-4c9e-b7a9-b1e6004fe149";
    var mewsRoomID = $self.attr("data-mews-room-id");

    var update = function update() {
      var $link = $self.find("a.chalet_calendar--link");
      $link.attr("href", "https://app.mews.com/distributor/".concat(mewsHotelID, "?mewsStart=").concat(moment(globalBeginDate).format('YYYY-MM-DD'), "&mewsEnd=").concat(moment(globalEndDate).format('YYYY-MM-DD'), "&mewsRoom=").concat(mewsRoomID, "&mewsRoute=rates&mewsAdultCount=").concat(nbr_adulte, "&mewsChildCount=").concat(nbr_children));
    };

    update();
    window.addEventListener("updateLinkC", update);
  });
}, 2000);
"use strict";

//- Filters
// Large Filter
var lFilters = $('.std_filters');
var calTypeI;

if (lFilters.length) {
  //...
  //console.log(dI, dO, pN, oP, bT);
  //console.log(oP);
  // Close all panels
  var closeAllPanels = function closeAllPanels() {
    var panels = $(lFilters).find('.std_filter--panel');
    panels.each(function () {
      var p = this;
      p.opacity = '';
      p.style.display = ''; //...

      if (p.classList.contains('std_filter--calender')) {
        var _calP = $('.std_filter--calender')[0];
        var _calPF = $(_calP).find('.from_date')[0];
        var _calPT = $(_calP).find('.to_date')[0]; //...

        var inDI = $('.std_filters--input-di');
        var inDO = $('.std_filters--input-do');
        var iHol = $(inDI).find('.std_filters--input--pholder')[0];
        var iArr = $(inDI).find('.std_filters--input--arrow')[0];
        var oHol = $(inDO).find('.std_filters--input--pholder')[0];
        var oArr = $(inDO).find('.std_filters--input--arrow')[0]; //...

        inDI[0].style.background = '#FFF';
        inDO[0].style.background = '#FFF'; //...

        iHol.style.background = '';
        iArr.style.transform = '';
        oHol.style.background = '';
        oArr.style.transform = ''; //...

        _calPF.style.opacity = 0;
        _calPF.style.display = '';
        _calPT.style.opacity = 0;
        _calPT.style.display = '';
      }

      if (p.classList.contains('std_filter--pers')) {
        var opC = $(lFilters).find('.std_filters--input-pn')[0];
        var pHol = $(opC).find('.std_filters--input--pholder')[0];
        var pArr = $(opC).find('.std_filters--input--arrow')[0];
        opC.style.background = '#FFF';
        pHol.style.background = '';
        pArr.style.transform = '';
      }

      if (p.classList.contains('std_filter--options')) {
        oP.style.background = '#FFF';
      }
    });
  }; // Date picker From


  var dI = $(lFilters).find('.std_filters--input-di')[0];
  var dO = $(lFilters).find('.std_filters--input-do')[0];
  var pN = $(lFilters).find('.std_filters--input-pn')[0];
  var oP = $(lFilters).find('.std_filters--options')[0];
  var bT = $(lFilters).find('.std_filters--btn')[0];
  var calP = $('.std_filter--calender')[0];
  var calPF = $(calP).find('.from_date')[0];
  var calPT = $(calP).find('.to_date')[0];

  dI.onclick = function () {
    // Set Type
    calTypeI = false; //...

    var pHol = $(dI).find('.std_filters--input--pholder')[0];
    var arr = $(dI).find('.std_filters--input--arrow')[0];

    if (calPF.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      calPF.style.opacity = 0;
      arr.style.transform = '';
      setTimeout(function () {
        //dI.style.background = '';
        pHol.style.background = ''; //...

        calPF.style.display = '';
      }, 200);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      calPF.style.display = 'block';
      arr.style.transform = 'rotate(180deg)';
      setTimeout(function () {
        dI.style.background = '#F5F6F5';
        pHol.style.background = '#F5F6F5'; //...

        calPF.style.opacity = 1;
      }, 10);
    }
  }; // Date picker To


  dO.onclick = function () {
    // Set Type
    calTypeI = true; //...

    var pHol = $(dO).find('.std_filters--input--pholder')[0];
    var arr = $(dO).find('.std_filters--input--arrow')[0];

    if (calPT.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      calPT.style.opacity = 0;
      arr.style.transform = '';
      setTimeout(function () {
        //dO.style.background = '';
        pHol.style.background = ''; //...

        calPT.style.display = '';
      }, 200);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      calPT.style.display = 'block';
      arr.style.transform = 'rotate(180deg)';
      setTimeout(function () {
        dO.style.background = '#F5F6F5';
        pHol.style.background = '#F5F6F5'; //...

        calPT.style.opacity = 1;
      }, 10);
    }
  }; // Pers. Btn


  pN.onclick = function () {
    var opC = $(lFilters).find('.std_filter--pers')[0];
    var pArr = $(pN).find('.std_filters--input--arrow')[0];
    var pHol = $(pN).find('.std_filters--input--pholder')[0];

    if (opC.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      opC.style.opacity = '';
      setTimeout(function () {
        pN.style.background = '#FFF';
        pArr.style.transform = '';
        pHol.style.background = '';
        opC.style.display = '';
      }, 100);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      opC.style.display = 'block';
      setTimeout(function () {
        pN.style.background = '#F5F6F5';
        pArr.style.transform = 'rotate(180deg)';
        pHol.style.background = '#F5F6F5';
        opC.style.opacity = 1;
      }, 10);
    }
  }; // Options Btn


  oP.onclick = function () {
    var opC = $(lFilters).find('.std_filter--options')[0];

    if (opC.style.display === 'block') {
      $('.std_filters--inner').removeClass('shadow');
      opC.style.opacity = '';
      setTimeout(function () {
        oP.style.background = '';
        opC.style.display = '';
      }, 100);
    } else {
      closeAllPanels();
      $('.std_filters--inner').addClass('shadow');
      opC.style.display = 'block';
      setTimeout(function () {
        oP.style.background = '#F5F6F5';
        opC.style.opacity = 1;
      }, 10);
    }
  }; //- Inc Filters Btns


  var incFBtns = $(lFilters).find('.std_filter--inc-btn');
  incFBtns.each(function () {
    var incC = this;
    var incT = incC.getAttribute('data-filter'); //...

    var input = $(incC).find('.std_filter--inc-input')[0];
    var rem = $(incC).find('.std_filter--rem-btn')[0];
    var add = $(incC).find('.std_filter--add-btn')[0];
    var val = $(incC).find('.std_filter--inc-val')[0]; // Handle Nums

    function incInc(i) {
      // Get Filter placeholder
      var pHolI = $('[data-filter="' + incT + '-pholder"]')[0];
      var pT = $(pHolI).find('.std_filters--input--title')[0];
      var pV = $(pHolI).find('.std_filters--input--value')[0];
      var pH = $(pHolI).find('.std_filters--input--pholder')[0];

      if (i && pHolI) {
        pH.style.display = 'none';
      } //...


      var value = parseInt(val.innerHTML);
      var newVal = value + i;

      if (newVal <= 1) {
        newVal = 1;
        rem.style.opacity = 0.4;
      } else rem.style.opacity = '';

      val.innerHTML = newVal;
      input.value = newVal;

      if (i) {
        // Set pHolder
        var pVO = pV.innerHTML;
        var pVOC = pVO.split(' ');
        pV.innerHTML = newVal + ' ' + pVOC[1];
      }
    }

    rem.onclick = function () {
      incInc(-1);
    };

    add.onclick = function () {
      incInc(1);
    }; // Init


    incInc(0);
  }); // Items N

  var setChaletNumber = function setChaletNumber() {
    setTimeout(function () {
      // Chalets
      var disChalets = 0;
      $('.chalets_list--container a.std_card--fullwidth').each(function () {
        if (!this.style.display) disChalets += 1;
      });
      $('.chalets_list--cnt_n').text(disChalets); // Chambres

      var disChambres = 0;
      $('.chambres_list--container a.std_card--fullwidth').each(function () {
        if (!this.style.display) disChambres += 1;
      });
      $('.chambres_list--cnt_n').text(disChambres);
    }, 300);
  }; //filter capaciy


  $('.add-pers').on('click', function () {
    var capacity = $('input[name=pers]').val();
    $('a.std_card--fullwidth').filter(function () {
      if (parseInt($(this).attr("data-capacity"), 10) < parseInt(capacity, 10)) $(this).hide();
    }); //...

    setChaletNumber();
  });
  $('.rem-pers').on('click', function () {
    var capacity = $('input[name=pers]').val();
    $('a.std_card--fullwidth').filter(function () {
      if (parseInt($(this).attr("data-capacity"), 10) >= parseInt(capacity, 10)) $(this).show();
    }); //...

    setChaletNumber();
  }); // Filter bathrooms

  $('.add-baths').on('click', function () {
    var bathrooms = $('input[name=sb]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bathrooms") < bathrooms) {
        $(this).hide();
      }
    }); //...

    setChaletNumber();
  });
  $('.rem-baths').on('click', function () {
    var bathrooms = $('input[name=sb]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bathrooms") >= bathrooms) {
        $(this).show(); //...

        setChaletNumber();
      }
    }); //...

    setChaletNumber();
  }); // Filter Bedrooms

  $('.add-bedrooms').on('click', function () {
    var bedrooms = $('input[name=ch]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bedrooms") < bedrooms) {
        $(this).hide();
      }
    }); //...

    setChaletNumber();
  });
  $('.rem-bedrooms').on('click', function () {
    var bedrooms = $('input[name=ch]').val();
    $('a.std_card--fullwidth').filter(function () {
      if ($(this).attr("data-bedrooms") >= bedrooms) {
        $(this).show();
      }
    }); //...

    setChaletNumber();
  });
}

window.addEventListener('click', function (e) {
  var filPanles = $('.std_filter--panel');
  filPanles.each(function () {// TODO: Close all filters's panels if the click outside a panel
    //console.log(e.currentTarget);
  });
}, true); // Filter Tags Close

var deskFilOptions = $('.std_filters--options-bottom, .mob_filters--form-checkboxs'); // Get Selected Option

deskFilOptions.each(function () {
  var checkboxs = $('.options_bottom--checkbox, .mob_filters--form-checkbox');
  checkboxs.each(function () {
    var inp = $(this).find('input');
    inp.change(function () {
      var option = inp.attr('id');

      if (inp.is(":checked")) {
        $('div.filters_tags--title').removeAttr('style');
        $('div.filters_tag--item.' + option).removeAttr('style');
        $("a.std_card--fullwidth:not(." + option + ")").hide();
        $('.chalets_list--cnt_n').text($("a.std_card--fullwidth[style='']").length);
      } else {
        if ($('input[name="options[]"]:checked').length === 0) {
          $('div.filters_tags--title').hide();
        }

        $('.filters_tag--item_close#' + option).trigger("click");
      }

      setChaletNumber();
    });
  });
}); // Type select checkboxes

var typeSelect = $('.type_select--checkbox input'); // Get Selected Option

typeSelect.change(function () {
  var checkbox = $(this)[0];
  var value = checkbox.value;
  var checked = checkbox.checked;

  if (value == "chalets") {
    $('.chalets_list--container').css('display', checked ? 'block' : 'none');
  } else if (value == "chambres") {
    $('.chambres_list--container').css('display', checked ? 'block' : 'none');
  }
});
$('body').on('click', '.filters_tag--item_close', function (e) {
  var removed_option = $(this).attr('id');
  var pC = $(this).parent();

  if (e.currentTarget.nodeName.toUpperCase() === 'DIV') {
    pC.css('opacity', '0');
    setTimeout(function () {
      pC.hide();
      $('input.filled-in[value=' + removed_option + ']').prop('checked', false);
      var selected_options = $('input[name="options[]"]:checked');
      var selected_options_classes = '';
      selected_options.map(function () {
        selected_options_classes += '.' + this.id;
      });
      $("a.std_card--fullwidth:not(." + removed_option + ")" + selected_options_classes).show();

      if ($('input[name="options[]"]:checked').length === 0) {
        $('div.filters_tags--title').hide();
      }

      $('.chalets_list--cnt_n').text($("a.std_card--fullwidth[style='']").length);
    }, 300);
  }
});
$('.home_hero--filters .input-daterange, .std_mob--filters .input-daterange').datepicker({
  maxViewMode: 0,
  inputs: $('.from_date, .to_date'),
  format: 'yyyy-mm-dd',
  language: locale,
  multidate: false,
  startDate: new Date()
}).on('changeDate', function (e) {
  var day, month, year, dateTo, dateFrom; // disable old days
  //...

  if (calTypeI) {
    // To
    dateTo = e.date;

    if (typeof dateTo === 'undefined') {
      day = NaN;
      month = NaN;
      year = NaN;
    } else {
      day = dateTo.getDate();
      month = dateTo.getMonth();
      year = dateTo.getFullYear();
    }
  } else {
    // From
    dateFrom = e.date; // var endDate = new Date(e.date);
    // endDate.setDate(e.date.getDate() + 1);
    // console.log(e.date);
    // console.log(endDate);

    $('.to_date').datepicker('setStartDate', e.date);

    if (typeof dateFrom === 'undefined') {
      day = NaN;
      month = NaN;
      year = NaN;
    } else {
      day = dateFrom.getDate();
      month = dateFrom.getMonth();
      year = dateFrom.getFullYear();
    }
  } // Test if not valid


  if (dateTo <= dateFrom && dateFrom && dateTo) {//console.log('fuck no');
  } else {
    // * is ok
    // Populate pHolder
    var _dI = $(lFilters).find('.std_filters--input-di')[0];
    var _dO = $(lFilters).find('.std_filters--input-do')[0];
    var dIP = $(_dI).find('.std_filters--input--pholder')[0];
    var dIV = $(_dI).find('.std_filters--input--value')[0];
    var dOP = $(_dO).find('.std_filters--input--pholder')[0];
    var dOV = $(_dO).find('.std_filters--input--value')[0]; //...

    var disDate = day + ' ' + $.fn.datepicker.dates[locale].months[month];
    month = ('0' + (month + 1)).slice(-2);
    day = ('0' + day).slice(-2);
    var finDate = year + '-' + month + '-' + day; //...

    if (calTypeI) {
      // To
      if (Number.isNaN(day)) dOP.style.display = 'block';else {
        dOP.style.display = 'none';
        dOV.innerHTML = disDate; // Populate the input

        var calInpT = $('.std_filter--calender-input_t')[0];
        calInpT.value = finDate;
      }
    } else {
      // From
      if (Number.isNaN(day)) dIP.style.display = 'block';else {
        dIP.style.display = 'none';
        dIV.innerHTML = disDate; // Populate the input

        var calInpF = $('.std_filter--calender-input_f')[0];
        calInpF.value = finDate;
      }
    }
  }
});
$(".std_mob--filters form, .std_filters form").submit(function (e) {
  var $form = $(e.target);
  var from = $form.find('input[name="from"]').val();
  var to = $form.find('input[name="to"]').val();
  var pers = $form.find('input[name="pers"]').val();
  window.sessionStorage.setItem('date_from', from);
  window.sessionStorage.setItem('date_to', to);
  window.sessionStorage.setItem('pers', pers);
}); //- DatePicker

if ($('.home_hero--filters').length) {
  $('.from_date .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.std_filters--input-do').trigger('click');
    }, 20);
  });
  $('.to_date  .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.std_filters--input-pn').trigger('click');
    }, 20);
  });
} // Filter Mobile
//- Inc Filters Btns


var mobFilters = $('.std_mob--filters');
var incFBtnsMob = $(mobFilters).find('.std_filter--inc-btn-mob');
incFBtnsMob.each(function () {
  var incC = this;
  var incT = incC.getAttribute('data-filter'); //...

  var input = $(incC).find('.std_filter--inc-input')[0];
  var rem = $(incC).find('.std_filter--rem-btn')[0];
  var add = $(incC).find('.std_filter--add-btn')[0];
  var val = $(incC).find('.std_filter--inc-val')[0]; // Handle Nums

  function incInc(i) {
    // Get Filter placeholder
    var pHolI = $('[data-filter="' + incT + '-pholder"]')[0];
    var pT = $(pHolI).find('.std_filters--input--title')[0];
    var pV = $(pHolI).find('.std_filters--input--value')[0];
    var pH = $(pHolI).find('.std_filters--input--pholder')[0];

    if (i && pHolI) {
      pH.style.display = 'none';
    } //...


    var value = parseInt(val.innerHTML);
    var newVal = value + i;

    if (newVal <= 1) {
      newVal = 1;
      rem.style.opacity = 0.4;
    } else rem.style.opacity = '';

    val.innerHTML = newVal;
    input.value = newVal;

    if (i) {
      // Set pHolder
      var pVO = pV.innerHTML;
      var pVOC = pVO.split(' ');
      pV.innerHTML = newVal + ' ' + pVOC[1];
    }
  }

  rem.onclick = function () {
    incInc(-1);
  };

  add.onclick = function () {
    incInc(1);
  }; // Init


  incInc(0);
});
$('.collapsible-header').each(function () {
  if ($(this).hasClass('active')) {
    $(this).attr('data-label', $(this).attr('data-label') + " -");
  } else {
    $(this).attr('data-label', $(this).attr('data-label') + " +");
  }
});
$('.collapsible-header').on('click', function () {
  var label = $(this).attr('data-label');

  if ($(this).hasClass('active')) {
    label.slice(0, -2);
    $(this).attr('data-label', $(this).attr('data-label') + " +");
  } else {
    label.slice(0, -2);
    $(this).attr('data-label', $(this).attr('data-label') + " -");
  }
}); // Mobile Filter Calendar

var calTypeIMob;
var mobFromB = $('.mob_cal--from-f .collapsible-header')[0];

if (mobFromB) {
  mobFromB.onclick = function () {
    calTypeIMob = false;
  };
}

var mobToB = $('.mob_cal--from-t .collapsible-header')[0];

if (mobToB) {
  mobToB.onclick = function () {
    calTypeIMob = true;
  };
}

$('.input-daterange-mob').datepicker({
  maxViewMode: 0,
  inputs: $('.from_date--mob, .to_date--mob'),
  format: 'yyyy-mm-dd',
  language: locale,
  multidate: true,
  startDate: new Date()
}).on('changeDate', function (e) {
  var day, month, dateTo, dateFrom;

  if (calTypeIMob) {
    // To
    dateTo = e.date;

    if (typeof dateTo === 'undefined') {
      day = NaN;
    } else {
      day = dateTo.getDate();
    }
  } else {
    // From
    dateFrom = e.date;

    if (typeof dateFrom === 'undefined') {
      day = NaN;
    } else {
      day = dateFrom.getDate();
    }
  } // Test if not valid


  if (dateTo <= dateFrom && dateFrom && dateTo) {//console.log('fuck no');
  } else {
    // * is ok
    var mobCalForm = $('.std_mob--filters-form');

    if (calTypeIMob) {
      // To
      if (!Number.isNaN(day)) {
        var calInpF = $(mobCalForm).find('.std_filter--calender-input--mob_t')[0];
        calInpF.value = e.format();
      }
    } else {
      // From
      if (!Number.isNaN(day)) {
        var _calInpF = $(mobCalForm).find('.std_filter--calender-input--mob_f')[0];
        _calInpF.value = e.format();
      }
    }
  }
}); //- DatePicker

if ($('.std_mob--filters').length) {
  $('.from_date--mob .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.mob_cal--from-t .collapsible-header').trigger('click');
    }, 20);
  });
  $('.to_date--mob  .datepicker').on('click', '.day:not(.disabled)', function () {
    setTimeout(function () {
      $('.mob_pn .collapsible-header').trigger('click');
    }, 20);
  });
}
"use strict";

//- single Gallery
var chaGalB = $('#single_gallery--btn')[0];

if (chaGalB) {
  chaGalB.onclick = function () {
    var lightbox = new FsLightbox(); // set up props, like sources, types, events etc.

    lightbox.props.sources = fslightCollection;
    lightbox.props.showThumbsOnMount = true;
    lightbox.open();
  };
}

var chaGalB1 = $('#single_gallery--btn-1')[0];

if (chaGalB1) {
  chaGalB1.onclick = function () {
    var lightbox = new FsLightbox(); // set up props, like sources, types, events etc.

    lightbox.props.sources = fslightCollection;
    lightbox.props.showThumbsOnMount = true;
    lightbox.open();
  };
}

var chaGalB2 = $('#single_gallery--btn-2')[0];

if (chaGalB2) {
  var fslightCollection = fslightCollections3;
  var lightbox = new FsLightbox(); // set up props, like sources, types, events etc.

  lightbox.props.sources = fslightCollection;
  lightbox.props.showThumbsOnMount = true;
  lightbox.open();
}

$('.contenu_gallery--btn').click(function (e) {
  var indexCollection = $(e.target).closest('.contenu_gallery--btn').attr('data-collection-index');
  console.log(indexCollection);
  var lightbox = new FsLightbox(); // set up props, like sources, types, events etc.

  lightbox.props.sources = fslightCollections[indexCollection];
  lightbox.props.showThumbsOnMount = true;
  lightbox.open();
});
$('body').on('click', 'button[data-season=1]:not(.season-toggle)', function () {
  console.log("click season 1");
  var fslightCollection = fslightCollections["1"];
  var lightbox = new FsLightbox(); // set up props, like sources, types, events etc.

  lightbox.props.sources = fslightCollection;
  lightbox.props.showThumbsOnMount = true;
  lightbox.open();
});
$('body').on('click', 'button[data-season=2]:not(.season-toggle)', function () {
  console.log("click season 2"); // Winter gallery

  var fslightCollection = fslightCollections["2"];
  var lightbox = new FsLightbox(); // set up props, like sources, types, events etc.

  lightbox.props.sources = fslightCollection;
  lightbox.props.showThumbsOnMount = true;
  lightbox.open();
});
"use strict";

var review_select_category = $('#review-select-category');

if (review_select_category.length) {
  review_select_category.on('change', function (e) {
    selected_value = review_select_category[0].options[review_select_category[0].selectedIndex].value;

    if (selected_value == 1) {
      $('#chalets_form_gp').show();
      $('#activities_form_gp').hide();
    } else {
      $('#chalets_form_gp').hide();
      $('#activities_form_gp').show();
    }
  });
}
"use strict";

// Select all links with hashes
$('a[href*="#"]') // Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').not('[data-seasonid]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Does a scroll target exist?

    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function () {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();

        if ($target.is(":focus")) {
          // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable

          $target.focus(); // Set focus again
        }

        ;
      });
    }
  }
});
"use strict";

function newPosition(lat, _long, id, selector) {
  var icon = 'Pin.svg';

  if (carte_type == "roadmap") {
    icon = 'Pin-vert.svg';
  }

  var obj = new Object();
  obj.latitude = lat;
  obj.longitude = _long;
  obj.id = id;
  obj.icon = {
    url: site_url + '/assets/images/icons/' + icon,
    scaledSize: new google.maps.Size(40, 40),
    // scaled size
    origin: new google.maps.Point(0, 0),
    // origin
    anchor: new google.maps.Point(0, 0) // anchor

  };
  obj.visible = true;
  obj.selector = selector;
  obj.html = {
    content: '',
    popup: false
  };
  return obj;
}

if ($('#map-contact').length) {
  var positionChalets = {
    lat: 46.5067455,
    lng: -71.0553494
  };
  var mapContact = new google.maps.Map(document.getElementById('map-contact'), {
    zoom: 9,
    center: positionChalets,
    maptype: 'roadmap',
    styles: [{
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ebf1f4"
      }]
    }, {
      "featureType": "landscape.man_made",
      "elementType": "geometry",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "hue": "#009cff"
      }]
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{
        "lightness": "100"
      }]
    }, {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [{
        "visibility": "simplified"
      }]
    }],
    title: 'Au Chalet au Bois Rond'
  });
  var markerChalet = new google.maps.Marker({
    position: {
      lat: 46.5067455,
      lng: -71.0553494
    },
    map: mapContact
  });
  var contentString = $('.map-chalet').clone().html();
  var infowindow = new google.maps.InfoWindow({
    content: contentString
  });
  markerChalet.addListener('click', function () {
    infowindow.open(map, markerChalet);
  });
}

if ($('#map').length > 0) {
  var markers = [];
  var chalets = [];
  var modalMap = $('.carte .std_card--fullwidth.std_card, .carte .std_card--fullwidth');
  $('.chalet-item').each(function () {
    var _long2 = parseFloat($(this).data('long'));

    var lat = parseFloat($(this).data('lat'));
    var id = $(this).data('id');
    var pos = newPosition(lat, _long2, 'chalet-' + id, '.chalet-item');
    chalets.push(pos);
  });
  var themap = {};
  $(function () {
    var position = {
      lat: 46.842528,
      lng: -71.9381946
    };
    markers = chalets;
    themap = $("#map").goMap({
      mapTypeId: google.maps.MapTypeId.SATELLITE,
      zoom: 15,
      maptype: carte_type,
      center: position,
      draggable: true,
      zoomControl: true,
      navigationControl: true,
      scrollwheel: false,
      markers: markers,
      styles: ''
    }); //on drag map, close modal marker

    map.addListener('center_changed', function () {
      modalMap.hide();
    });
    $.goMap.map.panTo({
      lat: 46.842528,
      lng: -71.9381946
    }); //hide modal marker

    $(".close-modal").click(function (e) {
      e.preventDefault();
      $(this).parent().hide();
    });
  });
}

$('#map-image .btn-zoom').on('click', function (e) {
  e.preventDefault();
  var zoom = $(this).attr('data-zoom');
  var img = $('#map-image img');
  var he = img.height();

  if (zoom == 'in') {
    img.height(he + 50);
  } else {
    if (img.width() > $(this).parent().width() + 50) {
      img.height(he - 50);
    }
  }
});
"use strict";

function fixedNav() {
  var pos_nav = $('.meal-service-nav').offset().top;
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > pos_nav) {
      $('.meal-service-nav').addClass('fixed-nav');
    } else {
      $('.meal-service-nav').removeClass('fixed-nav');
    }
  });
}

if ($('.meal-service-nav').length > 0) {
  fixedNav();
}
"use strict";

//-MixItUp filter Activities
if ($('.activities').length) {
  var mixer = mixitup('.mix-container', {
    controls: {
      toggleLogic: 'or'
    },
    animation: {
      effectsIn: 'fade translateY(100px)',
      effectsOut: 'fade translateY(-100px)'
    }
  });
}
"use strict";

$(".custom-modal").click(function () {
  $(".modal-overlay").trigger("click");
});
$(".custom-modal-inner").click(function (e) {
  e.stopPropagation();
});

function setXposition() {
  var md = parseInt($('.modal.custom-modal.open .modal-content').outerWidth());
  var mr = parseInt($('.modal.custom-modal.open .custom-modal-inner').css('margin-left'));
  var mx = parseInt($('.modal.custom-modal.open .custom-modal-inner').css('margin-top'));
  $('.modal.custom-modal.open .modal-close').css({
    'left': md + mr - 44
  });
  $('.modal.custom-modal.open .modal-close').css({
    'top': mx + 16
  });
}

function exitIntent(type) {
  var occurence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var occ = 1;
  var currentMousePos = {
    y: -1
  };
  $(document).mousemove(function (event) {
    if (occ <= occurence) {
      currentMousePos.y = event.pageY;

      if (currentMousePos.y < 11) {
        $('#' + type).modal('open');
        occ++;
      }
    }
  });
}

$(document).ready(function () {
  if ($("#exitLinkModal").length) {
    exitIntent('exitLinkModal');
  } else if ($("#exitInfoLetterModal").length) {
    exitIntent('exitInfoLetterModal');
  }
});
$('.modal').modal({
  dismissible: true,
  // Modal can be dismissed by clicking outside of the modal
  opacity: .5,
  // Opacity of modal background
  in_duration: 300,
  // Transition in duration
  out_duration: 300,
  // Transition out duration
  ready: function ready() {
    setXposition();
  },
  // Callback for Modal open
  complete: function complete() {} // Callback for Modal close

});
$(window).resize(function () {
  setXposition();
});
$('.modal-action.modal-close').on('click', function (e) {
  e.preventDefault();
});
/*$('.footer_newslettre-form').on('submit', function (e) {
    e.preventDefault();
    var form = $(this);
     
    $('#statusModal .submit-status').hide();
    $('#statusModal').modal('open').addClass('loading');

    $.ajax({
        type: "POST",
        url: form.attr('action'),
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
            dataLayer.push({
              'page': $('meta[name="title"]').attr('content'),
              'event': 'contactSubmit'
            });
            $('#statusModal').removeClass('loading');
            if (data.status == 'success') {
                $('#statusModal .submit-status.failed').hide();
                $('#statusModal .submit-status.success').show();
            } else {
                $('#statusModal .submit-status.failed').show();
                $('#statusModal .submit-status.success').hide();
            }

        },
        fail:function(){
            $('#statusModal').removeClass('loading');
            $('#statusModal .submit-status.failed').show();
            $('#statusModal .submit-status.success').hide();
        },
        error:function(){
           $('#statusModal').removeClass('loading');
            $('#statusModal .submit-status.failed').show();
            $('#statusModal .submit-status.success').hide();
        }
          


    });
  
});*/
"use strict";

//- Navigation
var mainNav = $('.main_nav--container')[0];
var praTabs = $(mainNav).find('.par-tab'); // Prevent Default On click

praTabs.each(function () {
  this.onclick = function (e) {
    e.preventDefault();
  };
}); // Show Sub-Tabs

$('.nav-sub-menu li, .nav_pri--l li, .dropdown-content li').on('mouseover', function () {
  $(this).siblings().addClass('hovered');
}).on('mouseout', function () {
  $(this).siblings().removeClass('hovered');
});
var navbarHeight = $('.main_nav--container').outerHeight();

function hasScrolled() {
  var st = $(document).scrollTop(); // If they scrolled down and are past the navbar.
  // This is necessary so you never see what is "behind" the navbar.

  if (st > navbarHeight) {
    // Scroll Down
    $('.main_nav--container').addClass('nav-down');
    $('body').addClass('nav-down-padding');
  } else {
    $('.main_nav--container').removeClass('nav-down');
    $('body').removeClass('nav-down-padding');
  }
}

$('.open-nav').click(function () {
  $('.main_nav--container').addClass('nav-mobile-open');
  $('.main_navigation').slideDown();
  $(this).hide();
  $('.close-nav').show();
  $('body').css('overflow', 'hidden');
});
$('.close-nav').click(function () {
  $('.main_navigation').slideUp();
  $('.main_nav--container').removeClass('nav-mobile-open');
  $(this).hide();
  $('.open-nav').show();
  $('body').css('overflow', 'auto');
});
/*
$('.nav_pri--has-subtabs').find('a').click(function () {
  if ($(window).outerWidth() < 808) {
  $(this).toggleClass('open');
  $(this).next().stop().slideToggle();
  }
});*/

var viewPortChanged = true;

function updateNav() {
  if ($(window).outerWidth() < 808) {
    $('.main_nav--container').removeClass('nav-down');
    $('.mobile_nav--btn').show();
    $('body').removeClass('nav-down-padding');
    $('body').addClass('fixed-nav-padding');

    if (viewPortChanged) {
      $('.main_navigation').hide();
      $('.nav-sub-menu').hide();
      $('.nav_pri--has-subtabs a').removeClass('open');
    }

    viewPortChanged = false;
  } else {
    viewPortChanged = true;
    $('.main_navigation').show();
    $('.main_nav--container').removeClass('nav-mobile-open');
    $('.close-nav').hide();
    $('.open-nav').show();
    $('.nav-sub-menu').show();
    $('.mobile_nav--btn').hide();
    $('body').css('overflow', 'auto');
    $('body').removeClass('fixed-nav-padding');
    $(window).scroll(function (event) {
      hasScrolled();
    });
  }
}

updateNav(); // When resize

window.addEventListener('resize', function () {
  updateNav();
});
$('ul .has-submenu>a').on('click', function (e) {
  e.preventDefault();

  if ($(window).outerWidth() < 808) {
    $(this).toggleClass('open');
    $(this).parent().children('ul').stop().slideToggle();
  }
});
"use strict";

function updateControls() {
  var max_scroll = Math.round($('.table_price_container table').outerWidth() - $('.table_price_container').outerWidth());

  if (max_scroll == 0) {
    $('.table-left-control').hide();
    $('.table-right-control').hide();
  } else if ($('.table-price-chalet').scrollLeft() <= 8) {
    $('.table-left-control').hide();
    $('.table-right-control').show();
  } else if ($('.table-price-chalet').scrollLeft() >= max_scroll - 8) {
    $('.table-right-control').hide();
    $('.table-left-control').show();
  } else {
    $('.table-left-control').show();
    $('.table-right-control').show();
  }
}

updateControls();
$('.table-left-control').click(function () {
  $('.table-price-chalet').animate({
    scrollLeft: $('.table-price-chalet').scrollLeft() - 85
  }, 300);
  setTimeout(updateControls, 301);
});
$('.table-right-control').click(function () {
  $('.table-price-chalet').animate({
    scrollLeft: $('.table-price-chalet').scrollLeft() + 85
  }, 300);
  setTimeout(updateControls, 301);
});
$(window).resize(function () {
  updateControls();
});
"use strict";

//- rating-stars on profile
$(".my-rating").starRating({
  totalStars: 5,
  starShape: 'rounded',
  starSize: 30,
  emptyColor: '#e0e0e0',
  hoverColor: '#0d400d',
  activeColor: '#0d400d',
  ratedColor: '#0d400d',
  useGradient: false,
  disableAfterRate: false,
  callback: function callback(currentRating, $el) {
    if ($('#review_value--input').length) {
      $('#review_value--input').attr("value", currentRating);
    } else {
      $('#review-value').append('<input id="review_value--input" type="hidden" name="rate" value="' + currentRating + '">');
    }
  }
}); //- Single STD Rating display

$('.std_single--rating').starRating({
  totalStars: 5,
  starShape: 'rounded',
  starSize: 20,
  readOnly: true,
  activeColor: '#0d400d',
  ratedColor: '#0d400d',
  useGradient: false,
  disableAfterRate: false
});
"use strict";

//- Sliders
$(document).ready(function () {
  function gtm(action, event) {
    var pourcentage = (event.item.index + 1) / event.item.count * 100;

    if (typeof variable !== 'undefined') {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Browsing',
        eventAction: action,
        eventLabel: pourcentage
      });
    }
  } // Home News Slider


  function homeNewsSlider() {
    if (window.innerWidth < 993) {
      $('.home_news--inner').addClass('owl-carousel').addClass('owl-theme');
      $('.home_news--inner').owlCarousel({
        loop: false,
        items: 1,
        nav: true,
        dots: false,
        margin: 24,
        smartSpeed: 500
      }).on('changed.owl.carousel', function (event) {
        gtm('news home page carousel scroll', event);
      });
    } else {
      $('.home_news--inner').removeClass('owl-carousel').removeClass('owl-theme');
      $('.home_news--inner').trigger('destroy.owl.carousel');
    }
  } // Home news slider init


  homeNewsSlider();
  window.addEventListener('resize', homeNewsSlider); // Home Chalets Slider

  $('.home_chalet--slider_inner').owlCarousel({
    loop: false,
    nav: true,
    margin: 16,
    smartSpeed: 500,
    responsive: {
      0: {
        items: 1,
        margin: 6
      },
      750: {
        items: 2
      },
      1032: {
        items: 3
      },
      1290: {
        items: 3
      }
    }
  }).on('changed.owl.carousel', function (event) {
    gtm('Chalets home page carousel scroll', event);
  }); // Home Activities Slider

  $('.home_activity--slider_inner').owlCarousel({
    loop: false,
    nav: true,
    margin: 18,
    smartSpeed: 500,
    responsive: {
      0: {
        items: 1,
        margin: 6
      },
      750: {
        items: 2
      },
      1032: {
        items: 3
      },
      1290: {
        items: 3
      }
    }
  }).on('changed.owl.carousel', function (event) {
    gtm('Activities home page carousel scroll', event);
  }); // Home Events Slider

  $('.about_activity--slider_inner').owlCarousel({
    loop: true,
    nav: false,
    margin: 18,
    smartSpeed: 500,
    responsive: {
      0: {
        items: 1,
        margin: 6
      },
      750: {
        items: 2
      },
      1032: {
        items: 3
      },
      1290: {
        items: 3
      }
    }
  }).on('changed.owl.carousel', function (event) {
    gtm('Events home page carousel scroll', event);
  }); // Home Promos Sliders

  $('#home--promos-slider .home_promos--slider-inner').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: false,
    smartSpeed: 500,
    animateIn: 'fadeIn',
    onInitialized: initPrev,
    onTranslate: promosUpPre,
    onChanged: changeBackgroundPromos
  }).on('changed.owl.carousel', function (event) {
    gtm('Promos home page carousel scroll', event);
  }); // Home Promos Sliders

  $('#home--noah-slider .home_promos--slider-inner').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: false,
    smartSpeed: 500,
    animateIn: 'fadeIn',
    onInitialized: initPrev,
    onTranslate: promosUpPre,
    onChanged: changeBackgroundNoah
  }).on('changed.owl.carousel', function (event) {
    gtm('Promos home page carousel scroll', event);
  });

  function changeBackgroundPromos(e) {
    setTimeout(function () {
      var back = $('#home--promos-slider .owl-item.active').find('.home_promos--item').attr('data-image');

      if (typeof back != 'undefined') {
        $('#home--promos-slider .home_promos--slider .home_promos--slider-previews').css('background-image', 'url(' + back + ')').addClass('test');
      }
    }, 100);
  }

  function changeBackgroundNoah(e) {
    setTimeout(function () {
      var back = $('#home--noah-slider .owl-item.active').find('.home_promos--item').attr('data-image');

      if (typeof back != 'undefined') {
        $('#home--noah-slider .home_promos--slider .home_promos--slider-previews').css('background-image', 'url(' + back + ')').addClass('test');
      }
    }, 100);
  }

  function gCurrItem(e) {
    var container = e.target.querySelectorAll('.owl-item');
    var currIndex = e.item.index;
    var currItem = container[currIndex].querySelector('.home_promos--item');
    return currItem.getAttribute('data-prev');
  }

  function initPrev(e) {
    var currIPrev = gCurrItem(e); //console.log('init : ', currIPrev);
  }

  function promosUpPre(e) {
    var currIPrev = gCurrItem(e); //console.log('change : ', currIPrev);
  } //- Std Single Beds


  function stdSingleBeds() {
    if (window.innerWidth < 350) {
      $('.std_single--beds').addClass('owl-carousel').addClass('owl-theme');
      $('.std_single--beds').owlCarousel({
        loop: false,
        items: 1.5,
        nav: false,
        dots: false,
        margin: 16,
        smartSpeed: 500
      });
    } else {
      $('.std_single--beds').removeClass('owl-carousel').removeClass('owl-theme');
      $('.std_single--beds').trigger('destroy.owl.carousel');
    }
  } // Home news slider init


  stdSingleBeds();
  window.addEventListener('resize', stdSingleBeds); //- Std Single Activities

  function stdSingleActivities() {
    if (window.innerWidth < 350) {
      $('.std_single--activities-inner').addClass('owl-carousel').addClass('owl-theme');
      $('.std_single--activities-inner').owlCarousel({
        loop: false,
        items: 1.1,
        nav: false,
        dots: false,
        margin: 16,
        smartSpeed: 500
      }).on('changed.owl.carousel', function (event) {
        gtm('Activities chalet page carousel scroll', event);
      });
    } else {
      $('.std_single--activities-inner').removeClass('owl-carousel').removeClass('owl-theme');
      $('.std_single--activities-inner').trigger('destroy.owl.carousel');
    }
  } // Home news slider init


  stdSingleActivities();
  window.addEventListener('resize', stdSingleActivities); //- Std Single Similar Chalet

  function stdSingleSimilar() {
    if (window.innerWidth < 350) {
      $('.std_single--similar-inner').addClass('owl-carousel').addClass('owl-theme');
      $('.std_single--similar-inner').owlCarousel({
        loop: false,
        items: 1.1,
        nav: false,
        dots: false,
        margin: 16,
        smartSpeed: 500
      }).on('changed.owl.carousel', function (event) {
        gtm('Similar chalet, chalet page carousel scroll', event);
      });
    } else {
      $('.std_single--similar-inner').removeClass('owl-carousel').removeClass('owl-theme');
      $('.std_single--similar-inner').trigger('destroy.owl.carousel');
    }
  } // Home news slider init


  stdSingleSimilar();
  window.addEventListener('resize', stdSingleSimilar);
});
"use strict";

// Blog
if ($('.blog').length) {
  $(window).on('scroll resize', function () {
    if ($(window).outerWidth() > 768) {
      var img = $('.blog-img-container').outerHeight();
      var blog = $('.blog-content').parent().outerHeight();
      var scroll = $(window).scrollTop();

      if (scroll < blog - img) {
        $('.blog-img-container').css('margin-top', scroll);
      } else {
        $('.blog-img-container').css('margin-top', blog - img);
      }
    } else {
      $('.blog-img-container').css('margin-top', 0);
    }
  });
} //Single Chalet


if ($('.chalet_single--details').length) {
  $(window).on('scroll resize', function () {
    if ($(window).outerWidth() > 1290) {
      var calender = $('.desktop-calendar .chalet_single--calender').outerHeight();
      var bg = $('.chalet_hero--bg').outerHeight();
      var chalet = $('.chalet_details--inner').outerHeight();
      var scroll = $(window).scrollTop();

      if (scroll < chalet - calender + bg && scroll > bg) {
        $('.chalet_single--calender').css('margin-top', scroll - bg);
      } else if (scroll <= bg) {
        $('.chalet_single--calender').css('margin-top', 0);
      } else {
        $('.chalet_single--calender').css('margin-top', chalet - calender + 'px');
      }
    } else {
      $('.chalet_single--calender').css('margin-top', 0);
    }
  });
} // Single event

/*
if ($('.event-single').length){
  $(window).on('scroll resize', function () {

    let sections = $('.event-single');

    if ($(window).outerWidth() > 768) {
      let scroll = $(window).scrollTop();
      let bg = $('.events-hero').outerHeight() ;
      let block = $('.block-details').outerHeight();
      let btn = $('.contact-button').outerHeight();
      let eventPadding = 0;

      sections.each(function () {

        let padding = parseInt($(this).css('padding-top')) + parseInt($(this).css('padding-bottom'));
        let img = $(this).find('.event-img-container').outerHeight() + 40;
        img = img + block + btn;
        bg = bg + eventPadding;
        let event = $(this).find('.event-details').outerHeight();
        eventPadding = event + padding;
        console.log(event, img)
        if(event>img){

          
          if (scroll < (event - img + bg) && (scroll > bg) ) {
            $(this).find('.event-img-container').css('margin-top', (scroll - bg - 80));
          }
          else if (scroll <= bg) {
            $(this).find('.event-img-container').css('margin-top', 0);
          }
          else {
            $(this).find('.event-img-container').css('margin-top', event - img - 80);
          }
        }
      });
    }
    else {
      sections.each(function () {
        $(this).find('.event-img-container').css('margin-top', 0);
      });
    }
  });
}
*/